/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
    [_ in K]?: never;
};
export type Incremental<T> =
    | T
    | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    /**  ISO 8601 formatted date  */
    Date: { input: any; output: any };
    /** Time in milliseconds since the unix epoch */
    DateTime: { input: any; output: any };
    /** String representing a ISO8601 duration: https://the-guild.dev/graphql/scalars/docs/scalars/duration */
    Duration: { input: any; output: any };
    EmailAddress: { input: any; output: any };
    GraphQLDouble: { input: any; output: any };
    /**
     * start of subgraph specific declarations
     * custom scalars and directives
     */
    GraphQLLong: { input: any; output: any };
    /**  Scalar to provide clarity on Input and Response Structure(Sometimes provides type safe as well)  */
    JSON: { input: any; output: any };
    /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
    JSONObject: { input: any; output: any };
    Json: { input: any; output: any };
    LocalDate: { input: any; output: any };
    LocalDateTime: { input: any; output: any };
    LocalTime: { input: any; output: any };
    Long: { input: any; output: any };
    NonEmptyString: { input: any; output: any };
    NonNegativeFloat: { input: any; output: any };
    NonNegativeInt: { input: any; output: any };
    PhoneNumber: { input: any; output: any };
    /**
     * Built-in scalar from the gqlgen library: https://gqlgen.com/reference/scalars/
     * Adheres to the RFC3339Nano time format
     */
    Time: { input: any; output: any };
    Timestamp: { input: any; output: any };
    URL: { input: any; output: any };
    USCurrency: { input: any; output: any };
    Void: { input: any; output: any };
    ZipCode: { input: any; output: any };
    _FieldSet: { input: any; output: any };
};

export type ABAD = {
    body: Scalars['String']['output'];
    buttonText: Scalars['String']['output'];
    header: Scalars['String']['output'];
    version?: Maybe<Scalars['Int']['output']>;
};

export type ABAssignment = {
    /** Name of the treatment */
    treatment?: InputMaybe<Scalars['String']['input']>;
    /** Name of the trial */
    trialName?: InputMaybe<Scalars['String']['input']>;
};

/** the percent distribution of an AB treatment */
export type ABTestDistributionType = {
    percent?: Maybe<Scalars['Int']['output']>;
    treatment?: Maybe<Scalars['String']['output']>;
};

/**
 * Provides the treatments to which the user is exposed for the requested trials.
 * Example:
 *
 *     {
 *       abTests {
 *         MortgageHDPUpsell: abTest(trial: "MortgageHDPUpsell")
 *         MortgageStaticPageWrapper: abTest(trial: "MortgageStaticPageWrapper")
 *       }
 *     }
 *
 * =>
 *
 *     {
 *       "data": {
 *         "abTests": {
 *           "MortgageHDPUpsell": "ZLF",
 *           "MortgageStaticPageWrapper": "STATIC"
 *         }
 *       }
 *     }
 */
export type ABTests = {
    abTest?: Maybe<Scalars['String']['output']>;
    distribution?: Maybe<Array<Maybe<ABTestDistributionType>>>;
};

/**
 * Provides the treatments to which the user is exposed for the requested trials.
 * Example:
 *
 *     {
 *       abTests {
 *         MortgageHDPUpsell: abTest(trial: "MortgageHDPUpsell")
 *         MortgageStaticPageWrapper: abTest(trial: "MortgageStaticPageWrapper")
 *       }
 *     }
 *
 * =>
 *
 *     {
 *       "data": {
 *         "abTests": {
 *           "MortgageHDPUpsell": "ZLF",
 *           "MortgageStaticPageWrapper": "STATIC"
 *         }
 *       }
 *     }
 */
export type ABTestsabTestArgs = {
    trial?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Provides the treatments to which the user is exposed for the requested trials.
 * Example:
 *
 *     {
 *       abTests {
 *         MortgageHDPUpsell: abTest(trial: "MortgageHDPUpsell")
 *         MortgageStaticPageWrapper: abTest(trial: "MortgageStaticPageWrapper")
 *       }
 *     }
 *
 * =>
 *
 *     {
 *       "data": {
 *         "abTests": {
 *           "MortgageHDPUpsell": "ZLF",
 *           "MortgageStaticPageWrapper": "STATIC"
 *         }
 *       }
 *     }
 */
export type ABTestsdistributionArgs = {
    trial?: InputMaybe<Scalars['String']['input']>;
};

export type AbadResponse = {
    /** Type of ABAD seen, Digital or eConsented */
    abadType?: Maybe<AbadType>;
    /** The full text of the ABAD document, in markdown format. */
    documentText: Scalars['String']['output'];
    /** The latest version of the ABAD document. */
    documentVersion: Scalars['Int']['output'];
    /** A Boolean value indicating if the ABAD has been viewed by the user or not */
    hasSeenAbad?: Maybe<Scalars['Boolean']['output']>;
};

export type AbadType = 'DIGITAL' | 'ECONSENTED';

export type ActivateBlendLoanOutput = {
    blend_activation_url?: Maybe<Scalars['String']['output']>;
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type ActivateMACUserOutput = {
    success: Scalars['Boolean']['output'];
};

export type Activity = {
    /** if available, the activity/event id */
    activityId?: Maybe<Scalars['ID']['output']>;
    /** if available, the activity time as epoch milliseconds */
    activityTime?: Maybe<Scalars['GraphQLLong']['output']>;
    /** the activity type */
    activityType: ActivityType;
    /** the user id associated with this activity */
    associatedId: IdBasedWithSource;
    /** source of the activity/event */
    source: Scalars['String']['output'];
};

/** filters on activities: implied AND logical operator among filter criteria fields */
export type ActivityFilter = {
    /** the activity type */
    activityTypes?: InputMaybe<Array<ActivityType>>;
    associatedIds?: InputMaybe<Array<IdentityFilter>>;
};

/** any activities involving or touching the user */
export type ActivityType =
    | 'SAVE_HOME'
    | 'SESSION'
    | 'SUBMIT_AGENT_CONTACT'
    | 'SUBMIT_LOAN_FORM'
    | 'SUBMIT_LOAN_SURVEY'
    | 'VIEW_HOME';

export type AdTargets = {
    aamgnrc1?: Maybe<Scalars['String']['output']>;
    ba?: Maybe<Scalars['String']['output']>;
    bd?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    cnty?: Maybe<Scalars['String']['output']>;
    dma?: Maybe<Scalars['String']['output']>;
    fsbid?: Maybe<Scalars['String']['output']>;
    listtp?: Maybe<Scalars['String']['output']>;
    mlat?: Maybe<Scalars['String']['output']>;
    mlong?: Maybe<Scalars['String']['output']>;
    pid?: Maybe<Scalars['String']['output']>;
    prange?: Maybe<Scalars['String']['output']>;
    premieragent?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['String']['output']>;
    proptp?: Maybe<Scalars['String']['output']>;
    sqft?: Maybe<Scalars['String']['output']>;
    sqftrange?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type AddSavedHomeCategoryInput = {
    /**  the category of this saved home  */
    category: Scalars['String']['input'];
    /**  property identifier  */
    propertyId: Scalars['ID']['input'];
    /**  the type of property id  */
    propertyIdType: PropertyIdType;
};

export type AdditionalHomesDetail = {
    alertTextError: Scalars['String']['output'];
    alertTextInfo: Scalars['String']['output'];
    body: Scalars['String']['output'];
    buttonTextAddProperty: Scalars['String']['output'];
    buttonTextContinue: Scalars['String']['output'];
    buttonTextRemoveProperty: Scalars['String']['output'];
    heading: Scalars['String']['output'];
    title: Scalars['String']['output'];
};

export type AdditionalRequirement = 'CONSUMER_REPORT' | 'NONE';

/** Street location */
export type Address = {
    city?: Maybe<Scalars['String']['output']>;
    community?: Maybe<Scalars['String']['output']>;
    directionalPrefix?: Maybe<Scalars['String']['output']>;
    directionalSuffix?: Maybe<Scalars['String']['output']>;
    houseFractionNumber?: Maybe<Scalars['String']['output']>;
    houseNumber?: Maybe<Scalars['String']['output']>;
    neighborhood?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    street?: Maybe<Scalars['String']['output']>;
    /** formatted house and unit number on street */
    streetAddress?: Maybe<Scalars['String']['output']>;
    streetSuffix?: Maybe<Scalars['String']['output']>;
    subdivision?: Maybe<Scalars['String']['output']>;
    unitNumber?: Maybe<Scalars['String']['output']>;
    unitPrefix?: Maybe<Scalars['String']['output']>;
    zipcode?: Maybe<Scalars['String']['output']>;
};

export type Ads = {
    /** A list of Ad Params */
    adParams?: Maybe<Array<Maybe<AdsParamType>>>;
    /** Ad Units */
    adUnit?: Maybe<Scalars['String']['output']>;
};

export type AdsadParamsArgs = {
    navigationAds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AdsParamType = {
    /** The key of AdsParam */
    key?: Maybe<Scalars['String']['output']>;
    /** The value of AdsParam */
    value?: Maybe<Scalars['String']['output']>;
};

export type AffordabilityEstimate = {
    /** The individual costs that sum up to the totalMonthlyPayment */
    monthly?: Maybe<AffordabilityEstimateBreakdown>;
    /** The data that Monthly Cost Calculator needs to route to the pre-qual experience with the right parameters */
    monthlyCostCalculatorData?: Maybe<MonthlyCostCalculator>;
    /** The data that clients need in order to display the Mortgage Chip on the FSHDP when appropriate */
    mortgageChipData?: Maybe<MortgageChip>;
    /**
     * The data that is needed by clients to show users a personalized payment
     * experience. This value will be null if the user and/or the property are not
     * eligible for PP
     */
    personalizedPaymentData?: Maybe<MortgagePersonalizedPaymentData>;
    /** The flag that lets clients know whether or not to display the Monthly Cost Calculator for that property */
    showMonthlyCostCalculator?: Maybe<Scalars['Boolean']['output']>;
    /** The flag that lets clients know whether or not to display the Mortgage Chip for that property */
    showMortgageChip?: Maybe<Scalars['Boolean']['output']>;
    /** This flag is set to true if the user has the Personalized Payment MVP, does not apply to iOS */
    showPencilIconForPPMVP?: Maybe<Scalars['Boolean']['output']>;
    /** The total estimated payment per month = propertyTax + homeownersInsurance + principalAndInterest+ hoaFees */
    totalMonthlyCost?: Maybe<Scalars['Float']['output']>;
    /** The values used as formula inputs to arrive at the totalMonthlyPayment */
    usedInputs?: Maybe<AffordabilityEstimateInputs>;
};

export type AffordabilityEstimateBreakdown = {
    /** The HOA fees portion of the estimated monthly payment */
    hoaFees?: Maybe<Scalars['Float']['output']>;
    /** The homeowners Insurance portion of the estimated monthly payment */
    homeownersInsurance?: Maybe<Scalars['Float']['output']>;
    /** The principal & Interest portion of the estimated monthly payment */
    principalAndInterest?: Maybe<Scalars['Float']['output']>;
    /** The PMI portion of the estimated monthly payment */
    privateMortgageInterest?: Maybe<Scalars['Float']['output']>;
    /** The property tax portion of the estimated monthly payment */
    propertyTax?: Maybe<Scalars['Float']['output']>;
};

export type AffordabilityEstimateInputs = {
    /**
     * The credit score used to get mortgage rates for the P&I This will be a self
     * reported credit score from user or assumed default for an EXCELLENT
     * creditScore is used
     */
    creditScore?: Maybe<CreditScoreUsed>;
    /**
     * The downPayment amount used to get mortgage interest rates as well as
     * determining PMI if applicable. This will be from mortgage preferences
     * specified by the user or a default of 20% of the property price if no
     * preferencs are given
     */
    downPaymentAmount?: Maybe<Scalars['Float']['output']>;
    /** The downPayment amount represented as percentage of the property price */
    downPaymentPercent?: Maybe<Scalars['Float']['output']>;
    /** True if the user's financial profile was the source of parameters, false otherwise */
    fromFinancialProfile?: Maybe<Scalars['Boolean']['output']>;
    /** Set to true if the downpayment used was in percentage of the price, false if the downpayment used is in dollar amount */
    isDownpaymentPreferencePercent?: Maybe<Scalars['Boolean']['output']>;
    /** The loan preferences as specified by user or in the absence of user preferences, a 30 year fixed mortgage type is assumed */
    loan?: Maybe<LoanDetails>;
};

export type AffordabilityFilters = {
    downPayment?: Maybe<Scalars['Float']['output']>;
    interestRate?: Maybe<Scalars['Float']['output']>;
    loanTerm?: Maybe<Scalars['Int']['output']>;
    monthlyPayment?: Maybe<SearchRangeIntegerFilter>;
};

export type AffordabilityStep = {
    stepIcon: SubmitFlowIcon;
    stepInformation: Scalars['String']['output'];
};

export type Agent = {
    /** The email address of the agent */
    emailAddress?: Maybe<Scalars['String']['output']>;
    /** The full name of the agent */
    fullName?: Maybe<Scalars['String']['output']>;
    /** The extension of the agent's preferred phone number */
    preferredPhoneExtension?: Maybe<Scalars['String']['output']>;
    /**
     * Agent's preferred phone number. North American 10 digit phone number
     * should be in the format of ###-###-#### (separated by hyphens).
     * Other conventions should use the common local standard.
     * International numbers should be preceded by a plus symbol.
     */
    preferredPhoneNumber?: Maybe<Scalars['String']['output']>;
    /** The website URL or ID of social media site or account of the member */
    socialMediaWebsiteUrlOrId?: Maybe<Scalars['String']['output']>;
};

/** AgentCall ... */
export type AgentCall = {
    agent_zuid?: Maybe<Scalars['Int']['output']>;
    call_id?: Maybe<Scalars['String']['output']>;
    call_position?: Maybe<Scalars['Int']['output']>;
    call_status?: Maybe<Scalars['String']['output']>;
    call_type?: Maybe<Scalars['String']['output']>;
    lead_pacing_position?: Maybe<Scalars['Int']['output']>;
    pacing_agent_zuid?: Maybe<Scalars['Int']['output']>;
};

/** Data for agent capacity */
export type AgentCapacity = {
    /** Whether or not the agent capacity data is ready to be sent */
    isAgentCapacityUITreatmentOn?: Maybe<Scalars['Boolean']['output']>;
};

export type AgentCare = {
    email?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
};

export type AgentCompensation = {
    /**
     * **Definition:** fixed amount of compensation. For TouringAgreements, this is expected to be 0
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    fixedAmount?: Maybe<Scalars['Int']['output']>;
};

/** An object containing the agent fees */
export type AgentFees = {
    buyerAgentFeePercent?: Maybe<Scalars['Float']['output']>;
    sellerAgentFeePercent?: Maybe<Scalars['Float']['output']>;
};

export type AgentInfo = {
    agentBadgeType?: Maybe<Scalars['String']['output']>;
    businessName?: Maybe<Scalars['String']['output']>;
    displayName?: Maybe<Scalars['String']['output']>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    photoUrl?: Maybe<Scalars['String']['output']>;
    profileUrl?: Maybe<Scalars['String']['output']>;
    ratingAverage?: Maybe<Scalars['Int']['output']>;
    recentSalesCount?: Maybe<Scalars['Int']['output']>;
    reviewsReceivedCount?: Maybe<Scalars['Int']['output']>;
    reviewsUrl?: Maybe<Scalars['String']['output']>;
};

export type AgentParticipant = {
    /**
     * **Definition:** The confirmation status of the agent participant. This field is 'true' if the agent participant status is 'accepted'
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    isConfirmed?: Maybe<Scalars['Boolean']['output']>;
    paAgent?: Maybe<PAAgent>;
    /**
     * **Definition:** The pending status of the agent participant. This field is 'true' if the agent participant status is 'pending'
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    pending?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** The zuid of the agent participant
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    zuid?: Maybe<Scalars['Int']['output']>;
};

/** Connection for team leaderboard for performance reporting */
export type AgentPerformanceLeaderboardConnection = {
    /** Edges for AgentPerformanceLeaderboard */
    edges?: Maybe<Array<Maybe<AgentPerformanceLeaderboardEntryEdge>>>;
    /** Relay Style PageInfo */
    pageInfo: PageInfo;
};

/** Single team member on leaderboard */
export type AgentPerformanceLeaderboardEntry = {
    /** Team member rank */
    performanceRank: Scalars['Int']['output'];
    /** Team member's performance rating */
    performanceRating?: Maybe<PerformanceRating>;
    /** Team member */
    teamMember: PAAgent;
};

/** Edge for AgentPerformanceLeaderboardEntryEdge */
export type AgentPerformanceLeaderboardEntryEdge = {
    /** Cursor for pagination */
    cursor: Scalars['String']['output'];
    /** AgentPerformanceLeaderboard node */
    node: AgentPerformanceLeaderboardEntry;
};

export type AgentProfile = {
    /**
     * **Definition:** Agent office city
     * **Datasource:** User Data Service (UDS)
     *
     * **Team Slack:** #sea-agent-data-team
     */
    officeCity?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Agent office state
     * **Datasource:** User Data Service (UDS)
     *
     * **Team Slack:** #sea-agent-data-team
     */
    officeState?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Agent profile url
     * **Datasource:** User Data Service (UDS)
     *
     * **Team Slack:** #sea-agent-data-team
     */
    profileUrl?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** The average rating of the agent
     * **Datasource:** User Data Service (UDS)
     *
     * **Team Slack:** #sea-agent-data-team
     */
    ratingAverage?: Maybe<Scalars['Float']['output']>;
    /**
     * **Definition:** The number of rating the agent has
     * **Datasource:** User Data Service (UDS)
     *
     * **Team Slack:** #sea-agent-data-team
     */
    ratingCount?: Maybe<Scalars['Int']['output']>;
};

export type AgentRescheduleTourAppointmentResponse = {
    /** **Definition:** Explanatory details for unsuccessful requests */
    errorMessage?: Maybe<Scalars['String']['output']>;
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type AgentStatusVersion = 'V1';

export type AgentTourView = {
    modules?: Maybe<Array<AgentTourViewModule>>;
};

export type AgentTourViewAlert = {
    eventTime?: Maybe<Scalars['String']['output']>;
    formattedInstant?: Maybe<TourViewModuleText>;
    formattedTemplate?: Maybe<TourViewModuleText>;
};

export type AgentTourViewCTA =
    | AgentTourViewCTAAddToCalendar
    | AgentTourViewCTABookTour
    | AgentTourViewCTACallContact
    | AgentTourViewCTACancelTour
    | AgentTourViewCTAEditTour
    | AgentTourViewCTARespond
    | AgentTourViewCTAShowingTimeBook;

export type AgentTourViewCTAAddToCalendar = IAgentTourViewCTA & {
    action?: Maybe<TourViewModuleText>;
    isPrimary?: Maybe<Scalars['Boolean']['output']>;
};

export type AgentTourViewCTABookTour = IAgentTourViewCTA & {
    action?: Maybe<TourViewModuleText>;
    isPrimary?: Maybe<Scalars['Boolean']['output']>;
};

export type AgentTourViewCTACallContact = IAgentTourViewCTA & {
    action?: Maybe<TourViewModuleText>;
    isPrimary?: Maybe<Scalars['Boolean']['output']>;
};

export type AgentTourViewCTACancelTour = IAgentTourViewCTA & {
    action?: Maybe<TourViewModuleText>;
    isPrimary?: Maybe<Scalars['Boolean']['output']>;
};

export type AgentTourViewCTAEditTour = IAgentTourViewCTA & {
    action?: Maybe<TourViewModuleText>;
    isPrimary?: Maybe<Scalars['Boolean']['output']>;
};

export type AgentTourViewCTARespond = IAgentTourViewCTA & {
    action?: Maybe<TourViewModuleText>;
    isPrimary?: Maybe<Scalars['Boolean']['output']>;
};

export type AgentTourViewCTAShowingTimeBook = IAgentTourViewCTA & {
    action?: Maybe<TourViewModuleText>;
    isPrimary?: Maybe<Scalars['Boolean']['output']>;
};

export type AgentTourViewCTAs = {
    ctas?: Maybe<Array<AgentTourViewCTA>>;
};

export type AgentTourViewHeader = {
    long?: Maybe<TourViewModuleText>;
    short?: Maybe<TourViewModuleText>;
};

export type AgentTourViewIcon = {
    calendarIcon?: Maybe<TourViewModulePhoto>;
    statusIcon?: Maybe<TourViewModulePhoto>;
};

/** The id of the requested agent tour view */
export type AgentTourViewId = 'AGENT_TOUR_STATUS_V0';

export type AgentTourViewModule =
    | AgentTourViewCTAs
    | AgentTourViewIcon
    | AgentTourViewText
    | AgentTourViewTourDetails;

export type AgentTourViewText = {
    alert?: Maybe<AgentTourViewAlert>;
    header?: Maybe<AgentTourViewHeader>;
    subheader?: Maybe<TourViewModuleText>;
};

export type AgentTourViewTourDetails = {
    appointmentTimes?: Maybe<Array<AgentTourViewTourTime>>;
    propertyAddressFull?: Maybe<TourViewModuleText>;
};

export type AgentTourViewTourTime = {
    appointmentTimeDatePicker?: Maybe<TourViewModuleText>;
    appointmentTimeListItemStatus?: Maybe<TourViewModuleText>;
    appointmentTimeMobileInbox?: Maybe<TourViewModuleText>;
    appointmentTimeMobileThreadHeader?: Maybe<TourViewModuleText>;
    appointmentTimeTabRowHeader?: Maybe<TourViewModuleText>;
    appointmentTimeWebThreadHeader?: Maybe<TourViewModuleText>;
};

export type AgentTouringAgreementEnablementStatus = 'AUTO' | 'MANUAL' | 'OFF';

/** related to aggregated metrics on user_activity */
export type AggregationType = 'TOTAL';

/** related to aggregated metrics on user_activity */
export type AggregationWindow = 'LIFETIME';

/**
 *  Similar Homes recommendations for Zillow Vacant, Zillow Non-Vacant, Trulia Vacant, Trulia Non-Vacant, and Rental
 * properties. Each Zillow property that recommendations are generated for has a list of associated recommended homes.
 */
export type AipersSimilarHomes = {
    /**  Unique ID identifying the exact model that was used to calculate the recommendations.  */
    modelId?: Maybe<Scalars['String']['output']>;
    /**  Array of Similar Home Recommendations for a specified anchor home  */
    recs?: Maybe<Array<AipersSimilarHomes_RecommendationRecord>>;
    /**
     *  Zpid is an internally generated ID originally created to uniquely identify a property.
     * For Similar Home records it represents the property ID of the anchor home recommendations
     * are generated for.
     */
    zpid: Scalars['String']['output'];
};

/**
 *  Similar Homes Recommendation Record. Contains a property ID of a Zillow, Trulia, or Rental record as well
 * as a score generated by a machine learning model which signifies how similar this property is to an anchor property.
 */
export type AipersSimilarHomes_RecommendationRecord = {
    /**
     *  Value between 0 and 1 which represents the score for how similar a home is to the referenced anchor home.
     * A higher value indicates that the home is “more similar” to the anchor home.
     */
    score?: Maybe<Scalars['Float']['output']>;
    /**
     *  Zpid is an internally generated ID originally created to uniquely identify a property.
     * For Similar Home recommendation records, it represents the property ID of a home found to be similar
     * to the anchor property.
     */
    zpid?: Maybe<Scalars['String']['output']>;
};

export type AirConditioning = 'Central' | 'None' | 'Unknown' | 'Wall' | 'Window' | 'Yes';

export type AmenitiesFilters =
    /** home with air conditioning amenity */
    | 'AIRCONDITIONING'
    /** home with pool amenity */
    | 'POOL'
    /** home with waterfront amenity */
    | 'WATERFRONT';

/** Detail list of building amenities */
export type AmenityDetails = {
    buildingAmenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    customAmenities?: Maybe<CustomAmenities>;
    fees?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    hours?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    isSmokeFree?: Maybe<Scalars['Boolean']['output']>;
    leaseTerms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    petDetails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    pets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    unitFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Summary list of high priority building ammenities */
export type AmenitySummary = {
    buildingDetails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    cooling?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    heating?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    laundry?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    outdoor?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    parking?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    pets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AnonymousViewer = {
    /** links to be rendered in the global top nav, returned as JSON */
    topNavJson?: Maybe<Scalars['JSON']['output']>;
    /** links to be rendered in the global top nav, returned as markup */
    topNavMarkup?: Maybe<Scalars['JSON']['output']>;
};

export type AnswerType = 'boolean' | 'string';

export type Answers = {
    aboutMe?: Maybe<Scalars['String']['output']>;
    backgroundReportComment?: Maybe<Scalars['String']['output']>;
    coapplicants?: Maybe<Array<Maybe<SentCoapplicantInvitation>>>;
    creditReportComment?: Maybe<Scalars['String']['output']>;
    currentIncome?: Maybe<CurrentIncome>;
    currentIncomes?: Maybe<Array<Maybe<CurrentIncome>>>;
    currentResidence?: Maybe<CurrentResidence>;
    customAnswers?: Maybe<Array<Maybe<CustomAnswer>>>;
    email?: Maybe<Scalars['EmailAddress']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    isMoveInDateFlexible?: Maybe<Scalars['Boolean']['output']>;
    isSmoker?: Maybe<Scalars['Boolean']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    middleName?: Maybe<Scalars['String']['output']>;
    moveInDate?: Maybe<Scalars['Date']['output']>;
    occupants?: Maybe<Scalars['Int']['output']>;
    pastJobs?: Maybe<Array<Maybe<PastJob>>>;
    pastResidences?: Maybe<Array<Maybe<PastResidence>>>;
    pets?: Maybe<Pets>;
    phone?: Maybe<Scalars['PhoneNumber']['output']>;
    reasonForMoving?: Maybe<Scalars['String']['output']>;
};

export type AnswerscurrentIncomeArgs = {
    id: Scalars['ID']['input'];
};

export type AnswersInput = {
    aboutMe?: InputMaybe<Scalars['NonEmptyString']['input']>;
    backgroundReportComment?: InputMaybe<Scalars['NonEmptyString']['input']>;
    creditReportComment?: InputMaybe<Scalars['NonEmptyString']['input']>;
    currentResidence?: InputMaybe<ResidenceInput>;
    customAnswers?: InputMaybe<Array<InputMaybe<CustomAnswerInput>>>;
    firstName?: InputMaybe<Scalars['NonEmptyString']['input']>;
    isMoveInDateFlexible?: InputMaybe<Scalars['Boolean']['input']>;
    isSmoker?: InputMaybe<Scalars['Boolean']['input']>;
    lastName?: InputMaybe<Scalars['NonEmptyString']['input']>;
    middleName?: InputMaybe<Scalars['String']['input']>;
    moveInDate?: InputMaybe<Scalars['Date']['input']>;
    occupants?: InputMaybe<Scalars['NonNegativeInt']['input']>;
    pets?: InputMaybe<PetsInput>;
    phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
    reasonForMoving?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type ApplianceType =
    | 'ConvectionOven'
    | 'Dishwasher'
    | 'DoubleOven'
    | 'Dryer'
    | 'Freezer'
    | 'GarbageDisposal'
    | 'MicrowaveOven'
    | 'None'
    | 'Oven'
    | 'Range'
    | 'Refrigerator'
    | 'TrashCompactor'
    | 'Unknown'
    | 'Washer'
    | 'WasherDryerHookups';

export type Applicant = {
    answers?: Maybe<Answers>;
    coapplicantInvitation?: Maybe<SentCoapplicantInvitation>;
    hasIcraaBeenAcceptedForByLandlord?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    isPrimaryApplicant?: Maybe<Scalars['Boolean']['output']>;
    landlordInvitation?: Maybe<SentLandlordInvitation>;
    status?: Maybe<ApplicantStatus>;
    submittedDateTime?: Maybe<Scalars['DateTime']['output']>;
    userId?: Maybe<Scalars['ID']['output']>;
    userStatuses?: Maybe<Array<Maybe<UserStatus>>>;
    zgAuthZone?: Maybe<ZgAuthZone>;
};

export type ApplicantContactInfo = {
    email?: Maybe<Scalars['EmailAddress']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
};

export type ApplicantStatus = 'completed' | 'pending' | 'withdrawn';

export type ApplicationStatus =
    | 'active'
    | 'approved'
    | 'declined'
    | 'invited'
    | 'invited_and_started'
    | 'invited_to_move_in'
    | 'partially_submitted'
    | 'started'
    | 'submitted'
    | 'withdrawn';

export type ApplicationStatusHistoryEvent = {
    date: Scalars['Float']['output'];
    /**
     * https://bitbucket.hotterpads.com/projects/RP/repos/zillow/browse/capps-client/src/main/java/com/hotpads/capps/client/dto/application/ApplicationStatusHistoryEvent.java
     * date is milliseconds since epoch
     * status has one of these values: ["Application opened", "%s Applied", "Application submitted", "Application withdrawn", "Application accepted"]
     * %s will be replaced by the name of the coapplicant that has also applied
     */
    status: Scalars['String']['output'];
    viewedByRachel: Scalars['Boolean']['output'];
};

export type AppliedTag = {
    /**  property id  */
    propertyId: Scalars['ID']['output'];
    /**  the type of property id  */
    propertyIdType: PropertyIdType;
    /**  property tag identifier  */
    propertyTags?: Maybe<Array<PropertyTag>>;
};

export type AppliedTagsInput = {
    /**  property identifier  */
    propertyId: Scalars['ID']['input'];
    /**  the type of property id, property-tags supports only zpid  */
    propertyIdType: PropertyIdType;
};

export type ApplyCustomPropertyTagInput = {
    /**  property identifier  */
    propertyId: Scalars['ID']['input'];
    /**  property identifier type, PTS supports zpid only */
    propertyIdType: PropertyIdType;
    /**  The tag text added by the user  */
    tagText: Scalars['String']['input'];
};

export type ApplyPropertyTagInput = {
    /**  property identifier  */
    propertyId: Scalars['ID']['input'];
    /**  property identifier type, PTS supports zpid only */
    propertyIdType: PropertyIdType;
    /**  property tag identifier  */
    propertyTagId: Scalars['ID']['input'];
};

export type AppointmentAcceptedByType = 'AGENT' | 'AUTOMATIC';

/** The individual available slot for a home evaluation appointment */
export type AppointmentSlot = {
    finishTime?: Maybe<Scalars['DateTime']['output']>;
    slotRating?: Maybe<Scalars['Float']['output']>;
    startTime?: Maybe<Scalars['DateTime']['output']>;
};

export type AppointmentVisibility = {
    /**
     * **Definition:** A list of external auth providers for the account of the buyer zuid associated with the tourAppointment
     *
     * **Source:** Appointments API and Account Service
     *
     * **No Auth**
     *
     * **Example: ** ["Google", "Apple"]
     */
    externalAuthProviders?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**
     * **Definition:** This field is true if the account of the buyer zuid associated with the tourAppointment has a password.
     *
     * **Source:** Appointments API and Account Service
     *
     * **No Auth**
     */
    hasPassword?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** This field is true if the zuid of the logged in account is the same as the buyer zuid associated with the tourAppointment, and false otherwise.
     * This field is also false if Beth is not logged in.
     *
     * **Source:** Auth Context and Appointments API
     *
     * **No Auth**
     * @deprecated Use viewerRole
     */
    isTourRequestSubmitter?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Convenience field that reflects how the user is associated with the
     * appointment they're querying for. Null if user is not logged in.`
     *
     * **Source:** Auth Context and Appointments API
     *
     * **No Auth**
     */
    viewerRole?: Maybe<ViewerRole>;
};

export type AppraisalStatusType = 'Ordered' | 'Received';

export type ApprovedThirdPartyVirtualTourProviderKeys =
    | 'CLOUDPANO'
    | 'INSIDEMAPS'
    | 'MATTERPORT'
    | 'PANOSKIN'
    | 'TOURBUILDER'
    | 'ZILLOW_IMX';

/** arm 5 rate object */
export type Arm5Bucket = {
    lastUpdated?: Maybe<Scalars['DateTime']['output']>;
    rate?: Maybe<Scalars['Float']['output']>;
    rateSource?: Maybe<Scalars['String']['output']>;
};

export type ArrayValue = {
    array?: Maybe<Array<Scalars['String']['output']>>;
};

export type ArrivalGoal = 'BUY' | 'RENT' | 'UNSPECIFIED';

export type AspectRatio = 'EightThirds' | 'FourThirds' | 'Original' | 'TwoToOne';

/** Association ... */
export type Association = {
    associationId?: Maybe<Scalars['String']['output']>;
    associationType?: Maybe<Scalars['String']['output']>;
    product?: Maybe<Scalars['String']['output']>;
};

/**
 * This type allows us to pass a key value pair of attribution entries to client
 * side. These attribution entries will be appended as url params to the internal
 * destination urls before routing.
 */
export type AttributionEntry = {
    key: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

/** List of fields that will return values when they are needed */
export type AttributionInfo = {
    agentEmail?: Maybe<Scalars['String']['output']>;
    agentLicenseNumber?: Maybe<Scalars['String']['output']>;
    agentName?: Maybe<Scalars['String']['output']>;
    agentPhoneNumber?: Maybe<Scalars['String']['output']>;
    agentPhoneNumberWithExtension?: Maybe<Scalars['String']['output']>;
    attributionTitle?: Maybe<Scalars['String']['output']>;
    brokerName?: Maybe<Scalars['String']['output']>;
    brokerPhoneNumber?: Maybe<Scalars['String']['output']>;
    buyerAgentMemberStateLicense?: Maybe<Scalars['String']['output']>;
    buyerAgentName?: Maybe<Scalars['String']['output']>;
    buyerBrokerageName?: Maybe<Scalars['String']['output']>;
    coAgentLicenseNumber?: Maybe<Scalars['String']['output']>;
    coAgentName?: Maybe<Scalars['String']['output']>;
    coAgentNumber?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoList1?: Maybe<Array<Maybe<listingOffice>>>;
    /** @deprecated Use non-obfuscated information instead */
    infoList2?: Maybe<Array<Maybe<listingAgent>>>;
    /** @deprecated Use non-obfuscated information instead */
    infoString1?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString2?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString3?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString4?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString5?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString6?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString7?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString8?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString9?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString10?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString11?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString12?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString13?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString14?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString15?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString16?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString17?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString18?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString19?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString20?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoString21?: Maybe<Scalars['String']['output']>;
    lastChecked?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['String']['output']>;
    listingAgentAttributionContact?: Maybe<Scalars['String']['output']>;
    listingAgents?: Maybe<Array<Maybe<listingAgent>>>;
    listingAgreement?: Maybe<Scalars['String']['output']>;
    listingAttributionContact?: Maybe<Scalars['String']['output']>;
    listingOfficeAttributionContact?: Maybe<Scalars['String']['output']>;
    listingOffices?: Maybe<Array<Maybe<listingOffice>>>;
    mlsDisclaimer?: Maybe<Scalars['String']['output']>;
    mlsId?: Maybe<Scalars['String']['output']>;
    mlsName?: Maybe<Scalars['String']['output']>;
    providerLogo?: Maybe<Scalars['String']['output']>;
    trueStatus?: Maybe<Scalars['String']['output']>;
};

export type AuthAssuranceLevel = 'AAL0' | 'AAL1' | 'AAL2' | 'AAL3';

export type AuthOTP = {
    isEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** A list of available appointments to schedule a home evaluation */
export type AvailableAppointments = {
    slots?: Maybe<Array<Maybe<AppointmentSlot>>>;
    timezone?: Maybe<Scalars['String']['output']>;
};

/** A plan that can be constructed on a new-construction lot. */
export type AvailablePlan = {
    /** Is this the primary plan for the lot? */
    isPrimaryPlan?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use ncListingAvailability */
    ncProperty?: Maybe<NcProperty>;
    /** The attributes of this plan which are stored in its POGO Property object */
    property?: Maybe<Property>;
    zpid?: Maybe<Scalars['Int']['output']>;
};

/** Consist of 2 lat(X)/long(Y) coordinates from southwest (bottom left) (minX, minY) to northeast (top right) (maxX, maxY) */
export type BBox = {
    /** top right latitude */
    maxX?: InputMaybe<Scalars['Float']['input']>;
    /** top right longitude */
    maxY?: InputMaybe<Scalars['Float']['input']>;
    /** bottom left latitude */
    minX?: InputMaybe<Scalars['Float']['input']>;
    /** bottom left longitude */
    minY?: InputMaybe<Scalars['Float']['input']>;
};

export type BadRequestError = BridgeContainerError & {
    message: Scalars['String']['output'];
    retryable?: Maybe<Scalars['Boolean']['output']>;
};

/** entity type: the id struct for basic user identifiers */
export type BaseIdStruct = IdBasedWithSource & {
    /** the confidence score about this id and the id's association to the primary id */
    confidence: Scalars['Float']['output'];
    createTime: Scalars['GraphQLLong']['output'];
    id: Scalars['String']['output'];
    idType: IdType;
    lastChecked: Scalars['GraphQLLong']['output'];
    /** the source of this id */
    source: Scalars['String']['output'];
};

export type BasementStatusType =
    /** finished basements */
    | 'FINISHED'
    /** no basements */
    | 'NONE'
    /** partial basements */
    | 'PARTIAL'
    /** unfinished basements */
    | 'UNFINISHED';

export type BasicScoringResult = UserLearningResult & {
    /** the user id associated with this learning */
    associatedId: IdBasedWithSource;
    extraData?: Maybe<Scalars['JSON']['output']>;
    insights?: Maybe<Array<Maybe<Insight>>>;
    /** the learning model that accounts for the result */
    learningModel: LearningModel;
    resultTime?: Maybe<Scalars['GraphQLLong']['output']>;
    scoreDecile?: Maybe<Scalars['Int']['output']>;
    scorePercentile?: Maybe<Scalars['Int']['output']>;
    scoreValue?: Maybe<Scalars['Float']['output']>;
};

/** Field that is on used for a reference resolver on some queries, not to be queried directly */
export type BatchRules = {
    /** canCommingleComparables rule enabled */
    canCommingleComparables?: Maybe<Scalars['Boolean']['output']>;
    /** category string */
    comminglingCategory?: Maybe<Scalars['String']['output']>;
    /** isAdsRestricted rule enabled */
    isAdsRestricted?: Maybe<Scalars['Boolean']['output']>;
};

export type BedRoomGroup = {
    beds?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['String']['output']>;
};

/** Min and max price that defines a range */
export type BedsPriceRange = {
    max?: Maybe<Scalars['Int']['output']>;
    min?: Maybe<Scalars['Int']['output']>;
};

export type BestOfZillowAgentReporting = {
    agentId?: Maybe<Scalars['ID']['output']>;
    agentIdEncoded?: Maybe<Scalars['ID']['output']>;
    csatUsAverage?: Maybe<Scalars['Int']['output']>;
    data?: Maybe<Array<BestOfZillowAgentReportingData>>;
    isPA?: Maybe<Scalars['Boolean']['output']>;
};

export type BestOfZillowAgentReportingData = {
    adjustedAnswerRate?: Maybe<Scalars['String']['output']>;
    baselineCxnCvr?: Maybe<Scalars['String']['output']>;
    csat?: Maybe<Scalars['Int']['output']>;
    pathwaysLevel?: Maybe<Scalars['Int']['output']>;
    pathwaysNationalPercentile?: Maybe<Scalars['String']['output']>;
    snapshotDate?: Maybe<Scalars['String']['output']>;
    teamLeadZuid?: Maybe<Scalars['ID']['output']>;
    teamLeadZuidEncoded?: Maybe<Scalars['ID']['output']>;
    teamMemberZuid?: Maybe<Scalars['ID']['output']>;
    teamMemberZuidEncoded?: Maybe<Scalars['ID']['output']>;
    timescaledCvr?: Maybe<Scalars['String']['output']>;
};

export type BestOfZillowOwnerReporting = {
    agentId?: Maybe<Scalars['ID']['output']>;
    agentIdEncoded?: Maybe<Scalars['ID']['output']>;
    csatUsAverage?: Maybe<Scalars['Int']['output']>;
    data?: Maybe<Array<BestOfZillowOwnerReportingData>>;
    isPA?: Maybe<Scalars['Boolean']['output']>;
};

export type BestOfZillowOwnerReportingData = {
    adjustedAnswerRate?: Maybe<Scalars['String']['output']>;
    baselineCxnCvr?: Maybe<Scalars['String']['output']>;
    commEventsCxn?: Maybe<Scalars['String']['output']>;
    csat?: Maybe<Scalars['Int']['output']>;
    nlpApptRate?: Maybe<Scalars['String']['output']>;
    pathwaysLevel?: Maybe<Scalars['Int']['output']>;
    pathwaysNationalPercentile?: Maybe<Scalars['String']['output']>;
    showRate6mo?: Maybe<Scalars['String']['output']>;
    snapshotDate?: Maybe<Scalars['String']['output']>;
    teamLeadZuid?: Maybe<Scalars['ID']['output']>;
    teamLeadZuidEncoded?: Maybe<Scalars['ID']['output']>;
    teamMemberZuid?: Maybe<Scalars['ID']['output']>;
    teamMemberZuidEncoded?: Maybe<Scalars['ID']['output']>;
    timescaledCvr?: Maybe<Scalars['String']['output']>;
};

export type BestOfZillowReportingResponse = {
    agentReport?: Maybe<BestOfZillowAgentReporting>;
    ownerReport?: Maybe<BestOfZillowOwnerReporting>;
    teamReport?: Maybe<BestOfZillowTeamReporting>;
};

export type BestOfZillowTeamReporting = {
    agentId?: Maybe<Scalars['ID']['output']>;
    agentIdEncoded?: Maybe<Scalars['ID']['output']>;
    csatUsAverage?: Maybe<Scalars['Int']['output']>;
    data?: Maybe<Array<BestOfZillowTeamReportingData>>;
    isPA?: Maybe<Scalars['Boolean']['output']>;
};

export type BestOfZillowTeamReportingData = {
    adjustedAnswerRate?: Maybe<Scalars['String']['output']>;
    baselineCxnCvr?: Maybe<Scalars['String']['output']>;
    commEventsCxn?: Maybe<Scalars['String']['output']>;
    csat?: Maybe<Scalars['Int']['output']>;
    nlpApptRate?: Maybe<Scalars['String']['output']>;
    pathwaysLevel?: Maybe<Scalars['Int']['output']>;
    pathwaysNationalPercentile?: Maybe<Scalars['String']['output']>;
    showRate6mo?: Maybe<Scalars['String']['output']>;
    snapshotDate?: Maybe<Scalars['String']['output']>;
    teamLeadZuid?: Maybe<Scalars['ID']['output']>;
    teamLeadZuidEncoded?: Maybe<Scalars['ID']['output']>;
    timescaledCvr?: Maybe<Scalars['String']['output']>;
};

/** Information about the bikeability of the area. */
export type BikeScoreResponse = {
    bikescore?: Maybe<Scalars['Int']['output']>;
    description?: Maybe<Scalars['String']['output']>;
};

export type BlendApplicationStatus = 'Created' | 'InApplication' | 'Invited' | 'Submitted';

export type BlendFollowUpContext = {
    document?: Maybe<BlendFollowUpDocument>;
    partyId?: Maybe<Scalars['ID']['output']>;
};

export type BlendFollowUpDocument = {
    type?: Maybe<Scalars['String']['output']>;
};

export type BlendFollowUpTask = {
    applicationId?: Maybe<Scalars['ID']['output']>;
    clientFollowUpReferenceId?: Maybe<Scalars['ID']['output']>;
    comments?: Maybe<Scalars['String']['output']>;
    context?: Maybe<BlendFollowUpContext>;
    dueDate?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    requestedAt?: Maybe<Scalars['String']['output']>;
    status?: Maybe<BlendFollowUpTaskStatus>;
    type?: Maybe<BlendFollowUpTaskType>;
};

export type BlendFollowUpTaskStatus =
    | 'COMPLETED'
    | 'COMPLETED_EXTERNALLY'
    | 'IN_PROGRESS'
    | 'PENDING_REVIEW'
    | 'REJECTED'
    | 'REQUESTED';

export type BlendFollowUpTaskType =
    | 'ASSET_STATEMENTS'
    | 'DOCUMENT_REQUEST'
    | 'DOCUMENT_SIGNATURE'
    | 'DOCUMENT_WET_SIGNATURE'
    | 'PAYMENT_COLLECTION'
    | 'PAYSTUBS'
    | 'REVIEW_DOCUMENTS'
    | 'SYSTEM'
    | 'TAX_RETURN'
    | 'TAX_TRANSCRIPTS'
    | 'W2';

export type BlendedRecommendation = {
    /** recommendation id. Depending on idType, this id can represent zpid or lotId */
    id?: Maybe<Scalars['String']['output']>;
    /** recommendation id type. It can either be a lotid or zpid */
    idType?: Maybe<HomeRecommendationIdType>;
    recommendation?: Maybe<recommendedPropertyOrBuilding>;
    /** Score for recommendation result, the higher the score reflect better recommendation */
    score?: Maybe<Scalars['Float']['output']>;
    trackingTags?: Maybe<trackingTags>;
    zpid?: Maybe<Scalars['Int']['output']>;
};

export type Book = {
    author?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type BooleanAnswer = CustomAnswer & {
    id?: Maybe<Scalars['ID']['output']>;
    question?: Maybe<Question>;
    value?: Maybe<Scalars['Boolean']['output']>;
};

export type BooleanValue = {
    boolean: Scalars['Boolean']['output'];
};

export type Borrower = {
    email?: Maybe<Scalars['String']['output']>;
    firstName: Scalars['String']['output'];
    lastName: Scalars['String']['output'];
    middleName?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BorrowerAttributesInput = {
    cellPhone?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    maritalStatus?: InputMaybe<ZHLMaritalStatus>;
    names?: InputMaybe<Array<InputMaybe<ZHLNameInput>>>;
    taxpayerID?: InputMaybe<Scalars['String']['input']>;
};

/** A geographic bound box */
export type BoundBox = {
    east?: Maybe<Scalars['Float']['output']>;
    north?: Maybe<Scalars['Float']['output']>;
    south?: Maybe<Scalars['Float']['output']>;
    west?: Maybe<Scalars['Float']['output']>;
};

export type BoundingBox = {
    /** The eastern most longitude of the bounding box */
    east: Scalars['Float']['input'];
    /** The northern most latitude of the bounding box */
    north: Scalars['Float']['input'];
    /** The southern most latitude of the bounding box */
    south: Scalars['Float']['input'];
    /** The western most longitude of the bounding box */
    west: Scalars['Float']['input'];
};

export type Brand = 'streeteasy' | 'trulia' | 'zillow';

/** Breadcrumb link data for top header area */
export type Breadcrumb = {
    gaLabel?: Maybe<Scalars['String']['output']>;
    path?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
};

/** Deprecated, use BridgeAgentParticipant instead */
export type BridgeAgentCrmAgentParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

/** Deprecated, use BridgeAgentTeamLeadParticipant instead */
export type BridgeAgentCrmAgentTeamLeadParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeAgentCrmContact = BridgeMoveComponent & {
    contactDetails?: Maybe<BridgeContactDetails>;
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    linkedComponents: Array<Scalars['ID']['output']>;
    status: BridgeComponentStatus;
    updateDt: Scalars['Time']['output'];
};

export type BridgeAgentParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    paAgent?: Maybe<PAAgent>;
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeAgentTeamLeadParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeArrivalGoal = {
    arrivalGoal: Array<ArrivalGoal>;
    createDt: Scalars['Time']['output'];
    source: BridgeSource;
    updateDt: Scalars['Time']['output'];
};

export type BridgeBorrowerParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeBrokerParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeBuy = BridgeMoveComponent & {
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    linkedComponents: Array<Scalars['ID']['output']>;
    myAgentRelationshipId?: Maybe<Scalars['String']['output']>;
    status: BridgeComponentStatus;
    updateDt: Scalars['Time']['output'];
};

/** Deprecated, use BridgeAgentParticipant instead */
export type BridgeBuyerAgentParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    paAgent?: Maybe<PAAgent>;
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

/** Deprecated, use BridgeAgentParticipant instead */
export type BridgeBuyerAgentTeamLeadParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeClosingBuy = BridgeMoveComponent & {
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    linkedComponents: Array<Scalars['ID']['output']>;
    status: BridgeComponentStatus;
    updateDt: Scalars['Time']['output'];
};

/** Deprecated, use BridgeAgentParticipant instead */
export type BridgeClosingBuyerAgentParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

/** Deprecated, use BridgeShopperParticipant instead */
export type BridgeClosingBuyerParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeClosingEscrowAssistantParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeClosingEscrowOfficerParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

/** Deprecated, use BridgeAgentParticipant instead */
export type BridgeClosingListingAgentParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeClosingSell = BridgeMoveComponent & {
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    linkedComponents: Array<Scalars['ID']['output']>;
    status: BridgeComponentStatus;
    updateDt: Scalars['Time']['output'];
};

/** Deprecated, use BridgeSellerParticipant instead */
export type BridgeClosingSellerParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

/**
 * BridgeComponentFilters filters components to return.
 * Defaults to returning all components except canceled components.
 */
export type BridgeComponentFilters = {
    /** list of component statuses to return (filter out all others) */
    statuses?: InputMaybe<Array<BridgeComponentStatus>>;
};

export type BridgeComponentInput = {
    references?: InputMaybe<Array<BridgeComponentReferenceInput>>;
};

export type BridgeComponentParticipation = {
    componentId: Scalars['ID']['output'];
    componentType: BridgeMoveComponentType;
    createDt: Scalars['Time']['output'];
    source: BridgeEventSource;
    updateDt: Scalars['Time']['output'];
};

export type BridgeComponentReferenceInput = {
    refId: Scalars['String']['input'];
    refType: BridgeMoveComponentReferenceType;
};

export type BridgeComponentStatus =
    /** The component is currently active on the move. */
    | 'ACTIVE'
    /** The component has been canceled and is no longer relevant to the move. */
    | 'CANCELED'
    /**
     * The component has been completed and is no longer expected to receive any
     * non-completion updates.
     */
    | 'COMPLETED'
    | 'UNSPECIFIED';

export type BridgeContactDetails = PAContact;

export type BridgeContainer = {
    moves: Array<BridgeMove>;
};

export type BridgeContainerError = {
    message: Scalars['String']['output'];
    retryable?: Maybe<Scalars['Boolean']['output']>;
};

export type BridgeCustomerParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    financeJourney: FinanceJourneyContext;
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeDepartureGoal = {
    createDt: Scalars['Time']['output'];
    departureGoal: Array<DepartureGoal>;
    source: BridgeSource;
    updateDt: Scalars['Time']['output'];
};

/** Originating system for the related component or participant */
export type BridgeEventSource =
    | 'ACTIVATION'
    | 'BRIDGE_CONTAINER'
    | 'BUYER_AGENT_RELATIONSHIPS'
    | 'CARP'
    | 'ILLUMINATE'
    | 'L2'
    | 'L3'
    | 'MISO'
    | 'MY_AGENT'
    | 'PA_CRM'
    | 'PEARL'
    | 'TOURING'
    | 'UNSPECIFIED'
    | 'ZHL';

export type BridgeFinance = BridgeMoveComponent & {
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    linkedComponents: Array<Scalars['ID']['output']>;
    status: BridgeComponentStatus;
    updateDt: Scalars['Time']['output'];
    zhlLid?: Maybe<Scalars['String']['output']>;
    zhlLoan?: Maybe<ZHLLoan>;
    zhlLoanNumber?: Maybe<Scalars['String']['output']>;
    zhlSalesforceLeadId?: Maybe<Scalars['String']['output']>;
};

export type BridgeFinanceGoal = {
    createDt: Scalars['Time']['output'];
    financeGoal: Array<FinanceGoal>;
    source: BridgeSource;
    updateDt: Scalars['Time']['output'];
};

export type BridgeFirstTimeBuyers = {
    createDt: Scalars['Time']['output'];
    /** Source indicates the source system responsible for providing to bridge container the response for BridgeFirstTimeBuyers. */
    source: BridgeSource;
    /** FirstTimeBuyerStatus indicates whether the customer participants have indicated they are first time buyers. */
    status?: Maybe<FirstTimeBuyerStatus>;
    updateDt: Scalars['Time']['output'];
};

export type BridgeHasBuyerAgent = {
    createDt: Scalars['Time']['output'];
    /** Source indicates the source system responsible for providing to bridge container the response for BridgeHasBuyerAgent. */
    source: BridgeSource;
    /** HasBuyerAgent indicates whether the customer participants have indicated they have a buyer's agent. */
    status?: Maybe<HasBuyerAgentStatus>;
    updateDt: Scalars['Time']['output'];
};

export type BridgeIsPreQualified = {
    createDt: Scalars['Time']['output'];
    source: BridgeSource;
    status?: Maybe<IsPreQualifiedStatus>;
    updateDt: Scalars['Time']['output'];
};

export type BridgeLead = BridgeMoveComponent & {
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    l2LeadId?: Maybe<Scalars['String']['output']>;
    l3LeadId?: Maybe<Scalars['String']['output']>;
    linkedComponents: Array<Scalars['ID']['output']>;
    status: BridgeComponentStatus;
    updateDt: Scalars['Time']['output'];
};

export type BridgeLeadArrival = BridgeMoveComponent & {
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    l2LeadId?: Maybe<Scalars['String']['output']>;
    l3LeadId?: Maybe<Scalars['String']['output']>;
    linkedComponents: Array<Scalars['ID']['output']>;
    status: BridgeComponentStatus;
    updateDt: Scalars['Time']['output'];
};

export type BridgeLeadDeparture = BridgeMoveComponent & {
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    l2LeadId?: Maybe<Scalars['String']['output']>;
    l3LeadId?: Maybe<Scalars['String']['output']>;
    linkedComponents: Array<Scalars['ID']['output']>;
    status: BridgeComponentStatus;
    updateDt: Scalars['Time']['output'];
};

export type BridgeLoanOfficerParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    details?: Maybe<BridgeLoanOfficerParticipantDetails>;
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeLoanOfficerParticipantDetails = {
    branchNMLSID?: Maybe<Scalars['Int']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    fullName?: Maybe<Scalars['String']['output']>;
    nmlsID?: Maybe<Scalars['Int']['output']>;
    officePhone?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type BridgeLoanProcessorParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeMisoOffer = BridgeMoveComponent & {
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    linkedComponents: Array<Scalars['ID']['output']>;
    misoAccessTokenId?: Maybe<Scalars['String']['output']>;
    misoId?: Maybe<Scalars['String']['output']>;
    misoQuestionnaireAnswers?: Maybe<QuestionnaireAnswersExt>;
    status: BridgeComponentStatus;
    updateDt: Scalars['Time']['output'];
};

export type BridgeMove = {
    agentCrmContact: Array<BridgeAgentCrmContact>;
    arrivalStatus: BridgeMoveStatus;
    buy: Array<BridgeBuy>;
    closingBuy: Array<BridgeClosingBuy>;
    closingSell: Array<BridgeClosingSell>;
    /** query components field if you want the list of all components */
    components: Array<BridgeMoveComponent>;
    createDt: Scalars['Time']['output'];
    departureStatus: BridgeMoveStatus;
    /** Components are sorted according to the SortMethod before the limit is applied. The default sorting is described in sorting methods */
    finance: Array<BridgeFinance>;
    id: Scalars['ID']['output'];
    /** @deprecated use leadArrival/leadDeparture instead */
    lead: Array<BridgeLead>;
    leadArrival: Array<BridgeLeadArrival>;
    leadDeparture: Array<BridgeLeadDeparture>;
    misoOffer: Array<BridgeMisoOffer>;
    profile: BridgeMoveProfile;
    status: BridgeMoveStatus;
    team: BridgeTeam;
    tourAppointments: Array<BridgeTourAppointment>;
    updateDt: Scalars['Time']['output'];
    version: Scalars['String']['output'];
    zillowTransactionBuy: Array<BridgeZillowTransactionBuy>;
    zillowTransactionSell: Array<BridgeZillowTransactionSell>;
};

export type BridgeMoveagentCrmContactArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMovebuyArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMoveclosingBuyArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMoveclosingSellArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMovecomponentsArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMovefinanceArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMoveleadArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMoveleadArrivalArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMoveleadDepartureArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMovemisoOfferArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMovetourAppointmentsArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMovezillowTransactionBuyArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMovezillowTransactionSellArgs = {
    filter?: InputMaybe<BridgeComponentFilters>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeMoveComponent = {
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    linkedComponents: Array<Scalars['ID']['output']>;
    status: BridgeComponentStatus;
    updateDt: Scalars['Time']['output'];
};

export type BridgeMoveComponentReferenceType =
    | 'L2_LEAD_ID'
    | 'L3_LEAD_ID'
    | 'MISO_ACCESS_TOKEN_ID'
    | 'MISO_ID'
    | 'MISO_QUESTIONNAIRE_RESPONSE_ID'
    | 'MY_AGENT_RELATIONSHIP_ID'
    | 'PA_CRM_CONTACT_ID'
    | 'TOURING_APPOINTMENT_HASH'
    | 'UNSPECIFIED'
    | 'ZHL_LID'
    | 'ZHL_LOAN_NUMBER'
    | 'ZHL_SALESFORCE_LEAD_ID'
    | 'ZHL_SALESFORCE_REQUEST_ID'
    | 'ZILLOW_REFERRAL_TRANSACTION_BUY'
    | 'ZILLOW_REFERRAL_TRANSACTION_SELL';

export type BridgeMoveComponentType =
    | 'AGENT_CRM_CONTACT'
    | 'BUYERS_AGENT'
    | 'CLOSING_BUY'
    | 'CLOSING_SELL'
    | 'FINANCE'
    | 'LEAD_ARRIVAL'
    | 'LEAD_DEPARTURE'
    | 'MISO_OFFER'
    | 'TOUR_APPOINTMENT'
    | 'UNSPECIFIED'
    | 'ZILLOW_TRANSACTION_BUY'
    | 'ZILLOW_TRANSACTION_SELL';

export type BridgeMoveFilters = {
    status: BridgeMoveStatus;
};

export type BridgeMoveProfile = {
    arrivalGoal?: Maybe<BridgeArrivalGoal>;
    createDt: Scalars['Time']['output'];
    departureGoal?: Maybe<BridgeDepartureGoal>;
    financeGoal?: Maybe<BridgeFinanceGoal>;
    /** FirstTimeBuyers indicates whether the customer participants have indicated they have first time home buyers */
    firstTimeBuyers?: Maybe<BridgeFirstTimeBuyers>;
    /** hasBuyerAgent indicates whether the customer participants have indicated they have a buyer's agent. */
    hasBuyerAgent?: Maybe<BridgeHasBuyerAgent>;
    isPreQualified?: Maybe<BridgeIsPreQualified>;
    moveId: Scalars['String']['output'];
    readyToDiscussFinancing?: Maybe<BridgeReadyToDiscussFinancing>;
    startedTouringHomes?: Maybe<BridgeStartedTouringHomes>;
    timeline?: Maybe<BridgeTimeline>;
    updateDt: Scalars['Time']['output'];
    workingWithLender?: Maybe<BridgeWorkingWithLender>;
};

export type BridgeMoveStatus =
    /** The move is currently active. */
    | 'ACTIVE'
    /**
     * The move has been completed and is no longer expected to add new non-completed
     * components, except in rare situations such as a Sebastian use case where they
     * may complete their departure side transaction before their arrival side.
     * This would eventually re-activate the move.
     */
    | 'COMPLETED'
    | 'UNSPECIFIED';

export type BridgeParticipantInput = {
    refId: Scalars['String']['input'];
    refType: BridgeParticipantReferenceType;
};

export type BridgeParticipantReferenceType = 'UNSPECIFIED' | 'ZUID';

/** Deprecated, use BridgeCustomerParticipant instead */
export type BridgeProfileParticipant = {
    createDt: Scalars['Time']['output'];
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeReadyToDiscussFinancing = {
    createDt: Scalars['Time']['output'];
    source: BridgeSource;
    status?: Maybe<ReadyToDiscussFinancingStatus>;
    updateDt: Scalars['Time']['output'];
};

export type BridgeSellerParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeShopperParticipant = BridgeZuidParticipant & {
    createDt: Scalars['Time']['output'];
    financeJourney: FinanceJourneyContext;
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type BridgeSortingMethod =
    /** default sorting method if none is specified */
    'UPDATE_DATE_DESCENDING';

/** Originating system for Move Profile Requests */
export type BridgeSource =
    | 'ACTIVATION'
    | 'BUYER_AGENT_RELATIONSHIPS'
    | 'ILLUMINATE'
    | 'PEARL'
    | 'SOURCE_UNSPECIFIED';

export type BridgeStartedTouringHomes = {
    createDt: Scalars['Time']['output'];
    source: BridgeSource;
    status?: Maybe<StartedTouringHomesStatus>;
    updateDt: Scalars['Time']['output'];
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeam = {
    /** @deprecated use agentTeamLeads instead */
    agentCrmAgentTeamLeads: Array<BridgeAgentCrmAgentTeamLeadParticipant>;
    /** @deprecated use agents instead */
    agentCrmAgents: Array<BridgeAgentCrmAgentParticipant>;
    agentTeamLeads: Array<BridgeAgentTeamLeadParticipant>;
    agents: Array<BridgeAgentParticipant>;
    borrowers: Array<BridgeBorrowerParticipant>;
    brokers: Array<BridgeBrokerParticipant>;
    /** @deprecated use agentTeamLeads instead */
    buyerAgentTeamLead: Array<BridgeBuyerAgentTeamLeadParticipant>;
    /** @deprecated use agents instead */
    buyerAgents: Array<BridgeBuyerAgentParticipant>;
    /** @deprecated use agents instead */
    closingBuyerAgents: Array<BridgeClosingBuyerAgentParticipant>;
    /** @deprecated use shoppers instead */
    closingBuyers: Array<BridgeClosingBuyerParticipant>;
    closingEscrowAssistants: Array<BridgeClosingEscrowAssistantParticipant>;
    closingEscrowOfficers: Array<BridgeClosingEscrowOfficerParticipant>;
    /** @deprecated use agents instead */
    closingListingAgents: Array<BridgeClosingListingAgentParticipant>;
    /** @deprecated use sellers instead */
    closingSellers: Array<BridgeClosingSellerParticipant>;
    /** The customers field will contain all shoppers, sellers, and borrowers */
    customers: Array<BridgeCustomerParticipant>;
    loanOfficers: Array<BridgeLoanOfficerParticipant>;
    loanProcessors: Array<BridgeLoanProcessorParticipant>;
    moveId: Scalars['String']['output'];
    /** @deprecated use customers instead */
    profileParticipants: Array<Maybe<BridgeProfileParticipant>>;
    sellers: Array<BridgeSellerParticipant>;
    shoppers: Array<BridgeShopperParticipant>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamagentCrmAgentTeamLeadsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamagentCrmAgentsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamagentTeamLeadsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamagentsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamborrowersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeambrokersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeambuyerAgentTeamLeadArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeambuyerAgentsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamclosingBuyerAgentsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamclosingBuyersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamclosingEscrowAssistantsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamclosingEscrowOfficersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamclosingListingAgentsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamclosingSellersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamcustomersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamloanOfficersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamloanProcessorsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamprofileParticipantsArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamsellersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

/** Use limit on each field to limit the number of participants returned */
export type BridgeTeamshoppersArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    sortMethod?: InputMaybe<BridgeSortingMethod>;
};

export type BridgeTimeline = {
    createDt: Scalars['Time']['output'];
    source: BridgeSource;
    timeline: Timeline;
    updateDt: Scalars['Time']['output'];
};

export type BridgeTimelineInput = {
    endDate?: InputMaybe<Scalars['Time']['input']>;
    startDate?: InputMaybe<Scalars['Time']['input']>;
    status: TimelineStatus;
};

export type BridgeTourAppointment = BridgeMoveComponent & {
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    linkedComponents: Array<Scalars['ID']['output']>;
    status: BridgeComponentStatus;
    tourAppointment?: Maybe<TourAppointment>;
    updateDt: Scalars['Time']['output'];
};

export type BridgeWorkingWithLender = {
    createDt: Scalars['Time']['output'];
    source: BridgeSource;
    status?: Maybe<WorkingWithLenderStatus>;
    updateDt: Scalars['Time']['output'];
};

export type BridgeZillowTransactionBuy = BridgeMoveComponent & {
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    linkedComponents: Array<Scalars['ID']['output']>;
    status: BridgeComponentStatus;
    transaction?: Maybe<FlexTransaction>;
    updateDt: Scalars['Time']['output'];
};

export type BridgeZillowTransactionSell = BridgeMoveComponent & {
    createDt: Scalars['Time']['output'];
    id: Scalars['ID']['output'];
    linkedComponents: Array<Scalars['ID']['output']>;
    status: BridgeComponentStatus;
    transaction?: Maybe<FlexTransaction>;
    updateDt: Scalars['Time']['output'];
};

export type BridgeZuidParticipant = {
    createDt: Scalars['Time']['output'];
    participatingComponents: Array<Maybe<BridgeComponentParticipation>>;
    updateDt: Scalars['Time']['output'];
    user?: Maybe<User>;
    zuid?: Maybe<Scalars['String']['output']>;
};

export type Brokerage = {
    email?: Maybe<Scalars['String']['output']>;
    escrowFlag?: Maybe<Scalars['Boolean']['output']>;
    officeAddress?: Maybe<Scalars['String']['output']>;
    officeCity?: Maybe<Scalars['String']['output']>;
    officeName?: Maybe<Scalars['String']['output']>;
    officeState?: Maybe<Scalars['String']['output']>;
    officeZip?: Maybe<Scalars['String']['output']>;
    zuid?: Maybe<Scalars['Int']['output']>;
};

/** HDP data relevant to Browse Homes. */
export type BrowseHomesHdp = {
    /** Formatted address of the HDP. */
    address?: Maybe<Scalars['String']['output']>;
    /** URL to the HDP. */
    url?: Maybe<Scalars['String']['output']>;
};

/** A new construction builder */
export type Builder = {
    /** List of all communities' plids for feedId, sorted by name -> minPrice -> plid */
    allCommunities?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    /** Reviews and aggregate ratings for this builder */
    averageRatings?: Maybe<BuilderReviewSet>;
    /** Geographic boundaries for this builder */
    boundBox?: Maybe<BoundBox>;
    communities?: Maybe<Array<Maybe<NcCommunity>>>;
    communitiesCount?: Maybe<Scalars['Int']['output']>;
    communitiesLite?: Maybe<Array<Maybe<NcCommunityLite>>>;
    communityCards?: Maybe<Array<Maybe<NcCommunityCard>>>;
    currency?: Maybe<CurrencyType>;
    description?: Maybe<Scalars['String']['output']>;
    featureConfig?: Maybe<builderFeatureConfig>;
    feedId?: Maybe<Scalars['Int']['output']>;
    locations?: Maybe<Array<Maybe<BuilderLocation>>>;
    logoUrl?: Maybe<Scalars['String']['output']>;
    minPrice?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    /** Reviews for this builder */
    reviews?: Maybe<Array<Maybe<BuilderReview>>>;
    specCount?: Maybe<Scalars['Int']['output']>;
    specialties?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    url?: Maybe<Scalars['String']['output']>;
};

/** A new construction builder */
export type BuildercommunitiesArgs = {
    pageNumber?: InputMaybe<Scalars['Int']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    regionId?: InputMaybe<Scalars['ID']['input']>;
};

/** A new construction builder */
export type BuildercommunitiesLiteArgs = {
    pageNumber?: InputMaybe<Scalars['Int']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    regionId?: InputMaybe<Scalars['ID']['input']>;
};

/** A new construction builder */
export type BuildercommunityCardsArgs = {
    pageNumber?: InputMaybe<Scalars['Int']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    regionId?: InputMaybe<Scalars['Int']['input']>;
};

/** A new construction builder */
export type BuilderreviewsArgs = {
    pageNumber?: InputMaybe<Scalars['Int']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type BuilderDirectory = {
    builders?: Maybe<Array<Maybe<Builder>>>;
    ncCommunityAggregate?: Maybe<NcCommunityAggregate>;
    region?: Maybe<Region>;
    results?: Maybe<Array<Maybe<Builder>>>;
    total?: Maybe<Scalars['Int']['output']>;
};

export type BuilderLocation = {
    /** Reviews and aggregate builder ratings in this location */
    averageRatings?: Maybe<BuilderReviewSet>;
    /** Geographic boundaries for this region */
    boundBox?: Maybe<BoundBox>;
    name?: Maybe<Scalars['String']['output']>;
    providerListingIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    regionId?: Maybe<Scalars['Int']['output']>;
    /** Reviews for this builder region */
    reviews?: Maybe<Array<Maybe<BuilderReview>>>;
    urlFragment?: Maybe<Scalars['String']['output']>;
};

export type BuilderLocationreviewsArgs = {
    pageNumber?: InputMaybe<Scalars['Int']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** Builder Provided School Data */
export type BuilderProvidedSchools = {
    elementarySchool?: Maybe<Scalars['String']['output']>;
    elementarySchoolDistrict?: Maybe<Scalars['String']['output']>;
    highSchool?: Maybe<Scalars['String']['output']>;
    middleOrJuniorSchool?: Maybe<Scalars['String']['output']>;
};

/** All data for an avid builder review */
export type BuilderReview = {
    /** Builder's written response to the reviewerComment */
    builderResponse?: Maybe<Scalars['String']['output']>;
    /** Date the builder responded */
    builderResponseDate?: Maybe<Scalars['String']['output']>;
    /** Zillow's name for this community */
    communityName?: Maybe<Scalars['String']['output']>;
    /** Rating reviewer gave for builder */
    overallRating?: Maybe<Scalars['Int']['output']>;
    /** Date the review was written */
    reviewDate?: Maybe<Scalars['String']['output']>;
    /** ID of review */
    reviewId?: Maybe<Scalars['Int']['output']>;
    /** Reviewer's written comments about the builder */
    reviewText?: Maybe<Scalars['String']['output']>;
    /** Name of reviewer who wrote the review */
    reviewerName?: Maybe<Scalars['String']['output']>;
};

/** Aggregate review data for the builder, builder region, or community */
export type BuilderReviewSet = NcReviewSet & {
    /** Average caring rating given for this builder, builder region, or community */
    caringRating?: Maybe<Scalars['Float']['output']>;
    /** Average confidence rating given for this builder, builder region, or community */
    confidenceRating?: Maybe<Scalars['Float']['output']>;
    /**
     * Number of reviews for this builder, builder region, or community
     * @deprecated Use reviewCount instead
     */
    count?: Maybe<Scalars['Int']['output']>;
    /** Average experience rating given for this builder, builder region, or community */
    experienceRating?: Maybe<Scalars['Float']['output']>;
    /** Average home rating given for this builder, builder region, or community */
    homeRating?: Maybe<Scalars['Float']['output']>;
    /** Average overall rating given for this builder, builder region, or community */
    overallRating?: Maybe<Scalars['Float']['output']>;
    /** Number of ratings for this builder, builder region, or community */
    ratingCount?: Maybe<Scalars['Int']['output']>;
    /** Average responsiveness rating given for this builder, builder region, or community */
    responsivenessRating?: Maybe<Scalars['Float']['output']>;
    /** Number of reviews for this builder, builder region, or community */
    reviewCount?: Maybe<Scalars['Int']['output']>;
    /** Average value rating given for this builder, builder region, or community */
    valueRating?: Maybe<Scalars['Float']['output']>;
    /** Number of reviewers who would recommend this builder, builder region, or community */
    wouldRecommendPercentage?: Maybe<Scalars['Int']['output']>;
};

/**
 * Provides building information based on:
 * - lot id
 * - latitude and longitude
 * - building key
 */
export type Building = {
    /** Building specific ad targeting context parameters */
    adTargets?: Maybe<Scalars['JSON']['output']>;
    /** The address for the building */
    address?: Maybe<Address>;
    /** Google Aerial View id */
    aerialViewVideoId?: Maybe<Scalars['String']['output']>;
    /** Building level 3D tours, it will query by zpid after RDAPI fully supports it */
    amenitiesVRModels?: Maybe<Array<Maybe<BuildingVRModel>>>;
    amenityDetails?: Maybe<AmenityDetails>;
    /** Pictures of the property */
    amenityPhotos?: Maybe<Array<Maybe<Photo>>>;
    amenitySummary?: Maybe<AmenitySummary>;
    /** Information about the closest assigned elementary, middle, and high school */
    assignedSchools?: Maybe<Array<Maybe<School>>>;
    /** Canonical URL for building page */
    bdpUrl?: Maybe<Scalars['String']['output']>;
    /** IANA timezone string of this property (i.e. America/New_York) or null if it is unavailable */
    bestGuessTimezone?: Maybe<Scalars['String']['output']>;
    bestMatchedUnit?: Maybe<UnitV2>;
    /** Information about the bikeability of the area. */
    bikeScore?: Maybe<BikeScoreResponse>;
    breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
    /** A list of building area details */
    buildingAreas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    buildingAttributes?: Maybe<BuildingAttributes>;
    buildingName?: Maybe<Scalars['String']['output']>;
    /** The URL used to load a native apps view of a BDP */
    buildingNativeAppsUrl?: Maybe<Scalars['String']['output']>;
    buildingPhoneNumber?: Maybe<Scalars['String']['output']>;
    /** Nearby Rental Premium Packages Building Info */
    buildingRentalPremiumPackagesInfo?: Maybe<Array<Maybe<BuildingCard>>>;
    /**
     * String representating the type of buildings, see https://bitbucket.zgtools.net/projects/SERVICES/repos/building-service/browse/src/main/java/com/zillow/bls/dto/BuildingType.java
     * for possible values
     */
    buildingType?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    /** search page url and text description to this property's city */
    citySearchUrl?: Maybe<UrlObjectType>;
    /** List of common amenities in units */
    commonUnitAmenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** A list of features related to, or available within, the community */
    communityFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Community type of the building */
    communitySubType?: Maybe<CommunitySubType>;
    comps?: Maybe<Comps>;
    contactInfo?: Maybe<ContactInfo>;
    /** The country code for the property */
    country?: Maybe<CountryCode>;
    county?: Maybe<Scalars['String']['output']>;
    /** The currency code for the property */
    currency?: Maybe<CurrencyType>;
    /** User defined description of the building */
    description?: Maybe<Scalars['String']['output']>;
    detailedParkingPolicies?: Maybe<Array<Maybe<DetailedParkingPolicy>>>;
    detailedPetPolicy?: Maybe<DetailedPetPolicy>;
    /** The info used for the Engrain map */
    engrain?: Maybe<BuildingEngrainType>;
    /** A list of features or description of the exterior of the property included in the sale/lease */
    exteriorFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** A list of building extra features */
    extraFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** disclaimer for greystar buildings */
    floorPlanDisclaimer?: Maybe<Scalars['String']['output']>;
    floorPlans?: Maybe<Array<Maybe<FloorPlan>>>;
    /**
     * This field behaves the same as the contactFormRenderData top level query
     * @deprecated deprecating as they are not used for BDPs and we should not allow them to be fetched for BDPs
     */
    forSaleContactFormData?: Maybe<ForSaleContactFormData>;
    /** The summary of the for sale units for the building */
    forSaleUnitsSummary?: Maybe<UnitsSummary>;
    fullAddress?: Maybe<Scalars['String']['output']>;
    /** Google reviews for a building */
    googleReviews?: Maybe<GoogleReviews>;
    /** Signed Google static map url */
    googleStaticMapSignedUrl?: Maybe<Scalars['String']['output']>;
    /** Signed Google Street View image url */
    googleStreetViewImageSignedUrl?: Maybe<Scalars['String']['output']>;
    /** Signed Google Street View metadata url */
    googleStreetViewMetadataSignedUrl?: Maybe<Scalars['String']['output']>;
    /** Boolean flag for attribute data source, it will set to true if the attribute is inferred */
    hasInferredAttribute?: Maybe<Scalars['Boolean']['output']>;
    /**
     * True if the property has a public video
     * @deprecated Feature has been deprecated. Fields will be removed once clients remove their dependencies.
     */
    hasPublicVideo?: Maybe<Scalars['Boolean']['output']>;
    /** Boolean indicating whether or not there are room for rent */
    hasRoomForRent?: Maybe<Scalars['Boolean']['output']>;
    /** Phrases used for home insight tags */
    homeInsights?: Maybe<BuildingHomeInsights>;
    /** List of recommended homes for logged in and anonymous users */
    homeRecommendations?: Maybe<HomeRecommendation>;
    /** The info used for the Engrain map */
    homeTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    housingConnector?: Maybe<HousingConnector>;
    /** Stores Housing Voucher eligibility and Local Content information */
    housingVoucher?: Maybe<HousingVoucher>;
    /**
     * A list of enabled instant tour tour types for a building
     * @deprecated migrating to instantTourTypesDetails
     */
    instantTourTypes?: Maybe<Array<Maybe<InstantTourType>>>;
    /** A list of enabled instant tour tour types for a building and their details */
    instantTourTypesDetails?: Maybe<Array<Maybe<InstantTourTypeDetails>>>;
    /** A list of features or description of the interior of the property included in the sale/lease */
    interiorFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Boolean value indicating if the instant tours for the building can be cancelled with Zillow */
    isInstantTourCancellable?: Maybe<Scalars['Boolean']['output']>;
    /** Boolean value indicating if the building has instant tour feature enabled */
    isInstantTourEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** Boolean indicating that the building participates in the Landlord Liaison Program */
    isLandlordLiaisonProgram?: Maybe<Scalars['Boolean']['output']>;
    /** Boolean indicating whether or not there are income restrictions */
    isLowIncome?: Maybe<Scalars['Boolean']['output']>;
    /** Indicates if the building properties are from paid multi family feed */
    isPaidMultiFamilyBrokerId?: Maybe<Scalars['Boolean']['output']>;
    /** Indicates if the building properties are from paid single family feed */
    isPaidSingleFamilyBrokerId?: Maybe<Scalars['Boolean']['output']>;
    /** Indicates if the building has met its monthly lead cap */
    isRentalsLeadCapMet?: Maybe<Scalars['Boolean']['output']>;
    isSavedByCurrentSignedInUser?: Maybe<Scalars['Boolean']['output']>;
    /** Boolean indicating that the building is only avialable to seniors */
    isSeniorHousing?: Maybe<Scalars['Boolean']['output']>;
    /** Boolean indicating that the building is only available to students */
    isStudentHousing?: Maybe<Scalars['Boolean']['output']>;
    /** Boolean value indicating if the building is a waitlist building */
    isWaitlisted?: Maybe<Scalars['Boolean']['output']>;
    latLong?: Maybe<LatLong>;
    /** latitude of the building */
    latitude?: Maybe<Scalars['Float']['output']>;
    /** Lease lengths available from this building */
    leaseLengths?: Maybe<Scalars['String']['output']>;
    /** Listing criteria for LC module on BDP */
    listingCriteria?: Maybe<ListingCriteria>;
    /** String value generated based on building posting information */
    listingFeatureType?: Maybe<Scalars['String']['output']>;
    listingMetadata?: Maybe<listingMetadata>;
    /** Local Protection Data For City, County, State */
    localProtections?: Maybe<localProtections>;
    /** longitude of the building */
    longitude?: Maybe<Scalars['Float']['output']>;
    /** Lot ID (unique ID) of the building */
    lotId?: Maybe<Scalars['ID']['output']>;
    /** The URL and city used to direct the user to the market insights page */
    marketInsightsUrl?: Maybe<MarketInsightsType>;
    /** Rental marketing treatments */
    marketingTreatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Metadata for Building SEO tests */
    metaData?: Maybe<MetaData>;
    /** Short descriptions of nearby amenities such as grocery stores and coffee shops */
    nearbyAmenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** List of links to nearby rental buildings */
    nearbyBuildingLinks?: Maybe<Array<Maybe<NearbyBuildingLink>>>;
    /** List of links to nearby cities for SEO footer */
    nearbyCities?: Maybe<Array<Maybe<Region>>>;
    /** List of links to nearby neighborhoods for SEO footer */
    nearbyNeighborhoods?: Maybe<Array<Maybe<Region>>>;
    /**
     * Information about nearby schools
     * @deprecated Provides identical results to `assignedSchools`.
     */
    nearbySchools?: Maybe<Array<Maybe<School>>>;
    /** List of links to nearby zip code for SEO footer */
    nearbyZipcodes?: Maybe<Array<Maybe<Region>>>;
    neighborhood?: Maybe<Scalars['String']['output']>;
    photoCount?: Maybe<Scalars['Int']['output']>;
    /** Pictures of the property */
    photos?: Maybe<Array<Maybe<Photo>>>;
    /** Id for google ratings */
    placeId?: Maybe<Scalars['String']['output']>;
    /** Describes a pool in terms of heated, gunite, above ground, etc */
    poolFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Posting contact from property for the given zpid */
    postingContact?: Maybe<postingContact>;
    /** The type of posting product from property for the given zpid */
    postingProductType?: Maybe<PostingProductType>;
    ppcLink?: Maybe<PPCLink>;
    /**
     * The primary public video of the property
     * @deprecated Feature has been deprecated. Fields will be removed once clients remove their dependencies.
     */
    primaryPublicVideo?: Maybe<Video>;
    /** A list of provider information */
    providerInfoList?: Maybe<Array<Maybe<ProviderInfoListType>>>;
    questionsAnswersInfo?: Maybe<QuestionsAnswersInfo>;
    regionIds?: Maybe<RegionIds>;
    /** Disclaimer for rental cost and fees module */
    rentalCostAndFeesDisclaimer?: Maybe<Scalars['String']['output']>;
    /** Instant rental property tour */
    rentalInstantTour?: Maybe<RentalInstantTour>;
    rentalListingOwnerContact?: Maybe<RentalListingOwnerContactType>;
    /** The summary of the rental units for the building */
    rentalUnitsSummary?: Maybe<UnitsSummary>;
    reviewsInfo?: Maybe<ReviewsInfo>;
    /** url and text description to search for schools in the property's city */
    schoolSearchUrl?: Maybe<UrlObjectType>;
    /** returns assigned school information from the schools v6 endpoint */
    schools?: Maybe<Array<Maybe<School>>>;
    /** Housing connector screening criteria for representative property */
    screeningCriteria?: Maybe<ScreeningCriteria>;
    /** Boolean value to show notice from ALN Apartment Data in the footer area */
    showAlnNotice?: Maybe<Scalars['Boolean']['output']>;
    /** Indicates whether we should show the text "Building" in the header */
    showBuildingLabel?: Maybe<Scalars['Boolean']['output']>;
    /** Boolean indicating whether to display the income restricted CTA on contact buttons */
    showIncomeRestrictedCTA?: Maybe<Scalars['Boolean']['output']>;
    specialOffers?: Maybe<Array<Maybe<SpecialOffer>>>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    /** A list of building's third-party virtual tours */
    thirdPartyVirtualTours?: Maybe<Array<Maybe<thirdPartyVirtualTour>>>;
    thumbnailPhoto?: Maybe<Photo>;
    /** Information about public transit availability in the area */
    transitScore?: Maybe<TransitScoreResponse>;
    /** A list of units that cannot be grouped under any floor plan */
    ungroupedUnits?: Maybe<Array<Maybe<UnitV2>>>;
    /** @deprecated Replaced by ungroupdUnits and floorPlans */
    unitListGroups?: Maybe<Array<Maybe<UnitListGroup>>>;
    /** Overview of bed, bath, and sqft of a unit */
    unitOverview?: Maybe<Array<Maybe<UnitOverview>>>;
    /** Floorplan / Unit level 3D tours */
    unitsVRModels?: Maybe<Array<Maybe<BuildingVRModel>>>;
    /** VaLoan status info */
    vaLoanStatus?: Maybe<Scalars['String']['output']>;
    /** A list of video urls */
    videos?: Maybe<Array<Maybe<VideoUrl>>>;
    /** Information about the walkability of the area. */
    walkScore?: Maybe<WalkScoreResponse>;
    zipcode?: Maybe<Scalars['String']['output']>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    zpid?: Maybe<Scalars['ID']['output']>;
};

/**
 * Provides building information based on:
 * - lot id
 * - latitude and longitude
 * - building key
 */
export type BuildingamenityPhotosArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Scalars['Int']['input']>;
    size?: InputMaybe<PropertyPhotoSize>;
};

/**
 * Provides building information based on:
 * - lot id
 * - latitude and longitude
 * - building key
 */
export type BuildinggoogleStaticMapSignedUrlArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    height?: InputMaybe<Scalars['Int']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    scale?: InputMaybe<Scalars['Int']['input']>;
    type?: InputMaybe<GoogleStaticMapType>;
    width?: InputMaybe<Scalars['Int']['input']>;
    zoom?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Provides building information based on:
 * - lot id
 * - latitude and longitude
 * - building key
 */
export type BuildinggoogleStreetViewImageSignedUrlArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    height?: InputMaybe<Scalars['Int']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    locationType?: InputMaybe<GoogleStreetviewLocationType>;
    width?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Provides building information based on:
 * - lot id
 * - latitude and longitude
 * - building key
 */
export type BuildinggoogleStreetViewMetadataSignedUrlArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    locationType?: InputMaybe<GoogleStreetviewLocationType>;
};

/**
 * Provides building information based on:
 * - lot id
 * - latitude and longitude
 * - building key
 */
export type BuildinghomeRecommendationsArgs = {
    clientName: Scalars['String']['input'];
    excludeZpids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    maxRecs?: InputMaybe<Scalars['Int']['input']>;
    placement: PlacementOption;
    queryType: QueryTypeOption;
    zpid?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Provides building information based on:
 * - lot id
 * - latitude and longitude
 * - building key
 */
export type BuildingphotosArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Scalars['Int']['input']>;
    size?: InputMaybe<PropertyPhotoSize>;
};

export type BuildingAddress = {
    city?: Maybe<Scalars['String']['output']>;
    neighborhood?: Maybe<Scalars['String']['output']>;
    postalCode?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
};

/** Provides all the building attributes of a building */
export type BuildingAttributes = {
    administrativeFee?: Maybe<Scalars['Float']['output']>;
    airConditioning?: Maybe<AirConditioning>;
    amenitiesNearby1?: Maybe<Scalars['String']['output']>;
    amenitiesNearby2?: Maybe<Scalars['String']['output']>;
    amenitiesNearby3?: Maybe<Scalars['String']['output']>;
    amenitiesNearby4?: Maybe<Scalars['String']['output']>;
    appliances?: Maybe<Array<Maybe<ApplianceType>>>;
    applicationFee?: Maybe<Scalars['Float']['output']>;
    architect?: Maybe<Scalars['String']['output']>;
    associationName?: Maybe<Scalars['String']['output']>;
    buildingName?: Maybe<Scalars['String']['output']>;
    busesNearbyDescription?: Maybe<Scalars['String']['output']>;
    canDisplay?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    communicationTypes?: Maybe<Array<Maybe<CommunicationType>>>;
    communityListingStatus?: Maybe<CommunityListingStatusType>;
    communityRooms?: Maybe<Array<Maybe<CommunityRoomType>>>;
    communitySizeType?: Maybe<CommunitySizeType>;
    communityType?: Maybe<CommunityType>;
    customAmenities?: Maybe<Scalars['String']['output']>;
    customPropertyAmenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    customUnitAmenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    depositFeeMax?: Maybe<Scalars['Float']['output']>;
    depositFeeMin?: Maybe<Scalars['Float']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    detailedParkingPolicies?: Maybe<Array<Maybe<DetailedParkingPolicy>>>;
    detailedPetPolicy?: Maybe<DetailedPetPolicy>;
    floorCoverings?: Maybe<Array<Maybe<FloorCoveringType>>>;
    hasAssistedLiving?: Maybe<Scalars['Boolean']['output']>;
    hasBarbecue?: Maybe<Scalars['Boolean']['output']>;
    hasBicycleStorage?: Maybe<Scalars['Boolean']['output']>;
    hasCeilingFan?: Maybe<Scalars['Boolean']['output']>;
    hasDisabledAccess?: Maybe<Scalars['Boolean']['output']>;
    hasDryCleaningDropOff?: Maybe<Scalars['Boolean']['output']>;
    hasElevator?: Maybe<Scalars['Boolean']['output']>;
    hasFireplace?: Maybe<Scalars['Boolean']['output']>;
    hasGuestSuite?: Maybe<Scalars['Boolean']['output']>;
    hasHotTub?: Maybe<Scalars['Boolean']['output']>;
    hasOnlineMaintenancePortal?: Maybe<Scalars['Boolean']['output']>;
    hasOnlineRentPayment?: Maybe<Scalars['Boolean']['output']>;
    hasOnsiteManagement?: Maybe<Scalars['Boolean']['output']>;
    hasPackageService?: Maybe<Scalars['Boolean']['output']>;
    hasPatioBalcony?: Maybe<Scalars['Boolean']['output']>;
    hasPetPark?: Maybe<Scalars['Boolean']['output']>;
    hasRoomForRent?: Maybe<Scalars['Boolean']['output']>;
    hasSauna?: Maybe<Scalars['Boolean']['output']>;
    hasSharedLaundry?: Maybe<Scalars['Boolean']['output']>;
    hasSpanishSpeakingStaff?: Maybe<Scalars['Boolean']['output']>;
    hasStorage?: Maybe<Scalars['Boolean']['output']>;
    hasSwimmingPool?: Maybe<Scalars['Boolean']['output']>;
    hasTwentyFourHourMaintenance?: Maybe<Scalars['Boolean']['output']>;
    hasVRModel?: Maybe<Scalars['Boolean']['output']>;
    hasValetTrash?: Maybe<Scalars['Boolean']['output']>;
    heatingSource?: Maybe<HeatingSourceType>;
    hoursOfOperation?: Maybe<Scalars['String']['output']>;
    incomeRestrictions?: Maybe<IncomeRestrictionsType>;
    isDisplayDescription?: Maybe<Scalars['Boolean']['output']>;
    isFurnished?: Maybe<Scalars['Boolean']['output']>;
    isLowIncome?: Maybe<Scalars['Boolean']['output']>;
    isMilitaryHousing?: Maybe<Scalars['Boolean']['output']>;
    isNewConstructionHousing?: Maybe<Scalars['Boolean']['output']>;
    isOver55?: Maybe<Scalars['Boolean']['output']>;
    isSeniorHousing?: Maybe<Scalars['Boolean']['output']>;
    isSmokeFree?: Maybe<Scalars['Boolean']['output']>;
    isStudentHousing?: Maybe<Scalars['Boolean']['output']>;
    latitude?: Maybe<Scalars['Float']['output']>;
    leaseLengths?: Maybe<Scalars['String']['output']>;
    leaseTerms?: Maybe<Array<Maybe<LeaseTermsType>>>;
    longitude?: Maybe<Scalars['Float']['output']>;
    lotURL?: Maybe<Scalars['String']['output']>;
    managerName?: Maybe<Scalars['String']['output']>;
    outdoorCommonAreas?: Maybe<Array<Maybe<OutdoorCommonAreaType>>>;
    parkingDescription?: Maybe<Scalars['String']['output']>;
    parkingRentDescription?: Maybe<Scalars['String']['output']>;
    parkingTypes?: Maybe<Array<Maybe<ParkingTypesType>>>;
    petPolicies?: Maybe<Array<Maybe<PetPolicyType>>>;
    petPolicyDescription?: Maybe<Scalars['String']['output']>;
    postalCode?: Maybe<Scalars['String']['output']>;
    primaryImage?: Maybe<PrimaryImageType>;
    railNearbyDescription?: Maybe<Scalars['String']['output']>;
    rentalCostAndFeesDisclaimer?: Maybe<Scalars['String']['output']>;
    rentalProductType?: Maybe<RentalProductType>;
    richMedia?: Maybe<Array<Maybe<RichMediaType>>>;
    securityTypes?: Maybe<Array<Maybe<SecurityTypesType>>>;
    specialOffers?: Maybe<Array<Maybe<SpecialOfferType>>>;
    sportsCourts?: Maybe<Array<Maybe<SportsCourtType>>>;
    state?: Maybe<Scalars['String']['output']>;
    statusType?: Maybe<Scalars['String']['output']>;
    storyCount?: Maybe<Scalars['Int']['output']>;
    streetAddress1?: Maybe<Scalars['String']['output']>;
    streetAddress2?: Maybe<Scalars['String']['output']>;
    structureType?: Maybe<StructureType>;
    translatedCustomAmenities?: Maybe<TranslatedAmenities>;
    unitCount?: Maybe<Scalars['Int']['output']>;
    utilitiesIncluded?: Maybe<Array<Maybe<UtilitiesIncludedType>>>;
    viewType?: Maybe<Array<Maybe<ViewType>>>;
    xxternalDataSourceType?: Maybe<Scalars['String']['output']>;
    yearBuilt?: Maybe<Scalars['Int']['output']>;
    yearRemodeled?: Maybe<Scalars['Int']['output']>;
};

export type BuildingAttributesMini = {
    incomeRestrictions?: Maybe<IncomeRestrictionsMini>;
    isLowIncome?: Maybe<Scalars['Boolean']['output']>;
};

export type BuildingCard = {
    bdpLink?: Maybe<Scalars['String']['output']>;
    bedroomGroups?: Maybe<Array<Maybe<BedRoomGroup>>>;
    buildingAddress?: Maybe<Scalars['String']['output']>;
    buildingName?: Maybe<Scalars['String']['output']>;
    /** latitude of the building */
    latitude?: Maybe<Scalars['Float']['output']>;
    listingMetadata?: Maybe<listingMetadata>;
    /** longitude of the building */
    longitude?: Maybe<Scalars['Float']['output']>;
    /** Lot ID (unique ID) of the building */
    lotId?: Maybe<Scalars['ID']['output']>;
    maxPrice?: Maybe<Scalars['Int']['output']>;
    minBaths?: Maybe<Scalars['Float']['output']>;
    minBeds?: Maybe<Scalars['Int']['output']>;
    minLivingArea?: Maybe<Scalars['Int']['output']>;
    minPrice?: Maybe<Scalars['Int']['output']>;
    photo?: Maybe<Photo>;
    photoCount?: Maybe<Scalars['String']['output']>;
    providerListingId?: Maybe<Scalars['String']['output']>;
    recentlyUpdated?: Maybe<Scalars['Boolean']['output']>;
    showUpdateTime?: Maybe<Scalars['Boolean']['output']>;
    updateTimeLabel?: Maybe<Scalars['String']['output']>;
};

export type BuildingCardMini = {
    /** latitude of the building */
    latitude?: InputMaybe<Scalars['Float']['input']>;
    /** longitude of the building */
    longitude?: InputMaybe<Scalars['Float']['input']>;
    /** Lot ID (unique ID) of the building */
    lotId?: InputMaybe<Scalars['ID']['input']>;
    /** mid price of the building */
    price?: InputMaybe<Scalars['Int']['input']>;
};

export type BuildingEngrainLevelsType = {
    floorId?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    units?: Maybe<Array<Maybe<BuildingEngrainUnitsType>>>;
};

export type BuildingEngrainType = {
    availableBedroomOptions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    levels?: Maybe<Array<Maybe<BuildingEngrainLevelsType>>>;
    mapId?: Maybe<Scalars['String']['output']>;
};

export type BuildingEngrainUnitsType = {
    bedroomType?: Maybe<Scalars['String']['output']>;
    engrainId?: Maybe<Scalars['String']['output']>;
    zpid?: Maybe<Scalars['String']['output']>;
};

export type BuildingHomeInsights = {
    insights?: Maybe<Array<Maybe<buildingInsights>>>;
};

/** A small set of fields from building type */
export type BuildingMini = {
    /** Cannonical URL for building page */
    bdpUrl?: Maybe<Scalars['String']['output']>;
    buildingAttributes?: Maybe<BuildingAttributesMini>;
    buildingName?: Maybe<Scalars['String']['output']>;
    forSaleUnitsSummary?: Maybe<BuildingUnitsSummary>;
    housingConnector?: Maybe<HousingConnector>;
    ppcLink?: Maybe<PPCLink>;
    rentalUnitsSummary?: Maybe<BuildingUnitsSummary>;
    streetAddress?: Maybe<Scalars['String']['output']>;
};

export type BuildingPermit = {
    /** Details for building permits */
    details?: Maybe<Array<Maybe<BuildingPermitDetail>>>;
    /** City issued building permit number. */
    permitNumber?: Maybe<Scalars['String']['output']>;
};

export type BuildingPermitDetail = {
    /** The business name of the contractor */
    contractor?: Maybe<Scalars['String']['output']>;
    /** Permit Date */
    date?: Maybe<Scalars['String']['output']>;
    /** Details of the permit */
    description?: Maybe<Scalars['String']['output']>;
    /** Status of the building permit */
    status?: Maybe<Scalars['String']['output']>;
};

/** MLS Rules associated with this building */
export type BuildingPropertyRules = {
    agentNameIfRequired?: Maybe<Scalars['String']['output']>;
    agentPhoneIfRequired?: Maybe<PhoneRule>;
    brokerNameIfRequired?: Maybe<Scalars['String']['output']>;
    brokerPhoneIfRequired?: Maybe<PhoneRule>;
    builderNameIfRequired?: Maybe<Scalars['String']['output']>;
    canShowAddress?: Maybe<Scalars['Boolean']['output']>;
    canShowCroppedPhotos?: Maybe<Scalars['Boolean']['output']>;
    canShowNonIDXMedia?: Maybe<Scalars['Boolean']['output']>;
    canShowOnMap?: Maybe<Scalars['Boolean']['output']>;
    comminglingCategory?: Maybe<Scalars['String']['output']>;
    justAgentNameIfRequired?: Maybe<Scalars['String']['output']>;
    mapCardAttribution?: Maybe<MapCardAttribution>;
    mlsIdIfRequired?: Maybe<Scalars['String']['output']>;
    mlsNameIfRequired?: Maybe<Scalars['String']['output']>;
    mlsStatusIfRequired?: Maybe<Scalars['String']['output']>;
    mustDisplayLotSizeInAcres?: Maybe<Scalars['Boolean']['output']>;
    providerLogoIfRequired?: Maybe<Array<Maybe<ProviderLogo>>>;
};

export type BuildingSchool = {
    address?: Maybe<BuildingSchoolAddress>;
    assigned?: Maybe<Scalars['Boolean']['output']>;
    distance?: Maybe<Scalars['Float']['output']>;
    grades?: Maybe<Scalars['String']['output']>;
    isAssigned?: Maybe<Scalars['Boolean']['output']>;
    level?: Maybe<Scalars['String']['output']>;
    link?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    overwriteSource?: Maybe<Scalars['String']['output']>;
    rating?: Maybe<Scalars['Int']['output']>;
    size?: Maybe<Scalars['Int']['output']>;
    studentsPerTeacher?: Maybe<Scalars['Int']['output']>;
    totalCount?: Maybe<Scalars['Int']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

export type BuildingSchoolAddress = {
    city?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    street?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type BuildingSeoTags = {
    description?: Maybe<Scalars['String']['output']>;
    h1?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

/** Provides essential building information, designed for a list card */
export type BuildingSummary = {
    address?: Maybe<SummaryAddress>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    bestMatchZpid?: Maybe<Scalars['ID']['output']>;
    buildingPropertyRules?: Maybe<BuildingPropertyRules>;
    /**
     * String representating the type of buildings, see https://bitbucket.zgtools.net/projects/SERVICES/repos/building-service/browse/src/main/java/com/zillow/bls/dto/BuildingType.java
     * for possible values
     */
    buildingType?: Maybe<Scalars['String']['output']>;
    /** Whether or not the building has an associated 3D Tour model */
    hasVRModel?: Maybe<Scalars['Boolean']['output']>;
    /** latitude of the building */
    latitude?: Maybe<Scalars['Float']['output']>;
    /** longitude of the building */
    longitude?: Maybe<Scalars['Float']['output']>;
    /** Lot ID (unique ID) of the building */
    lotId?: Maybe<Scalars['ID']['output']>;
    /** Name of the building */
    name?: Maybe<Scalars['String']['output']>;
    rentalUnitsSummary?: Maybe<UnitsSummary>;
    /** Region Id of the state where the building is located */
    stateId?: Maybe<Scalars['Int']['output']>;
    thumbnailPhoto?: Maybe<BuildingThumbnailPhoto>;
    /** Canonical URL for building page */
    url?: Maybe<Scalars['String']['output']>;
};

export type BuildingSummaryPhoto = {
    caption?: Maybe<Scalars['String']['output']>;
    height?: Maybe<Scalars['Int']['output']>;
    url?: Maybe<Scalars['String']['output']>;
    width?: Maybe<Scalars['Int']['output']>;
};

/** An image */
export type BuildingThumbnailPhoto = {
    /** height in pixels */
    height?: Maybe<Scalars['Int']['output']>;
    url?: Maybe<Scalars['String']['output']>;
    /** width in pixels */
    width?: Maybe<Scalars['Int']['output']>;
};

export type BuildingType =
    | 'FOR_RENT'
    | 'FOR_SALE'
    | 'MIXED'
    | 'OFFLINE'
    | 'OFF_MARKET'
    | 'RECENTLY_SOLD';

export type BuildingUnit = {
    baths?: Maybe<Scalars['Float']['output']>;
    beds?: Maybe<Scalars['Int']['output']>;
    price?: Maybe<Scalars['Int']['output']>;
    propertyType?: Maybe<Scalars['String']['output']>;
    sqft?: Maybe<Scalars['Int']['output']>;
    zpid?: Maybe<Scalars['Int']['output']>;
};

/** The summary of the units for the building */
export type BuildingUnitsSummary = {
    availableUnitCount?: Maybe<Scalars['Int']['output']>;
    /** A list of all the possible bed counts for active rental units in the building */
    bedOptions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    /** The price range for each bed options */
    bedOptionsPriceRanges?: Maybe<Array<Maybe<BedsPriceRange>>>;
    maxPrice?: Maybe<Scalars['Int']['output']>;
    maxSqft?: Maybe<Scalars['Int']['output']>;
    minPrice?: Maybe<Scalars['Int']['output']>;
    minSqft?: Maybe<Scalars['Int']['output']>;
    unitCount?: Maybe<Scalars['Int']['output']>;
};

export type BuildingUnitsSummarySnapshot = {
    bathRange?: Maybe<DoubleRange>;
    bedRange?: Maybe<LongRange>;
    priceRange?: Maybe<LongRange>;
    sqftRange?: Maybe<LongRange>;
};

export type BuildingVRFloor = {
    fkEntranceEntityId?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
};

export type BuildingVRModel = {
    associations?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    cdnHost?: Maybe<Scalars['String']['output']>;
    panoStructure?: Maybe<BuildingVRPanoStructure>;
    revisionId?: Maybe<Scalars['String']['output']>;
    viewerUrl?: Maybe<Scalars['String']['output']>;
    vrModelGuid?: Maybe<Scalars['String']['output']>;
};

export type BuildingVRPano = {
    entityId?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type BuildingVRPanoStructure = {
    floors?: Maybe<Array<Maybe<BuildingVRFloor>>>;
    panos?: Maybe<Array<Maybe<BuildingVRPano>>>;
    startingFloorId?: Maybe<Scalars['Int']['output']>;
};

export type BulkCurrentIncomeInput = {
    currentIncome: CurrentIncomeInput;
    id?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkLookupFilters = {
    /**
     * Filters results based on the property's commingling category.  Each
     * property has a commingling category of either rulesApplicable or
     * rulesNotApplicable.
     *
     * The purpose of the the flag is to identify how the listing can be
     * displayed with other listings.  All listings marked as rulesApplicable
     * can be displayed together (ie on tab 1).  Listings marked as
     * rulesNotApplicable can be displayed together (ie tab 2) but cannot be
     * displayed on tab 1.
     *
     * This parameter accepts a third state 'commingled' which doesn't filter
     * on the flag and returns all listings regardless of how they can be
     * displayed.   The response field propertyResultRules_comminglingCategory
     * can be requested and will identify each listing as rulesApplicable or
     * rulesNotApplicable.
     *
     * Response records for which a propertyResult was filtered out for this
     * reason will have a status value of COMMINGLING_CATEGORY.
     */
    comminglingCategory?: InputMaybe<ComminglingCategory>;
    /**
     * Filters results based on whether the listing is adsRestricted.
     *
     * Response records for which a propertyResult was filtered out for this
     * reason will have a status value of ADS_RESTRICTED.
     */
    excludeListingsWithAdsRestricted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BulkLookupResponse = {
    /** List of provider info. */
    providerInfoList?: Maybe<Array<PSLProviderInfo>>;
    /** List of property results, each corresponding to a requested listing. */
    results?: Maybe<Array<PropertyResult>>;
};

export type BulkPastJobInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
    pastJob: PastJobInput;
};

export type BulkResidenceInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
    residence: ResidenceInput;
};

export type BusinessConsultant = {
    email?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    phoneExtension?: Maybe<Scalars['String']['output']>;
    photoUrl?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type Buyer = {
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    paContact?: Maybe<PAContact>;
    phone?: Maybe<Scalars['String']['output']>;
};

export type BuyerAgencyAgreement = ServiceAgreement & {
    agent?: Maybe<PAAgent>;
    buyer?: Maybe<Buyer>;
    compensation?: Maybe<AgentCompensation>;
    createdDate?: Maybe<Scalars['DateTime']['output']>;
    zDocsId?: Maybe<Scalars['String']['output']>;
};

export type BuyerParticipant = {
    /**
     * **Definition:** The contact id for the buyer's tour request submission
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-buyer-pii.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    contactId?: Maybe<Scalars['Int']['output']>;
    /**
     * **Definition:** The buyer's email
     *
     * **Source:** See "emailSource" field
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-buyer-pii.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** not visible
     */
    email?: Maybe<Scalars['String']['output']>;
    emailSource?: Maybe<ParticipantContactDataSource>;
    /**
     * **Definition:** A masked version of the buyer's email
     *
     * **Source:** See "emailSource" field
     *
     * **No Auth**
     *
     * **Example:** "b******z@zillow.com"
     */
    maskedEmail?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** The buyer's full name
     *
     * **Source:** See "nameSource" field
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-buyer-pii.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    name?: Maybe<Scalars['String']['output']>;
    nameSource?: Maybe<ParticipantContactDataSource>;
    paContact?: Maybe<PAContact>;
    /**
     * **Definition:** The buyer's phone
     *
     * **Source:** See "phoneSource" field
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-buyer-pii.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    phone?: Maybe<Scalars['String']['output']>;
    phoneSource?: Maybe<ParticipantContactDataSource>;
    /**
     * **Definition:** The zuid of the buyer participant
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-buyer-pii.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** not visible
     */
    zuid?: Maybe<Scalars['Int']['output']>;
};

export type BuyerStatusVersion = 'V1';

export type BuyingPowerBreakdownTooltip = ZHLTooltip & {
    body?: Maybe<Scalars['String']['output']>;
    breakdownItems?: Maybe<Array<Maybe<BuyingPowerValueLabel>>>;
    title: Scalars['String']['output'];
};

export type BuyingPowerChoice = {
    label: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

/** Input object type for current type inputs */
export type BuyingPowerCurrencyInput = {
    type: BuyingPowerInputType;
    value: Scalars['Float']['input'];
};

/** Fetches UI prompt for currency inputs */
export type BuyingPowerCurrencyPrompt = BuyingPowerPrompt & {
    bounds?: Maybe<BuyingPowerInputBounds>;
    explanation?: Maybe<Scalars['String']['output']>;
    isOptional: Scalars['Boolean']['output'];
    prompt: Scalars['String']['output'];
    tooltip?: Maybe<BuyingPowerTooltip>;
    tooltipButton?: Maybe<ZHLTooltipButton>;
    type: BuyingPowerInputType;
    value?: Maybe<Scalars['Float']['output']>;
};

/** User inputs used for type currency */
export type BuyingPowerCurrencyUsedInput = {
    type: BuyingPowerInputType;
    value: Scalars['Float']['output'];
};

/** Renders the UI component for the DTI meter on Buying Power Details view */
export type BuyingPowerDTIMeter = {
    color: BuyingPowerDtiMeterColors;
    description: Scalars['String']['output'];
    /** @deprecated Use wholeLowerBound */
    lowerBound?: Maybe<Scalars['Float']['output']>;
    ratio: Scalars['Float']['output'];
    tooltip: BuyingPowerTooltip;
    /** @deprecated Use wholeUpperBound */
    upperBound: Scalars['Float']['output'];
    /** @deprecated Use wholeValue */
    value: Scalars['Float']['output'];
    wholeLowerBound?: Maybe<Scalars['Int']['output']>;
    wholeUpperBound: Scalars['Int']['output'];
    wholeValue: Scalars['Int']['output'];
};

/** Fetches UI for About you section of Buying Power Details view */
export type BuyingPowerDetailsAboutYou = {
    ctaButton: ZHLStandardButton;
    title: Scalars['String']['output'];
    userInputs: Array<BuyingPowerValueLabel>;
};

/** A breakdown of the user's budget */
export type BuyingPowerDetailsBudget = {
    budgetItems: Array<BuyingPowerCurrencyPrompt>;
    /** If applicable, details regarding the error that occurred when building the Buying Power Details budget view */
    error?: Maybe<BuyingPowerDetailsBudgetError>;
    title: Scalars['String']['output'];
};

/** Error details encountered with calculating the Buying Power Details budget */
export type BuyingPowerDetailsBudgetError = {
    /** More detailed notes about the error that occurred */
    description: Scalars['String']['output'];
    /** Determines the style of error message */
    style: ZHLErrorMessageStyle;
    /** Header text content for the error */
    title: Scalars['String']['output'];
};

/** List of error reasons for why buying power calculation fails */
export type BuyingPowerDetailsErrorReasons = {
    description: Scalars['String']['output'];
    label: Scalars['String']['output'];
};

/** Renders custom error view for buying power calculation error */
export type BuyingPowerDetailsErrorView = {
    ctaButton: ZHLStandardButton;
    heading: Scalars['String']['output'];
    inputs: BuyingPowerUsedInputs;
    reasons: Array<BuyingPowerDetailsErrorReasons>;
    title: Scalars['String']['output'];
};

/** Fetches UI for the hero section of Buying Power Details view */
export type BuyingPowerDetailsHero = {
    aprRate: BuyingPowerValueLabel;
    buyingPower: BuyingPowerValueLabel;
    dtiMeter: BuyingPowerDTIMeter;
    footerDescription?: Maybe<Scalars['String']['output']>;
    footerTitle?: Maybe<Scalars['String']['output']>;
    interestRate: BuyingPowerValueLabel;
};

/** Fetches UI for the loan terms section of Buying Power Details view */
export type BuyingPowerDetailsLoanTerms = {
    ctaButton: ZHLStandardButton;
    description: Scalars['String']['output'];
    footer: Scalars['String']['output'];
    interestRate?: Maybe<BuyingPowerInterestRateDetails>;
    terms: Array<BuyingPowerValueLabel>;
    title: Scalars['String']['output'];
};

export type BuyingPowerDetailsResultView = BuyingPowerDetailsErrorView | BuyingPowerDetailsView;

/** Fetches UI for Save upsell section of Buying Power Details view */
export type BuyingPowerDetailsSaveUpsell = {
    ctaButton: ZHLStandardButton;
    description: Scalars['String']['output'];
    footer?: Maybe<Scalars['String']['output']>;
    heading: Scalars['String']['output'];
};

/** Renders detail view of buying power */
export type BuyingPowerDetailsView = {
    aboutYou: BuyingPowerDetailsAboutYou;
    budget: BuyingPowerDetailsBudget;
    editButtonCTA: ZHLStandardButton;
    header: BuyingPowerValueLabel;
    hero: BuyingPowerDetailsHero;
    inputs: BuyingPowerUsedInputs;
    loanTerms: BuyingPowerDetailsLoanTerms;
    navigationTitle: Scalars['String']['output'];
    saveButtonFooter?: Maybe<ZHLButtonFooter>;
    saveUpsell?: Maybe<BuyingPowerDetailsSaveUpsell>;
};

/** Color ranges for DTI meter */
export type BuyingPowerDtiMeterColors = 'GREEN' | 'RED' | 'YELLOW';

/** Defines bounds for input types */
export type BuyingPowerInputBounds = {
    error: Scalars['String']['output'];
    icon?: Maybe<Scalars['String']['output']>;
    lowerBound: Scalars['Float']['output'];
    upperBound: Scalars['Float']['output'];
};

export type BuyingPowerInputCollectionExperience = 'IMPLICIT_SAVE_FOR_SIGNED_IN_USERS';

/** Renders Input collection view form to request user preferences */
export type BuyingPowerInputCollectionView = {
    ctaButton: ZHLStandardButton;
    description: Scalars['String']['output'];
    financesPromptGroup: BuyingPowerPromptGroup;
    footer?: Maybe<Scalars['String']['output']>;
    futureHomePromptGroup: BuyingPowerPromptGroup;
    navigationTitle: Scalars['String']['output'];
    title: Scalars['String']['output'];
};

/** Input types supported by Buying Power */
export type BuyingPowerInputType =
    | 'ANNUAL_INCOME'
    | 'CREDIT_SCORE'
    | 'DOWN_PAYMENT'
    | 'LOCATION'
    | 'MONTHLY_DEBTS'
    | 'MONTHLY_PAYMENT';

/** Input object type representing the buying power inputs for a user. */
export type BuyingPowerInputs = {
    currencyInputs?: InputMaybe<Array<BuyingPowerCurrencyInput>>;
    singleChoiceInputs?: InputMaybe<Array<BuyingPowerSingleChoiceInput>>;
};

/** Input object type for current type inputs */
export type BuyingPowerInputsSaveResult = {
    success: Scalars['Boolean']['output'];
};

/** Fetches UI for the interest rate details part of loan terms */
export type BuyingPowerInterestRateDetails = {
    icon?: Maybe<ZHLRatesSource>;
    subtext?: Maybe<Scalars['String']['output']>;
    title: Scalars['String']['output'];
    tooltip?: Maybe<BuyingPowerTooltip>;
    value: Scalars['String']['output'];
};

/** Fetches UI prompt for location/address type inputs */
export type BuyingPowerLocationPrompt = BuyingPowerPrompt & {
    error?: Maybe<Scalars['String']['output']>;
    explanation?: Maybe<Scalars['String']['output']>;
    isOptional: Scalars['Boolean']['output'];
    placeholder: Scalars['String']['output'];
    prompt: Scalars['String']['output'];
    stateChoices: Array<BuyingPowerChoice>;
    stateSelectedChoice?: Maybe<BuyingPowerChoice>;
    type: BuyingPowerInputType;
};

/** Override input type for values that will take precedence over existing settings */
export type BuyingPowerOverrideInputs = {
    /** Currency Inputs that will take precedence over other currency inputs when calculating the Buying Power */
    currencyInputs?: InputMaybe<Array<InputMaybe<BuyingPowerCurrencyInput>>>;
};

/** Interface for defining prompts */
export type BuyingPowerPrompt = {
    isOptional: Scalars['Boolean']['output'];
    prompt: Scalars['String']['output'];
    type: BuyingPowerInputType;
};

/** Fetches UI for a group of prompts */
export type BuyingPowerPromptGroup = {
    prompts: Array<BuyingPowerPrompt>;
    title: Scalars['String']['output'];
};

/** Input object type for single choice inputs */
export type BuyingPowerSingleChoiceInput = {
    type: BuyingPowerInputType;
    value: Scalars['String']['input'];
};

/** Fetches UI prompt for single choice inputs */
export type BuyingPowerSingleChoicePrompt = BuyingPowerPrompt & {
    choices: Array<BuyingPowerChoice>;
    explanation?: Maybe<Scalars['String']['output']>;
    isOptional: Scalars['Boolean']['output'];
    placeholder: Scalars['String']['output'];
    prompt: Scalars['String']['output'];
    selectedChoice?: Maybe<BuyingPowerChoice>;
    type: BuyingPowerInputType;
};

/** User inputs used for type single choice */
export type BuyingPowerSingleChoiceUsedInput = {
    type: BuyingPowerInputType;
    value: Scalars['String']['output'];
};

/** Text size formats supported */
export type BuyingPowerSizeFormat = 'COMPACT' | 'FULL';

/** Renders a summary view of buying power */
export type BuyingPowerSummaryView = {
    /** Order of buttons dictates the order of button on the UI */
    ctaButtons: Array<ZHLStandardButton>;
    footer?: Maybe<Scalars['String']['output']>;
    header: Scalars['String']['output'];
    icon: ZHLRatesSource;
    price: BuyingPowerValueLabel;
    priceDetails: Array<BuyingPowerValueLabel>;
};

/** Fetches UI for Tooptip */
export type BuyingPowerTooltip = {
    body?: Maybe<Scalars['String']['output']>;
    heading?: Maybe<Scalars['String']['output']>;
    title: Scalars['String']['output'];
};

/** User inputs used to make calculations */
export type BuyingPowerUsedInputs = {
    currencyInputs?: Maybe<Array<BuyingPowerCurrencyUsedInput>>;
    singleChoiceInputs?: Maybe<Array<BuyingPowerSingleChoiceUsedInput>>;
};

/** A singular metric of the breakdown of a user's buying power */
export type BuyingPowerValueLabel = {
    label: Scalars['String']['output'];
    sublabel?: Maybe<Scalars['String']['output']>;
    tooltip?: Maybe<BuyingPowerTooltip>;
    value: Scalars['String']['output'];
};

/** A singular metric of the breakdown of a user's buying power */
export type BuyingPowerValueLabelvalueArgs = {
    sizeFormat?: InputMaybe<BuyingPowerSizeFormat>;
};

export type BuysideQuestionnaire = {
    mappingSchema?: Maybe<Scalars['JSON']['output']>;
    questionnaireSchema?: Maybe<Scalars['JSON']['output']>;
    schemaKey?: Maybe<Scalars['String']['output']>;
    schemaVersion?: Maybe<Scalars['String']['output']>;
};

export type BuysideQuestionnaireAnswers = {
    /**  Sebastian buyside answers  */
    questionnaireAnswersJson: QuestionnaireAnswersJsonExt;
    /**  The buyside questionnaire response Id  */
    responseId: Scalars['ID']['output'];
    /**  Status of the buyside questionnaire responses  */
    status?: Maybe<QuestionnaireAnswersStatus>;
    /**  The standard Zillow user Id  */
    zuid: Scalars['Int']['output'];
};

export type BuysideQuestionnaireAnswersInput = {
    /**  Questionnaire schema and answers   */
    questionnaireAnswersJson?: InputMaybe<QuestionnaireAnswersJsonInput>;
    /**  Unique ID for the Sebastian buyside answers  */
    responseId: Scalars['ID']['input'];
    /**  Status of Questionnaire Submission Process  */
    status?: InputMaybe<QuestionnaireAnswersStatus>;
};

/** The ccd latest denormalized view of a user based on one of the zillow ids that is associated with the user */
export type CCDLatestDenormalizedView = {
    abcResponseFirstTimeBuyer?: Maybe<Scalars['Boolean']['output']>;
    abcResponseMilitaryStatus?: Maybe<Scalars['Boolean']['output']>;
    abcResponseTimelineToBuy?: Maybe<Scalars['String']['output']>;
    accountTypeId?: Maybe<Scalars['Int']['output']>;
    activityDataDate?: Maybe<Scalars['String']['output']>;
    allZoEligibleHomeClaimMarkts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    allZoEligibleHomeClaimZips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    app3dhTotalToursPub?: Maybe<Scalars['Int']['output']>;
    app3dhTotalToursPub28d?: Maybe<Scalars['Int']['output']>;
    appOnboardingBedMax?: Maybe<Scalars['String']['output']>;
    appOnboardingBedMin?: Maybe<Scalars['String']['output']>;
    appOnboardingLocation?: Maybe<Scalars['String']['output']>;
    appOnboardingPriceMax?: Maybe<Scalars['String']['output']>;
    appOnboardingPriceMin?: Maybe<Scalars['String']['output']>;
    appOnboardingReason?: Maybe<Scalars['String']['output']>;
    ccpaDeleteRequestDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    countFshdppvs7d?: Maybe<Scalars['Int']['output']>;
    countFshdppvs28d?: Maybe<Scalars['Int']['output']>;
    countVisits7d?: Maybe<Scalars['Int']['output']>;
    countVisits28d?: Maybe<Scalars['Int']['output']>;
    creDate?: Maybe<Scalars['String']['output']>;
    datadate?: Maybe<Scalars['String']['output']>;
    dtOf3dhAppInstall?: Maybe<Scalars['String']['output']>;
    dtOfLastMwebVisit?: Maybe<Scalars['String']['output']>;
    emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    ezuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    ezuidsToday?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    firstname?: Maybe<Scalars['String']['output']>;
    funnelDataDate?: Maybe<Scalars['String']['output']>;
    funnelSubstatusLastUpdatedDate?: Maybe<Scalars['String']['output']>;
    funnelType?: Maybe<Scalars['String']['output']>;
    guids?: Maybe<Scalars['JSON']['output']>;
    hasActiveRelationships?: Maybe<Scalars['Boolean']['output']>;
    hasVisitedIosDevice?: Maybe<Scalars['Boolean']['output']>;
    homeSavesLast7d?: Maybe<Scalars['Int']['output']>;
    homeSavesLast28d?: Maybe<Scalars['Int']['output']>;
    homeSharesLast7d?: Maybe<Scalars['Int']['output']>;
    homeSharesLast28d?: Maybe<Scalars['Int']['output']>;
    id: Scalars['String']['output'];
    idDetail?: Maybe<Scalars['String']['output']>;
    idType?: Maybe<Scalars['String']['output']>;
    identityDataDate?: Maybe<Scalars['String']['output']>;
    installSource3dh?: Maybe<Scalars['String']['output']>;
    isActive?: Maybe<Scalars['Int']['output']>;
    isBounce?: Maybe<Scalars['Int']['output']>;
    last3dhAppLoginDt?: Maybe<Scalars['String']['output']>;
    last3dhAppPanoCreateDate?: Maybe<Scalars['String']['output']>;
    last3dhAppTourCreDt?: Maybe<Scalars['String']['output']>;
    last3dhAppTourPubDt?: Maybe<Scalars['String']['output']>;
    last3dhAppVisitDt?: Maybe<Scalars['String']['output']>;
    lastAgentTourDate?: Maybe<Scalars['String']['output']>;
    lastAuthenticatedZillowLeadCreationTimestamp?: Maybe<Scalars['String']['output']>;
    lastConnectionFromAuthenticatedZillowLeadTimestamp?: Maybe<Scalars['String']['output']>;
    lastHdppvSource?: Maybe<Scalars['String']['output']>;
    lastMyAgentStatusChangeTimeUtc?: Maybe<Scalars['String']['output']>;
    lastReAppAgentTourSubmitDate?: Maybe<Scalars['String']['output']>;
    lastReAppFsSearchSvDt?: Maybe<Scalars['String']['output']>;
    lastReAppHdppvDate?: Maybe<Scalars['String']['output']>;
    lastReAppHomeSaveDt?: Maybe<Scalars['String']['output']>;
    lastReAppHomeShareDt?: Maybe<Scalars['String']['output']>;
    lastReAppInstallDt?: Maybe<Scalars['String']['output']>;
    lastReAppLoginDt?: Maybe<Scalars['String']['output']>;
    lastReAppSubmitDate?: Maybe<Scalars['String']['output']>;
    lastReAppViewListSearchDt?: Maybe<Scalars['String']['output']>;
    lastReAppVisitDt?: Maybe<Scalars['String']['output']>;
    lastReAppVisitSource?: Maybe<Scalars['String']['output']>;
    lastReAppVisitSources28d?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    lastSeenDate?: Maybe<Scalars['String']['output']>;
    lastTourItNowUnlockSuccDate?: Maybe<Scalars['String']['output']>;
    lastname?: Maybe<Scalars['String']['output']>;
    maxHdpDwell7d?: Maybe<Scalars['Int']['output']>;
    maxHdpDwell28d?: Maybe<Scalars['Int']['output']>;
    mostRecentAppVer3dh?: Maybe<Scalars['String']['output']>;
    mostRecentClaimListingStatus?: Maybe<Scalars['String']['output']>;
    mostRecentZoEligibleClaimZip?: Maybe<Scalars['String']['output']>;
    mostRecentZoEligibleHomeClaimMkt?: Maybe<Scalars['String']['output']>;
    numOfMwebVisitsLast28d?: Maybe<Scalars['Int']['output']>;
    numOfReAppVisitsLast28d?: Maybe<Scalars['Int']['output']>;
    numReAppAgentTourSubmitsLast28d?: Maybe<Scalars['Int']['output']>;
    numReAppFsSearchSaveLast28d?: Maybe<Scalars['Int']['output']>;
    numReAppHdppvsLast28d?: Maybe<Scalars['Int']['output']>;
    numReAppHomeSavesLast28d?: Maybe<Scalars['Int']['output']>;
    numReAppHomeSharesLast28d?: Maybe<Scalars['Int']['output']>;
    numReAppHomeSubmitLast28d?: Maybe<Scalars['Int']['output']>;
    numReAppTourItNowSubmitsLast28d?: Maybe<Scalars['Int']['output']>;
    numSavedHomesLast7d?: Maybe<Scalars['Int']['output']>;
    paCrmFunnelStatus?: Maybe<Scalars['String']['output']>;
    paCrmFunnelStatusLastUpdatedDate?: Maybe<Scalars['String']['output']>;
    paCrmFunnelSubstatus?: Maybe<Scalars['String']['output']>;
    paLeadMonetizationType?: Maybe<Scalars['String']['output']>;
    paPearlFunnelStatus?: Maybe<Scalars['String']['output']>;
    paPearlFunnelStatusLastUpdatedDate?: Maybe<Scalars['String']['output']>;
    paPearlFunnelSubstatus?: Maybe<Scalars['String']['output']>;
    pearlSmsOptout?: Maybe<Scalars['Boolean']['output']>;
    phones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    polarisId?: Maybe<Scalars['String']['output']>;
    polarisList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    preferenceDataDate?: Maybe<Scalars['String']['output']>;
    primaryRelSourceIsFlexLead?: Maybe<Scalars['Boolean']['output']>;
    processTime?: Maybe<Scalars['String']['output']>;
    profileEmail?: Maybe<Scalars['String']['output']>;
    profileType?: Maybe<Scalars['String']['output']>;
    propertyDataDate?: Maybe<Scalars['String']['output']>;
    reAppInstallSource?: Maybe<Scalars['String']['output']>;
    relPubUpdTimeUtc?: Maybe<Scalars['String']['output']>;
    rentalsFunnelStatus?: Maybe<Scalars['String']['output']>;
    rentalsFunnelSubstatus?: Maybe<Scalars['String']['output']>;
    searchSavesLast7d?: Maybe<Scalars['Int']['output']>;
    searchSavesLast28d?: Maybe<Scalars['Int']['output']>;
    sessionDuration7d?: Maybe<Scalars['Int']['output']>;
    sessionDuration28d?: Maybe<Scalars['Int']['output']>;
    seuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    subscribeToConsumer?: Maybe<Scalars['String']['output']>;
    subscribeToRepro?: Maybe<Scalars['String']['output']>;
    sumCommitted7d?: Maybe<Scalars['Int']['output']>;
    sumCommitted28d?: Maybe<Scalars['Int']['output']>;
    sumDac7d?: Maybe<Scalars['Int']['output']>;
    sumDac28d?: Maybe<Scalars['Int']['output']>;
    sumHdpdwell7d?: Maybe<Scalars['Int']['output']>;
    sumHdpdwell28d?: Maybe<Scalars['Int']['output']>;
    tuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    userClaimedHomeEligibleZo?: Maybe<Scalars['Boolean']['output']>;
    visitedMortgagesappiosLast365d?: Maybe<Scalars['Boolean']['output']>;
    visitedReappiosLast365d?: Maybe<Scalars['Boolean']['output']>;
    visitedRentalsappiosLast365d?: Maybe<Scalars['Boolean']['output']>;
    wpNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    zoClosed?: Maybe<Scalars['Boolean']['output']>;
    zoFunnelStatus?: Maybe<Scalars['String']['output']>;
    zoFunnelStatusLastUpdatedDate?: Maybe<Scalars['String']['output']>;
    zoFunnelSubstatus?: Maybe<Scalars['String']['output']>;
    zoMostRecentCompletedStepDesc?: Maybe<Scalars['String']['output']>;
    zoMostRecentCompletedStepId?: Maybe<Scalars['String']['output']>;
    zoMostRecentCompletedStepNo?: Maybe<Scalars['Int']['output']>;
    zoMostRecentCompletedStepQueue?: Maybe<Scalars['String']['output']>;
    zuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CCDPropensity = {
    creDate?: Maybe<Scalars['String']['output']>;
    extraData?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    modelType?: Maybe<Scalars['String']['output']>;
    modelVersion?: Maybe<Scalars['String']['output']>;
    processTime?: Maybe<Scalars['Float']['output']>;
    scoreDecile?: Maybe<Scalars['Int']['output']>;
    scorePrecentile?: Maybe<Scalars['Int']['output']>;
    scoreValue?: Maybe<Scalars['Float']['output']>;
};

export type CMSAttachment = CMSPostInterface & {
    alt_text?: Maybe<Scalars['String']['output']>;
    caption?: Maybe<CMSRenderedContent>;
    date?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    link?: Maybe<Scalars['String']['output']>;
    media_details?: Maybe<CMSAttachmentDetails>;
    media_type?: Maybe<Scalars['String']['output']>;
    modified?: Maybe<Scalars['String']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    source_url?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    title?: Maybe<CMSRenderedContent>;
    type?: Maybe<Scalars['String']['output']>;
};

export type CMSAttachmentDetails = {
    file?: Maybe<Scalars['String']['output']>;
    filesize?: Maybe<Scalars['Int']['output']>;
    height?: Maybe<Scalars['Int']['output']>;
    sizes?: Maybe<CMSAttachmentSizes>;
    width?: Maybe<Scalars['Int']['output']>;
};

export type CMSAttachmentSize = {
    file?: Maybe<Scalars['String']['output']>;
    filesize?: Maybe<Scalars['String']['output']>;
    height?: Maybe<Scalars['String']['output']>;
    mime_type?: Maybe<Scalars['String']['output']>;
    source_url?: Maybe<Scalars['String']['output']>;
    width?: Maybe<Scalars['String']['output']>;
};

export type CMSAttachmentSizes = {
    full?: Maybe<CMSAttachmentSize>;
    large?: Maybe<CMSAttachmentSize>;
    medium?: Maybe<CMSAttachmentSize>;
    small?: Maybe<CMSAttachmentSize>;
    thumbnail?: Maybe<CMSAttachmentSize>;
};

export type CMSFooter = CMSPostInterface & {
    cms_blocks?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    link?: Maybe<Scalars['String']['output']>;
    modified?: Maybe<Scalars['String']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    title?: Maybe<CMSRenderedContent>;
    type?: Maybe<Scalars['String']['output']>;
};

export type CMSFooterIdentifiers = {
    author?: Maybe<Scalars['ID']['output']>;
    category?: Maybe<Scalars['ID']['output']>;
    default?: Maybe<Scalars['ID']['output']>;
    postTag?: Maybe<Scalars['ID']['output']>;
    search?: Maybe<Scalars['ID']['output']>;
};

export type CMSIDType = 'ID' | 'SLUG' | 'URI';

export type CMSMenuItem = {
    attr_id?: Maybe<Scalars['String']['output']>;
    attr_title?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    parent?: Maybe<Scalars['Int']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    target?: Maybe<Scalars['String']['output']>;
    title?: Maybe<CMSRenderedContent>;
    url?: Maybe<Scalars['String']['output']>;
};

export type CMSPage = CMSPostInterface & {
    brands?: Maybe<Array<Maybe<CMSTerm>>>;
    cms_blocks?: Maybe<Scalars['String']['output']>;
    content?: Maybe<CMSRenderedContent>;
    date?: Maybe<Scalars['String']['output']>;
    excerpt?: Maybe<CMSRenderedContent>;
    footer?: Maybe<CMSFooter>;
    footer_id?: Maybe<Scalars['ID']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    link?: Maybe<Scalars['String']['output']>;
    menu?: Maybe<Array<Maybe<CMSMenuItem>>>;
    menu_id?: Maybe<Scalars['ID']['output']>;
    modified?: Maybe<Scalars['String']['output']>;
    personas?: Maybe<Array<Maybe<CMSTerm>>>;
    revisions?: Maybe<Array<Maybe<CMSRevision>>>;
    sidebar?: Maybe<CMSSidebar>;
    sidebar_id?: Maybe<Scalars['ID']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    template?: Maybe<Scalars['String']['output']>;
    title?: Maybe<CMSRenderedContent>;
    topic?: Maybe<Array<Maybe<CMSTerm>>>;
    type?: Maybe<Scalars['String']['output']>;
    yoast_head?: Maybe<Scalars['String']['output']>;
};

export type CMSPagerevisionsArgs = {
    per_page?: InputMaybe<Scalars['String']['input']>;
};

export type CMSPost = CMSPostInterface & {
    author?: Maybe<CMSUser>;
    author_id?: Maybe<Scalars['ID']['output']>;
    brands?: Maybe<Array<Maybe<CMSTerm>>>;
    categories?: Maybe<Array<Maybe<CMSTerm>>>;
    cms_blocks?: Maybe<Scalars['String']['output']>;
    content?: Maybe<CMSRenderedContent>;
    date?: Maybe<Scalars['String']['output']>;
    excerpt?: Maybe<CMSRenderedContent>;
    featuredImage?: Maybe<CMSAttachment>;
    featured_media?: Maybe<Scalars['ID']['output']>;
    footer?: Maybe<CMSFooter>;
    footer_id?: Maybe<Scalars['ID']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    link?: Maybe<Scalars['String']['output']>;
    menu?: Maybe<Array<Maybe<CMSMenuItem>>>;
    menu_id?: Maybe<Scalars['ID']['output']>;
    meta?: Maybe<CMSPostMeta>;
    modified?: Maybe<Scalars['String']['output']>;
    personas?: Maybe<Array<Maybe<CMSTerm>>>;
    postTags?: Maybe<Array<Maybe<CMSTerm>>>;
    primaryCategory?: Maybe<CMSTerm>;
    primary_category?: Maybe<Scalars['ID']['output']>;
    readTime?: Maybe<Scalars['String']['output']>;
    related?: Maybe<Array<CMSPostInterface>>;
    /** @deprecated Use related instead */
    relatedPosts?: Maybe<CMSPostsResult>;
    revisions?: Maybe<Array<Maybe<CMSRevision>>>;
    sidebar?: Maybe<CMSSidebar>;
    sidebar_id?: Maybe<Scalars['ID']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    template?: Maybe<Scalars['String']['output']>;
    title?: Maybe<CMSRenderedContent>;
    topic?: Maybe<Array<Maybe<CMSTerm>>>;
    type?: Maybe<Scalars['String']['output']>;
    yoast_head?: Maybe<Scalars['String']['output']>;
};

export type CMSPostrelatedPostsArgs = {
    order?: InputMaybe<CMSPostOrder>;
    orderby?: InputMaybe<CMSPostOrderBy>;
    page?: InputMaybe<Scalars['String']['input']>;
    per_page?: InputMaybe<Scalars['String']['input']>;
};

export type CMSPostrevisionsArgs = {
    per_page?: InputMaybe<Scalars['String']['input']>;
};

export type CMSPostInterface = {
    date?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    link?: Maybe<Scalars['String']['output']>;
    modified?: Maybe<Scalars['String']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    title?: Maybe<CMSRenderedContent>;
    type?: Maybe<Scalars['String']['output']>;
};

export type CMSPostMeta = {
    relatedPosts?: Maybe<CMSRelatedPostMeta>;
};

export type CMSPostOrder = 'ASC' | 'DESC';

export type CMSPostOrderBy =
    | 'AUTHOR'
    | 'DATE'
    | 'ID'
    | 'INCLUDE'
    | 'INCLUDE_SLUGS'
    | 'MENU_ORDER'
    | 'MODIFIED'
    | 'PARENT'
    | 'RELEVANCE'
    | 'SLUG'
    | 'TITLE';

export type CMSPostTypeEnum = 'FOOTER' | 'PAGE' | 'POST' | 'SIDEBAR';

export type CMSPostsResult = {
    pages?: Maybe<Scalars['Int']['output']>;
    posts?: Maybe<Array<Maybe<CMSPostInterface>>>;
    total?: Maybe<Scalars['Int']['output']>;
};

export type CMSRedirect = {
    format?: Maybe<Scalars['String']['output']>;
    origin?: Maybe<Scalars['String']['output']>;
    target?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['Int']['output']>;
};

export type CMSRelatedPostMeta = {
    categories?: Maybe<Array<Scalars['ID']['output']>>;
    tags?: Maybe<Array<Scalars['ID']['output']>>;
};

export type CMSRenderedContent = {
    raw?: Maybe<Scalars['String']['output']>;
    rendered?: Maybe<Scalars['String']['output']>;
};

export type CMSRevision = {
    author?: Maybe<Scalars['Int']['output']>;
    cms_blocks?: Maybe<Scalars['String']['output']>;
    data?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    menu?: Maybe<Array<Maybe<CMSMenuItem>>>;
    menu_id?: Maybe<Scalars['ID']['output']>;
    parent?: Maybe<Scalars['Int']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    title?: Maybe<CMSRenderedContent>;
};

export type CMSSearchHead = {
    yoast_head?: Maybe<Scalars['String']['output']>;
};

export type CMSSetting = {
    dateFormat?: Maybe<Scalars['String']['output']>;
    defaultCategory?: Maybe<Scalars['Int']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    footerId?: Maybe<CMSFooterIdentifiers>;
    language?: Maybe<Scalars['String']['output']>;
    menu?: Maybe<Array<Maybe<CMSMenuItem>>>;
    menuId?: Maybe<Scalars['ID']['output']>;
    pageForPosts?: Maybe<Scalars['Int']['output']>;
    pageOnFront?: Maybe<Scalars['Int']['output']>;
    postsPerPage?: Maybe<Scalars['Int']['output']>;
    showOnFront?: Maybe<Scalars['String']['output']>;
    sidebar?: Maybe<CMSSidebar>;
    sidebarId?: Maybe<CMSSidebarIdentifiers>;
    startOfWeek?: Maybe<Scalars['Int']['output']>;
    timeFormat?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type CMSSettingsidebarArgs = {
    placement?: InputMaybe<CMSSidebarIdentifiersEnum>;
};

export type CMSSidebar = CMSPostInterface & {
    cms_blocks?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    link?: Maybe<Scalars['String']['output']>;
    modified?: Maybe<Scalars['String']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    title?: Maybe<CMSRenderedContent>;
    type?: Maybe<Scalars['String']['output']>;
};

export type CMSSidebarIdentifiers = {
    author?: Maybe<Scalars['ID']['output']>;
    category?: Maybe<Scalars['ID']['output']>;
    default?: Maybe<Scalars['ID']['output']>;
    postTag?: Maybe<Scalars['ID']['output']>;
    search?: Maybe<Scalars['ID']['output']>;
};

export type CMSSidebarIdentifiersEnum = 'AUTHOR' | 'CATEGORY' | 'DEFAULT' | 'POST_TAG' | 'SEARCH';

export type CMSSite = 'LEARN' | 'ROOT' | 'ZHL';

export type CMSTaxonomy = {
    hierarchical?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    rest_base?: Maybe<Scalars['String']['output']>;
    rest_namespace?: Maybe<Scalars['String']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CMSTaxonomyEnum = 'BRAND' | 'CATEGORY' | 'PERSONA' | 'POST_TAG' | 'TOPIC';

export type CMSTaxonomyInput = {
    ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    taxonomy?: InputMaybe<CMSTaxonomyEnum>;
};

export type CMSTerm = {
    description?: Maybe<Scalars['String']['output']>;
    footer?: Maybe<CMSFooter>;
    footer_id?: Maybe<Scalars['ID']['output']>;
    id: Scalars['ID']['output'];
    link?: Maybe<Scalars['String']['output']>;
    menu?: Maybe<Array<Maybe<CMSMenuItem>>>;
    menu_id?: Maybe<Scalars['ID']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    parent?: Maybe<Scalars['Int']['output']>;
    posts?: Maybe<CMSPostsResult>;
    primary?: Maybe<Scalars['Boolean']['output']>;
    sidebar?: Maybe<CMSSidebar>;
    sidebar_id?: Maybe<Scalars['ID']['output']>;
    slug?: Maybe<Scalars['String']['output']>;
    taxonomy?: Maybe<Scalars['String']['output']>;
    taxonomyObject?: Maybe<CMSTaxonomy>;
    yoast_head?: Maybe<Scalars['String']['output']>;
};

export type CMSTermpostsArgs = {
    order?: InputMaybe<CMSPostOrder>;
    orderby?: InputMaybe<CMSPostOrderBy>;
    page?: InputMaybe<Scalars['String']['input']>;
    per_page?: InputMaybe<Scalars['String']['input']>;
    post_type: CMSPostTypeEnum;
    search?: InputMaybe<Scalars['String']['input']>;
};

export type CMSUser = {
    avatar?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    jobTitle?: Maybe<Scalars['String']['output']>;
    link?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

/** Customer satisfaction surveys, specified by touchpoints in Susan`s offer experience */
export type CSATSurveys = {
    csatSurvey?: Maybe<SurveyTouchpoint>;
};

/** Customer satisfaction surveys, specified by touchpoints in Susan`s offer experience */
export type CSATSurveyscsatSurveyArgs = {
    touchpoint?: InputMaybe<Scalars['String']['input']>;
};

export type CachedConversationCounts = {
    /** Cached total conversation count from satellite */
    totalConversationsCount?: Maybe<Scalars['Int']['output']>;
    /** Cached unread message count from satellite */
    unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type CalculatorInteractionEvent = UserEvent & {
    /** Events associated with the semantic tag: calculator_interaction */
    eventId: Scalars['ID']['output'];
    eventSource: StreamSource;
    eventTime: Scalars['GraphQLLong']['output'];
    /** This is the clickstream event type id */
    eventType: Scalars['String']['output'];
    financingCalculatorOutput: FinancingCalculatorOutput;
};

export type CancelTourContactAgentView = ITourView & {
    alerts?: Maybe<Array<TourViewAlert>>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewMetadata>;
    modules?: Maybe<Array<TourViewModule>>;
    toasts?: Maybe<Array<TourViewToast>>;
};

export type CancelTourRequestFormView = ITourView & {
    alerts?: Maybe<Array<TourViewAlert>>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewMetadata>;
    modules?: Maybe<Array<TourViewModule>>;
    toasts?: Maybe<Array<TourViewToast>>;
};

export type CancelTourV0Input = {
    appointmentHash: Scalars['ID']['input'];
};

export type CancellationEnumType = 'REQUESTED_TOUR_CANCEL';

export type CancellationInput = {
    /** **Definition:** Optional note, required if cancellationReasonType is OTHER */
    cancellationReasonNote?: InputMaybe<Scalars['String']['input']>;
    cancellationReasonType: CancellationReasonEnumType;
    requestType: CancellationEnumType;
};

export type CancellationReasonEnumType =
    | 'ALREADY_HAS_AGENT'
    | 'FAMILY_EMERGENCY'
    | 'INCLEMENT_WEATHER'
    | 'NO_LONGER_AVAILABLE'
    | 'NO_LONGER_INTERESTED'
    | 'OTHER'
    | 'REQUESTED_TOUR_ACCIDENTALLY';

export type CancellationRequest = {
    /**
     * **Definition:** Cancellation reason text
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     */
    cancellationReason?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Cancellation reason note
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     */
    cancellationReasonNote?: Maybe<Scalars['String']['output']>;
};

export type CancellationResponse = {
    /** **Definition:** Explanatory details for unsuccessful requests */
    errorMessage?: Maybe<Scalars['String']['output']>;
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type CaptureDate = {
    day?: Maybe<Scalars['Int']['output']>;
    month?: Maybe<Scalars['Int']['output']>;
    year?: Maybe<Scalars['Int']['output']>;
};

export type CaseworkerData = {
    /** Caseworker's email address */
    emailAddress?: Maybe<Scalars['String']['output']>;
    /** Caseworker's zuid */
    zuid?: Maybe<Scalars['Int']['output']>;
};

/** Cash offer related data */
export type CashOffer = {
    /** Show whether cash offer is available */
    isCashOfferAvailable?: Maybe<Scalars['Boolean']['output']>;
    /** Show whether the current user is the owner of the cash offer on this property */
    isCurrentUserOfferOwner?: Maybe<Scalars['Boolean']['output']>;
    /** Price of active cash offer, it will be suppressed when provided zuid is not matched within offer response */
    price?: Maybe<Scalars['Int']['output']>;
};

export type Category = {
    id?: Maybe<Scalars['ID']['output']>;
    pages?: Maybe<Array<Maybe<Page>>>;
};

export type CategoryGroupType = {
    /** A list of categories in a category group */
    categories?: Maybe<Array<Maybe<CategoryType>>>;
    /** name of the category group */
    categoryGroupName?: Maybe<Scalars['String']['output']>;
};

export type CategoryType = {
    /** an array of values of the category */
    categoryFacts?: Maybe<Array<Maybe<FactType>>>;
    /** name of the category */
    categoryName?: Maybe<Scalars['String']['output']>;
};

export type ChangeStatusType =
    | 'ADD_LISTING'
    | 'LISTING_STATUS_CHANGE'
    | 'MMM_PRICE_CHANGE'
    | 'MOVE_IN_MONTHS_AWAY'
    | 'MOVE_IN_READY'
    | 'NEW_3D_TOUR'
    | 'NEW_CONSTRUCTION_PROMOTION'
    | 'NEW_DEFAULT'
    | 'NEW_FORECLOSURE'
    | 'NEW_NON_RETAIL_AUCTION'
    | 'NEW_VIDEO'
    | 'NONE'
    | 'OPEN_HOUSE_CHANGE'
    | 'PRICE_CHANGE'
    | 'RENT_CHANGE'
    | 'SALE'
    | 'SOL_AMOUNT_CHANGE'
    | 'SPECIAL_OFFER'
    | 'UNDER_CONSTRUCTION'
    | 'UNKNOWN';

export type ChipElementType = {
    /** Description of chip element value */
    contentDescription?: Maybe<Scalars['String']['output']>;
    elementType?: Maybe<Scalars['String']['output']>;
    /** href to make this chip element link to */
    jsMessage?: Maybe<Scalars['String']['output']>;
    /** The prefix to the chip element value */
    prefixLabel?: Maybe<ResponsiveString>;
    /** The suffix to the chip element value */
    suffixLabel?: Maybe<ResponsiveString>;
    /** The value of the chip element */
    value?: Maybe<ResponsiveString>;
};

export type Choice = {
    label?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type ClaimResponse = {
    /** Error type if any */
    error?: Maybe<Scalars['String']['output']>;
    /** Indicates if the operation was successful */
    success?: Maybe<Scalars['Boolean']['output']>;
};

/**  Climate peril data for a given property.  */
export type ClimatePropertyDetails = {
    /**  Air quality peril data  */
    airSources?: Maybe<ClimatePropertyDetails_AirSources>;
    /**  Fire peril data  */
    fireSources?: Maybe<ClimatePropertyDetails_FireSources>;
    /**  Flood peril data  */
    floodSources?: Maybe<ClimatePropertyDetails_FloodSources>;
    /**  Heat peril data  */
    heatSources?: Maybe<ClimatePropertyDetails_HeatSources>;
    /**  Wind peril data  */
    windSources?: Maybe<ClimatePropertyDetails_WindSources>;
    /**  ZPID  */
    zpid: Scalars['Int']['output'];
};

/**  Air quality peril data  */
export type ClimatePropertyDetails_AirPeril = {
    /**  Count of days above AQI 100 at various timeframes.  */
    badAirDays?: Maybe<Array<ClimatePropertyDetails_PerilDayCount>>;
    /**  The location's risk growth based on the change in risk for the location from today to thirty years from now.  */
    riskGrowth?: Maybe<ClimatePropertyDetails_RiskGrowth>;
    /**  Air quality risk score  */
    riskScore?: Maybe<ClimatePropertyDetails_RiskScore>;
    /**  Metadata about data source (vendor)  */
    source?: Maybe<ClimatePropertyDetails_ClimateSourceMetadata>;
};

/**  Air quality peril top-level container which may be extended to support showing data from multiple vendors  */
export type ClimatePropertyDetails_AirSources = {
    /**  Primary data source for this peril  */
    primary?: Maybe<ClimatePropertyDetails_AirPeril>;
};

/**  Metadata about where climate data was sourced (vendor)  */
export type ClimatePropertyDetails_ClimateSourceMetadata = {
    /**  The source/vendors unique ID for this record.  */
    id?: Maybe<Scalars['String']['output']>;
    /**  Free-form field to put extra matching metadata in.  */
    matchMetadata?: Maybe<Scalars['String']['output']>;
    /**  The matching method used to associate the ZPID with the source/vendor data.  */
    matchType?: Maybe<Scalars['String']['output']>;
    /**  The source/vendor name.  */
    name?: Maybe<Scalars['String']['output']>;
    /**  A URL to the source/vendor for this record.  */
    url?: Maybe<Scalars['String']['output']>;
    /**  Version string from vendor or internal.  */
    version?: Maybe<Scalars['String']['output']>;
};

/**  FEMA Zones as described at https://www.fema.gov/blog/fema-flood-maps-and-zones-explained and https://www.fema.gov/about/glossary/z  */
export type ClimatePropertyDetails_FemaZone =
    | 'A'
    | 'A99'
    | 'AE'
    | 'AH'
    | 'AO'
    | 'B'
    | 'C'
    | 'D'
    | 'UNKNOWN'
    | 'V'
    | 'VE'
    | 'X'
    | 'X_SHADED'
    | 'X_UNSHADED';

/**  Fire peril data  */
export type ClimatePropertyDetails_FirePeril = {
    /**  Count of large wildfires within 20 miles of the property in the last ten years  */
    historicCount10Year?: Maybe<Scalars['Int']['output']>;
    /**  Count of large wildfires within 20 miles of the property for all historical records (~1984)  */
    historicCountAll?: Maybe<Scalars['Int']['output']>;
    /**  Whether fire insurance covering is recommended  */
    insuranceRecommendation?: Maybe<ClimatePropertyDetails_InsuranceRecommendation>;
    /**  Whether a separate fire insurance policy is recommended  */
    insuranceSeparatePolicy?: Maybe<ClimatePropertyDetails_InsuranceSeparatePolicy>;
    /**  Cumulative probability of burn for the given year based on combined wildfire risk (greater of burn and ember).  */
    probability?: Maybe<Array<ClimatePropertyDetails_PerilProbability>>;
    /**  The location's risk growth based on the change in risk for the location from today to thirty years from now.  */
    riskGrowth?: Maybe<ClimatePropertyDetails_RiskGrowth>;
    /**  Fire risk score  */
    riskScore?: Maybe<ClimatePropertyDetails_RiskScore>;
    /**  Metadata about data source (vendor)  */
    source?: Maybe<ClimatePropertyDetails_ClimateSourceMetadata>;
};

/**  Fire peril top-level container which may be extended to support showing data from multiple vendors  */
export type ClimatePropertyDetails_FireSources = {
    /**  Primary data source for this peril  */
    primary?: Maybe<ClimatePropertyDetails_FirePeril>;
};

/**  Flood peril data  */
export type ClimatePropertyDetails_FloodPeril = {
    /**  The property's estimated FEMA zone  */
    femaZone?: Maybe<ClimatePropertyDetails_FemaZone>;
    /**  Count of flooding events with flooding near the property in the last 10 years  */
    historicCount10Year?: Maybe<Scalars['Int']['output']>;
    /**  Count of flooding events with flooding near the property for all historical records (~2000)  */
    historicCountAll?: Maybe<Scalars['Int']['output']>;
    /**  Count of flooding events with flooding to the property in the last 10 years  */
    historicCountProperty10Year?: Maybe<Scalars['Int']['output']>;
    /**  Count of flooding events with flooding to the property for all historical records (~2000)  */
    historicCountPropertyAll?: Maybe<Scalars['Int']['output']>;
    /**  Whether flood insurance covering is recommended  */
    insuranceRecommendation?: Maybe<ClimatePropertyDetails_InsuranceRecommendation>;
    /**  Whether a separate flood insurance policy is recommended  */
    insuranceSeparatePolicy?: Maybe<ClimatePropertyDetails_InsuranceSeparatePolicy>;
    /**  Cumulative probability of a flood at depth 0 for a given year.  */
    probability?: Maybe<Array<ClimatePropertyDetails_PerilProbability>>;
    /**  The location's risk growth based on the change in risk for the location from today to thirty years from now.  */
    riskGrowth?: Maybe<ClimatePropertyDetails_RiskGrowth>;
    /**  Flood risk score  */
    riskScore?: Maybe<ClimatePropertyDetails_RiskScore>;
    /**  Metadata about data source (vendor)  */
    source?: Maybe<ClimatePropertyDetails_ClimateSourceMetadata>;
};

/**  Flood peril top-level container which may be extended to support showing data from multiple vendors  */
export type ClimatePropertyDetails_FloodSources = {
    /**  Primary data source for this peril  */
    primary?: Maybe<ClimatePropertyDetails_FloodPeril>;
};

/**  Heat peril data  */
export type ClimatePropertyDetails_HeatPeril = {
    /**  Predictive count of days above today's 98th percentile temperature (hottest week) on a given relative future year.  */
    hotDays?: Maybe<Array<ClimatePropertyDetails_PerilDayCount>>;
    /**  98th Percentile temperature for the property (Fahrenheit)  */
    percentile98Temp?: Maybe<Scalars['Float']['output']>;
    /**  The location's risk growth based on the change in risk for the location from today to thirty years from now.  */
    riskGrowth?: Maybe<ClimatePropertyDetails_RiskGrowth>;
    /**  Heat risk score  */
    riskScore?: Maybe<ClimatePropertyDetails_RiskScore>;
    /**  Metadata about data source (vendor)  */
    source?: Maybe<ClimatePropertyDetails_ClimateSourceMetadata>;
};

/**  Heat peril top-level container which may be extended to support showing data from multiple vendors  */
export type ClimatePropertyDetails_HeatSources = {
    /**  Primary data source for this peril  */
    primary?: Maybe<ClimatePropertyDetails_HeatPeril>;
};

/**  Whether insurance covering a given peril is recommended  */
export type ClimatePropertyDetails_InsuranceRecommendation =
    | 'CRITICAL'
    | 'NOT_CRITICAL'
    | 'RECOMMENDED'
    | 'UNKNOWN';

/**  Enum describing whether a separate insurance policy is required.  */
export type ClimatePropertyDetails_InsuranceSeparatePolicy =
    | 'LIKELY_OPTIONAL'
    | 'LIKELY_REQUIRED'
    | 'NOT_REQUIRED'
    | 'RECOMMENDED'
    | 'REQUIRED'
    | 'STRONGLY_RECOMMENDED'
    | 'UNKNOWN';

/**  Count of days for a given time frame.  */
export type ClimatePropertyDetails_PerilDayCount = {
    /**  Count of days at this timeframe.  */
    dayCount?: Maybe<Scalars['Int']['output']>;
    /**  Relative time frame in years of the prediction. Eg. 15 represents 15 years from this year.  */
    relativeYear?: Maybe<Scalars['Int']['output']>;
};

/**  Represents probability for a given time frame  */
export type ClimatePropertyDetails_PerilProbability = {
    /**  The probability float value from 0 to 1  */
    probability?: Maybe<Scalars['Float']['output']>;
    /**  Relative time frame in years of the probability prediction. Eg. 15 represents 15 years from this year.  */
    relativeYear?: Maybe<Scalars['Int']['output']>;
};

/**  Risk growth represented based on the change in risk for the location from today to thirty years from now.  */
export type ClimatePropertyDetails_RiskGrowth =
    | 'DECREASING'
    | 'INCREASING'
    | 'STATIONARY'
    | 'UNKNOWN';

/**  Risk score for a given peril  */
export type ClimatePropertyDetails_RiskScore = {
    /**  Display label corresponding to the numeric value  */
    label?: Maybe<ClimatePropertyDetails_RiskScoreLabel>;
    /**  Max value for risk score  */
    max?: Maybe<Scalars['Int']['output']>;
    /**  Min value for risk score  */
    min?: Maybe<Scalars['Int']['output']>;
    /**  Risk score value expressed as an int  */
    value?: Maybe<Scalars['Int']['output']>;
};

/**  Risk score label  */
export type ClimatePropertyDetails_RiskScoreLabel =
    | 'EXTREME'
    | 'MAJOR'
    | 'MINIMAL'
    | 'MINOR'
    | 'MODERATE'
    | 'SEVERE'
    | 'UNKNOWN';

/**  Wind peril data  */
export type ClimatePropertyDetails_WindPeril = {
    /**  Count of recorded tropical cyclones and tornadoes near the property in the last 10 years  */
    historicCount10Year?: Maybe<Scalars['Int']['output']>;
    /**  Count of recorded tropical cyclones and tornadoes, near the property for all historical records (~1984)  */
    historicCountAll?: Maybe<Scalars['Int']['output']>;
    /**  Whether wind insurance covering is recommended  */
    insuranceRecommendation?: Maybe<ClimatePropertyDetails_InsuranceRecommendation>;
    /**  Whether a separate wind insurance policy is recommended  */
    insuranceSeparatePolicy?: Maybe<ClimatePropertyDetails_InsuranceSeparatePolicy>;
    /**  The cumulative probability of strong wind events for a given relative year.  */
    probability?: Maybe<Array<ClimatePropertyDetails_PerilProbability>>;
    /**  The location's risk growth based on the change in risk for the location from today to thirty years from now.  */
    riskGrowth?: Maybe<ClimatePropertyDetails_RiskGrowth>;
    /**  Wind risk score. Note: Wind Factor of 2 means it only has risk from tornados and won't have a cumulative number  */
    riskScore?: Maybe<ClimatePropertyDetails_RiskScore>;
    /**  Metadata about data source (vendor)  */
    source?: Maybe<ClimatePropertyDetails_ClimateSourceMetadata>;
};

/**  Wind peril top-level container which may be extended to support showing data from multiple vendors  */
export type ClimatePropertyDetails_WindSources = {
    /**  Primary data source for this peril  */
    primary?: Maybe<ClimatePropertyDetails_WindPeril>;
};

/** An object containing the closing costs breakdown */
export type ClosingCosts = {
    additionalConcessions?: Maybe<Scalars['Int']['output']>;
    closingCosts?: Maybe<Scalars['Int']['output']>;
};

export type CoShopper = {
    /**  The co-shopper email  */
    email?: Maybe<Scalars['String']['output']>;
    /**  The encoded co-shopper zuid  */
    encodedZuid?: Maybe<Scalars['String']['output']>;
};

export type CoShopperConnection = {
    /**  CoShopper user information  */
    coShopperUserInfo?: Maybe<CoShopper>;
    /**  The status of the link from the other user to this user  */
    incomingLinkStatus?: Maybe<CoShoppingLinkStatus>;
    /**  The status of the link from this user to the other user */
    outgoingLinkStatus?: Maybe<CoShoppingLinkStatus>;
};

export type CoShoppingLinkStatus =
    | 'CANCELLED'
    | 'DECLINED'
    | 'LINKED'
    | 'NONE'
    | 'PENDING'
    | 'RESCINDED';

/** A collection of recommendations for a user */
export type Collection = RecsModule & {
    /** Building cards fetched from BLS when the resulting collection has BuildingIds */
    buildingCards?: Maybe<Array<Maybe<BuildingCard>>>;
    /** Subtitle of the collection to display in the UI */
    caption?: Maybe<Scalars['String']['output']>;
    /** Content Type included in the collection (for sale, for rent, etc). */
    contentType?: Maybe<CollectionContentType>;
    /** List of feedback options to display in the UI */
    feedback?: Maybe<Array<Maybe<FeedbackOption>>>;
    link?: Maybe<CollectionLink>;
    /** Name of the collection to display in the UI */
    name: Scalars['String']['output'];
    /** Placement of the module on the page */
    placement?: Maybe<ModulePlacement>;
    /** Property details fetched from PSL */
    propertyDetails?: Maybe<Array<Maybe<Property>>>;
    /** List of recommendations in the collection */
    recs?: Maybe<Array<Maybe<RealtimeRecomendation>>>;
    /**
     * Subtitle of the collection to display in the UI
     * @deprecated Use caption instead
     */
    subtitle: Scalars['String']['output'];
    /** List of tracking tags associated with the request */
    trackingTags?: Maybe<Array<Maybe<RecsTag>>>;
};

/** Content Type included in the collection (for sale, for rent, etc). */
export type CollectionContentType = 'FOR_RENT' | 'FOR_SALE' | 'UPSELL_ZHL';

/** A link that should be displayed for the collection (typically to SRP) */
export type CollectionLink = {
    /** The text that should be displayed to the user in the UI */
    displayText: Scalars['String']['output'];
    /** The url to link to */
    url: Scalars['String']['output'];
};

/** List of personalized collections for a user */
export type Collections = {
    /**
     * List of collections for the user
     * @deprecated Use modules field instead
     */
    collections?: Maybe<Array<Maybe<Collection>>>;
    /** List of recommended modules (in order of priority) */
    modules?: Maybe<Array<Maybe<RecsModule>>>;
    /** List of tracking tags associated with the request */
    trackingTags?: Maybe<Array<Maybe<RecsTag>>>;
};

export type CombinedReview = {
    buildingReview?: Maybe<Review>;
    created?: Maybe<Scalars['String']['output']>;
    propertyManagerReview?: Maybe<Review>;
    reviewerName?: Maybe<Scalars['String']['output']>;
    reviewerType?: Maybe<Scalars['String']['output']>;
};

export type ComingSoon = {
    /**
     * The date when the property will be coming on the market
     * without a time-zone in ISO-8601.
     * Example: 2019-07-03
     */
    comingSoonAvailabilityDate?: Maybe<Scalars['LocalDate']['output']>;
};

/**
 * Indicates whether to filter properties that are rulesApplicable, rulesNotApplicable, or commingled.
 *
 * A commingled value does not filter any results and clients will receive properties that are rulesApplicable and
 * rulesNotApplicable and thus take responsibility that these potentially commingled listings will only be
 * used/displayed in cases where this is allowed.
 */
export type ComminglingCategory =
    | 'COMMINGLED'
    | 'RULES_APPLICABLE'
    | 'RULES_NOT_APPLICABLE'
    | 'UNKNOWN';

export type CommunicationChannel =
    | 'ADS'
    | 'CHAT'
    | 'DOCUMENT_PORTAL'
    | 'EMAIL'
    | 'FORM'
    | 'MESSAGING'
    | 'PHONE'
    | 'SURVEY';

export type CommunicationType =
    | 'BuildingWideWireless'
    | 'Cable'
    | 'HighSpeedInternet'
    | 'None'
    | 'Other'
    | 'SatelliteTV'
    | 'Unknown';

export type CommunityListingStatusType = 'FOR_SALE' | 'OFF_MARKET' | 'RECENTLY_SOLD';

export type CommunityMarketingStatus =
    | 'ACTIVE'
    | 'CLOSEOUT'
    | 'COMING_SOON'
    | 'GRAND_OPENING'
    | 'UNKNOWN';

export type CommunityRegion = {
    name?: Maybe<Scalars['String']['output']>;
    regionId?: Maybe<Scalars['Int']['output']>;
    urlFragment?: Maybe<Scalars['String']['output']>;
};

/** Aggregate review data for the community */
export type CommunityReviewSet = NcReviewSet & {
    /** Average overall rating given for the builder of this community */
    builderOverallRating?: Maybe<Scalars['Float']['output']>;
    /** Number of ratings for the builder of this community */
    builderRatingCount?: Maybe<Scalars['Int']['output']>;
    /** Number of reviews for the builder of this community */
    builderReviewCount?: Maybe<Scalars['Int']['output']>;
    /** Average caring rating given for this builder, builder region, or community */
    caringRating?: Maybe<Scalars['Float']['output']>;
    /** Average confidence rating given for this builder, builder region, or community */
    confidenceRating?: Maybe<Scalars['Float']['output']>;
    /**
     * Number of reviews for this builder, builder region, or community
     * @deprecated Use reviewCount instead
     */
    count?: Maybe<Scalars['Int']['output']>;
    /** Average experience rating given for this builder, builder region, or community */
    experienceRating?: Maybe<Scalars['Float']['output']>;
    /** Average home rating given for this builder, builder region, or community */
    homeRating?: Maybe<Scalars['Float']['output']>;
    /** Average overall rating given for this builder, builder region, or community */
    overallRating?: Maybe<Scalars['Float']['output']>;
    /** Number of ratings for this builder, builder region, or community */
    ratingCount?: Maybe<Scalars['Int']['output']>;
    /** Average responsiveness rating given for this builder, builder region, or community */
    responsivenessRating?: Maybe<Scalars['Float']['output']>;
    /** Number of reviews for this builder, builder region, or community */
    reviewCount?: Maybe<Scalars['Int']['output']>;
    /** Average value rating given for this builder, builder region, or community */
    valueRating?: Maybe<Scalars['Float']['output']>;
    /** Number of reviewers who would recommend this builder, builder region, or community */
    wouldRecommendPercentage?: Maybe<Scalars['Int']['output']>;
};

export type CommunityRoomType =
    | 'BusinessCenter'
    | 'Clubhouse'
    | 'ConferenceRoom'
    | 'FitnessCenter'
    | 'GameRoom'
    | 'Library'
    | 'Lounge'
    | 'None'
    | 'PartyRoom'
    | 'PetWashingStation'
    | 'Theater'
    | 'Unknown';

export type CommunitySchools = {
    /** Get the 3 best schools to assign by lat/long */
    assignedSchools?: Maybe<Array<Maybe<School>>>;
};

export type CommunitySizeType =
    | 'FIFTY_PLUS_UNITS'
    | 'FIVE_TO_FOURTYNINE_UNITS'
    | 'TWO_TO_FOUR_UNITS';

export type CommunitySubType = 'BUILD_TO_RENT';

export type CommunityType = 'MIXED' | 'RENTAL';

export type CommuteDestinationInputType = {
    /** Formatted address of the commute destination */
    address: Scalars['String']['input'];
    /** Unique identifier for the location as sent by Google Place Autocomplete/Details API. */
    googlePlaceId?: InputMaybe<Scalars['String']['input']>;
    /** User added label for the commute destination like 'my work' */
    label?: InputMaybe<Scalars['String']['input']>;
    /** Latitude of the commute destination */
    latitude: Scalars['Float']['input'];
    /** Longitude of the commute destination */
    longitude: Scalars['Float']['input'];
    /** List of modes of commute to the destination */
    modesOfCommute: Array<InputMaybe<CommuteModeType>>;
    /** Time of departure to destination. */
    timeOfCommuteDeparture: Scalars['String']['input'];
    /** UTC offset for the destination */
    utcOffset: Scalars['Int']['input'];
};

export type CommuteDetailType = {
    /** Duration, distance and route details for various modes of commute to a given destination */
    modes?: Maybe<Array<Maybe<CommuteModeDetailType>>>;
    /** status of the commute details response for a given destination */
    status?: Maybe<Scalars['String']['output']>;
};

export type CommuteDistanceType = {
    /**
     * String representation for the commute distance in either imperial or metric
     * units, as specified in the units param to the commute-details-provider service
     */
    text?: Maybe<Scalars['String']['output']>;
    /** Distance in meters to the destination for the commute */
    value?: Maybe<Scalars['Int']['output']>;
};

export type CommuteDurationType = {
    /** String representation for the commute time */
    text?: Maybe<Scalars['String']['output']>;
    /** Number of seconds for commute for the mode */
    value?: Maybe<Scalars['Int']['output']>;
};

export type CommuteMode = 'BIKING' | 'DRIVING' | 'TRANSIT' | 'WALKING';

export type CommuteModeDetailType = {
    /** Details for distance to the commute destination */
    distance?: Maybe<CommuteDistanceType>;
    /** Commute duration details */
    duration?: Maybe<CommuteDurationType>;
    /** Name of the mode of commute */
    name?: Maybe<CommuteModeType>;
    /** Container of a geoJSON object that contains a commute route */
    route?: Maybe<Scalars['String']['output']>;
    /** Response status for commute details for this mode of commute */
    status?: Maybe<Scalars['String']['output']>;
};

export type CommuteModeType = 'BICYCLING' | 'DRIVING' | 'TRANSIT' | 'WALKING';

/** Commute destination details and corresponding distances and times to commute */
export type CommuteResponseType = {
    /** Formatted address of the commute destination */
    address?: Maybe<Scalars['String']['output']>;
    /** List of commute modes and the corresponding time and distance details to the location */
    commuteDetails?: Maybe<CommuteDetailType>;
    /** Unique identifier for the destination as sent by Google Place Details API. */
    googlePlaceId?: Maybe<Scalars['String']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    /** Latitude of the commute destination */
    latitude?: Maybe<Scalars['Float']['output']>;
    /** ID of the destination as stored in user-commute-locations service */
    locationId?: Maybe<Scalars['Int']['output']>;
    /** Longitude of the commute destination */
    longitude?: Maybe<Scalars['Float']['output']>;
    /** List of modes of commute to the location */
    modesOfCommute?: Maybe<Array<Maybe<CommuteModeType>>>;
    /** Time of commute to destination. */
    timeOfCommuteDeparture?: Maybe<Scalars['String']['output']>;
    /** UTC offset for the destination as sent by Google Place Details API. */
    utcOffset?: Maybe<Scalars['Int']['output']>;
};

export type Comp = {
    property?: Maybe<Property>;
    rank?: Maybe<Scalars['Int']['output']>;
    zpid?: Maybe<Scalars['Int']['output']>;
};

/** shape of comp for mutation */
export type CompInputType = {
    compType?: InputMaybe<Scalars['String']['input']>;
    isSelectedAsComp?: InputMaybe<Scalars['Boolean']['input']>;
    zpid?: InputMaybe<Scalars['Int']['input']>;
};

export type CompListType = {
    compListId?: Maybe<Scalars['String']['output']>;
    comps?: Maybe<Array<Maybe<Property>>>;
    createTime?: Maybe<Scalars['String']['output']>;
    lastUpdateTime?: Maybe<Scalars['String']['output']>;
    zpid?: Maybe<Scalars['Int']['output']>;
    zuid?: Maybe<Scalars['Int']['output']>;
};

export type Comparables = {
    comps?: Maybe<Array<Maybe<Comp>>>;
    parcelId?: Maybe<Scalars['Int']['output']>;
};

/** Nearby homes and buildings for nearby comparisons card carousel on building pages */
export type Comps = {
    BuildingDataT?: Maybe<Array<Maybe<HomeCard>>>;
    BuildingDataU?: Maybe<Array<Maybe<HomeCard>>>;
    compBuildings?: Maybe<Array<Maybe<BuildingCard>>>;
    compHomes?: Maybe<Array<Maybe<Property>>>;
    compRecentlySoldHomes?: Maybe<Array<Maybe<HomeCard>>>;
};

export type ConcurrencyTokenConflictError = BridgeContainerError & {
    message: Scalars['String']['output'];
    retryable?: Maybe<Scalars['Boolean']['output']>;
};

export type ConfirmedClaimedHome = {
    createTime?: Maybe<Scalars['String']['output']>;
    landlordUpsellViewedBool?: Maybe<Scalars['Boolean']['output']>;
    property?: Maybe<Property>;
    propertyClaimSourceType?: Maybe<PropertyClaimSourceType>;
    propertyClaimType?: Maybe<PropertyClaimType>;
    propertyId?: Maybe<Scalars['Int']['output']>;
    updateTime?: Maybe<Scalars['String']['output']>;
};

export type ConnectionActivity = Activity & {
    /** if available, the activity/event id */
    activityId?: Maybe<Scalars['ID']['output']>;
    /** if available, the activity time as epoch milliseconds */
    activityTime?: Maybe<Scalars['GraphQLLong']['output']>;
    /** the activity type */
    activityType: ActivityType;
    /** the user id associated with this activity */
    associatedId: IdBasedWithSource;
    channel: CommunicationChannel;
    details?: Maybe<Scalars['JSON']['output']>;
    participants: Array<IdBasedWithSource>;
    /** source of the activity/event */
    source: Scalars['String']['output'];
};

export type ConnectionData = {
    assigneeZillowUserId: Scalars['ID']['output'];
    assigneeZillowUserIdEncoded: Scalars['ID']['output'];
    value: Scalars['Int']['output'];
};

/** Output for retrieving the latest connection recommendation */
export type ConnectionPlanning = {
    /** List of team member connection target recommendations updated - paginated */
    activeTeamMemberConnectionTargetConnection?: Maybe<TeamMemberConnectionTargetConnection>;
    /** Whether or not the current team lead is in the 'on' treatment of the split UI trial */
    isConnectionPlanningUITreatmentOn?: Maybe<Scalars['Boolean']['output']>;
    /** Batch Id latest connection target recommendations */
    recommendationBatchId?: Maybe<Scalars['String']['output']>;
    /** Date of creation of the latest connection target recommendations */
    recommendationDate?: Maybe<Scalars['DateTime']['output']>;
    /** Status of the latest connection target recommendations */
    status?: Maybe<ConnectionPlanningStatus>;
};

/** Output for retrieving the latest connection recommendation */
export type ConnectionPlanningactiveTeamMemberConnectionTargetConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
};

/** Status of the latest connection recommendations */
export type ConnectionPlanningStatus =
    /** Recommendations were reviewed and submitted */
    | 'CAPACITY_SUBMITTED'
    /** New recommendations were created */
    | 'RECOMMENDATIONS_CREATED';

export type ConnectionRateData = {
    assigneeZillowUserId: Scalars['ID']['output'];
    assigneeZillowUserIdEncoded: Scalars['ID']['output'];
    value: Scalars['Float']['output'];
};

export type ConnectionsPipelineReportingData = {
    allTimeConnections?: Maybe<Array<ConnectionData>>;
    answerRate?: Maybe<Array<ConnectionRateData>>;
    answeredCalls?: Maybe<Array<ConnectionData>>;
    appointmentRate?: Maybe<Array<ConnectionRateData>>;
    appointments?: Maybe<Array<ConnectionData>>;
    callAttempts?: Maybe<Array<ConnectionData>>;
    connectionAttempts?: Maybe<Array<ConnectionData>>;
    connections?: Maybe<Array<ConnectionData>>;
    contactStatuses?: Maybe<Array<ContactStatusesData>>;
    contractRate?: Maybe<Array<ConnectionRateData>>;
    conversionRate?: Maybe<Array<ConnectionRateData>>;
    conversions?: Maybe<ConversionData>;
    csat?: Maybe<Array<ConnectionData>>;
    meetWithLead?: Maybe<Array<ConnectionData>>;
    metWithRate?: Maybe<Array<ConnectionRateData>>;
    numConnectionsLast30d?: Maybe<Array<ConnectionData>>;
    offerRate?: Maybe<Array<ConnectionRateData>>;
    offers?: Maybe<Array<ConnectionData>>;
    pickupRate?: Maybe<Array<ConnectionRateData>>;
    pickups?: Maybe<Array<ConnectionData>>;
    rejectedRate?: Maybe<Array<ConnectionRateData>>;
    salesClosed?: Maybe<Array<ConnectionData>>;
    /** Showing Homes number */
    showing?: Maybe<Array<ConnectionData>>;
    /** Showing Homes rate */
    showingRate?: Maybe<Array<ConnectionRateData>>;
    underContract?: Maybe<Array<ConnectionData>>;
    updatesDue?: Maybe<Array<ConnectionData>>;
    zipLevelAnswerRate?: Maybe<Array<ZipLevelAnswerRateData>>;
};

export type ConnectionsPipelineReportingDatacontactStatusesArgs = {
    isFlex?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ConstructionClosingProcessType = 'SingleClosing' | 'TwoClosing';

export type ContactAgentFormVariant =
    | 'AGENT_DIRECTORY'
    | 'FORECLOSURE_SPECIALIST'
    | 'MY_AGENT'
    | 'NO_BOX'
    | 'OPAQUE'
    | 'OWNER_CONTACT'
    | 'RENTAL'
    | 'SELLER_AGENT'
    | 'TRAFFIC_OPTIMIZED';

export type ContactButton = {
    action: ContactButtonAction;
    appearance: ContactButtonAppearance;
    type: ContactButtonType;
};

export type ContactButtonAction =
    | DialPhoneNumberAction
    | LaunchContactFormAction
    | LaunchExternalUrlAction
    | LaunchTourFormAction;

export type ContactButtonActionType =
    | 'DialPhoneNumber'
    | 'LaunchContactForm'
    | 'LaunchExternalUrl'
    | 'LaunchTourForm';

/** Related to rendering a Contact Button */
export type ContactButtonAppearance = {
    bottomSheet?: Maybe<ContactButtonAppearanceBottomSheet>;
    nextAvailableTourTime?: Maybe<Scalars['String']['output']>;
    /** Shortened version of the title */
    shortTitle?: Maybe<Scalars['String']['output']>;
    title: Scalars['String']['output'];
};

export type ContactButtonAppearanceBottomSheet = {
    text?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type ContactButtonType =
    /** CTA relates to phone calls */
    | 'CALL'
    /** CTA relates to async messaging, e.g. email */
    | 'MESSAGE'
    /** Catch-all for other types of buttons */
    | 'OTHER'
    /** CTA relates to touring a property */
    | 'TOUR';

export type ContactButtonsForPropertyVersion = 'V1' | 'V2';

export type ContactFormInputTextField = {
    clientSideValidationErrorMessage?: Maybe<Scalars['String']['output']>;
    defaultSubmitValue?: Maybe<Scalars['String']['output']>;
    inputName: Scalars['String']['output'];
    inputType: ContactFormInputType;
    isRequired: Scalars['Boolean']['output'];
    isUserInputDisabled: Scalars['Boolean']['output'];
    label: Scalars['String']['output'];
    maxCharacters?: Maybe<Scalars['Int']['output']>;
    numberOfLines: Scalars['Int']['output'];
    placeholder?: Maybe<Scalars['String']['output']>;
    validationRegex?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type ContactFormInputType = 'EMAIL' | 'MESSAGE' | 'NAME' | 'PHONE_NUMBER';

export type ContactFormPlatform =
    | 'ANDROID_APP'
    | 'DESKTOP_WEB'
    | 'IOS_APP'
    | 'MOBILE_WEB'
    | 'TABLET_WEB';

export type ContactFormRenderData = {
    /** This field is provided as JSON, passed through from and documented in adsdisplay. */
    data?: Maybe<Scalars['JSON']['output']>;
    /**
     * An extension of ContactFormData that is specialized for new construction.
     * @deprecated Use ncCommunity.contactData instead
     */
    ncContact?: Maybe<Scalars['JSON']['output']>;
    /** ZPID that contact form is rendered for. */
    zpid?: Maybe<Scalars['Int']['output']>;
};

export type ContactFormRenderParameter = {
    isDoubleScroll?: InputMaybe<Scalars['Boolean']['input']>;
    platform?: InputMaybe<Scalars['String']['input']>;
    zpid: Scalars['ID']['input'];
};

/**
 * Contact information for contact form component. Using homeStatus to decide which
 * contact form component that we need to show on the page
 */
export type ContactInfo = {
    contactType?: Maybe<Scalars['String']['output']>;
    homeStatus?: Maybe<Scalars['String']['output']>;
    isTrusted?: Maybe<Scalars['Boolean']['output']>;
    listingSubType?: Maybe<ListingSubType>;
    providerListingID?: Maybe<Scalars['String']['output']>;
    rentalApplicationsAcceptedType?: Maybe<Scalars['String']['output']>;
};

export type ContactInfoInput = {
    /**  Email address of Sebastian  */
    email: Scalars['String']['input'];
    /**  Full name of Sebastian  */
    fullName: Scalars['String']['input'];
    /**  Contact number of Sebastian  */
    phoneNumber: Scalars['String']['input'];
};

export type ContactStatus = {
    /** Contact Status Code */
    code?: Maybe<Scalars['ID']['output']>;
    /** Contact Status Label */
    label?: Maybe<Scalars['String']['output']>;
    /** Contact Status Count */
    value?: Maybe<Scalars['Int']['output']>;
};

export type ContactStatusesData = {
    /** ZUID */
    assigneeZillowUserId: Scalars['ID']['output'];
    /** ZUID Encoded */
    assigneeZillowUserIdEncoded: Scalars['ID']['output'];
    statusList?: Maybe<Array<ContactStatus>>;
};

/**
 * **Definition:** Mapping of zillow account zuid to contact ids
 *
 * **Team Slack:** #theclosers
 */
export type ContactZillowAccountZuidToContactIds = {
    contactIds: Array<Scalars['String']['output']>;
    zillowAccountZuid?: Maybe<Scalars['String']['output']>;
};

export type ContactedRental = {
    applicationId?: Maybe<Scalars['String']['output']>;
    building?: Maybe<VL_Building>;
    cardClickAction?: Maybe<RenterHubCta>;
    cardDetailsModalData?: Maybe<ContactedRentalPropertyCardDetailsModalData>;
    cardPrimaryAction?: Maybe<RenterHubCta>;
    cardSecondaryAction?: Maybe<RenterHubCta>;
    cardStatusTag?: Maybe<RenterHubCardTag>;
    cardTabSection?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    cardType?: Maybe<ContactedRentalCardType>;
    gdpProperty?: Maybe<Property>;
    instantTourData?: Maybe<ScheduledTour>;
    isPropertyAvailable?: Maybe<Scalars['Boolean']['output']>;
    isYourRental?: Maybe<Scalars['Boolean']['output']>;
    listingAlias?: Maybe<Scalars['String']['output']>;
    menuActions?: Maybe<Array<Maybe<RenterHubCta>>>;
    /** @deprecated use gdpProperty instead */
    property?: Maybe<ZGProperty>;
    propertyId?: Maybe<Scalars['String']['output']>;
    propertyIdType?: Maybe<PropertyIdType>;
    propertyOwners?: Maybe<Array<Maybe<ContactedRentalPropertyOwner>>>;
    /** The flag to control the display of archive button on a property card */
    shouldAllowArchive?: Maybe<Scalars['Boolean']['output']>;
    singleCardLabel?: Maybe<Scalars['String']['output']>;
};

export type ContactedRentalCardType = 'CONTACTED' | 'NEXT_STEP';

export type ContactedRentalData = {
    contactedRental?: Maybe<ContactedRental>;
    isContactedRental?: Maybe<Scalars['Boolean']['output']>;
    notifications?: Maybe<Array<Maybe<RenterHubNotification>>>;
};

export type ContactedRentalForSpecifiedId = {
    /** Boolean for if the rental has been contacted */
    isContactedRental?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactedRentalJourneyStatusType = 'APPLICATION' | 'CONTACTED' | 'YOUR_RENTAL';

export type ContactedRentalPropertyCardDetailsModalAdditionalContent = {
    description?: Maybe<Scalars['String']['output']>;
    textLink?: Maybe<RenterHubCta>;
};

export type ContactedRentalPropertyCardDetailsModalData = {
    availableDateString?: Maybe<Scalars['String']['output']>;
    lastUpdatedTimestamp?: Maybe<Scalars['String']['output']>;
    menuActions?: Maybe<Array<Maybe<RenterHubCta>>>;
    messageSenderName?: Maybe<Scalars['String']['output']>;
    modalAdditionalContent?: Maybe<ContactedRentalPropertyCardDetailsModalAdditionalContent>;
    modalContent?: Maybe<Scalars['String']['output']>;
    modalMessageContent?: Maybe<Scalars['String']['output']>;
    modalPrimaryAction?: Maybe<RenterHubCta>;
    modalSecondaryAction?: Maybe<RenterHubCta>;
    modalTitle?: Maybe<Scalars['String']['output']>;
    stepperProps?: Maybe<ContactedRentalPropertyCardDetailsModalStepperProps>;
};

export type ContactedRentalPropertyCardDetailsModalStepperProps = {
    currentStep?: Maybe<ContactedRentalJourneyStatusType>;
    isAvailable?: Maybe<Scalars['Boolean']['output']>;
    isCurrentStateComplete?: Maybe<Scalars['Boolean']['output']>;
    isDisabled?: Maybe<Scalars['Boolean']['output']>;
    shouldDenyCurrentStep?: Maybe<Scalars['Boolean']['output']>;
};

export type ContactedRentalPropertyOwner = {
    name?: Maybe<Scalars['String']['output']>;
};

export type ContactedRentalsPageData = {
    contactedRentals?: Maybe<Array<Maybe<ContactedRental>>>;
    hasArchivedApplications?: Maybe<Scalars['Boolean']['output']>;
    notifications?: Maybe<Array<Maybe<RenterHubNotification>>>;
    renterProfileModuleAction?: Maybe<RenterHubCta>;
    /** The flag to control the display of the show all application link */
    shouldShowAllApplicationLink?: Maybe<Scalars['Boolean']['output']>;
};

export type ContingencyType = 'ACCEPTING_BACKUP_OFFERS' | 'CONTINGENT' | 'UNDER_CONTRACT';

export type ContingentListingType = 'ACCEPTING_BACKUPS' | 'CONTINGENT' | 'UNDER_CONTRACT';

export type Conversation = {
    conversationCreatedMs?: Maybe<Scalars['String']['output']>;
    conversationId?: Maybe<Scalars['ID']['output']>;
    eventDates?: Maybe<EventDates>;
    gdpProperty?: Maybe<Property>;
    hasUnreadMessage?: Maybe<Scalars['Boolean']['output']>;
    lastReadTimestampMs?: Maybe<Scalars['String']['output']>;
    listing?: Maybe<RentalPlatformListingDetails>;
    listingAlias?: Maybe<Scalars['String']['output']>;
    messageEntries?: Maybe<Array<Maybe<MessageEntries>>>;
    mostRecentMessageTimestampMs?: Maybe<Scalars['String']['output']>;
    /** @deprecated use gdpProperty instead */
    property?: Maybe<ZGProperty>;
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type ConversionData = {
    conversionRate: Scalars['Float']['output'];
    salesClosed: Scalars['Int']['output'];
    salesVolume: Scalars['Float']['output'];
    totalClients: Scalars['Int']['output'];
    underContract: Scalars['Int']['output'];
};

export type CoreProfileData = {
    /**
     * Profile Photo URL from core-profile-data service
     * This replaces the old source from user-data service
     */
    profilePhotoUrl?: Maybe<Scalars['String']['output']>;
};

export type CoreQuestionId =
    | 'aboutMe'
    | 'backgroundReportComment'
    | 'creditReportComment'
    | 'currentResidence'
    | 'firstName'
    | 'isMoveInDateFlexible'
    | 'isSmoker'
    | 'lastName'
    | 'middleName'
    | 'moveInDate'
    | 'occupants'
    | 'pets'
    | 'phone'
    | 'reasonForMoving';

/** An object containing the name and value of an item used in the traditional sale numbers */
export type CostItem = {
    name?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['Int']['output']>;
};

export type Country =
    | 'AD'
    | 'AE'
    | 'AF'
    | 'AG'
    | 'AI'
    | 'AL'
    | 'AM'
    | 'AO'
    | 'AR'
    | 'AS'
    | 'AT'
    | 'AU'
    | 'AW'
    | 'AX'
    | 'AZ'
    | 'BA'
    | 'BB'
    | 'BD'
    | 'BE'
    | 'BF'
    | 'BG'
    | 'BH'
    | 'BI'
    | 'BJ'
    | 'BL'
    | 'BM'
    | 'BN'
    | 'BO'
    | 'BQ'
    | 'BR'
    | 'BS'
    | 'BT'
    | 'BV'
    | 'BW'
    | 'BY'
    | 'BZ'
    | 'CA'
    | 'CC'
    | 'CD'
    | 'CF'
    | 'CG'
    | 'CH'
    | 'CI'
    | 'CK'
    | 'CL'
    | 'CM'
    | 'CN'
    | 'CO'
    | 'CR'
    | 'CU'
    | 'CV'
    | 'CW'
    | 'CX'
    | 'CY'
    | 'CZ'
    | 'DE'
    | 'DJ'
    | 'DK'
    | 'DM'
    | 'DO'
    | 'DZ'
    | 'EC'
    | 'EE'
    | 'EG'
    | 'EH'
    | 'ER'
    | 'ES'
    | 'ET'
    | 'FI'
    | 'FJ'
    | 'FK'
    | 'FM'
    | 'FO'
    | 'FR'
    | 'GA'
    | 'GB'
    | 'GD'
    | 'GE'
    | 'GF'
    | 'GG'
    | 'GH'
    | 'GI'
    | 'GL'
    | 'GM'
    | 'GN'
    | 'GP'
    | 'GQ'
    | 'GR'
    | 'GS'
    | 'GT'
    | 'GU'
    | 'GW'
    | 'GY'
    | 'HK'
    | 'HM'
    | 'HN'
    | 'HR'
    | 'HT'
    | 'HU'
    | 'ID'
    | 'IE'
    | 'IL'
    | 'IM'
    | 'IN'
    | 'IQ'
    | 'IR'
    | 'IS'
    | 'IT'
    | 'JE'
    | 'JM'
    | 'JO'
    | 'JP'
    | 'KE'
    | 'KG'
    | 'KH'
    | 'KI'
    | 'KM'
    | 'KN'
    | 'KP'
    | 'KR'
    | 'KW'
    | 'KY'
    | 'KZ'
    | 'LA'
    | 'LB'
    | 'LC'
    | 'LI'
    | 'LK'
    | 'LR'
    | 'LS'
    | 'LT'
    | 'LU'
    | 'LV'
    | 'LY'
    | 'MA'
    | 'MC'
    | 'MD'
    | 'ME'
    | 'MF'
    | 'MG'
    | 'MH'
    | 'MK'
    | 'ML'
    | 'MM'
    | 'MN'
    | 'MO'
    | 'MP'
    | 'MQ'
    | 'MR'
    | 'MS'
    | 'MT'
    | 'MU'
    | 'MV'
    | 'MW'
    | 'MX'
    | 'MY'
    | 'MZ'
    | 'NA'
    | 'NC'
    | 'NE'
    | 'NF'
    | 'NG'
    | 'NI'
    | 'NL'
    | 'NO'
    | 'NP'
    | 'NR'
    | 'NU'
    | 'NZ'
    | 'OM'
    | 'PA'
    | 'PE'
    | 'PF'
    | 'PG'
    | 'PH'
    | 'PK'
    | 'PL'
    | 'PM'
    | 'PN'
    | 'PR'
    | 'PS'
    | 'PT'
    | 'PW'
    | 'PY'
    | 'QA'
    | 'RE'
    | 'RO'
    | 'RS'
    | 'RU'
    | 'RW'
    | 'SA'
    | 'SB'
    | 'SC'
    | 'SD'
    | 'SE'
    | 'SG'
    | 'SH'
    | 'SI'
    | 'SJ'
    | 'SK'
    | 'SL'
    | 'SM'
    | 'SN'
    | 'SO'
    | 'SR'
    | 'SS'
    | 'ST'
    | 'SV'
    | 'SX'
    | 'SY'
    | 'SZ'
    | 'TC'
    | 'TD'
    | 'TF'
    | 'TG'
    | 'TH'
    | 'TJ'
    | 'TK'
    | 'TL'
    | 'TM'
    | 'TN'
    | 'TO'
    | 'TR'
    | 'TT'
    | 'TV'
    | 'TW'
    | 'TZ'
    | 'UA'
    | 'UG'
    | 'UM'
    | 'US'
    | 'UY'
    | 'UZ'
    | 'VA'
    | 'VC'
    | 'VE'
    | 'VG'
    | 'VI'
    | 'VN'
    | 'VU'
    | 'WF'
    | 'WS'
    | 'YE'
    | 'YT'
    | 'ZA'
    | 'ZM'
    | 'ZW';

export type CountryCode = 'CAN' | 'USA';

export type CreateBorrowerInput = {
    attributes?: InputMaybe<BorrowerAttributesInput>;
    loanID: Scalars['ID']['input'];
};

export type CreateBorrowerOutput = {
    id?: Maybe<Scalars['ID']['output']>;
};

export type CreateBorrowerPairInput = {
    jointBorrowerID: Scalars['ID']['input'];
    loanID: Scalars['ID']['input'];
    primaryBorrowerID: Scalars['ID']['input'];
};

export type CreateBorrowerPairOutput = {
    success: Scalars['Boolean']['output'];
    zhlLoan?: Maybe<ZHLLoan>;
};

export type CreateFlexTxnRequest = {
    address: FlexTxnAddressInput;
    agentZuid: Scalars['String']['input'];
    brokerCommissionDetails: FlexTxnBrokerCommissionDetailsInput;
    /**  ISO 8601 (YYYY-MM-DD)  */
    closeDate: Scalars['Date']['input'];
    closingCompany?: InputMaybe<Scalars['String']['input']>;
    contactId: Scalars['String']['input'];
    /**  The logged-in account has a ZUID, often referred to as agent-zuid. This is used to track changes. Though it's optional, it's usually filled by reading the access token.  */
    lastUpdatedBy?: InputMaybe<Scalars['String']['input']>;
    legalName: Scalars['String']['input'];
    price: Scalars['Float']['input'];
    representationType?: InputMaybe<FlexTxnRepresentationType>;
    /**  System initiating or altering the resource. While optional, it is typically auto-filled by interpreting the x-caller-id header.  */
    sourceSystem?: InputMaybe<Scalars['String']['input']>;
    transactionStatus: FlexTxnStatusCode;
};

export type CreateFlexTxnResponse = {
    destinationAccountNumber?: Maybe<Scalars['String']['output']>;
    transaction?: Maybe<FlexTransaction>;
    validation?: Maybe<Array<FlexTxnValidation>>;
    ztid?: Maybe<Scalars['String']['output']>;
};

/** Create contact input */
export type CreatePAContactInput = {
    /** Contact info */
    contact: PAContactInput;
    /** Owner or assignee agent ZUID (for clients using scope token) */
    ownerOrAssigneeAgentZuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Create contact mutation payload */
export type CreatePAContactPayload = {
    /** Updated Contact object */
    contact?: Maybe<PAContact>;
    /** Errors */
    errors?: Maybe<Array<Error>>;
};

export type CreateProofOfInsuranceResponse = {
    proofId?: Maybe<Scalars['String']['output']>;
};

export type CreateUserNoteInput = {
    noteText: Scalars['String']['input'];
    noteType: Scalars['String']['input'];
    propertyId: Scalars['ID']['input'];
    propertyIdType: PropertyIdType;
    subjectLine?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserNoteResponse = {
    noteId?: Maybe<Scalars['String']['output']>;
    success: Scalars['Boolean']['output'];
};

export type CreateZHLBorrowerAssetInput = {
    attributes: ZHLBorrowerAssetAttributesInput;
    /** The IDs of the borrowers that own the asset. */
    owners: Array<Scalars['ID']['input']>;
};

export type CreateZHLBorrowerEmploymentInput = {
    attributes: ZHLBorrowerEmploymentAttributesInput;
    borrowerID: Scalars['ID']['input'];
};

export type CreateZHLBorrowerOtherIncomeInput = {
    attributes: ZHLBorrowerOtherIncomeAttributesInput;
    borrowerID: Scalars['ID']['input'];
};

export type CreateZHLDocumentInput = {
    borrowerName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    documentData: DocumentData;
    documentType: DocumentType;
    loanID: Scalars['ID']['input'];
    /** loanIssueDate: optional if documentType is "DOCUMENT_TYPE_PRE_APPROVAL_LETTER" */
    loanIssueDate?: InputMaybe<Scalars['String']['input']>;
    loanOfficer?: InputMaybe<ZHLLoanOfficerInput>;
};

export type CreditScoreRange = {
    creditScoreMax?: InputMaybe<Scalars['Int']['input']>;
    creditScoreMin?: InputMaybe<Scalars['Int']['input']>;
    rangeType?: InputMaybe<CreditScoreRangeType>;
};

export type CreditScoreRangeCategory = {
    categoryName?: Maybe<CreditScoreRangeType>;
    lastUpdated?: Maybe<Scalars['String']['output']>;
};

export type CreditScoreRangeInput = {
    categoryName?: InputMaybe<CreditScoreRangeType>;
};

export type CreditScoreRangeType = 'AVERAGE' | 'BAD' | 'EXCELLENT' | 'GOOD' | 'POOR';

export type CreditScoreUsed = {
    creditScoreMax?: Maybe<Scalars['Int']['output']>;
    creditScoreMin?: Maybe<Scalars['Int']['output']>;
    rangeType?: Maybe<CreditScoreRangeType>;
};

export type CurrencyType = 'CAD' | 'USD';

export type CurrencyValue = {
    lastUpdated?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['Float']['output']>;
};

export type CurrentIncome = {
    amount?: Maybe<Scalars['USCurrency']['output']>;
    areDocumentsExpired?: Maybe<Scalars['Boolean']['output']>;
    documents?: Maybe<Array<Maybe<Document>>>;
    id?: Maybe<Scalars['String']['output']>;
    isVerified?: Maybe<Scalars['Boolean']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    type?: Maybe<IncomeType>;
    verification?: Maybe<IncomeVerification>;
};

export type CurrentIncomeInput = {
    amount?: InputMaybe<Scalars['USCurrency']['input']>;
    documents?: InputMaybe<Array<InputMaybe<DocumentInput>>>;
    employer?: InputMaybe<EmployerInput>;
    note?: InputMaybe<Scalars['NonEmptyString']['input']>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
    title?: InputMaybe<Scalars['NonEmptyString']['input']>;
    type: IncomeType;
};

export type CurrentResidence = {
    address?: Maybe<RentalApplicationAddress>;
    id?: Maybe<Scalars['ID']['output']>;
    monthlyPayment?: Maybe<Scalars['USCurrency']['output']>;
    startDate?: Maybe<Scalars['Date']['output']>;
    type?: Maybe<ResidenceType>;
};

export type CurrentScheduleMonth = {
    dueDate?: Maybe<Scalars['String']['output']>;
    scheduleMonth?: Maybe<Scalars['String']['output']>;
};

export type CurrentTitleHoldingMannerType =
    | 'JointTenancyWithRightOfSurvivorship'
    | 'LifeEstate'
    | 'Other'
    | 'SoleOwnership'
    | 'TenancyByTheEntirety'
    | 'TenancyInCommon';

export type CustomAmenities = {
    rawAmenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    translatedAmenities?: Maybe<TranslatedAmenities>;
};

export type CustomAnswer = {
    id?: Maybe<Scalars['ID']['output']>;
    question?: Maybe<Question>;
};

export type CustomAnswerInput = {
    id: Scalars['ID']['input'];
    value?: InputMaybe<Scalars['JSON']['input']>;
};

export type CustomRegion = {
    /** unique identifier for the custom region */
    customRegionId?: Maybe<Scalars['ID']['output']>;
    /** polygon in WKT format */
    polygon?: Maybe<Scalars['String']['output']>;
};

/**
 * external entity: BridgeMove, resolvable: false
 * cannot establish the edge because the @key was undefined on the original type
 * type BridgeMove @key (fields: "id") @extends
 * {
 * id: ID! @external
 * journeyId: ID!
 * }
 */
export type CustomerJourney = {
    id: Scalars['ID']['output'];
};

export type CustomerLead = {
    /** activities following the creation of the lead */
    activities: Array<Activity>;
    /** the user id associated with this learning */
    associatedId: IdBasedWithSource;
    createTime: Scalars['GraphQLLong']['output'];
    /** the origin funnel of the lead */
    funnel: Funnel;
    lastUpdate?: Maybe<Scalars['GraphQLLong']['output']>;
    /** the unique id for the lead */
    leadId: Scalars['ID']['output'];
    /** the status of the lead */
    status: LeadStatus;
};

export type DayOfWeek =
    | 'FRIDAY'
    | 'MONDAY'
    | 'SATURDAY'
    | 'SUNDAY'
    | 'THURSDAY'
    | 'TUESDAY'
    | 'WEDNESDAY';

export type DebugRequest = {
    /**
     * Whether to log information other than rules for debugging purposes.
     * The information to be logged includes: home recs zpids, query to the underlying search index
     */
    logInfo?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether the rules, the response should be logged */
    logRules?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * The rules behaviors the request should apply, absent of individual rule behavior will
     * be considered as not applicable
     */
    mockSearchRuleBehaviors?: InputMaybe<MockSearchRuleBehaviors>;
    /**
     * Whether to enable mock rule mode to override the rules behavior for the whole results,
     * if yes, a not null MockLookupRuleBehaviors should also be provided
     * This feature is disabled in production
     */
    shouldMockRuleBehavior?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeclineReason = {
    additionalRequirement?: Maybe<AdditionalRequirement>;
    message?: Maybe<Scalars['String']['output']>;
    type?: Maybe<DeclineReasonType>;
};

export type DeclineReasonType =
    | 'BACKGROUND_CHECK'
    | 'CREDIT_REPORT'
    | 'INSUFFICIENT_RENT_INCOME_RATIO'
    | 'INVALID_REF_CHECK'
    | 'INV_APPLICATION_REQ'
    | 'NOT_AVAILABLE'
    | 'PETS'
    | 'SMOKING';

export type DedicatedLoanOfficer = {
    email: Scalars['String']['output'];
    fullName: Scalars['String']['output'];
    imageUrl?: Maybe<Scalars['String']['output']>;
    phone: Scalars['String']['output'];
    shareableKey?: Maybe<Scalars['String']['output']>;
    shareableLoLinkUrl?: Maybe<Scalars['String']['output']>;
};

/** Information needed to display DEEP_LINK tasks. */
export type DeepLinkPayload = {
    /** Text for the button shown for this task, e.g. 'Click me' */
    buttonLabel: Scalars['String']['output'];
    /** URL to deep link experience for user. */
    url: Scalars['String']['output'];
};

export type DeleteBorrowerOutput = {
    success: Scalars['Boolean']['output'];
};

/** Delete contact input */
export type DeletePAContactInput = {
    /** Contact ID */
    id: Scalars['ID']['input'];
};

/** Delete contact mutation payload */
export type DeletePAContactPayload = {
    /** Deleted Contact ID */
    contactId?: Maybe<Scalars['ID']['output']>;
    /** Errors */
    errors?: Maybe<Array<Error>>;
};

/** Mutation input for deleting the connection target of a team member */
export type DeleteTeamMemberConnectionTargetInput = {
    /** The team member zuid of whoms connection target to delete */
    teamMemberZuid: ZuidInput;
};

/** Mutation result indicating whether the deletion was performed successfully */
export type DeleteTeamMemberConnectionTargetResult = {
    /** Whether or not the deletion was successful */
    successful: Scalars['Boolean']['output'];
};

export type DeleteUserNoteInput = {
    noteId?: InputMaybe<Scalars['String']['input']>;
    noteType: Scalars['String']['input'];
    propertyId: Scalars['ID']['input'];
    propertyIdType: PropertyIdType;
};

export type DeliveryChannel = 'app' | 'email' | 'link' | 'onsite' | 'sms';

export type DepartureGoal = 'SELL' | 'UNSPECIFIED';

export type DescriptionWithSize = {
    /** A general type (broader than description) of the entity represented by this class. */
    category?: Maybe<Scalars['String']['output']>;
    /**
     * A description of the attribute represented by this object.
     * For instance, Attic for BuildingAreas, Heated Pool for Pools, etc.
     */
    description?: Maybe<Scalars['String']['output']>;
    /** The size of the area from the description */
    size?: Maybe<Scalars['Int']['output']>;
    /** The units that correspond to the size such as Square Feet, Linear Feet, etc. */
    sizeUnits?: Maybe<Scalars['String']['output']>;
};

export type DescriptionWithSizeAndSpace = {
    /**
     * A description of the attribute represented by this object.
     * For instance, Attic for BuildingAreas, Heated Pool for Pools, etc.
     */
    description?: Maybe<Scalars['String']['output']>;
    /** The size of the area from the description */
    size?: Maybe<Scalars['Int']['output']>;
    /** The units that correspond to the size such as Square Feet, Linear Feet, etc. */
    sizeUnits?: Maybe<Scalars['String']['output']>;
    /**
     * The unit count of the attribute represented by this object.
     * For instance, ParkingSpaces for Parking.
     */
    spaces?: Maybe<Scalars['Int']['output']>;
};

export type DetailedIconStyle = 'INFO' | 'SUCCESS';

export type DetailedIconType =
    | 'ADD_USER'
    | 'AIR_CONDITIONING'
    | 'APP_DOWNLOAD'
    | 'APP_HOME'
    | 'BLUEPRINT'
    | 'BRAIN_GEAR'
    | 'BRIEFCASE_GEAR'
    | 'BUS'
    | 'CALCULATOR'
    | 'CALCULATOR_MONEY'
    | 'CALENDAR'
    | 'CAMERA'
    | 'CHECKLIST'
    | 'CLAP'
    | 'COMPARE'
    | 'COMPUTER'
    | 'DOLLAR_HOME'
    | 'EMAIL'
    | 'EMPTY_LOT'
    | 'FAUCET'
    | 'FILE'
    | 'FLOOR_PLAN_TOUR'
    | 'FOR_SALE_SIGN'
    | 'HAMMER'
    | 'HANDSHAKE'
    | 'HARD_HAT'
    | 'HEARING_AID'
    | 'HEART_HOME'
    | 'HIGHFIVE'
    | 'HOME'
    | 'HOME_TOUR'
    | 'KEY_HOME'
    | 'KEY_TAG'
    | 'LAUNDRY'
    | 'LEGAL_PROTECTIONS'
    | 'LIMITED_MOBILITY'
    | 'MAIL'
    | 'MEGAPHONE'
    | 'MESSAGE_HEART'
    | 'MOVING_TRUCK'
    | 'NEW_CONSTRUCTION'
    | 'OUTLET_PLUG'
    | 'PAINT_ROLLER'
    | 'PAPER_AIRPLANE'
    | 'PARK'
    | 'PEDESTRIAN'
    | 'PENCIL_DOLLAR'
    | 'PET'
    | 'PHONE'
    | 'PIGGYBANK'
    | 'PRESENT'
    | 'PRIVACY'
    | 'PROFILE'
    | 'RENT'
    | 'RENT_BUY'
    | 'SCHOOL'
    | 'SEARCH_HEART'
    | 'STAR_RISING'
    | 'TARGET'
    | 'TEA'
    | 'THUMBS_UP'
    | 'TROPHY'
    | 'TROWEL'
    | 'UNLOCK'
    | 'USERS'
    | 'VIRTUAL_TOUR'
    | 'WRENCH';

export type DetailedParkingPolicy = {
    assigned?: Maybe<Scalars['Boolean']['output']>;
    comment?: Maybe<Scalars['String']['output']>;
    numberOfSpaces?: Maybe<Scalars['Int']['output']>;
    parkingType?: Maybe<Scalars['String']['output']>;
    spaceFee?: Maybe<Scalars['Float']['output']>;
};

/** Detailed pet policy for a building */
export type DetailedPetPolicy = {
    general?: Maybe<Scalars['String']['output']>;
    petPolicies?: Maybe<Array<Maybe<PetPolicy>>>;
};

export type DevicePlatform = 'ANDROID' | 'IPAD' | 'IPHONE';

/**
 * This is the kind of ContactButtonAction we use to dial phone numbers. The format is
 * <areacode><prefix><number> or <areacode><prefix><number>,,<ext># if the phone number
 * includes an extension.
 */
export type DialPhoneNumberAction = {
    phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type DisplayStatus =
    | 'FORECLOSED'
    | 'FOR_RENT'
    | 'FOR_SALE'
    | 'OTHER'
    | 'PREFORECLOSURE'
    | 'RECENTLY_SOLD';

export type DisplayStrings = {
    bodyText?: Maybe<Scalars['String']['output']>;
    iconUrl?: Maybe<Scalars['String']['output']>;
    ineligibleReasonText?: Maybe<Scalars['String']['output']>;
    learnMoreBodyText?: Maybe<Scalars['String']['output']>;
    learnMoreTitle?: Maybe<Scalars['String']['output']>;
};

export type Document = {
    editorUrl?: Maybe<Scalars['URL']['output']>;
    expirationDateTime?: Maybe<Scalars['DateTime']['output']>;
    fileName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isRedacted?: Maybe<Scalars['Boolean']['output']>;
    previewUrl?: Maybe<Scalars['URL']['output']>;
};

export type DocumentData = {
    preApprovalLetter?: InputMaybe<PreApprovalLetter>;
    scenarios?: InputMaybe<Array<InputMaybe<Scenario>>>;
};

export type DocumentInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
    isRedacted?: InputMaybe<Scalars['Boolean']['input']>;
    messageToken?: InputMaybe<Scalars['ID']['input']>;
};

export type DocumentType =
    | 'DOCUMENT_TYPE_BLEND_UPLOADED_DOCUMENTS'
    | 'DOCUMENT_TYPE_DIGITAL_ASSET_REPORT'
    | 'DOCUMENT_TYPE_DIGITAL_PRE_APPROVAL_UPLOADED_DOCUMENT'
    | 'DOCUMENT_TYPE_LOAN_COMPARISON_WORKSHEET'
    | 'DOCUMENT_TYPE_PRE_APPROVAL_LETTER'
    | 'DOCUMENT_TYPE_UNSPECIFIED';

export type DoubleRange = {
    max?: Maybe<Scalars['GraphQLDouble']['output']>;
    min?: Maybe<Scalars['GraphQLDouble']['output']>;
};

export type DownPayment = {
    lastUpdated?: Maybe<Scalars['String']['output']>;
    valueAsDollarAmount?: Maybe<Scalars['Int']['output']>;
    valueAsPercent?: Maybe<Scalars['Int']['output']>;
    valuePreference?: Maybe<DownPaymentOption>;
};

export type DownPaymentAssistanceProgramListType = {
    /** Maximum assistance offered in results */
    max_assistance?: Maybe<Scalars['Int']['output']>;
    /** List of eligible programs */
    programs?: Maybe<Array<Maybe<DownPaymentAssistanceProgramType>>>;
    /** Number of results */
    result_count?: Maybe<Scalars['Int']['output']>;
};

export type DownPaymentAssistanceProgramType = {
    /** Agency Id */
    agency_id?: Maybe<Scalars['Int']['output']>;
    /** amount of assistance */
    assistance_amount?: Maybe<Scalars['String']['output']>;
    /** Agency contact */
    contact_agency_url?: Maybe<Scalars['String']['output']>;
    /** Id */
    id?: Maybe<Scalars['Int']['output']>;
    /** max sales price */
    max_sales_price?: Maybe<Scalars['String']['output']>;
    /** Name of program */
    name?: Maybe<Scalars['String']['output']>;
    /** provider type */
    provider_type?: Maybe<Scalars['String']['output']>;
    /** Program status */
    status?: Maybe<Scalars['String']['output']>;
};

export type DownPaymentInput = {
    valueAsDollarAmount?: InputMaybe<Scalars['Int']['input']>;
    valueAsPercent?: InputMaybe<Scalars['Int']['input']>;
    valuePreference?: InputMaybe<DownPaymentOption>;
};

export type DownPaymentOption = 'AMOUNT' | 'PERCENT';

export type DpaProgram = {
    /** Program Name and Link */
    Links?: InputMaybe<Array<InputMaybe<DpaProgramObject>>>;
    /** Max loan amount provided for the program */
    MaxLoanAmount?: InputMaybe<Scalars['String']['input']>;
};

export type DpaProgramObject = {
    /** URL to program */
    Link?: InputMaybe<Scalars['String']['input']>;
    /** Program name */
    Name?: InputMaybe<Scalars['String']['input']>;
};

export type EditCoapplicantInput = {
    firstName: Scalars['NonEmptyString']['input'];
    lastName: Scalars['NonEmptyString']['input'];
};

export type EditFlexTransactionResponse = {
    transaction?: Maybe<FlexTransaction>;
    validation?: Maybe<Array<FlexTxnValidation>>;
    ztid?: Maybe<Scalars['String']['output']>;
};

export type EditFlexTxnRequest = {
    brokerCommissionDetails?: InputMaybe<FlexTxnBrokerCommissionDetailsInput>;
    closingDetails: FlexTransactionClosingDetailsInput;
    consumer?: InputMaybe<FlexTransactionConsumerInput>;
    propertyDetails: FlexTransactionPropertyDetailsInput;
    ztid: Scalars['String']['input'];
};

export type EditZHLBorrowerAssetInput = {
    assetID: Scalars['ID']['input'];
    attributes: ZHLBorrowerAssetAttributesInput;
};

export type EditZHLBorrowerAttributesInput = {
    attributes: ZHLBorrowerAttributes;
    id: Scalars['ID']['input'];
    loanID: Scalars['ID']['input'];
};

export type EditZHLBorrowerEmploymentInput = {
    attributes: ZHLBorrowerEmploymentAttributesInput;
    employmentID: Scalars['ID']['input'];
};

export type EditZHLBorrowerOtherIncomeInput = {
    attributes: ZHLBorrowerOtherIncomeAttributesInput;
    otherIncomeID: Scalars['ID']['input'];
};

export type EditZHLLoanAttributesInput = {
    attributes?: InputMaybe<ZHLLoanAttributesInput>;
    id: Scalars['ID']['input'];
};

export type EditZHLLoanAttributesOutput = {
    id?: Maybe<Scalars['ID']['output']>;
    tridTriggered?: Maybe<Scalars['Boolean']['output']>;
    zhlLoan?: Maybe<ZHLLoan>;
};

export type EffectiveRegionTreatmentType = {
    /** zillow region id */
    effectiveRegionId?: Maybe<Scalars['Int']['output']>;
    /** type of the treatment */
    treatment?: Maybe<Scalars['String']['output']>;
};

export type EligibilityType = 'MISO' | 'SHOWCASE_DIRECT' | 'UNKNOWN';

export type EmbeddedTourRequestConfirmationV0Input = {
    /** The type of booking for this tour appointment (ex. STANDARD, INSTANT, INSTANT_BOOK) */
    bookingType?: InputMaybe<Scalars['String']['input']>;
    /** Whether or not the buyer has indicated they are currently working with an agent */
    hasAgent?: InputMaybe<Scalars['Boolean']['input']>;
    /** An array of requested tour times, formatted with optional time value as YYYY-MM-DDTHH:MM:SS or without time value as YYYY-MM-DD */
    requestedTourTimes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type EmbeddedTourRequestConfirmationV1Input = {
    /** The type of booking for this tour appointment (ex. STANDARD, INSTANT, INSTANT_BOOK) */
    bookingType?: InputMaybe<Scalars['String']['input']>;
    /** The tour experience type (ex: DCV1, DCV2, RTT, NONE) */
    experienceType?: InputMaybe<Scalars['String']['input']>;
    /** The type of financing checkbox that was displayed (ex: ZHL, ZGMI, NONE) */
    financingCheckboxType?: InputMaybe<Scalars['String']['input']>;
    /** Whether or not the buyer has indicated they are currently working with an agent */
    hasAgent?: InputMaybe<Scalars['Boolean']['input']>;
    /** An array of requested tour times, formatted with optional time value as YYYY-MM-DDTHH:MM:SS or without time value as YYYY-MM-DD */
    requestedTourTimes?: InputMaybe<Array<Scalars['String']['input']>>;
    /** The time range in which the buyer said they were looking to buy (ex: 0-3Months, 3-6Months, ... ) */
    timelineToBuy?: InputMaybe<Scalars['String']['input']>;
    /** Whether or not the buyer checked the box in the pre-qual flow that they want financing with ZHL */
    wantsFinancingWithZHL?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Employer = ReferenceContactInfo & {
    email?: Maybe<Scalars['EmailAddress']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    organization?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type EmployerInput = {
    email?: InputMaybe<Scalars['EmailAddress']['input']>;
    name?: InputMaybe<Scalars['NonEmptyString']['input']>;
    organization?: InputMaybe<Scalars['NonEmptyString']['input']>;
    phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type EmploymentIncome = CurrentIncome & {
    amount?: Maybe<Scalars['USCurrency']['output']>;
    areDocumentsExpired?: Maybe<Scalars['Boolean']['output']>;
    documents?: Maybe<Array<Maybe<Document>>>;
    employer?: Maybe<Employer>;
    id?: Maybe<Scalars['String']['output']>;
    isVerified?: Maybe<Scalars['Boolean']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    startDate?: Maybe<Scalars['Date']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    type?: Maybe<IncomeType>;
    verification?: Maybe<IncomeVerification>;
};

export type EnhancedMarketDataResponse = {
    isEnhancedMarket?: Maybe<Scalars['Boolean']['output']>;
};

/**  base on the avm schema: https://gitlab.zgtools.net/analytics/artificial-intelligence/ai-platform/aip-feature-engineering/odp-schema-registration/-/blob/master/src/main/avro/schemas/entity_property_avm.avsc  */
export type EntityPropertyAvm = {
    groupId?: Maybe<Scalars['Int']['output']>;
    high?: Maybe<Scalars['Float']['output']>;
    low?: Maybe<Scalars['Float']['output']>;
    score?: Maybe<Scalars['Float']['output']>;
    valuationId?: Maybe<Scalars['String']['output']>;
    zpid: Scalars['Int']['output'];
};

export type EntryActionLink = {
    leadType?: Maybe<Scalars['String']['output']>;
    link?: Maybe<Scalars['String']['output']>;
};

/** Generic error type */
export type Error = {
    /** Error code */
    code: ErrorCode;
    /** Error message */
    message: Scalars['String']['output'];
    /** Path to the field */
    path?: Maybe<Array<Scalars['String']['output']>>;
};

/** Error Code */
export type ErrorCode =
    /** Input is invalid */
    | 'INPUT_INVALID'
    /** Input is required */
    | 'INPUT_REQUIRED'
    /** Unknown error */
    | 'UNKNOWN';

export type Estimate = {
    /** Information about the rental payment estimate for this home */
    restimate?: Maybe<Restimate>;
    /** Information about the price estimate for this home */
    zestimate?: Maybe<PSLZestimate>;
};

export type EstimateOfferData = {
    estimateOfferExpGroup?: Maybe<Scalars['String']['output']>;
    estimateOfferPrice?: Maybe<Scalars['Int']['output']>;
};

/** The evaluation details associated with the provided offer request id */
export type EvaluationType = {
    availableAppointments?: Maybe<AvailableAppointments>;
    scheduledAppointment?: Maybe<HomeEvaluationAppointment>;
};

/** The evaluation details associated with the provided offer request id */
export type EvaluationTypeavailableAppointmentsArgs = {
    appointmentEndWindow: Scalars['String']['input'];
    appointmentStartWindow: Scalars['String']['input'];
};

export type EventBySemanticTagFilter = {
    /**
     * EXACT pulls only events for the user where we are 100% sure the event is attributable to the specified user Id
     * INFERRED pulls for events that we infer for the user based on guid->zuid mappings.
     * - When not specified the default value is EXACT and INFERRED
     */
    idMatchTypes?: InputMaybe<Array<InputMaybe<IdMatchType>>>;
    /**
     * Number of user events which match the filter criteria (semantic name) to return for this events list. There is a
     * maximum of 200 events returned, but maxEvents can be defined if fewer are wanted.
     * - When not specified, the default value is 200
     */
    maxEventsToReturn?: InputMaybe<Scalars['Int']['input']>;
    /**
     * Timestamp range in epochMS
     * When neither specified, the query fetches the most recent events.
     * When only max is specified, the query fetches the most recent events before the specified max
     * When only min is specified, the query fetches the most recent events after the specified min
     * When both min and max are specified, the query fetches the most recent events between the specified min and max
     */
    timestampRange?: InputMaybe<LongRangeInput>;
};

export type EventDates = {
    lastApplicationRequestedMs?: Maybe<Scalars['String']['output']>;
    lastTourRequestedMs?: Maybe<Scalars['String']['output']>;
};

/** This block contains the event meta date for OMP */
export type EventMetaData = {
    exposureBlock?: Maybe<ExposureBlock>;
    nbaBlock?: Maybe<NbaBlock>;
    ompBlock?: Maybe<OmpBlock>;
};

export type ExcludeType =
    /** exclude properties that are only accepting backup offers */
    | 'ACCEPTING_BACKUPOFFERS'
    /** exclude properties that are in contingent status */
    | 'CONTINGENT_LISTING'
    /** exclude properties with no hoa data */
    | 'NO_HOA_DATA'
    /** exclude pending properties */
    | 'PENDING'
    /** exclude senior community properties */
    | 'SENIOR_COMMUNITY'
    /** exclude properties that are under contract */
    | 'UNDER_CONTRACT'
    /** exclude unmappable properties */
    | 'UNMAPPABLE';

export type ExperimentalQueries = {
    productEligibility?: Maybe<ProductEligibility>;
};

export type ExperimentalQueriesproductEligibilityArgs = {
    productEligibilityInput: ProductEligibilityInput;
};

/** This block is used to create the exposure events for omp experiments. It will contain all necessary fields. */
export type ExposureBlock = {
    /** Assignment service used like abs, cauldron, etc. */
    assignmentServiceCd?: Maybe<Scalars['String']['output']>;
    /** Decision id, e.g. 36sU6R_1649978282 */
    decisionToken?: Maybe<Scalars['String']['output']>;
    /** Id of the page or experience */
    experienceId?: Maybe<Scalars['String']['output']>;
    /** Custom key value mapping for extended exposure meta data */
    extendedInfo?: Maybe<Array<Maybe<MapEntry>>>;
    /** The key type used, e.g. guid */
    keyTypeCd?: Maybe<Scalars['String']['output']>;
    /** The key sent to ABS to id the randomization unit */
    randomizationKey?: Maybe<Scalars['String']['output']>;
    /** A list of OMP treatments that the user is exposed to */
    treatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ExternalAuthAccountData = {
    /** The External Account ID */
    externalConnectID?: Maybe<Scalars['ID']['output']>;
    /** The Type ID of external Account */
    externalType?: Maybe<Scalars['String']['output']>;
    /** The canonical name of the external Account */
    externalTypeName?: Maybe<Scalars['String']['output']>;
};

export type ExternalAuthData = {
    /** The External Account ID */
    externalConnectID?: Maybe<Scalars['String']['output']>;
    /** The Type ID of external Account */
    externalType?: Maybe<Scalars['String']['output']>;
    /** The canonical name of the external Account */
    externalTypeName?: Maybe<Scalars['String']['output']>;
};

/** FSHDP tab internal route */
export type FSHDPRoute = INativeIOSDestination & {
    attributions: Array<AttributionEntry>;
    zpid: Scalars['String']['output'];
};

export type FactType = {
    factLabel?: Maybe<Scalars['String']['output']>;
    factValue?: Maybe<Scalars['String']['output']>;
};

export type FactsAndFeatures = {
    /** Type of architecture of the building such as modern, colonial, etc. (less descriptive than structureType). */
    architectureType?: Maybe<Scalars['String']['output']>;
    /**
     * A list of building details, often supplied with a size.
     * Legacy fields mapped: hasAttic and atticSquareFeet (pair), hasPorch, hasStorageAvailable, basementType and basementSquareFeet (pair), additionSquareFeet, hasMotherInLawApartment, per floor sq ft (floor 1, floor 2, etc.)
     * RESO fields mapped: AboveGradeFinishedArea and Units, BelowGradeFinishedArea and Units, BuildingAreaTotal and Units, Basement, FoundationArea, Attic
     * Expected mapping of public data: BuildingArea, OtherBuildingYard
     */
    buildingAreas?: Maybe<Array<DescriptionWithSize>>;
    /** The shape of the building such as L-shaped, irregular, rectangular, etc. */
    buildingShapeType?: Maybe<Scalars['String']['output']>;
    /**
     * A list of features related to, or available within, the community.
     * Legacy fields mapped: hasDoorman, hasFitnessCenter, isFiftyFivePlusActiveCommunity, isAssistedLivingCommunity, hasOnSiteLaundryAvailable
     * RESO fields mapped: Fields contained https://ddwiki.reso.org/display/DDW17/CommunityFeatures+Lookups may change over time.
     */
    communityFeatures?: Maybe<Array<Scalars['String']['output']>>;
    /** Often expressed as a grade, the quality of the fixture as reported by the county or other source. */
    constructionQualityType?: Maybe<Scalars['String']['output']>;
    /** Type of construction materials or approaches used for the building such as concrete, wood, frame, manufactured, etc. */
    constructionTypes?: Maybe<Array<Scalars['String']['output']>>;
    /** The types of cooling systems present in this property */
    coolingSystems?: Maybe<Array<Scalars['String']['output']>>;
    /**
     * Contains disclaimer or related info regarding where the listing originated from.
     * For instance, "Copyright FMLS. All rights reserved. Information is deemed reliable but not guaranteed."
     */
    disclaimer?: Maybe<Scalars['String']['output']>;
    /**
     * A list of features or description of the exterior of the property included in the sale/lease.
     * Legacy fields mapped: hasGarden, hasGatedEntry, hasGreenhouse, hasLawn, hasSprinklerSystem
     * RESO fields mapped: Fields contained https://ddwiki.reso.org/display/DDW17/ExteriorFeatures+Lookups may change over time.
     */
    exteriorFeatures?: Maybe<Array<Scalars['String']['output']>>;
    /** Exterior materials used in construction such as brick, stucco, wood, etc. */
    exteriorMaterials?: Maybe<Array<Scalars['String']['output']>>;
    /**
     * A list of building features, sometimes supplied with a size.
     * Legacy fields mapped: hasBarbecueArea, hasFencedYard, hasRVParking, hasSauna, hasDeck, hasPatio, hasSportsCourt, hasBasketballCourt, hasTennisCourt, hasSecuritySystem
     * RESO fields mapped: BuildingFeatures
     * Expected mapping of public data: ExtraFeatures
     */
    extraFeatures?: Maybe<Array<DescriptionWithSize>>;
    /** The type of fireplace such as masonry, wood stove, etc. */
    fireplaceType?: Maybe<Scalars['String']['output']>;
    /** The types of floor coverings present in this property */
    floorCoverings?: Maybe<Array<Scalars['String']['output']>>;
    /** The floor number that you would live on (useful for larger buildings, but can also be populated for single family homes). */
    floorYouLiveOn?: Maybe<Scalars['Int']['output']>;
    /** The type of building foundation such as concrete, slab, pier, etc. */
    foundationTypes?: Maybe<Array<Scalars['String']['output']>>;
    /** The number of full bathrooms. A Full Bath will typically contain four elements; Sink, Toilet, Tub, and Shower Head.* */
    fullBathroomCount?: Maybe<Scalars['Int']['output']>;
    /** The number of 1/2 bathrooms. Missing two of the elements of a full bath, often the tub and shower head. */
    halfBathroomCount?: Maybe<Scalars['Int']['output']>;
    /** Does this fixture have air conditioning? */
    hasAirConditioning?: Maybe<Scalars['Boolean']['output']>;
    /** Does this fixture have at least one fireplace? */
    hasFireplace?: Maybe<Scalars['Boolean']['output']>;
    /** Does this property has a pool associated with it */
    hasPool?: Maybe<Scalars['Boolean']['output']>;
    /** Does this fixture have a spa (aka hot tub) associated with it? */
    hasSpa?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Includes the source of heating such as geo thermal, electric, oil, etc.
     * Also the type of heating such as baseboard, forced air, etc.
     */
    heatingSourcesAndSystems?: Maybe<Array<Scalars['String']['output']>>;
    /** The appliances included in this property */
    includedAppliances?: Maybe<Array<Scalars['String']['output']>>;
    /**
     * A list of features or description of the interior of the property included in the sale/lease.
     * Legacy fields mapped: isCableReady, hasCeilingFans, hasDisabledAccess, hasDoublePaneStormWindows, hasElevator, hasIntercom, hasJettedTub, hasSkylights, hasWetBar, isWired, hasVaultedCeilings, hasControlledAccess, isFurnished, isSatTVReady, isHighSpeedInternetAvailable
     * RESO fields mapped: Fields contained https://ddwiki.reso.org/display/DDW17/InteriorOrRoomFeatures+Lookups may change over time.
     */
    interiorFeatures?: Maybe<Array<Scalars['String']['output']>>;
    /**
     * A list of parking related data including garage information.
     * Legacy fields mapped: parkingTypes, {garageCarportLocationType + garageCarportType, garageSquareFeet} {"Covered Parking Spaces", coveredParkingSpaceCount}
     * RESO fields mapped to {description, spaces}: {"Covered Parking", CoveredSpaces}, {AttachedGarageYN, GarageSpaces}, {GarageYN, GarageSpaces}, {CarportYN, CarportSpaces}, {OpenParkingYN, OpenParkingSpaces}, OtherParking, {coalesce(ParkingFeatures, "Total Parking"), ParkingTotal}
     */
    parkingFeatures?: Maybe<Array<DescriptionWithSizeAndSpace>>;
    /**
     * Describes a pool in terms of heated, gunite, above ground, etc. Includes size.
     * Legacy fields mapped: swimmingPoolType
     * RESO fields mapped: PoolFeatures
     * Expected mapping of public data: Pool
     */
    poolFeatures?: Maybe<Array<PoolWithSize>>;
    /** The number of 1/4 bathrooms. Missing three of the elements of a full bath, often includes only a sink. */
    quarterBathroomCount?: Maybe<Scalars['Int']['output']>;
    /** Product used for roofing such as asphalt, metal, wood, etc. */
    roofTypes?: Maybe<Array<Scalars['String']['output']>>;
    /** Describes the types of rooms in the property; */
    roomTypes?: Maybe<Array<Scalars['String']['output']>>;
    /** Structure of the building such as modular, craftsman, loft, etc. (more descriptive than architectureType). */
    structureType?: Maybe<Scalars['String']['output']>;
    /** The number of 3/4 bathrooms. Missing one of the elements of a full bath, often the tub. */
    threeQuarterBathroomCount?: Maybe<Scalars['Int']['output']>;
    /**
     * Similar to description, but less focused on home facts.
     * This field will be null when HideUGC is applicable
     */
    whatILoveAboutMyHome?: Maybe<Scalars['String']['output']>;
};

export type FallbackPhotoStrategy = 'GOOGLE_SATELLITE_URL' | 'NO_PHOTO_URL';

export type FeatureDisplayTag =
    | 'Recommendation_Dual'
    | 'Recommendation_None'
    | 'Recommendation_OD'
    /**  short-term recommendation related tags for Pearl  */
    | 'Recommendation_PL'
    | 'SHOWCASE';

/** Deprecated. */
export type FeatureFlagging = {
    effectiveRegionTreatment?: Maybe<EffectiveRegionTreatmentType>;
};

/** A feedback option that should be display in the UI */
export type FeedbackOption = {
    /** The text that should be displayed to the user in the feedback option */
    displayText: Scalars['String']['output'];
};

export type FeedbackResponse = {
    messageIndex: Scalars['String']['output'];
    success: Scalars['Boolean']['output'];
};

/** Includes all HOA and non-HOA fees info */
export type FeesAndDues = {
    /** Parsed fee string, includes currency and frequency */
    fee?: Maybe<Scalars['String']['output']>;
    /** Name of Home Owner Association, only apply to HOA type */
    name?: Maybe<Scalars['String']['output']>;
    /** Phone of Home Owner Association, only apply to HOA type */
    phone?: Maybe<Scalars['String']['output']>;
    /** Type of fees, includes HOA and non-HOA types */
    type?: Maybe<Scalars['String']['output']>;
};

export type FieldValue = ArrayValue | BooleanValue | IntegerValue | StringValue;

/** fifteen year fixed rate object */
export type FifteenYearFixedBucket = {
    lastUpdated?: Maybe<Scalars['DateTime']['output']>;
    rate?: Maybe<Scalars['Float']['output']>;
    rateSource?: Maybe<Scalars['String']['output']>;
};

export type FinanceAIResults = {
    /** AI content */
    aiContent?: Maybe<Scalars['String']['output']>;
    /** map of citations */
    citations?: Maybe<Array<Maybe<FinanceResultPair>>>;
    /** possible action */
    possibleActions?: Maybe<Array<Maybe<FinanceResultPair>>>;
    /** suggested query */
    suggestedQueries?: Maybe<Array<Maybe<FinanceResultPair>>>;
    /** Users feedback */
    userFeedback?: Maybe<UsersFeedback>;
};

/** Simple module, used for sign in or info */
export type FinanceActivityModule = {
    /** @deprecated Use activityButtonV2 */
    activityButton?: Maybe<FinanceModuleButton>;
    activityButtonV2?: Maybe<HubStandardModuleButton>;
    header: Scalars['String']['output'];
    subheader?: Maybe<Scalars['String']['output']>;
};

export type FinanceButtonAction = 'SAVED_HOMES' | 'SIGN_IN';

export type FinanceChatBotResponse = {
    /** messageIndex */
    messageIndex?: Maybe<Scalars['String']['output']>;
    /** nextOffset */
    nextOffset?: Maybe<Scalars['Int']['output']>;
    /** query time of request */
    qTime?: Maybe<Scalars['Float']['output']>;
    /** result object returned by Finance Chatbot */
    results?: Maybe<Array<Maybe<FinanceResult>>>;
    /** status */
    status?: Maybe<ResponseStatus>;
};

/** Optional arguments used to modify results returns by the API */
export type FinanceContext = {
    /** interactionId to track user interactions */
    interactionId?: InputMaybe<Scalars['String']['input']>;
    /** Identifier to track the message number for given user */
    messageIndex?: InputMaybe<Scalars['String']['input']>;
    /** Latitude of the user's location, used for personalization. */
    userLat?: InputMaybe<Scalars['Float']['input']>;
    /** Longitude of the user's location, used for personalization. */
    userLong?: InputMaybe<Scalars['Float']['input']>;
};

export type FinanceDashboardDirective = {
    type: FinanceDashboardModuleType;
};

export type FinanceDashboardGroup = {
    backgroundColor?: Maybe<Scalars['String']['output']>;
    directives: Array<FinanceDashboardDirective>;
    headerText?: Maybe<Scalars['String']['output']>;
};

export type FinanceDashboardModuleType =
    | 'BUYING_POWER_SUMMARY'
    | 'DISCLAIMER'
    | 'DIVIDER'
    | 'NEXT_STEPS'
    | 'OUTCOME_SUMMARY'
    | 'RESOURCES'
    | 'SIGN_IN'
    | 'UPSELL'
    | 'YOUR_TEAM';

export type FinanceDashboardStaticDirective = FinanceDashboardDirective & {
    module?: Maybe<FinanceDashboardStaticModule>;
    type: FinanceDashboardModuleType;
};

export type FinanceDashboardStaticModule =
    | FinanceDisclaimerModule
    | FinanceDividerModule
    | FinanceOutcomeSummaryModule;

export type FinanceDashboardView = {
    groups?: Maybe<Array<FinanceDashboardGroup>>;
    metadata: FinanceMetadata;
};

export type FinanceDisclaimerModule = {
    text: Scalars['String']['output'];
};

export type FinanceDividerModule = {
    type: FinanceDividerType;
};

export type FinanceDividerType = 'FULL' | 'INSET';

export type FinanceExperienceVariant =
    | 'WITHOUT_ZHL_NEXT_STEPS_FOR_MAC_LOANS'
    | 'WITH_ZHL_NEXT_STEPS_FOR_MAC_LOANS';

export type FinanceGoal =
    | 'CASH'
    | 'HAS_FINANCING'
    | 'NEEDS_FINANCING'
    | 'REFINANCE'
    | 'UNSPECIFIED';

export type FinanceHuman = {
    /** Human chat query string */
    humanMessage: Scalars['String']['output'];
};

export type FinanceIndependentDynamicDirective = FinanceDashboardDirective & {
    required: Scalars['Boolean']['output'];
    type: FinanceDashboardModuleType;
};

export type FinanceJourneyContext = {
    status?: Maybe<FinanceJourneyStatusType>;
    zuid: Scalars['String']['output'];
};

export type FinanceJourneyStatusType = 'ENGAGED' | 'PREAPPROVED' | 'PREQUALIFIED';

export type FinanceLoanDependentDynamicDirective = FinanceDashboardDirective & {
    required: Scalars['Boolean']['output'];
    type: FinanceDashboardModuleType;
    zhlLid: Scalars['String']['output'];
};

export type FinanceMetadata = {
    hasLoan: Scalars['Boolean']['output'];
};

/** Deprecated in favor of HubModuleButton */
export type FinanceModuleButton = {
    /** @deprecated Use field in navInfo */
    analyticsTag?: Maybe<Scalars['String']['output']>;
    /**
     * Leads to a webview, and is a fallback url in case the native action defined in FinanceButtonAction is not available
     * @deprecated Use field in navInfo
     */
    ctaUrl: Scalars['String']['output'];
    /**
     * Enum value defining contextual native action
     * @deprecated Use field in navInfo
     */
    nativeAction?: Maybe<FinanceButtonAction>;
    navInfo: FinanceNavInfo;
    /** @deprecated Use field in navInfo */
    showAbad?: Maybe<Scalars['Boolean']['output']>;
    text: Scalars['String']['output'];
    type: FinanceModuleButtonStyle;
};

export type FinanceModuleButtonStyle =
    | 'CAUTION'
    | 'PRIMARY'
    | 'SECONDARY'
    | 'TERTIARY'
    | 'TEXT_ONLY';

export type FinanceModuleGroupView = {
    backgroundColor?: Maybe<Scalars['String']['output']>;
    headerText?: Maybe<Scalars['String']['output']>;
    modules?: Maybe<Array<FinanceViewModule>>;
};

export type FinanceMoveDependentDynamicDirective = FinanceDashboardDirective & {
    moveId: Scalars['String']['output'];
    required: Scalars['Boolean']['output'];
    type: FinanceDashboardModuleType;
};

export type FinanceNavInfo = {
    /** Tag for clickstream analytics */
    analyticsTag?: Maybe<Scalars['String']['output']>;
    /** Leads to a webview, and is a fallback url in case the native action is not available */
    ctaUrl: Scalars['String']['output'];
    /** Enum value defining contextual native action */
    nativeAction?: Maybe<FinanceButtonAction>;
    /** Determines if abad should be shown on native action or url click */
    showAbad?: Maybe<Scalars['Boolean']['output']>;
    /** Boolean value to determine if in-app browser should be used */
    useInAppBrowser?: Maybe<Scalars['Boolean']['output']>;
};

export type FinanceNextStepsModule = {
    ctaButtonText?: Maybe<Scalars['String']['output']>;
    description: Scalars['String']['output'];
    headerText: Scalars['String']['output'];
    steps: Array<ZhlMacPnsStep>;
    title: Scalars['String']['output'];
    zhlLoanId: Scalars['ID']['output'];
};

export type FinanceNextStepsModuleV2 = {
    /** @deprecated Use ctaButtons list instead */
    ctaButton: HubStandardModuleButton;
    ctaButtons: Array<HubStandardModuleButton>;
    description: Scalars['String']['output'];
    headerText: Scalars['String']['output'];
    steps: Array<ZhlMacStep>;
    title: Scalars['String']['output'];
    zhlLoanId: Scalars['ID']['output'];
};

export type FinanceOutcomeSummaryModule = {
    headerText: Scalars['String']['output'];
    /** URL to the header image. If no format is given, a PNG file is returned. */
    imageUrl?: Maybe<Scalars['String']['output']>;
};

export type FinanceOutcomeSummaryModuleimageUrlArgs = {
    format?: InputMaybe<ImageFileFormat>;
};

/** Module with link to external resources */
export type FinanceResource = {
    /** @deprecated Use field in navAction */
    analyticsTag?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use field in navAction */
    buttonAction?: Maybe<FinanceButtonAction>;
    /** @deprecated Use field in navAction */
    ctaUrl: Scalars['String']['output'];
    iconType?: Maybe<DetailedIconType>;
    navAction: HubNavAction;
    /** @deprecated Use field in navAction */
    navInfo: FinanceNavInfo;
    subtext?: Maybe<Scalars['String']['output']>;
    title: Scalars['String']['output'];
};

export type FinanceResourcesView = {
    resources: Array<FinanceResource>;
};

export type FinanceResult = {
    ai?: Maybe<FinanceAIResults>;
    human?: Maybe<FinanceHuman>;
    messageIndex?: Maybe<Scalars['String']['output']>;
    system?: Maybe<Scalars['String']['output']>;
};

export type FinanceResultPair = {
    /** Key */
    key: Scalars['String']['output'];
    /** Value */
    value: Scalars['String']['output'];
};

export type FinanceSignInModule = {
    header: Scalars['String']['output'];
    signInButton?: Maybe<HubStandardModuleButton>;
    subheader?: Maybe<Scalars['String']['output']>;
};

/** Module that acts as the upsell / header part */
export type FinanceUpsellModule = {
    header: Scalars['String']['output'];
    /** URL to the header image. If no format is given, a PNG file is returned. */
    imageUrl?: Maybe<Scalars['String']['output']>;
    subheader?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use upsellButtonV2 */
    upsellButton?: Maybe<FinanceModuleButton>;
    upsellButtonV2?: Maybe<HubStandardModuleButton>;
};

/** Module that acts as the upsell / header part */
export type FinanceUpsellModuleimageUrlArgs = {
    format?: InputMaybe<ImageFileFormat>;
};

export type FinanceUpsellPage = {
    clickstreamMetadata: SubmitFlowComponentClickstreamMetadata;
    confirmationIcon: SubmitFlowIcon;
    confirmationMessage: Scalars['String']['output'];
    financing: FinanceUpsell_Financing;
    property: FinanceUpsell_Property;
    title: Scalars['String']['output'];
};

export type FinanceUpsellView = ITourView & {
    alerts?: Maybe<Array<TourViewAlert>>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewMetadata>;
    modules?: Maybe<Array<TourViewModule>>;
    toasts?: Maybe<Array<TourViewToast>>;
};

export type FinanceUpsell_Financing = {
    finePrint: Scalars['String']['output'];
    logo?: Maybe<SubmitFlowPhoto>;
    messageText: Scalars['String']['output'];
    primaryCTA: SubmitFlowCTA;
    title: Scalars['String']['output'];
};

export type FinanceUpsell_Property = {
    price?: Maybe<Scalars['String']['output']>;
    propertyPhoto?: Maybe<SubmitFlowPhoto>;
};

export type FinanceView = {
    metadata: FinanceMetadata;
    moduleGroups?: Maybe<Array<FinanceModuleGroupView>>;
};

export type FinanceViewModule =
    | FinanceActivityModule
    | FinanceDisclaimerModule
    | FinanceDividerModule
    | FinanceNextStepsModule
    | FinanceNextStepsModuleV2
    | FinanceOutcomeSummaryModule
    | FinanceResource
    | FinanceUpsellModule
    | YourTeamModule;

export type FinancialProfile = {
    encodedZuid?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['String']['output']>;
    selfReported?: Maybe<SelfReported>;
    selfReportedCreditScoreRange?: Maybe<CreditScoreRangeCategory>;
    selfReportedDownPayment?: Maybe<DownPayment>;
    zuid: Scalars['Int']['output'];
};

export type FinancingCalculatorOutput = {
    calculatorType?: Maybe<Scalars['String']['output']>;
    downPaymentAmount?: Maybe<Scalars['Float']['output']>;
    downPaymentPercent?: Maybe<Scalars['Float']['output']>;
    estimatedMonthlyPaymentAmount?: Maybe<Scalars['Float']['output']>;
    interestRate?: Maybe<Scalars['Float']['output']>;
    loanProgram?: Maybe<Scalars['String']['output']>;
    propertyValue?: Maybe<Scalars['Float']['output']>;
};

export type FinancingCheckbox = {
    checkedClickstreamMetadata: SubmitFlowComponentClickstreamMetadata;
    financingType: FinancingCheckboxType;
    initialClickstreamMetadata: SubmitFlowComponentClickstreamMetadata;
    isCheckedInitialState: Scalars['Boolean']['output'];
    label: Scalars['String']['output'];
    leadFieldName: Scalars['String']['output'];
    uncheckedClickstreamMetadata: SubmitFlowComponentClickstreamMetadata;
};

export type FinancingCheckboxType = 'NONE' | 'ZGMI' | 'ZHL';

/** FindAlanResult ... */
export type FindAlanResult = {
    agent_zuid?: Maybe<Scalars['Int']['output']>;
    paying_agent_zuid?: Maybe<Scalars['Int']['output']>;
};

/** FindAlanSummaryByIdResponse ... */
export type FindAlanSummaryByIdResponse = {
    action?: Maybe<Scalars['String']['output']>;
    agent_calls?: Maybe<Array<Maybe<AgentCall>>>;
    associated_lead_ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    consumer_id?: Maybe<Scalars['String']['output']>;
    find_alan_transaction_id?: Maybe<Scalars['String']['output']>;
    lead_pacing_request_id?: Maybe<Scalars['String']['output']>;
    lead_pacing_request_type?: Maybe<Scalars['String']['output']>;
    notification_connection_id?: Maybe<Scalars['String']['output']>;
    operation_context_id?: Maybe<Scalars['String']['output']>;
    opportunity_agents?: Maybe<Array<Maybe<OpportunityAgent>>>;
    pacing_agents?: Maybe<Array<Maybe<PacingAgent>>>;
    primary_lead_id?: Maybe<Scalars['String']['output']>;
    result?: Maybe<FindAlanResult>;
    send_preconnection_sms?: Maybe<Scalars['Boolean']['output']>;
};

export type FirstTimeBuyerStatus = 'NO' | 'UNSPECIFIED' | 'YES';

export type FixtureType =
    | 'IMPROVEMENT'
    | 'LOTLAND'
    | 'REPRESENTATIVE'
    | 'SUBUNIT'
    | 'UNIT'
    | 'UNKNOWN';

export type FlagHighlightInput = {
    comment: Scalars['String']['input'];
    /** Text of the flagged highlight. */
    content: Scalars['String']['input'];
    /** Reason for flagging the highlight. */
    reason: Scalars['String']['input'];
    /** Zillow property identifier. */
    zpid: Scalars['Int']['input'];
};

export type FlagHighlightResult = {
    errorMessage?: Maybe<Scalars['String']['output']>;
};

export type FlexAddress = {
    city?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    street?: Maybe<Scalars['String']['output']>;
    street2?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type FlexBrokerCommissionDetails = {
    commissionAddition?: Maybe<Scalars['Float']['output']>;
    commissionAmount?: Maybe<Scalars['Float']['output']>;
    commissionPercentage?: Maybe<Scalars['Float']['output']>;
    commissionReduction?: Maybe<Scalars['Float']['output']>;
};

export type FlexOtpForm = {
    documentId?: Maybe<Scalars['String']['output']>;
    downloadLink?: Maybe<Scalars['String']['output']>;
    previewLink?: Maybe<Scalars['String']['output']>;
};

export type FlexProperty = {
    address?: Maybe<FlexAddress>;
    zpid?: Maybe<Scalars['String']['output']>;
};

export type FlexTransaction = {
    agent?: Maybe<FlexTxnAgent>;
    broker?: Maybe<FlexTxnBroker>;
    brokerCommissionDetails?: Maybe<FlexBrokerCommissionDetails>;
    carpOtpDocumentId?: Maybe<Scalars['String']['output']>;
    closingDetails?: Maybe<FlexTxnClosingDetails>;
    consumer?: Maybe<FlexTxnConsumer>;
    contact?: Maybe<FlexTxnContact>;
    contactOwner?: Maybe<FlexTxnContactOwner>;
    destinationAccountNumber?: Maybe<Scalars['String']['output']>;
    invoiceNumber?: Maybe<Scalars['String']['output']>;
    isDocumentUploaded?: Maybe<Scalars['Boolean']['output']>;
    isPaymentAuthorized?: Maybe<Scalars['Boolean']['output']>;
    metadata?: Maybe<FlexTxnMetadata>;
    otpForm?: Maybe<FlexOtpForm>;
    paymentAmount?: Maybe<Scalars['Float']['output']>;
    paymentAuthorizedBy?: Maybe<Scalars['String']['output']>;
    paymentAuthorizedTime?: Maybe<Scalars['DateTime']['output']>;
    paymentStatus?: Maybe<FlexTxnPaymentStatus>;
    property?: Maybe<FlexProperty>;
    ztid: Scalars['ID']['output'];
};

export type FlexTransactionCancellationReason = {
    id: Scalars['String']['output'];
    otherText?: Maybe<Scalars['String']['output']>;
    text: Scalars['String']['output'];
};

export type FlexTransactionCancellationReasonInput = {
    /**  Use 'OTHER' as id for when submitting user supplied reason as 'otherText'.  */
    id: Scalars['String']['input'];
    otherText?: InputMaybe<Scalars['String']['input']>;
    text: Scalars['String']['input'];
};

export type FlexTransactionCancellationReasonItem = {
    id: Scalars['String']['output'];
    text: Scalars['String']['output'];
};

export type FlexTransactionClosingDetailsInput = {
    brokerGrossCommission?: InputMaybe<Scalars['Float']['input']>;
    /**  ISO 8601 (YYYY-MM-DD)  */
    closeDate?: InputMaybe<Scalars['Date']['input']>;
    propertySalesPrice?: InputMaybe<Scalars['Float']['input']>;
    transactionCancellationReason?: InputMaybe<FlexTransactionCancellationReasonInput>;
    transactionStatus?: InputMaybe<FlexTxnStatusCode>;
    transactionType?: InputMaybe<FlexTxnRepresentationType>;
};

export type FlexTransactionConsumerInput = {
    name: Scalars['String']['input'];
};

export type FlexTransactionPropertyDetailsInput = {
    address?: InputMaybe<FlexTxnAddressInput>;
};

export type FlexTxnAddressInput = {
    city: Scalars['String']['input'];
    state: Scalars['String']['input'];
    street: Scalars['String']['input'];
    street2?: InputMaybe<Scalars['String']['input']>;
    zip: Scalars['String']['input'];
};

export type FlexTxnAgent = {
    agentEmail?: Maybe<Scalars['String']['output']>;
    agentZuid?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    teamLeadName?: Maybe<Scalars['String']['output']>;
    teamLeadZuid?: Maybe<Scalars['String']['output']>;
};

export type FlexTxnBroker = {
    billingAccountExists?: Maybe<Scalars['Boolean']['output']>;
    brokerEmail?: Maybe<Scalars['String']['output']>;
    brokerName?: Maybe<Scalars['String']['output']>;
    brokerZuid?: Maybe<Scalars['String']['output']>;
    brokerageAddress?: Maybe<FlexAddress>;
    brokerageName?: Maybe<Scalars['String']['output']>;
};

export type FlexTxnBrokerCommissionDetailsInput = {
    commissionAddition?: InputMaybe<Scalars['Float']['input']>;
    commissionAmount?: InputMaybe<Scalars['Float']['input']>;
    commissionPercentage?: InputMaybe<Scalars['Float']['input']>;
    commissionReduction?: InputMaybe<Scalars['Float']['input']>;
};

export type FlexTxnClosingDetails = {
    brokerGrossCommission?: Maybe<Scalars['String']['output']>;
    /**  ISO 8601 (YYYY-MM-DD)  */
    closeDate?: Maybe<Scalars['Date']['output']>;
    closingCompany?: Maybe<Scalars['String']['output']>;
    flexVersion?: Maybe<Scalars['String']['output']>;
    market?: Maybe<Scalars['String']['output']>;
    propertySalesPrice?: Maybe<Scalars['Float']['output']>;
    transactionCancellationReason?: Maybe<FlexTransactionCancellationReason>;
    transactionCreatedDate?: Maybe<Scalars['Date']['output']>;
    transactionStatus?: Maybe<FlexTxnStatusCode>;
    transactionType?: Maybe<FlexTxnRepresentationType>;
    zgFee?: Maybe<Scalars['Float']['output']>;
    zgFeePercentage?: Maybe<Scalars['Float']['output']>;
};

export type FlexTxnConsumer = {
    consumerId?: Maybe<Scalars['ID']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

export type FlexTxnContact = {
    contactDate?: Maybe<Scalars['String']['output']>;
    contactId?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

export type FlexTxnContactOwner = {
    name?: Maybe<Scalars['String']['output']>;
    zuid?: Maybe<Scalars['ID']['output']>;
};

export type FlexTxnMetadata = {
    createBy?: Maybe<Scalars['String']['output']>;
    createTime?: Maybe<Scalars['DateTime']['output']>;
    eventType?: Maybe<Scalars['String']['output']>;
    lastUpdateBy?: Maybe<Scalars['String']['output']>;
    lastUpdateTime?: Maybe<Scalars['String']['output']>;
    messageId?: Maybe<Scalars['String']['output']>;
    messageTime?: Maybe<Scalars['DateTime']['output']>;
    sourceSystem?: Maybe<Scalars['String']['output']>;
    versionNumber?: Maybe<Scalars['String']['output']>;
};

export type FlexTxnPaymentStatus = 'DUE' | 'NA' | 'NOTYETDUE' | 'RECEIVED';

export type FlexTxnRepresentationType = 'BUY' | 'SELL';

export type FlexTxnStatusCode = 'CANCELED' | 'CANCELLED' | 'CLOSED' | 'PENDING';

export type FlexTxnValidation = {
    code?: Maybe<Scalars['String']['output']>;
    message?: Maybe<Scalars['String']['output']>;
    path?: Maybe<Array<Scalars['String']['output']>>;
    type?: Maybe<FlexTxnValidationType>;
};

export type FlexTxnValidationType = 'ERROR' | 'WARNING';

export type FloorCoveringType =
    | 'Carpet'
    | 'Concrete'
    | 'Hardwood'
    | 'Laminate'
    | 'Linoleum'
    | 'Other'
    | 'Slate'
    | 'Softwood'
    | 'Tile'
    | 'Unknown'
    | 'Vinyl';

/** Floor map created from a 3D Home */
export type FloorMap = {
    cdnHost?: Maybe<Scalars['String']['output']>;
    floorMapGuid?: Maybe<Scalars['String']['output']>;
    vrModelGuid?: Maybe<Scalars['String']['output']>;
};

/** Floor plan information for WOW BDP */
export type FloorPlan = {
    amenityDetails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    availableFrom?: Maybe<Scalars['String']['output']>;
    availableFromDateStr?: Maybe<Scalars['String']['output']>;
    baths?: Maybe<Scalars['Float']['output']>;
    beds?: Maybe<Scalars['Int']['output']>;
    depositsAndFees?: Maybe<Scalars['Float']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    floorPlanUnitPhotos?: Maybe<Array<Maybe<Photo>>>;
    /** Floorplan VR Model based on virtualTourUrl */
    floorplanVRModel?: Maybe<BuildingVRModel>;
    hasApprovedThirdPartyVirtualTour?: Maybe<Scalars['Boolean']['output']>;
    leaseTerm?: Maybe<Scalars['String']['output']>;
    maloneId?: Maybe<Scalars['String']['output']>;
    maxPrice?: Maybe<Scalars['Int']['output']>;
    minPrice?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    photos?: Maybe<Array<Maybe<Photo>>>;
    sqft?: Maybe<Scalars['Int']['output']>;
    /** Floorplan 3rd party virtual tour */
    thirdPartyVirtualTour?: Maybe<thirdPartyVirtualTour>;
    units?: Maybe<Array<Maybe<UnitV2>>>;
    videos?: Maybe<Array<Maybe<FloorplanVideos>>>;
    /** This field will not be used until RDAPI fully supports requesting by zpid */
    vrModels?: Maybe<Array<Maybe<BuildingVRModel>>>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type FloorPlanBoundingBox = {
    maxLat: Scalars['Float']['output'];
    maxLng: Scalars['Float']['output'];
    minLat: Scalars['Float']['output'];
    minLng: Scalars['Float']['output'];
};

export type FloorPlanDimensionsMeters = {
    height: Scalars['Float']['output'];
    width: Scalars['Float']['output'];
};

export type FloorPlanOnMap = {
    dimensions: FloorPlanDimensionsMeters;
    floor: ShowcaseFloor;
    googleMapCoordinates: GoogleMapCoordinates;
    mapKitCoordinates: MapKitCoordinates;
    roomHighlightOrder: Array<Maybe<ShowcaseRoom>>;
    rotateDeg: Scalars['Float']['output'];
};

export type Floorplan = {
    baths?: Maybe<Scalars['Float']['output']>;
    lightboxPhotoUrl?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['String']['output']>;
    sqft?: Maybe<Scalars['Int']['output']>;
    thumbnailPhotoUrl?: Maybe<Scalars['String']['output']>;
    units?: Maybe<Array<Maybe<Unit>>>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type FloorplanVideos = {
    label?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
};

export type ForSaleContactFormData = {
    /** This field is provided as JSON, passed through from and documented in adsdisplay */
    data?: Maybe<Scalars['JSON']['output']>;
    /** ZPID that contact form is rendered for */
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type ForSaleContactFormVariant = 'OWNER_CONTACT' | 'SELLER_AGENT';

export type ForbiddenError = BridgeContainerError & {
    message: Scalars['String']['output'];
    retryable?: Maybe<Scalars['Boolean']['output']>;
};

export type Foreclosure = {
    /**
     * Information about the current status of this
     * foreclosure
     */
    foreclosureStage?: Maybe<ForeclosureStageType>;
    /**
     * The date that the foreclosure entered this stage
     * (i.e. when its status changed to the current status)
     * Example: 2019-07-03
     */
    foreclosureStageDate?: Maybe<Scalars['LocalDate']['output']>;
    /** True if the foreclosure is owned by bank */
    isBankOwned?: Maybe<Scalars['Boolean']['output']>;
};

/** Flags indicating the foreclosure-related stages the property has been in */
export type ForeclosureFlags = {
    /** Whether the property is any type of active foreclosure (bank-owned, foreclosed nfs, foreclosure, or preforeclosure) */
    isAnyForeclosure?: Maybe<Scalars['Boolean']['output']>;
    /** Whether the property is bank-owned */
    isBankOwned?: Maybe<Scalars['Boolean']['output']>;
    /** Whether the property is foreclosed and not for sale */
    isForeclosedNFS?: Maybe<Scalars['Boolean']['output']>;
    /** Whether the property is a pre-foreclosure */
    isPreforeclosure?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Whether the property was in default
     * @deprecated Does not exist in PDC
     */
    wasDefault?: Maybe<Scalars['Boolean']['output']>;
    /** Whether the property has been foreclosed on */
    wasForeclosed?: Maybe<Scalars['Boolean']['output']>;
    /** Whether the property has undergone a non-retail auction */
    wasNonRetailAuction?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Whether the property was real estate owned
     * @deprecated Does not exist in PDC
     */
    wasREO?: Maybe<Scalars['Boolean']['output']>;
};

export type ForeclosureMoreInfo = {
    /** Assessor's parcel number, assigned to a property by the tax assessor */
    apn?: Maybe<Scalars['String']['output']>;
    /**
     * The legal description of the property in foreclosure. Could contain the street
     * address, boundaries and/or other descriptors about the property
     */
    legalDescription?: Maybe<Scalars['String']['output']>;
    /** The recording number(s) and filing date(s) for foreclosure documents filed with the county */
    recordedDocs?: Maybe<Array<Maybe<ForeclosureMoreInfoDocument>>>;
    /** The name of the subdivision, plat, or tract where the property is located */
    subdivision?: Maybe<Scalars['String']['output']>;
    /** Address of the entity guiding the property through the foreclosure process */
    trusteeAddress?: Maybe<Scalars['String']['output']>;
    /** Name of the entity guiding the property through the foreclosure process */
    trusteeName?: Maybe<Scalars['String']['output']>;
    /** Phone number of the entity guiding the property through the foreclosure process */
    trusteePhone?: Maybe<Scalars['String']['output']>;
};

export type ForeclosureMoreInfoDocument = {
    /** Filing date of the document */
    date?: Maybe<Scalars['DateTime']['output']>;
    /** Name of the filed document */
    name?: Maybe<Scalars['String']['output']>;
    /** Filing number of the document */
    number?: Maybe<Scalars['String']['output']>;
};

export type ForeclosureStageType =
    | 'LENDER_TAKEN_POSSESSION'
    | 'NOTICE_OF_DEFAULT'
    | 'NOTICE_OF_SALE'
    | 'UNKNOWN';

export type FormQuestion = {
    inputName: Scalars['String']['output'];
    questionIcon: Scalars['String']['output'];
    questionText: Scalars['String']['output'];
};

export type FormQuestionnaire = {
    formQuestions: Array<Maybe<FormQuestion>>;
};

export type FormType =
    | 'AGENT_DIRECTORY'
    | 'FORECLOSURE_SPECIALIST'
    | 'INSTANT'
    | 'INSTANT_BOOK'
    | 'MY_AGENT'
    | 'NO_BOX'
    | 'OPAQUE'
    | 'OWNER_CONTACT'
    | 'RENTAL'
    | 'SELLER_AGENT'
    | 'STANDARD'
    | 'TRAFFIC_OPTIMIZED';

export type FormattedAddress = {
    /** The city of the formatted address */
    city?: Maybe<Scalars['String']['output']>;
    /**
     * The first line of the formatted address.
     * By default this includes the street address but not
     * city/state/zip.
     * For new construction properties with an address override
     * this will be the address override.
     * For apartment floorplans and units this will be the property+plan names.
     * For certain types of properties where we obscure the address, this may
     * only contain the street name (no house number).
     * For grouped results the formatted address will not contain a unit number.
     */
    line1?: Maybe<Scalars['String']['output']>;
    /**
     * The second line of the formatted address
     * This is the city/state and zipcode
     */
    line2?: Maybe<Scalars['String']['output']>;
    /** The postal code of the formatted address */
    postalCode?: Maybe<Scalars['String']['output']>;
    /** The State or Province of the formatted address */
    stateOrProvince?: Maybe<Scalars['String']['output']>;
};

export type FormattedChip = {
    /** Array of additional facts for the chip */
    additionalFacts?: Maybe<Array<Maybe<ChipElementType>>>;
    /** Property Address */
    location?: Maybe<Array<Maybe<ResponsiveString>>>;
    /** Formatted Price for a property, depending on type */
    mainPrice?: Maybe<ChipElementType>;
    /** Details about the price change */
    priceChange?: Maybe<ChipElementType>;
    /** Array of Quick Facts */
    quickFacts?: Maybe<Array<Maybe<ChipElementType>>>;
    /** Property Status */
    status?: Maybe<ResponsiveString>;
};

export type FreeformResponseQuestion = FormQuestion & {
    inputName: Scalars['String']['output'];
    questionIcon: Scalars['String']['output'];
    questionText: Scalars['String']['output'];
};

/** funnels that attribute to leads to Zillow */
export type Funnel =
    | 'DIRECT'
    | 'EMAIL_CAMPAIGN'
    | 'PA_CRM'
    | 'PA_PEARL'
    | 'RENTAL'
    | 'SEM'
    | 'SMM'
    | 'ZHL';

export type GenderType = 'FEMALE' | 'MALE' | 'NON_BINARY' | 'PREFER_NOT_TO_IDENTIFY' | 'UNKNOWN';

export type GeoAttributes = {
    city?: Maybe<Scalars['String']['output']>;
    cityId?: Maybe<Scalars['Int']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    county?: Maybe<Scalars['String']['output']>;
    countyFips?: Maybe<Scalars['String']['output']>;
    countyId?: Maybe<Scalars['Int']['output']>;
    neighborhoodId?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    zipCode?: Maybe<Scalars['String']['output']>;
};

export type GeometryType =
    | 'GEOMETRYCOLLECTION'
    | 'LINESTRING'
    | 'MULTILINESTRING'
    | 'MULTIPOINT'
    | 'MULTIPOLYGON'
    | 'POINT'
    | 'POLYGON'
    | 'UNKNOWN';

/** GetFindAlanSummaryByIdInput ... */
export type GetFindAlanSummaryByIdInput = {
    find_alan_transaction_id?: InputMaybe<Scalars['String']['input']>;
};

export type GetLandingPageOutput = {
    featuresEnabled: Scalars['String']['output'];
    landingPage: Scalars['String']['output'];
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type GetLeaseActivity = {
    label?: Maybe<Scalars['String']['output']>;
    message?: Maybe<Scalars['String']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

/** GetPhonesByAssociationInput ... */
export type GetPhonesByAssociationInput = {
    association_type?: InputMaybe<Scalars['String']['input']>;
    association_value?: InputMaybe<Scalars['String']['input']>;
    product?: InputMaybe<Scalars['String']['input']>;
};

export type GetPreApprovalLetterOutput = {
    documents?: Maybe<Array<Maybe<ZHLDocumentMetadata>>>;
};

export type GoogleAerialView = {
    metadata?: Maybe<VideoMetaData>;
    state?: Maybe<Scalars['String']['output']>;
    uris?: Maybe<UrisFormat>;
};

export type GoogleMapCoordinates = {
    boundingBox: FloorPlanBoundingBox;
    lat: Scalars['Float']['output'];
    lng: Scalars['Float']['output'];
};

export type GoogleReview = {
    authorName?: Maybe<Scalars['String']['output']>;
    rating?: Maybe<Scalars['Float']['output']>;
    text?: Maybe<Scalars['String']['output']>;
    time?: Maybe<Scalars['Int']['output']>;
    translated?: Maybe<Scalars['Boolean']['output']>;
};

export type GoogleReviews = {
    rating?: Maybe<Scalars['Float']['output']>;
    reviews?: Maybe<Array<Maybe<GoogleReview>>>;
    userRatingsTotal?: Maybe<Scalars['Int']['output']>;
};

export type GoogleStaticMapType = 'HYBRID' | 'ROAD' | 'SATELLITE' | 'TERRAIN';

export type GoogleStreetviewLocationType = 'ADDRESS' | 'BUILDING_ADDRESS' | 'LAT_LONG';

export type GrantHardCreditConsentInput = {
    method?: InputMaybe<ZHLCreditConsentMethod>;
};

export type GrantHardCreditConsentOutput = {
    id?: Maybe<Scalars['ID']['output']>;
};

export type Greeting = {
    /** Content for greeting */
    content?: Maybe<Scalars['String']['output']>;
    /** Unique ID for greeting */
    id: Scalars['Int']['output'];
};

export type GreetingAuthorizationError = {
    message?: Maybe<Scalars['String']['output']>;
};

export type GreetingResult = Greeting | GreetingAuthorizationError;

export type GroupingStrategy = 'BUILDING_ID' | 'LOCATION' | 'LOCATION_AND_BEDROOM';

export type GuestUser = {
    guid: Scalars['String']['output'];
    upsBDPRealTimeHistograms?: Maybe<GuidUpsBDPRealTimeHistograms>;
    upsCollectionFeedbackRealTimeHistograms?: Maybe<GuidUpsCollectionFeedbackRealTimeHistograms>;
    upsForRentLongTermFeatures?: Maybe<GuidUpsForRentLongTermFeatures>;
    upsForRentRealTimeHistograms?: Maybe<GuidUpsForRentRealTimeHistograms>;
    upsForSaleBatchOnlyEmbeddings?: Maybe<GuidUpsForSaleBatchOnlyEmbeddings>;
    upsForSaleBatchOnlyHistograms?: Maybe<GuidUpsForSaleBatchOnlyHistograms>;
    upsForSaleLongTermFeatures?: Maybe<GuidUpsForSaleLongTermFeatures>;
    upsForSaleRealTimeHistograms?: Maybe<GuidUpsForSaleRealTimeHistograms>;
    upsSavedSearchRealTimeFeatures?: Maybe<GuidUpsSavedSearchRealTimeFeatures>;
    upsSearchRealTimeFeatures?: Maybe<GuidUpsSearchRealTimeFeatures>;
};

export type GuestUserupsBDPRealTimeHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type GuestUserupsCollectionFeedbackRealTimeHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type GuestUserupsForRentLongTermFeaturesArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type GuestUserupsForRentRealTimeHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type GuestUserupsForSaleBatchOnlyHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type GuestUserupsForSaleLongTermFeaturesArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type GuestUserupsForSaleRealTimeHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type GuestUserupsSavedSearchRealTimeFeaturesArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type GuestUserupsSearchRealTimeFeaturesArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/** related to aggregated metrics on user_activity: basic */
export type GuidSubMetric = 'UNIQUE_COUNT';

/**  Default Experience BDP feature group for features filtered by Zillow Users who are not logged in  */
export type GuidUpsBDPRealTimeHistograms = {
    /**  GUID - the devide ID that uniquely identifies unknown Zillow users  */
    guid: Scalars['String']['output'];
    /**  Record containing computed histogram features for a user  */
    histograms?: Maybe<GuidUpsBDPRealTimeHistograms_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  History of properties viewed by the unknown Zillow user with the most recent views first  */
    viewHistory?: Maybe<Array<GuidUpsBDPRealTimeHistograms_ViewHistoryRecord>>;
};

/**  Histogram fields/feature group computed for ZUIDs and GUIDs for BDP views  */
export type GuidUpsBDPRealTimeHistograms_HistogramRecord = {
    /**  The number of bedrooms based on BDP Views  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies cities of the properties viewed, BDP only  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.), based on HDP views only  */
    hdpHouseType?: Maybe<Scalars['JSON']['output']>;
    /**  Distribution of HDP vs. BDP views  */
    hdpView?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  The min number of bedrooms, BDP only  */
    minBedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Min Home price, BDP only  */
    minPrice?: Maybe<Scalars['JSON']['output']>;
    /**  Min Square Feet of the property, BDP only  */
    minSqft?: Maybe<Scalars['JSON']['output']>;
    /**  The number of bedrooms based on HDP and BDP Views, short-term  */
    mixBedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  The number of bedrooms based on HDP and BDP Views, long-term  */
    mixBedroomsLR?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies cities of the properties viewed, BDP and HDP, short term  */
    mixCityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies cities of the properties viewed, BDP and HDP, long term  */
    mixCityRegionIdLR?: Maybe<Scalars['JSON']['output']>;
    /**  Home price from HDP and BDP events, short-term  */
    mixPrice?: Maybe<Scalars['JSON']['output']>;
    /**  Home price from HDP and BDP events, long-term  */
    mixPriceLR?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property, HDP and BDP, short term  */
    mixSqft?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property, HDP and BDP, long term  */
    mixSqftLR?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property, BDP+ HDP, short term  */
    mixZip2?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property, BDP+ HDP, long term  */
    mixZip2LR?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property, BDP+ HDP, short term  */
    mixZip3?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property, BDP+ HDP, long term  */
    mixZip3LR?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property, BDP + HDP, short term  */
    mixZip4?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property, BDP + HDP, long term  */
    mixZip4LR?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property, BDP + HDP, short term  */
    mixZipCode?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property, BDP + HDP, long term  */
    mixZipCodeLR?: Maybe<Scalars['JSON']['output']>;
    /**  Home price from BDP events only  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property, BDP only  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property, BDP  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property, BDP  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property, BDP  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property, BDP  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a zillow property was viewed, and for how long it was viewed, by a user.  */
export type GuidUpsBDPRealTimeHistograms_ViewHistoryRecord = {
    /**  lotid - Unique identifier for a (rental) building viewed by a user.  */
    lotid?: Maybe<Scalars['String']['output']>;
    /**  providerlistingid - Provider listing ID is what ties a listing to an Agent..  */
    providerlistingid?: Maybe<Scalars['String']['output']>;
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
    /**  ZPID - Unique identifier for a property viewed by a user.  */
    zpid?: Maybe<Scalars['String']['output']>;
};

/**
 *  Default Collection Feedback feature group
 * *  for features filtered by Zillow Users who are not logged in
 */
export type GuidUpsCollectionFeedbackRealTimeHistograms = {
    /**  GUID - the devide ID that uniquely identifies unknown Zillow users  */
    guid: Scalars['String']['output'];
    /**  Record containing computed histogram features for a user  */
    histograms?: Maybe<GuidUpsCollectionFeedbackRealTimeHistograms_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
};

/**  Histogram fields/feature group computed for ZUIDs and GUIDs for Collections Feedback  */
export type GuidUpsCollectionFeedbackRealTimeHistograms_HistogramRecord = {
    /**
     *  Value indicates the preferences of the user on collection feedback.
     * *  Positive value means like, negative value means dislike.
     */
    collectionFeedback?: Maybe<Scalars['JSON']['output']>;
};

/**  long_term/zillow_for_rent_histograms feature group for GUIDs, ups-fr-longterm-gh  */
export type GuidUpsForRentLongTermFeatures = {
    /**  GUID - the devide ID that uniquely identifies an unknown user interacting with Zillow  */
    guid: Scalars['String']['output'];
    /**  Histograms calculated as part of the For Rent Long Term experience  */
    histograms?: Maybe<GuidUpsForRentLongTermFeatures_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the unknown Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  History of rental properties viewed by the unknown Zillow user with the most recent views first  */
    viewHistory?: Maybe<Array<GuidUpsForRentLongTermFeatures_ViewHistoryRecord>>;
};

/**  Histogram fields/feature group computed for ZUIDs and GUIDs for long_term/zillow_for_rent_histograms feature group  */
export type GuidUpsForRentLongTermFeatures_HistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Internal representation for more granular city allocation  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  Rental price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a zillow property was viewed, and for how long it was viewed, by a user.  */
export type GuidUpsForRentLongTermFeatures_ViewHistoryRecord = {
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
    /**  ZPID - Unique identifier for a property viewed by a user.  */
    zpid?: Maybe<Scalars['String']['output']>;
};

/**
 *  Histograms generated for GUID-identified Zillow users in the context of For Rent properties and near-realtime
 * *  histogram computation (RUFUS).
 */
export type GuidUpsForRentRealTimeHistograms = {
    /**  GUID - the devide ID that uniquely identifies an unknown user interacting with Zillow  */
    guid: Scalars['String']['output'];
    /**  Histograms calculated as part of the For Rent Long Term experience  */
    histograms?: Maybe<GuidUpsForRentRealTimeHistograms_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the unknown Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  History of rental properties viewed by the unknown Zillow user with the most recent views first  */
    viewHistory?: Maybe<Array<GuidUpsForRentRealTimeHistograms_ViewHistoryRecord>>;
};

/**  Record contains realtime time-decayed histogram fields based on rental properties a user has viewed on site.  */
export type GuidUpsForRentRealTimeHistograms_HistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Internal representation for more granular city allocation  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies whether the land is vacant or not  */
    isVacantLand?: Maybe<Scalars['JSON']['output']>;
    /**  Rental price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a zillow property was viewed, and for how long it was viewed, by a user.  */
export type GuidUpsForRentRealTimeHistograms_ViewHistoryRecord = {
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
    /**  ZPID - Unique identifier for a property viewed by a user.  */
    zpid?: Maybe<Scalars['String']['output']>;
};

/**
 *  Contains embedding representation generated by AI models for
 * search features filtered by logged in Zillow Users
 */
export type GuidUpsForSaleBatchOnlyEmbeddings = {
    /**  Embedding representation of a user  */
    embedding?: Maybe<Array<Scalars['Float']['output']>>;
    /**  GUID - the devide ID that uniquely identifies unknown Zillow users  */
    guid: Scalars['String']['output'];
    /**  Metadata of producing entity  */
    version?: Maybe<Scalars['String']['output']>;
};

/**
 *  Default Experience feature group for RelevanceMLBatchOnly containing histograms generated by AI models for
 * search features filtered by Zillow Users who are not logged in
 */
export type GuidUpsForSaleBatchOnlyHistograms = {
    /**  GUID - the devide ID that uniquely identifies unknown Zillow users  */
    guid: Scalars['String']['output'];
    /**  Record containing computed histogram features for a user  */
    histograms?: Maybe<GuidUpsForSaleBatchOnlyHistograms_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
};

/**  Histogram fields/feature group computed for ZUIDs and GUIDs as part of the default relevanceMLBatchOnly UPS experience  */
export type GuidUpsForSaleBatchOnlyHistograms_HistogramRecord = {
    /**  TODO  */
    boroughRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    cityDaysCount?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    cityDaysDiff?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    geohash5?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    geohash5Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    neighborhoodRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    newConstruction?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    priceDaysCount?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    priceDaysDiff?: Maybe<Scalars['JSON']['output']>;
    /**  Histogram of school district ids that reflect the school district preference per user  */
    schoolDistrictIds?: Maybe<Scalars['JSON']['output']>;
};

/**  long_term/zillow_for_sale_histograms feature group for GUIDs, ups-fs-longterm-gh  */
export type GuidUpsForSaleLongTermFeatures = {
    /**  GUID - the devide ID that uniquely identifies unknown Zillow users  */
    guid: Scalars['String']['output'];
    /**  Record containing computed histogram features for a user  */
    histograms?: Maybe<GuidUpsForSaleLongTermFeatures_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  History of properties viewed by the unknown Zillow user with the most recent views first  */
    viewHistory?: Maybe<Array<GuidUpsForSaleLongTermFeatures_ViewHistoryRecord>>;
};

/**  Histogram fields/feature group computed for ZUIDs and GUIDs for long_term/zillow_for_sale_histograms feature group  */
export type GuidUpsForSaleLongTermFeatures_HistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  RegionID of the borough, PDA data  */
    boroughRegionId?: Maybe<Scalars['JSON']['output']>;
    /**
     *  the number of days a user had actions on each city and normalized by the total number of active
     * days
     */
    cityDaysCount?: Maybe<Scalars['JSON']['output']>;
    /**
     *  the days difference between a user's latest interaction on a city and the current date
     * and subtracted by the min of days difference.
     */
    cityDaysDiff?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies cities of the properties viewed  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  5 letter/digit string geohash of the geo location of the property, PDA data  */
    geohash5?: Maybe<Scalars['JSON']['output']>;
    /**  geohash5 of the neighborhood, PDA data  */
    geohash5Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  was the property vacant  */
    isVacant?: Maybe<Scalars['JSON']['output']>;
    /**  RegionID of the neighborhood, PDA data  */
    neighborhoodRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Boolean histogram for whether the property is a new construction  */
    newConstruction?: Maybe<Scalars['JSON']['output']>;
    /**  Home price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**
     *  the number of days a user had actions on each price range and normalized by the total number of active
     * days
     */
    priceDaysCount?: Maybe<Scalars['JSON']['output']>;
    /**
     *  the days difference between a user's latest interaction on a price range and the current date
     * and subtracted by the min of days difference.
     */
    priceDaysDiff?: Maybe<Scalars['JSON']['output']>;
    /**  distribution of school districts associated with the viewed neighborhoods  */
    schoolDistrictIds?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a zillow property was viewed, and for how long it was viewed, by a user.  */
export type GuidUpsForSaleLongTermFeatures_ViewHistoryRecord = {
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
    /**  ZPID - Unique identifier for a property viewed by a user.  */
    zpid?: Maybe<Scalars['String']['output']>;
};

/**
 *  Default Experience feature group for RelevanceML containing histograms generated by AI models for search
 * features filtered by Zillow Users who are not logged in
 */
export type GuidUpsForSaleRealTimeHistograms = {
    /**  GUID - the devide ID that uniquely identifies unknown Zillow users  */
    guid: Scalars['String']['output'];
    /**  Record containing computed histogram features for a user  */
    histograms?: Maybe<GuidUpsForSaleRealTimeHistograms_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  History of properties viewed by the unknown Zillow user with the most recent views first  */
    viewHistory?: Maybe<Array<GuidUpsForSaleRealTimeHistograms_ViewHistoryRecord>>;
};

/**  Histogram fields/feature group computed for ZUIDs and GUIDs as part of the default relevanceML UPS experience  */
export type GuidUpsForSaleRealTimeHistograms_HistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies cities of the properties viewed  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  Boolean histogram for whether the property is a new construction  */
    newConstruction?: Maybe<Scalars['JSON']['output']>;
    /**  Home price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies zipcode region id of the properties viewed  */
    zipcodeId?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a zillow property was viewed, and for how long it was viewed, by a user.  */
export type GuidUpsForSaleRealTimeHistograms_ViewHistoryRecord = {
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
    /**  ZPID - Unique identifier for a property viewed by a user.  */
    zpid?: Maybe<Scalars['String']['output']>;
};

/**  Default Search feature group for GUID  */
export type GuidUpsSavedSearchRealTimeFeatures = {
    /**  GUID - the devide ID that uniquely identifies unknown Zillow users  */
    guid: Scalars['String']['output'];
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  Record containing computed search features for a user  */
    recentSearches?: Maybe<Array<GuidUpsSavedSearchRealTimeFeatures_SearchRecord>>;
};

/**  History of search related features computed for ZUIDs and GUIDs  */
export type GuidUpsSavedSearchRealTimeFeatures_SearchRecord = {
    /**  timestamp when search event happens  */
    searchEventTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  contains raw UESV2 search filters where the values of filters are non-null, non-default  */
    searchFilters?: Maybe<GuidUpsSavedSearchRealTimeFeatures_UpsSearchFiltersSchema>;
};

/**  this block will provide key search filter metadata  */
export type GuidUpsSavedSearchRealTimeFeatures_UpsSearchFiltersSchema = {
    /**  true if has air conditioning  */
    acInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is accepting backup offers  */
    acceptingBackupOfferInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Represents the credit score for the affordability monthly cost calculation  */
    affordabilityCreditScoreTxt?: Maybe<Scalars['String']['output']>;
    /**  customer can select a down payment to calculate monthly cost  */
    affordabilityDownPaymentNb?: Maybe<Scalars['String']['output']>;
    /**  customer can select monthly cost to filter listings  */
    affordabilityFilterTxt?: Maybe<Scalars['String']['output']>;
    /**  Represents the interest rate for the affordability monthly cost calculation  */
    affordabilityInterestRateNb?: Maybe<Scalars['Float']['output']>;
    /**  Represents the loan term for the affordability monthly cost calculation  */
    affordabilityLoanTermNb?: Maybe<Scalars['Int']['output']>;
    /**  user identified age is 55 or higher  */
    age55PlusInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is all homes  */
    allHomesInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Rachels can indicate if they want an Apartment Community. This is different from the Home Type filter above because Apartment Communities refer specifically s to larger properties that have extra amenities and at least 50 units  */
    apartmentCommunityInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is an apartment  */
    aptInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is an apartment or a condo  */
    aptOrCondoInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is auction  */
    auctionInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Rachel can indicate if she wants a basement, with no options for finished or unfinished basements. Applies only for Rentals Search  */
    basementInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected, this displays the number of bathrooms for that search  */
    bathCntTxt?: Maybe<Scalars['String']['output']>;
    /**  if selected by the user, this displays the highest bedroom count for that search  */
    bedMaxCntTxt?: Maybe<Scalars['String']['output']>;
    /**  if selected by the user, this displays the lowest bedroom count for that search  */
    bedMinCntTxt?: Maybe<Scalars['String']['output']>;
    /**  if selected by the user, this displays the newest year build for that search  */
    builtYearMaxNb?: Maybe<Scalars['Int']['output']>;
    /**  if selected by the user, this displays the oldest year build for that search  */
    builtYearMinNb?: Maybe<Scalars['Int']['output']>;
    /**  boolean if user chose buy  */
    buyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  The filter fields which were changed in the user's most recent filter interaction. E.g. if a user enters a query for 'Seattle WA homes with 3 beds and in unit laundry', this field would be ['custom_region_ids', 'bath_cnt_txt', 'rental_in_unit_laundry_ind']. This is necessary to measure which filters are changed by users  */
    changedFilterFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  true if the filter includes charter schools  */
    charterSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  zillow identier for city included in the search  */
    cityId?: Maybe<Scalars['Int']['output']>;
    /**  this is the city name included in the search  */
    cityNm?: Maybe<Scalars['String']['output']>;
    /**  true if has a city view  */
    cityViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is coming soon  */
    comingSoonInd?: Maybe<Scalars['Boolean']['output']>;
    /**  customer can select a location from autocomplete to commute from it to filter listtings  */
    commuteAutoCompleteTxt?: Maybe<Scalars['String']['output']>;
    /**  This indicates whether the commute destination was selected from the autocomplete results or resolved by query understanding. This field is expected only when the commute destination  field is first set and not on subsequent triggers.  */
    commuteFilterSelectionTypeCd?: Maybe<Scalars['String']['output']>;
    /**  customer can enter an address to commute from it to filter listing  */
    commuteFilterTxt?: Maybe<Scalars['String']['output']>;
    /**  customer can select a max commute travel time including 60,45,30,15, or Any  */
    commuteMaxTravelTimeTxt?: Maybe<Scalars['String']['output']>;
    /**  customer can select a commute mode including car, transit, walk, bicycle  */
    commuteModeCd?: Maybe<Scalars['String']['output']>;
    /**  customer can select a commute time including rush hour, now, off-peak  */
    commuteTimeOfDayTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is a condo  */
    condoInd?: Maybe<Scalars['Boolean']['output']>;
    /**  user identified custom region populates homes within that identified region  */
    customRegionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    /**  user identified region search (used to be assocaited with cd018, customdimension018) - deprecated  */
    customRegionTxt?: Maybe<Scalars['String']['output']>;
    /**  user identified region search (used to be assocaited with cd018, customdimension018), and it can include an array of strings because multiple regions can be searched  */
    customRegionsTxt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  if selected by the user, this displays the number of days this listing has been shown on zillows website  */
    dayOnZillowNb?: Maybe<Scalars['Int']['output']>;
    /**  user identified district id populates homes within that district  */
    districtId?: Maybe<Scalars['String']['output']>;
    /**  true if the filter includes elementary schools  */
    elementarySchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if schools are allowed in the search  */
    enableSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the basement is finished  */
    finishedBasementInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is for rent  */
    forRentInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is fore sale foreclosure  */
    forclosureInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is for sale by agent  */
    fsbaInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is for sale by owner  */
    fsboInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if has a garage  */
    garageInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the ratings of the school  */
    greatSchoolsRatingTxt?: Maybe<Scalars['String']['output']>;
    /**  true if the filter includes high schools  */
    highSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the property is not in an homeowner's association  */
    hoaInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the highest homeowner's association costs allowed for that search  */
    hoaMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  Rachel can indicate whether she wants to search for homes, apartments, townhomes, or a combination of those  */
    homeTypeCd?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  indicates whether search filter housing_connector is checked  */
    housingConnectorInd?: Maybe<Scalars['Boolean']['output']>;
    /**  The unique identifier for each search box interaction. It is used to link requests within a single search box interaction to generate ML training data and produce interaction level metrics on the search box.  */
    interactionId?: Maybe<Scalars['String']['output']>;
    /**  customer inputs keywords to serach for hom. this is provided per search filter definitions: https://gitlab.zgtools.net/zillow/searchxp/search-filter-defs/-/blob/master/filter-definitions.json  */
    keywordsTxt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  True when customer selects list price to filter homes  */
    listPriceInd?: Maybe<Scalars['Boolean']['output']>;
    /**  boolean if user chose “just look around”  */
    lookAroundInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a lot of land  */
    lotLandInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the lot size ceiling for that search  */
    lotSizeSqftMaxNb?: Maybe<Scalars['Float']['output']>;
    /**  if selected by the user, this displays the lot size floor for that search (in feet)  */
    lotSizeSqftMinNb?: Maybe<Scalars['Float']['output']>;
    /**  true if is a manufactured property  */
    manufacturedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the filter includes middle schools  */
    middleSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Return listings where monthly costs fall within the minimum and maximum monthly cost ranges user has entered  */
    monthlyCostPaymentMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  Return listings where monthly costs fall within the minimum and maximum monthly cost ranges user has entered.  */
    monthlyCostPaymentMinAmt?: Maybe<Scalars['Float']['output']>;
    /**  True when customer selects monthly price to filter homes  */
    monthlyPaymentInd?: Maybe<Scalars['Boolean']['output']>;
    /**  maximum amount for the monthly payment for rent search. this is provided per search filter definitions. https://gitlab.zgtools.net/zillow/searchxp/search-filter-defs/-/blob/master/filter-definitions.json  */
    monthlyPaymentMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  minimum amount for the monthly payment for for rent search. this is provided per search filter definitions. https://gitlab.zgtools.net/zillow/searchxp/search-filter-defs/-/blob/master/filter-definitions.json  */
    monthlyPaymentMinAmt?: Maybe<Scalars['Float']['output']>;
    /**  true if is a mountain view  */
    mountainViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this is the date the user selected to move in. The standard format is yyyy-mm-dd.  */
    moveInDt?: Maybe<Scalars['String']['output']>;
    /**  true if is a multi family property  */
    multiFamilyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this is the neighborhood id included in the search  */
    neighborhoodId?: Maybe<Scalars['Int']['output']>;
    /**  this is the neighborhood name included in the search  */
    neighborhoodNm?: Maybe<Scalars['String']['output']>;
    /**  true if is new construction  */
    newConstructionInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is open houses only  */
    onlyOpenHouseInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if properties already have a price reduction  */
    onlyPriceReductionInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if properties must have a photo  */
    onlyWithPhotoInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a park view  */
    parkViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  the number of parking spots at the property (Any, 1+, 2+, 3+, 4+)  */
    parkingSpotTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is pending listings only  */
    pendingListingInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this will capture the point of interest that was either displayed to the user or was selected by the user within their search experience.  */
    poiTxt?: Maybe<Scalars['String']['output']>;
    /**  true if has a pool  */
    poolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is pre market foreclosure  */
    premarketForeclosureInd?: Maybe<Scalars['Boolean']['output']>;
    /**  represents the current value of the premarket pre-foreclosure filter for the user  */
    premarketPreforeclosureInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the price ceiling for that search (applies for for-sale properties)  */
    priceRangeMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  if selected by the user, this displays the price floor for that search (applies for for-sale properties)  */
    priceRangeMinAmt?: Maybe<Scalars['Float']['output']>;
    /**  true if the filter includes private schools  */
    privateSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the filter includes public schools  */
    publicSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  This is either 'FULLY', 'PARTIALLY' or 'FAILED'. It indicates whether the last search box query was understood fully, parts of the query was understood, or the query failed completely. It is used to measure query success rate and impact of failed searches on downstream metrics.  */
    queryResolutionStatusTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is recently sold  */
    recentlySoldInd?: Maybe<Scalars['Boolean']['output']>;
    /**  This is an array of the type (city, neighborhood, zip, borough, etc) of each region in the custom_region_ids field. This is used to measure distribution of searches and understand how user behavior changes based on region type searched (and optimize the search experience based on that)  */
    regionTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  true if rental proeprty allows large pets (dogs)  */
    rentLargePetsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property is accepting applications  */
    rentalAcceptsApplicationInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property allows cats  */
    rentalCatsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the rrental housing is connected  */
    rentalHousingConnectedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if laundry is available in unit  */
    rentalInUnitLaundryInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property is a rental income restricted listing  */
    rentalIncomeRestrictedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the rental is a multi family building  */
    rentalMultiFamilyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the rentals in the dates provided by the user are not available  */
    rentalNotAvailableInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental parking is available  */
    rentalParkingAvailableInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property allows pets (any pets - dogs or cats)  */
    rentalPetsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this is the rental availability date selected in the search  */
    rentalRequestedAvailabilityDt?: Maybe<Scalars['String']['output']>;
    /**  true if rental property allows small pets (dogs)  */
    rentalSmallPetsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  The unique identifier for each request made to the AC / QU API. It is used to join the clickstream logs to the backend logs which contain additional metadata at a request level  */
    requestId?: Maybe<Scalars['String']['output']>;
    /**  True when the search was completed and the room for rent filter was turned on.  */
    roomForRentInd?: Maybe<Scalars['Boolean']['output']>;
    /**  enrollment id is populated when a search is saved  */
    savedSearchEnrollmentId?: Maybe<Scalars['String']['output']>;
    /**  to know what type of school the user is searching for.  */
    schoolClassifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  to know what school district(s) the user is searching for  */
    schoolDistrictIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  to know what school(s) the user is searching for  */
    schoolIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  This is the method the user used to execute their search (AUTOCOMPLETE, MANUAL, RECENT, SAVED_SEARCH, SAVED_HOME, SUGGESTED, CURRENT_LOCATION, etc) It is used to measure distribution of search methods and understand how to further optimize the search experience & build models  */
    searchSelectionTypeTxt?: Maybe<Scalars['String']['output']>;
    /**  This is the type of the result which was selected by the user (ADDRESS, REGION, NATURAL, SCHOOL, BUILDING, COMMUNITY, etc). It is used to measure distribution of search types and understand how to further optimize the search experience & build models.  */
    searchTypeTxt?: Maybe<Scalars['String']['output']>;
    /**  If the search was executed via clicking a result from the search box dropdown list (autocomplete, recent, etc), then this is the index/rank (1 indexed) of the clicked suggestion. If the search was not generated from a click on one of those suggestions, then it should be null. This is necessary to measure the relevance of the autocomplete suggestions  */
    selectionIndexNb?: Maybe<Scalars['Int']['output']>;
    /**  boolean if user chose rent  */
    sellInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the property search requests that its a senior living property  */
    seniorLivingInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if added by the user this is field for extra keywords for the search  */
    seoFieldTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is a single family home  */
    singleFamilyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the property is a 1 story  */
    singleStoryInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the square footage celing for that search  */
    sqftMaxNb?: Maybe<Scalars['Int']['output']>;
    /**  if selected by the user, this displays the square footage floor for that search  */
    sqftMinNb?: Maybe<Scalars['Int']['output']>;
    /**  this is the state name included in the search  */
    stateCd?: Maybe<Scalars['String']['output']>;
    /**  zillow identier for state included in the search  */
    stateId?: Maybe<Scalars['Int']['output']>;
    /**  true if 3d tours are available for the property  */
    tour3dInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a townhouse  */
    townhouseInd?: Maybe<Scalars['Boolean']['output']>;
    /**  This is the understood form of the user's query and is used to know what was the actual search result that the user ended up with after their query  */
    understoodQueryTxt?: Maybe<Scalars['String']['output']>;
    /**  true if the basement is unfinished  */
    unfinishedBasementInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if unrated schools are allowed in the search  */
    unratedSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  the array of words the user typed out in the search field  */
    userSearchTermsTxt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  This is what the user typed in the commute destination field before selecting an autocomplete suggestion or hitting the search button. This field is expected only when the commute destination field is first set and not on subsequent triggers  */
    userTypedCommuteFilterTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is a water view  */
    waterViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a waterfront property  */
    waterfrontInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is zillow owned  */
    zillowOwnedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this is the zip code included in the search  */
    zipCd?: Maybe<Scalars['String']['output']>;
};

/**  Default Search feature group for GUID  */
export type GuidUpsSearchRealTimeFeatures = {
    /**  GUID - the devide ID that uniquely identifies unknown Zillow users  */
    guid: Scalars['String']['output'];
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  Record containing computed search features for a user  */
    recentSearches?: Maybe<Array<GuidUpsSearchRealTimeFeatures_SearchRecord>>;
};

/**  History of search related features computed for ZUIDs and GUIDs  */
export type GuidUpsSearchRealTimeFeatures_SearchRecord = {
    /**  timestamp when search event happens  */
    searchEventTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  contains raw UESV2 search filters where the values of filters are non-null, non-default  */
    searchFilters?: Maybe<GuidUpsSearchRealTimeFeatures_UpsSearchFiltersSchema>;
};

/**  this block will provide key search filter metadata  */
export type GuidUpsSearchRealTimeFeatures_UpsSearchFiltersSchema = {
    /**  true if has air conditioning  */
    acInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is accepting backup offers  */
    acceptingBackupOfferInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Represents the credit score for the affordability monthly cost calculation  */
    affordabilityCreditScoreTxt?: Maybe<Scalars['String']['output']>;
    /**  customer can select a down payment to calculate monthly cost  */
    affordabilityDownPaymentNb?: Maybe<Scalars['String']['output']>;
    /**  customer can select monthly cost to filter listings  */
    affordabilityFilterTxt?: Maybe<Scalars['String']['output']>;
    /**  Represents the interest rate for the affordability monthly cost calculation  */
    affordabilityInterestRateNb?: Maybe<Scalars['Float']['output']>;
    /**  Represents the loan term for the affordability monthly cost calculation  */
    affordabilityLoanTermNb?: Maybe<Scalars['Int']['output']>;
    /**  user identified age is 55 or higher  */
    age55PlusInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is all homes  */
    allHomesInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Rachels can indicate if they want an Apartment Community. This is different from the Home Type filter above because Apartment Communities refer specifically s to larger properties that have extra amenities and at least 50 units  */
    apartmentCommunityInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is an apartment  */
    aptInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is an apartment or a condo  */
    aptOrCondoInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is auction  */
    auctionInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Rachel can indicate if she wants a basement, with no options for finished or unfinished basements. Applies only for Rentals Search  */
    basementInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected, this displays the number of bathrooms for that search  */
    bathCntTxt?: Maybe<Scalars['String']['output']>;
    /**  if selected by the user, this displays the highest bedroom count for that search  */
    bedMaxCntTxt?: Maybe<Scalars['String']['output']>;
    /**  if selected by the user, this displays the lowest bedroom count for that search  */
    bedMinCntTxt?: Maybe<Scalars['String']['output']>;
    /**  if selected by the user, this displays the newest year build for that search  */
    builtYearMaxNb?: Maybe<Scalars['Int']['output']>;
    /**  if selected by the user, this displays the oldest year build for that search  */
    builtYearMinNb?: Maybe<Scalars['Int']['output']>;
    /**  boolean if user chose buy  */
    buyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  The filter fields which were changed in the user's most recent filter interaction. E.g. if a user enters a query for 'Seattle WA homes with 3 beds and in unit laundry', this field would be ['custom_region_ids', 'bath_cnt_txt', 'rental_in_unit_laundry_ind']. This is necessary to measure which filters are changed by users  */
    changedFilterFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  true if the filter includes charter schools  */
    charterSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  zillow identier for city included in the search  */
    cityId?: Maybe<Scalars['Int']['output']>;
    /**  this is the city name included in the search  */
    cityNm?: Maybe<Scalars['String']['output']>;
    /**  true if has a city view  */
    cityViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is coming soon  */
    comingSoonInd?: Maybe<Scalars['Boolean']['output']>;
    /**  customer can select a location from autocomplete to commute from it to filter listtings  */
    commuteAutoCompleteTxt?: Maybe<Scalars['String']['output']>;
    /**  This indicates whether the commute destination was selected from the autocomplete results or resolved by query understanding. This field is expected only when the commute destination  field is first set and not on subsequent triggers.  */
    commuteFilterSelectionTypeCd?: Maybe<Scalars['String']['output']>;
    /**  customer can enter an address to commute from it to filter listing  */
    commuteFilterTxt?: Maybe<Scalars['String']['output']>;
    /**  customer can select a max commute travel time including 60,45,30,15, or Any  */
    commuteMaxTravelTimeTxt?: Maybe<Scalars['String']['output']>;
    /**  customer can select a commute mode including car, transit, walk, bicycle  */
    commuteModeCd?: Maybe<Scalars['String']['output']>;
    /**  customer can select a commute time including rush hour, now, off-peak  */
    commuteTimeOfDayTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is a condo  */
    condoInd?: Maybe<Scalars['Boolean']['output']>;
    /**  user identified custom region populates homes within that identified region  */
    customRegionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    /**  user identified region search (used to be assocaited with cd018, customdimension018) - deprecated  */
    customRegionTxt?: Maybe<Scalars['String']['output']>;
    /**  user identified region search (used to be assocaited with cd018, customdimension018), and it can include an array of strings because multiple regions can be searched  */
    customRegionsTxt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  if selected by the user, this displays the number of days this listing has been shown on zillows website  */
    dayOnZillowNb?: Maybe<Scalars['Int']['output']>;
    /**  user identified district id populates homes within that district  */
    districtId?: Maybe<Scalars['String']['output']>;
    /**  true if the filter includes elementary schools  */
    elementarySchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if schools are allowed in the search  */
    enableSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the basement is finished  */
    finishedBasementInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is for rent  */
    forRentInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is fore sale foreclosure  */
    forclosureInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is for sale by agent  */
    fsbaInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is for sale by owner  */
    fsboInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if has a garage  */
    garageInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the ratings of the school  */
    greatSchoolsRatingTxt?: Maybe<Scalars['String']['output']>;
    /**  true if the filter includes high schools  */
    highSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the property is not in an homeowner's association  */
    hoaInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the highest homeowner's association costs allowed for that search  */
    hoaMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  Rachel can indicate whether she wants to search for homes, apartments, townhomes, or a combination of those  */
    homeTypeCd?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  indicates whether search filter housing_connector is checked  */
    housingConnectorInd?: Maybe<Scalars['Boolean']['output']>;
    /**  The unique identifier for each search box interaction. It is used to link requests within a single search box interaction to generate ML training data and produce interaction level metrics on the search box.  */
    interactionId?: Maybe<Scalars['String']['output']>;
    /**  customer inputs keywords to serach for hom. this is provided per search filter definitions: https://gitlab.zgtools.net/zillow/searchxp/search-filter-defs/-/blob/master/filter-definitions.json  */
    keywordsTxt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  True when customer selects list price to filter homes  */
    listPriceInd?: Maybe<Scalars['Boolean']['output']>;
    /**  boolean if user chose “just look around”  */
    lookAroundInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a lot of land  */
    lotLandInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the lot size ceiling for that search  */
    lotSizeSqftMaxNb?: Maybe<Scalars['Float']['output']>;
    /**  if selected by the user, this displays the lot size floor for that search (in feet)  */
    lotSizeSqftMinNb?: Maybe<Scalars['Float']['output']>;
    /**  true if is a manufactured property  */
    manufacturedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the filter includes middle schools  */
    middleSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Return listings where monthly costs fall within the minimum and maximum monthly cost ranges user has entered  */
    monthlyCostPaymentMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  Return listings where monthly costs fall within the minimum and maximum monthly cost ranges user has entered.  */
    monthlyCostPaymentMinAmt?: Maybe<Scalars['Float']['output']>;
    /**  True when customer selects monthly price to filter homes  */
    monthlyPaymentInd?: Maybe<Scalars['Boolean']['output']>;
    /**  maximum amount for the monthly payment for rent search. this is provided per search filter definitions. https://gitlab.zgtools.net/zillow/searchxp/search-filter-defs/-/blob/master/filter-definitions.json  */
    monthlyPaymentMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  minimum amount for the monthly payment for for rent search. this is provided per search filter definitions. https://gitlab.zgtools.net/zillow/searchxp/search-filter-defs/-/blob/master/filter-definitions.json  */
    monthlyPaymentMinAmt?: Maybe<Scalars['Float']['output']>;
    /**  true if is a mountain view  */
    mountainViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this is the date the user selected to move in. The standard format is yyyy-mm-dd.  */
    moveInDt?: Maybe<Scalars['String']['output']>;
    /**  true if is a multi family property  */
    multiFamilyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this is the neighborhood id included in the search  */
    neighborhoodId?: Maybe<Scalars['Int']['output']>;
    /**  this is the neighborhood name included in the search  */
    neighborhoodNm?: Maybe<Scalars['String']['output']>;
    /**  true if is new construction  */
    newConstructionInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is open houses only  */
    onlyOpenHouseInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if properties already have a price reduction  */
    onlyPriceReductionInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if properties must have a photo  */
    onlyWithPhotoInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a park view  */
    parkViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  the number of parking spots at the property (Any, 1+, 2+, 3+, 4+)  */
    parkingSpotTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is pending listings only  */
    pendingListingInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this will capture the point of interest that was either displayed to the user or was selected by the user within their search experience.  */
    poiTxt?: Maybe<Scalars['String']['output']>;
    /**  true if has a pool  */
    poolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is pre market foreclosure  */
    premarketForeclosureInd?: Maybe<Scalars['Boolean']['output']>;
    /**  represents the current value of the premarket pre-foreclosure filter for the user  */
    premarketPreforeclosureInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the price ceiling for that search (applies for for-sale properties)  */
    priceRangeMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  if selected by the user, this displays the price floor for that search (applies for for-sale properties)  */
    priceRangeMinAmt?: Maybe<Scalars['Float']['output']>;
    /**  true if the filter includes private schools  */
    privateSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the filter includes public schools  */
    publicSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  This is either 'FULLY', 'PARTIALLY' or 'FAILED'. It indicates whether the last search box query was understood fully, parts of the query was understood, or the query failed completely. It is used to measure query success rate and impact of failed searches on downstream metrics.  */
    queryResolutionStatusTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is recently sold  */
    recentlySoldInd?: Maybe<Scalars['Boolean']['output']>;
    /**  This is an array of the type (city, neighborhood, zip, borough, etc) of each region in the custom_region_ids field. This is used to measure distribution of searches and understand how user behavior changes based on region type searched (and optimize the search experience based on that)  */
    regionTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  true if rental proeprty allows large pets (dogs)  */
    rentLargePetsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property is accepting applications  */
    rentalAcceptsApplicationInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property allows cats  */
    rentalCatsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the rrental housing is connected  */
    rentalHousingConnectedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if laundry is available in unit  */
    rentalInUnitLaundryInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property is a rental income restricted listing  */
    rentalIncomeRestrictedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the rental is a multi family building  */
    rentalMultiFamilyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the rentals in the dates provided by the user are not available  */
    rentalNotAvailableInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental parking is available  */
    rentalParkingAvailableInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property allows pets (any pets - dogs or cats)  */
    rentalPetsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this is the rental availability date selected in the search  */
    rentalRequestedAvailabilityDt?: Maybe<Scalars['String']['output']>;
    /**  true if rental property allows small pets (dogs)  */
    rentalSmallPetsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  The unique identifier for each request made to the AC / QU API. It is used to join the clickstream logs to the backend logs which contain additional metadata at a request level  */
    requestId?: Maybe<Scalars['String']['output']>;
    /**  True when the search was completed and the room for rent filter was turned on.  */
    roomForRentInd?: Maybe<Scalars['Boolean']['output']>;
    /**  enrollment id is populated when a search is saved  */
    savedSearchEnrollmentId?: Maybe<Scalars['String']['output']>;
    /**  to know what type of school the user is searching for.  */
    schoolClassifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  to know what school district(s) the user is searching for  */
    schoolDistrictIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  to know what school(s) the user is searching for  */
    schoolIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  This is the method the user used to execute their search (AUTOCOMPLETE, MANUAL, RECENT, SAVED_SEARCH, SAVED_HOME, SUGGESTED, CURRENT_LOCATION, etc) It is used to measure distribution of search methods and understand how to further optimize the search experience & build models  */
    searchSelectionTypeTxt?: Maybe<Scalars['String']['output']>;
    /**  This is the type of the result which was selected by the user (ADDRESS, REGION, NATURAL, SCHOOL, BUILDING, COMMUNITY, etc). It is used to measure distribution of search types and understand how to further optimize the search experience & build models.  */
    searchTypeTxt?: Maybe<Scalars['String']['output']>;
    /**  If the search was executed via clicking a result from the search box dropdown list (autocomplete, recent, etc), then this is the index/rank (1 indexed) of the clicked suggestion. If the search was not generated from a click on one of those suggestions, then it should be null. This is necessary to measure the relevance of the autocomplete suggestions  */
    selectionIndexNb?: Maybe<Scalars['Int']['output']>;
    /**  boolean if user chose rent  */
    sellInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the property search requests that its a senior living property  */
    seniorLivingInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if added by the user this is field for extra keywords for the search  */
    seoFieldTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is a single family home  */
    singleFamilyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the property is a 1 story  */
    singleStoryInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the square footage celing for that search  */
    sqftMaxNb?: Maybe<Scalars['Int']['output']>;
    /**  if selected by the user, this displays the square footage floor for that search  */
    sqftMinNb?: Maybe<Scalars['Int']['output']>;
    /**  this is the state name included in the search  */
    stateCd?: Maybe<Scalars['String']['output']>;
    /**  zillow identier for state included in the search  */
    stateId?: Maybe<Scalars['Int']['output']>;
    /**  true if 3d tours are available for the property  */
    tour3dInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a townhouse  */
    townhouseInd?: Maybe<Scalars['Boolean']['output']>;
    /**  This is the understood form of the user's query and is used to know what was the actual search result that the user ended up with after their query  */
    understoodQueryTxt?: Maybe<Scalars['String']['output']>;
    /**  true if the basement is unfinished  */
    unfinishedBasementInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if unrated schools are allowed in the search  */
    unratedSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  the array of words the user typed out in the search field  */
    userSearchTermsTxt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  This is what the user typed in the commute destination field before selecting an autocomplete suggestion or hitting the search button. This field is expected only when the commute destination field is first set and not on subsequent triggers  */
    userTypedCommuteFilterTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is a water view  */
    waterViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a waterfront property  */
    waterfrontInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is zillow owned  */
    zillowOwnedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this is the zip code included in the search  */
    zipCd?: Maybe<Scalars['String']['output']>;
};

/** Housing Connector URL link and test. If mobile = true, then the link can also be shown to mobile users */
export type HCBuildingLink = {
    mobile?: Maybe<Scalars['Boolean']['output']>;
    path?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
};

export type HasBuyerAgentStatus = 'NO' | 'UNSPECIFIED' | 'YES';

export type HdpMapSearchMapItemType = 'Building' | 'Community' | 'Property';

/** An object representing the result of a map search. Includes access to the full underlying Property object. */
export type HdpMapSearchResult = {
    /** How many properties are represented by this result */
    count?: Maybe<Scalars['Int']['output']>;
    /** The property referenced by this result. Or in the case of a grouped result, the first property. */
    property?: Maybe<Property>;
    /** The homeStatus for this result */
    resultStatus?: Maybe<HomeStatus>;
    resultType?: Maybe<HdpMapSearchMapItemType>;
};

export type HeatingSourceType =
    | 'Electric'
    | 'Gas'
    | 'HeatPump'
    | 'None'
    | 'Oil'
    | 'Other'
    | 'PropaneButane'
    | 'Solar'
    | 'Unknown';

export type HiddenHome = {
    /**  the hidden time of the property  */
    hiddenDateTime?: Maybe<Scalars['DateTime']['output']>;
    /**  property information, retrieved from property-search-lookup subgraph  */
    property?: Maybe<PropertyResult>;
    /**  property id  */
    propertyId: Scalars['ID']['output'];
    /**  the type of property id  */
    propertyIdType: PropertyIdType;
};

export type HiddenHomeInput = {
    /**  property id  */
    propertyId: Scalars['ID']['input'];
    /**  the type of property id  */
    propertyIdType: PropertyIdType;
};

export type HighResPhoto = RichMediaPhoto & {
    /** Alt text for the photo */
    alt: Scalars['String']['output'];
    /** Photo ID or key */
    id: Scalars['String']['output'];
    /** Is photo chosen as hero photo by the agent for display on the SDP */
    isHeroPhoto: Scalars['Boolean']['output'];
    /** Is photo an interior photo */
    isInteriorPhoto?: Maybe<Scalars['Boolean']['output']>;
    /** Is photo showcased by the agent for display on the SDP */
    isShowcased: Scalars['Boolean']['output'];
    /** Responsive photo URLs */
    mixedSources: PhotoMixedSources;
};

export type Highlight = {
    /** The information of the agent who submitted the highlight. */
    agent?: Maybe<HighlightAgent>;
    /** Text submitted by agent. */
    content: Scalars['String']['output'];
    /** Date of highlight submission. */
    date: Scalars['DateTime']['output'];
    /** ID of the highlight. */
    id?: Maybe<Scalars['Int']['output']>;
    /** Moderation status. */
    status: Scalars['String']['output'];
};

export type HighlightAgent = {
    /** Name of the agent. */
    name: Scalars['String']['output'];
    /** URL to a photo of the agent. */
    photoUrl: Scalars['String']['output'];
    /** URL to the profile page of the agent. */
    profileUrl: Scalars['String']['output'];
    /** Title of the agent. */
    title: Scalars['String']['output'];
};

export type HighlightTag = {
    /** TODO: SS-4856 - Add logic for icon and color */
    color?: Maybe<Scalars['String']['output']>;
    /** TODO: SS-4856 - Add logic for icon and color */
    icon?: Maybe<Scalars['String']['output']>;
    /** The type of the tag */
    name?: Maybe<HighlightTagType>;
};

export type HighlightTagType = 'SHOWCASE' | 'UNKNOWN';

/** An object containing the holding cost breakdown */
export type HoldingCosts = {
    costBreakdown?: Maybe<Array<Maybe<CostItem>>>;
    numDaysToClose?: Maybe<Scalars['Int']['output']>;
};

export type HomeCard = {
    bathrooms?: Maybe<Scalars['Int']['output']>;
    bedrooms?: Maybe<Scalars['Int']['output']>;
    currency?: Maybe<Scalars['String']['output']>;
    displayIconType?: Maybe<Scalars['String']['output']>;
    hdpUrl?: Maybe<Scalars['String']['output']>;
    homeInfo?: Maybe<Scalars['String']['output']>;
    listingMetadata?: Maybe<listingMetadata>;
    livingArea?: Maybe<Scalars['Int']['output']>;
    photo?: Maybe<Photo>;
    price?: Maybe<Scalars['Int']['output']>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    zpid?: Maybe<Scalars['ID']['output']>;
};

/** The home evaluation appointment associated with the provided offer request id */
export type HomeEvaluationAppointment = {
    endTime?: Maybe<Scalars['DateTime']['output']>;
    startTime?: Maybe<Scalars['DateTime']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    timezone?: Maybe<Scalars['String']['output']>;
};

export type HomeFactsComparisonData = {
    /** Other Facts of the property */
    otherFacts?: Maybe<Array<Maybe<HomeFactsComparisonDataItem>>>;
    /** Top Facts of the property */
    topFacts?: Maybe<Array<Maybe<HomeFactsComparisonDataItem>>>;
};

export type HomeFactsComparisonDataItem = {
    label?: Maybe<Scalars['String']['output']>;
    publicValue?: Maybe<Scalars['String']['output']>;
    zillowValue?: Maybe<Scalars['String']['output']>;
};

export type HomeFactsType = {
    aboveFactsAndFeaturesCategories?: Maybe<Array<Maybe<CategoryType>>>;
    atAGlanceFacts?: Maybe<Array<Maybe<FactType>>>;
    categoryDetails?: Maybe<Array<Maybe<CategoryGroupType>>>;
};

export type HomeInsights = {
    /** All the home insights for each treatment */
    insights?: Maybe<Array<Insights>>;
};

export type HomeLoansDashboard = {
    personalizedNextSteps: ZHLPersonalizedNextSteps;
};

export type HomeLoansDashboardpersonalizedNextStepsArgs = {
    version?: InputMaybe<ZHLPersonalizedNextStepsVersion>;
    zhlLoanId: Scalars['ID']['input'];
};

/** HomeLoans tab internal route */
export type HomeLoansRoute = INativeIOSDestination & {
    attributions: Array<AttributionEntry>;
    guid: Scalars['String']['output'];
    zpid: Scalars['String']['output'];
    zuid?: Maybe<Scalars['String']['output']>;
};

export type HomeOwnerValuation = {
    /** @deprecated Deprecated with ZO wind down */
    cashOffer?: Maybe<CashOffer>;
    zpid?: Maybe<Scalars['Int']['output']>;
};

/** List of recommended homes for logged in and anonymous users */
export type HomeRecommendation = {
    /** Home recommendation data from Home Recommendation Service that blends buildings and properties */
    blendedRecs?: Maybe<Array<Maybe<BlendedRecommendation>>>;
    /** Sub title for Home Recommendation react component */
    displayLong?: Maybe<Scalars['String']['output']>;
    /** Title for Home Recommendation react component */
    displayShort?: Maybe<Scalars['String']['output']>;
    /**
     * Home recommendation data from Home Recommendation Service
     * @deprecated Use blendedRecs instead to gain support for both properties and buildings
     */
    recs: Array<Recommendation>;
};

export type HomeRecommendationIdType = 'LOTID' | 'ZPID';

export type HomeStatus =
    | 'FORECLOSED'
    | 'FOR_RENT'
    | 'FOR_SALE'
    | 'MMM'
    | 'OTHER'
    | 'PENDING'
    | 'PRE_FORECLOSURE'
    | 'RECENTLY_SOLD'
    | 'SOLD'
    | 'STATUS_UNKNOWN';

export type HomeStatusType =
    | 'AUCTION'
    | 'COMING_SOON'
    | 'FORECLOSED'
    | 'FORECLOSURE'
    | 'FOR_RENT'
    | 'FSBA'
    | 'FSBO'
    | 'NEW_CONSTRUCTION'
    | 'NEW_CONSTRUCTION_LOT'
    | 'PREFORECLOSURE'
    | 'RECENTLY_SOLD'
    | 'ZESTIMATE';

export type HomeTourHighlights = {
    /** Highlights approved by moderation. */
    approved: Array<Maybe<Highlight>>;
    /** Highlight submitted by the current user. */
    user?: Maybe<Highlight>;
};

/**
 * The HomeType, ContactFormPlatform, and HomeStatus enum must remain in sync with the enums of the same name in GDP
 * https://gitlab.zgtools.net/zillow-offers/orca/registrars/zg-graph-schemas/-/blob/master/schemas/gdp.graphql#L2685
 *
 * Read more: https://www.apollographql.com/docs/federation/v1/value-types/
 */
export type HomeType =
    | 'APARTMENT'
    | 'CONDO'
    | 'HOME_TYPE_UNKNOWN'
    | 'LOT'
    | 'MANUFACTURED'
    | 'MULTI_FAMILY'
    | 'SINGLE_FAMILY'
    | 'TOWNHOUSE';

export type HomeValuation = {
    /** zestimate-neuralnet comps, data source - ODP */
    comparables?: Maybe<Comparables>;
    /**
     * Show whether cash offer is available
     * @deprecated Deprecated with ZO wind down
     */
    isCashOfferAvailable?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Deprecated with ZO wind down */
    offer?: Maybe<Offer>;
    /** New model On market zestimate - ODP - valuation team */
    onMarketZestimate?: Maybe<OnMarketZestimate>;
    valuation?: Maybe<Valuation>;
    zpid?: Maybe<Scalars['Int']['output']>;
};

export type HomeValueChartMetricType =
    | 'LISTING_PRICE'
    | 'LOCAL_HOME_VALUES'
    | 'LOCAL_RENTAL_RATES'
    | 'TAX_ASSESSMENT'
    | 'TAX_PAID'
    | 'ZESTIMATE_PERCENT_CHANGE';

export type HomeValueChartRegionType = 'CITY' | 'NEIGHBORHOOD' | 'STATE' | 'ZIPCODE';

export type HomeValueChartTimePeriod = 'FIVE_YEARS' | 'ONE_YEAR' | 'TEN_YEARS';

export type HomeValueDataPoint = {
    x?: Maybe<Scalars['Float']['output']>;
    y?: Maybe<Scalars['Float']['output']>;
};

/** historical home value data */
export type HomeValueDataSeries = {
    id?: Maybe<Scalars['ID']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    points?: Maybe<Array<Maybe<HomeValueDataPoint>>>;
    regionType?: Maybe<Scalars['String']['output']>;
};

export type HomeValueMetric = {
    dataTypeId?: Maybe<Scalars['String']['output']>;
    dateEnd?: Maybe<Scalars['String']['output']>;
    metricTypeId?: Maybe<Scalars['String']['output']>;
    /** Month over month change in percentage. */
    mom?: Maybe<Scalars['Float']['output']>;
    /** Quarter over quarter change in percentage. */
    qoq?: Maybe<Scalars['Float']['output']>;
    regionId?: Maybe<Scalars['Int']['output']>;
    timePeriodTypeId?: Maybe<Scalars['String']['output']>;
    /** Current value for this metric. */
    value?: Maybe<Scalars['Float']['output']>;
    /** Year over year change in percentage. */
    yoy?: Maybe<Scalars['Float']['output']>;
};

export type HomeValueMetricsByDataType = {
    _2?: Maybe<HomeValueMetricsDetails>;
    _3?: Maybe<HomeValueMetricsDetails>;
    _9?: Maybe<HomeValueMetricsDetails>;
};

export type HomeValueMetricsDetails = {
    /**
     * Days on zillow. Median time on market(NSA).
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    averageDaysOnZillow?: Maybe<HomeValueMetric>;
    /**
     * Buy-rent breakeven horizon.
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    breakEvenHorizon?: Maybe<HomeValueMetric>;
    /**
     * Value is 0-10, 0 being seller's market and 10 being buyer's.
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    buyerSellerIndex?: Maybe<HomeValueMetric>;
    /**
     * Value is count per 10k
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    homesForeclosed?: Maybe<HomeValueMetric>;
    /** Median listing price/sqft predicted by Zillow. */
    listPerSqft?: Maybe<HomeValueMetric>;
    /** @deprecated This field was supported by the tg.HomeValues service, which is no longer in use. */
    marketHealth?: Maybe<HomeValueMetric>;
    /** Median listing price. */
    medianList?: Maybe<HomeValueMetric>;
    medianSale?: Maybe<HomeValueMetric>;
    /**
     * Negative equity. Delinquent on mortgage. Delinquent rate of homes.
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    percentDelinquent?: Maybe<HomeValueMetric>;
    /**
     * % of listings with price reductions.
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    percentPriceCut?: Maybe<HomeValueMetric>;
    /** @deprecated This field was supported by the tg.HomeValues service, which is no longer in use. */
    percentUnderwater?: Maybe<HomeValueMetric>;
    /**
     * Zillow Rent Index.
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    rentalZhvi?: Maybe<HomeValueMetric>;
    /** Zillow Home Value Index. */
    zhvi?: Maybe<HomeValueMetric>;
    /** Zillow Home Value Index forecast. */
    zhviForecast?: Maybe<HomeValueMetric>;
};

export type HomeValueParent = {
    docid?: Maybe<Scalars['Int']['output']>;
    link?: Maybe<Scalars['String']['output']>;
    shortName?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['Int']['output']>;
};

export type HomeValueRegion = {
    /**
     * Days on zillow. Median time on market(NSA).
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    averageDaysOnZillow?: Maybe<HomeValueMetric>;
    /**
     * Buy-rent breakeven horizon.
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    breakEvenHorizon?: Maybe<HomeValueMetric>;
    /**
     * Value is 0-10, 0 being seller's market and 10 being buyer's.
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    buyerSellerIndex?: Maybe<HomeValueMetric>;
    /**
     * BuyerSellerIndex Cross Time SSA.
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    buyerSellerIndexCrossTimeSsa?: Maybe<HomeValueMetric>;
    docid?: Maybe<Scalars['Int']['output']>;
    /**
     * Value is count per 10k
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    homesForeclosed?: Maybe<HomeValueMetric>;
    link?: Maybe<Scalars['String']['output']>;
    /** Median listing price/sqft predicted by Zillow. */
    listPerSqft?: Maybe<HomeValueMetric>;
    /** @deprecated This field was supported by the tg.HomeValues service, which is no longer in use. */
    marketHealth?: Maybe<HomeValueMetric>;
    /** Median listing price. */
    medianList?: Maybe<HomeValueMetric>;
    medianSale?: Maybe<HomeValueMetric>;
    /** @deprecated This field was supported by the tg.HomeValues service, which is no longer in use. */
    moreMetricsByDataType?: Maybe<HomeValueMetricsByDataType>;
    name?: Maybe<Scalars['String']['output']>;
    parent?: Maybe<HomeValueParent>;
    /**
     * Negative equity. Delinquent on mortgage. Delinquent rate of homes.
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    percentDelinquent?: Maybe<HomeValueMetric>;
    /**
     * % of listings with price reductions.
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    percentPriceCut?: Maybe<HomeValueMetric>;
    /** @deprecated This field was supported by the tg.HomeValues service, which is no longer in use. */
    percentUnderwater?: Maybe<HomeValueMetric>;
    regionTypeName?: Maybe<Scalars['String']['output']>;
    /**
     * Zillow Rent Index.
     * @deprecated This field was supported by the tg.HomeValues service, which is no longer in use.
     */
    rentalZhvi?: Maybe<HomeValueMetric>;
    shortName?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['Int']['output']>;
    /** Zillow Home Value Index. */
    zhvi?: Maybe<HomeValueMetric>;
    /** Zillow Home Value Index forecast. */
    zhviForecast?: Maybe<HomeValueMetric>;
    zindexSqFt?: Maybe<Scalars['Int']['output']>;
};

/** One point in home values time series. */
export type HomeValueTimeSeriesPoint = {
    /** Number in dollar. */
    x?: Maybe<Scalars['Float']['output']>;
    /** Epoch time. */
    y?: Maybe<Scalars['Float']['output']>;
};

export type HomeValuesDataTypeId = 'ALL' | 'CONDO' | 'SINGLE_FAMILY' | 'TRIPLEX_DUPLEX';

export type HomeValuesMetricTypeId = 'MEDIAN_LISTING_PRICE' | 'MEDIAN_SALE_PRICE';

export type HomeValuesResponse = {
    nation?: Maybe<HomeValueRegion>;
    parentRegion?: Maybe<HomeValueRegion>;
    region?: Maybe<HomeValueRegion>;
};

/** Housing Connector Info */
export type HousingConnector = {
    hcLink?: Maybe<HCBuildingLink>;
};

export type HousingConnectorType = 'EXCLUSIVE' | 'GENERAL_PUBLIC' | 'UNKNOWN';

export type HousingDeveloper = {
    description?: Maybe<Scalars['String']['output']>;
    /** Subdivision sales office information */
    salesOffice?: Maybe<SalesOffice>;
};

/** Determines when to display Housing Voucher tips and Local Content in HDP and BDP */
export type HousingVoucher = {
    localContentForRender?: Maybe<LocalVoucherContent>;
    /** Determines if listing meets voucher payment standards */
    voucherModuleDisplayEligible?: Maybe<Scalars['Boolean']['output']>;
};

export type HubBasicResourceModule = {
    analyticsTag: Scalars['String']['output'];
    ctaText?: Maybe<Scalars['String']['output']>;
    ctaUrl: Scalars['String']['output'];
    description: Scalars['String']['output'];
    progress: HubResourceStatus;
    resourceId: Scalars['Int']['output'];
    title: Scalars['String']['output'];
};

export type HubBasicStageModule = {
    description: Scalars['String']['output'];
    iconType: DetailedIconType;
    progress: HubStageProgress;
    resources: Array<HubResourceModule>;
    stageId: Scalars['Int']['output'];
    title: Scalars['String']['output'];
    type: HubStageType;
};

export type HubBulkResourceStatusInput = {
    resourceStatuses: Array<HubResourceStatusInput>;
};

/**
 * Clone existing FinanceModuleButtonStyle and deprecate that type so we can use this as a
 * generic button style type going forward
 */
export type HubButtonStyle = 'CAUTION' | 'PRIMARY' | 'SECONDARY' | 'TERTIARY' | 'TEXT_ONLY';

export type HubButtonType = 'ICON_ONLY' | 'STANDARD';

export type HubChangePlanModule = {
    confirmOption: Scalars['String']['output'];
    dismissOption: Scalars['String']['output'];
    subText: Scalars['String']['output'];
    title: Scalars['String']['output'];
};

/** Empty type to support proper type-generation on mobile */
export type HubConstellationTextAttribute = HubDynamicTextAttribute & {
    tokenIndices?: Maybe<HubTextTokenIndices>;
};

export type HubContactNavAction = HubNavAction & {
    analyticsTag?: Maybe<Scalars['String']['output']>;
    showAbad: Scalars['Boolean']['output'];
    value: Scalars['String']['output'];
};

/** Generic set of types to support arbitrarily styled text */
export type HubDynamicText = {
    text: Scalars['String']['output'];
    textAttributes: Array<HubDynamicTextAttribute>;
};

export type HubDynamicTextAttribute = {
    tokenIndices?: Maybe<HubTextTokenIndices>;
};

export type HubHighlightedModule = {
    analyticsTag: Scalars['String']['output'];
    ctaUrl: Scalars['String']['output'];
    description: Scalars['String']['output'];
    iconType: DetailedIconType;
    progressLabel?: Maybe<ProgressLabel>;
    showAbad: Scalars['Boolean']['output'];
    title: Scalars['String']['output'];
};

export type HubIconOnlyModuleButton = HubModuleButton & {
    buttonIcon?: Maybe<HubIconType>;
    navAction: HubNavAction;
};

export type HubIconType =
    | 'ASK_QUESTION_OUTLINE'
    | 'CHECKMARK_CIRCLE_OUTLINE'
    | 'DOOR_OPEN_OUTLINE'
    | 'FILE_OUTLINE'
    | 'GRADUATION_CAP_OUTLINE'
    | 'INFO_OUTLINE'
    | 'MAIL'
    | 'MAIL_OUTLINE'
    | 'MAP_OUTLINE'
    | 'MESSAGE'
    | 'MLS_OUTLINE'
    | 'PHONE'
    | 'WAITING_OUTLINE';

export type HubInProgressResourceModule = {
    analyticsTag: Scalars['String']['output'];
    ctaUrl: Scalars['String']['output'];
    description: Scalars['String']['output'];
    iconType: DetailedIconType;
    resourceId: Scalars['Int']['output'];
    showAbad: Scalars['Boolean']['output'];
    title: Scalars['String']['output'];
};

export type HubInProgressStageModule = {
    description: Scalars['String']['output'];
    iconType: DetailedIconType;
    resources: Array<HubResourceModule>;
    stageId: Scalars['Int']['output'];
    title: Scalars['String']['output'];
    type: HubStageType;
};

export type HubInfoBullet = {
    icon: HubIconType;
    text: HubDynamicText;
};

export type HubInfoBulletsList = {
    infoBullets: Array<HubInfoBullet>;
    title: Scalars['String']['output'];
};

export type HubIntroOrPlanModule = HubJourneyIntroModule | HubPlanModule;

export type HubJourneyIntroModule = {
    description: Scalars['String']['output'];
    errorMessage?: Maybe<Scalars['String']['output']>;
    options: Array<HubPlanOption>;
    title: Scalars['String']['output'];
};

/** Defines a text link */
export type HubLinkTextAttribute = HubDynamicTextAttribute & {
    isUnderlined: Scalars['Boolean']['output'];
    navAction: HubNavAction;
    tokenIndices?: Maybe<HubTextTokenIndices>;
};

export type HubModalContent = {
    body: HubModalContentBody;
    title: Scalars['String']['output'];
};

export type HubModalContentBody = HubDynamicText | HubInfoBulletsList;

export type HubModalNavAction = HubNavAction & {
    analyticsTag?: Maybe<Scalars['String']['output']>;
    content: HubModalContent;
    showAbad: Scalars['Boolean']['output'];
};

/** Interface to support UI buttons */
export type HubModuleButton = {
    navAction: HubNavAction;
};

export type HubMoveGoal = 'BUY' | 'RENT' | 'SELL';

export type HubMoveListView = {
    heading: Scalars['String']['output'];
    modules?: Maybe<Array<HubMoveListViewInfo>>;
};

export type HubMoveListViewInfo = {
    moveId: Scalars['String']['output'];
    moveName: Scalars['String']['output'];
    openTaskCount: Scalars['Int']['output'];
    openTaskDescription: Scalars['String']['output'];
};

/** This interface is intended to replace the existing FinanceNavInfo type.  Implementing types will represent different possible navigation actions */
export type HubNavAction = {
    analyticsTag?: Maybe<Scalars['String']['output']>;
    showAbad: Scalars['Boolean']['output'];
};

export type HubPlanModule = {
    changePlanModule?: Maybe<HubChangePlanModule>;
    detailsTitle: Scalars['String']['output'];
    goal: HubMoveGoal;
    overviewTitle: Scalars['String']['output'];
    planId: Scalars['Int']['output'];
    stages: Array<HubStageModule>;
};

export type HubPlanOption = {
    goal: HubMoveGoal;
    title: Scalars['String']['output'];
};

export type HubResourceModule = HubBasicResourceModule | HubInProgressResourceModule;

export type HubResourceStatus = 'COMPLETE' | 'NOT_STARTED';

export type HubResourceStatusInput = {
    resourceId: Scalars['Int']['input'];
    status: HubResourceStatus;
};

export type HubResourceStatusPayload = {
    resourceId: Scalars['Int']['output'];
    status: HubResourceStatus;
};

export type HubReviewsDisplay = {
    label: HubDynamicText;
    ratingAltText: Scalars['String']['output'];
    ratingAverage: Scalars['Float']['output'];
    ratingAverageText: Scalars['String']['output'];
};

export type HubSavedHomesNavAction = HubNavAction & {
    analyticsTag?: Maybe<Scalars['String']['output']>;
    showAbad: Scalars['Boolean']['output'];
    url: Scalars['String']['output'];
};

export type HubSignInNavAction = HubNavAction & {
    analyticsTag?: Maybe<Scalars['String']['output']>;
    showAbad: Scalars['Boolean']['output'];
};

export type HubStageModule = HubBasicStageModule | HubHighlightedModule | HubInProgressStageModule;

export type HubStageProgress = {
    numberOfCompletedResources: Scalars['Int']['output'];
    numberOfTotalResources: Scalars['Int']['output'];
};

export type HubStageType =
    | 'ALTERNATE_OPTIONS'
    | 'APPLY'
    | 'BUDGET'
    | 'DETERMINE_VALUE'
    | 'FIND'
    | 'IN_PROGRESS'
    | 'OFFER'
    | 'REVIEW_OPTIONS'
    | 'START_SEARCH';

export type HubStandardModuleButton = HubModuleButton & {
    buttonIcon?: Maybe<HubIconType>;
    buttonType: HubButtonStyle;
    navAction: HubNavAction;
    text: Scalars['String']['output'];
};

export type HubTag = {
    style: HubTagStyle;
    text: Scalars['String']['output'];
};

export type HubTagStyle = 'ERROR' | 'GRAY' | 'INFO' | 'SUCCESS' | 'WARNING';

/** Schema for a task, to be created by LOB and rendered via Illuminate UX. */
export type HubTask = {
    /** List of assignees to task */
    assignees: Array<Scalars['String']['output']>;
    /** Date task was completed, in RFC 3339 format */
    completedAt?: Maybe<Scalars['String']['output']>;
    /** Date task was created, in RFC 3339 format */
    createdAt: Scalars['String']['output'];
    /** Description of the task */
    description: Scalars['String']['output'];
    /** Date the task should be completed by, in RFC 3339 format. If null, there is no dueDate. */
    dueDate?: Maybe<Scalars['String']['output']>;
    /** Estimated amount of time for task to be completed, in minutes */
    estimatedEffortInMinutes?: Maybe<Scalars['Int']['output']>;
    /** Boolean to determine whether or not the task is archived */
    isArchived?: Maybe<Scalars['Boolean']['output']>;
    /** Line of Business logo for task */
    logo?: Maybe<HubTaskLogo>;
    /** Information necessary for displaying different types of tasks. */
    payload?: Maybe<TaskPayload>;
    /** Completion priority of task */
    priority?: Maybe<Priority>;
    /** LOB reference ID to use to link task to LOB processes */
    referenceId?: Maybe<Scalars['String']['output']>;
    /** Type of reference ID e.g. ZHLID or MoveID */
    referenceType?: Maybe<Scalars['String']['output']>;
    /** Current status of task */
    status: HubTaskStatus;
    /** Optional message to be included with the task. Details current task step */
    stepMessage?: Maybe<StepMessage>;
    taskId: Scalars['ID']['output'];
    /** Title of the task */
    title: Scalars['String']['output'];
    /** Type of task */
    type: TaskType;
    /** Date task was last updated, in RFC 3339 format */
    updatedAt?: Maybe<Scalars['String']['output']>;
    /** Information on whether task is past due or not */
    visualEscalation?: Maybe<VisualEscalation>;
};

export type HubTaskAlertType = 'ERROR' | 'INFO' | 'WARN';

export type HubTaskButtonType = 'PRIMARY_BUTTON' | 'SECONDARY_BUTTON';

export type HubTaskDetailView = {
    modules?: Maybe<Array<HubTaskDetailViewModule>>;
};

export type HubTaskDetailViewDeepLinkButtonModule = {
    buttonType: HubTaskButtonType;
    ctaUrl: Scalars['String']['output'];
    text: Scalars['String']['output'];
};

export type HubTaskDetailViewDescriptionModule = {
    description: Scalars['String']['output'];
};

export type HubTaskDetailViewHeaderModule = {
    dueDetails: HubTaskDueDetails;
    id: Scalars['ID']['output'];
    status: HubTaskStatus;
    timeToComplete: Scalars['String']['output'];
    title: Scalars['String']['output'];
};

export type HubTaskDetailViewLogoModule = {
    altText: Scalars['String']['output'];
    logoUrl: Scalars['String']['output'];
};

export type HubTaskDetailViewModule =
    | HubTaskDetailViewDeepLinkButtonModule
    | HubTaskDetailViewDescriptionModule
    | HubTaskDetailViewHeaderModule
    | HubTaskDetailViewRemotePackageButtonModule
    | HubTaskDetailViewStepMessageModule
    | HubTaskLogoModule;

export type HubTaskDetailViewRemotePackageButtonModule = {
    buttonType: HubTaskButtonType;
    remotePackageUrl: Scalars['String']['output'];
    text: Scalars['String']['output'];
};

export type HubTaskDetailViewStepMessageModule = {
    heading: Scalars['String']['output'];
    stepMessage: Scalars['String']['output'];
    type: HubTaskAlertType;
};

export type HubTaskDueDetails = {
    type?: Maybe<HubTaskDueType>;
    value?: Maybe<Scalars['String']['output']>;
};

/** Input schema for due details for task */
export type HubTaskDueDetailsInput = {
    /** Due details type (e.g. ONGOING) */
    type?: InputMaybe<HubTaskDueType>;
    /** Due details description */
    value?: InputMaybe<Scalars['String']['input']>;
};

export type HubTaskDueType = 'DATE' | 'ONGOING';

/** Input schema for creating a task */
export type HubTaskInput = {
    /** List of assignees to task */
    assignees: Array<Scalars['String']['input']>;
    /** Description of the task */
    description: Scalars['String']['input'];
    /** Date the task should be completed by, RFC 3339 format. If null, there is no dueDate. */
    dueDate?: InputMaybe<Scalars['String']['input']>;
    /** Estimated amount of time for task to be completed, in minutes */
    estimatedEffortInMinutes?: InputMaybe<Scalars['Int']['input']>;
    /** Line of Business logo for task */
    logo?: InputMaybe<HubTaskLogoInput>;
    /** Information necessary to display different types of tasks. */
    payload: TaskPayloadInput;
    /** Completion priority of task */
    priority?: InputMaybe<Priority>;
    /** LOB reference ID to use to link task to LOB processes */
    referenceId: Scalars['String']['input'];
    /** Type of reference ID e.g. ZHLID or MoveID */
    referenceType: Scalars['String']['input'];
    /** Current status of task */
    status: HubTaskStatus;
    /** Optional message to be included with the task. Details current task step */
    stepMessage?: InputMaybe<StepMessageInput>;
    /** Title of the task */
    title: Scalars['String']['input'];
    /** Type of task */
    type: TaskType;
};

export type HubTaskListView = {
    heading: Scalars['String']['output'];
    modules?: Maybe<Array<HubTaskListViewInfoModule>>;
};

export type HubTaskListViewInfoModule = {
    dueDetails: HubTaskDueDetails;
    id: Scalars['ID']['output'];
    logo: HubTaskLogoModule;
    status: HubTaskStatus;
    timeToComplete: Scalars['String']['output'];
    title: Scalars['String']['output'];
};

/** Schema for LOB Logo for task */
export type HubTaskLogo = {
    /** Alt text for Logo image, seen while mouse hovers on image */
    altText?: Maybe<Scalars['String']['output']>;
    /** Image URL for LOB logo */
    url?: Maybe<Scalars['String']['output']>;
};

/** Input schema for LOB Logo for task */
export type HubTaskLogoInput = {
    /** Alt text for Logo image, seen while mouse hovers on image */
    altText: Scalars['String']['input'];
    /** Image URL for LOB logo */
    url: Scalars['String']['input'];
};

export type HubTaskLogoModule = {
    altText: Scalars['String']['output'];
    logoUrl?: Maybe<Scalars['String']['output']>;
};

/** Input schema for searching for a task */
export type HubTaskSearchInput = {
    /** List of reference ID/reference type pairs */
    referenceIds?: InputMaybe<Array<InputMaybe<ReferenceIdsInput>>>;
    /** ZUID of the assignee */
    zuid: Scalars['ID']['input'];
};

export type HubTaskStatus =
    | 'COMPLETE'
    | 'IN_PROGRESS'
    | 'IN_REVIEW'
    | 'NEEDS_WORK'
    | 'NONE'
    | 'NOT_STARTED';

/** Input schema for updating a task */
export type HubTaskUpdateInput = {
    /** List of assignees to be added */
    assigneesToAdd?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** List of assignees to be removed */
    assigneesToRemove?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Description of the task */
    description?: InputMaybe<Scalars['String']['input']>;
    /** Date the task should be completed by, RFC 3339 format. If null, there is no dueDate. */
    dueDate?: InputMaybe<Scalars['String']['input']>;
    /** Estimated amount of time for task to be completed, in minutes */
    estimatedEffortInMinutes?: InputMaybe<Scalars['Int']['input']>;
    /** Line of Business logo for task */
    logo?: InputMaybe<HubTaskLogoInput>;
    /** Information necessary to display different types of tasks. */
    payload?: InputMaybe<TaskPayloadInput>;
    /** Completion priority of task */
    priority?: InputMaybe<Priority>;
    /** LOB reference ID to use to link task to LOB processes */
    referenceId?: InputMaybe<Scalars['String']['input']>;
    /** Type of reference ID e.g. ZHLID or MoveID */
    referenceType?: InputMaybe<Scalars['String']['input']>;
    /** Current status of task */
    status?: InputMaybe<HubTaskStatus>;
    /** Optional message to be included with the task. Details current task step */
    stepMessage?: InputMaybe<StepMessageInput>;
    /** Title of the task */
    title?: InputMaybe<Scalars['String']['input']>;
};

export type HubTextTokenIndices = {
    tokenEndIndex: Scalars['Int']['output'];
    tokenStartIndex: Scalars['Int']['output'];
};

export type HubUrlNavAction = HubNavAction & {
    analyticsTag?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use field urlExperience */
    ctaUrl: Scalars['String']['output'];
    showAbad: Scalars['Boolean']['output'];
    urlExperience: HubUrlNavExperience;
    /** @deprecated Use field urlExperience */
    useInAppBrowser: Scalars['Boolean']['output'];
};

export type HubUrlNavExperience = {
    ctaUrl: Scalars['String']['output'];
};

export type HubUrlNavInAppBrowserExperience = HubUrlNavExperience & {
    ctaUrl: Scalars['String']['output'];
};

export type HubUrlNavSystemBrowserExperience = HubUrlNavExperience & {
    authAssuranceLevel: AuthAssuranceLevel;
    ctaUrl: Scalars['String']['output'];
};

export type HubUrlNavWebViewExperience = HubUrlNavExperience & {
    ctaUrl: Scalars['String']['output'];
};

export type IAgentTourViewCTA = {
    action?: Maybe<TourViewModuleText>;
    isPrimary?: Maybe<Scalars['Boolean']['output']>;
};

export type IDOutput = {
    id: Scalars['ID']['output'];
};

export type IMX = {
    source?: Maybe<Scalars['String']['output']>;
};

/** Base interface that defines the IOS apps internal routes */
export type INativeIOSDestination = {
    attributions: Array<AttributionEntry>;
};

/** Possible internal routes that can be sent through to IOS apps */
export type IOSCTADestinations = FSHDPRoute | HomeLoansRoute | PreQualRoute | UpdatesRoute;

/** IOS Component CTA Fields */
export type IOSComponentCTA = {
    /** In app CTA routing field. Possible internal routes that could be routed to from an IOS component */
    ctaDestination?: Maybe<IOSCTADestinations>;
    /** CTA text for the button on the upsell */
    primaryCTAText?: Maybe<Scalars['String']['output']>;
    /** CTA url for webview transitions to destination */
    primaryCTAUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * Type of components supported by onsiteMessage Placement on IOS. The component
 * name must match with the name registered in CMS
 */
export type IOSSupportedComponentsType = 'IOSUpsellArrowCTACard' | 'IOSUpsellCardWrapper';

/** IOS Upsell Card with no CTA text and and arrow for CTA */
export type IOSUpsellArrowCTACard = {
    /** Body content for the upsell card  */
    bodyText?: Maybe<Scalars['String']['output']>;
    /** Contains primary CTA url OR destination for IOSUpsellArrowCard component. */
    cta?: Maybe<IOSComponentCTA>;
    /** Icon url that loads an icon asset from the DAM or s3 */
    iconUrl?: Maybe<Scalars['String']['output']>;
    /** Title text for the upsell card */
    titleText?: Maybe<Scalars['String']['output']>;
};

/** IOS Upsell Card Component Fields */
export type IOSUpsellCard = {
    /** Body content for the upsell card  */
    bodyText?: Maybe<Scalars['String']['output']>;
    /** Contains primary CTA url, text and destination for IOSUpsellCard component */
    cta?: Maybe<IOSComponentCTA>;
    /** Icon url that loads an icon asset from the DAM or s3 */
    iconUrl?: Maybe<Scalars['String']['output']>;
    /** Field for mls note text on the upsell card */
    mlsNoteText?: Maybe<Scalars['String']['output']>;
    /** Title text for the upsell card */
    titleText?: Maybe<Scalars['String']['output']>;
    /** Field for tool tip message in the upsell card */
    toolTipText?: Maybe<Scalars['String']['output']>;
    /** Field for tool tip title in the upsell card */
    toolTipTitle?: Maybe<Scalars['String']['output']>;
};

export type ITourView = {
    alerts?: Maybe<Array<TourViewAlert>>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewMetadata>;
    modules?: Maybe<Array<TourViewModule>>;
    toasts?: Maybe<Array<TourViewToast>>;
};

export type ITourViewModule = {
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
};

export type ITourViewModuleButton = {
    action?: Maybe<TourViewAction>;
    icon?: Maybe<TourViewIcon>;
    iconPosition?: Maybe<TourViewModuleButtonIconPosition>;
    label: TourViewModuleText;
    metadata?: Maybe<TourViewModuleMetadata>;
    tag?: Maybe<TourViewModuleTag>;
    type?: Maybe<TourViewModuleButtonType>;
};

export type ITourViewModuleTextAttribute = {
    tokenEndIndex: Scalars['Int']['output'];
    tokenStartIndex: Scalars['Int']['output'];
};

export type ITourViewToast = {
    appearance: TourViewToastAppearance;
    body: TourViewModuleText;
    duration: Scalars['Int']['output'];
};

export type IZHLPreApprovalSection = {
    type: ZHLPreApprovalSectionType;
    ui?: Maybe<ZHLPreApprovalSectionUI>;
};

export type IZHLTextAttributes = {
    endIndex: Scalars['Int']['output'];
    startIndex: Scalars['Int']['output'];
};

export type IcraaPageConfig = {
    appliesTo?: Maybe<Array<Maybe<RentalApplicationSection>>>;
    body?: Maybe<Array<Maybe<PageConfigBodyElement>>>;
    callToActionLabel?: Maybe<Scalars['String']['output']>;
    complianceType?: Maybe<Scalars['String']['output']>;
    finePrint?: Maybe<Scalars['String']['output']>;
    googleAnalytics?: Maybe<PageConfigGoogleAnalytics>;
    hasBeenAcceptedFor?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    header?: Maybe<Scalars['String']['output']>;
    requiredForms?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** interfaces */
export type IdBasedWithSource = {
    /** the confidence score about this id and the id's association to the primary id */
    confidence: Scalars['Float']['output'];
    createTime: Scalars['GraphQLLong']['output'];
    id: Scalars['String']['output'];
    idType: IdType;
    lastChecked: Scalars['GraphQLLong']['output'];
    /** the source of this id */
    source: Scalars['String']['output'];
};

export type IdMatchType = 'EXACT' | 'INFERRED';

/**  Id Types we support  */
export type IdType =
    | 'EZUID'
    /** guids */
    | 'GUID'
    /** Error handling, double check with Meng on idea */
    | 'UNKNOWN'
    /** We unify zuid with ezuid as they can be converted back and forth easily and store one is sufficient */
    | 'ZUID';

/** input types */
export type IdentityFilter = {
    id: Scalars['String']['input'];
    idType: IdType;
};

export type ImageFileFormat = 'PDF' | 'PNG' | 'SVG';

export type ImageSubjectType =
    | 'BIRDSEYE'
    | 'BUILDING'
    | 'DIGS'
    | 'DRIVINGDIRECTIONS'
    | 'ELEVATION'
    | 'FLOORPLAN'
    | 'GPANO'
    | 'HOMEIMPROVEMENT'
    | 'INTERIOR'
    | 'LOGO'
    | 'LOTMAP'
    | 'PANO'
    | 'UNKNOWN';

export type Imx = {
    /** What type of IMX data is localized and ready to be shown */
    imxAvailableData?: Maybe<Array<ImxAvailableData>>;
    /** Most recent revision ID */
    revisionId?: Maybe<Scalars['ID']['output']>;
    /** Viewer URL of the Integrated Media eXperience */
    viewerUrl?: Maybe<Scalars['String']['output']>;
};

export type ImxAvailableData = 'LOCALIZED_PHOTOS' | 'UNKNOWN';

export type ImxBounds = {
    /** Max x bound in real world units (meters) when 0,0 is ~center of the floor: sourced originally from IMX JSON data */
    xMax: Scalars['Float']['output'];
    /** Min x bound in real world units (meters) when 0,0 is ~center of the floor: sourced originally from IMX JSON data */
    xMin: Scalars['Float']['output'];
    /** Max y bound in real world units (meters) when 0,0 is ~center of the floor: sourced originally from IMX JSON data */
    yMax: Scalars['Float']['output'];
    /** Min y bound in real world units (meters) when 0,0 is ~center of the floor: sourced originally from IMX JSON data */
    yMin: Scalars['Float']['output'];
};

export type ImxCarouselPhoto = {
    /** High res photo representation - currently sourced from showcase model */
    highRes?: Maybe<HighResPhoto>;
    /** Minimal MLS photo representation */
    mls?: Maybe<ImxMlsPhoto>;
};

export type ImxCoordinate = {
    x: Scalars['Float']['output'];
    y: Scalars['Float']['output'];
    z: Scalars['Float']['output'];
};

export type ImxFloor = RichMediaFloor & {
    /** The starting pano ID for the floor in the 3D tour */
    entrancePanoId?: Maybe<Scalars['String']['output']>;
    /** Physical floor order (in real life) */
    floorNumber: Scalars['Int']['output'];
    /** Floor ID */
    id: Scalars['String']['output'];
    /** Whether floor has no panos associated with it */
    isPanoless: Scalars['Boolean']['output'];
    /** Floor name or label */
    name: Scalars['String']['output'];
    /** Floor plan dimensions in meters (generated from RMX floor plan data) */
    sqft?: Maybe<Scalars['Float']['output']>;
    /** Visualization ID for the floor plan */
    visualizationId: Scalars['String']['output'];
};

export type ImxMlsPhoto = {
    /** Photo key/id: sourced originally from PSL */
    id: Scalars['String']['output'];
    /** Photo url fallback: sourced originally from PSL */
    url: Scalars['String']['output'];
};

export type ImxPano = RichMediaPano & {
    /** Panos that can be navigated to from the current pano */
    destinations: Array<ImxPanoDestination>;
    /** Pano ID */
    entityId: Scalars['String']['output'];
    /** Associated floor ID */
    floorId: Scalars['String']['output'];
    /** Max fov or zoom level (in degrees): 180 for spherical panos, less for hand-held capture */
    fov: Scalars['Int']['output'];
    /** Safe default display angle (in degrees): editable via 3d tour editor */
    startAngle: Scalars['Int']['output'];
    /** Pano texture data and urls */
    textureFileUrls: ImxTextureFileUrls;
    /** Pano title or label */
    title: Scalars['String']['output'];
};

export type ImxPanoDestination = RichMediaPanoDestination & {
    /** Angle that the arrow (exit) should point to (in degrees) */
    departureAngle: Scalars['Int']['output'];
    /** Pano ID */
    destEntityId: Scalars['String']['output'];
    /** Relative angle between current pano and destination pano (in degrees). Aligns panos to same real world direction since tripod is not perfectly aligned between panos in real life. Combine this with user's current viewing angle to get direction they would face when they arrive. */
    panoRelativeAngle?: Maybe<Scalars['Float']['output']>;
    /** Pano title or label */
    title: Scalars['String']['output'];
};

export type ImxPanoLoc = {
    /** Pano location in the home layout in real world units (meters): sourced originally from IMX JSON data */
    world: Array<ImxPanoLocEntry>;
};

export type ImxPanoLocEntry = {
    /** Pano location in the home in real world units (meters): sourced originally from IMX JSON data */
    center?: Maybe<ImxWorldCoordinate>;
    /** Used to align FOV cone on floor map (in degrees): sourced originally from IMX JSON data */
    horizontalAngle: Scalars['Float']['output'];
    /** Pano position in the 3D tour order: sourced originally from IMX JSON data */
    order: Scalars['Int']['output'];
    /** Pano ID: sourced originally from IMX JSON data */
    panoId: Scalars['String']['output'];
};

export type ImxPhotoLoc = {
    /** Photo location on the floor plan image in pixel units: sourced originally from Photo Loc JSON data */
    pixel: Array<ImxPhotoLocEntry>;
};

export type ImxPhotoLocEntry = {
    /** Associated floor ID: sourced originally from Photo Loc JSON data */
    floorId: Scalars['ID']['output'];
    /** Description TODO RMXCPLW-1469: sourced originally from Photo Loc JSON data */
    horizontalFov: Scalars['Float']['output'];
    /** Photo ID: sourced originally from Photo Loc JSON data */
    photoId: Scalars['ID']['output'];
    /** Photo location on floor plan (normalized % out of) where 0,0 is top left corner: sourced originally from Photo Loc JSON data */
    position: ImxPixelCoordinate;
    /** FOV rotation angle (in degrees): sourced originally from Photo Loc JSON data */
    viewAngle: Scalars['Float']['output'];
};

export type ImxPixelCoordinate = {
    /** X value in pixels */
    x: Scalars['Float']['output'];
    /** Y value in pixels */
    y: Scalars['Float']['output'];
};

export type ImxRoom = {
    /** Associated floor ID: sourced originally from GBR-lite data. Sourced from GBR if not present in GBR-Lite data. If no value can be found, the room is filtered out. */
    floorId: Scalars['ID']['output'];
    /** Room ID: sourced originally from GBR-Lite JSON data */
    id: Scalars['ID']['output'];
    /** Room name: sourced originally from GBR-Lite JSON data */
    name: Scalars['String']['output'];
    /** All pano IDs associated with room: sourced originally from GBR-Lite JSON data */
    panoIds: Array<Scalars['ID']['output']>;
    /** All photo IDs associated with room: sourced originally from GBR-Lite JSON data */
    photoIds: Array<Scalars['ID']['output']>;
};

export type ImxTextureFileUrlTiles = RichMediaTextureFileUrlTiles & {
    coords: Array<Scalars['Int']['output']>;
    url: Scalars['String']['output'];
};

export type ImxTextureFileUrls = RichMediaTextureFileUrls & {
    pano4k: Scalars['String']['output'];
    pano512: Scalars['String']['output'];
    thumbnail?: Maybe<Scalars['String']['output']>;
    tiles: Array<ImxTextureFileUrlTiles>;
};

export type ImxTourPhotographer = {
    /** Photographer caption: sourced originally from IMX JSON data */
    caption: Scalars['String']['output'];
    /** Is photographer (alternatively may be 'creator'): sourced originally from IMX JSON data */
    isPhotographer: Scalars['Boolean']['output'];
    /** Photographer name: sourced originally from IMX JSON data */
    name: Scalars['String']['output'];
    /** Photographer photo URL: sourced originally from IMX JSON data */
    photoUrl?: Maybe<Scalars['String']['output']>;
};

export type ImxVisualization = {
    /** Associated floor ID: sourced originally from IMX JSON data */
    floorId: Scalars['String']['output'];
    /** Visualization ID: sourced originally from IMX JSON data */
    id: Scalars['String']['output'];
    /** PNG visualization data: sourced originally from IMX JSON data */
    png: ImxVisualizationPNG;
    /** SVG visualization data: sourced originally from IMX JSON data */
    svg?: Maybe<ImxVisualizationSVG>;
};

export type ImxVisualizationPNG = {
    /** Floor plan bounds in real world units (meters) where 0,0 is ~center of the floor: sourced originally from IMX JSON data */
    bounds: ImxBounds;
    /** Description TODO RMXCPLW-1469: sourced originally from IMX JSON data */
    offset: ImxCoordinate;
    /** Largest & most detailed IMX floor plan: sourced originally from IMX JSON data */
    primaryAssetSource: Scalars['String']['output'];
    /** @deprecated Use showcase floorPlanOnMap data */
    rotation?: Maybe<Scalars['Int']['output']>;
    /** Floor plan scale mapping meters->pixels: sourced originally from IMX JSON data */
    scale: ImxCoordinate;
    /** Simplified IMX floor plan: sourced originally from IMX JSON data */
    sidebarAssetSource: Scalars['String']['output'];
    /** Thumbnail IMX floor plan: sourced originally from IMX JSON data */
    thumbnailAssetSource: Scalars['String']['output'];
};

export type ImxVisualizationSVG = {
    /** Floor plan bounds in real world units (meters) where 0,0 is ~center of the floor: sourced originally from IMX JSON data */
    bounds: ImxBounds;
    /** Description TODO RMXCPLW-1469: sourced originally from IMX JSON data */
    offset: ImxCoordinate;
    /** @deprecated Use showcase floorPlanOnMap data */
    rotation?: Maybe<Scalars['Int']['output']>;
    /** Floor plan scale mapping meters->pixels (NOTE pixels is an odd unit for use with an SVG): sourced originally from IMX JSON data */
    scale: ImxCoordinate;
    /** SVG version of image with fixtures: sourced originally from IMX JSON data */
    withFixturesSource: Scalars['String']['output'];
    /** SVG version of image without fixtures: sourced originally from IMX JSON data */
    withoutFixturesSource: Scalars['String']['output'];
};

export type ImxWorldCoordinate = {
    /** X value in real world units (meters) */
    x: Scalars['Float']['output'];
    /** Y value in real world units (meters) */
    y: Scalars['Float']['output'];
    /** Z value in real world units (meters) */
    z: Scalars['Float']['output'];
};

export type IncomeLimitsMini = {
    maximumIncome?: Maybe<Scalars['Int']['output']>;
    occupants?: Maybe<Scalars['Int']['output']>;
};

export type IncomeLimitsType = {
    maximumIncome?: Maybe<Scalars['Int']['output']>;
    occupants?: Maybe<Scalars['Int']['output']>;
};

export type IncomeRestrictionsMini = {
    buildingWideMaximumIncome?: Maybe<Scalars['Int']['output']>;
    disclaimerCustomText?: Maybe<Scalars['String']['output']>;
    disclaimerType?: Maybe<Scalars['String']['output']>;
    incomeLimits?: Maybe<Array<Maybe<IncomeLimitsMini>>>;
    incomeRestricted?: Maybe<Scalars['Boolean']['output']>;
};

export type IncomeRestrictionsType = {
    buildingWideMaximumIncome?: Maybe<Scalars['Int']['output']>;
    disclaimerCustomText?: Maybe<Scalars['String']['output']>;
    disclaimerType?: Maybe<Scalars['String']['output']>;
    incomeLimits?: Maybe<Array<Maybe<IncomeLimitsType>>>;
    incomeRestricted?: Maybe<Scalars['Boolean']['output']>;
};

export type IncomeType = 'employment' | 'other' | 'selfEmployed' | 'voucher';

export type IncomeVerification = {
    endDate?: Maybe<Scalars['Date']['output']>;
    startDate?: Maybe<Scalars['Date']['output']>;
    vendor?: Maybe<IncomeVerificationVendor>;
    verifiedDate?: Maybe<Scalars['Date']['output']>;
};

export type IncomeVerificationVendor = 'finicity';

export type IndexRange = {
    length: Scalars['Int']['output'];
    startIndex: Scalars['Int']['output'];
};

export type IndianCountryLandTenureType =
    | 'AlaskaNativeCorporationLand'
    | 'FeeSimpleOnReservation'
    | 'IndividualTrustLand'
    | 'TribalTrustLandOffReservation'
    | 'TribalTrustLandOnReservation';

export type IneligibleInfo = {
    /**  Contact Info of Sebastian persisted in DB  */
    contactInfo: MisoContactInfo;
    /**  Reason for in-eligibility  */
    eliminationReason?: Maybe<Scalars['String']['output']>;
    /**  Unique ID for the Sebastian answers persisted in DB  */
    responseId: Scalars['ID']['output'];
    /**  The standard Zillow Property Id persisted in DB  */
    zpid: Scalars['Int']['output'];
};

export type IneligibleInfoInput = {
    /**  Contact Info of Sebastian  */
    contactInfo: ContactInfoInput;
    /**  Reason for In-eligibility  */
    eliminationReason?: InputMaybe<Scalars['String']['input']>;
    /**  Unique ID for the Sebastian answers  */
    responseId: Scalars['ID']['input'];
    /**  The standard Zillow Property Id  */
    zpid: Scalars['Int']['input'];
};

export type InitialSubmitFlowState = {
    contactAgentFormVariant: ContactAgentFormVariant;
    platform: ContactFormPlatform;
    requestSource?: InputMaybe<SubmitFlowRequestSource>;
    requestType?: InputMaybe<SubmitFlowRequestType>;
    tourType?: InputMaybe<SubmitFlowTourType>;
};

export type Insight = {
    endTime?: Maybe<Scalars['GraphQLLong']['output']>;
    for?: Maybe<ZillowPersona>;
    id: Scalars['String']['output'];
    startTime?: Maybe<Scalars['GraphQLLong']['output']>;
    value?: Maybe<Scalars['Float']['output']>;
};

export type Insights = {
    /** Identifier referencing the associated model/experience used to generate the insights */
    modelId?: Maybe<Scalars['String']['output']>;
    /** Home insight tags (i.e., phrases) generated for the property */
    phrases?: Maybe<Array<Scalars['String']['output']>>;
    /** Identifier to determine the AB trial treatment/bucket associated with these insights */
    treatmentId?: Maybe<Scalars['String']['output']>;
    /** Epoch Timestamp in ms of when the insights are generated, in UTC */
    updatedTime?: Maybe<Scalars['String']['output']>;
};

export type InstantTourType = 'IN_PERSON' | 'LIVE_VIDEO' | 'SELF_GUIDED';

export type InstantTourTypeDetails = {
    dateOnly?: Maybe<Scalars['Boolean']['output']>;
    schedulingProvider?: Maybe<Scalars['String']['output']>;
    tourType?: Maybe<InstantTourType>;
};

export type IntegerValue = {
    integer: Scalars['Int']['output'];
};

export type InternalServerError = BridgeContainerError & {
    message: Scalars['String']['output'];
    retryable?: Maybe<Scalars['Boolean']['output']>;
};

export type InviteCoShopperInput = {
    /**  the email of the coShopper  */
    email: Scalars['String']['input'];
    /**  the propertyId that the user want to share  */
    propertyId?: InputMaybe<Scalars['ID']['input']>;
};

export type InviteCoapplicantInput = {
    email: Scalars['EmailAddress']['input'];
    firstName: Scalars['NonEmptyString']['input'];
    lastName: Scalars['NonEmptyString']['input'];
};

export type InvitedByContactInfo = ApplicantContactInfo & {
    email?: Maybe<Scalars['EmailAddress']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
};

export type IsPreQualifiedStatus = 'NO' | 'UNSPECIFIED' | 'YES';

/** Issue type details */
export type IssueTypeDetails = {
    /** Issue type in Salesforce */
    contactReason?: Maybe<Scalars['String']['output']>;
    /** Issue type display name */
    displayName?: Maybe<Scalars['String']['output']>;
};

export type LandlordProfile = {
    accountExists?: Maybe<Scalars['Boolean']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

export type LandlordRentalApplication = {
    applicant?: Maybe<Applicant>;
    applicants?: Maybe<Array<Maybe<Applicant>>>;
    declinedDateTime?: Maybe<Scalars['DateTime']['output']>;
    declinedReasons?: Maybe<Array<Maybe<DeclineReason>>>;
    icraaPageConfig?: Maybe<IcraaPageConfig>;
    id?: Maybe<Scalars['ID']['output']>;
    invitations?: Maybe<Array<Maybe<SentCoapplicantInvitation>>>;
    invitedToMoveInDateTime?: Maybe<Scalars['DateTime']['output']>;
    isEligibleToVerifyIncome?: Maybe<Scalars['Boolean']['output']>;
    isIncomeToRentEligible?: Maybe<Scalars['Boolean']['output']>;
    isIncomeToRentVerified?: Maybe<Scalars['Boolean']['output']>;
    isViewed?: Maybe<Scalars['Boolean']['output']>;
    legalCompliances?: Maybe<Array<Maybe<LegalCompliance>>>;
    mergedDateTime?: Maybe<Scalars['DateTime']['output']>;
    overallStatus?: Maybe<ApplicationStatus>;
    withdrawnDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type LandlordRentalApplicationapplicantArgs = {
    userId: Scalars['ID']['input'];
    zgAuthZone: ZgAuthZone;
};

export type LastSale = {
    /** Was this property sold recently */
    isRecentlySold?: Maybe<Scalars['Boolean']['output']>;
    /**
     * The date of the last time the property was sold without a time-zone in ISO-8601.
     * Example: 2019-07-03
     */
    lastSoldDate?: Maybe<Scalars['LocalDate']['output']>;
    /** The price of the property the last time it was sold */
    lastSoldPrice?: Maybe<Scalars['Int']['output']>;
};

export type LatLon = {
    /** The latitude coordinate for this latlon point */
    latitude: Scalars['Float']['output'];
    /** The longitude coordinate for this latlon point */
    longitude: Scalars['Float']['output'];
};

export type LatLonInput = {
    /** The latitude coordinate for this latlon point */
    latitude: Scalars['Float']['input'];
    /** The longitude coordinate for this latlon point */
    longitude: Scalars['Float']['input'];
};

/** Object containing latitude(lat) and longitude(long) of the building */
export type LatLong = {
    lat?: Maybe<Scalars['Float']['output']>;
    long?: Maybe<Scalars['Float']['output']>;
};

/**
 * This is the kind of ContactButtonAction we use to launch the contact forms
 * implemented for web in https://gitlab.zgtools.net/zillow/connections-web/contact-form.
 */
export type LaunchContactFormAction = {
    url?: Maybe<Scalars['String']['output']>;
    variant?: Maybe<Scalars['String']['output']>;
};

/** This is the kind of ContactButtonAction we use to open external links. */
export type LaunchExternalUrlAction = {
    url?: Maybe<Scalars['String']['output']>;
};

/**
 * This is the kind of ContactButtonAction we use to launch the tour forms
 * implemented for web in https://gitlab.zgtools.net/zillow/connections-web/contact-form.
 */
export type LaunchTourFormAction = {
    url?: Maybe<Scalars['String']['output']>;
};

export type LaunchUrlCTAAction = {
    url?: Maybe<Scalars['String']['output']>;
};

/** the status of a lead */
export type LeadStatus =
    | 'ABANDONED'
    | 'ACTION_TAKEN'
    | 'BAD_INFO'
    | 'CONNECTED'
    | 'CONTACTED'
    | 'Contacting'
    | 'Converted'
    | 'DUPLICATES'
    | 'Discovery'
    | 'INITIATED'
    | 'New'
    | 'Pre_Approval'
    | 'Qualification'
    | 'RECONNECTED'
    | 'Unassigned'
    | 'Unqualified';

export type LeadType =
    /** All Flex connections (Flex & MiSO), in ALR flex_contact_flag=1 and miso_flag=1 */
    | 'ALL_FLEX'
    /** All tours (RTT & Touring) MBP + Flex, in ALR l2_program_participation in ('instant_book_tour', 'rtt_with_agent_transfer_hybrid_market') */
    | 'ALL_TOURS'
    /** Buyer Connections (Flex, not MiSO), in ALR flex_contact_flag=1 and miso_flag=0 */
    | 'BUYER_CONNECTIONS'
    /** Flex connections, in ALR flex_contact_flag=1 */
    | 'FLEX'
    /** MBP connections, in ALR flex_contact_flag=0 and miso_flag=0 */
    | 'MBP'
    /** MISO connections, in ALR miso_flag=1 */
    | 'MISO'
    /** Flex RTT tours, in ALR l2_program_participation in ('instant_book_tour', 'rtt_with_agent_transfer_hybrid_market') and flex_contact_flag=1 */
    | 'RTT'
    /** Seller Connections (MiSO, not Flex), in ALR flex_contact_flag=0 and miso_flag=1 */
    | 'SELLER_CONNECTIONS';

/** the AI/ML models for the results we project */
export type LearningGoal =
    /** computes the propensity scores, supported by various models */
    'PROPENSITY';

export type LearningModel = {
    createTime?: Maybe<Scalars['GraphQLLong']['output']>;
    deprecateTime?: Maybe<Scalars['GraphQLLong']['output']>;
    /** provides some description of this learning model */
    description?: Maybe<Scalars['String']['output']>;
    /** the goal of this learning model */
    goal: LearningGoal;
    lastUpdate?: Maybe<Scalars['GraphQLLong']['output']>;
    /**
     * the learning model that can be applied to data with a goal
     * for example,
     * see https://zwiki.zillowgroup.net/pages/viewpage.action?spaceKey=AT&title=Propensity+Models
     */
    modelName: LearningModelName;
    /** the version of this learning model */
    version?: Maybe<Scalars['String']['output']>;
};

/** our ML models */
export type LearningModelName =
    | 'LIKELY_BARS_YES'
    | 'LIKELY_BETH_SUBMITTER'
    | 'LIKELY_BUYER'
    | 'LIKELY_HOMEFEATURES'
    | 'LIKELY_HOMEOWNER'
    | 'LIKELY_HOMEOWNER_CALIBRATED'
    | 'LIKELY_LONG_TERM_REGION_PREFERENCE'
    | 'LIKELY_MORTGAGE_PURCHASE_SUBMITTER'
    | 'LIKELY_PREAPPROVAL'
    | 'LIKELY_RACHEL_SUBMITTER'
    | 'LIKELY_SELLER'
    | 'LIKELY_ZIPCODE'
    | 'LIKELY_ZOREQUESTOR'
    | 'LIKELY_ZPID'
    | 'PERSONA_INTEREST_BUYER'
    | 'PERSONA_INTEREST_RENTER'
    | 'PERSONA_INTEREST_SELLER'
    | 'ROLLING_ADMISSION_MODEL'
    | 'USER_AFFORDABILITY';

export type Lease = {
    actions?: Maybe<Array<Maybe<LeaseAction>>>;
    creationDate?: Maybe<Scalars['String']['output']>;
    documentBackend?: Maybe<Scalars['String']['output']>;
    encodedId?: Maybe<Scalars['String']['output']>;
    endDate?: Maybe<Scalars['String']['output']>;
    gdpProperty?: Maybe<Property>;
    id?: Maybe<Scalars['Int']['output']>;
    isSelfUpload?: Maybe<Scalars['Boolean']['output']>;
    landlords?: Maybe<Array<Maybe<Signator>>>;
    listingAlias?: Maybe<Scalars['String']['output']>;
    messageData?: Maybe<GetLeaseActivity>;
    name?: Maybe<Scalars['String']['output']>;
    /** @deprecated use gdpProperty instead */
    property?: Maybe<ZGProperty>;
    propertyId?: Maybe<Scalars['String']['output']>;
    ratifiedDate?: Maybe<Scalars['String']['output']>;
    recentActivity?: Maybe<Scalars['String']['output']>;
    sharedDate?: Maybe<Scalars['String']['output']>;
    signedUsers?: Maybe<WhoHasSigned>;
    startDate?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    tenants?: Maybe<Array<Maybe<Signator>>>;
    updateDate?: Maybe<Scalars['String']['output']>;
    userActionExpected?: Maybe<Scalars['Boolean']['output']>;
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type LeaseAction = {
    disabled?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

export type LeaseDetails = {
    /** Description of lease */
    leaseDescription?: Maybe<Scalars['String']['output']>;
    /** Term of lease */
    leaseTerm?: Maybe<Scalars['String']['output']>;
};

export type LeaseTermsType =
    | 'Flexible'
    | 'LessThanOneYear'
    | 'Monthly'
    | 'MoreThanOneYear'
    | 'None'
    | 'OneYear'
    | 'Other'
    | 'SixMonths'
    | 'Unknown';

export type LegalCompliance = {
    body?: Maybe<Scalars['String']['output']>;
    complianceType?: Maybe<Scalars['String']['output']>;
    hasBeenAccepted?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
};

export type ListedByAction = {
    /** Webview url to open contact form */
    url: Scalars['String']['output'];
    /** Contact form variant */
    variant: ForSaleContactFormVariant;
};

export type ListedByElement = {
    /** Element action when clicked in listedBy section */
    action?: Maybe<ListedByAction>;
    /** Element id in listedBy section */
    id: Scalars['String']['output'];
    /** Element text to display in listedBy section */
    text: Scalars['String']['output'];
};

export type ListedBySection = {
    /** Elements sorted in order to display */
    elements?: Maybe<Array<ListedByElement>>;
    /** Section id in listedby module */
    id: Scalars['String']['output'];
    /** text style to apply for a whole section */
    textStyle?: Maybe<ListedBySectionTextStyle>;
};

export type ListedBySectionTextStyle = 'STRONG';

/** Account information on the lister of the property. Admin-only. */
export type ListingAccountType = {
    email?: Maybe<Scalars['String']['output']>;
    zuid?: Maybe<Scalars['Int']['output']>;
};

export type ListingAgentInfoRequest = {
    /**
     * Include in the response listings that match one of the provided agent email addresses
     *
     * This field is logically ORed together with mlsAgentIdentifiers returning listings that
     * match either criteria
     */
    agentEmailAddresses?: InputMaybe<Array<Scalars['String']['input']>>;
    /**
     * Include in the response listings that match one of the provided ssid, mlsAgentIdentifier pairs
     *
     * This field is logically ORed together with agentEmailAddresses returning listings that
     * match either criteria
     */
    mlsAgentIdentifiers?: InputMaybe<Array<SsidMlsAgentIdentifierPair>>;
};

export type ListingApplicationStatus = {
    applicantStatus?: Maybe<Scalars['String']['output']>;
    /**
     * Return the detailed status for an application to a specific property
     * https://bitbucket.hotterpads.com/projects/RP/repos/zillow/browse/capps-client/src/main/java/com/hotpads/capps/client/dto/application/ListingApplicationStatus.java
     */
    applicationId?: Maybe<Scalars['String']['output']>;
    applicationStatus?: Maybe<Scalars['String']['output']>;
    applicationStatusHistory?: Maybe<Array<Maybe<ApplicationStatusHistoryEvent>>>;
    isPrimaryApplicant?: Maybe<Scalars['Boolean']['output']>;
    listing?: Maybe<ListingOverview>;
    listingOwner?: Maybe<ListingOwnerOverview>;
};

export type ListingComminglingCategory = 'RULES_APPLICABLE' | 'RULES_NOT_APPLICABLE';

/** Listing criteria for a rental property */
export type ListingCriteria = {
    /** Whether Irene/the listing feed has indicated that cats are allowed, null if unknown */
    areCatsAllowed?: Maybe<Scalars['Boolean']['output']>;
    /** Whether Irene/the listing feed has indicated that dogs are allowed, null if unknown */
    areDogsAllowed?: Maybe<Scalars['Boolean']['output']>;
    /** Credit score screening criteria */
    creditScore?: Maybe<Scalars['String']['output']>;
    /** Whether creditScore criterion is mandatory */
    creditScoreMandatory?: Maybe<Scalars['Boolean']['output']>;
    /** The ratio of income to rent */
    incomeToRent?: Maybe<Scalars['String']['output']>;
    /** Whether incomeToRent criterion is mandatory */
    incomeToRentMandatory?: Maybe<Scalars['Boolean']['output']>;
    /** Whether Irene has completed the post-flow in the listing creation process and set the listing criteria */
    isZrmScreeningCriteriaSet?: Maybe<Scalars['Boolean']['output']>;
    /** Pet policy - number of cats allowed */
    petPolicyCatCount?: Maybe<Scalars['String']['output']>;
    /** Whether petPolicyCatCount criterion is mandatory */
    petPolicyCatCountMandatory?: Maybe<Scalars['Boolean']['output']>;
    /** Pet policy - number of dogs allowed */
    petPolicyDogCount?: Maybe<Scalars['String']['output']>;
    /** Whether petPolicyDogCount criterion is mandatory */
    petPolicyDogCountMandatory?: Maybe<Scalars['Boolean']['output']>;
    /** Pet policy - dog size information */
    petPolicyDogSize?: Maybe<Scalars['String']['output']>;
    /** Whether petPolicyDogSize criterion is mandatory */
    petPolicyDogSizeMandatory?: Maybe<Scalars['Boolean']['output']>;
    /** Pet policy - other pets allowed on property */
    petPolicyOtherPets?: Maybe<Scalars['String']['output']>;
    /** Whether petPolicyOtherPets criterion is mandatory */
    petPolicyOtherPetsMandatory?: Maybe<Scalars['Boolean']['output']>;
    /** Pet policy - pet deposit amount */
    petPolicyPetDeposit?: Maybe<Scalars['String']['output']>;
    /** Whether petPolicyPetDeposit criterion is mandatory */
    petPolicyPetDepositMandatory?: Maybe<Scalars['Boolean']['output']>;
    /** Pet policy - pet rent amount */
    petPolicyPetRent?: Maybe<Scalars['String']['output']>;
    /** Whether petPolicyPetRent criterion is mandatory */
    petPolicyPetRentMandatory?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * The display option selected for home-details. Currently, only one option may be
 * selected. The legacy representation is an enum
 */
export type ListingDisplayOptions = {
    /** Use the default home-details behavior */
    standard?: Maybe<Scalars['Boolean']['output']>;
    /** Really send traffic to the listing owner. (e.g. replaces contact module with traffic-generating variant) */
    superTrafficOptimized?: Maybe<Scalars['Boolean']['output']>;
    /** Auction listing behavior 1 */
    superTrafficOptimizedADC1?: Maybe<Scalars['Boolean']['output']>;
    /** Auction listing behavior 2 */
    superTrafficOptimizedADC2?: Maybe<Scalars['Boolean']['output']>;
    /** Auction listing behavior 3 */
    superTrafficOptimizedADC3?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Really send traffic to the listing owner with a different
     *                    set of anchor text. (e.g. replaces contact module with traffic-generating
     *                    variant)
     */
    superTrafficOptimizedB?: Maybe<Scalars['Boolean']['output']>;
    /** Send traffic to the listing owner (e.g. prioritize external links over contact forms). */
    trafficOptimized?: Maybe<Scalars['Boolean']['output']>;
};

export type ListingMetadata = {
    BuildingDataA?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataB?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataC?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataD?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataE?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataF?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataG?: Maybe<Scalars['String']['output']>;
    BuildingDataH?: Maybe<Scalars['String']['output']>;
    BuildingDataI?: Maybe<Scalars['String']['output']>;
    BuildingDataJ?: Maybe<Scalars['String']['output']>;
    BuildingDataK?: Maybe<Scalars['String']['output']>;
    BuildingDataL?: Maybe<Scalars['String']['output']>;
    BuildingDataM?: Maybe<Scalars['String']['output']>;
    BuildingDataN?: Maybe<Scalars['String']['output']>;
    BuildingDataO?: Maybe<Scalars['String']['output']>;
    BuildingDataP?: Maybe<Scalars['String']['output']>;
    BuildingDataQ?: Maybe<Scalars['String']['output']>;
    BuildingDataR?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataS?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutA?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutAA?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutAB?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutB?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutC?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutD?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutE?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutF?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutG?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutH?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutI?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutJ?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutK?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutL?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutM?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutN?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutO?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutP?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutQ?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutR?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutS?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutT?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutU?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutV?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutW?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutX?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutY?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutZ?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the camel-cased version instead */
    HidePriceAdjustmentFlexField?: Maybe<Scalars['Boolean']['output']>;
    canCommingleComparables?: Maybe<Scalars['Boolean']['output']>;
    canShowAutomatedValuationDisplay?: Maybe<Scalars['Boolean']['output']>;
    canShowComparables?: Maybe<Scalars['Boolean']['output']>;
    canShowCroppedPhotos?: Maybe<Scalars['Boolean']['output']>;
    canShowNonIDXMedia?: Maybe<Scalars['Boolean']['output']>;
    canShowOnMap?: Maybe<Scalars['Boolean']['output']>;
    canShowPrequalifiedLinkInChip?: Maybe<Scalars['Boolean']['output']>;
    canShowPriceHistory?: Maybe<Scalars['Boolean']['output']>;
    canShowTaxHistory?: Maybe<Scalars['Boolean']['output']>;
    canShowUserGeneratedContent?: Maybe<Scalars['Boolean']['output']>;
    canShowZillowLogoInHeader?: Maybe<Scalars['Boolean']['output']>;
    comminglingCategory?: Maybe<Scalars['Boolean']['output']>;
    comminglingCategoryIsRulesApplicable?: Maybe<Scalars['Boolean']['output']>;
    hidePriceAdjustmentFlexField?: Maybe<Scalars['Boolean']['output']>;
    isAdsRestricted?: Maybe<Scalars['Boolean']['output']>;
    isSuperTrafficOptimized?: Maybe<Scalars['Boolean']['output']>;
    mustAttributeOfficeNameBeforeAgentName?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayAttributionListAgentEmail?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayAttributionListAgentPhone?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayAttributionListingOfficePhone?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayDisclaimerBelowAttribution?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayFeedLogoInContactBox?: Maybe<Scalars['Boolean']['output']>;
    mustHighlightAgentName?: Maybe<Scalars['Boolean']['output']>;
    mustHighlightListOfficeName?: Maybe<Scalars['Boolean']['output']>;
    mustHighlightMarketingType?: Maybe<Scalars['Boolean']['output']>;
    mustHighlightMlsId?: Maybe<Scalars['Boolean']['output']>;
    mustHighlightMlsStatus?: Maybe<Scalars['Boolean']['output']>;
    mustMakeListingAgentContactable?: Maybe<Scalars['Boolean']['output']>;
    passwordRequiredForZestimateMarketAnalysis?: Maybe<Scalars['Boolean']['output']>;
};

export type ListingOverview = {
    city?: Maybe<Scalars['String']['output']>;
    fullImgUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    gdpProperty?: Maybe<Property>;
    /** https://bitbucket.hotterpads.com/projects/RP/repos/zillow/browse/capps-client/src/main/java/com/hotpads/capps/client/dto/listing/ListingOverview.java */
    id?: Maybe<Scalars['String']['output']>;
    latitude?: Maybe<Scalars['Float']['output']>;
    longitude?: Maybe<Scalars['Float']['output']>;
    /** @deprecated use gdpProperty instead */
    property?: Maybe<ZGProperty>;
    propertyLink?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    street?: Maybe<Scalars['String']['output']>;
    thumbImgUrl?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type ListingOwner = {
    email?: Maybe<Scalars['EmailAddress']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['PhoneNumber']['output']>;
    userId?: Maybe<Scalars['ID']['output']>;
};

export type ListingOwnerOverview = {
    email?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    /** https://bitbucket.hotterpads.com/projects/RP/repos/zillow/browse/capps-client/src/main/java/com/hotpads/capps/client/dto/listing/ListingOwnerOverview.java */
    userId?: Maybe<Scalars['String']['output']>;
};

/** Reputation data for a listing provider */
export type ListingOwnerReputation = {
    /** Number of applications of the listing. */
    applicationCount?: Maybe<Scalars['Int']['output']>;
    /** Number of contacts of the listing provider. */
    contactCount?: Maybe<Scalars['Int']['output']>;
    /** Is listing owner id verified? */
    isLandlordIdVerified?: Maybe<Scalars['Boolean']['output']>;
    /** Response rate the listing provider contact. */
    responseRate?: Maybe<Scalars['Float']['output']>;
    /** Response time of the listing provider contact in milliseconds. */
    responseTimeMs?: Maybe<Scalars['Int']['output']>;
};

export type ListingProvider = {
    /** License number of the listing agent */
    agentLicenseNumber?: Maybe<Scalars['String']['output']>;
    /** Name of the listing agent */
    agentName?: Maybe<Scalars['String']['output']>;
    /** The content of the disclaimer message */
    disclaimerText?: Maybe<Scalars['String']['output']>;
    /** Text of an enhanced description */
    enhancedDescriptionText?: Maybe<Scalars['String']['output']>;
    /** URL of an enhanced video */
    enhancedVideoURL?: Maybe<Scalars['String']['output']>;
    /** Whether the description text came from Zillow Rental Manager */
    isZRMSourceText?: Maybe<Scalars['Boolean']['output']>;
    /** A List of logos to display */
    logos?: Maybe<Array<Maybe<ListingProviderLogo>>>;
    /** Phone number of the listing agent */
    phoneNumber?: Maybe<Scalars['String']['output']>;
    /** Name of the group that posted the listing */
    postingGroupName?: Maybe<Scalars['String']['output']>;
    /** Text to be used for the posting website link */
    postingWebsiteLinkText?: Maybe<Scalars['String']['output']>;
    /** URL of the posting website */
    postingWebsiteURL?: Maybe<Scalars['String']['output']>;
    /** If an enhanced listing should be displayed */
    showEnhancedListing?: Maybe<Scalars['Boolean']['output']>;
    /** Whether logos should be shown */
    showLogos?: Maybe<Scalars['Boolean']['output']>;
    /** Whether logos should be shown at mobile viewport sizes */
    showMobileLogos?: Maybe<Scalars['Boolean']['output']>;
    /** Whether to show the backup message indicating there was no contact info for the listing agent */
    showNoContactInfoMessage?: Maybe<Scalars['Boolean']['output']>;
    /** Text describing the source of the listing */
    sourceText?: Maybe<Scalars['String']['output']>;
    /** Title for the module */
    title?: Maybe<Scalars['String']['output']>;
};

export type ListingProviderLogo = {
    /** URL to which this logo should link */
    link?: Maybe<Scalars['String']['output']>;
    /** URL of the logo image */
    src?: Maybe<Scalars['String']['output']>;
};

export type ListingStatusType =
    /** auction listing type */
    | 'AUCTION'
    /** coming soon listing type */
    | 'COMINGSOON'
    /** foreclosed listing type */
    | 'FORECLOSED'
    /** foreclosure listing type */
    | 'FORECLOSURE'
    /** for rent listing type */
    | 'FOR_RENT'
    /** for sale listing type */
    | 'FOR_SALE'
    /** for sale by agent listing type */
    | 'FSBA'
    /** for sale by owner listing type */
    | 'FSBO'
    /** new construction listing type */
    | 'NEWCONSTRUCTION'
    /** new construction lot listing type */
    | 'NEWCONSTRUCTION_LOT'
    /** preforeclosure listing type */
    | 'PREFORECLOSURE'
    /** recently sold listing type */
    | 'RECENTLY_SOLD'
    /** sold listing type */
    | 'SOLD'
    /** zestimate listing type */
    | 'ZESTIMATE';

export type ListingSubType = {
    isFSBA?: Maybe<Scalars['Boolean']['output']>;
    isFSBO?: Maybe<Scalars['Boolean']['output']>;
};

export type ListingSubtype = {
    /** is this property for-sale by agent? */
    is_FSBA?: Maybe<Scalars['Boolean']['output']>;
    /** is this property for-sale by owner? */
    is_FSBO?: Maybe<Scalars['Boolean']['output']>;
    is_bankOwned?: Maybe<Scalars['Boolean']['output']>;
    is_comingSoon?: Maybe<Scalars['Boolean']['output']>;
    is_forAuction?: Maybe<Scalars['Boolean']['output']>;
    is_foreclosure?: Maybe<Scalars['Boolean']['output']>;
    is_newHome?: Maybe<Scalars['Boolean']['output']>;
    is_openHouse?: Maybe<Scalars['Boolean']['output']>;
    /** is sale of this property pending? */
    is_pending?: Maybe<Scalars['Boolean']['output']>;
    is_roomForRent?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * The object in API response is same as V1 endpoint StandingOfferData.Based on
 * requirement we rename it to live offer in GDP schema
 */
export type LiveOfferData = {
    liveOfferGroup?: Maybe<Scalars['String']['output']>;
    liveOfferPrice?: Maybe<Scalars['Int']['output']>;
};

export type LivingQuarterType = {
    areaTotal?: Maybe<Scalars['Float']['output']>;
    areaTotalUnits?: Maybe<Scalars['String']['output']>;
    features?: Maybe<Scalars['String']['output']>;
    livingArea?: Maybe<Scalars['Float']['output']>;
    livingAreaUnits?: Maybe<Scalars['String']['output']>;
    livingQuarterType?: Maybe<Scalars['String']['output']>;
};

export type LoanActivity = Activity & {
    /** if available, the activity/event id */
    activityId?: Maybe<Scalars['ID']['output']>;
    /** if available, the activity time as epoch milliseconds */
    activityTime?: Maybe<Scalars['GraphQLLong']['output']>;
    /** the activity type */
    activityType: ActivityType;
    /** the user id associated with this activity */
    associatedId: IdBasedWithSource;
    /**
     * leave this edge out until bridge-subgraph defines the @key
     * move: BridgeMove @provides(fields: "id")
     */
    moveId?: Maybe<Scalars['ID']['output']>;
    /** source of the activity/event */
    source: Scalars['String']['output'];
};

export type LoanDetails = {
    loanDetailsString?: Maybe<Scalars['String']['output']>;
    loanTypeTerm?: Maybe<LoanTypeTerm>;
    rate?: Maybe<Scalars['Float']['output']>;
    rateSource?: Maybe<Scalars['String']['output']>;
};

export type LoanFinanceJourneyContext = {
    loanId: Scalars['String']['output'];
    status?: Maybe<LoanFinanceJourneyStatusType>;
};

export type LoanFinanceJourneyStatusType = 'PREAPPROVED' | 'PREQUALIFIED';

export type LoanOfficer = {
    email: Scalars['String']['output'];
    name: Scalars['String']['output'];
    officePhone: Scalars['String']['output'];
    title?: Maybe<Scalars['String']['output']>;
};

export type LoanOfficerInfo = {
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    imageUrl?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    middleName?: Maybe<Scalars['String']['output']>;
    nmlsId?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    salesForceId?: Maybe<Scalars['String']['output']>;
    shareableLoanOfficerLink?: Maybe<Scalars['String']['output']>;
};

export type LoanType = 'CONVENTIONAL' | 'FHA' | 'HOMEREADY' | 'JUMBO' | 'VA';

export type LoanTypeTerm = 'arm5' | 'fixed15Year' | 'fixed30Year';

export type LocalProtections = {
    protectionLevels?: Maybe<ProtectionLevels>;
    protectionTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    protections?: Maybe<Array<Maybe<Protections>>>;
};

/** Local voucher information to render on HDP and BDP */
export type LocalVoucherContent = {
    /** City to be rendered */
    city?: Maybe<Scalars['String']['output']>;
    /** Incentive language to be rendered */
    incentiveLanguage?: Maybe<Scalars['String']['output']>;
    /** Determines if city or state will be rendered */
    isLawLevelState?: Maybe<Scalars['Boolean']['output']>;
    /** Public housing authority to be rendered */
    publicHousingAuthority?: Maybe<Scalars['String']['output']>;
    /** Report abuse agency to be rendered */
    reportAbuseAgency?: Maybe<Scalars['String']['output']>;
    /** Report abuse agency phone number to be rendered */
    reportAbusePhone?: Maybe<Scalars['String']['output']>;
    /** State to be rendered */
    state?: Maybe<Scalars['String']['output']>;
    /** Violation fine value to be rendered */
    violationFineValue?: Maybe<Scalars['Int']['output']>;
};

export type Location = {
    city?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    county?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['String']['output']>;
    stateAbbr?: Maybe<Scalars['String']['output']>;
    zipcode?: Maybe<Scalars['String']['output']>;
};

export type LocationInput = {
    city?: InputMaybe<Scalars['String']['input']>;
    country?: InputMaybe<Scalars['String']['input']>;
    county?: InputMaybe<Scalars['String']['input']>;
    stateAbbr?: InputMaybe<Scalars['String']['input']>;
    zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type LongRange = {
    max?: Maybe<Scalars['GraphQLLong']['output']>;
    min?: Maybe<Scalars['GraphQLLong']['output']>;
};

export type LongRangeInput = {
    max?: InputMaybe<Scalars['GraphQLLong']['input']>;
    min?: InputMaybe<Scalars['GraphQLLong']['input']>;
};

export type LotToAvailablePlan = {
    /** The number of available plans for this NC lot */
    availablePlanCount?: Maybe<Scalars['Int']['output']>;
    /** The available plans for a new-construction lot. */
    availablePlans?: Maybe<Array<Maybe<AvailablePlan>>>;
    /** Cost of the lot or land associated with a posting on this property */
    lotPremium?: Maybe<Scalars['Int']['output']>;
    /** The primary plan for a new-construction lot. */
    primaryPlan?: Maybe<PrimaryPlan>;
    /** ZPID of a lot in the community */
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type MACNextStepsStatus = {
    details: MACNextStepsStatusDetails;
    status: MACNextStepsStatusType;
};

export type MACNextStepsStatusDetails = {
    offerAccepted: Scalars['Boolean']['output'];
    outstandingTasks: Scalars['Boolean']['output'];
    /** MAC UI-specific values to show breakdowns of where a specific borrower is in a loan */
    preApproved: Scalars['Boolean']['output'];
};

export type MACNextStepsStatusType =
    /**
     * MAC UI-specific enum to represent where a specific borrower is in a loan
     * Drives what they're shown based on what's been completed
     */
    'New' | 'OutstandingTasks' | 'VerifiedPreApproval' | 'WaitingToClose';

/** Retrieve the malone result from a full address */
export type MaloneProperty = {
    /** Name of the building (null if it is a _not_ a building) */
    buildingName?: Maybe<Scalars['String']['output']>;
    /** Number of child properties, if property is a group type */
    childPropertyCount?: Maybe<Scalars['Int']['output']>;
    /** If the property is a multi-family building (false if it is a unit) */
    isBuilding?: Maybe<Scalars['Boolean']['output']>;
    /** If the property is a unit in a multi-family building (false if it is a building) */
    isUnit?: Maybe<Scalars['Boolean']['output']>;
    /** Latitude of the property */
    latitude?: Maybe<Scalars['Float']['output']>;
    /** Longitude of the property */
    longitude?: Maybe<Scalars['Float']['output']>;
    /** If the property is a building (or enclosed by one), the unique ID of the building */
    lotId?: Maybe<Scalars['ID']['output']>;
    /** High-level property classification */
    propertyClass?: Maybe<PropertyClassType>;
    /** Malone property ID */
    propertyId?: Maybe<Scalars['ID']['output']>;
    /** Zillow property ID */
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type ManagedTagUpdate = {
    /**
     * **Definition:** Short name of the tag, used as a unique key
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    shortName: Scalars['String']['output'];
    /**
     * **Definition:** Value of the tag, true means it was added, false means it was removed
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    value: Scalars['Boolean']['output'];
};

export type ManagerContactInfo = ReferenceContactInfo & {
    email?: Maybe<Scalars['EmailAddress']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type ManagerContactInfoInput = {
    email?: InputMaybe<Scalars['EmailAddress']['input']>;
    name?: InputMaybe<Scalars['NonEmptyString']['input']>;
    phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type MapCardAttribution = {
    brokerNameIfRequired?: Maybe<Scalars['String']['output']>;
    mlsIdIfRequired?: Maybe<Scalars['String']['output']>;
    providerLogoIfRequired?: Maybe<Array<Maybe<ProviderLogo>>>;
};

/**
 * This type allows us to pass flags under extended_info_txt. The list of flags
 * here will be mapped into the dictionary on the client side.
 */
export type MapEntry = {
    key?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type MapEntryStringToFloat = {
    key: Scalars['String']['output'];
    value?: Maybe<Scalars['Float']['output']>;
};

export type MapEntryStringToFloat_NonNull = {
    key: Scalars['String']['output'];
    value: Scalars['Float']['output'];
};

export type MapEntryStringToInt = {
    key: Scalars['String']['output'];
    value?: Maybe<Scalars['Int']['output']>;
};

export type MapEntryStringToInt_NonNull = {
    key: Scalars['String']['output'];
    value: Scalars['Int']['output'];
};

export type MapEntryStringToString = {
    key: Scalars['String']['output'];
    value?: Maybe<Scalars['String']['output']>;
};

export type MapEntryStringToString_NonNull = {
    key: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

export type MapKitCoordinates = {
    boundingBox: FloorPlanBoundingBox;
    lat: Scalars['Float']['output'];
    lng: Scalars['Float']['output'];
};

export type MarketInsightsType = {
    path?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
};

export type MarketScopeForBuyAndSellInput = {
    /**  The buyside questionnaire response Id  */
    buysideQuestionnaireResponseId: Scalars['ID']['input'];
    /**  The standard Zillow Property Id  */
    zpid: Scalars['Int']['input'];
};

export type MarketingRepresentationType = 'AGENT' | 'BANK' | 'BUILDER' | 'OWNER' | 'UNKNOWN';

export type MarketingStatusType =
    | 'ACTIVE'
    | 'CLOSED'
    | 'COMING_SOON'
    | 'OFF_MARKET'
    | 'PENDING'
    | 'UNKNOWN';

export type MarketingSubType = 'BUILD_TO_RENT' | 'ROOM' | 'UNKNOWN';

export type MarketingTreatment =
    | 'MULTI_FAMILY_SALES_LISTING'
    | 'PAID'
    | 'TRUSTED_LISTING'
    | 'UNKNOWN'
    | 'ZILLOW_RENTAL_MANAGER';

export type MarketingType = 'AUCTION' | 'FOR_RENT' | 'FOR_SALE' | 'UNKNOWN';

export type MarketingUserProfile = {
    audiences?: Maybe<Array<Scalars['String']['output']>>;
    timestamp: Scalars['DateTime']['output'];
    zuid: Scalars['String']['output'];
};

export type Mbr = {
    maxMbrLatitude?: Maybe<Scalars['Float']['output']>;
    maxMbrLongitude?: Maybe<Scalars['Float']['output']>;
    minMbrLatitude?: Maybe<Scalars['Float']['output']>;
    minMbrLongitude?: Maybe<Scalars['Float']['output']>;
};

/**
 * Each placement will have its own AB bucket to decide how many audiences to be
 * put in different testing phases. Such ab bucket will have the listed treatments
 */
export type MessageAbBucketType =
    | 'BASELINE_CTRL'
    | 'BASELINE_TREATMENT'
    | 'CONTROL'
    | 'PORTFOLIO_INTEGRATION_CTRL'
    | 'PORTFOLIO_INTEGRATION_TREATMENT'
    | 'TARGET_SELECTION_CTRL'
    | 'TARGET_SELECTION_TREATMENT';

export type MessageCounts = {
    buildingCache?: Maybe<Scalars['Boolean']['output']>;
    /** Total number of conversations associated with the user */
    totalConversationsCount?: Maybe<Scalars['Int']['output']>;
    /** Number of unread messages for the user */
    unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type MessageEntries = {
    conversationId?: Maybe<Scalars['ID']['output']>;
    isMessageOwner?: Maybe<Scalars['Boolean']['output']>;
    message?: Maybe<Scalars['String']['output']>;
    messageDateMs?: Maybe<Scalars['String']['output']>;
    senderName?: Maybe<Scalars['String']['output']>;
    senderRelayEmail?: Maybe<Scalars['String']['output']>;
};

/** The 3 phases that a treatment might go through to get into the portfolio */
export type MessageTestPhaseType =
    | 'BASELINE'
    | 'PORTFOLIO_INTEGRATION'
    | 'TARGET_SELECTION'
    | 'UNKNOWN';

/** A treatment could be in the following testing statuses to experience evaluations in the 3-stage experiments */
export type MessageTreatmentStatusType =
    | 'BASELINE_EVALUATION'
    | 'DISABLED'
    | 'PORTFOLIO'
    | 'PORTFOLIO_TEST'
    | 'TARGET_SELECTION';

/**
 * One treatment is a special UI design to be potentially displayed on a placement
 * of a page. Its display data has been defined in the CMS tool by marketers
 */
export type MessageTreatmentType = {
    /** The Constellation component's name which is used to render this treatment */
    component?: Maybe<Scalars['String']['output']>;
    id: Scalars['Int']['output'];
    lastModified: Scalars['String']['output'];
    name: Scalars['String']['output'];
    /** The Constellation component's props JSON serialized as String */
    renderingProps?: Maybe<Scalars['JSON']['output']>;
    status: MessageTreatmentStatusType;
};

export type Messages = {
    conversations?: Maybe<Array<Maybe<Conversation>>>;
    messageCounts?: Maybe<MessageCounts>;
};

export type MetaData = {
    seoTags?: Maybe<BuildingSeoTags>;
    seoTests?: Maybe<Array<Maybe<SeoTest>>>;
};

export type Metadata = {
    /** The traceId of the last service that updated the property data */
    latestTraceId?: Maybe<Scalars['ID']['output']>;
};

/** Information needed to display MICRO_UI tasks. */
export type MicroUIPayload = {
    /** Text for the button shown for this task, e.g. 'Click me' */
    buttonLabel: Scalars['String']['output'];
    /** URL to the remote package used by the Micro-UI platform to display content. */
    remotePackageUrl: Scalars['String']['output'];
};

export type MinMaxFloat = {
    max?: InputMaybe<Scalars['Float']['input']>;
    min?: InputMaybe<Scalars['Float']['input']>;
};

export type MinMaxInteger = {
    max?: InputMaybe<Scalars['Int']['input']>;
    min?: InputMaybe<Scalars['Int']['input']>;
};

export type MirageMarket = {
    code: Scalars['String']['output'];
};

export type MirageProduct = {
    code: Scalars['String']['output'];
};

export type MisoContactInfo = {
    /**  Email address of Sebastian  */
    email: Scalars['String']['output'];
    /**  Full name of Sebastian  */
    fullName: Scalars['String']['output'];
    /**  Contact number of Sebastian  */
    phoneNumber: Scalars['String']['output'];
};

export type MisoMobilePrefillPropertyData = {
    bedroomCount?: Maybe<Scalars['Int']['output']>;
    fullBathCount?: Maybe<Scalars['Int']['output']>;
    halfBathCount?: Maybe<Scalars['Int']['output']>;
    hasHoa?: Maybe<Scalars['Boolean']['output']>;
    homeType?: Maybe<Scalars['String']['output']>;
    livingAreaSize?: Maybe<Scalars['Int']['output']>;
    storyCount?: Maybe<Scalars['Int']['output']>;
    threeQuarterBathCount?: Maybe<Scalars['Int']['output']>;
    yearBuilt?: Maybe<Scalars['String']['output']>;
    zpid?: Maybe<Scalars['Int']['output']>;
};

export type MisoOfferRecommendation = {
    description?: Maybe<Scalars['String']['output']>;
    explanations?: Maybe<Array<Scalars['String']['output']>>;
    recommendedOffers?: Maybe<Array<RecommendedOfferType>>;
    version: Scalars['String']['output'];
};

/** Base high res photo mixed source from non-MLS source (e.g. LMS) */
export type MixedSource = {
    url: Scalars['String']['output'];
    width: Scalars['Int']['output'];
};

/** Base high res photo mixed sources from non-MLS source (e.g. LMS) */
export type MixedSources = {
    jpeg: Array<MixedSource>;
    webp: Array<MixedSource>;
};

export type MobileUser = {
    mpid: Scalars['String']['output'];
    upsForRentLongTermHistograms?: Maybe<MpidUpsForRentLongTermHistograms>;
    upsForSaleLongTermHistograms?: Maybe<MpidUpsForSaleLongTermHistograms>;
};

export type MobileUserupsForRentLongTermHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type MobileUserupsForSaleLongTermHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type MockSearchRuleBehaviors = {
    /** Whether should apply AdRestrictionsInPlace */
    adsRestricted?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply AppendAgentLicenseToAgentName */
    appendAgentLicenseToAgentNameApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply AppendBrokerageToListOfficeName */
    appendBrokerageToListOfficeName?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplayAuctionStatusAsSold */
    displayAuctionStatusAsSoldApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplayBuilderNameOnListCard */
    displayBuilderNameOnListCardApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplayListAgentNameOnListCard */
    displayListAgentNameApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplayListAgentPhoneNumberOnListCard */
    displayListAgentPhoneNumberApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * Whether should apply DisplayListOfficeNameOnListCard/DisplayListOfficeNameOnListCardForState
     * DisplayListOfficeNameForStateForRent
     */
    displayListOfficeNameApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * Whether should apply DisplayListOfficePhoneNumberOnListCard
     * DisplayListOfficePhoneNumberOnListCardForState/DisplayListOfficePhoneNumberOnListCardForStateForRent
     */
    displayListOfficePhoneNumberApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplayListingIdOnListCard */
    displayListingIdApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplayMLSListOfficeOnMapMarkerCard */
    displayMLSListOfficeOnMapMarkerCardApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplayMLSListingIdOnMapMarkerCard */
    displayMLSListingIdOnMapMarkerCardApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplayMLSLogoOnMapMarkerCard */
    displayMLSLogoOnMapMarkerCardApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplayMLSNameOnListCard */
    displayMLSNameApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplayMLSStatusOnListCard */
    displayMLSStatusApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplayMLSLogoOnListCard */
    displayProviderLogoApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplaySoldByOfficeNameOnListCard */
    displaySoldByOfficeNameOnListCardApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DisplaySourceAddress */
    displaySourceAddressApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply DonotCropPhotos */
    donotCropPhotoApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply HideActualSqft */
    hideActualSqftApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether to hide the address, note there's no rule for this and PSL is checking isUndisclosedAddress flag */
    hideAddressApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply HideDaysOnMarketFlexField */
    hideDaysOnMarketFlexFieldApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply HideListingId */
    hideListingIdApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply HideMapPinWithFlag */
    hideMapPinApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply CannotShowNonIDXMedia */
    hideNonIDXMediaApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply HidePhotosSold */
    hidePhotosApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply HidePriceAdjustmentFlexField */
    hidePriceAdjustmentFlexFieldApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply HidePriceEstimate */
    hidePriceEstimateApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply HidePriceHistory */
    hidePriceHistoryApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply HidePriceHistoryOnSold */
    hidePriceHistoryOnSoldApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply HidePricePerSqft */
    hidePricePerSqftApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply HideSoldPriceForState */
    hideSoldPriceForStateApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** The value of search result should limit when apply LimitSearchResults */
    limitSearchResultsValue?: InputMaybe<Scalars['Int']['input']>;
    /** Whether should apply MustDisplayHoaFeeFrequencyAnnually */
    mustDisplayHoaFeeFrequencyAnnuallyApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply MustDisplayLotSizeInAcres */
    mustDisplayLotSizeInAcresApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether should apply OnlyFirstPhotoPending/OnlyFirstPhotoSold/OnlyFirstPhotoSoldAndOlderThan */
    onlyFirstPhotoApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /** The Attribution copy value when apply DisplayAttributionCopyForState/DisplayAttributionCopyForStateForRent */
    requiredAttributionCopy?: InputMaybe<Scalars['String']['input']>;
    /** Whether should apply SuperTrafficOptimized */
    superTrafficOptimizedApplicable?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Vendor-provided model home address */
export type ModelHomeAddress = {
    city: Scalars['String']['output'];
    latitude?: Maybe<Scalars['String']['output']>;
    longitude?: Maybe<Scalars['String']['output']>;
    postalCode: Scalars['String']['output'];
    state: Scalars['String']['output'];
    street1: Scalars['String']['output'];
    street2?: Maybe<Scalars['String']['output']>;
};

export type ModelHomeInfo = {
    /** Full address of the model home */
    address?: Maybe<ModelHomeAddress>;
    /** Distance from the actual property to the model home */
    distanceToModelHome?: Maybe<Scalars['Int']['output']>;
    /** Whether tour is for a representative property or the actual property */
    hasModelHome?: Maybe<Scalars['Boolean']['output']>;
    /** Plan name of the model home */
    planName?: Maybe<Scalars['String']['output']>;
};

/** The recommended placement for the module on the page. */
export type ModulePlacement = 'NEIGHBORHOOD' | 'RECOMMENDATION';

export type MonthlyCostCalculator = {
    /** The mortgage CTA that needs to be shown on the FSHDP Monthly Cost Calculator when appropriate */
    mortgageCTA?: Maybe<MortgageCTA>;
};

export type MonthlyCostFilter = {
    /** Down payment put on a home */
    downPaymentAmount?: InputMaybe<Scalars['Int']['input']>;
    /**
     * Annual interest rate percentage used to calculate monthly mortgage payment
     * which affects total monthly payment
     */
    interestRate?: InputMaybe<Scalars['Float']['input']>;
    /**
     * Loan term (in years) used to calculate monthly mortgage payment
     * which affects total monthly payment
     */
    loanTerm?: InputMaybe<Scalars['Int']['input']>;
    /**
     * Only include properties with a monthly cost
     * within this range
     */
    monthlyCost?: InputMaybe<MinMaxInteger>;
};

export type Mortgage = {
    dedicatedLoanOfficerTeam?: Maybe<Array<DedicatedLoanOfficer>>;
    displayStrings: DisplayStrings;
    eventDateTime?: Maybe<Scalars['String']['output']>;
    isPreferredLoanOfficerDisabled?: Maybe<Scalars['Boolean']['output']>;
    loanFileServiceId?: Maybe<Scalars['String']['output']>;
    loanOfficer?: Maybe<LoanOfficer>;
    mortgageStage: MortgageStage;
    /** @deprecated Moved to mortgageStage to also include loan Status */
    mortgageStatus: MortgageStatus;
    opportunityData?: Maybe<OpportunityData>;
    preferredLoanOfficerConnectionStatus?: Maybe<PreferredLoanOfficerConnectionStatus>;
};

export type MortgageCTA = {
    /** This is copy text/ label that will be shown on the mortgage CTA on the FSHDP Chip */
    ctaCopyText?: Maybe<Scalars['String']['output']>;
    /** When the CTA is clicked, this is the URL with parameters that the user will be routed to */
    routingURL?: Maybe<Scalars['String']['output']>;
};

export type MortgageCalculationAssumptionsSection = {
    creditScore?: Maybe<MortgageLineItem>;
    downPayment?: Maybe<MortgageLineItem>;
    homePrice?: Maybe<MortgageLineItem>;
    interestRate?: Maybe<MortgageLineItem>;
    loanProgram?: Maybe<MortgageLineItem>;
    /** this will hold the title string for the assumptions section of the personalized payment output */
    title?: Maybe<Scalars['String']['output']>;
};

export type MortgageCalculationBreakdownSection = {
    monthlyHOADues?: Maybe<MortgageLineItem>;
    monthlyHomeInsurance?: Maybe<MortgageLineItem>;
    monthlyPI?: Maybe<MortgageLineItem>;
    monthlyPMI?: Maybe<MortgageLineItem>;
    monthlyPropertyTaxes?: Maybe<MortgageLineItem>;
    /** this will hold the title string for the breakdown section */
    title?: Maybe<Scalars['String']['output']>;
    /** Tooltip for the payment breakdown on the output screen */
    tooltip?: Maybe<MortgageTooltipInline>;
};

export type MortgageChip = {
    /** This is copy text/ label that will be shown on the FSHDP Chip */
    chipCopyText?: Maybe<Scalars['String']['output']>;
    /** information on whether or not there is an active experiment, name of trial & treatment */
    chipExperiment?: Maybe<MortgageExperiment>;
    /** this will be non-null if and only if the chip returned is the personalizable chip */
    inlineTooltip?: Maybe<MortgageTooltipInline>;
    /** This value will indicate if or not the mortgage chip returned is the personalizable chip */
    isPersonalized?: Maybe<Scalars['Boolean']['output']>;
    /**
     * The mortgage CTA that needs to be shown on the FSHDP Chip when
     * appropriate.This depends on if the property qualifies for the Mortgage Chip.
     * If there is an experiment running, the content can vary based on what
     * treatment or control is assigned to the client
     */
    mortgageCTA?: Maybe<MortgageCTA>;
    /** provides information on whether or not the client should display the mortgage CTA */
    showCTA?: Maybe<Scalars['Boolean']['output']>;
    /** provides information on whether or not the client should display the dollar icon */
    showDollarIcon?: Maybe<Scalars['Boolean']['output']>;
    /** this will be true if and only if the chip is personalizable and the inline tooltip should be shown */
    showInlineTooltip?: Maybe<Scalars['Boolean']['output']>;
    /** provides information on whether or not the client should display the tooltip */
    showTooltip?: Maybe<Scalars['Boolean']['output']>;
    /** provides information on whether or not the client should display the total monthly cost */
    showTotalMonthlyCost?: Maybe<Scalars['Boolean']['output']>;
    /** The tooltip text that provides information on the mortgage CTA eg: disclaimer for mortgage rates */
    tooltipCopyText?: Maybe<Scalars['String']['output']>;
};

export type MortgageCreditRangeSection = {
    /** The label on the PP input screen for the credit score input UI */
    labelCopy?: Maybe<Scalars['String']['output']>;
    /** The strings that are listed as the Credit score ranges in the UI. */
    rangeDropdownItems?: Maybe<MortgageUICreditRanges>;
    /** The tooltip that provides user information on how Credit Score factors in the calculations */
    tooltip?: Maybe<MortgageTooltipInline>;
};

export type MortgageDownPaymentSection = {
    amountCopy?: Maybe<Scalars['String']['output']>;
    amountInCurrency?: Maybe<Scalars['String']['output']>;
    currencyHelperText?: Maybe<Scalars['String']['output']>;
    downpaymentCopy?: Maybe<Scalars['String']['output']>;
    helperText?: Maybe<Scalars['String']['output']>;
    inPercentage?: Maybe<Scalars['String']['output']>;
    percentageCopy?: Maybe<Scalars['String']['output']>;
    percentageHelperText?: Maybe<Scalars['String']['output']>;
    /** The tooltip that provides user information on Down Payment */
    tooltip?: Maybe<MortgageTooltipInline>;
    usePercentage?: Maybe<Scalars['Boolean']['output']>;
};

export type MortgageExperiment = {
    /** true if this is an active experiment, false otherwise */
    isActiveExperiment?: Maybe<Scalars['Boolean']['output']>;
    /** name of the assigned and applied treatment of the active AB trial, empty otherwise */
    treatmentName?: Maybe<Scalars['String']['output']>;
    /** name of the active AB trial, empty otherwise */
    trialName?: Maybe<Scalars['String']['output']>;
};

export type MortgageHero = {
    /** This will hold the body text to display on the hero */
    bodyText?: Maybe<Scalars['String']['output']>;
    /** This will hold the CTA displayed at the bottom of the Hero, which will differ between the hub and the spoke */
    cta?: Maybe<MortgageCTA>;
    /** This will hold the string that holds the total estimated payment calculated. eg: $12,500/month' */
    estMonthlyPayment?: Maybe<Scalars['String']['output']>;
    /** This will hold the HOA dues portion aka line item of the total estimated payment */
    monthlyHOAFees?: Maybe<MortgageLineItem>;
    /** This will hold the P & I portion aka line item of the total estimated payment */
    monthlyPrincipalAndInterest?: Maybe<MortgageLineItem>;
    /** This will hold the taxes and insurance portion aka line item of the total estimated payment */
    monthlyTaxesAndInsurance?: Maybe<MortgageLineItem>;
    /**
     * This will be set to true for the hub to show the tooltip next to the
     * 'Estimated payment' title. N/A for the hub at this point
     */
    showTitleTooltip?: Maybe<Scalars['Boolean']['output']>;
    /** This will be the title within the hero, eg: 'Estimated payment' in the hub but would be different in the Spoke */
    title?: Maybe<Scalars['String']['output']>;
    /** This will hold the copy text that explains what an estimated payment is and also contain the link to ZHL's privacy policy */
    titleTooltip?: Maybe<MortgageTooltipInline>;
};

export type MortgageHub = {
    /** this will hold the data to display in the mortgage hero part of the hub */
    hubHero?: Maybe<MortgageHero>;
};

export type MortgageLineItem = {
    copy?: Maybe<Scalars['String']['output']>;
    percentageOfTotal?: Maybe<Scalars['Int']['output']>;
    showTooltip?: Maybe<Scalars['Boolean']['output']>;
    tooltip?: Maybe<MortgageTooltipInline>;
    /** @deprecated Use tooltip instead */
    tooltipCopy?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type MortgageLink = {
    /** The copy text that will be used in the UI but route to the link that the field below will hold */
    copy?: Maybe<Scalars['String']['output']>;
    /**
     * the url to which the user should be routed, this field will also contain any
     * routing parameters that are applicable to the scenario and user
     */
    link?: Maybe<Scalars['String']['output']>;
};

export type MortgagePersonalizedPaymentData = {
    hub?: Maybe<MortgageHub>;
    spoke?: Maybe<MortgageSpoke>;
};

export type MortgagePersonalizedPaymentInputScreen = {
    /** this will hold the credit score ranges for the credit range section of the input screen */
    creditRangeSection?: Maybe<MortgageCreditRangeSection>;
    /** this will contain the CTA data that shows below the hero in the spoke */
    cta?: Maybe<MortgageCTA>;
    /** this will represent the downpayment section of the input screen */
    dowpaymentSection?: Maybe<MortgageDownPaymentSection>;
    footerPersonalization?: Maybe<Scalars['String']['output']>;
    loginAndSaveActionButtonCopy?: Maybe<Scalars['String']['output']>;
    privacyPolicyLink?: Maybe<MortgageLink>;
    privacyPolicyText?: Maybe<Scalars['String']['output']>;
    saveActionButtonCopy?: Maybe<Scalars['String']['output']>;
};

export type MortgagePersonalizedPaymentOutputScreen = {
    /** The address to display on the output screen */
    address?: Maybe<Scalars['String']['output']>;
    assumptions?: Maybe<MortgageCalculationAssumptionsSection>;
    breakdown?: Maybe<MortgageCalculationBreakdownSection>;
    /** Data to show the breakdown hero on the output screen */
    breakdownHero?: Maybe<MortgageHero>;
    /** The title for the output screen */
    title?: Maybe<Scalars['String']['output']>;
    /** The tooltip for the title */
    titleTooltip?: Maybe<MortgageTooltipInline>;
};

/** rent your money */
export type MortgageRates = {
    /** @deprecated To be turned into an object */
    arm5Rate?: Maybe<Scalars['Float']['output']>;
    /** @deprecated To be turned into an object */
    fifteenYearFixedRate?: Maybe<Scalars['Float']['output']>;
    /** @deprecated To be turned into an object */
    thirtyYearFixedRate?: Maybe<Scalars['Float']['output']>;
};

export type MortgageReferral = {
    updateDate?: Maybe<Scalars['DateTime']['output']>;
};

export type MortgageSpoke = {
    /**  The address of the HDP property */
    address?: Maybe<Scalars['String']['output']>;
    /** The body text to display for the spoke */
    bodyText?: Maybe<Scalars['String']['output']>;
    inputScreen?: Maybe<MortgagePersonalizedPaymentInputScreen>;
    outputScreen?: Maybe<MortgagePersonalizedPaymentOutputScreen>;
    spokeHero?: Maybe<MortgageHero>;
    /** The data to display the sticky header when we scroll past the hero */
    stickyHeader?: Maybe<StickyHeader>;
    /** The title for the spoke, currently expected to be 'Estimated payment' */
    title?: Maybe<Scalars['String']['output']>;
    /** The tooltip that provides user information on what estimated payment is */
    titleTooltip?: Maybe<MortgageTooltipInline>;
};

export type MortgageStage =
    | 'ClosedFunded'
    | 'ClosedLost'
    | 'Closing'
    | 'Contacting'
    | 'Converted'
    | 'Discovery'
    | 'Funding'
    | 'Ineligible'
    | 'InitialDisclosure'
    | 'LoanApplication'
    | 'LoanSetup'
    | 'New'
    | 'Pending'
    | 'PreApproval'
    | 'Processing'
    | 'Qualification'
    | 'Rejected'
    | 'Unassigned'
    | 'Underwriting'
    | 'Unqualified';

export type MortgageStatus =
    | 'Contacting'
    | 'Converted'
    | 'Discovery'
    | 'Ineligible'
    | 'New'
    | 'Pending'
    | 'PreApproval'
    | 'Qualification'
    | 'Rejected'
    | 'Unassigned'
    | 'Unqualified';

export type MortgageTooltipInline = {
    /** The informational tooltip text */
    bodyCopy?: Maybe<Scalars['String']['output']>;
    /** Link to display in the tooltip */
    mortgageLink?: Maybe<Array<Maybe<MortgageLink>>>;
    title?: Maybe<Scalars['String']['output']>;
};

export type MortgageUICreditRanges = {
    /** Should hold the second highest credit score range, which is currently (660 - 719) */
    highRangeCopy?: Maybe<Scalars['String']['output']>;
    /** Should hold the highest credit score range, which is currently (720-840) */
    highestRangeCopy?: Maybe<Scalars['String']['output']>;
    /** Should hold the next lower credit score range, which is currently (580 - 619) */
    lowRangeCopy?: Maybe<Scalars['String']['output']>;
    /** Should hold the lowest credit score range, which is currently (300 - 579) */
    lowestRangeCopy?: Maybe<Scalars['String']['output']>;
    /** Should hold the middle credit score range, which is currently (620 - 659) */
    middleRangeCopy?: Maybe<Scalars['String']['output']>;
};

/** rent your money */
export type MortgageZHLRates = {
    arm5Bucket?: Maybe<Arm5Bucket>;
    fifteenYearFixedBucket?: Maybe<FifteenYearFixedBucket>;
    thirtyYearFixedBucket?: Maybe<ThirtyYearFixedBucket>;
};

/** Mortgage rate */
export type MortgageZHLRatesByCreditScore = {
    thirtyYearFixedBucket?: Maybe<ThirtyYearFixedBucketByCreditScore>;
};

export type MoveInCostsDetails = {
    dueDate?: Maybe<Scalars['String']['output']>;
    isScheduled?: Maybe<Scalars['Boolean']['output']>;
    paymentCategory?: Maybe<Scalars['String']['output']>;
    sendDate?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    totalAmount?: Maybe<Scalars['Int']['output']>;
};

export type MoveInReportCard = {
    cta?: Maybe<RenterHubCta>;
    description?: Maybe<Scalars['String']['output']>;
};

/**
 *  Histograms generated for MPID-identified Trulia users in the context of For Rent properties and batch/offline
 * *  histogram computation. The "Long Term" suffux here indicates original assumption of using longer historical
 * *	user events to calculate the histograms. Should this Long Term assumption become invalid in future, it is suggested
 * 	to deprecate this set and create a more generic "offline" set instead.
 */
export type MpidUpsForRentLongTermHistograms = {
    /**  Histograms calculated as part of the For Rent Long Term experience  */
    histograms?: Maybe<MpidUpsForRentLongTermHistograms_LongTermHistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Trulia user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  MPID - the devide ID that uniquely identifies a user interacting with Trulia  */
    mpid: Scalars['String']['output'];
    /**  History of rental properties viewed by the known Trulia user with the most recent views first  */
    viewHistory?: Maybe<Array<MpidUpsForRentLongTermHistograms_ViewHistoryRecord>>;
};

/**  Record contains time-decayed histogram fields based on Trulia properties a user has viewed on site.  */
export type MpidUpsForRentLongTermHistograms_LongTermHistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Internal representation for more granular city allocation  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Crime score of the viewed properties  */
    crimeScore?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure based on hash representation of longitude/latitude of viewed properties.  */
    geohash5?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure extended to geohash neighbors  */
    geohash5Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure based on hash representation of longitude/latitude of viewed properties.  */
    geohash6?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure extended to geohash neighbors  */
    geohash6Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  Whether or not the viewed properties allow pets  */
    petsAllowed?: Maybe<Scalars['JSON']['output']>;
    /**  Rental price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Rent price per bedroom  */
    pricePerBedroom?: Maybe<Scalars['JSON']['output']>;
    /** @deprecated This field no longer exists based on the latest generated schema. */
    rentPricePerBedroom?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a trulia property was viewed, and for how long it was viewed, by a user.  */
export type MpidUpsForRentLongTermHistograms_ViewHistoryRecord = {
    /**  dwell in seconds for the user viewed the property (specified by propertyId)  */
    dwellSeconds?: Maybe<Scalars['Int']['output']>;
    /**  idType - Unique identifier for types of property ids. 0: zpid, 1: tpid  */
    idType?: Maybe<Scalars['Int']['output']>;
    /**  propertyId - Unique identifier for a property viewed by a user.  */
    propertyId?: Maybe<Scalars['String']['output']>;
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
};

/**
 *  Histograms generated for MPID-identified Trulia users in the context of For Sale properties and batch/offline
 * *  histogram computation. The "Long Term" suffux here indicates original assumption of using longer historical
 * *	user events to calculate the histograms. Should this Long Term assumption become invalid in future, it is suggested
 * 	to deprecate this set and create a more generic "offline" set instead.
 */
export type MpidUpsForSaleLongTermHistograms = {
    /**  Histograms calculated as part of the For Sale Long Term experience  */
    histograms?: Maybe<MpidUpsForSaleLongTermHistograms_LongTermHistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Trulia user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  MPID - the Mobile ID that uniquely identifies an user interacting with Trulia  */
    mpid: Scalars['String']['output'];
    /**  History of rental properties viewed by the Trulia user with the most recent views first  */
    viewHistory?: Maybe<Array<MpidUpsForSaleLongTermHistograms_ViewHistoryRecord>>;
};

/**  Record contains time-decayed histogram fields based on Trulia properties a user has viewed on site.  */
export type MpidUpsForSaleLongTermHistograms_LongTermHistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Internal representation for more granular city allocation  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Crime score of the viewed properties  */
    crimeScore?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure based on hash representation of longitude/latitude of viewed properties.  */
    geohash5?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure extended to geohash neighbors  */
    geohash5Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure based on hash representation of longitude/latitude of viewed properties.  */
    geohash6?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure extended to geohash neighbors  */
    geohash6Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies whether the land is vacant or not  */
    isVacantLand?: Maybe<Scalars['JSON']['output']>;
    /**  Rental price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a trulia property was viewed, and for how long it was viewed, by a user.  */
export type MpidUpsForSaleLongTermHistograms_ViewHistoryRecord = {
    /**  dwell in seconds for the user viewed the property (specified by propertyId)  */
    dwellSeconds?: Maybe<Scalars['Int']['output']>;
    /**  idType - Unique identifier for types of property ids. 0: zpid, 1: tpid  */
    idType?: Maybe<Scalars['Int']['output']>;
    /**  propertyId - Unique identifier for a property viewed by a user.  */
    propertyId?: Maybe<Scalars['String']['output']>;
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
};

export type MrktListing = {
    forSaleInventory?: Maybe<Scalars['Float']['output']>;
    marketTempIndex?: Maybe<Scalars['Float']['output']>;
    marketTempLabel?: Maybe<Scalars['String']['output']>;
    meanDaysToPending?: Maybe<Scalars['Float']['output']>;
    meanListingsPriceCutAmt?: Maybe<Scalars['Float']['output']>;
    meanListingsPriceCutPerc?: Maybe<Scalars['Float']['output']>;
    medianDaysToPending?: Maybe<Scalars['Float']['output']>;
    medianListPrice?: Maybe<Scalars['Float']['output']>;
    medianListingsPriceCutAmt?: Maybe<Scalars['Float']['output']>;
    medianListingsPriceCutPerc?: Maybe<Scalars['Float']['output']>;
    metadataKey: Scalars['String']['output'];
    newListings?: Maybe<Scalars['Float']['output']>;
    newPending?: Maybe<Scalars['Float']['output']>;
    percListingsPriceCut?: Maybe<Scalars['Float']['output']>;
    regionId: Scalars['Int']['output'];
    timePeriodEnd: Scalars['Date']['output'];
};

export type MrktSale = {
    meanDaysToClose?: Maybe<Scalars['Float']['output']>;
    meanSalePrice?: Maybe<Scalars['Float']['output']>;
    meanSaleToList?: Maybe<Scalars['Float']['output']>;
    medianDaysToClose?: Maybe<Scalars['Float']['output']>;
    medianSalePrice?: Maybe<Scalars['Float']['output']>;
    medianSaleToList?: Maybe<Scalars['Float']['output']>;
    metadataKey: Scalars['String']['output'];
    newConMeanSalePrice?: Maybe<Scalars['Float']['output']>;
    newConMedianSalePrice?: Maybe<Scalars['Float']['output']>;
    newConMedianSalePricePerSqft?: Maybe<Scalars['Float']['output']>;
    newConSalesCountRaw?: Maybe<Scalars['Float']['output']>;
    pctSoldAboveList?: Maybe<Scalars['Float']['output']>;
    pctSoldBelowList?: Maybe<Scalars['Float']['output']>;
    regionId: Scalars['Int']['output'];
    timePeriodEnd: Scalars['Date']['output'];
    totalTransactionValue?: Maybe<Scalars['Float']['output']>;
};

export type MrktTemperature = {
    marketTempIndex?: Maybe<Scalars['Float']['output']>;
    marketTempIsImputed?: Maybe<Scalars['Int']['output']>;
    marketTempLabel?: Maybe<Scalars['String']['output']>;
    marketTempLabelDescription?: Maybe<Scalars['String']['output']>;
    metadataKey: Scalars['String']['output'];
    regionId: Scalars['Int']['output'];
    timePeriodEnd: Scalars['Date']['output'];
};

export type MultiFactorAuthData = {
    isEnabled: Scalars['Boolean']['output'];
    phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** A set of image source sets */
export type MultiImageSourceType = {
    /** JPEG Source Set */
    jpeg?: Maybe<Array<Maybe<ResponsiveImageSource>>>;
    /** WEBP Source Set */
    webp?: Maybe<Array<Maybe<ResponsiveImageSource>>>;
};

export type MultipleChoiceAnswerOption = {
    labelText: Scalars['String']['output'];
    submitValue: Scalars['String']['output'];
};

export type MultipleChoiceQuestion = FormQuestion & {
    answerOptions: Array<Maybe<MultipleChoiceAnswerOption>>;
    inputName: Scalars['String']['output'];
    questionIcon: Scalars['String']['output'];
    questionText: Scalars['String']['output'];
};

/** When a single CTA button may need to do multiple Nav Actions. */
export type MultipleZHLNavAction = ZHLNavAction & {
    analyticsTag?: Maybe<Scalars['String']['output']>;
    urlExperience: Array<Maybe<ZHLUrlNavExperience>>;
};

export type MutateServiceAgreementResponse = {
    agreement?: Maybe<ServiceAgreement>;
    errors?: Maybe<Array<ServiceAgreementError>>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type Mutation = {
    _noop?: Maybe<Scalars['String']['output']>;
    /**  accept the coShopping invitation from the inviter  */
    acceptCoShopper?: Maybe<Scalars['Boolean']['output']>;
    acceptIcraa?: Maybe<IcraaPageConfig>;
    acceptInvitation?: Maybe<RentalApplication>;
    acceptLandlordInvitation?: Maybe<RentalApplication>;
    acceptLegalCompliance?: Maybe<LegalCompliance>;
    /**  mark that a seller was sent to the dashboard link  */
    acceptOdReferral: OffersResult;
    /** Activate a previously created loan in Blend */
    activateBlendLoan?: Maybe<ActivateBlendLoanOutput>;
    activateMACUser?: Maybe<ActivateMACUserOutput>;
    activateZHLDashboardUser: ZHLDashboardUserActivationResult;
    addCommuteDestination?: Maybe<CommuteResponseType>;
    addCurrentIncome?: Maybe<CurrentIncome>;
    addPastJob?: Maybe<PastJob>;
    addPastResidence?: Maybe<PastResidence>;
    addQuestionnaire?: Maybe<Scalars['Boolean']['output']>;
    /**  add a category to an existing saved home's category list  */
    addSavedHomeCategory?: Maybe<Scalars['Boolean']['output']>;
    /** Add a self-reported visit for a given user to a specific ZPID */
    addVisitedHome?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** View the touring agreement. Creates one if it does not exist.
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Appointment created on behalf of a logged in agent
     */
    agentCreateTouringAgreement?: Maybe<MutateServiceAgreementResponse>;
    /**
     * **Definition:** Buyer agent initiated tour appointment time update
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    agentRescheduleTourAppointment?: Maybe<AgentRescheduleTourAppointmentResponse>;
    /**
     * **Definition:** Agent signs the touring agreement
     * The signerTimeZone argument is ignored
     * This is currently only used for testing MVP and does not adhere to P1 requirements
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Logged in user must be the agent associated with the provided zDocsId
     */
    agentSignTouringAgreement?: Maybe<MutateServiceAgreementResponse>;
    /**  apply a custom property tag text on a given property */
    applyCustomPropertyTag?: Maybe<Scalars['Boolean']['output']>;
    /**  apply a property tag on a given property  */
    applyPropertyTag?: Maybe<Scalars['Boolean']['output']>;
    approveApplication?: Maybe<LandlordRentalApplication>;
    /**
     * This mutation archives an existing task.
     * @deprecated Do not use this mutation in prod. Use the dev environment instead.
     */
    archiveTask?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Buyer signs the touring agreement
     * The signerTimeZone argument is ignored
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Signs agreement for the logged in buyer
     */
    buyerSignTouringAgreement?: Maybe<MutateServiceAgreementResponse>;
    /**
     * **Definition:** Buyer updates a touring agreement field
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Update Touring Agreement field from buyer's side
     */
    buyerUpdateTouringAgreementField?: Maybe<MutateServiceAgreementResponse>;
    /**
     * **Definition:** Requests cancellation of a scheduled tour appointment
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer"
     */
    cancelTourAppointment?: Maybe<CancellationResponse>;
    /**
     * **Definition:** Agent initiated showing time cancellation of a tour appointment
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    cancelTourAppointmentInShowingTime?: Maybe<ShowingTimeCancellationResponse>;
    /** Adds/Updates the confirmed claim on a property for the current user */
    claimHome?: Maybe<ClaimResponse>;
    /** Connect a ZHL Borrower with ZGMI */
    connectZHLBorrowerWithZGMI?: Maybe<IDOutput>;
    /**
     * **Definition:** Mutation for self pausing an agent
     * **Datasource:** agentselfpause (agentavailability DB)
     *
     * **Team Slack:** #apex-eng
     */
    createAgentSelfPause?: Maybe<PAAgentSelfPause>;
    createBorrower?: Maybe<SuccessOutput>;
    createBorrowerPair: CreateBorrowerPairOutput;
    /**
     * **Definition:** mutation to create a note
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    createContactNote?: Maybe<PAContactNoteCreationPayload>;
    createFlexTransaction?: Maybe<CreateFlexTxnResponse>;
    /** Create the implicit claim on a property for the current user */
    createImplicitClaim?: Maybe<ClaimResponse>;
    /**  trigger new offers creation for seller dashboard  */
    createOffers: Scalars['ID']['output'];
    /**
     * **Definition:** Mutation to create a MBP contact.
     *
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    createPAContact?: Maybe<CreatePAContactPayload>;
    /** Create proof of insurance entry from zDocs messageToken */
    createProofOfInsurance?: Maybe<CreateProofOfInsuranceResponse>;
    /**
     * This mutation creates a new task, then returns the created task.
     * @deprecated Do not use this mutation in prod. Use the dev environment instead.
     */
    createTask?: Maybe<HubTask>;
    createTransaction?: Maybe<PATransactionPayload>;
    /**  add user note on a given property  */
    createUserNote?: Maybe<CreateUserNoteResponse>;
    /** Creates the verified claim on a property for the current user */
    createVerifiedClaim?: Maybe<ClaimResponse>;
    createZHLAutomatedTasks?: Maybe<ZHLCreateAutomatedTasksPayload>;
    /** Creates a ZHL Borrower's Assets */
    createZHLBorrowerAsset?: Maybe<ZHLBorrowerAsset>;
    /** Create ZHL Borrower Employment */
    createZHLBorrowerEmployment?: Maybe<ZHLBorrowerEmployment>;
    /** Create Borrower Other Income */
    createZHLBorrowerOtherIncome?: Maybe<ZHLBorrowerOtherIncome>;
    /** Create a document for the loan */
    createZHLDocument?: Maybe<ZHLDocument>;
    createZHLPlaidLink?: Maybe<ZHLCreatePlaidLinkPayload>;
    /** Create a ZHL purchase lead */
    createZHLPurchaseLead?: Maybe<ZHLPreQualPurchaseLead>;
    createZHLTask?: Maybe<ZHLCreateTaskPayload>;
    createZHLTasksForLFSRecord?: Maybe<ZHLCreateTasksForLFSRecordPayload>;
    /**
     *  mutation to compute In/Out market value for sellside and buyside questionnaire submission
     * @deprecated cross-sell deprecation
     */
    decideMarketScopeForBuyAndSell?: Maybe<Scalars['Boolean']['output']>;
    /**  decline the coShopping invitation from the inviter  */
    declineCoShopper?: Maybe<Scalars['Boolean']['output']>;
    deleteAnswers?: Maybe<Answers>;
    deleteBorrower?: Maybe<DeleteBorrowerOutput>;
    /** Deletes verified, confirmed, and implicit claims on the property and user pair */
    deleteClaims?: Maybe<ClaimResponse>;
    deleteCommuteDestination?: Maybe<Scalars['String']['output']>;
    deleteCurrentIncome?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Mutation to delete (soft delete) a contact
     *
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     * @deprecated Not implemented yet
     */
    deletePAContact?: Maybe<DeletePAContactPayload>;
    deletePATask?: Maybe<PATask>;
    deletePastJob?: Maybe<Scalars['Boolean']['output']>;
    deletePastResidence?: Maybe<Scalars['Boolean']['output']>;
    /**  delete the property tag */
    deletePropertyTag?: Maybe<Scalars['Boolean']['output']>;
    deleteSavedSearch?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Deletes the connection target for a team member
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT token:** identifies team lead
     */
    deleteTeamMemberConnectionTarget?: Maybe<DeleteTeamMemberConnectionTargetResult>;
    /**  remove user note from the given property  */
    deleteUserNote?: Maybe<Scalars['Boolean']['output']>;
    /** Deletes the verified claim on a property */
    deleteVerifiedClaimByPropertyId?: Maybe<ClaimResponse>;
    /** Deletes a ZHL Borrower's Asset */
    deleteZHLBorrowerAsset?: Maybe<ZHLBorrowerAsset>;
    /** Delete ZHL Borrower Employment */
    deleteZHLBorrowerEmployment?: Maybe<ZHLBorrowerEmployment>;
    /** Delete Borrower Other Income */
    deleteZHLBorrowerOtherIncome?: Maybe<ZHLBorrowerOtherIncome>;
    deleteZHLDocumentRequest?: Maybe<ZHLTask>;
    deleteZHLTask?: Maybe<ZHLTask>;
    /** Dismiss the specified renter hub notifications */
    dismissNotifications?: Maybe<Scalars['Boolean']['output']>;
    editFlexTransaction?: Maybe<EditFlexTransactionResponse>;
    editInvitation?: Maybe<SentCoapplicantInvitation>;
    /** Edits a ZHL Borrower's Asset */
    editZHLBorrowerAsset?: Maybe<ZHLBorrowerAsset>;
    /** Edit the attributes for a ZHL Borrower */
    editZHLBorrowerAttributes?: Maybe<IDOutput>;
    /** Edit ZHL Borrower Employment */
    editZHLBorrowerEmployment?: Maybe<ZHLBorrowerEmployment>;
    /** Edit Borrower Other Income */
    editZHLBorrowerOtherIncome?: Maybe<ZHLBorrowerOtherIncome>;
    /** Edit the attributes of a ZHL Loan */
    editZHLLoanAttributes?: Maybe<EditZHLLoanAttributesOutput>;
    /** **Definition:** Mutation for ending an agent's self pause */
    endAgentSelfPause?: Maybe<PAAgentSelfPause>;
    flagHighlight?: Maybe<FlagHighlightResult>;
    generateZHLDashboardUserActivationToken: ZHLDashboardGenerateActivationTokenResult;
    generateZHLDashboardUserActivationTokenForLead: ZHLDashboardGenerateActivationTokenResult;
    grantHardCreditConsent?: Maybe<GrantHardCreditConsentOutput>;
    /** Grant soft credit consent to the ZHL Borrower */
    grantZHLBorrowerSoftCreditConsent?: Maybe<IDOutput>;
    /**
     * **Definition:** Handles subsequent tour request responses from Alan
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    handleSubsequentTourRequest?: Maybe<SubsequentTourRequestResponse>;
    /**  hide a home (only support zpid now) for the signed in user */
    hideHome?: Maybe<Scalars['Boolean']['output']>;
    hubBulkUpdateResourceStatus: Array<HubResourceStatusPayload>;
    /** Creates a new Journey Plan for a user with the provided move goal. */
    hubCreatePlan: HubIntroOrPlanModule;
    hubResetPlan: HubJourneyIntroModule;
    hubUpdateResourceStatus: HubIntroOrPlanModule;
    /**  invite coShopper. The initiator user shouldn't have any linked or pending link  */
    inviteCoShopper?: Maybe<CoShopperConnection>;
    inviteCoapplicant?: Maybe<SentCoapplicantInvitation>;
    markAcceptedTerms?: Maybe<Array<Maybe<Term>>>;
    markApplicationsAsViewed?: Maybe<Array<Maybe<LandlordRentalApplication>>>;
    markIncomeToRentEligible?: Maybe<LandlordRentalApplication>;
    mergeApplications?: Maybe<LandlordRentalApplication>;
    /** Books a self tour for a new construction property */
    ncScheduleTour?: Maybe<NcScheduleTourResponseType>;
    postHighlight?: Maybe<PostHighlightResult>;
    /**  mutation to re-drive miso Questionnaire datalake payload  */
    redriveMisoDataLakeQuestionnaireData: Scalars['Boolean']['output'];
    /**  remove all the saved homes for the signed in user */
    removeAllSavedHomes?: Maybe<Scalars['Boolean']['output']>;
    /**  remove the applied property tag from the property  */
    removeAppliedPropertyTag?: Maybe<Scalars['Boolean']['output']>;
    /**  remove the user's coShopper  */
    removeCoShopper?: Maybe<Scalars['Boolean']['output']>;
    removeInvitation?: Maybe<Scalars['Boolean']['output']>;
    /**  remove saved home for the signed in user */
    removeSavedHome?: Maybe<Scalars['Boolean']['output']>;
    /**  remove a category from an existing saved home's category list  */
    removeSavedHomeCategory?: Maybe<Scalars['Boolean']['output']>;
    /** Remove a self-reported visit for a given user to a specific ZPID */
    removeVisitedHome?: Maybe<Scalars['Boolean']['output']>;
    replaceCurrentIncomes?: Maybe<Array<Maybe<CurrentIncome>>>;
    replacePastJobs?: Maybe<Array<Maybe<PastJob>>>;
    replacePastResidences?: Maybe<Array<Maybe<PastResidence>>>;
    /**  request agent connection for given offer misoId  */
    requestAgentConnection: Scalars['Boolean']['output'];
    /**  request call from advisor for the given offer misoId  */
    requestCallFromAdvisor: Scalars['Boolean']['output'];
    requestHighlights?: Maybe<RequestHighlightsResult>;
    /**  request LTA connection for given offer misoId  */
    requestLTAAgentConnection: Scalars['Boolean']['output'];
    /**  new version of createOffers, use input and return type for easier Graphql evolution  */
    requestOffersCreation: OfferCreationResponse;
    /**
     *  request Automated Directed Lead (ADL) connection from Pearl
     * @deprecated Use requestAgentConnection
     */
    requestSellingOffersConnection: Scalars['Boolean']['output'];
    /**
     *  request Live Transfer Agent (LTA) connection from Pearl
     * @deprecated Use requestLTAAgentConnection
     */
    requestSellingOffersLTAConnection: Scalars['Boolean']['output'];
    /**
     * **Definition:** Requests buyer-initiated reschedule of a scheduled tour appointment
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer"
     */
    rescheduleTourAppointment?: Maybe<TourAppointmentRescheduleResponse>;
    revokeHardCreditConsent?: Maybe<RevokeHardCreditConsentOutput>;
    saveAnswers?: Maybe<Answers>;
    saveBuyingPowerInputs: BuyingPowerInputsSaveResult;
    saveComps?: Maybe<CompListType>;
    saveCustomRegion?: Maybe<CustomRegion>;
    saveFinancialProfile?: Maybe<FinancialProfile>;
    saveFinancialProfileByEncodedZuid?: Maybe<FinancialProfile>;
    saveFinancialProfileV2?: Maybe<FinancialProfile>;
    saveHome?: Maybe<Scalars['Boolean']['output']>;
    saveHomeV2?: Maybe<Scalars['Boolean']['output']>;
    /**  save a home (zpid or building) for the signed in user, this is new mutation recommended for all new clients */
    saveOrUpdateHome?: Maybe<Scalars['Boolean']['output']>;
    saveSuccessSurvey?: Maybe<Scalars['Boolean']['output']>;
    /** DPA program list email response */
    sendDpaProgramsListEmail?: Maybe<sendEmail>;
    /** Sends password reset email to user */
    sendPasswordResetEmail?: Maybe<passwordReset>;
    /** send a payments notification */
    sendPaymentNotification?: Maybe<SendPaymentNotificationResponse>;
    sendZhlDashboardActivationLinkEmail?: Maybe<Scalars['Boolean']['output']>;
    /**
     * setMoveProfile allows for a move profile to be created or modified by participant refId (zuid) or moveId
     * returns the move id of the move profile that was acted upon by the change
     */
    setMoveProfile?: Maybe<SetBridgeMoveProfileResponse>;
    /** Sets name for a user */
    setUserRealName?: Maybe<nameUpdate>;
    /** Enables ZMA for a user */
    setZMAConsent?: Maybe<enableZMA>;
    startApplication?: Maybe<RentalApplication>;
    storeVoucherToRentCoverage?: Maybe<LandlordRentalApplication>;
    submitApplication?: Maybe<RentalApplication>;
    submitQuestionnaire?: Maybe<SubmitQuestionnaireOutput>;
    /**  Mutation to submit miso ineligible response. This will be exposed in ZG-Graph but this is not used by FE now  */
    submitSellingOptionsIneligibleInfo?: Maybe<Scalars['Boolean']['output']>;
    /**  Mutation to submit Sebastian responses for questionnaire. Deprecated mutation, use upsertMutation  */
    submitSellingOptionsQuestionnaireAnswers?: Maybe<Scalars['Boolean']['output']>;
    submitUserFeedback: FeedbackResponse;
    /** Creates a purchase lead */
    submitZHLLead?: Maybe<IDOutput>;
    /** Toggle digitalExperience for loanId */
    toggleZHLDigitalExperience?: Maybe<ZHLPreQualPurchaseLead>;
    /** Deletes the confirmed claim on a property for the current user */
    unclaimHome?: Maybe<ClaimResponse>;
    /**  remove all hidden homes the user has for the signed in user */
    unhideAllHomes?: Maybe<Scalars['Boolean']['output']>;
    /**  remove a hidden home (only support zpid now) for the signed in user */
    unhideHome?: Maybe<Scalars['Boolean']['output']>;
    unsaveAllHomes?: Maybe<Scalars['Boolean']['output']>;
    unsaveHome?: Maybe<Scalars['Boolean']['output']>;
    unsaveHomeV2?: Maybe<Scalars['Boolean']['output']>;
    updateApplicantLastViewedSnapshotStatusDate?: Maybe<RentalApplication>;
    updateBorrowerAttributes?: Maybe<SuccessOutput>;
    updateCommuteDestination?: Maybe<CommuteResponseType>;
    /**
     * Update a contacted property for a specified CTA
     * It returns the updated contacted property if the update happens
     * Otherwise returns null
     */
    updateContactedRental?: Maybe<UpdateContactedRentalResponse>;
    /** Trigger the contacted rentals cache update for the specified user */
    updateContactedRentalCache?: Maybe<UpdateContactedRentalCacheResponse>;
    /** Update the is archived status of the conversation */
    updateConversationArchivingStatus?: Maybe<UpdateMessageStatusResponse>;
    updateCurrentIncome?: Maybe<CurrentIncome>;
    updateFavoritesPageSort?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Mutation to update a contact
     *
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     * @deprecated Not implemented yet
     */
    updatePAContact?: Maybe<UpdatePAContactPayload>;
    updatePATask?: Maybe<PATask>;
    /**
     * **Definition:** mutation to update external tags for a bulk list of contactIds
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    updatePaContactExternalManagedTagBulk?: Maybe<PaContactManagedTagUpdatePayload>;
    /**  mark the list of properties as viewed for the user */
    updatePropertyView?: Maybe<Scalars['Boolean']['output']>;
    updateSavedSearchFrequency?: Maybe<Scalars['Boolean']['output']>;
    updateSavedSearchName?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Not implemented yet. Hackweek26 Agent Self Pause */
    updateSelfPause?: Maybe<PASelfPause>;
    /**  CCPA purpose only, mutation to update Sebastian responses  */
    updateSellingOptionsQuestionnaireAnswers?: Maybe<Scalars['Boolean']['output']>;
    /**
     * This mutation updates an existing task.
     * @deprecated Do not use this mutation in prod. Use the dev environment instead.
     */
    updateTask?: Maybe<HubTask>;
    /**
     * **Definition:** Updates the connection target for a team member
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT token:** identifies team lead
     */
    updateTeamMemberConnectionTarget?: Maybe<UpdateTeamMemberConnectionTargetResult>;
    /**
     * **Definition:** Updates the connection target for a team member
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT token:** identifies team lead
     */
    updateTeamMemberConnectionTargetFromPlanning?: Maybe<UpdateTeamMemberConnectionTargetResult>;
    /**
     * **Definition:** Update the connection target recommendations for one or more team members
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** 'routing/crda.write' scope
     *
     * **Auth - Zillow OAuth2.0 User JWT token:** not supported
     */
    updateTeamMemberConnectionTargetRecommendations?: Maybe<UpdateTeamMemberConnectionTargetRecommendationsResult>;
    updateTransaction?: Maybe<PATransactionPayload>;
    /**
     * Requires forwarded auth headers or a bearer auth token for authentication. Please see https://zgtools.net/docs/building-blocks/shared-services/zg-graph/auth/ for more details on how to pass headers.
     * Updates the user's ABAD viewing status.
     * Will return a 200 with errors array populated if no auth headers or bearer auth are passed.
     */
    updateUserAbadStatus?: Maybe<UpdateAbadResponse>;
    /**  update user note on a given property  */
    updateUserNote?: Maybe<Scalars['Boolean']['output']>;
    /** Updates the verified claim on a property to a new user */
    updateVerifiedClaim?: Maybe<ClaimResponse>;
    updateZHLDocumentRequestStatus?: Maybe<ZHLTask>;
    /**
     * Store the draft answers data for pre-approval guided flows given a loan id
     *
     * this is a partial update. Only included fields are getting updated
     */
    updateZHLPreApprovalDraftAnswers?: Maybe<ZHLPreApprovalOutput>;
    updateZHLTaskStatus?: Maybe<ZHLTask>;
    /**
     *  Mutation to submit or update Sebastian responses for buyside questionnaire. This mutation is exposed in ZG-Graph
     * @deprecated cross-sell deprecation
     */
    upsertBuySideQuestionnaireAnswers?: Maybe<Scalars['Boolean']['output']>;
    /**
     *  upsert Buyside questionnaire responseId to miso case
     * @deprecated cross-sell deprecation
     */
    upsertBuysideData?: Maybe<Scalars['Boolean']['output']>;
    /**  Mutation to submit or update Sebastian responses for questionnaire. This mutation is exposed in ZG-Graph  */
    upsertSellingOptionsQuestionnaireAnswers?: Maybe<Scalars['Boolean']['output']>;
    withdrawApplication?: Maybe<Scalars['Boolean']['output']>;
    /** Add a participant to an existing conversation */
    zibsAddParticipant?: Maybe<ZIBSConversation>;
    /** Creates a conversation using the given input. Returns the created conversation object back as a response. */
    zibsCreateConversation?: Maybe<ZIBSConversation>;
    /**
     * Sends a new message to an existing conversation
     * Will implicitly pass in authenticated user info
     */
    zibsSendMessage?: Maybe<Scalars['Boolean']['output']>;
    /** Mark a specific conversation as read using the last read messageId. */
    zimReadConversation?: Maybe<ZIMReadConversationResponse>;
    /**
     * Sends a new message to an existing conversation
     * Will implicitly pass in authenticated user info
     */
    zimSendMessage?: Maybe<ZIMMessage>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationacceptCoShopperArgs = {
    inviterEncodedZuid: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationacceptIcraaArgs = {
    applicationId: Scalars['ID']['input'];
    isIcraaApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    listingAlias: Scalars['ID']['input'];
    userIds: Array<Scalars['ID']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationacceptInvitationArgs = {
    applicationId: Scalars['ID']['input'];
    invitationId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationacceptLandlordInvitationArgs = {
    applicationId: Scalars['ID']['input'];
    invitationId: Scalars['ID']['input'];
    listingAlias: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationacceptLegalComplianceArgs = {
    applicationId: Scalars['ID']['input'];
    complianceType: Scalars['String']['input'];
    listingAlias: Scalars['ID']['input'];
    userIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationacceptOdReferralArgs = {
    misoId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationactivateBlendLoanArgs = {
    loanId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationactivateMACUserArgs = {
    activationToken: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationactivateZHLDashboardUserArgs = {
    activationToken: Scalars['String']['input'];
    zuid: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationaddCommuteDestinationArgs = {
    destination: CommuteDestinationInputType;
    startLat?: InputMaybe<Scalars['Float']['input']>;
    startLng?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationaddCurrentIncomeArgs = {
    currentIncome: CurrentIncomeInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationaddPastJobArgs = {
    applicationId: Scalars['ID']['input'];
    pastJob: PastJobInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationaddPastResidenceArgs = {
    applicationId: Scalars['ID']['input'];
    residence: ResidenceInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationaddQuestionnaireArgs = {
    input: QuestionnaireInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationaddSavedHomeCategoryArgs = {
    addSavedHomeCategoryInput: AddSavedHomeCategoryInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationaddVisitedHomeArgs = {
    zpid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationagentCreateTouringAgreementArgs = {
    appointmentHash?: InputMaybe<Scalars['String']['input']>;
    buyerFirstName: Scalars['String']['input'];
    buyerLastName: Scalars['String']['input'];
    buyerZuid?: InputMaybe<Scalars['Int']['input']>;
    contactId?: InputMaybe<Scalars['String']['input']>;
    location: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationagentRescheduleTourAppointmentArgs = {
    appointmentHash: Scalars['String']['input'];
    updatedTime: ShowingTimeUpdateTimeInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationagentSignTouringAgreementArgs = {
    firstName: Scalars['String']['input'];
    lastName: Scalars['String']['input'];
    signerTimeZone?: InputMaybe<Scalars['String']['input']>;
    zDocsId: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationapplyCustomPropertyTagArgs = {
    applyCustomPropertyTagInput: ApplyCustomPropertyTagInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationapplyPropertyTagArgs = {
    applyPropertyTagInput: ApplyPropertyTagInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationapproveApplicationArgs = {
    applicationId: Scalars['ID']['input'];
    emailText: Scalars['String']['input'];
    listingAlias: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationarchiveTaskArgs = {
    id: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationbuyerSignTouringAgreementArgs = {
    firstName: Scalars['String']['input'];
    lastName: Scalars['String']['input'];
    signerTimeZone?: InputMaybe<Scalars['String']['input']>;
    zDocsId: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationbuyerUpdateTouringAgreementFieldArgs = {
    buyerFirstName: Scalars['String']['input'];
    buyerLastName: Scalars['String']['input'];
    zDocsId: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcancelTourAppointmentArgs = {
    appointmentHash: Scalars['String']['input'];
    cancellation: CancellationInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcancelTourAppointmentInShowingTimeArgs = {
    appointmentHash: Scalars['String']['input'];
    cancellation: ShowingTimeCancellationInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationclaimHomeArgs = {
    landlordUpsellViewed?: InputMaybe<Scalars['Boolean']['input']>;
    propertyClaimSourceType: PropertyClaimSourceType;
    propertyClaimType: PropertyClaimType;
    zpid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationconnectZHLBorrowerWithZGMIArgs = {
    borrowerId: Scalars['ID']['input'];
    input: ZHLBorrowerHandleZGMIConnectInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateAgentSelfPauseArgs = {
    agentZuid: Scalars['ID']['input'];
    reason?: InputMaybe<Scalars['String']['input']>;
    unpauseAt?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateBorrowerArgs = {
    input: CreateBorrowerInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateBorrowerPairArgs = {
    input: CreateBorrowerPairInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateContactNoteArgs = {
    input: PACreateContactNoteInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateFlexTransactionArgs = {
    input: CreateFlexTxnRequest;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateImplicitClaimArgs = {
    propertyImplicitClaimType: PropertyImplicitClaimType;
    zpid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateOffersArgs = {
    eligibilityType?: InputMaybe<EligibilityType>;
    questionnaireResponseId: Scalars['ID']['input'];
    zpid: Scalars['Int']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreatePAContactArgs = {
    input: CreatePAContactInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateProofOfInsuranceArgs = {
    listingAlias?: InputMaybe<Scalars['String']['input']>;
    messageToken?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateTaskArgs = {
    task: HubTaskInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateTransactionArgs = {
    input: PATransactionInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateUserNoteArgs = {
    createUserNoteInput: CreateUserNoteInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateVerifiedClaimArgs = {
    propertyClaimSourceType: PropertyClaimSourceType;
    propertyClaimType: PropertyClaimType;
    propertyClaimVerificationMethod?: InputMaybe<PropertyClaimVerificationMethod>;
    zpid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateZHLAutomatedTasksArgs = {
    loanId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateZHLBorrowerAssetArgs = {
    input: CreateZHLBorrowerAssetInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateZHLBorrowerEmploymentArgs = {
    input: CreateZHLBorrowerEmploymentInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateZHLBorrowerOtherIncomeArgs = {
    input: CreateZHLBorrowerOtherIncomeInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateZHLDocumentArgs = {
    input: CreateZHLDocumentInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateZHLPlaidLinkArgs = {
    borrowerId: Scalars['ID']['input'];
    deliveryMethod?: InputMaybe<ZHLPlaidHostedLinkDeliveryMethod>;
    loanId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateZHLPurchaseLeadArgs = {
    input: ZHLPreQualCreatePurchaseLeadInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateZHLTaskArgs = {
    input: ZHLCreateTaskInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationcreateZHLTasksForLFSRecordArgs = {
    input: ZHLCreateTasksForLFSRecordInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdecideMarketScopeForBuyAndSellArgs = {
    input: MarketScopeForBuyAndSellInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeclineCoShopperArgs = {
    inviterEncodedZuid: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteAnswersArgs = {
    applicationId: Scalars['ID']['input'];
    coreQuestionIds?: InputMaybe<Array<InputMaybe<CoreQuestionId>>>;
    customQuestionIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteBorrowerArgs = {
    borrowerId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteClaimsArgs = {
    propertyClaimReleaseReason: PropertyClaimReleaseReason;
    propertyClaimType: PropertyClaimType;
    zpid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteCommuteDestinationArgs = {
    locationId: Scalars['Int']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteCurrentIncomeArgs = {
    currentIncomeId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeletePAContactArgs = {
    input: DeletePAContactInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeletePATaskArgs = {
    agentZuid: Scalars['ID']['input'];
    contactId: Scalars['ID']['input'];
    taskUuid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeletePastJobArgs = {
    applicationId: Scalars['ID']['input'];
    pastJobId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeletePastResidenceArgs = {
    applicationId: Scalars['ID']['input'];
    pastResidenceId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeletePropertyTagArgs = {
    propertyTagId: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteSavedSearchArgs = {
    subscriptionEnrollmentId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteTeamMemberConnectionTargetArgs = {
    input: DeleteTeamMemberConnectionTargetInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteUserNoteArgs = {
    deleteUserNoteInput: DeleteUserNoteInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteVerifiedClaimByPropertyIdArgs = {
    propertyClaimReleaseReason: PropertyClaimReleaseReason;
    propertyClaimSourceType: PropertyClaimSourceType;
    propertyClaimType: PropertyClaimType;
    zpid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteZHLBorrowerAssetArgs = {
    assetID: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteZHLBorrowerEmploymentArgs = {
    employmentID: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteZHLBorrowerOtherIncomeArgs = {
    otherIncomeID: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteZHLDocumentRequestArgs = {
    id: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdeleteZHLTaskArgs = {
    source?: InputMaybe<ZHLTaskSourceSystem>;
    taskId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationdismissNotificationsArgs = {
    notifications: Array<RenterHubNotificationParams>;
    undo?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationeditFlexTransactionArgs = {
    input: EditFlexTxnRequest;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationeditInvitationArgs = {
    applicant: EditCoapplicantInput;
    applicationId: Scalars['ID']['input'];
    invitationId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationeditZHLBorrowerAssetArgs = {
    input: EditZHLBorrowerAssetInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationeditZHLBorrowerAttributesArgs = {
    input: EditZHLBorrowerAttributesInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationeditZHLBorrowerEmploymentArgs = {
    input: EditZHLBorrowerEmploymentInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationeditZHLBorrowerOtherIncomeArgs = {
    input: EditZHLBorrowerOtherIncomeInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationeditZHLLoanAttributesArgs = {
    input: EditZHLLoanAttributesInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationendAgentSelfPauseArgs = {
    agentZuid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationflagHighlightArgs = {
    input: FlagHighlightInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationgenerateZHLDashboardUserActivationTokenArgs = {
    expirationSeconds?: InputMaybe<Scalars['Int']['input']>;
    zhlBorrowerId: Scalars['ID']['input'];
    zhlLoanId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationgenerateZHLDashboardUserActivationTokenForLeadArgs = {
    borrowerEmail: Scalars['String']['input'];
    expirationSeconds?: InputMaybe<Scalars['Int']['input']>;
    salesforceLeadId: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationgrantHardCreditConsentArgs = {
    borrowerId: Scalars['ID']['input'];
    input?: InputMaybe<GrantHardCreditConsentInput>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationgrantZHLBorrowerSoftCreditConsentArgs = {
    input: ZHLBorrowerGrantSoftCreditConsentInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationhandleSubsequentTourRequestArgs = {
    appointmentHash: Scalars['String']['input'];
    subsequentTourRequestInput: SubsequentTourRequestInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationhideHomeArgs = {
    hiddenHomeInput: HiddenHomeInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationhubBulkUpdateResourceStatusArgs = {
    input: HubBulkResourceStatusInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationhubCreatePlanArgs = {
    includeZhlStatus?: Scalars['Boolean']['input'];
    moveGoal: HubMoveGoal;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationhubUpdateResourceStatusArgs = {
    includeZhlStatus?: Scalars['Boolean']['input'];
    input: HubResourceStatusInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationinviteCoShopperArgs = {
    inviteCoShopperInput: InviteCoShopperInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationinviteCoapplicantArgs = {
    applicant: InviteCoapplicantInput;
    applicationId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationmarkAcceptedTermsArgs = {
    terms: Array<InputMaybe<TermInput>>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationmarkApplicationsAsViewedArgs = {
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
    listingAlias: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationmarkIncomeToRentEligibleArgs = {
    applicationId: Scalars['ID']['input'];
    incomeToRentEligible: Scalars['Boolean']['input'];
    listingAlias: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationmergeApplicationsArgs = {
    applicationIds: Array<InputMaybe<Scalars['ID']['input']>>;
    listingAlias: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationncScheduleTourArgs = {
    dateTime?: InputMaybe<Scalars['String']['input']>;
    emailAddress?: InputMaybe<Scalars['String']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    visitorTermsUrl?: InputMaybe<Scalars['String']['input']>;
    zpid?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationpostHighlightArgs = {
    input: PostHighlightInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationredriveMisoDataLakeQuestionnaireDataArgs = {
    body: Scalars['String']['input'];
    questionnaireResponseId: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationremoveAppliedPropertyTagArgs = {
    removeAppliedPropertyTag: RemoveAppliedPropertyTagInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationremoveCoShopperArgs = {
    coShopperEncodedZuid: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationremoveInvitationArgs = {
    applicationId: Scalars['ID']['input'];
    invitationId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationremoveSavedHomeArgs = {
    removeSavedHomeInput: RemoveSavedHomeInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationremoveSavedHomeCategoryArgs = {
    removeSavedHomeCategoryInput: RemoveSavedHomeCategoryInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationremoveVisitedHomeArgs = {
    zpid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationreplaceCurrentIncomesArgs = {
    currentIncomes: Array<InputMaybe<BulkCurrentIncomeInput>>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationreplacePastJobsArgs = {
    applicationId: Scalars['ID']['input'];
    pastJobs: Array<InputMaybe<BulkPastJobInput>>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationreplacePastResidencesArgs = {
    applicationId: Scalars['ID']['input'];
    residences: Array<InputMaybe<BulkResidenceInput>>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationrequestAgentConnectionArgs = {
    misoId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationrequestCallFromAdvisorArgs = {
    misoId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationrequestHighlightsArgs = {
    input: RequestHighlightsInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationrequestLTAAgentConnectionArgs = {
    misoId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationrequestOffersCreationArgs = {
    offersCreationInput: OffersCreationInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationrequestSellingOffersConnectionArgs = {
    requestSellingOffersConnectionInput: RequestSellingOffersConnectionInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationrequestSellingOffersLTAConnectionArgs = {
    requestSellingOffersConnectionInput: RequestSellingOffersConnectionInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationrescheduleTourAppointmentArgs = {
    appointmentHash: Scalars['String']['input'];
    rescheduleRequest: TourAppointmentRescheduleInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationrevokeHardCreditConsentArgs = {
    borrowerId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsaveAnswersArgs = {
    answers: AnswersInput;
    applicationId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsaveBuyingPowerInputsArgs = {
    inputs: BuyingPowerInputs;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsaveCompsArgs = {
    compListInput: SaveCompsInputType;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsaveCustomRegionArgs = {
    customRegionToSave: SaveCustomRegionInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsaveFinancialProfileArgs = {
    selfReportedAnnualIncome?: InputMaybe<Scalars['Float']['input']>;
    selfReportedCreditScoreRange?: InputMaybe<CreditScoreRangeInput>;
    selfReportedDownPayment?: InputMaybe<DownPaymentInput>;
    selfReportedLocation?: InputMaybe<LocationInput>;
    selfReportedMonthlyDebts?: InputMaybe<Scalars['Float']['input']>;
    selfReportedMonthlyPayment?: InputMaybe<Scalars['Float']['input']>;
    zuid: Scalars['Int']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsaveFinancialProfileByEncodedZuidArgs = {
    encodedZuid: Scalars['String']['input'];
    selfReportedAnnualIncome?: InputMaybe<Scalars['Float']['input']>;
    selfReportedCreditScoreRange?: InputMaybe<CreditScoreRangeInput>;
    selfReportedDownPayment?: InputMaybe<DownPaymentInput>;
    selfReportedLocation?: InputMaybe<LocationInput>;
    selfReportedMonthlyDebts?: InputMaybe<Scalars['Float']['input']>;
    selfReportedMonthlyPayment?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsaveFinancialProfileV2Args = {
    selfReportedAnnualIncome?: InputMaybe<Scalars['Float']['input']>;
    selfReportedCreditScoreRange?: InputMaybe<CreditScoreRangeInput>;
    selfReportedDownPayment?: InputMaybe<DownPaymentInput>;
    selfReportedLocation?: InputMaybe<LocationInput>;
    selfReportedMonthlyDebts?: InputMaybe<Scalars['Float']['input']>;
    selfReportedMonthlyPayment?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsaveHomeArgs = {
    zpid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsaveHomeV2Args = {
    propertyId: Scalars['ID']['input'];
    propertyIdType: PropertyIdType;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsaveOrUpdateHomeArgs = {
    savedHomeInput: SavedHomeInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsaveSuccessSurveyArgs = {
    competitorAnswer?: InputMaybe<Scalars['String']['input']>;
    foundHomeAnswer?: InputMaybe<Scalars['String']['input']>;
    zrmAnswer?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsendDpaProgramsListEmailArgs = {
    clientMessageId?: InputMaybe<Scalars['String']['input']>;
    operationalEmailId?: InputMaybe<Scalars['Int']['input']>;
    renderParameters?: InputMaybe<dpaRenderParameters>;
    toEmailAddresses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsendPasswordResetEmailArgs = {
    accountId?: InputMaybe<Scalars['Int']['input']>;
    emailLink?: InputMaybe<Scalars['String']['input']>;
    emailTypeId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsendPaymentNotificationArgs = {
    data?: InputMaybe<Scalars['String']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    notificationType: Scalars['String']['input'];
    resourceId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsendZhlDashboardActivationLinkEmailArgs = {
    zhlBorrowerId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsetMoveProfileArgs = {
    moveProfile: SetBridgeMoveProfileRequestInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsetUserRealNameArgs = {
    firstName?: InputMaybe<Scalars['String']['input']>;
    lastName?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationstartApplicationArgs = {
    listingAlias: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationstoreVoucherToRentCoverageArgs = {
    applicationId: Scalars['ID']['input'];
    listingAlias: Scalars['ID']['input'];
    voucherToRentCoverage: VoucherToRentCoverage;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsubmitApplicationArgs = {
    answers?: InputMaybe<AnswersInput>;
    applicationId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsubmitQuestionnaireArgs = {
    input: SubmitQuestionnaireInput;
    loanId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsubmitSellingOptionsIneligibleInfoArgs = {
    input: IneligibleInfoInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsubmitSellingOptionsQuestionnaireAnswersArgs = {
    input: QuestionnaireAnswersInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsubmitUserFeedbackArgs = {
    category?: InputMaybe<Scalars['String']['input']>;
    comment?: InputMaybe<Scalars['String']['input']>;
    interactionId: Scalars['String']['input'];
    messageIndex: Scalars['String']['input'];
    userFeedback: UsersFeedback;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationsubmitZHLLeadArgs = {
    input: SubmitZHLLeadInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationtoggleZHLDigitalExperienceArgs = {
    loanId: Scalars['String']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationunclaimHomeArgs = {
    zpid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationunhideHomeArgs = {
    hiddenHomeInput: HiddenHomeInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationunsaveHomeArgs = {
    zpid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationunsaveHomeV2Args = {
    propertyId: Scalars['ID']['input'];
    propertyIdType: PropertyIdType;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateApplicantLastViewedSnapshotStatusDateArgs = {
    applicationId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateBorrowerAttributesArgs = {
    borrowerId: Scalars['ID']['input'];
    input?: InputMaybe<UpdateBorrowerInput>;
    loanId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateCommuteDestinationArgs = {
    destination: CommuteDestinationInputType;
    locationId: Scalars['Int']['input'];
    startLat?: InputMaybe<Scalars['Float']['input']>;
    startLng?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateContactedRentalArgs = {
    clientData?: InputMaybe<Scalars['String']['input']>;
    ctaAction?: InputMaybe<Scalars['String']['input']>;
    propertyId: Scalars['String']['input'];
    propertyIdType: Scalars['String']['input'];
    showInstantTour?: InputMaybe<Scalars['Boolean']['input']>;
    updateCache?: InputMaybe<Scalars['Boolean']['input']>;
    useNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateContactedRentalCacheArgs = {
    userId: Scalars['String']['input'];
    waitForUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateConversationArchivingStatusArgs = {
    isArchived?: InputMaybe<Scalars['Boolean']['input']>;
    listingAlias?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateCurrentIncomeArgs = {
    currentIncome: CurrentIncomeInput;
    currentIncomeId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateFavoritesPageSortArgs = {
    filterPreferences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    isSortDescending?: InputMaybe<Scalars['Boolean']['input']>;
    sortOption?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdatePAContactArgs = {
    input: UpdatePAContactInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdatePATaskArgs = {
    input: PATaskInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdatePaContactExternalManagedTagBulkArgs = {
    agentZuid: Scalars['Int']['input'];
    contactIds: Array<Scalars['Int']['input']>;
    managedTag: PAContactManagedTagInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdatePropertyViewArgs = {
    updatePropertyViewInput: UpdatePropertyViewInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateSavedSearchFrequencyArgs = {
    emailFrequency: SavedSearchEmailFrequency;
    subscriptionEnrollmentId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateSavedSearchNameArgs = {
    newName: Scalars['String']['input'];
    subscriptionEnrollmentId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateSelfPauseArgs = {
    agentZuid: Scalars['Int']['input'];
    isSelfPaused: Scalars['Boolean']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateSellingOptionsQuestionnaireAnswersArgs = {
    input: QuestionnaireAnswersInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateTaskArgs = {
    id: Scalars['ID']['input'];
    task: HubTaskUpdateInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateTeamMemberConnectionTargetArgs = {
    data?: InputMaybe<UpdateTeamMemberConnectionTargetInput>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateTeamMemberConnectionTargetFromPlanningArgs = {
    data: UpdateTeamMemberConnectionTargetFromPlanningInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateTeamMemberConnectionTargetRecommendationsArgs = {
    input: Array<UpdateTeamMemberConnectionTargetRecommendationInput>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateTransactionArgs = {
    input: PATransactionInput;
    transactionId: Scalars['Int']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateUserAbadStatusArgs = {
    updateUserAbadStatusInput: UpdateUserAbadStatusInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateUserNoteArgs = {
    updateUserNoteInput: UpdateUserNoteInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateVerifiedClaimArgs = {
    propertyClaimSourceType: PropertyClaimSourceType;
    propertyClaimType: PropertyClaimType;
    propertyClaimVerificationMethod?: InputMaybe<PropertyClaimVerificationMethod>;
    zpid: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateZHLDocumentRequestStatusArgs = {
    comments?: InputMaybe<Array<InputMaybe<ZHLDocumentRequestCommentInput>>>;
    id: Scalars['ID']['input'];
    status: ZHLDocumentRequestStatus;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateZHLPreApprovalDraftAnswersArgs = {
    answers: ZHLPreApprovalDraftAnswersInput;
    loanID: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupdateZHLTaskStatusArgs = {
    source?: InputMaybe<ZHLTaskSourceSystem>;
    taskComments?: InputMaybe<Array<InputMaybe<ZHLTaskCommentInput>>>;
    taskId: Scalars['ID']['input'];
    taskStatus: ZHLTaskStatus;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupsertBuySideQuestionnaireAnswersArgs = {
    input: BuysideQuestionnaireAnswersInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupsertBuysideDataArgs = {
    upsertBuysideDataInput: UpsertBuysideDataInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationupsertSellingOptionsQuestionnaireAnswersArgs = {
    input: QuestionnaireAnswersInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationwithdrawApplicationArgs = {
    applicationId: Scalars['ID']['input'];
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationzibsAddParticipantArgs = {
    conversationID?: InputMaybe<Scalars['String']['input']>;
    participant?: InputMaybe<ZIBSParticipantInput>;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationzibsCreateConversationArgs = {
    conversationInput: ZIBSConversationInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationzibsSendMessageArgs = {
    messageInput: ZIBSMessageInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationzimReadConversationArgs = {
    readConversationInput: ZIMReadConversationInput;
};

/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type MutationzimSendMessageArgs = {
    messageInput: ZIMMessageInput;
};

export type MyAgentReconnections = {
    clickstreamMetadata: SubmitFlowComponentClickstreamMetadata;
    continueCTA: SubmitFlowCTA;
    requestNewAgentCTA: SubmitFlowCTA;
    supportingText: Scalars['String']['output'];
    title: Scalars['String']['output'];
};

/** user preferences data such as favorites page sort option */
export type MyZillowPreferences = {
    /** user preferences data on favorites list filter option */
    filterPreferences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** user preferences of ascending or descending sort */
    isSortDescending?: Maybe<Scalars['Boolean']['output']>;
    /** user preferences data on favorites list sort option */
    sortOption?: Maybe<Scalars['String']['output']>;
};

export type NA = {
    na: Scalars['Boolean']['input'];
};

/** This block is used to create the nba contextual block in the NBA NL events. */
export type NbaBlock = {
    /** If no NBA mapping was selected, this field should be set to true */
    fallBackActionRankingUsedInd?: Maybe<Scalars['Boolean']['output']>;
    /** A boolean to indicate if NBA is used in selection process */
    isNbaProcessed?: Maybe<Scalars['Boolean']['output']>;
    /** Unique ID returned from the NBA Orchestration Service for a request */
    joiningUuid?: Maybe<Scalars['String']['output']>;
    /** Location of the upsell */
    position?: Maybe<Scalars['String']['output']>;
    /**
     * If non-null, contains the position to action mapping which the client
     * selected. Null indicates no recommended mapping was selected. Keys in map will
     * evolve over time.
     */
    selectedActionPositions?: Maybe<Array<Maybe<MapEntry>>>;
    /**
     * Should only be non-null if no NBA mapping was selected. If non-null, contains
     * a mapping of positions to selected actions. Keys in map will evolve over time.
     */
    selectedFallBackActions?: Maybe<Array<Maybe<MapEntry>>>;
    /**
     * Indicates the “version” of this data. If an existing field changes meaning,
     * this number should be incremented. Note this is different than schema change
     */
    semanticVersionId?: Maybe<Scalars['Int']['output']>;
    /**
     * A boolean indicator to show NBA service error. Set to True if the NBA
     * Orchestration Service is returning an error to the client. False otherwise.
     */
    serviceErrorInd?: Maybe<Scalars['Boolean']['output']>;
    /** If there was a NBA service error, the error message is returned */
    serviceErrorTxt?: Maybe<Scalars['String']['output']>;
    /** Unique id for a page */
    surfaceId?: Maybe<Scalars['String']['output']>;
    /**
     * A boolean indicator that should be set to true if a call to a measurement
     * system was made to report this user being exposed.
     */
    userImpressionReportedInd?: Maybe<Scalars['Boolean']['output']>;
};

/** A new construction community */
export type NcCommunity = NcCommunityCore & {
    amenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**
     * Reviews and aggregate builder ratings for this community
     * @deprecated Use ncCommunity.ratings
     */
    averageRatings?: Maybe<BuilderReviewSet>;
    billingId?: Maybe<Scalars['String']['output']>;
    brokerId?: Maybe<Scalars['Int']['output']>;
    builderName?: Maybe<Scalars['String']['output']>;
    builderProfileUrl?: Maybe<Scalars['String']['output']>;
    builderProvidedSchools?: Maybe<BuilderProvidedSchools>;
    byAppointment?: Maybe<Scalars['Boolean']['output']>;
    /** Flag indicating whether the community's coming soon status is inferred or not */
    comingSoonInferred?: Maybe<Scalars['Boolean']['output']>;
    communityAddress?: Maybe<NcCommunityAddress>;
    contactData?: Maybe<NcContactData>;
    corporationName?: Maybe<Scalars['String']['output']>;
    currency?: Maybe<CurrencyType>;
    description?: Maybe<Scalars['String']['output']>;
    /** Builder provided driving directions to this community */
    drivingDirections?: Maybe<Scalars['String']['output']>;
    featureConfig?: Maybe<featureConfig>;
    federatedPhotos?: Maybe<Array<Maybe<federatedPhoto>>>;
    geoRegion?: Maybe<CommunityRegion>;
    images?: Maybe<Array<Maybe<NcCommunityImage>>>;
    /**
     * True if the communityAddress zipcode is in an active ZO markets
     * @deprecated Disused ZO field backed by decommissioned service.
     */
    isInZOActiveMarket?: Maybe<Scalars['Boolean']['output']>;
    /**
     * True if the communityAddress zipcode is in a paused ZO market
     * @deprecated Disused ZO field backed by decommissioned service.
     */
    isInZOPausedMarket?: Maybe<Scalars['Boolean']['output']>;
    /** Flag indicating whether the community has lots with fixed plans */
    isPairedPlanCommunity?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use ncCommunity.featureConfig.isTourBookingEnabled */
    leadsConfig?: Maybe<NcLeadsConfig>;
    marketingStatus?: Maybe<CommunityMarketingStatus>;
    /** minimum price of a property in the community */
    minPrice?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    nearbyCommunities?: Maybe<Array<Maybe<NearbyCommunity>>>;
    nearbyCommunitiesLite?: Maybe<Array<Maybe<NcRelatedCommunity>>>;
    officeHours?: Maybe<Scalars['String']['output']>;
    paContactData?: Maybe<NcPaContactData>;
    parentCommunityName?: Maybe<Scalars['String']['output']>;
    parentGeoRegionsByType?: Maybe<ParentRegionsByType>;
    /** Region ids in which this community is contained */
    parentRegions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    postingUrl?: Maybe<Scalars['String']['output']>;
    promotion?: Maybe<NcPromotion>;
    properties?: Maybe<NcListingAvailability>;
    providerListingId?: Maybe<Scalars['Int']['output']>;
    /** Reviews and aggregate builder ratings for this community */
    ratings?: Maybe<CommunityReviewSet>;
    /** Reviews for this community */
    reviews?: Maybe<Array<Maybe<BuilderReview>>>;
    salesOfficeAddress?: Maybe<NcCommunityAddress>;
    schools?: Maybe<CommunitySchools>;
    sharedBuilderCommunities?: Maybe<Array<Maybe<SharedBuilderCommunity>>>;
    sharedBuilderCommunitiesLite?: Maybe<Array<Maybe<NcRelatedCommunity>>>;
    /** Retrieve a static map of the requested community in a range of sizes */
    staticMap?: Maybe<StaticMap>;
    structuredOfficeHours?: Maybe<Array<Maybe<StructuredHours>>>;
    /** The community style for vertical living */
    style?: Maybe<Scalars['String']['output']>;
    tourHours?: Maybe<Array<Maybe<StructuredHours>>>;
    /** CDP URL for this community */
    url?: Maybe<Scalars['String']['output']>;
    videos?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**
     * Zillow Offers Url for a community
     * @deprecated Use ncCommunity.featureConfig.zoUpsellUrl
     */
    zoUpsellUrl?: Maybe<Scalars['String']['output']>;
};

/** A new construction community */
export type NcCommunityimagesArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Scalars['Int']['input']>;
    size?: InputMaybe<PropertyPhotoSize>;
};

/** A new construction community */
export type NcCommunitynearbyCommunitiesArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
};

/** A new construction community */
export type NcCommunitynearbyCommunitiesLiteArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
};

/** A new construction community */
export type NcCommunityreviewsArgs = {
    pageNumber?: InputMaybe<Scalars['Int']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
};

/** A new construction community */
export type NcCommunitysharedBuilderCommunitiesArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
};

/** A new construction community */
export type NcCommunitysharedBuilderCommunitiesLiteArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
};

/** A new construction community */
export type NcCommunitystaticMapArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<GoogleStaticMapType>;
    zoom?: InputMaybe<Scalars['Int']['input']>;
};

export type NcCommunityAddress = {
    city?: Maybe<Scalars['String']['output']>;
    /** Signed Google static map url */
    googleStaticMapSignedUrl?: Maybe<Scalars['String']['output']>;
    latitude?: Maybe<Scalars['Float']['output']>;
    longitude?: Maybe<Scalars['Float']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress1?: Maybe<Scalars['String']['output']>;
    streetAddress2?: Maybe<Scalars['String']['output']>;
    zipcode?: Maybe<Scalars['String']['output']>;
};

export type NcCommunityAddressgoogleStaticMapSignedUrlArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    height?: InputMaybe<Scalars['Int']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    scale?: InputMaybe<Scalars['Int']['input']>;
    type?: InputMaybe<GoogleStaticMapType>;
    width?: InputMaybe<Scalars['Int']['input']>;
    zoom?: InputMaybe<Scalars['Int']['input']>;
};

export type NcCommunityAggregate = {
    communityCount?: Maybe<Scalars['Int']['output']>;
    moveInReadySpecCount?: Maybe<Scalars['Int']['output']>;
    planAverages?: Maybe<NcPropertyAverages>;
    planCount?: Maybe<Scalars['Int']['output']>;
    specAverages?: Maybe<NcPropertyAverages>;
    topBuilders?: Maybe<Array<Maybe<TopBuilder>>>;
    underConstructionSpecCount?: Maybe<Scalars['Int']['output']>;
};

/** A new construction communityCard */
export type NcCommunityCard = {
    communityAddress?: Maybe<NcCommunityAddress>;
    currency?: Maybe<CurrencyType>;
    featuredImage?: Maybe<NcCommunityImage>;
    /** minimum price of a property in the community */
    minPrice?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    providerListingId?: Maybe<Scalars['Int']['output']>;
    /** The community style for vertical living */
    style?: Maybe<Scalars['String']['output']>;
    /** CDP URL for this community */
    url?: Maybe<Scalars['String']['output']>;
};

/** A new construction communityCard */
export type NcCommunityCardfeaturedImageArgs = {
    size?: InputMaybe<PropertyPhotoSize>;
};

/** A core interface for new construction communities */
export type NcCommunityCore = {
    amenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    billingId?: Maybe<Scalars['String']['output']>;
    brokerId?: Maybe<Scalars['Int']['output']>;
    builderName?: Maybe<Scalars['String']['output']>;
    builderProfileUrl?: Maybe<Scalars['String']['output']>;
    builderProvidedSchools?: Maybe<BuilderProvidedSchools>;
    byAppointment?: Maybe<Scalars['Boolean']['output']>;
    /** Flag indicating whether the community's coming soon status is inferred or not */
    comingSoonInferred?: Maybe<Scalars['Boolean']['output']>;
    communityAddress?: Maybe<NcCommunityAddress>;
    contactData?: Maybe<NcContactData>;
    corporationName?: Maybe<Scalars['String']['output']>;
    currency?: Maybe<CurrencyType>;
    description?: Maybe<Scalars['String']['output']>;
    /** Builder provided driving directions to this community */
    drivingDirections?: Maybe<Scalars['String']['output']>;
    geoRegion?: Maybe<CommunityRegion>;
    images?: Maybe<Array<Maybe<NcCommunityImage>>>;
    /** Flag indicating whether the community has lots with fixed plans */
    isPairedPlanCommunity?: Maybe<Scalars['Boolean']['output']>;
    marketingStatus?: Maybe<CommunityMarketingStatus>;
    /** minimum price of a property in the community */
    minPrice?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    officeHours?: Maybe<Scalars['String']['output']>;
    paContactData?: Maybe<NcPaContactData>;
    parentCommunityName?: Maybe<Scalars['String']['output']>;
    parentGeoRegionsByType?: Maybe<ParentRegionsByType>;
    /** Region ids in which this community is contained */
    parentRegions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    postingUrl?: Maybe<Scalars['String']['output']>;
    promotion?: Maybe<NcPromotion>;
    providerListingId?: Maybe<Scalars['Int']['output']>;
    salesOfficeAddress?: Maybe<NcCommunityAddress>;
    structuredOfficeHours?: Maybe<Array<Maybe<StructuredHours>>>;
    /** The community style for vertical living */
    style?: Maybe<Scalars['String']['output']>;
    tourHours?: Maybe<Array<Maybe<StructuredHours>>>;
    /** CDP URL for this community */
    url?: Maybe<Scalars['String']['output']>;
    videos?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** A core interface for new construction communities */
export type NcCommunityCoreimagesArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Scalars['Int']['input']>;
    size?: InputMaybe<PropertyPhotoSize>;
};

export type NcCommunityImage = {
    caption?: Maybe<Scalars['String']['output']>;
    mixedSources?: Maybe<MultiImageSourceType>;
    sources?: Maybe<Array<Maybe<ResponsiveImageSource>>>;
    url?: Maybe<Scalars['String']['output']>;
};

export type NcCommunityImagemixedSourcesArgs = {
    aspectRatio?: InputMaybe<AspectRatio>;
    maxWidth?: InputMaybe<Scalars['Int']['input']>;
    minWidth?: InputMaybe<Scalars['Int']['input']>;
};

export type NcCommunityImagesourcesArgs = {
    aspectRatio?: InputMaybe<AspectRatio>;
    maxWidth?: InputMaybe<Scalars['Int']['input']>;
    minWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** A lite new construction community */
export type NcCommunityLite = NcCommunityCore & {
    amenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    billingId?: Maybe<Scalars['String']['output']>;
    brokerId?: Maybe<Scalars['Int']['output']>;
    builderName?: Maybe<Scalars['String']['output']>;
    builderProfileUrl?: Maybe<Scalars['String']['output']>;
    builderProvidedSchools?: Maybe<BuilderProvidedSchools>;
    byAppointment?: Maybe<Scalars['Boolean']['output']>;
    /** Flag indicating whether the community's coming soon status is inferred or not */
    comingSoonInferred?: Maybe<Scalars['Boolean']['output']>;
    communityAddress?: Maybe<NcCommunityAddress>;
    contactData?: Maybe<NcContactData>;
    corporationName?: Maybe<Scalars['String']['output']>;
    currency?: Maybe<CurrencyType>;
    description?: Maybe<Scalars['String']['output']>;
    /** Builder provided driving directions to this community */
    drivingDirections?: Maybe<Scalars['String']['output']>;
    geoRegion?: Maybe<CommunityRegion>;
    images?: Maybe<Array<Maybe<NcCommunityImage>>>;
    /** Flag indicating whether the community has lots with fixed plans */
    isPairedPlanCommunity?: Maybe<Scalars['Boolean']['output']>;
    marketingStatus?: Maybe<CommunityMarketingStatus>;
    /** minimum price of a property in the community */
    minPrice?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    officeHours?: Maybe<Scalars['String']['output']>;
    paContactData?: Maybe<NcPaContactData>;
    parentCommunityName?: Maybe<Scalars['String']['output']>;
    parentGeoRegionsByType?: Maybe<ParentRegionsByType>;
    /** Region ids in which this community is contained */
    parentRegions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    postingUrl?: Maybe<Scalars['String']['output']>;
    promotion?: Maybe<NcPromotion>;
    providerListingId?: Maybe<Scalars['Int']['output']>;
    salesOfficeAddress?: Maybe<NcCommunityAddress>;
    structuredOfficeHours?: Maybe<Array<Maybe<StructuredHours>>>;
    /** The community style for vertical living */
    style?: Maybe<Scalars['String']['output']>;
    tourHours?: Maybe<Array<Maybe<StructuredHours>>>;
    /** CDP URL for this community */
    url?: Maybe<Scalars['String']['output']>;
    videos?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** A lite new construction community */
export type NcCommunityLiteimagesArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Scalars['Int']['input']>;
    size?: InputMaybe<PropertyPhotoSize>;
};

export type NcContactData = {
    displayName?: Maybe<Scalars['String']['output']>;
    imageUrl?: Maybe<Scalars['String']['output']>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type NcContactFormAuthentication = {
    hmac?: Maybe<Scalars['String']['output']>;
    requestId?: Maybe<Scalars['String']['output']>;
};

/** Leads configuration for a new construction community */
export type NcLeadsConfig = {
    isTourBookingEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** A property within a new construction community */
export type NcListing = {
    /** @deprecated Use ncListingAvailability */
    ncProperty?: Maybe<NcProperty>;
    property?: Maybe<Property>;
};

export type NcListingAvailability = {
    /** Lot to available plans info for this zpid. Replaces ncProperty */
    lotToPlansAvailability?: Maybe<LotToAvailablePlan>;
    /** Lots in this community */
    lots?: Maybe<Array<Maybe<NcListing>>>;
    /** All lots to available plans info for community. Replaces ncProperty */
    lotsToPlansAvailability?: Maybe<Array<Maybe<LotToAvailablePlan>>>;
    /** Plan zpid for the provided spec property, if any */
    planForSpec?: Maybe<PlanPropertyForSpec>;
    /** Plans in this community */
    plans?: Maybe<Array<Maybe<NcListing>>>;
    /** List of tuples of spec (zpid) in the community and its associated plan (zpid), if any */
    plansForSpecs?: Maybe<Array<Maybe<SpecPlanZpidsMapping>>>;
    /** Sold/reserved listings in this community */
    soldOrReserved?: Maybe<Array<Maybe<SoldReservedListing>>>;
    /** Spec homes in this community */
    specs?: Maybe<Array<Maybe<NcListing>>>;
};

export type NcListingAvailabilitylotToPlansAvailabilityArgs = {
    zpid?: InputMaybe<Scalars['ID']['input']>;
};

export type NcListingAvailabilityplanForSpecArgs = {
    zpid?: InputMaybe<Scalars['ID']['input']>;
};

export type NcPaContactData = {
    authentication?: Maybe<NcContactFormAuthentication>;
    impressionId?: Maybe<Scalars['String']['output']>;
    submitId?: Maybe<Scalars['String']['output']>;
    truliaPhoneNumber?: Maybe<Scalars['String']['output']>;
    zillowPhoneNumber?: Maybe<Scalars['String']['output']>;
};

export type NcPromotion = {
    description?: Maybe<Scalars['String']['output']>;
    headline?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
};

/** A new construction home */
export type NcProperty = Node & {
    /** The number of available plans for this NC lot */
    availablePlanCount?: Maybe<Scalars['Int']['output']>;
    /** The available plans for a new-construction lot. */
    availablePlans?: Maybe<Array<Maybe<AvailablePlan>>>;
    /** The ID of an object */
    id: Scalars['ID']['output'];
    /** Cost of the lot or land associated with a posting on this property */
    lotPremium?: Maybe<Scalars['Int']['output']>;
    /** The primary plan for a new-construction lot. */
    primaryPlan?: Maybe<PrimaryPlan>;
    /** zillow property id */
    zpid?: Maybe<Scalars['Int']['output']>;
};

export type NcPropertyAverages = {
    bedroomCount?: Maybe<Scalars['Float']['output']>;
    livingAreaSquareFeet?: Maybe<Scalars['Int']['output']>;
    price?: Maybe<Scalars['Int']['output']>;
};

export type NcRelatedCommunity = {
    distance?: Maybe<Scalars['Float']['output']>;
    ncCommunity?: Maybe<NcCommunityLite>;
};

/** Aggregate review data for the builder, builder region, or community */
export type NcReviewSet = {
    /** Average caring rating given for this builder, builder region, or community */
    caringRating?: Maybe<Scalars['Float']['output']>;
    /** Average confidence rating given for this builder, builder region, or community */
    confidenceRating?: Maybe<Scalars['Float']['output']>;
    /**
     * Number of reviews for this builder, builder region, or community
     * @deprecated Use reviewCount instead
     */
    count?: Maybe<Scalars['Int']['output']>;
    /** Average experience rating given for this builder, builder region, or community */
    experienceRating?: Maybe<Scalars['Float']['output']>;
    /** Average home rating given for this builder, builder region, or community */
    homeRating?: Maybe<Scalars['Float']['output']>;
    /** Average overall rating given for this builder, builder region, or community */
    overallRating?: Maybe<Scalars['Float']['output']>;
    /** Number of ratings for this builder, builder region, or community */
    ratingCount?: Maybe<Scalars['Int']['output']>;
    /** Average responsiveness rating given for this builder, builder region, or community */
    responsivenessRating?: Maybe<Scalars['Float']['output']>;
    /** Number of reviews for this builder, builder region, or community */
    reviewCount?: Maybe<Scalars['Int']['output']>;
    /** Average value rating given for this builder, builder region, or community */
    valueRating?: Maybe<Scalars['Float']['output']>;
    /** Number of reviewers who would recommend this builder, builder region, or community */
    wouldRecommendPercentage?: Maybe<Scalars['Int']['output']>;
};

export type NcScheduleTourResponseType = {
    /** Successfully scheduled appointment */
    appointment?: Maybe<NcSelfTourAppointment>;
    /** Error messages if any */
    errorMessages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Indicates if the operation was successful */
    success?: Maybe<Scalars['Boolean']['output']>;
};

/** Self tour options for a new construction property */
export type NcSelfTour = {
    /** Tour times for zpid */
    availableTimes?: Maybe<ncSelfTourAvailableTimes>;
};

export type NcSelfTourAppointment = {
    /** Tour id */
    id?: Maybe<Scalars['String']['output']>;
    /** ISO8601 string in UTC */
    tourTime?: Maybe<Scalars['String']['output']>;
    /** Door code for tour */
    vendorCode?: Maybe<Scalars['String']['output']>;
};

export type NearbyBuildingLink = {
    buildingUrl?: Maybe<UrlObjectType>;
};

export type NearbyCommunity = {
    distance?: Maybe<Scalars['Float']['output']>;
    ncCommunity?: Maybe<NcCommunity>;
};

/** Net sheet data containing information about the proposed traditional sale numbers */
export type NetSheetData = {
    agentFees?: Maybe<AgentFees>;
    closingCosts?: Maybe<ClosingCosts>;
    highEndSaleValue?: Maybe<Scalars['Int']['output']>;
    /** @deprecated These fields were never used for traditional sale numbers. */
    holdingCosts?: Maybe<HoldingCosts>;
    landscapingAndCleaningCosts?: Maybe<Array<Maybe<CostItem>>>;
    lowEndSaleValue?: Maybe<Scalars['Int']['output']>;
    prepAndRepairCosts?: Maybe<Array<Maybe<CostItem>>>;
    /** @deprecated These fields were never used for traditional sale numbers. */
    transactionCosts?: Maybe<TransactionCosts>;
};

export type NewConstruction = {
    /** The number of plans the builder has available */
    availablePlanCount?: Maybe<Scalars['Int']['output']>;
    /** The name of the new construction builder responsible for this property */
    builderName?: Maybe<Scalars['String']['output']>;
    /** If the new construction is builder plan */
    isBuilderPlan?: Maybe<Scalars['Boolean']['output']>;
    /** If the new construction builder is a premium builder */
    isPremierBuilder?: Maybe<Scalars['Boolean']['output']>;
    /** The builder-provided number for the lot */
    lotNumber?: Maybe<Scalars['ID']['output']>;
    /**
     * The date when this property will be completed and ready to move in to
     * Example: 2019-07-03
     */
    moveInCompletionDate?: Maybe<Scalars['LocalDate']['output']>;
    /** The name of the plan */
    planName?: Maybe<Scalars['String']['output']>;
    /** The builder-provided number for the plan */
    planNumber?: Maybe<Scalars['ID']['output']>;
    /** The builder-provided number for the spec */
    specNumber?: Maybe<Scalars['ID']['output']>;
    /** The spec status of the new construction property (e.g. moveInReady, underConstruction) */
    specStatus?: Maybe<NewConstructionSpecStatus>;
};

export type NewConstructionSpecStatus = 'MOVE_IN_READY' | 'UNDER_CONSTRUCTION' | 'UNKNOWN';

export type NewConstructionType =
    | 'BUILDER_LOT_AND_PRIMARY_PLAN_FACTS'
    | 'BUILDER_PLAN'
    | 'BUILDER_SPEC';

export type NextPayable = {
    dueDate?: Maybe<Scalars['String']['output']>;
    isScheduled?: Maybe<Scalars['Boolean']['output']>;
    numberOfPaymentsRemaining?: Maybe<Scalars['Int']['output']>;
    scheduleMonth?: Maybe<Scalars['String']['output']>;
    totalAmount?: Maybe<Scalars['Int']['output']>;
};

/** An object with an ID */
export type Node = {
    /** The id of the object. */
    id: Scalars['ID']['output'];
};

export type NonConfirmationUpsellPage = {
    clickstreamMetadata: SubmitFlowComponentClickstreamMetadata;
    contactAgent: NonConfirmation_ContactAgent;
    financing: NonConfirmation_Financing;
    pageTransitionText: Scalars['String']['output'];
    title: Scalars['String']['output'];
};

export type NonConfirmation_ContactAgent = {
    clickstreamMetadata: SubmitFlowComponentClickstreamMetadata;
    heading: Scalars['String']['output'];
    headingIcon: SubmitFlowIcon;
    phoneNumberIndices: IndexRange;
    subheading: Scalars['String']['output'];
};

export type NonConfirmation_Financing = {
    affordabilitySteps: Array<AffordabilityStep>;
    affordabilityTitle: Scalars['String']['output'];
    financeLogo?: Maybe<SubmitFlowPhoto>;
    finePrint: Scalars['String']['output'];
    primaryCTA: SubmitFlowCTA;
};

export type NotAuthorizedError = BridgeContainerError & {
    message: Scalars['String']['output'];
    retryable?: Maybe<Scalars['Boolean']['output']>;
};

export type Notification = {
    /** What type of change caused this notification to be generated */
    changeStatusType?: Maybe<ChangeStatusType>;
    /**
     * When did this property become a notification
     * It is a date time in UTC in ISO-8601.
     * Example: 2019-07-03T20:47:55Z
     */
    notificationTime?: Maybe<Scalars['DateTime']['output']>;
    /** Has this notification been read */
    statusRead?: Maybe<Scalars['Boolean']['output']>;
};

export type NotifyStatus = 'complete' | 'failure' | 'retry';

/**  This new type is added to meed the requirement - all subfield should be nullable. Check for schema of miso-questionnaire-fetch for detail. */
export type NullableQuestionnaireAnswersExt = {
    /**  Contact Info of Sebastian  */
    contactInfo?: Maybe<MisoContactInfo>;
    /**  Field to represent which questionnaire the answer is for. If it's for MISO sell questionnaire or buyside questionnaire. */
    label?: Maybe<Scalars['String']['output']>;
    /**  Sebastian answers  */
    questionnaireAnswersJson?: Maybe<NullableQuestionnaireAnswersJsonExt>;
    /**  The questionnaire response Id  */
    responseId: Scalars['ID']['output'];
    /**  Status of the questionnaire responses  */
    status?: Maybe<QuestionnaireAnswersStatus>;
    /**  The standard Zillow Property Id  */
    zpid?: Maybe<Scalars['Int']['output']>;
};

export type NullableQuestionnaireAnswersJsonExt = {
    /**  Sebastian answers to the questionnaire */
    responses?: Maybe<Array<Maybe<NullableResponseDetails>>>;
    /**  The questionnaire schema key ex:MISO_ATL  */
    schemaKey?: Maybe<Scalars['String']['output']>;
    /**  The questionnaire schema version  */
    schemaVersion?: Maybe<Scalars['String']['output']>;
};

export type NullableResponseDetails = {
    fieldName?: Maybe<Scalars['String']['output']>;
    fieldValue?: Maybe<FieldValue>;
    title?: Maybe<Scalars['String']['output']>;
};

export type ODDataResponse = {
    closedAt?: Maybe<Scalars['String']['output']>;
    coeDate?: Maybe<Scalars['String']['output']>;
    estimatedClosingCostCents?: Maybe<Scalars['Int']['output']>;
    estimatedClosingCostPercent?: Maybe<Scalars['Float']['output']>;
    /**  When the offer will expired, or for expired offer, what date the offer expired  */
    expirationAt?: Maybe<Scalars['String']['output']>;
    /**  expiration display date from opendoor  */
    expirationAtDisplayDate?: Maybe<Scalars['String']['output']>;
    feeCostCents?: Maybe<Scalars['Int']['output']>;
    feeCostPercent?: Maybe<Scalars['Float']['output']>;
    headlinePriceCents?: Maybe<Scalars['Int']['output']>;
    offerSource?: Maybe<Scalars['String']['output']>;
    opendoorOfferId: Scalars['String']['output'];
    priceAlert?: Maybe<Scalars['String']['output']>;
    repairCostCents?: Maybe<Scalars['Int']['output']>;
    sentAt?: Maybe<Scalars['String']['output']>;
    /**  different than the UpdateOpendoorInput - stateEventType. This is the actual OD status we want to override to  */
    status?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
};

export type OdpMarketAnalytics = {
    mrktListingBatchLatest?: Maybe<Array<Maybe<MrktListing>>>;
    mrktListingLatest?: Maybe<MrktListing>;
    mrktListingRange?: Maybe<Array<Maybe<MrktListing>>>;
    mrktSaleBatchLatest?: Maybe<Array<Maybe<MrktSale>>>;
    mrktSaleLatest?: Maybe<MrktSale>;
    mrktSaleRange?: Maybe<Array<Maybe<MrktSale>>>;
    mrktTemperatureBatchLatest?: Maybe<Array<Maybe<MrktTemperature>>>;
    mrktTemperatureLatest?: Maybe<MrktTemperature>;
    mrktTemperatureRange?: Maybe<Array<Maybe<MrktTemperature>>>;
    rentalMrktBatchLatest?: Maybe<Array<Maybe<RentalMrkt>>>;
    rentalMrktLatest?: Maybe<RentalMrkt>;
    rentalMrktRange?: Maybe<Array<Maybe<RentalMrkt>>>;
    zhvfIndex1?: Maybe<Array<Maybe<Zhvf>>>;
    zhvfIndex1Range?: Maybe<Array<Maybe<Zhvf>>>;
    zhvfRange?: Maybe<Array<Maybe<Zhvf>>>;
    zhviBatchLatest?: Maybe<Array<Maybe<Zhvi>>>;
    zhviLatest?: Maybe<Zhvi>;
    zhviRange?: Maybe<Array<Maybe<Zhvi>>>;
    zoriBatchLatest?: Maybe<Array<Maybe<Zori>>>;
    zoriLatest?: Maybe<Zori>;
    zoriRange?: Maybe<Array<Maybe<Zori>>>;
};

export type OdpMarketAnalyticsmrktListingBatchLatestArgs = {
    metadataKeyList: Array<Scalars['ID']['input']>;
    regionIdList: Array<Scalars['ID']['input']>;
};

export type OdpMarketAnalyticsmrktListingLatestArgs = {
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
};

export type OdpMarketAnalyticsmrktListingRangeArgs = {
    asc?: InputMaybe<Scalars['Boolean']['input']>;
    from?: InputMaybe<Scalars['String']['input']>;
    maxFetch?: InputMaybe<Scalars['Int']['input']>;
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
    to?: InputMaybe<Scalars['String']['input']>;
};

export type OdpMarketAnalyticsmrktSaleBatchLatestArgs = {
    metadataKeyList: Array<Scalars['ID']['input']>;
    regionIdList: Array<Scalars['ID']['input']>;
};

export type OdpMarketAnalyticsmrktSaleLatestArgs = {
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
};

export type OdpMarketAnalyticsmrktSaleRangeArgs = {
    asc?: InputMaybe<Scalars['Boolean']['input']>;
    from?: InputMaybe<Scalars['String']['input']>;
    maxFetch?: InputMaybe<Scalars['Int']['input']>;
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
    to?: InputMaybe<Scalars['String']['input']>;
};

export type OdpMarketAnalyticsmrktTemperatureBatchLatestArgs = {
    metadataKeyList: Array<Scalars['ID']['input']>;
    regionIdList: Array<Scalars['ID']['input']>;
};

export type OdpMarketAnalyticsmrktTemperatureLatestArgs = {
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
};

export type OdpMarketAnalyticsmrktTemperatureRangeArgs = {
    asc?: InputMaybe<Scalars['Boolean']['input']>;
    from?: InputMaybe<Scalars['String']['input']>;
    maxFetch?: InputMaybe<Scalars['Int']['input']>;
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
    to?: InputMaybe<Scalars['String']['input']>;
};

export type OdpMarketAnalyticsrentalMrktBatchLatestArgs = {
    metadataKeyList: Array<Scalars['ID']['input']>;
    regionIdList: Array<Scalars['ID']['input']>;
};

export type OdpMarketAnalyticsrentalMrktLatestArgs = {
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
};

export type OdpMarketAnalyticsrentalMrktRangeArgs = {
    asc?: InputMaybe<Scalars['Boolean']['input']>;
    from?: InputMaybe<Scalars['String']['input']>;
    maxFetch?: InputMaybe<Scalars['Int']['input']>;
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
    to?: InputMaybe<Scalars['String']['input']>;
};

export type OdpMarketAnalyticszhvfIndex1Args = {
    indexPKey: Scalars['String']['input'];
    indexSortKey?: InputMaybe<Scalars['String']['input']>;
    latestVersion?: InputMaybe<Scalars['Boolean']['input']>;
    maxRecords?: InputMaybe<Scalars['Int']['input']>;
};

export type OdpMarketAnalyticszhvfIndex1RangeArgs = {
    from?: InputMaybe<Scalars['String']['input']>;
    indexPKey: Scalars['String']['input'];
    latestVersion?: InputMaybe<Scalars['Boolean']['input']>;
    maxRecords?: InputMaybe<Scalars['Int']['input']>;
    to?: InputMaybe<Scalars['String']['input']>;
};

export type OdpMarketAnalyticszhvfRangeArgs = {
    asc?: InputMaybe<Scalars['Boolean']['input']>;
    from?: InputMaybe<Scalars['String']['input']>;
    maxFetch?: InputMaybe<Scalars['Int']['input']>;
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
    to?: InputMaybe<Scalars['String']['input']>;
};

export type OdpMarketAnalyticszhviBatchLatestArgs = {
    metadataKeyList: Array<Scalars['ID']['input']>;
    regionIdList: Array<Scalars['ID']['input']>;
};

export type OdpMarketAnalyticszhviLatestArgs = {
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
};

export type OdpMarketAnalyticszhviRangeArgs = {
    asc?: InputMaybe<Scalars['Boolean']['input']>;
    from?: InputMaybe<Scalars['String']['input']>;
    maxFetch?: InputMaybe<Scalars['Int']['input']>;
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
    to?: InputMaybe<Scalars['String']['input']>;
};

export type OdpMarketAnalyticszoriBatchLatestArgs = {
    metadataKeyList: Array<Scalars['ID']['input']>;
    regionIdList: Array<Scalars['ID']['input']>;
};

export type OdpMarketAnalyticszoriLatestArgs = {
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
};

export type OdpMarketAnalyticszoriRangeArgs = {
    asc?: InputMaybe<Scalars['Boolean']['input']>;
    from?: InputMaybe<Scalars['String']['input']>;
    maxFetch?: InputMaybe<Scalars['Int']['input']>;
    metadataKey: Scalars['ID']['input'];
    regionId: Scalars['ID']['input'];
    to?: InputMaybe<Scalars['String']['input']>;
};

/**  Object containing ODP data relevant for a property given a zpid. Sort key parameter can be omitted on certain fields, in which case the latest data available is retrieved.  */
export type OdpPropertyModels = {
    aipersSimilarHomes?: Maybe<AipersSimilarHomes>;
    climate?: Maybe<ClimatePropertyDetails>;
    scmaValuation?: Maybe<EntityPropertyAvm>;
    zcr?: Maybe<EntityPropertyAvm>;
    zestimate?: Maybe<OdpZestimate>;
    zestimateConfidenceLabels?: Maybe<ZestimateConfidenceLabels>;
    zestimateNeuralNetComps?: Maybe<ZestimateNeuralNetComps>;
    zestimateNeuralNetComps2?: Maybe<ZestimateNeuralNetComps2>;
    zestimateOffMarket?: Maybe<ZestimateOffMarket>;
    zpid: Scalars['String']['output'];
};

/**  Object containing ODP data relevant for a property given a zpid. Sort key parameter can be omitted on certain fields, in which case the latest data available is retrieved.  */
export type OdpPropertyModelsaipersSimilarHomesArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing ODP data relevant for a property given a zpid. Sort key parameter can be omitted on certain fields, in which case the latest data available is retrieved.  */
export type OdpPropertyModelszestimateArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing ODP data relevant for a property given a zpid. Sort key parameter can be omitted on certain fields, in which case the latest data available is retrieved.  */
export type OdpPropertyModelszestimateConfidenceLabelsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing ODP data relevant for a property given a zpid. Sort key parameter can be omitted on certain fields, in which case the latest data available is retrieved.  */
export type OdpPropertyModelszestimateNeuralNetCompsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing ODP data relevant for a property given a zpid. Sort key parameter can be omitted on certain fields, in which case the latest data available is retrieved.  */
export type OdpPropertyModelszestimateNeuralNetComps2Args = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing ODP data relevant for a property given a zpid. Sort key parameter can be omitted on certain fields, in which case the latest data available is retrieved.  */
export type OdpPropertyModelszestimateOffMarketArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type OdpZestimate = {
    groupId?: Maybe<Scalars['Int']['output']>;
    high?: Maybe<Scalars['Float']['output']>;
    low?: Maybe<Scalars['Float']['output']>;
    score?: Maybe<Scalars['Float']['output']>;
    valuationId?: Maybe<Scalars['String']['output']>;
    zpid: Scalars['Int']['output'];
};

export type Offer = {
    offerRequestId?: Maybe<Scalars['String']['output']>;
    price?: Maybe<Scalars['Int']['output']>;
    zuid?: Maybe<Scalars['Int']['output']>;
};

export type OfferCreationResponse = {
    accessToken: Scalars['ID']['output'];
    misoID: Scalars['ID']['output'];
};

/** Information about the expiration of an offer */
export type OfferExpiration = {
    isExpired?: Maybe<Scalars['Boolean']['output']>;
};

/** A zillow offers request */
export type OfferRequest = {
    abTests?: Maybe<OfferRequestABTests>;
    /** Information about the assigned zillow advisor for a seller */
    assignedZillowOffersAdvisor?: Maybe<OfferRequestAdvisor>;
    /** Number of bathrooms reported in the questionnaire answers */
    bathrooms?: Maybe<Scalars['Int']['output']>;
    /** Number of bedrooms reported in the questionnaire answers */
    bedrooms?: Maybe<Scalars['Int']['output']>;
    builderSource?: Maybe<Scalars['String']['output']>;
    /** The reason the offer request was closed */
    closeReason?: Maybe<Scalars['String']['output']>;
    /**
     * The comps associated with an offer request. The string value 'adjusted' to the
     * arg offerType gives adjusted offer comps, otherwise gives default initial offer comps
     */
    comps?: Maybe<Array<Maybe<OfferRequestComp>>>;
    createDate?: Maybe<Scalars['DateTime']['output']>;
    csatSurveys?: Maybe<CSATSurveys>;
    /** Categories for user submitted issues on their Offer Request */
    customerServiceIssueTypes?: Maybe<Array<Maybe<IssueTypeDetails>>>;
    dates?: Maybe<OfferRequestDateItem>;
    encodedOfferRequestId?: Maybe<Scalars['String']['output']>;
    /** Estimates for an offer request. */
    estimates?: Maybe<Array<Maybe<estimate>>>;
    /**
     * The evaluation details associated with the provided offer request id
     * @deprecated ZO service wind down
     */
    evaluation?: Maybe<EvaluationType>;
    /** The URL where home evaluations can be scheduled */
    evaluationScheduleUrl?: Maybe<Scalars['String']['output']>;
    /** The zDocs evaluation waiver URL for ZO inspections which require it */
    evaluationWaiverUrl?: Maybe<Scalars['String']['output']>;
    /** Whether the offer associated with the offer request is expired */
    isExpired?: Maybe<Scalars['Boolean']['output']>;
    isPermanentlyClosed?: Maybe<Scalars['Boolean']['output']>;
    /** Living area reported in the questionnaire answers */
    livingArea?: Maybe<Scalars['Int']['output']>;
    /** The offer presentations of an offer request */
    offer?: Maybe<OfferType>;
    /** Information about the expiration of an offer */
    offerExpiration?: Maybe<OfferExpiration>;
    offerRequestStatus?: Maybe<Scalars['String']['output']>;
    /** The offers associated with this offer request */
    offersJson?: Maybe<Scalars['JSON']['output']>;
    /**
     * The information of the associated partner broker for the provided offer request id
     * @deprecated Zillow Offers Shutdown. No longer supporting Partner Agents
     */
    partnerAgent?: Maybe<PartnerAgent>;
    /** The partner broker associated with the market the offer request was created in */
    partnerBroker?: Maybe<PartnerBroker>;
    /**
     * The information of the associated partner lead for the provided offer request id
     * @deprecated Zillow Offers Shutdown. Partner agent leads no longer in use
     */
    partnerLead?: Maybe<PartnerLead>;
    /**
     * The ML predictions associated with this offer request
     * @deprecated Repair cost estimation has been removed from the seller dashboard
     */
    predictionsJson?: Maybe<Scalars['JSON']['output']>;
    property?: Maybe<Property>;
    /** The questionnaire results associated with this offer request */
    questionnaireResultsJson?: Maybe<Scalars['JSON']['output']>;
    /**
     * The list of repairs necessary for a home submitted to Zillow Offers associated with the provided offer request id
     * @deprecated Repairs breakdown has been removed from the seller dashboard
     */
    repairs?: Maybe<Array<Maybe<RepairItem>>>;
    /** Information about the assigned zillow advisor for a seller */
    sellerResponses?: Maybe<SellerResponseInfoItem>;
    /** The seller perspective of an offer request status */
    sellerStatus?: Maybe<OfferRequestStatus>;
};

/** A zillow offers request */
export type OfferRequestcompsArgs = {
    offerType?: InputMaybe<Scalars['String']['input']>;
};

/** A zillow offers request */
export type OfferRequestestimatesArgs = {
    overrideAssignments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overrideTrials?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A zillow offers request */
export type OfferRequestevaluationWaiverUrlArgs = {
    signerName: Scalars['String']['input'];
};

/** A zillow offers request */
export type OfferRequestoffersJsonArgs = {
    offerType?: InputMaybe<Scalars['String']['input']>;
};

/** AB treatments tied to the offer request */
export type OfferRequestABTests = {
    abTest?: Maybe<Scalars['String']['output']>;
};

/** AB treatments tied to the offer request */
export type OfferRequestABTestsabTestArgs = {
    trial?: InputMaybe<Scalars['String']['input']>;
};

/** Information about the assigned zillow advisor for a seller */
export type OfferRequestAdvisor = {
    email?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

/** The single comp associated with an offer request */
export type OfferRequestComp = {
    address?: Maybe<OfferRequestCompAddress>;
    amenitiesDifferenceList?: Maybe<Array<Maybe<OfferRequestCompAmenityDifferences>>>;
    appreciationPercent?: Maybe<Scalars['Float']['output']>;
    bathrooms?: Maybe<Scalars['Float']['output']>;
    bedrooms?: Maybe<Scalars['Int']['output']>;
    compType?: Maybe<Scalars['String']['output']>;
    daysOnMarket?: Maybe<Scalars['Int']['output']>;
    imageUrls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    latitude?: Maybe<Scalars['Float']['output']>;
    listDate?: Maybe<Scalars['DateTime']['output']>;
    listMLS?: Maybe<Scalars['String']['output']>;
    listOfficeName?: Maybe<Scalars['String']['output']>;
    listPrice?: Maybe<Scalars['Int']['output']>;
    livingArea?: Maybe<Scalars['Int']['output']>;
    longitude?: Maybe<Scalars['Float']['output']>;
    property?: Maybe<Property>;
    saleDate?: Maybe<Scalars['DateTime']['output']>;
    salePrice?: Maybe<Scalars['Int']['output']>;
};

/** The address for a comp */
export type OfferRequestCompAddress = {
    city?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    zipcode?: Maybe<Scalars['String']['output']>;
};

/** The amenity differences for a comp */
export type OfferRequestCompAmenityDifferences = {
    amenityDifference?: Maybe<Scalars['String']['output']>;
    customerFacingKey?: Maybe<Scalars['String']['output']>;
};

/** Evaluation and presentation dates for an offer. */
export type OfferRequestDateItem = {
    scheduledEvaluationDate?: Maybe<Scalars['DateTime']['output']>;
    scheduledEvaluationDateTimezone?: Maybe<Scalars['String']['output']>;
    scheduledInitialPresentationDate?: Maybe<Scalars['DateTime']['output']>;
};

/** The status of an offer request */
export type OfferRequestStatus = {
    /** An unordered array of constant strings representing the states this projection has reached */
    currentState: Array<Maybe<Scalars['String']['output']>>;
};

/** The offer presentations of an offer request id */
export type OfferType = {
    adjustedOffer?: Maybe<offer>;
    initialOffer?: Maybe<offer>;
};

/** The offer presentations of an offer request id */
export type OfferTypeadjustedOfferArgs = {
    overrideAssignments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overrideTrials?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** The offer presentations of an offer request id */
export type OfferTypeinitialOfferArgs = {
    overrideAssignments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    overrideTrials?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type OfferUpsellData = {
    estimateOfferData?: Maybe<EstimateOfferData>;
    liveOfferData?: Maybe<LiveOfferData>;
};

export type Offers = {
    od?: Maybe<OpendoorOffer>;
    scma?: Maybe<Scma>;
};

export type OffersCreationInput = {
    questionnaireResponseId: Scalars['ID']['input'];
    zpid: Scalars['Int']['input'];
};

export type OffersResult = {
    /**  unique id to be used to access the seller dashboard  */
    accessTokenId: Scalars['ID']['output'];
    /**  eligibilityType for miso offers  */
    eligibilityType?: Maybe<EligibilityType>;
    /**  property miso identifier  */
    misoId: Scalars['ID']['output'];
    /**  offers to display on the seller dashboard  */
    offers: Offers;
    property: Property;
    /**  unique id for the questionnaire response  */
    questionnaireResponseId: Scalars['ID']['output'];
    recommendation?: Maybe<MisoOfferRecommendation>;
    /**  zpid of property for the dashboard  */
    zpid: Scalars['Int']['output'];
};

/** This block is used to create the omp contextual block in the omp new lane events. */
export type OmpBlock = {
    /** The placement's corresponding AB bucket that the user falls in */
    bucket?: Maybe<Scalars['String']['output']>;
    /** User's decision context encoded zuid */
    decisionContextEncodedZuid?: Maybe<Scalars['String']['output']>;
    /** User guid */
    decisionContextGuid?: Maybe<Scalars['String']['output']>;
    /**
     * For certain placement, we will simulate a random coin flip to decide whether
     * to render the chosen treatment on UI, so that the user won't be overwhelmed by
     * messages on every page view
     */
    didPassThrottle?: Maybe<Scalars['Boolean']['output']>;
    /** A unique event id for clickstream events for upsells to help track them in analytics */
    eventId?: Maybe<Scalars['String']['output']>;
    /** A boolean to indicate if the user guid is in OMP global holdout bucket */
    isGlobalHoldout?: Maybe<Scalars['Boolean']['output']>;
    /** A boolean to indicate whether the user guid is in OMP placement-level holdout bucket */
    isPlacementHoldout?: Maybe<Scalars['Boolean']['output']>;
    /** Timestamp when the placement config data was last modified */
    lastModified?: Maybe<Scalars['String']['output']>;
    /** Placement id */
    placementId?: Maybe<Scalars['Int']['output']>;
    /** The placement where OMP displays the message */
    placementName?: Maybe<Scalars['String']['output']>;
    /** A list of Baseline treatments that the user is eligible for */
    qualifiedTreatmentBaselineEvaluation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** A list of OMP Portfolio treatments that the user is eligible for */
    qualifiedTreatmentPortfolio?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** A list of OMP Portfolio Test treatments that the user is eligible for */
    qualifiedTreatmentPortfolioTest?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** A list of Target Selection treatments that the user is eligible for */
    qualifiedTreatmentTargetSelection?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Selected treatment's experiment family */
    selectedTreatmentExperimentFamilyNm?: Maybe<Scalars['String']['output']>;
    /** Selected treatment's experiment iteration */
    selectedTreatmentExperimentIterationTxt?: Maybe<Scalars['String']['output']>;
    /** Selected treatment's id number */
    selectedTreatmentId?: Maybe<Scalars['Int']['output']>;
    /** Selected treatment's last modified timestamp */
    selectedTreatmentLastModified?: Maybe<Scalars['String']['output']>;
    /** Selected treatment's line of business */
    selectedTreatmentLobNm?: Maybe<Scalars['String']['output']>;
    /** Selected treatment's location, e.g. top */
    selectedTreatmentLocationNm?: Maybe<Scalars['String']['output']>;
    /** Selected treatment's name */
    selectedTreatmentName?: Maybe<Scalars['String']['output']>;
    /** Selected treatment's placement, e.g. fshdp */
    selectedTreatmentPlacement?: Maybe<Scalars['String']['output']>;
    /** Selected treatment's status */
    selectedTreatmentStatus?: Maybe<Scalars['String']['output']>;
    /** Selected treatment's variation name */
    selectedTreatmentVariationNm?: Maybe<Scalars['String']['output']>;
    /** A boolean to indicate whether the selected treatment (if any) should be displayed for the user */
    shouldDisplay?: Maybe<Scalars['Boolean']['output']>;
    /** If the selected treatment is decided not to be displayed, this field will explain the reason of skipping displaying */
    skipDisplayReason?: Maybe<Scalars['String']['output']>;
    /** The experiment phase that the user falls in */
    testPhase?: Maybe<Scalars['String']['output']>;
};

export type OmpComponentType = IOSUpsellArrowCTACard | IOSUpsellCard;

export type OnMarketZestimate = {
    zestimate?: Maybe<Scalars['Int']['output']>;
    zestimateHighPercent?: Maybe<Scalars['String']['output']>;
    zestimateLowPercent?: Maybe<Scalars['String']['output']>;
};

/** A collection of message display decisions for a given list of placements */
export type OnsiteMessageResultType = {
    /**
     * [Deprecated] a JSON String that contains all the context data used or to be
     * used to make the treatment selection decision (which will be logged and used
     * by data scientists)
     * @deprecated Deprecated to move field into [messages] to better support bulk requests for Onsite Message selection decisions
     */
    decisionContext: Scalars['JSON']['output'];
    /**
     * [Deprecated] field for unique event id for the chosen treatment
     * @deprecated Deprecated to move field into [messages] to better support bulk requests for Onsite Message selection decisions
     */
    eventId: Scalars['String']['output'];
    messages?: Maybe<Array<Maybe<PlacementDecisionType>>>;
};

export type OpenHouse = {
    endTime?: Maybe<Scalars['String']['output']>;
    openHouseMethod?: Maybe<Scalars['String']['output']>;
    startTime?: Maybe<Scalars['String']['output']>;
    virtualOpenHouseURL?: Maybe<Scalars['String']['output']>;
};

export type OpendoorOffer = {
    /**  closed date of transaction  */
    closedAt?: Maybe<Scalars['String']['output']>;
    /**  estimate of the proceeds of transaction  */
    estCashProceed?: Maybe<Scalars['Int']['output']>;
    /**  estimated closing cost of property value 1%  */
    estClosingCost?: Maybe<Scalars['Int']['output']>;
    /**  estimated closing cost of property value by percentage  */
    estClosingCostPercent?: Maybe<Scalars['Float']['output']>;
    /**  estimated repair cost  */
    estRepairCost?: Maybe<Scalars['Int']['output']>;
    /**  estimated service charge of property value 5%  */
    estServiceCharge?: Maybe<Scalars['Int']['output']>;
    /**  estimated service charge of property value by percentage  */
    estServiceChargePercent?: Maybe<Scalars['Float']['output']>;
    /**  expected close date of transaction  */
    expectedCloseDate?: Maybe<Scalars['String']['output']>;
    /**  date when the offer expires  */
    expirationDateTime?: Maybe<Scalars['String']['output']>;
    /**  expiration display date from opendoor   */
    expirationDisplayDate?: Maybe<Scalars['String']['output']>;
    /**  flag to determine if opendoor has responded with an offer  */
    isOdEligible?: Maybe<Scalars['Boolean']['output']>;
    /**  unique id of the opendoor offer  */
    opendoorOfferId: Scalars['ID']['output'];
    /**  offer price  */
    price?: Maybe<Scalars['Int']['output']>;
    /**  flag about opendoor offer price alert  */
    priceAlert?: Maybe<Scalars['String']['output']>;
    /**  status of the opendoor offer  */
    status: Scalars['String']['output'];
    /**  link to the dashboard to redirect the seller  */
    url?: Maybe<Scalars['String']['output']>;
};

/** OpportunityAgent ... */
export type OpportunityAgent = {
    action_type_code?: Maybe<Scalars['String']['output']>;
    agent_zuid?: Maybe<Scalars['Int']['output']>;
    lead_pacing_position?: Maybe<Scalars['Int']['output']>;
    lead_rule_id?: Maybe<Scalars['Int']['output']>;
    pacing_agent_zuid?: Maybe<Scalars['Int']['output']>;
    position?: Maybe<Scalars['Int']['output']>;
    routed_by?: Maybe<Scalars['String']['output']>;
};

export type OpportunityData = {
    lastModifiedDate?: Maybe<Scalars['String']['output']>;
};

export type OtherCurrentResidence = CurrentResidence &
    OtherResidence &
    Residence & {
        address?: Maybe<RentalApplicationAddress>;
        description?: Maybe<Scalars['String']['output']>;
        id?: Maybe<Scalars['ID']['output']>;
        monthlyPayment?: Maybe<Scalars['USCurrency']['output']>;
        startDate?: Maybe<Scalars['Date']['output']>;
        type?: Maybe<ResidenceType>;
    };

export type OtherIncome = CurrentIncome & {
    amount?: Maybe<Scalars['USCurrency']['output']>;
    areDocumentsExpired?: Maybe<Scalars['Boolean']['output']>;
    documents?: Maybe<Array<Maybe<Document>>>;
    id?: Maybe<Scalars['String']['output']>;
    isVerified?: Maybe<Scalars['Boolean']['output']>;
    note?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    type?: Maybe<IncomeType>;
    verification?: Maybe<IncomeVerification>;
};

export type OtherPastResidence = OtherResidence &
    PastResidence &
    Residence & {
        address?: Maybe<RentalApplicationAddress>;
        description?: Maybe<Scalars['String']['output']>;
        endDate?: Maybe<Scalars['Date']['output']>;
        id?: Maybe<Scalars['ID']['output']>;
        startDate?: Maybe<Scalars['Date']['output']>;
        type?: Maybe<ResidenceType>;
    };

export type OtherResidence = {
    description?: Maybe<Scalars['String']['output']>;
};

export type OutdoorCommonAreaType =
    | 'Deck'
    | 'Garden'
    | 'Gazebo'
    | 'Lawn'
    | 'None'
    | 'Patio'
    | 'PicnicArea'
    | 'Playground'
    | 'RooftopDeck'
    | 'Trail'
    | 'Unknown'
    | 'WaterFeature';

export type OwnedCurrentResidence = CurrentResidence &
    Residence & {
        address?: Maybe<RentalApplicationAddress>;
        id?: Maybe<Scalars['ID']['output']>;
        monthlyPayment?: Maybe<Scalars['USCurrency']['output']>;
        startDate?: Maybe<Scalars['Date']['output']>;
        type?: Maybe<ResidenceType>;
    };

export type OwnedPastResidence = PastResidence &
    Residence & {
        address?: Maybe<RentalApplicationAddress>;
        endDate?: Maybe<Scalars['Date']['output']>;
        id?: Maybe<Scalars['ID']['output']>;
        startDate?: Maybe<Scalars['Date']['output']>;
        type?: Maybe<ResidenceType>;
    };

export type Owner = {
    /** Name of the owner of the property */
    name?: Maybe<Scalars['String']['output']>;
    /**
     * Owner's Phone Number. North American 10 digit phone numbers
     * should be in the format of ###-###-#### (separated by hyphens).
     * Other conventions should use the common local standard.
     * International numbers should be preceded by a plus symbol.
     */
    phone?: Maybe<Scalars['String']['output']>;
};

/** Account information on the owner of the property. Admin-only. */
export type OwnerAccountType = {
    email?: Maybe<Scalars['String']['output']>;
    zuid?: Maybe<Scalars['Int']['output']>;
};

export type PAAgent = {
    activeZipCampaigns?: Maybe<PAAgentZipCampaigns>;
    agentCare?: Maybe<AgentCare>;
    autoPublishPastSales?: Maybe<autoPublishPastSalesSetting>;
    betaGroups?: Maybe<Array<Scalars['String']['output']>>;
    brokerage?: Maybe<Brokerage>;
    businessConsultant?: Maybe<BusinessConsultant>;
    businessName?: Maybe<Scalars['String']['output']>;
    dotloopLinked: Scalars['Boolean']['output'];
    email?: Maybe<Scalars['String']['output']>;
    encodedZillowUserId?: Maybe<Scalars['String']['output']>;
    flexReason?: Maybe<Scalars['String']['output']>;
    flexStatus?: Maybe<Scalars['String']['output']>;
    hasFlex?: Maybe<Scalars['Boolean']['output']>;
    hasMyAgent: Scalars['Boolean']['output'];
    hasPA4: Scalars['Boolean']['output'];
    hasPremierAgent: Scalars['Boolean']['output'];
    hasTpro: Scalars['Boolean']['output'];
    /** @deprecated Zillow offers is deprecated */
    hasZillowOffers: Scalars['Boolean']['output'];
    isAgent?: Maybe<Scalars['Boolean']['output']>;
    isAgentOrTeamLeadPaying?: Maybe<Scalars['Boolean']['output']>;
    isBroker?: Maybe<Scalars['Boolean']['output']>;
    isGrowthPartner?: Maybe<Scalars['Boolean']['output']>;
    isPACEnabled: Scalars['Boolean']['output'];
    isPaying?: Maybe<Scalars['Boolean']['output']>;
    isTeamLead?: Maybe<Scalars['Boolean']['output']>;
    isTeamMember?: Maybe<Scalars['Boolean']['output']>;
    isTouringAgreementEnabled?: Maybe<AgentTouringAgreementEnablementStatus>;
    isTwilioEnabled: Scalars['Boolean']['output'];
    /** @deprecated ZCS is deprecated, used by legacy apps */
    isZcsPartner?: Maybe<Scalars['Boolean']['output']>;
    mailbox?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    photoUrl?: Maybe<Scalars['String']['output']>;
    profile?: Maybe<AgentProfile>;
    screenName?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Sms preferences for agent notifications
     * **Source:** Agent Phone Provisioning Service (aka EAN) via PA Graph
     *
     * **Team Slack:** #deltaforce
     */
    smsPreferences?: Maybe<SmsPreferences>;
    teamLeadOf?: Maybe<PATeam>;
    teamMemberOf?: Maybe<Array<PATeam>>;
    /**
     * **Definition:** The name of the team the agent leads, or the public team they're a member of.
     * **Auth:** Public
     * **Source:** Profile Data Management via PA Graph
     */
    teamName?: Maybe<Scalars['String']['output']>;
    twilioNumber?: Maybe<Scalars['String']['output']>;
    usesEscrow: Scalars['Boolean']['output'];
    website?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** The zuid of the agent participant
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     */
    zillowUserId: Scalars['Int']['output'];
};

export type PAAgentisPayingArgs = {
    useTeamLeadStatus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PAAgentisTeamMemberArgs = {
    publicOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PAAgentteamMemberOfArgs = {
    publicOnly: Scalars['Boolean']['input'];
};

export type PAAgentSelfPause = {
    assigneeZillowUserId: Scalars['ID']['output'];
    creationDate: Scalars['DateTime']['output'];
    deleteDate?: Maybe<Scalars['DateTime']['output']>;
    encodedZuid?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    reason?: Maybe<Scalars['String']['output']>;
    unpausedAt?: Maybe<Scalars['DateTime']['output']>;
    updateDate: Scalars['DateTime']['output'];
};

export type PAAgentZipCampaign = {
    regionId?: Maybe<Scalars['Int']['output']>;
    zipcode?: Maybe<Scalars['String']['output']>;
};

export type PAAgentZipCampaigns = {
    flex?: Maybe<Array<PAFlexAgentZipCampaign>>;
    /** @deprecated Source service is deprecated contact PACE team for directions on how to get this data */
    mbp?: Maybe<Array<PAMBPAgentZipCampaign>>;
};

export type PAContact = {
    /**
     * **Definition:** Get contact phones
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    Phones?: Maybe<Array<Maybe<PAPhone>>>;
    /** @deprecated Renamed. Use recentActivity */
    activityEvents?: Maybe<PAContactActivityEvents>;
    /**
     * **Definition:** Summary of Buyer's preferences based on activity
     * **Team Slack:** #sirius-support
     *
     * activityPreferences uses the agentZuid from the access token and is not currently able to use the agentZuid in the paContact parameter
     */
    activityPreferences?: Maybe<PAContactActivityPreferences>;
    /**
     * **Definition:** Summary of Buyer's activity for given date range
     *
     * **Team Slack:** #iron-chef
     *
     * endDate should be an ISO UTC datetime (example: 2023-11-07T19:38:47.803Z)
     *
     * activitySummaries uses the agentZuid from the access token and is not currently able to use the agentZuid in the paContact parameter
     */
    activitySummaries?: Maybe<PAContactActivitySummaries>;
    /**
     * **Definition:** Assignee agent of the contact
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    assigneeAgent?: Maybe<PAAgent>;
    /**
     * **Definition:** Contact's assist status
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    assistStatus?: Maybe<PAContactAssistStatus>;
    /**
     * **Definition:** Contact Background
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    background?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Contact birthday
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    birthdayDate?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** Contact company
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    company?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** List of contact history events. Combine with contact events, forward history events, & lender events
     *
     * **Datasource:** Contacts Resource (CRM DB), events API
     *
     * **Team Slack:** #theclosers
     */
    contactHistory?: Maybe<Array<PAContactHistoryEvent>>;
    /**
     * **Definition:** Contact id
     *
     * **Team Slack:** #theclosers
     * @deprecated Use id for ID type
     */
    contactId: Scalars['Int']['output'];
    /**
     * **Definition:** The duration of contact's current status and the threshold of that status
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    contactStatusDuration?: Maybe<PAContactStatusDuration>;
    /**
     * **Definition:** Contact creation date
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    creationDate: Scalars['DateTime']['output'];
    /**
     * **Definition:** Contact display name, with fallback to email or phone
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Get contact email
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    email?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Encoded contact id
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    encodedContactId?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Contact first name
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    firstName: Scalars['String']['output'];
    /**
     * **Definition:** Contact forward history
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    forwardHistory?: Maybe<Array<Maybe<PAContactForwardHistory>>>;
    /**
     * **Definition:** Deeplink from PA app to Follow Up Boss app.
     * **Datasource:** Webhook Subscription API
     *
     * **Team Slack:** #sirius-business
     */
    fubDeeplinkUrl?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Does contact have an agent?
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    hasAgent?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Contact has mortgage lender?
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    hasMortgageLender?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Contact requested pre-approval?
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    hasRequestedPreApproval?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Contact's home address
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    homeAddress?: Maybe<PAContactAddress>;
    /**
     * **Definition:** Contact home recommendations
     * **Datasource:** Collections Api
     *
     * **Team Slack:** #theclosers
     */
    homeRecommendationCollections?: Maybe<Array<PAContactHomeRecommendationCollection>>;
    /**
     * **Definition:** Contact home recommendations
     * **Datasource:** Home Recs Api
     *
     * **Team Slack:** #sirius-business
     */
    homeRecommendations?: Maybe<Array<PAContactHomeRecommendation>>;
    /**
     * **Definition:** Contact id
     *
     * **Team Slack:** #theclosers
     */
    id: Scalars['ID']['output'];
    /**
     * **Definition:** Is contact billable. When contact in flex or ZO
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    isBillable?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** If contact is in flex channel
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    isFlex?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:**
     *
     * Determine if this Contact has MyAgent Relationship with assignee or the team lead
     *
     * Note: Currently only work with the logged in agent access token and not the agentZuid param/scoped token until we migrate fully migrate paContact query to pa-crm-subgraph
     *
     * **Team Slack:** #my-agent
     */
    isMyAgentLinked?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Contact job title
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    jobTitle?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Contact last modifiied date
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    lastModifiedDateTime?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** Contact last name
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    lastName: Scalars['String']['output'];
    /**
     * **Definition:** Contact loan status
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    loanStatus?: Maybe<PAContactLoanStatus>;
    /**
     * **Definition:** Contact dotloop list
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    loops?: Maybe<Array<Maybe<PALoop>>>;
    /**
     * **Definition:** Array of Managed Tags associated with this contact
     *
     * **Team Slack:** #theclosers
     */
    managedTags?: Maybe<Array<PAContactManagedTag>>;
    /**
     * **Definition:** Miso Id
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    misoId?: Maybe<Scalars['String']['output']>;
    mortgage?: Maybe<Mortgage>;
    /**
     * **Definition:** Total number of notes for this contact
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    noteTotal?: Maybe<Scalars['Int']['output']>;
    /**
     * **Definition:** Contact notes
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    notes?: Maybe<Array<Maybe<PANote>>>;
    /**
     * **Definition:** Loan officer visibility disclaimer
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    notesViewDisclaimerText?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Contact's online frequencies
     *
     * **Source:** BUA contact insights API
     *
     * **Timezone format TZ identifier
     *
     * ** eg: America/Los_Angeles
     */
    onlineFrequencies?: Maybe<Array<PAContactOnlineFrequencies>>;
    /**
     * **Definition:** Owner agent of the contact
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    ownerAgent?: Maybe<PAAgent>;
    /**
     * **Definition:** Percentage change in saves compared to similar previous period
     *
     * **Datasource:** BUA API
     *
     * **Team Slack:** #sirius-business
     */
    percentageSavedChange?: Maybe<Scalars['Float']['output']>;
    /**
     * **Definition:** Percentage change in views compared to similar previous period
     *
     * **Datasource:** BUA API
     *
     * **Team Slack:** #sirius-business
     */
    percentageViewedChange?: Maybe<Scalars['Float']['output']>;
    /**
     * **Definition:** Contact's polaris Id
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    polarisId?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Price point
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    pricePoint?: Maybe<Scalars['Int']['output']>;
    /**
     * **Definition:** CRM Property Snapshot
     *
     * **Team Slack:** #theclosers
     */
    propertySnapshots?: Maybe<Array<PAPropertySnapshot>>;
    /**
     * **Definition:** Prospect type code
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    prospectTypeCode?: Maybe<PAContactProspectType>;
    /**
     * **Definition:** Buyer's activities
     *
     * If date range is not provide, it will use the last 7 days as default
     *
     * **Team Slack:** #iron-chef
     */
    recentActivity?: Maybe<PAContactActivityEvents>;
    /**
     * **Definition:** Contact relationships
     * **Datasource:** Contacts Resource, MyAgent relationship
     *
     * **Team Slack:** #theclosers, #sea-profile-team
     */
    relationships?: Maybe<Array<Maybe<PAContactRelationship>>>;
    /**
     * **Definition:** Contact search history/criteria
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    searchHistory?: Maybe<PAContactSearchHistory>;
    /**
     * **Definition:** Contact Socical Insights
     *
     * **Team Slack:** #theclosers
     */
    socialInsights?: Maybe<PAContactSocialInsight>;
    /**
     * **Definition:** Get contact source (eg. zillow, trulia, streeteasy, outbound email, outbound sms etc.
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    source: Scalars['String']['output'];
    /**
     * **Definition:** Current status for the contact
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    status?: Maybe<PAContactStatus>;
    /**
     * **Definition:** Most recent reason for a status change, but _only_ if the current status requires a reason (Rejected, Nurture)
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    statusChangeReason?: Maybe<PAContactStatusChangeReason>;
    /**
     * **Definition:** Possible statuses for the contact
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    statusList?: Maybe<Array<Maybe<PAContactStatus>>>;
    /**
     * **Definition:** Contact timeframe (values: 0, 1, 3, 6, justlooking)
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     * @deprecated Use PAContact.timeframeData instead
     */
    timeframe: Scalars['String']['output'];
    /**
     * **Definition:** Contact timeframe data
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    timeframeData?: Maybe<PAContactTimeframe>;
    /**
     * **Definition:** Contact Transactions
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    transactions?: Maybe<Array<Maybe<PATransaction>>>;
    /**
     * **Definition:** Determine if contact is interested in ZHL.
     * **Datasource:** Contacts Resource -> Contact table (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    wantsFinancingWithZHL?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** ZHL referral
     *
     * **Team Slack:** #theclosers
     */
    zhlReferral?: Maybe<PAContactZHLReferral>;
    /** @deprecated Renamed. Use zhlReferral. */
    zillow360?: Maybe<PAContactZillow360>;
    /**
     * **Definition:** Zillow Account Zuid associated with this contact
     *
     * **Team Slack:** #theclosers
     */
    zillowAccountZuid?: Maybe<Scalars['String']['output']>;
};

export type PAContactactivityPreferencesArgs = {
    endDate: Scalars['DateTime']['input'];
    startDate: Scalars['DateTime']['input'];
};

export type PAContactactivitySummariesArgs = {
    endDate: Scalars['DateTime']['input'];
    startDate: Scalars['DateTime']['input'];
};

export type PAContactcontactHistoryArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    order?: InputMaybe<Sort>;
};

export type PAContacthomeRecommendationCollectionsArgs = {
    experience: PACrmViewExperience;
};

export type PAContactnotesArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    orderBy?: InputMaybe<PANoteSortOrder>;
};

export type PAContactonlineFrequenciesArgs = {
    limit?: InputMaybe<Scalars['Int']['input']>;
    timezone: Scalars['String']['input'];
};

export type PAContactpercentageSavedChangeArgs = {
    endDate: Scalars['DateTime']['input'];
    startDate: Scalars['DateTime']['input'];
};

export type PAContactpercentageViewedChangeArgs = {
    endDate: Scalars['DateTime']['input'];
    startDate: Scalars['DateTime']['input'];
};

export type PAContactrecentActivityArgs = {
    endDate?: InputMaybe<Scalars['DateTime']['input']>;
    startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type PAContacttransactionsArgs = {
    zpid?: InputMaybe<Scalars['String']['input']>;
};

export type PAContactActionInterval = {
    /**
     * **Definition:** Action interval ID
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    actionIntervalId: Scalars['ID']['output'];
    /**
     * **Definition:** Display name for the action interval
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Scalars['String']['output'];
};

export type PAContactActivityEvents = {
    /** @deprecated Email event is deprecated */
    emailEvent?: Maybe<PAContactEmailEvent>;
    /** Contact is online now when lastActivityDate is within 30 mins */
    isOnlineNow?: Maybe<Scalars['Boolean']['output']>;
    /** Last activity date */
    lastActivityDate?: Maybe<Scalars['DateTime']['output']>;
    /** @deprecated Email event is deprecated */
    openedEmailCount?: Maybe<Scalars['Int']['output']>;
    /** Paginated property events. Use cursor to get next page, and pageSize to set page size */
    paginatedPropertyEvents?: Maybe<PAPaginatedPropertyEvents>;
    /** Saved property event */
    propertyEvent?: Maybe<PAContactPropertyEvent>;
    /** All property events */
    propertyEvents?: Maybe<Array<PAContactPropertyEvent>>;
    /** Number of home saved */
    savedHomeCount?: Maybe<Scalars['Int']['output']>;
    /** @deprecated Email event is deprecated */
    sentEmailCount?: Maybe<Scalars['Int']['output']>;
    /** Number of home views */
    viewedHomeCount?: Maybe<Scalars['Int']['output']>;
};

export type PAContactActivityEventspaginatedPropertyEventsArgs = {
    cursor?: InputMaybe<Scalars['String']['input']>;
    filter?: InputMaybe<PAPropertyEventsFilter>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type PAContactActivityEventspropertyEventsArgs = {
    filter?: InputMaybe<PAPropertyEventsFilter>;
};

export type PAContactActivityPreferences = {
    bathrooms?: Maybe<Scalars['String']['output']>;
    bedrooms?: Maybe<Scalars['String']['output']>;
    hometype?: Maybe<Array<Scalars['String']['output']>>;
    neighborhoods?: Maybe<Array<Scalars['String']['output']>>;
    price?: Maybe<Scalars['String']['output']>;
    sqft?: Maybe<Scalars['String']['output']>;
    zipcodes?: Maybe<Array<Scalars['String']['output']>>;
};

export type PAContactActivitySummaries = {
    biweekly?: Maybe<Array<PAPreferenceCounts>>;
    daily?: Maybe<Array<PAPreferenceCounts>>;
    price?: Maybe<Array<PAPreferenceCounts>>;
    weekly?: Maybe<Array<PAPreferenceCounts>>;
};

export type PAContactAddress = {
    address?: Maybe<Scalars['String']['output']>;
    address2?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['Int']['output']>;
    stateCode?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

/** Contact's address input */
export type PAContactAddressInput = {
    /** Address */
    address?: InputMaybe<Scalars['String']['input']>;
    /** Address2 */
    address2?: InputMaybe<Scalars['String']['input']>;
    /** city */
    city?: InputMaybe<Scalars['String']['input']>;
    /** Address id */
    id?: InputMaybe<Scalars['Int']['input']>;
    /** State code */
    stateCode?: InputMaybe<Scalars['String']['input']>;
    /** Zipcode */
    zip?: InputMaybe<Scalars['String']['input']>;
};

export type PAContactAssistStatus = {
    /** Assist status detail */
    detail?: Maybe<Scalars['String']['output']>;
    /** Contact assist status */
    status?: Maybe<Scalars['Int']['output']>;
    /** Assist status summary */
    summary?: Maybe<Scalars['String']['output']>;
    /** Assist status update date time */
    updateDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type PAContactChannel = 'FLEX' | 'NONE' | 'ZO';

export type PAContactEmailEvent = {
    brand?: Maybe<Scalars['String']['output']>;
    campaignType?: Maybe<Scalars['String']['output']>;
    eventDate?: Maybe<Scalars['String']['output']>;
    searchPreferences?: Maybe<PAContactSearchPreferences>;
    sentTimestampUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type PAContactFlexPipeline = {
    /**
     * **Definition:** Active flex status
     *
     * **Team Slack:** #theclosers
     */
    active?: Maybe<Array<PAFlexPipelineItem>>;
    /**
     * **Definition:** Total number of flex contacts
     *
     * **Team Slack:** #theclosers
     */
    flexTotal?: Maybe<Scalars['Int']['output']>;
    /**
     * **Definition:** Inactive flex status
     *
     * **Team Slack:** #theclosers
     */
    inactive?: Maybe<Array<PAFlexPipelineItem>>;
    /**
     * **Definition:** Total number of flex contacts needs attention
     *
     * **Team Slack:** #theclosers
     */
    needsAttentionTotal?: Maybe<Scalars['Int']['output']>;
    /**
     * **Definition:** Nurture flex status
     *
     * **Team Slack:** #theclosers
     */
    nurture?: Maybe<PAFlexPipelineItem>;
    /**
     * **Definition:** Program Status
     *
     * **Team Slack:** #theclosers
     */
    programStatus?: Maybe<PAFlexProgramStatus>;
};

export type PAContactForwardHistory = {
    /**
     * **Definition:** Contact creation date
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    agentEmail?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Agent name
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    agentName?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Forward history event creation date
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    creationDate?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** Forward history event type
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    eventType?: Maybe<PAContactForwardHistoryEventType>;
    /**
     * **Definition:** Forwarding rule id
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    forwardingRuleID?: Maybe<Scalars['ID']['output']>;
    /** @deprecated Use forwardingRuleID instead. */
    forwardingRuleId?: Maybe<Scalars['Int']['output']>;
    /**
     * **Definition:** Forward history id
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    id?: Maybe<Scalars['Int']['output']>;
};

export type PAContactForwardHistoryEventType = 'forwardfrom' | 'forwardto';

export type PAContactHistoryEvent = {
    /**
     * Event copy
     *
     * eg: Transaction details added for
     */
    eventCopy?: Maybe<Scalars['String']['output']>;
    /**
     * Event data
     *
     * eg: 555 1/2 28 3/4 Rd, Grand Junction, CO, 81501
     */
    eventData?: Maybe<Scalars['String']['output']>;
    /** Event data time */
    eventDate?: Maybe<Scalars['DateTime']['output']>;
    /**
     * Event icon url
     *
     * eg: http://static-resource.zg-ap-apps.com.s3.us-west-2.amazonaws.com/transactionIcon.png
     */
    eventIconUrl?: Maybe<Scalars['String']['output']>;
    /**
     * Event source
     *
     * eg: Zillow, Follow up boss
     */
    eventSource?: Maybe<Scalars['String']['output']>;
    /**
     * Event type
     *
     * (eg: contact.create, contact.delete, contactLender.create, contactForward.create,
     * contactLoop.create, contactNote.create, contactTransaction.create, contactNote.delete,
     * contactAssist.update, contact.update.status, contact.update.timeframe, contactTransaction.update,
     * agentContactLink.update)
     */
    eventType?: Maybe<Scalars['String']['output']>;
};

export type PAContactHomeRecommendation = {
    /**
     * **Definition:** Home address
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    address?: Maybe<PAHomeRecAddress>;
    /**
     * **Definition:** Home images
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    images?: Maybe<Array<PAHomeRecImage>>;
    /**
     * **Definition:** Listing office
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    listingOffice?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** MLS ID
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    mlsId?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** MLS Logo
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    mlsLogo?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Number of bathrooms
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    numBaths?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Number of beds
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    numBeds?: Maybe<Scalars['Int']['output']>;
    /**
     * **Definition:** Home price
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    price?: Maybe<Scalars['Int']['output']>;
    /**
     * **Definition:** zpid
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    propertyId: Scalars['ID']['output'];
    /**
     * **Definition:** URL to the HDP
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    propertyUrl?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Website the HDP is from
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    source?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** House square feet
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    sqft?: Maybe<Scalars['Int']['output']>;
    /**
     * **Definition:** House status
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    status?: Maybe<Scalars['String']['output']>;
};

export type PAContactHomeRecommendationCollection = {
    /**
     * **Definition:** Contact home recommendations collection name
     * **Datasource:** Collections Api
     *
     * **Team Slack:** #theclosers
     */
    collectionName?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Contact home recommendations Property array
     * **Datasource:** Collections Api / GDP (federated)
     *
     * **Team Slack:** #theclosers
     */
    properties?: Maybe<Array<Maybe<Property>>>;
};

/** Contact input for create/update mutation */
export type PAContactInput = {
    /** Action interval id */
    actionIntervalID?: InputMaybe<Scalars['ID']['input']>;
    /** Contact's address */
    address?: InputMaybe<PAContactAddressInput>;
    /** Contact's background */
    background?: InputMaybe<Scalars['String']['input']>;
    /** Contact's birthday */
    birthday?: InputMaybe<Scalars['DateTime']['input']>;
    /** Contact's compnay */
    company?: InputMaybe<Scalars['String']['input']>;
    /** Contact's email */
    email?: InputMaybe<Scalars['String']['input']>;
    /** Contact's first name */
    firstName?: InputMaybe<Scalars['String']['input']>;
    /** Does contact have an agent */
    hasAgent?: InputMaybe<Scalars['Boolean']['input']>;
    /** Does contact have a mortgage lender */
    hasMortgageLender?: InputMaybe<Scalars['Boolean']['input']>;
    /** Contact's job title */
    jobTitle?: InputMaybe<Scalars['String']['input']>;
    /** Contact's last name */
    lastName?: InputMaybe<Scalars['String']['input']>;
    /** Loan status type (One of, PRE_APPROVED, NOT_PRE_APPROVED, CASH_BUYER) */
    loanStatusType?: InputMaybe<Scalars['String']['input']>;
    /** List of contact's phone numbers */
    phones?: InputMaybe<Array<PAPhoneInput>>;
    /** Price point */
    pricePoint?: InputMaybe<Scalars['Int']['input']>;
    /** Prospect type (eg. buyer, seller, agent etc) */
    prospectTypeValue?: InputMaybe<PAContactProspectTypeValue>;
    /** Contact's source */
    source?: InputMaybe<Scalars['String']['input']>;
    /** Status change reason id. Applies for all responses from the QueryResponse table in the CRM DB */
    statusChangeReasonId?: InputMaybe<Scalars['ID']['input']>;
    /** Contact status ID */
    statusId?: InputMaybe<Scalars['ID']['input']>;
    /** Timeframe ID */
    timeframeID?: InputMaybe<Scalars['ID']['input']>;
};

/** Deprecated. Use the timeframeId query filter instead */
export type PAContactListFilterTimeframe =
    /** Timeframe: Just looking */
    | 'JUSTLOOKING'
    /** Timeframe: Now */
    | 'NOW'
    /** Timeframe: 1-3 months */
    | 'ONE'
    /** Timeframe: 6+ months */
    | 'SIX'
    /** Timeframe: 3-6 months */
    | 'THREE';

export type PAContactListFiltersInput = {
    /** Contacts that have been assigned to this zuid */
    assignee?: InputMaybe<Scalars['ID']['input']>;
    /**
     * List of contact channels (a.k.a referral type). Returns only contacts that have one of these channels - (FLEX, ZO, NONE).
     * NONE represents contacts that do not belong to a named channel.
     */
    channels?: InputMaybe<Array<PAContactChannel>>;
    /** List of the contactIds to filter by (ignores other filters) */
    contactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    /** List of the contact managed tags to filter by (use shortName) */
    managedTags?: InputMaybe<Array<Scalars['ID']['input']>>;
    /** My Agent status ('confirmed', 'pending', 'endingSoon', 'expired', 'declined') */
    myAgentStatus?: InputMaybe<PAContactListFiltersMyAgentStatus>;
    /** Contacts that owned by this zuid */
    owner?: InputMaybe<Scalars['ID']['input']>;
    /** The search string to query by */
    search?: InputMaybe<Scalars['String']['input']>;
    /** List of the contact status ids to filter by */
    statuses?: InputMaybe<Array<Scalars['ID']['input']>>;
    /** The timeframe id for when Beth is ready to buy */
    timeframeId?: InputMaybe<Scalars['ID']['input']>;
    /**
     * List of lead type codes. Returns only contacts that have these multi-selectable values
     * (buyer, seller, buyerseller, agent, renter, investor, recruit, personalcontact, lender, other)
     */
    typeCodes?: InputMaybe<Array<PAContactProspectTypeValue>>;
    /** returns only contacts with updates required */
    updateRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PAContactListFiltersMyAgentStatus =
    | 'ACTIVE'
    | 'CONFIRMED'
    | 'DECLINED'
    | 'ENDINGSOON'
    | 'EXPIRED'
    | 'PENDING';

/** Field to sort by at the CRM */
export type PAContactListSortInput = 'CREATION_DATE' | 'FIRST_NAME';

export type PAContactLoanStatus = {
    /**
     * **Definition:** Loan status display name
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Loan status type
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    type?: Maybe<Scalars['String']['output']>;
};

/**
 * **Definition:** Contact Managed Tags
 *
 * **Team Slack:** #theclosers
 */
export type PAContactManagedTag = {
    /**
     * **Definition:** The long name of the tag, used for UI display
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    longName?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Short name of the tag, used as a unique key
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    shortName: Scalars['ID']['output'];
};

/**
 * **Definition:** Contact Managed Tag Update
 *
 * **Team Slack:** #theclosers
 */
export type PAContactManagedTagInput = {
    /**
     * **Definition:** Short name of the tag, used as a unique key
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    shortName: Scalars['ID']['input'];
    /**
     * **Definition:** Value of the tag: true adds the tag and false removes it
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    value: Scalars['Boolean']['input'];
};

export type PAContactNoteCreationPayload = {
    /**
     * **Definition:** The name of the user that last changed the note (optional)
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    authorName?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** The ID of the note
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    contactNoteId: Scalars['ID']['output'];
    /**
     * **Definition:** The note text
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    note: Scalars['String']['output'];
    /**
     * **Definition:** The last platform to change the note
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    sourcePlatform: Scalars['String']['output'];
    /**
     * **Definition:** The user type that last changed the note (optional)
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    userType?: Maybe<Scalars['String']['output']>;
};

export type PAContactNurtureReasons = PAContactStatusReasons & {
    /**
     * **Definition:** Nurture reasons for a seller contact
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    buyer: QuestionReasonsSet;
    /**
     * **Definition:** Default nurture reasons for a contact
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    default: QuestionReasonsSet;
    /**
     * **Definition:** Nurture reasons for a seller contact
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    seller: QuestionReasonsSet;
    /**
     * **Definition:** Nurture reasons for a sellerBuyer contact
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    sellerBuyer: QuestionReasonsSet;
};

export type PAContactOnlineFrequencies = {
    day?: Maybe<Scalars['String']['output']>;
    hour?: Maybe<Scalars['Int']['output']>;
    saves?: Maybe<Scalars['Int']['output']>;
    views?: Maybe<Scalars['Int']['output']>;
};

export type PAContactPropertyEvent = {
    address?: Maybe<Scalars['String']['output']>;
    baths?: Maybe<Scalars['Int']['output']>;
    beds?: Maybe<Scalars['Int']['output']>;
    brand?: Maybe<Scalars['String']['output']>;
    brandPropertyID?: Maybe<Scalars['ID']['output']>;
    /** @deprecated Use brandPropertyID instead */
    brandPropertyId?: Maybe<Scalars['Int']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    eventDate?: Maybe<Scalars['DateTime']['output']>;
    eventType?: Maybe<Scalars['String']['output']>;
    imageUrl?: Maybe<Scalars['String']['output']>;
    lastSavedDate?: Maybe<Scalars['DateTime']['output']>;
    latitude?: Maybe<Scalars['Float']['output']>;
    listingOffice?: Maybe<Scalars['String']['output']>;
    longitude?: Maybe<Scalars['Float']['output']>;
    mlsId?: Maybe<Scalars['String']['output']>;
    propertyUrl?: Maybe<Scalars['String']['output']>;
    source?: Maybe<Scalars['String']['output']>;
    sqft?: Maybe<Scalars['Int']['output']>;
    stateCode?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    valuation?: Maybe<Scalars['Int']['output']>;
    viewCount?: Maybe<Scalars['Int']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type PAContactProspectType = {
    /**
     * **Definition:** Prospect type display name
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Prospect type code
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    value?: Maybe<PAContactProspectTypeValue>;
};

export type PAContactProspectTypeValue =
    | 'agent'
    | 'buyer'
    | 'buyerseller'
    | 'investor'
    | 'lender'
    | 'other'
    | 'personalcontact'
    | 'recruit'
    | 'renter'
    | 'seller'
    | 'vendor';

export type PAContactRejectedReasons = PAContactStatusReasons & {
    /**
     * **Definition:** Rejected reasons for a seller contact
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    buyer: QuestionReasonsSet;
    /**
     * **Definition:** Default rejected reasons for a contact
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    default: QuestionReasonsSet;
    /**
     * **Definition:** Rejected reasons for a seller contact
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    seller: QuestionReasonsSet;
    /**
     * **Definition:** Rejected reasons for a sellerBuyer contact
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    sellerBuyer: QuestionReasonsSet;
};

export type PAContactRelationship = {
    /**
     * **Definition:** Agent connection type
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    agentConnectionType?: Maybe<PARelationshipConnectionType>;
    /**
     * **Definition:** Relationship brand
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    brand?: Maybe<PARelationshipBrand>;
    /**
     * **Definition:** Can invite contact to MyAgent?
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    canInvite?: Maybe<PARelationshipCanInvite>;
    /**
     * **Definition:** Relationship canceled date
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    canceledAt?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** Relationship creation date
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    createdAt?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** Relationship description
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    description?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Relationship expiration date
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    expiresAt?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** Relationship header
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    header?: Maybe<Scalars['String']['output']>;
    level?: Maybe<Scalars['Int']['output']>;
    /**
     * **Definition:** Relationship status
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    status?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Relationship token
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    token?: Maybe<PARelationshipToken>;
    /**
     * **Definition:** User connection type
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    userConnectionType?: Maybe<PARelationshipConnectionType>;
};

/**
 * **Definition:** Result for paContacts query
 * **Datasource:** Contacts Resource (CRM DB)
 *
 * **Team Slack:** #theclosers
 */
export type PAContactResult = {
    /**
     * **Definition:** Contact id
     *
     * **Team Slack:** #theclosers
     * @deprecated Use id for ID type
     */
    contactId?: Maybe<Scalars['Int']['output']>;
    creationDate?: Maybe<Scalars['DateTime']['output']>;
    displayName?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Contact id
     *
     * **Team Slack:** #theclosers
     */
    id: Scalars['ID']['output'];
    isFlex?: Maybe<Scalars['Boolean']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Array of Managed Tags associated with this contact
     *
     * **Team Slack:** #theclosers
     */
    managedTags?: Maybe<Array<PAContactManagedTag>>;
    notes?: Maybe<Array<PANote>>;
    notesViewDisclaimerText?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    status?: Maybe<PAContactStatus>;
    /**
     * **Definition:** Zillow Account Zuid associated with this contact
     *
     * **Team Slack:** #theclosers
     */
    zillowAccountZuid?: Maybe<Scalars['String']['output']>;
};

export type PAContactSearchHistory = {
    /**
     * **Definition:** Number of bathrooms
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    bath?: Maybe<PAMinMax>;
    /**
     * **Definition:** Number of bedrooms
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    bed?: Maybe<PAMinMax>;
    /**
     * **Definition:** Search locations
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    locations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**
     * **Definition:** Search price
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    price?: Maybe<PAMinMax>;
    /**
     * **Definition:** property type (values: Single-Family Home, Condo Apartment, Multi-Family Home, Manufactured, Lots Land)
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    propertyTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PAContactSearchPreferences = {
    cities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    maxBathrooms?: Maybe<Scalars['Float']['output']>;
    maxBedrooms?: Maybe<Scalars['Int']['output']>;
    maxPrice?: Maybe<Scalars['Int']['output']>;
    minBathrooms?: Maybe<Scalars['Float']['output']>;
    minBedrooms?: Maybe<Scalars['Int']['output']>;
    minPrice?: Maybe<Scalars['Int']['output']>;
};

/**
 * **Definition:** Result for paContactSellerInfoByMisoIds query
 * **Datasource:** Contacts Resource (CRM DB)
 *
 * **Team Slack:** #theclosers
 */
export type PAContactSellerInfo = {
    /**
     * **Definition:** The contactId that is associated with the misoId
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    contactId: Scalars['ID']['output'];
    /**
     * **Definition:** Miso Id
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    misoId: Scalars['ID']['output'];
    /**
     * **Definition:** The owner agentZuid that owns with the misoId's contact
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    ownerAgentZuid: Scalars['ID']['output'];
};

export type PAContactSocialInsight = {
    facebookUrl?: Maybe<Scalars['String']['output']>;
    linkedInUrl?: Maybe<Scalars['String']['output']>;
    photoSource?: Maybe<PAContactSocialInsightPhotoSource>;
    photoUrl?: Maybe<Scalars['String']['output']>;
    twitterUrl?: Maybe<Scalars['String']['output']>;
};

export type PAContactSocialInsightPhotoSource = 'facebook' | 'linkedin' | 'twitter';

export type PAContactSpamReason = {
    /**
     * **Definition:** Display name for the spam reason
     * **Datasource:** N/A (constant)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Scalars['String']['output'];
    /**
     * **Definition:** Spam reason ID
     * **Datasource:** N/A (constant)
     *
     * **Team Slack:** #theclosers
     */
    spamReasonId: Scalars['ID']['output'];
};

export type PAContactStaticData = {
    /**
     * **Definition:** Action intervals
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    actionIntervals: Array<PAContactActionInterval>;
    /**
     * **Definition:** Connection statuses
     * **Datasource:** N/A (constant)
     *
     * **Team Slack:** #theclosers
     */
    connectionStatuses: Array<Scalars['String']['output']>;
    /**
     * **Definition:** Contact Type Map
     * **Datasource:** N/A (constant)
     *
     * **Team Slack:** #theclosers
     */
    contactTypes: Array<PAContactTypes>;
    /**
     * **Definition:** Spam reasons
     * **Datasource:** N/A (constant)
     *
     * **Team Slack:** #theclosers
     */
    spamReasons: Array<PAContactSpamReason>;
    /**
     * **Definition:** Status change reasons
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    statusChangeReasons: PAContactStatusChangeReasons;
    /**
     * **Definition:** Contact timeframes
     * **Datasource:** N/A (constant)
     *
     * **Team Slack:** #theclosers
     */
    timeframes: Array<PAContactTimeframe>;
    /**
     * **Definition:** Transaction statuses
     * **Datasource:** N/A (constant)
     *
     * **Team Slack:** #theclosers
     */
    transactionStatuses: Array<PAContactTransactionStatus>;
};

export type PAContactStatus = {
    id?: Maybe<Scalars['ID']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
};

export type PAContactStatusChangeReason = {
    /**
     * **Definition:** Text of the reason chosen for the status change
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Scalars['String']['output'];
    /**
     * **Definition:** Indicates whether the reason is valid given the contact's prospect type
     *
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    isValid: Scalars['Boolean']['output'];
    /**
     * **Definition:** The reason chosen to answer the question of why the status change was made
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    questionReasonId: Scalars['ID']['output'];
};

export type PAContactStatusChangeReasons = {
    /**
     * **Definition:** Reasons for Alan to select when a contact's status is changed to Nurture
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    nurtureReasons: PAContactNurtureReasons;
    /**
     * **Definition:** Reasons for Alan to select when a contact's status is changed to Rejected
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    rejectedReasons: PAContactRejectedReasons;
};

export type PAContactStatusDuration = {
    /**
     * **Definition:** Status last update date - default to creation date if there has not been a status update
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    lastUpdatedDate?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** Minimum number of days before displaying duration in ui. Defaults to null if no threshold exists.
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    statusThreshold?: Maybe<Scalars['Int']['output']>;
};

export type PAContactStatusLabel = {
    /**
     * **Definition:** The ID of the status, what is passed in as an arg
     * **Team Slack:** #theclosers
     */
    id?: Maybe<Scalars['ID']['output']>;
    /**
     * **Definition:** The label of the status
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    label?: Maybe<Scalars['String']['output']>;
};

export type PAContactStatusReasons = {
    default: QuestionReasonsSet;
};

export type PAContactStatusWithQuickAction = {
    /**
     * **Definition:** Details for the bottom section of the quick action module (Add Transaction, Add Reminder, etc)
     *
     * **Team Slack:** #theclosers
     */
    quickAction?: Maybe<PAFlexQuickAction>;
    /**
     * **Definition:** Contact status
     *
     * **Team Slack:** #theclosers
     */
    status?: Maybe<PAContactStatus>;
};

export type PAContactTimeframe = {
    /**
     * **Definition:** Display name for timeframe
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Scalars['String']['output'];
    /**
     * **Definition:** Recommended action interval for a timeframe
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    recommendedActionInterval: PAContactActionInterval;
    /**
     * **Definition:** Timeframe ID
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    timeframeId: Scalars['ID']['output'];
};

export type PAContactTransactionStatus = {
    /**
     * **Definition:** Display name for the transaction status
     * **Datasource:** N/A (constant)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Scalars['String']['output'];
    /**
     * **Definition:** Transaction status ID
     * **Datasource:** N/A (constant)
     *
     * **Team Slack:** #theclosers
     */
    transactionStatusId: Scalars['ID']['output'];
};

export type PAContactTypes = {
    /**
     * **Definition:** Display name for the Contact Type
     * **Datasource:** N/A (constant)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Scalars['String']['output'];
    /**
     * **Definition:** Contact Type
     * **Datasource:** N/A (constant)
     *
     * **Team Slack:** #theclosers
     */
    type: Scalars['String']['output'];
};

export type PAContactZHLReferral = {
    bodyText?: Maybe<Scalars['String']['output']>;
    learnMoreBodyText?: Maybe<Scalars['String']['output']>;
    learnMoreTitle?: Maybe<Scalars['String']['output']>;
    updateDate?: Maybe<Scalars['DateTime']['output']>;
    zhlReferralState?: Maybe<PAContactZhlReferralState>;
};

export type PAContactZhlReferralState = 'closedStatus' | 'declined' | 'pending' | 'sent';

export type PAContactZillow360 = {
    bodyText?: Maybe<Scalars['String']['output']>;
    learnMoreBodyText?: Maybe<Scalars['String']['output']>;
    learnMoreTitle?: Maybe<Scalars['String']['output']>;
    updateDate?: Maybe<Scalars['DateTime']['output']>;
    zhlReferralState?: Maybe<PAContactZhlReferralState>;
};

export type PACreateContactNoteInput = {
    agentZuid: Scalars['Int']['input'];
    authorName?: InputMaybe<Scalars['String']['input']>;
    contactId: Scalars['Int']['input'];
    note: Scalars['String']['input'];
    sourcePlatform?: InputMaybe<Scalars['String']['input']>;
    userType?: InputMaybe<Scalars['String']['input']>;
};

/**
 * **Definition:** PA Experience enum
 *
 * **Team Slack:** #theclosers
 */
export type PACrmViewExperience = 'APPOINTMENTS_TAB';

export type PAFlexAgentZipCampaign = PAAgentZipCampaign & {
    regionId?: Maybe<Scalars['Int']['output']>;
    zipcode?: Maybe<Scalars['String']['output']>;
};

export type PAFlexContact = {
    contactId: Scalars['ID']['output'];
    /**
     * **Definition:** Contact email
     *
     * **Team Slack:** #theclosers
     */
    email?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Contact image URL
     *
     * **Team Slack:** #theclosers
     */
    imageUrl?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Contact name
     *
     * **Team Slack:** #theclosers
     */
    name?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** A flag the marks the contact as someone who needs attention
     *
     * **Team Slack:** #theclosers
     */
    needsAttention?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Most recently added note about the contact. This will be null if a note has not yet been added.
     *
     * Notes: lastAction, platformLastUpdatedOn will be null and isMutatable will be false as lastNote API doesn't return these fields.
     *
     * **Team Slack:** #theclosers
     */
    note?: Maybe<PANote>;
    /**
     * **Definition:** Contact phone
     *
     * **Team Slack:** #theclosers
     */
    phone?: Maybe<PAPhone>;
    /**
     * **Definition:** The prompt or question blurb based on the status
     *
     * eg. Have you scheduled an appointment
     *
     * **Team Slack:** #theclosers
     */
    prompt?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Prospect type
     *
     * **Team Slack:** #theclosers
     */
    prospectType?: Maybe<PAContactProspectType>;
    /**
     * **Definition:** Status list for the contact
     *
     * **Team Slack:** #theclosers
     */
    statusList?: Maybe<Array<PAContactStatus>>;
    /**
     * **Definition:** Contact status with quick action
     *
     * **Team Slack:** #theclosers
     */
    statusWithAction?: Maybe<PAContactStatusWithQuickAction>;
    /**
     * **Definition:** Timeframe Id
     *
     * **Team Slack:** #theclosers
     */
    timeframeId?: Maybe<Scalars['ID']['output']>;
};

export type PAFlexPipelineItem = {
    /**
     * **Definition:** Contact Status
     *
     * **Team Slack:** #theclosers
     */
    contactStatus?: Maybe<PAContactStatus>;
    /**
     * **Definition:** Icon for mobile UI
     *
     * **Team Slack:** #theclosers
     */
    iconUrl?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Total number of contacts in this categrory
     *
     * **Team Slack:** #theclosers
     */
    total?: Maybe<Scalars['Int']['output']>;
};

export type PAFlexPipelineItemiconUrlArgs = {
    device?: InputMaybe<PAMobileDevicePlatform>;
};

export type PAFlexProgramStatus = {
    /**
     * **Definition:** Flex program status reason
     *
     * **Team Slack:** #theclosers
     */
    reason?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Flex program status
     *
     * **Team Slack:** #theclosers
     */
    status?: Maybe<PAFlexProgramStatusType>;
    /**
     * **Definition:** Flex program status subtitle
     *
     * **Team Slack:** #theclosers
     */
    subtitle?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Flex program status title
     *
     * **Team Slack:** #theclosers
     */
    title?: Maybe<Scalars['String']['output']>;
};

export type PAFlexProgramStatusType =
    | 'ACTIVENOLEADS'
    | 'BLOCKED'
    | 'ONBOARDING'
    | 'PAUSED'
    | 'PROBATION'
    | 'SUSPENDED'
    | 'WAITLISTED';

export type PAFlexQuickAction = {
    /**
     * **Definition:** The deep link URL for the quick action
     *
     * eg:
     * https://www.premieragent.com/status/loop
     * https://www.premieragent.com/status/transaction/edit
     * https://www.premieragent.com/status/transaction/add
     * https://www.premieragent.com/status/reminder
     *
     * **Team Slack:** #theclosers
     */
    deeplink?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** The subtitle of the quick action
     *
     * eg: 123 Main St, Some City...
     *
     * **Team Slack:** #theclosers
     */
    subtitle?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** The title of the quick action
     *
     * eg: (Add Transaction, Add Reminder...)
     *
     * **Team Slack:** #theclosers
     */
    title?: Maybe<Scalars['String']['output']>;
};

export type PAHomeRecAddress = {
    city: Scalars['String']['output'];
    stateCode: Scalars['String']['output'];
    street: Scalars['String']['output'];
    zip: Scalars['String']['output'];
};

export type PAHomeRecImage = {
    imageUrl?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

export type PALoop = {
    id?: Maybe<Scalars['Int']['output']>;
    loopUrl?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

export type PAMBPAgentZipCampaign = PAAgentZipCampaign & {
    regionId?: Maybe<Scalars['Int']['output']>;
    zipcode?: Maybe<Scalars['String']['output']>;
};

export type PAMinMax = {
    max?: Maybe<Scalars['String']['output']>;
    min?: Maybe<Scalars['String']['output']>;
};

export type PAMobileDevicePlatform = 'ANDROID' | 'IOS';

export type PANote = {
    /**
     * **Definition:** Note creation date
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    creationDate: Scalars['String']['output'];
    /**
     * **Definition:** Is note mutable
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    isMutable?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Note last action (values: created, deleted, edited)
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    lastAction?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Note author name
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    lastActionAuthorName?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Note
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    note: Scalars['String']['output'];
    noteId: Scalars['ID']['output'];
    /**
     * **Definition:** The platform that last updated the note
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    platformLastUpdatedOn?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Note update date
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    updateDate: Scalars['String']['output'];
};

export type PANoteSortOrder =
    | 'CREATION_DATE_ASC'
    | 'CREATION_DATE_DESC'
    | 'UPDATE_DATE_ASC'
    | 'UPDATE_DATE_DESC';

export type PAOTPForm = {
    billingPhoneNumber?: Maybe<Scalars['String']['output']>;
    documentId?: Maybe<Scalars['String']['output']>;
    downloadLink?: Maybe<Scalars['String']['output']>;
    previewLink?: Maybe<Scalars['String']['output']>;
};

export type PAOTPFormInput = {
    billingPhoneNumber?: InputMaybe<Scalars['String']['input']>;
    documentId?: InputMaybe<Scalars['String']['input']>;
    downloadLink?: InputMaybe<Scalars['String']['input']>;
    previewLink?: InputMaybe<Scalars['String']['input']>;
};

export type PAPaginatedPropertyEvents = {
    /** Cursor for next page */
    cursor?: Maybe<Scalars['String']['output']>;
    /** Page size */
    pageSize?: Maybe<Scalars['Int']['output']>;
    /** Property events */
    propertyEvents?: Maybe<Array<PAContactPropertyEvent>>;
    /** Total events count */
    total?: Maybe<Scalars['Int']['output']>;
};

export type PAPhone = {
    number?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Phone id
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    phoneId?: Maybe<Scalars['ID']['output']>;
    /**
     * **Definition:** Phone number string
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     * @deprecated Use PAPhone.number as value can be null
     */
    phoneNumber: Scalars['String']['output'];
    /**
     * **Definition:** Phone type (values: Mobile, Home, Work)
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    type: Scalars['String']['output'];
};

/** Contact's phone input */
export type PAPhoneInput = {
    /** Phone number */
    number: Scalars['String']['input'];
    /** Phone ID */
    phoneID?: InputMaybe<Scalars['ID']['input']>;
    /** Phone type (eg. Mobile, Home, Work) */
    type: Scalars['String']['input'];
};

export type PAPreferenceCounts = {
    /** Label for the preference bucket */
    preference?: Maybe<Scalars['String']['output']>;
    saved?: Maybe<Scalars['Int']['output']>;
    viewed?: Maybe<Scalars['Int']['output']>;
};

export type PAPropertyEventType = 'OPENED_EMAIL' | 'SAVED_HOME' | 'VIEWED_HOME';

export type PAPropertyEventsFilter = {
    eventTypes?: InputMaybe<Array<PAPropertyEventType>>;
    limit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * **Definition:** CRM Property Snapshot
 *
 * **Team Slack:** #theclosers
 */
export type PAPropertySnapshot = {
    address?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    imageUrl?: Maybe<Scalars['String']['output']>;
    listingOffice?: Maybe<Scalars['String']['output']>;
    mlsId?: Maybe<Scalars['String']['output']>;
    numBaths?: Maybe<Scalars['String']['output']>;
    numBeds?: Maybe<Scalars['Int']['output']>;
    pid?: Maybe<Scalars['ID']['output']>;
    /** @deprecated GQL doesn't support non 32-bits integer. Use pid instead */
    propertyId?: Maybe<Scalars['Int']['output']>;
    propertySource?: Maybe<Scalars['String']['output']>;
    propertyUrl?: Maybe<Scalars['String']['output']>;
    stateCode?: Maybe<Scalars['String']['output']>;
    valuation?: Maybe<Scalars['Int']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type PARelationshipBrand =
    | 'Hotpads'
    | 'OutboundEmail'
    | 'RealEstate'
    | 'StreetEasy'
    | 'Trulia'
    | 'Zillow';

export type PARelationshipCanInvite =
    | 'AGENT_HAS_NO_REGIONS'
    | 'AGENT_NOT_WHITELISTED'
    | 'EXPLICIT_RELATIONSHIP_ALREADY_EXISTS'
    | 'INVITE_ALLOWED'
    | 'NOT_ALLOWED_LEAD_TYPE'
    | 'NOT_ALLOWED_SOURCE'
    | 'PENDING_INVITATION_EXISTS'
    | 'RATE_LIMIT_EXCEEDED';

export type PARelationshipConnectionType =
    | 'CallBroadcastAccept'
    | 'ConnectedLead'
    | 'Email'
    | 'InvitationEmail'
    | 'PACLiveTransfer'
    | 'SMS';

export type PARelationshipToken = {
    createdAt?: Maybe<Scalars['DateTime']['output']>;
    redeemedAt?: Maybe<Scalars['DateTime']['output']>;
    rejectedReason?: Maybe<PARelationshipTokenRejectedReason>;
    status?: Maybe<PARelationshipTokenStatus>;
};

export type PARelationshipTokenRejectedReason =
    | 'NONE_OF_THE_ABOVE'
    | 'NOT_SHOPPING'
    | 'NOT_WORKING_WITH_AGENT'
    | 'NO_REASON_GIVEN'
    | 'UNKNOWN_AGENT';

export type PARelationshipTokenStatus = 'ACCEPTED' | 'EXPIRED' | 'PENDING' | 'REJECTED';

export type PARoutingRules = {
    selfPause?: Maybe<PASelfPause>;
};

export type PASelfPause = {
    /** **Definition:** Is the agent self paused */
    isSelfPaused?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Agent pause message
     *
     * example: Agent was paused at {date}
     */
    message?: Maybe<Scalars['String']['output']>;
    /** **Definition:** The date the agent self paused */
    pausedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PATask = {
    agentZuid: Scalars['ID']['output'];
    completeDate?: Maybe<Scalars['DateTime']['output']>;
    contactId: Scalars['ID']['output'];
    createDate?: Maybe<Scalars['DateTime']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    dueDate?: Maybe<Scalars['DateTime']['output']>;
    isCompleted?: Maybe<Scalars['Boolean']['output']>;
    isHidden?: Maybe<Scalars['Boolean']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    notifyBeginDate?: Maybe<Scalars['DateTime']['output']>;
    notifyCompleteDate?: Maybe<Scalars['DateTime']['output']>;
    notifyStatus?: Maybe<NotifyStatus>;
    ownerAgentZuid?: Maybe<Scalars['Int']['output']>;
    recurringReminderTimeInterval?: Maybe<Scalars['Int']['output']>;
    reminderTimeInterval?: Maybe<Scalars['String']['output']>;
    taskTypeName?: Maybe<Scalars['String']['output']>;
    taskUUID: Scalars['ID']['output'];
    transactionId?: Maybe<Scalars['Int']['output']>;
    updateBy?: Maybe<Scalars['String']['output']>;
    updateDate?: Maybe<Scalars['DateTime']['output']>;
};

export type PATaskInput = {
    agentZuid: Scalars['ID']['input'];
    contactId: Scalars['ID']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
    dueDate?: InputMaybe<Scalars['DateTime']['input']>;
    isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    ownerAgentZuid?: InputMaybe<Scalars['Int']['input']>;
    recurringReminderTimeInterval?: InputMaybe<Scalars['Int']['input']>;
    reminderTimeInterval?: InputMaybe<Scalars['String']['input']>;
    taskTypeName?: InputMaybe<Scalars['String']['input']>;
    taskUuid: Scalars['ID']['input'];
    transactionId?: InputMaybe<Scalars['Int']['input']>;
    updateBy?: InputMaybe<Scalars['String']['input']>;
};

export type PATeam = {
    lead: PAAgent;
    memberships?: Maybe<Array<PATeamMembership>>;
    name?: Maybe<Scalars['String']['output']>;
    teamId: Scalars['String']['output'];
};

export type PATeammembershipsArgs = {
    publicOnly: Scalars['Boolean']['input'];
    sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type PATeamMembership = {
    canExportContacts: Scalars['Boolean']['output'];
    canReassignLeads: Scalars['Boolean']['output'];
    member: PAAgent;
    role: PATeamMembershipRole;
};

export type PATeamMembershipRole = 'PRIVATE' | 'PUBLIC';

export type PATransaction = {
    address?: Maybe<PATransactionAddress>;
    closeDate?: Maybe<Scalars['String']['output']>;
    closingCompany?: Maybe<Scalars['String']['output']>;
    commissionAddition?: Maybe<Scalars['Float']['output']>;
    commissionAmount?: Maybe<Scalars['Float']['output']>;
    commissionPercentage?: Maybe<Scalars['Float']['output']>;
    commissionReduction?: Maybe<Scalars['Float']['output']>;
    contact: PAContact;
    creationDate?: Maybe<Scalars['String']['output']>;
    legalName?: Maybe<Scalars['String']['output']>;
    otpDocument?: Maybe<PAOTPForm>;
    price?: Maybe<Scalars['Float']['output']>;
    representationType?: Maybe<Scalars['String']['output']>;
    splitPercentage?: Maybe<Scalars['Float']['output']>;
    status?: Maybe<PATransactionStatus>;
    transactionId: Scalars['Int']['output'];
    updateDate?: Maybe<Scalars['String']['output']>;
    zgFeeAmount?: Maybe<Scalars['Float']['output']>;
    zgFeePercentage?: Maybe<Scalars['Float']['output']>;
    zillowPropertyId?: Maybe<Scalars['String']['output']>;
    ztid?: Maybe<Scalars['String']['output']>;
};

export type PATransactionAddress = {
    city?: Maybe<Scalars['String']['output']>;
    stateCode?: Maybe<Scalars['String']['output']>;
    street?: Maybe<Scalars['String']['output']>;
    street2?: Maybe<Scalars['String']['output']>;
    zipCode?: Maybe<Scalars['String']['output']>;
};

export type PATransactionAddressInput = {
    city?: InputMaybe<Scalars['String']['input']>;
    stateCode?: InputMaybe<Scalars['String']['input']>;
    street?: InputMaybe<Scalars['String']['input']>;
    street2?: InputMaybe<Scalars['String']['input']>;
    zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type PATransactionInput = {
    address: PATransactionAddressInput;
    closeDate?: InputMaybe<Scalars['String']['input']>;
    closingCompany?: InputMaybe<Scalars['String']['input']>;
    commissionAddition?: InputMaybe<Scalars['Float']['input']>;
    commissionAmount?: InputMaybe<Scalars['Float']['input']>;
    commissionPercentage?: InputMaybe<Scalars['Float']['input']>;
    commissionReduction?: InputMaybe<Scalars['Float']['input']>;
    contactId: Scalars['Int']['input'];
    creationDate?: InputMaybe<Scalars['String']['input']>;
    legalName?: InputMaybe<Scalars['String']['input']>;
    otpDocument?: InputMaybe<PAOTPFormInput>;
    price?: InputMaybe<Scalars['Float']['input']>;
    representationType?: InputMaybe<Scalars['String']['input']>;
    splitPercentage?: InputMaybe<Scalars['Float']['input']>;
    statusCode: Scalars['Int']['input'];
    updateDate?: InputMaybe<Scalars['String']['input']>;
    zgFeeAmount?: InputMaybe<Scalars['Float']['input']>;
    zgFeePercentage?: InputMaybe<Scalars['Float']['input']>;
    zillowPropertyId?: InputMaybe<Scalars['String']['input']>;
    zillowUserId: Scalars['Int']['input'];
    ztid?: InputMaybe<Scalars['String']['input']>;
};

export type PATransactionPayload = {
    transaction?: Maybe<PATransaction>;
};

export type PATransactionStatus = {
    code: Scalars['Int']['output'];
    label: Scalars['String']['output'];
};

/** Pay Per Click URL link and test. If mobile = true, then the link can also be shown to mobile users */
export type PPCLink = {
    mobile?: Maybe<Scalars['Boolean']['output']>;
    path?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
};

export type PSLAddress = {
    /**
     * The city (e.g. Seattle in
     * "1301 2nd Ave, Seattle WA, 98101")
     */
    city?: Maybe<Scalars['String']['output']>;
    /** The name of the new construction community to which the property belongs */
    communityName?: Maybe<Scalars['String']['output']>;
    /**
     * The prefix direction (e.g. W in
     * "305 W 100 S, Salt Lake City, UT 84119")
     */
    directionPrefix?: Maybe<Scalars['String']['output']>;
    /**
     * The suffix direction (e.g. S in
     * "305 W 100 S, Salt Lake City, UT 84119")
     */
    directionSuffix?: Maybe<Scalars['String']['output']>;
    /** The group name used to group map dots for properties in the same community. */
    groupName?: Maybe<Scalars['String']['output']>;
    /**
     * The house number part of the address (e.g. 1301
     * in "1301 2nd Ave, Seattle WA, 98101")
     */
    houseNumber?: Maybe<Scalars['String']['output']>;
    /**
     * For house numbers that include a fraction (e.g.
     * 1/2 in "1100 1/2 W 6th Ave #91")
     */
    houseNumberFraction?: Maybe<Scalars['String']['output']>;
    /**
     * Is this address undisclosed (e.g. we don't
     * know or are not allowed to display the
     * actual address). If this is true,
     * then parts of the address are likely missing.
     */
    isUndisclosedAddress?: Maybe<Scalars['Boolean']['output']>;
    /**
     * The five digit postal code (e.g. 98101 in
     * "1301 2nd Ave, Seattle WA, 98101")
     */
    postalCode?: Maybe<Scalars['String']['output']>;
    /**
     * The state (e.g. WA in
     * "1301 2nd Ave, Seattle WA, 98101")
     */
    state?: Maybe<Scalars['String']['output']>;
    /**
     * The street name (e.g. 2nd in
     * "1301 2nd Ave, Seattle WA, 98101")
     */
    streetName?: Maybe<Scalars['String']['output']>;
    /**
     * The street suffix (e.g. Ave in
     * "1301 2nd Ave, Seattle WA, 98101")
     */
    streetSuffix?: Maybe<Scalars['String']['output']>;
    /** The name of the subdivision to which the property belongs */
    subdivisionName?: Maybe<Scalars['String']['output']>;
    /**
     * The unit number (e.g C in
     * "5800 Springfield Gardens Cir, Apt C, Springfield VA 22162")
     */
    unitNumber?: Maybe<Scalars['String']['output']>;
    /**
     * The unit prefix (e.g. Apt in
     * "5800 Springfield Gardens Cir, Apt C, Springfield VA 22162")
     */
    unitPrefix?: Maybe<Scalars['String']['output']>;
    /**
     * The 4 digit portion of the full 5 + 4 digit zip code (e.g.
     * 22162-1058, where 22162 is {@link #postalCode}, and 1058 is {@link #zipPlusFour}
     */
    zipPlusFour?: Maybe<Scalars['String']['output']>;
};

export type PSLBasementStatusType = 'FINISHED' | 'FULL' | 'NONE' | 'PARTIAL' | 'UNFINISHED';

export type PSLBrokerage = {
    /** The legal name of the brokerage */
    name?: Maybe<Scalars['String']['output']>;
    /** The extension of the brokerage's phone number */
    officePhoneExtension?: Maybe<Scalars['String']['output']>;
    /**
     * The brokerage's office phone number. North American 10 digit phone number
     * should be in the format of ###-###-#### (separated by hyphens).
     * Other conventions should use the common local standard.
     * International numbers should be preceded by a plus symbol.
     */
    officePhoneNumber?: Maybe<Scalars['String']['output']>;
};

export type PSLCountryCode = 'CA' | 'US';

export type PSLEnrichment = {
    /**
     * Estimates for property data
     * This value will be nulled out if HidePriceEstimate is applicable
     */
    estimate?: Maybe<Estimate>;
    /**
     * Home insight tags (i.e. phrases) for a property. Different insights may be generated
     * for separate property records.
     */
    homeInsights?: Maybe<Array<HomeInsights>>;
    /**
     * Information about the last sale of this property.
     * This field will be null when HidePriceHistory is applicable and the
     * property is on market, or when HidePriceHistoryOnSold is applicable and
     * the property has a rawHomeStatus (in the case of /lookup/) or
     * filteredHomeStatus (in the case of /search/) equal to recentlySold.
     */
    lastSale?: Maybe<LastSale>;
    /** Information pertaining to Rich Media Experience vr models, floorplans, etc. */
    richMedia?: Maybe<Array<PSLRichMedia>>;
};

export type PSLExcludeType =
    | 'ACCEPTING_BACKUP_OFFERS'
    | 'ACCEPTING_BACKUP_OFFERS_UNLESS_PENDING_CONTINGENT_UNDER_CONTRACT'
    | 'CONTINGENT'
    | 'NO_HOA_DATA'
    | 'PENDING'
    | 'PENDING_CONTINGENT_UNDER_CONTRACT_UNLESS_ACCEPTING_BACKUP_OFFERS'
    | 'SENIOR_COMMUNITY'
    | 'UNDER_CONTRACT'
    | 'UNMAPPABLE';

export type PSLFee = {
    fee?: Maybe<Scalars['Float']['output']>;
    feeFrequency?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    type?: Maybe<PSLFeeType>;
};

export type PSLFeeType =
    | 'ADMINISTRATIVE'
    | 'APPLICATION'
    | 'CONDO_AND_COOP'
    | 'DEPOSIT'
    | 'HOA'
    | 'MEMBERSHIP'
    | 'PARKING'
    | 'PET'
    | 'PET_DEPOSIT'
    | 'UNKNOWN';

export type PSLFloorPlan = {
    /** GUID of the floor plan */
    floorMapGuid?: Maybe<Scalars['ID']['output']>;
    /** URL to the static floor plan hero image */
    heroImageUrl?: Maybe<Scalars['String']['output']>;
    /** Viewer URL of the floor plan */
    viewerUrl?: Maybe<Scalars['String']['output']>;
};

export type PSLGeoRegion = {
    /** The school zones to which this property belongs */
    assignedSchoolIds?: Maybe<Array<Scalars['ID']['output']>>;
    /** The id of the borough in which the property is located */
    boroughId?: Maybe<Scalars['ID']['output']>;
    /** The id of the city in which the property is located */
    cityId?: Maybe<Scalars['ID']['output']>;
    /** The id of the county in which the property is located */
    countyId?: Maybe<Scalars['ID']['output']>;
    /**
     * A value of true indicates that we have low confidence in the accuracy
     * of the latLon information that we have about the property
     */
    isBadGeocode?: Maybe<Scalars['Boolean']['output']>;
    /**
     * The latitude and longitude of the property
     * This field will be null when HideMapPinWithFlag is applicable, for search result only
     */
    latLon?: Maybe<LatLon>;
    /** The id of the neighborhood in which the property is located */
    neighborhoodId?: Maybe<Scalars['ID']['output']>;
    /** The id of the state in which the property is located */
    stateId?: Maybe<Scalars['ID']['output']>;
    /** The id of the zpicode in which the property is located */
    zipcodeId?: Maybe<Scalars['ID']['output']>;
};

export type PSLHomeStatus = {
    /** The contingency of the current status */
    contingency?: Maybe<ContingencyType>;
    /**
     * We may treat some contingent properties as non contingent for display purposes.
     * 'displayContingency' may be different from 'contingency' for this reason
     */
    displayContingency?: Maybe<ContingencyType>;
    /**
     * The major display status. Multiple home status types may map to a single display status.
     * Ex. FSBO and FSBA should be displayed as ForSale
     */
    displayStatus?: Maybe<DisplayStatus>;
    /**
     * The home status with dynamic trumping logic based on the search filters.
     * Homes in multiple states (e.g. for sale and for rent) will be assigned
     * a single home status based on this trumping logic. Filter criteria are
     * used to decide the "filtered" home status.
     */
    filteredHomeStatus?: Maybe<HomeStatusType>;
    /** Is this property a new construction property */
    isNewConstruction?: Maybe<Scalars['Boolean']['output']>;
    /** Is this property preforeclosure auction */
    isPreforeclosureAuction?: Maybe<Scalars['Boolean']['output']>;
    /**
     * If this listing is listed as a foreclosure, the stage in the foreclosure process
     * that it is in. Otherwise, null.
     */
    listingForeclosureStage?: Maybe<ForeclosureStageType>;
    /**
     * Information about how the property is being classified
     * (e.g. forsale/forrent, active/pending etc.)
     */
    marketing?: Maybe<PSLMarketing>;
    /**
     * The home status with static trumping logic. Homes in multiple states
     * (e.g. for sale and for rent) will be assigned a single home status
     * based on this trumping logic.
     */
    rawHomeStatus?: Maybe<HomeStatusType>;
};

export type PSLHomeType =
    | 'APARTMENT'
    | 'CONDO'
    | 'LAND'
    | 'MANUFACTURED'
    | 'MULTI_FAMILY'
    | 'SINGLE_FAMILY'
    | 'TOWNHOME'
    | 'UNKNOWN';

export type PSLMapCardAttribution = {
    /**
     * The brokerage name that list the property.  The value will be populated only if the property has the
     * "DisplayMLSListOfficeOnMapMarkerCard" rule requiring it be displayed on map marker card.
     */
    brokerNameIfRequired?: Maybe<Scalars['String']['output']>;
    /**
     * The MLS ID for the property used to uniquely identify it.  The value will be populated only if the property has
     * the "DisplayMLSListingIdOnMapMarkerCard" rule requiring it be displayed on map marker card.
     */
    mlsIdIfRequired?: Maybe<Scalars['ID']['output']>;
    /**
     * Map of treatments (as keys) to PhotoLink (as values) for the logo of the provider of the property. The value will
     * only be populated if the property has the "DisplayMLSLogoOnMapMarkerCard" rule requiring it be displayed on map marker card.
     */
    providerLogoIfRequired?: Maybe<Array<PhotoAlbum>>;
};

export type PSLMapCardAttributionproviderLogoIfRequiredArgs = {
    photoTreatments: Array<PhotoTreatment>;
};

export type PSLMarketing = {
    /** The representation for the listing (e.g. owner, agent etc.) */
    representation?: Maybe<MarketingRepresentationType>;
    /** Simplified status of the listing, excluding Contingent */
    statusSimplified?: Maybe<MarketingStatusType>;
    /** SubType of the listing. Null if listing isn't a subtype like Room */
    subType?: Maybe<MarketingSubType>;
    /** The marketing type of the property (e.g. sale, rent etc.) */
    type?: Maybe<MarketingType>;
};

export type PSLOpenHouse = {
    /**
     * The ending date and time of the open house without a time-zone in ISO-8601.
     * (The timezone is the local time of the property location.)
     * Example: 2019-07-03T20:47:55
     */
    endTime?: Maybe<Scalars['LocalDateTime']['output']>;
    /** The type of open house, In Person or Virtual */
    openHouseMethod?: Maybe<Scalars['String']['output']>;
    /**
     * The starting date and time of the open house without a time-zone in ISO-8601.
     * (The timezone is the local time of the property location.)
     * Example: 2019-07-03T20:47:55
     */
    startTime?: Maybe<Scalars['LocalDateTime']['output']>;
    /** A web link to a live virtual open house */
    virtualOpenHouseURL?: Maybe<Scalars['String']['output']>;
};

export type PSLPetPolicyType = 'ALL' | 'CAT' | 'DOG' | 'FISH' | 'OTHER' | 'REPTILE' | 'UNKNOWN';

export type PSLProviderInfo = {
    /** The disclaimer provided by the provider */
    disclaimer?: Maybe<Scalars['String']['output']>;
    /** The entityOUID as returned by the SSID info API */
    ouid?: Maybe<Scalars['ID']['output']>;
    /** The PhotoLink containing image url of the provider logo */
    providerLogo?: Maybe<PhotoLink>;
    /** The ssid of the provider */
    ssid: Scalars['ID']['output'];
};

export type PSLProviderInfoproviderLogoArgs = {
    photoTreatment: PhotoTreatment;
};

export type PSLRecommendation = {
    /**
     * A tag with relevant insights into the property
     * (e.g. why was it recommended)
     */
    homeInsight?: Maybe<Scalars['String']['output']>;
    /** Is this property recommended for the current user */
    isHomeRec?: Maybe<Scalars['Boolean']['output']>;
    /** Metadata about the recommendation, used for analytics */
    trackingData?: Maybe<Array<TrackingData>>;
};

export type PSLRegion = {
    /**
     * The centroid of the region being specified.
     * This should only be included for regions of type
     * {@link RegionType#centroid}
     */
    centroid?: InputMaybe<LatLonInput>;
    /**
     * ClipPolygon simple format string, maximum point is 600
     * i.e. 47.621323,-122.250538|47.638675,-122.250538|47.653247,-122.245731
     * You can either pass clipPolygon or polygonWkt, but not both
     */
    clipPolygon?: InputMaybe<Scalars['String']['input']>;
    /**
     * A simplified WKT polygon representing the region.
     * This should only be included for regions of type customPolygon
     * You can either pass clipPolygon or polygonWkt, but not both
     */
    polygonWkt?: InputMaybe<Scalars['String']['input']>;
    /**
     * The region id. This should only be included for
     * regions of type standardId
     */
    regionId?: InputMaybe<RegionId>;
    /** The type of region being specified */
    regionType: RegionType;
};

export type PSLRental = {
    /** The types of pets allowed in this property */
    allowedPets?: Maybe<Array<Scalars['String']['output']>>;
    /** Are zillow rental applications accepted */
    areApplicationsAccepted?: Maybe<Scalars['Boolean']['output']>;
    /** The rental deposits and Fees */
    depositsAndFees?: Maybe<Scalars['Float']['output']>;
    /** The name of the floor plan */
    floorPlanName?: Maybe<Scalars['String']['output']>;
    /** The ways in which private property owners and managers can connect to those most in need of housing */
    housingConnector?: Maybe<HousingConnectorType>;
    /** True if the rental property is an apartment complex */
    isApartmentComplex?: Maybe<Scalars['Boolean']['output']>;
    /** True if the property has specific income caps to determine eligibility. */
    isIncomeRestricted?: Maybe<Scalars['Boolean']['output']>;
    /** Search boolean for rental listings with smoking allowed. */
    isSmokingAllowed?: Maybe<Scalars['Boolean']['output']>;
    /** Lease description for the rental agreement. This includes information other than lease duration. */
    leaseDescription?: Maybe<Scalars['String']['output']>;
    /** The rental lease term */
    leaseTerm?: Maybe<Scalars['String']['output']>;
    /** Information used to inform how a rental will be presented to customers. */
    marketingTreatments?: Maybe<Array<MarketingTreatment>>;
    /** The identifier that is included in the rental feed */
    providerModelId?: Maybe<Scalars['ID']['output']>;
    /**
     * Used to control how long a rental will remain higher in search
     * until it begins to fall further down the results.
     * It is a date time in UTC in ISO-8601.
     * Example: 2019-07-03T20:47:55Z
     */
    rentalRankingTime?: Maybe<Scalars['DateTime']['output']>;
    /** Room for rent details. */
    roomForRent?: Maybe<PSLRoomForRent>;
    /** Information used to indicate type of special housing. Student, Senior, Military are some possible values. */
    specialHousingTypes?: Maybe<Array<SpecialHousingType>>;
    /** Rental specific status information. */
    subStatus?: Maybe<Array<RentalSubStatus>>;
};

export type PSLRichMedia = {
    /**
     * Date time since Linux epoch record was last updated
     * It is in UTC in ISO-8601.
     * Example: 2019-07-03T20:47:55Z
     */
    lastUpdateTime?: Maybe<Scalars['DateTime']['output']>;
    /** Optional list of owner emails that own this media */
    listingEmails?: Maybe<Array<Scalars['String']['output']>>;
    /** Multimap of treatments (as keys) to Links (as values) for all Listing Media Service (LMS) photos */
    listingMediaServicePhotos?: Maybe<Array<PhotoAlbum>>;
    /** List of palsIds this record is associated with */
    palsIds?: Maybe<Array<Scalars['ID']['output']>>;
    /** List of RMX data. Currently virtual tours and floor plans */
    rmxData?: Maybe<Array<RMXData>>;
};

export type PSLRichMedialistingMediaServicePhotosArgs = {
    photoTreatments: Array<PhotoTreatment>;
};

export type PSLRoomDetails = {
    /** Search boolean for room for rent listings with private bath. */
    hasPrivateBath?: Maybe<Scalars['Boolean']['output']>;
    /** Search boolean for room being leased is Furnished. */
    roomIsFurnished?: Maybe<Scalars['Boolean']['output']>;
    /** Description on how utilities are shared among roommates. */
    utilitiesShareDescription?: Maybe<Scalars['String']['output']>;
};

export type PSLRoomForRent = {
    /** Information on who posted this listing. */
    postedBy?: Maybe<PostedByType>;
    /** Information used to inform additional room details. */
    roomDetails?: Maybe<PSLRoomDetails>;
    /** Information used to inform roommate details. */
    roommateDetails?: Maybe<PSLRoommateDetails>;
    /** Information used to inform roommate requirements. */
    roommateRequirements?: Maybe<PSLRoommateRequirements>;
};

export type PSLRoommateDetails = {
    /** Existing roommate description. */
    description?: Maybe<Scalars['String']['output']>;
    /** Existing roommates gender and count. */
    roommateGenderDetails?: Maybe<Array<PSLRoommateGenderDetails>>;
    /** Existing roommate pet details. */
    roommatePetDetails?: Maybe<Array<PSLRoommatePetDetails>>;
    /** Total number of roommates in property. String is used here to support cases like "4+" */
    totalCount?: Maybe<Scalars['String']['output']>;
};

export type PSLRoommateGenderDetails = {
    /** Gender count for gender type in property. String type is used here to support cases like "4+ */
    genderCount?: Maybe<Scalars['String']['output']>;
    /** Type of gender. */
    genderType?: Maybe<GenderType>;
};

export type PSLRoommatePetDetails = {
    /** Pet count for pet type. String type is used here to support cases like "4+" */
    petCount?: Maybe<Scalars['String']['output']>;
    /** Type of pet related to pet policy. */
    petType?: Maybe<PSLPetPolicyType>;
};

export type PSLRoommateRequirements = {
    /** Potential roommate genders. */
    genderTypes?: Maybe<Array<GenderType>>;
    /** Required minimum age for potential roommate. */
    minimumAge?: Maybe<Scalars['Int']['output']>;
};

export type PSLShowOnlyType =
    | 'ACCEPTS_RENTAL_APPLICATIONS'
    | 'AIR_CONDITIONING'
    | 'APPROVED_VIRTUAL_TOUR'
    | 'ASSIGNED_PARKING'
    | 'EV_CHARGER'
    | 'GARAGE'
    | 'HOUSING_CONNECTOR'
    | 'INCOME_RESTRICTED'
    | 'IN_UNIT_LAUNDRY'
    | 'OPEN_HOUSES'
    | 'POOL'
    | 'PRICE_REDUCTION'
    | 'SINGLE_STORY'
    | 'TOUR_IT_NOW'
    | 'WATER_FRONT'
    | 'ZILLOW_OWNED';

export type PSLTaxAssessment = {
    /** The year of the tax assessment */
    assessmentYear?: Maybe<Scalars['Int']['output']>;
    /** The annual property taxes due based on the assessment */
    taxAmount?: Maybe<Scalars['Int']['output']>;
    /** The value that the property was assessed at */
    taxAssessedValue?: Maybe<Scalars['Int']['output']>;
};

export type PSLViewType = 'CITY' | 'MOUNTAIN' | 'PARK' | 'TERRITORIAL' | 'WATER';

export type PSLVirtualTour = {
    /** Most recent revision ID */
    revisionId?: Maybe<Scalars['ID']['output']>;
    /** Viewer URL of the virtual tour */
    viewerUrl?: Maybe<Scalars['String']['output']>;
    /** GUID of the virtual tour */
    vrModelGuid?: Maybe<Scalars['ID']['output']>;
};

export type PSLZestimate = {
    /** Average of the Zestimate for the previous 30 days */
    averageOfLast30Days?: Maybe<Scalars['Int']['output']>;
    /** The dollar value of the Zestimate */
    value?: Maybe<Scalars['Int']['output']>;
    /** The higher value of the Zestimate range */
    zestimateRangeHigh?: Maybe<Scalars['Int']['output']>;
    /** The lower value of the Zestimate range */
    zestimateRangeLow?: Maybe<Scalars['Int']['output']>;
};

export type PaContactManagedTagUpdatePayload = {
    /**
     * **Definition:** The contacts whos managed tags were updated
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    contactIds: Array<Scalars['Int']['output']>;
    /**
     * **Definition:** The managed tag update that was performed
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    managedTag: ManagedTagUpdate;
};

/** PacingAgent ... */
export type PacingAgent = {
    agent_zuid?: Maybe<Scalars['Int']['output']>;
    allocation_type?: Maybe<Scalars['String']['output']>;
    lender_id?: Maybe<Scalars['Int']['output']>;
    position?: Maybe<Scalars['Int']['output']>;
    program?: Maybe<Scalars['String']['output']>;
};

export type Page = {
    id?: Maybe<Scalars['ID']['output']>;
    questions?: Maybe<Array<Maybe<Question>>>;
};

export type PageConfigAnchor = {
    googleAnalytics?: Maybe<PageConfigGoogleAnalytics>;
    href?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
};

export type PageConfigBodyElement = {
    form?: Maybe<PageConfigForm>;
    richText?: Maybe<Array<Maybe<PageConfigRichText>>>;
    text?: Maybe<Scalars['String']['output']>;
    textList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    type?: Maybe<PageConfigBodyElementType>;
};

export type PageConfigBodyElementType = 'paragraph' | 'radio';

export type PageConfigForm = {
    id?: Maybe<Scalars['ID']['output']>;
    options?: Maybe<Array<Maybe<PageConfigFormOptions>>>;
};

export type PageConfigFormOptions = {
    id?: Maybe<Scalars['ID']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

export type PageConfigGoogleAnalytics = {
    action?: Maybe<Scalars['String']['output']>;
    category?: Maybe<Scalars['String']['output']>;
    formLabel?: Maybe<Scalars['String']['output']>;
    label?: Maybe<Scalars['String']['output']>;
};

export type PageConfigRichText = {
    anchor?: Maybe<PageConfigAnchor>;
    bold?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
    unorderedList?: Maybe<Array<Maybe<TextObject>>>;
};

/**
 * PageInfo type provides metadata about the pagination of a connection.
 * It includes information about the start and end cursors of the current page,
 * and whether there are more pages available before or after the current page.
 */
export type PageInfo = {
    /**
     * The cursor corresponding to the last item in the current page.
     * This cursor can be used to fetch the next page of items.
     */
    endCursor?: Maybe<Scalars['String']['output']>;
    /**
     * Indicates whether there are more pages available after the current page.
     * This is useful for determining if the user can navigate forward in the list.
     */
    hasNextPage: Scalars['Boolean']['output'];
    /**
     * Indicates whether there are more pages available before the current page.
     * This is useful for determining if the user can navigate back in the list.
     */
    hasPreviousPage: Scalars['Boolean']['output'];
    /**
     * The cursor corresponding to the first item in the current page.
     * This cursor can be used to fetch the previous page of items.
     */
    startCursor?: Maybe<Scalars['String']['output']>;
};

export type PageViewCount = {
    date?: Maybe<Scalars['String']['output']>;
    view?: Maybe<Scalars['Int']['output']>;
};

export type ParentRegionsByType = {
    city?: Maybe<ParentRegionsByTypeIdentifier>;
    country?: Maybe<ParentRegionsByTypeIdentifier>;
    county?: Maybe<ParentRegionsByTypeIdentifier>;
    neighborhood?: Maybe<ParentRegionsByTypeIdentifier>;
    state?: Maybe<ParentRegionsByTypeIdentifier>;
    zipcode?: Maybe<ParentRegionsByTypeIdentifier>;
};

export type ParentRegionsByTypeIdentifier = {
    name?: Maybe<Scalars['String']['output']>;
    regionId?: Maybe<Scalars['Int']['output']>;
    url?: Maybe<Scalars['String']['output']>;
};

export type ParkingTypesType =
    | 'AttachedGarage'
    | 'CoveredParking'
    | 'DetachedGarage'
    | 'MultiLevelGarage'
    | 'None'
    | 'ParkingLot'
    | 'UndergroundGarage'
    | 'Unknown';

export type ParticipantContactDataSource = 'ALAN_SUBSEQUENT_TOUR_SERVICE' | 'LEADS_API';

/** A Zillow Offers partner agent */
export type PartnerAgent = {
    /**
     * Whether the provided agent is classified as best of Zillow or not
     * @deprecated The Best of Zillow feature is deprecated
     */
    bestOfZillow?: Maybe<Scalars['Boolean']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    profileUrl?: Maybe<Scalars['String']['output']>;
    ratings?: Maybe<Ratings>;
    /**
     * The seller perspective of an agent-led sale
     * @deprecated Zillow Offers Shutdown. Partner agents no longer in use
     */
    sellerStatus?: Maybe<PartnerAgentStatus>;
};

/** The status of the partner agent flow */
export type PartnerAgentStatus = {
    /** An unordered array of constant strings representing the states this projection has reached */
    currentState: Array<Maybe<Scalars['String']['output']>>;
};

/** A Zillow Offers partner broker */
export type PartnerBroker = {
    businessName?: Maybe<Scalars['String']['output']>;
};

/** A Zillow Offers partner lead */
export type PartnerLead = {
    associatedORIDs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    createDate?: Maybe<Scalars['DateTime']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    lastUpdateDate?: Maybe<Scalars['DateTime']['output']>;
    netSheetData?: Maybe<NetSheetData>;
};

export type PastJob = {
    employer?: Maybe<Employer>;
    endDate?: Maybe<Scalars['Date']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    startDate?: Maybe<Scalars['Date']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type PastJobInput = {
    employer?: InputMaybe<EmployerInput>;
    endDate?: InputMaybe<Scalars['Date']['input']>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
    title?: InputMaybe<Scalars['NonEmptyString']['input']>;
};

export type PastResidence = {
    address?: Maybe<RentalApplicationAddress>;
    endDate?: Maybe<Scalars['Date']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    startDate?: Maybe<Scalars['Date']['output']>;
    type?: Maybe<ResidenceType>;
};

export type Payment = {
    currentScheduleMonth?: Maybe<CurrentScheduleMonth>;
    gdpProperty?: Maybe<Property>;
    invitationLink?: Maybe<Scalars['String']['output']>;
    isRachelRequestPaymentsEnabled?: Maybe<Scalars['Boolean']['output']>;
    landlordProfile?: Maybe<LandlordProfile>;
    listingAlias?: Maybe<Scalars['String']['output']>;
    moveInCostsDetails?: Maybe<MoveInCostsDetails>;
    nextPayable?: Maybe<NextPayable>;
    onboardingComplete?: Maybe<Scalars['Boolean']['output']>;
    onboardingStatus?: Maybe<Scalars['String']['output']>;
    paymentDetails?: Maybe<PaymentDetails>;
    paymentHistory?: Maybe<Array<Maybe<PaymentHistory>>>;
    /** @deprecated use gdpProperty instead */
    property?: Maybe<ZGProperty>;
    propertyId?: Maybe<Scalars['String']['output']>;
    rentTerms?: Maybe<RentTerms>;
    /** @deprecated use landlordProfile instead */
    renterHubLandlordProfile?: Maybe<RenterHubLandlordProfile>;
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type PaymentAlertData = {
    appearance?: Maybe<Scalars['String']['output']>;
    cta?: Maybe<RenterHubCta>;
    text?: Maybe<Scalars['String']['output']>;
    /**
     * The type of payment alert to show
     *
     * Valid values are:
     * TERMS_ENDING_SOON
     * TERM_ENDED
     */
    type?: Maybe<Scalars['String']['output']>;
};

export type PaymentDetails = {
    paymentSubscriptionDetails?: Maybe<PaymentSubscriptionDetails>;
};

export type PaymentHistory = {
    transactions?: Maybe<Array<Maybe<PaymentTransaction>>>;
};

export type PaymentInformationCardData = {
    bodyText?: Maybe<Scalars['String']['output']>;
    /**
     * The type of payment information card to show
     *
     * Valid values are:
     * REQUEST_SET_UP_PAYMENT
     * RENT_AMOUNT_CHANGE
     */
    cardType?: Maybe<Scalars['String']['output']>;
    footerCta?: Maybe<RenterHubCta>;
    headingText?: Maybe<Scalars['String']['output']>;
};

export type PaymentNotificationCardData = {
    additionalNotes?: Maybe<Scalars['String']['output']>;
    amountText?: Maybe<Scalars['String']['output']>;
    cardActions?: Maybe<Array<Maybe<RenterHubCta>>>;
    notes?: Maybe<Scalars['String']['output']>;
    statusTag?: Maybe<RenterHubCardTag>;
    title?: Maybe<Scalars['String']['output']>;
};

export type PaymentSubscriptionDetails = {
    amount?: Maybe<Scalars['Int']['output']>;
    firstScheduledDate?: Maybe<Scalars['String']['output']>;
    nextArrivalDate?: Maybe<Scalars['String']['output']>;
    nextScheduledDate?: Maybe<Scalars['String']['output']>;
    recurring?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentTransaction = {
    dateCreated?: Maybe<Scalars['String']['output']>;
    dateReceived?: Maybe<Scalars['String']['output']>;
    dueDate?: Maybe<Scalars['String']['output']>;
    notes?: Maybe<Scalars['String']['output']>;
    paymentCategory?: Maybe<Scalars['String']['output']>;
    paymentType?: Maybe<Scalars['String']['output']>;
    renterStatus?: Maybe<Scalars['String']['output']>;
    scheduleMonth?: Maybe<Scalars['String']['output']>;
    totalAmount?: Maybe<Scalars['Int']['output']>;
};

/** Team member's performance rating */
export type PerformanceRating =
    /** High */
    | 'High'
    /** Low */
    | 'Low'
    /** Mid */
    | 'Mid';

export type PersonalizedCoShopping = {
    /**  saved home info  */
    savedHome?: Maybe<ShopperSavedHome>;
    /**  List of tags added by the co-shopper  */
    tags?: Maybe<Array<Maybe<PropertyTag>>>;
};

export type PersonalizedShopping = {
    /**  Co-Shopper data for the signed-in user  */
    coShopper?: Maybe<CoShopper>;
    /**  get coShopper connections linked with the user  */
    coShopperConnections?: Maybe<Array<Maybe<CoShopperConnection>>>;
    /**  Personalized property data for the signed-in user  */
    shopperProperty?: Maybe<Array<Maybe<ShopperProperty>>>;
};

export type PersonalizedShoppingshopperPropertyArgs = {
    propertyId?: InputMaybe<Scalars['ID']['input']>;
    propertyIdType?: InputMaybe<PropertyIdType>;
};

export type PersonalizedShoppingForUser = {
    /**  saved home info  */
    savedHome?: Maybe<ShopperSavedHome>;
    /**  List of tags added by the user  */
    tags?: Maybe<Array<Maybe<PropertyTag>>>;
    /**
     *  List of user notes added by the user
     * @deprecated use property.userPersonalizedShoppingData instead
     */
    userNotes?: Maybe<Array<UserNote>>;
    /**  Property view information for the user  */
    viewed?: Maybe<PropertyView>;
};

export type PersonalizedShoppingForUseruserNotesArgs = {
    noteType?: InputMaybe<Scalars['String']['input']>;
};

export type PetDetails = {
    /** Number of cats in household */
    catCount?: Maybe<Scalars['String']['output']>;
    /** Number of dogs in household */
    dogCount?: Maybe<Scalars['String']['output']>;
};

/** A single pet policy for a building */
export type PetPolicy = {
    allowed?: Maybe<Scalars['Boolean']['output']>;
    comment?: Maybe<Scalars['String']['output']>;
    deposit?: Maybe<Scalars['Float']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    feeRangeMax?: Maybe<Scalars['Float']['output']>;
    feeRangeMin?: Maybe<Scalars['Float']['output']>;
    maxNumberAllowed?: Maybe<Scalars['Int']['output']>;
    maxWeightAllowed?: Maybe<Scalars['Float']['output']>;
    monthlyFee?: Maybe<Scalars['Float']['output']>;
    oneTimeFee?: Maybe<Scalars['Float']['output']>;
    petCare?: Maybe<Scalars['Boolean']['output']>;
    petSize?: Maybe<Scalars['String']['output']>;
    petType?: Maybe<Scalars['String']['output']>;
    restriction?: Maybe<Scalars['String']['output']>;
};

export type PetPolicyType =
    | 'Cats'
    | 'LargeDogs'
    | 'Other'
    | 'PetsForbidden'
    | 'SmallDogs'
    | 'Unknown';

export type Pets = {
    cats?: Maybe<Scalars['Int']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    largeDogs?: Maybe<Scalars['Int']['output']>;
    mediumDogs?: Maybe<Scalars['Int']['output']>;
    other?: Maybe<Scalars['Int']['output']>;
    smallDogs?: Maybe<Scalars['Int']['output']>;
};

export type PetsAllowedType = 'CATS' | 'LARGE_DOGS' | 'SMALL_DOGS';

export type PetsInput = {
    cats: Scalars['NonNegativeInt']['input'];
    description?: InputMaybe<Scalars['NonEmptyString']['input']>;
    largeDogs: Scalars['NonNegativeInt']['input'];
    mediumDogs: Scalars['NonNegativeInt']['input'];
    other: Scalars['NonNegativeInt']['input'];
    smallDogs: Scalars['NonNegativeInt']['input'];
};

export type Phone = {
    /** The extension of the phone number */
    extension?: Maybe<Scalars['String']['output']>;
    /** North American 10 digit phone number that should be in the format of ###-###-####. */
    number?: Maybe<Scalars['String']['output']>;
};

/** Phone number which is required to be shown with a listing */
export type PhoneRule = {
    /** Phone number extension */
    extension?: Maybe<Scalars['String']['output']>;
    /** Phone number */
    number?: Maybe<Scalars['String']['output']>;
};

/** PhoneSource ... */
export type PhoneSource = {
    source?: Maybe<Scalars['String']['output']>;
    twilioAccountSid?: Maybe<Scalars['String']['output']>;
    twilioMessagingServiceSid?: Maybe<Scalars['String']['output']>;
    twilioPhoneSid?: Maybe<Scalars['String']['output']>;
};

/** PhonesByAssociationResponse ... */
export type PhonesByAssociationResponse = {
    phones?: Maybe<Array<Maybe<SwitchboardPhone>>>;
};

/** An image */
export type Photo = {
    /** A caption for the image, only request when visible on page. call is expensive. */
    caption?: Maybe<Scalars['String']['output']>;
    /** height in pixels */
    height?: Maybe<Scalars['Int']['output']>;
    /** Raw metadata tags from PSL */
    metadataTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    mixedSources?: Maybe<MultiImageSourceType>;
    /** String representing a photo id. Also included in the url. */
    photoKey?: Maybe<Scalars['String']['output']>;
    sources?: Maybe<Array<Maybe<ResponsiveImageSource>>>;
    /** See ImageSubjectTypeID from Pogo */
    subjectType?: Maybe<ImageSubjectType>;
    url?: Maybe<Scalars['String']['output']>;
    /** width in pixels */
    width?: Maybe<Scalars['Int']['output']>;
};

/** An image */
export type PhotomixedSourcesArgs = {
    aspectRatio?: InputMaybe<AspectRatio>;
    maxWidth?: InputMaybe<Scalars['Int']['input']>;
    minWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** An image */
export type PhotosourcesArgs = {
    aspectRatio?: InputMaybe<AspectRatio>;
    maxWidth?: InputMaybe<Scalars['Int']['input']>;
    minWidth?: InputMaybe<Scalars['Int']['input']>;
};

export type PhotoAlbum = {
    /** Links of the photos */
    photoLinks?: Maybe<Array<PhotoLink>>;
    /** Treatment of the photos */
    treatment?: Maybe<PhotoTreatment>;
};

export type PhotoAlbums = {
    /** Should show fallback photo or not */
    isFallbackPhoto?: Maybe<Scalars['Boolean']['output']>;
    /** Lst of photo albums */
    photoAlbums?: Maybe<Array<PhotoAlbum>>;
};

export type PhotoLink = {
    /** The caption to be used for the photo. This could be null for third party photos. */
    caption?: Maybe<Scalars['String']['output']>;
    /**
     * List of metadata tags to the related metadata of the photo (e.g. floorplan, elevation, etc.). These tags could be
     * freely obtained from PDC or created on the fly in PSL using this enum PhotoLinkMetadataTag
     */
    metadataTags?: Maybe<Array<Scalars['String']['output']>>;
    /** The URL of the photo */
    url?: Maybe<Scalars['String']['output']>;
};

export type PhotoMixedSource = MixedSource & {
    url: Scalars['String']['output'];
    width: Scalars['Int']['output'];
};

export type PhotoMixedSources = MixedSources & {
    jpeg: Array<PhotoMixedSource>;
    webp: Array<PhotoMixedSource>;
};

export type PhotoSize = {
    /** Horizontal pixel value */
    horizontal: Scalars['Int']['input'];
    /** Vertical pixel value */
    vertical: Scalars['Int']['input'];
};

/** List of treatments and their definitions: https://gitlab.zgtools.net/zillow/leap/egg.image-processing-library/-/blob/master/zimagelib/imagespec.py */
export type PhotoTreatment =
    | 'ADS_MEDIUM'
    | 'ADS_THUMBNAIL'
    | 'CAPPED_ORIGINAL'
    | 'COVER_CROP_96_48'
    | 'COVER_CROP_96_72'
    | 'COVER_CROP_192_144'
    | 'COVER_CROP_384_288'
    | 'COVER_CROP_576_432'
    | 'COVER_CROP_768_576'
    | 'COVER_CROP_960_720'
    | 'COVER_CROP_1152_864'
    | 'COVER_CROP_1344_1008'
    | 'COVER_CROP_1536_1152'
    | 'DIGS_LARGE'
    | 'DIGS_LARGER'
    | 'DIGS_MEDIUM'
    | 'DIGS_XL'
    | 'FLOORPLAN_LARGE'
    | 'FLOORPLAN_XL'
    | 'HOME_IMPROVEMENT_120_106'
    | 'HOME_IMPROVEMENT_150_112'
    | 'HOME_IMPROVEMENT_164_219'
    | 'HOME_IMPROVEMENT_213_283'
    | 'HOME_IMPROVEMENT_290_196'
    | 'HOME_IMPROVEMENT_290_435'
    | 'HOME_IMPROVEMENT_292_219'
    | 'HOME_IMPROVEMENT_306_207'
    | 'HOME_IMPROVEMENT_306_460'
    | 'HOME_IMPROVEMENT_365_246'
    | 'HOME_IMPROVEMENT_426_283'
    | 'HOME_IMPROVEMENT_640_1136'
    | 'HOME_IMPROVEMENT_656_490'
    | 'HOME_IMPROVEMENT_656_874'
    | 'HOME_IMPROVEMENT_1024_768'
    | 'HOME_IMPROVEMENT_1136_640'
    | 'LOGO_80_40'
    | 'LOGO_120_50'
    | 'LOGO_LIST'
    | 'LOGO_PROFILE'
    | 'OE_WEB_LISTING_CARD'
    | 'OE_WEB_LISTING_CAROUSEL'
    | 'OE_WEB_LISTING_GALLERY'
    | 'OE_WEB_LISTING_THUMB'
    | 'ORIGINAL_SIZE'
    | 'PA_DIRECT_1080_1080'
    | 'PRODUCT_175_175'
    | 'PRODUCT_350_350'
    | 'PROFILE_60_60'
    | 'PROFILE_75_100'
    | 'PROFILE_120_120'
    | 'PROFILE_160_160'
    | 'PROFILE_160_180'
    | 'PROFILE_180_120'
    | 'PROFILE_240_240'
    | 'PROFILE_320_360'
    | 'PROFILE_360_240'
    | 'PROFILE_LARGE_THUMBNAIL'
    | 'PROFILE_MEDIUM'
    | 'PROFILE_SMALL_THUMBNAIL'
    | 'PROFILE_TALL_MEDIUM'
    | 'PROFILE_THUMBNAIL'
    | 'PROFILE_WEE_THUMBNAIL'
    | 'PROPERTY_227_227'
    | 'PROPERTY_308_308'
    | 'PROPERTY_548_366'
    | 'PROPERTY_550_413'
    | 'PROPERTY_1920_1080'
    | 'PROPERTY_IWATCH_308_346'
    | 'PROPERTY_LARGE'
    | 'PROPERTY_LARGE_THUMBNAIL'
    | 'PROPERTY_MEDIUM'
    | 'PROPERTY_SMALL'
    | 'PROPERTY_THUMBNAIL'
    | 'PROPERTY_THUMBNAIL_150_112'
    | 'PROPERTY_XL'
    | 'PROPERTY_XXL'
    | 'RENTALS_LARGE_1200_1200'
    | 'RENTALS_MEDIUM_500_500'
    | 'RENTALS_MEDIUM_MODELLAYOUT_640_640'
    | 'RENTALS_SQUARETHUMB_74_74'
    | 'RENTALS_THUMB_180_180'
    | 'SE_EXTRA_LARGE_1500_800'
    | 'SE_LARGE_800_400'
    | 'SE_MEDIUM_500_250'
    | 'SE_THUMB_80_40'
    | 'TRULIA_95_35'
    | 'TRULIA_INF_40'
    | 'TRULIA_THUMBS_3_320_240'
    | 'TRULIA_THUMBS_4_640_480'
    | 'TRULIA_THUMBS_5_1024_768'
    | 'TRULIA_THUMBS_6_2048_1536'
    | 'TRULIA_THUMBS_70_50'
    | 'TRULIA_THUMBS_BIG_140_100'
    | 'TRULIA_WEB_60_37'
    | 'TRULIA_WEB_INF_18'
    | 'TRULIA_WEB_INF_20'
    | 'UNCROPPED_SCALED_WITHIN_1344_1008'
    | 'UNCROPPED_SCALED_WITHIN_1536_1152'
    | 'UPLOAD_LARGE'
    | 'UPLOAD_LARGER'
    | 'UPLOAD_LARGE_THUMBNAIL'
    | 'UPLOAD_THUMBNAIL'
    | 'ZILLOW_APPS_48_18'
    | 'ZILLOW_APPS_95_35'
    | 'ZILLOW_APPS_96_36'
    | 'ZILLOW_APPS_144_54'
    | 'ZILLOW_APPS_192_72'
    | 'ZILLOW_APPS_240_90'
    | 'ZILLOW_WEB_48_23'
    | 'ZILLOW_WEB_85_37'
    | 'ZILLOW_WEB_95_35'
    | 'ZILLOW_WEB_INF_11'
    | 'ZILLOW_WEB_INF_14'
    | 'ZILLOW_WEB_LOGO_INF_11';

export type PhotoTreatmentRequest = {
    /**
     * This is the fallback photo treatment to use when the DonotCropPhotos
     * rule is applicable, which means the photo should not be cropped.
     */
    noCropFallbackTreatment: PhotoTreatment;
    /** This is the primary requested photo treatment and must be specified with every request. */
    primaryTreatment: PhotoTreatment;
};

export type PickUpRate = {
    answerRate: Scalars['Float']['output'];
    callsToTeamMember: Scalars['Int']['output'];
    connections: Scalars['Int']['output'];
    pickupRate: Scalars['Float']['output'];
    pickups: Scalars['Int']['output'];
    zip: Scalars['String']['output'];
};

/** Additional data specific to onsiteMessage placements */
export type PlacementData = {
    deviceType?: InputMaybe<deviceType>;
    isCarouselAdsRestricted?: InputMaybe<Scalars['Boolean']['input']>;
    placementSupportedComponents?: InputMaybe<Array<InputMaybe<PlacementSupportedComponents>>>;
};

/**
 * Decision of which treatment to be displayed for this placement, the placement's
 * testing phase, and all other qualified treatments for the current user
 */
export type PlacementDecisionType = {
    bucket: MessageAbBucketType;
    /**
     * a JSON String that contains all the context data used or to be used to make
     * the treatment selection decision (which will be logged and used by data scientists)
     */
    decisionContext?: Maybe<Scalars['JSON']['output']>;
    /** A unique event-id used to mark the web events for upsells that will help track them in the analytics side of things */
    eventId?: Maybe<Scalars['String']['output']>;
    eventMetadata?: Maybe<EventMetaData>;
    /** A boolean to indicate whether the user guid is in Onsite Messaging's global Hold out bucket */
    isGlobalHoldout: Scalars['Boolean']['output'];
    /** A boolean to indicate whether the user guid is in Onsite Messaging's placement-level Hold out bucket */
    isPlacementHoldout: Scalars['Boolean']['output'];
    lastModified: Scalars['String']['output'];
    /**
     * For certain placement, we will simulate a random coin flip to decide whether
     * to render the chosen treatment on UI, so that the user won't be overwhelmed by
     * messages on every page view
     */
    passThrottle: Scalars['Boolean']['output'];
    placementId: Scalars['Int']['output'];
    placementName: Scalars['String']['output'];
    qualifiedTreatments?: Maybe<Array<Maybe<MessageTreatmentType>>>;
    /** The selected treatment which is qualified for current user's context */
    selectedTreatment?: Maybe<MessageTreatmentType>;
    /** A boolean to indicate whether the selected treatment (if any) should be displayed for the user */
    shouldDisplay: Scalars['Boolean']['output'];
    /** If the selected treatment is decided not to be displayed, this field will explain the reason of skipping displaying */
    skipDisplayReason?: Maybe<Scalars['String']['output']>;
    testPhase: MessageTestPhaseType;
    typedSelectedTreatment?: Maybe<OmpComponentType>;
};

export type PlacementOption =
    | 'BDP_BOTTOM'
    | 'EMAIL'
    | 'HDP_BOTTOM'
    | 'HDP_SIMILAR_HOMES'
    | 'HOME_PAGE'
    | 'MOBILE_LIST_HRV1'
    | 'MOBILE_MAP_HRV1'
    | 'MOBILE_PUSH_HRV1'
    | 'SEM_LANDING_PAGE_HERO_IMAGE';

/** Components supported by onsiteMessage placement */
export type PlacementSupportedComponents = {
    placementIdentifier: Scalars['String']['input'];
    supportedComponents: Array<InputMaybe<IOSSupportedComponentsType>>;
};

export type PlanForSpec = {
    /** @deprecated Use ncListingAvailability */
    ncProperty?: Maybe<NcProperty>;
    /** The attributes of this plan which are stored in its POGO Property object */
    property?: Maybe<Property>;
};

export type PlanPropertyForSpec = {
    /** The attributes of this plan which are stored in its POGO Property object */
    property?: Maybe<Property>;
};

export type PoolWithSize = {
    /** A description of the the pool such as Heated pool Above ground pool, etc. */
    description?: Maybe<Scalars['String']['output']>;
    /** The size of the pool from the description. Sizes may be numbers or strings ("600" or "20 x 10"). */
    size?: Maybe<Scalars['String']['output']>;
};

export type PostContactFormSubmitView = FinanceUpsellView | TourRequestConfirmationView;

export type PostContactFormSubmitViewInput = {
    /** The type of booking for this tour appointment (ex. STANDARD, INSTANT, INSTANT_BOOK) */
    bookingType: Scalars['String']['input'];
    /** The tour experience type (ex: DCV1, DCV2, RTT, NONE) */
    experienceType?: InputMaybe<Scalars['String']['input']>;
    /** Whether or not the buyer checked the box indicated by financingCheckboxType */
    financingCheckboxSelected?: InputMaybe<Scalars['Boolean']['input']>;
    /** The type of financing checkbox that was displayed (ex: ZHL, ZGMI, NONE) */
    financingCheckboxType?: InputMaybe<Scalars['String']['input']>;
    /** Whether or not the buyer has indicated they are currently working with an agent */
    hasAgent?: InputMaybe<Scalars['Boolean']['input']>;
    /** An array of requested tour times, formatted with optional time value as YYYY-MM-DDTHH:MM:SS or without time value as YYYY-MM-DD */
    requestedTourTimes?: InputMaybe<Array<Scalars['String']['input']>>;
    /** The time range in which the buyer said they were looking to buy (ex: 0-3Months, 3-6Months, ... ) */
    timelineToBuy?: InputMaybe<Scalars['String']['input']>;
};

export type PostHighlightInput = {
    /** Text constituting the highlight. */
    content: Scalars['String']['input'];
    /** Zillow property identifier. */
    zpid: Scalars['Int']['input'];
};

export type PostHighlightResult = {
    errorMessage?: Maybe<Scalars['String']['output']>;
};

export type PostedByType = 'AGENT' | 'OWNER' | 'OWNER_RESIDENT' | 'TENANT' | 'UNKNOWN';

export type PostingPresentationTypes =
    | 'AdOpsCollectionBased'
    | 'Basic'
    | 'BrokerFeatured'
    | 'FeedOwnerConfig'
    | 'HideZestimate'
    | 'InsideSalesAccountBased'
    | 'ListingOwnerConfig'
    | 'PaidFeatured'
    | 'PremierBuilder'
    | 'SpecialOfferFeatured'
    | 'SpecialOfferManual'
    | 'TNCCollectionBased'
    | 'TNCFeatureListing'
    | 'TNCFeatureListingAndOpenHouse'
    | 'TNCOpenHouse'
    | 'TNCRental'
    | 'WebPosting';

export type PostingProductType =
    | 'Apartment'
    | 'ApartmentUnit'
    | 'Auction'
    | 'AuctionForeclosure'
    | 'Foreclosure'
    | 'Lot'
    | 'Plan'
    | 'REO_Foreclosure'
    | 'Spec'
    | 'SpecUnderConstruction'
    | 'Standard'
    | 'WaitlistApartment'
    | 'WaitlistApartmentUnit';

export type PreApprovalBorrower = {
    fullName?: InputMaybe<Scalars['String']['input']>;
};

export type PreApprovalBorrowerPair = {
    coborrower?: InputMaybe<PreApprovalBorrower>;
    primaryBorrower: PreApprovalBorrower;
};

export type PreApprovalConditionInput = {
    conditionDescription: Scalars['String']['input'];
    conditionName: Scalars['String']['input'];
    conditionTypeName: Scalars['String']['input'];
};

export type PreApprovalLetter = {
    borrowers: Array<InputMaybe<PreApprovalBorrowerPair>>;
    conditions?: InputMaybe<Array<InputMaybe<PreApprovalConditionInput>>>;
    downPayment: Scalars['String']['input'];
    loanAmount: Scalars['String']['input'];
    loanTerm?: InputMaybe<Scalars['String']['input']>;
    loanType: LoanType;
    ltvRatio?: InputMaybe<Scalars['String']['input']>;
    noteRate?: InputMaybe<Scalars['String']['input']>;
    purchasePrice: Scalars['String']['input'];
    subjectPropertyLocation: Scalars['String']['input'];
    subjectPropertyLocationState: Scalars['String']['input'];
};

/** PreQual page internal route */
export type PreQualRoute = INativeIOSDestination & {
    attributions: Array<AttributionEntry>;
    guid: Scalars['String']['output'];
    zpid: Scalars['String']['output'];
    zuid?: Maybe<Scalars['String']['output']>;
};

export type PreferredLoanOfficerConnectionStatus = 'ConnectionSpecialist' | 'Direct' | 'Disabled';

/** Rental Premium Package info for a single zpid */
export type PremiumPackageInfo = {
    /** CustomerId (HotpadsCustomerCode) for this listing */
    customerId?: Maybe<Scalars['String']['output']>;
    /** PackageType purchased under this customerId */
    packageType?: Maybe<Scalars['String']['output']>;
    /** PriorityScore for this listing */
    score?: Maybe<Scalars['Float']['output']>;
};

export type PreviousAgentParticipant = {
    paAgent?: Maybe<PAAgent>;
    /**
     * **Definition:** The zuid of the agent participant
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    zuid?: Maybe<Scalars['Int']['output']>;
};

export type Price = {
    /** The price of the property based on the "filtered" home status */
    filteredPrice?: Maybe<Scalars['Int']['output']>;
    /** Information about the most recent price change */
    priceChange?: Maybe<PriceChange>;
    /** the price per square foot, will be null out if HidePricePerSqft is applicable */
    pricePerSquareFoot?: Maybe<Scalars['Int']['output']>;
    /** The price of the property based on the "raw" home status */
    rawPrice?: Maybe<Scalars['Int']['output']>;
    /** Suffix displayed after price. Ex. when suffix is "+" and price is $200, price should be displayed as $200+ */
    suffix?: Maybe<Scalars['String']['output']>;
};

export type PriceChange = {
    /** * Whether the price change is increase or not */
    isPriceDecrease?: Maybe<Scalars['Boolean']['output']>;
    /**
     * * The amount that the price changed, represented as a signed integer
     * *
     * * If HidePriceAdjustmentFlexField rule is applicable, this field will be nulled out
     */
    priceChangeAmount?: Maybe<Scalars['Int']['output']>;
    /**
     * The date that the price changed
     * Example: 2019-07-03
     */
    priceChangeDate?: Maybe<Scalars['LocalDate']['output']>;
};

/** Min and max price that defines a range */
export type PriceRange = {
    max?: Maybe<Scalars['Int']['output']>;
    min?: Maybe<Scalars['Int']['output']>;
};

/** A single item in a price history */
export type PriceRecord = {
    /** Attribution source for this event */
    attributeSource?: Maybe<PriceRecordAttributeSource>;
    /** Agent representing the buyer during this event */
    buyerAgent?: Maybe<PriceTaxAgentSummary>;
    /** The date of the event */
    date?: Maybe<Scalars['String']['output']>;
    /** A description of the price change event */
    event?: Maybe<Scalars['String']['output']>;
    /** External source type for the event */
    externalSourceType?: Maybe<Scalars['String']['output']>;
    /** The posting id for this event */
    postingId?: Maybe<Scalars['ID']['output']>;
    /** If true, the price reflects a monthly cost for rental */
    postingIsRental?: Maybe<Scalars['Boolean']['output']>;
    /** The new price after the event */
    price?: Maybe<Scalars['Float']['output']>;
    /** The change in price from the previous price */
    priceChangeRate?: Maybe<Scalars['Float']['output']>;
    /** The new pricePerSquareFoot after the event */
    pricePerSquareFoot?: Maybe<Scalars['Float']['output']>;
    /** Agent representing the seller during this event */
    sellerAgent?: Maybe<PriceTaxAgentSummary>;
    /** If true, the source should link to the county data page */
    showCountyLink?: Maybe<Scalars['Boolean']['output']>;
    /** Data source for the event */
    source?: Maybe<Scalars['String']['output']>;
    /** When the price event occurred */
    time?: Maybe<Scalars['DateTime']['output']>;
};

/** Attribution source for a price history event */
export type PriceRecordAttributeSource = {
    infoString1?: Maybe<Scalars['String']['output']>;
    infoString2?: Maybe<Scalars['String']['output']>;
    infoString3?: Maybe<Scalars['String']['output']>;
    /** Whether to expose infoString3 outside the row dropdown or keep it inside */
    infoString4?: Maybe<Scalars['Boolean']['output']>;
};

export type PriceTaxAgentSummary = {
    businessName?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    photo?: Maybe<Photo>;
    profileUrl?: Maybe<Scalars['String']['output']>;
};

export type PriceTaxAgentSummaryphotoArgs = {
    size?: InputMaybe<PropertyPhotoSize>;
};

export type PrimaryImageType = {
    imageId?: Maybe<Scalars['Float']['output']>;
};

export type PrimaryPlan = {
    /** @deprecated Use ncListingAvailability */
    ncProperty?: Maybe<NcProperty>;
    property?: Maybe<Property>;
};

/** Task priority */
export type Priority = 'HIGH' | 'LOW' | 'MEDIUM';

export type ProductEligibility = {
    market?: Maybe<MirageMarket>;
    products?: Maybe<Array<MirageProduct>>;
};

export type ProductEligibilityInput = {
    excludeProducts?: InputMaybe<Array<Scalars['String']['input']>>;
    includeProducts?: InputMaybe<Array<Scalars['String']['input']>>;
    zpid: Scalars['Int']['input'];
};

export type Profile = {
    /**
     * Vibe description of this region.
     * @deprecated The upstream service is deco'd. Please remove usages or reach out to traffic-core.
     */
    character?: Maybe<Scalars['String']['output']>;
    /**
     * Housing description of this region.
     * @deprecated The upstream service is deco'd. Please remove usages or reach out to traffic-core.
     */
    housing?: Maybe<Scalars['String']['output']>;
    /**
     * General introduction of the region.
     * @deprecated The upstream service is deco'd. Please remove usages or reach out to traffic-core.
     */
    intro?: Maybe<Scalars['String']['output']>;
    /**
     * Services description of this region.
     * @deprecated The upstream service is deco'd. Please remove usages or reach out to traffic-core.
     */
    services?: Maybe<Scalars['String']['output']>;
    /**
     * Transport description of the region.
     * @deprecated The upstream service is deco'd. Please remove usages or reach out to traffic-core.
     */
    transport?: Maybe<Scalars['String']['output']>;
};

export type ProgressLabel = {
    state: ProgressStateEnum;
    title: Scalars['String']['output'];
};

export type ProgressStateEnum = 'INFO' | 'SUCCESS' | 'WARNING';

export type ProofOfInsurance = {
    hasExistingProofOfInsurance?: Maybe<Scalars['Boolean']['output']>;
    isProofOfInsuranceEnabled?: Maybe<Scalars['Boolean']['output']>;
    isShared?: Maybe<Scalars['Boolean']['output']>;
    proofOfInsuranceId?: Maybe<Scalars['String']['output']>;
    thumbnailUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type Property = Node & {
    /** For a new construction property, the Lot #, Plan Name, or Spec street address, without the community name appended to it */
    abbreviatedAddress?: Maybe<Scalars['String']['output']>;
    /** Blob of ad targeting context parameters */
    adTargets?: Maybe<Scalars['JSON']['output']>;
    /** Parse pogo's semicolon-delimited formatted address */
    address?: Maybe<Address>;
    affordabilityEstimate?: Maybe<AffordabilityEstimate>;
    /** The email address of the agent associated with the listing */
    agentEmailAddress?: Maybe<Scalars['String']['output']>;
    /** The annual home owners insurance of this property */
    annualHomeownersInsurance?: Maybe<Scalars['Float']['output']>;
    /** Search page URL and description for aparments for rent in the zipcode */
    apartmentsForRentInZipcodeSearchUrl?: Maybe<UrlObjectType>;
    /** Information about the closest assigned elementary, middle, and high school */
    assignedSchools?: Maybe<Array<Maybe<School>>>;
    attributionInfo?: Maybe<AttributionInfo>;
    batchRules?: Maybe<BatchRules>;
    /** number of bathrooms */
    bathrooms?: Maybe<Scalars['Float']['output']>;
    /** number of bedrooms */
    bedrooms?: Maybe<Scalars['Float']['output']>;
    /** Information about the bikeability of the area. */
    bikeScore?: Maybe<BikeScoreResponse>;
    /** Region ID for the borough */
    boroughId?: Maybe<Scalars['Int']['output']>;
    /** search page url and text description to this property's borough */
    boroughSearchUrl?: Maybe<UrlObjectType>;
    /** The property's posting's broker ID */
    brokerId?: Maybe<Scalars['Int']['output']>;
    brokerIdDimension?: Maybe<Scalars['String']['output']>;
    /**
     * The property's posting's broker ID to be used for tracking metrics. Has
     * fallbacks if brokerId is missing based on the homeStatus.
     */
    brokerIdForTracking?: Maybe<Scalars['String']['output']>;
    /** Name of brokerage */
    brokerageName?: Maybe<Scalars['String']['output']>;
    building?: Maybe<BuildingMini>;
    /** The property's building/lot ID */
    buildingId?: Maybe<Scalars['ID']['output']>;
    /** List of building permits */
    buildingPermits?: Maybe<Array<Maybe<BuildingPermit>>>;
    city?: Maybe<Scalars['String']['output']>;
    /** Region ID for the city */
    cityId?: Maybe<Scalars['Int']['output']>;
    /** Region identified by cityId */
    cityRegion?: Maybe<Region>;
    /** search page url and text description to this property's city */
    citySearchUrl?: Maybe<UrlObjectType>;
    /** List of personalized collections for a user */
    collections?: Maybe<Collections>;
    /**
     * Date and time of when the property is coming to market (Used for Coming Soon properties)
     * @deprecated Use Property.comingSoonOnMarketDate to align with home info
     */
    comingSoonMarketDate?: Maybe<Scalars['DateTime']['output']>;
    /** Date and time of when the property is coming to market (Used for Coming Soon properties) */
    comingSoonOnMarketDate?: Maybe<Scalars['DateTime']['output']>;
    /** url to the community details page for the community of this property */
    communityUrl?: Maybe<UrlObjectType>;
    /** List of commute destinations and the corresponding commute distance and time for the viewer from the current property */
    commute?: Maybe<Array<Maybe<CommuteResponseType>>>;
    compType?: Maybe<Scalars['String']['output']>;
    /** Comparable homes (ForSale, ForRent or Hedonic) to the current home */
    comps?: Maybe<Array<Maybe<Property>>>;
    contactAgentFormVariant?: Maybe<ContactAgentFormVariant>;
    /** url to the contact agent form for mobile */
    contactAgentUrl?: Maybe<UrlObjectType>;
    /** Data for rendering for sale contact forms */
    contactFormRenderData?: Maybe<PropertyContactFormRenderData>;
    /** The type of contigent offer for a given listing */
    contingentListingType?: Maybe<ContingentListingType>;
    /** The country code for the property */
    country?: Maybe<CountryCode>;
    /**
     * The currency symbol of the country that the property belongs to.
     * @deprecated To be consistent with CurrencyType enum on homeInfo. Use currency instead.
     */
    countryCurrency?: Maybe<Scalars['String']['output']>;
    /** string of the requested property county */
    county?: Maybe<Scalars['String']['output']>;
    countyFIPS?: Maybe<Scalars['String']['output']>;
    /** Region ID for the county */
    countyId?: Maybe<Scalars['Int']['output']>;
    /** search page url and text description to this property's county */
    countySearchUrl?: Maybe<UrlObjectType>;
    countyWebsiteUrl?: Maybe<Scalars['String']['output']>;
    /** The currency code for the property */
    currency?: Maybe<CurrencyType>;
    /** When the listing was posted */
    datePosted?: Maybe<Scalars['DateTime']['output']>;
    /** When the listing was posted (as date string) */
    datePostedString?: Maybe<Scalars['String']['output']>;
    /** When listing price changed */
    datePriceChanged?: Maybe<Scalars['DateTime']['output']>;
    /** When the listing was last sold */
    dateSold?: Maybe<Scalars['DateTime']['output']>;
    /** When the listing was last sold (as date string) */
    dateSoldString?: Maybe<Scalars['String']['output']>;
    /**
     * The effective number of days this listing has been present if it has not been
     * refreshed by RentalsListingRanker, or the last refreshed date if it has been
     * refreshed by the rentalListingRanker. Returns 1 for less than 1 day.
     */
    daysOnZillow?: Maybe<Scalars['Int']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    desktopWebHdpImageLink?: Maybe<Scalars['String']['output']>;
    /** @deprecated Superseded by Property.homeFacts */
    detailsItems?: Maybe<Array<Maybe<PropertyDetailItem>>>;
    /** Information about down payment assistance programs */
    downPaymentAssistance?: Maybe<downPaymentAssistance>;
    /** Information about down payment assistance programs */
    downPaymentAssistanceProgramDetails?: Maybe<DownPaymentAssistanceProgramListType>;
    /** Down Payment Assistance authorization token timestamp */
    downPaymentAssistanceTimestamp?: Maybe<Scalars['String']['output']>;
    /** A relative url to edit the property history, available to admins only */
    editPropertyHistorylink?: Maybe<Scalars['String']['output']>;
    /** The URL of a broker logo to show up by the price */
    enhancedBrokerImageUrl?: Maybe<Scalars['String']['output']>;
    /** Number of times this property has been saved */
    favoriteCount?: Maybe<Scalars['Int']['output']>;
    featuredListingTypeDimension?: Maybe<Scalars['String']['output']>;
    /**
     * Foreclosure estimate
     * @deprecated Not provided by PDC any longer.
     */
    festimate?: Maybe<Scalars['Int']['output']>;
    /**
     * Finished basement area, in square feet
     * @deprecated Relies on POGO attributeBlob, which doesn't exist in PSL
     */
    finishedBasementSize?: Maybe<Scalars['Float']['output']>;
    /**
     * Number of floors of the property
     * @deprecated Relies on POGO attributeBlob, which doesn't exist in PSL
     */
    floorCount?: Maybe<Scalars['Float']['output']>;
    /** List of floor maps created from 3D Home */
    floorMaps?: Maybe<Array<Maybe<FloorMap>>>;
    /** 1 yr forecast of zestimate value */
    forecast?: Maybe<Scalars['String']['output']>;
    /** The bank that foreclosed the property */
    foreclosingBank?: Maybe<Scalars['String']['output']>;
    /** The value of the foreclosed property at foreclosure */
    foreclosureAmount?: Maybe<Scalars['Int']['output']>;
    /** City of the foreclosure auction */
    foreclosureAuctionCity?: Maybe<Scalars['String']['output']>;
    /** The type of foreclosure auction */
    foreclosureAuctionDescription?: Maybe<Scalars['String']['output']>;
    /** Date the foreclosure auction was filed */
    foreclosureAuctionFilingDate?: Maybe<Scalars['String']['output']>;
    /** Location of the foreclosure auction */
    foreclosureAuctionLocation?: Maybe<Scalars['String']['output']>;
    /** Time of the foreclosure auction */
    foreclosureAuctionTime?: Maybe<Scalars['DateTime']['output']>;
    /** When the past due balance was reported */
    foreclosureBalanceReportingDate?: Maybe<Scalars['DateTime']['output']>;
    /** When the foreclosure occurred */
    foreclosureDate?: Maybe<Scalars['DateTime']['output']>;
    /** Description of foreclosure default */
    foreclosureDefaultDescription?: Maybe<Scalars['String']['output']>;
    /** When the foreclosure default was filed */
    foreclosureDefaultFilingDate?: Maybe<Scalars['DateTime']['output']>;
    /** Whether the state court is involved in foreclosures ("Judicial") or not ("Non-Judicial"), or "Unknown" */
    foreclosureJudicialType?: Maybe<Scalars['String']['output']>;
    /** The amount loaned to assume the property during foreclosure */
    foreclosureLoanAmount?: Maybe<Scalars['Int']['output']>;
    /** Date foreclosed loan was originally issued */
    foreclosureLoanDate?: Maybe<Scalars['DateTime']['output']>;
    /** Originator of foreclosed loan */
    foreclosureLoanOriginator?: Maybe<Scalars['String']['output']>;
    /** Additional info about the foreclosure */
    foreclosureMoreInfo?: Maybe<ForeclosureMoreInfo>;
    /** The amount the mortgage was past due */
    foreclosurePastDueBalance?: Maybe<Scalars['Int']['output']>;
    /** The prior sale amount of the foreclosed property */
    foreclosurePriorSaleAmount?: Maybe<Scalars['Int']['output']>;
    /** The prior sale date of the foreclosed property */
    foreclosurePriorSaleDate?: Maybe<Scalars['DateTime']['output']>;
    foreclosureTypes?: Maybe<ForeclosureFlags>;
    /** The amount unpaid on the foreclosed loan */
    foreclosureUnpaidBalance?: Maybe<Scalars['Int']['output']>;
    /** Data for the formatted HDP chip */
    formattedChip?: Maybe<FormattedChip>;
    /** Signed Google static map url */
    googleStaticMapSignedUrl?: Maybe<Scalars['String']['output']>;
    /** Signed Google Street View image url */
    googleStreetViewImageSignedUrl?: Maybe<Scalars['String']['output']>;
    /** Signed Google Street View metadata url */
    googleStreetViewMetadataSignedUrl?: Maybe<Scalars['String']['output']>;
    /** Indicates whether the property has an approved third party virtual tour url */
    hasApprovedThirdPartyVirtualTourUrl?: Maybe<Scalars['Boolean']['output']>;
    /** Does the property have bad geographical coordinates */
    hasBadGeocode?: Maybe<Scalars['Boolean']['output']>;
    /** Whether or not the listing has the owner's email address. */
    hasOwnerEmailAddress?: Maybe<Scalars['Boolean']['output']>;
    /** Whether or not there's an active promotion for this property */
    hasPromotion?: Maybe<Scalars['Boolean']['output']>;
    /**
     * True if the property has a public video
     * @deprecated Feature has been deprecated. Fields will be removed once clients remove their dependencies.
     */
    hasPublicVideo?: Maybe<Scalars['Boolean']['output']>;
    hasVRModel?: Maybe<Scalars['Boolean']['output']>;
    /** if home has verified owner, used instead of ownerAccount when possible */
    hasVerifiedClaimOwner?: Maybe<Scalars['Boolean']['output']>;
    hdpTypeDimension?: Maybe<Scalars['String']['output']>;
    /** url to this property's HDP */
    hdpUrl?: Maybe<Scalars['String']['output']>;
    hiResImageLink?: Maybe<Scalars['String']['output']>;
    /** Do we hide the Zestimate market analysis */
    hideZMA?: Maybe<Scalars['Boolean']['output']>;
    /** Whether to hide zestimate */
    hideZestimate?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Highlights of a property posted by a touring agent
     * @deprecated highlights data is not available anymore.
     */
    highlights?: Maybe<HomeTourHighlights>;
    /** hoa fees, in dollars */
    hoaFee?: Maybe<Scalars['Int']['output']>;
    /** frequency of hoa fee value */
    hoaFeeFrequency?: Maybe<Scalars['String']['output']>;
    homeDescriptionExcerpt?: Maybe<Scalars['String']['output']>;
    /**
     * Home Facts for the facts+features sections
     * @deprecated Use resoFacts instead. HFF /facts call uses a legacy POGO query.
     */
    homeFacts?: Maybe<HomeFactsType>;
    /**
     * List of comparison between Zillow compiled Home facts and County Data
     * @deprecated HomeFactsComparisonData will not be PRExited
     */
    homeFactsComparisonData?: Maybe<HomeFactsComparisonData>;
    /** List of home highlight features */
    homeInsights?: Maybe<Array<Maybe<homeInsights>>>;
    /**
     * Deprecated - Home owner valuation data for property
     * @deprecated Deprecated with ZO wind down
     */
    homeOwnerValuation?: Maybe<HomeOwnerValuation>;
    /**
     * Recommended homes for logged in and anonymous users, contextualized on a given property
     * @deprecated Deprecated in favour of the collections API. For new homeRecommendations cases see https://zillowgroup.atlassian.net/wiki/spaces/AT/pages/269942836/Onboarding+a+Consumer+to+the+Collections+API
     */
    homeRecommendations?: Maybe<HomeRecommendation>;
    homeStatus?: Maybe<HomeStatus>;
    /** TODO */
    homeStatusForHDP?: Maybe<Scalars['String']['output']>;
    /**
     * A list of tags for a home. The tags come from AI team data.
     * @deprecated Home tags data is not available anymore.
     */
    homeTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    homeType?: Maybe<HomeType>;
    /** Home valuation data for property */
    homeValuation?: Maybe<HomeValuation>;
    /** A list of home value time series */
    homeValueChartData?: Maybe<Array<Maybe<HomeValueDataSeries>>>;
    homeValues?: Maybe<HomeValuesResponse>;
    /** Search page URL and description for houses for rent in the zipcode */
    housesForRentInZipcodeSearchUrl?: Maybe<UrlObjectType>;
    /** Stores Housing Voucher eligibility and Local Content information */
    housingVoucher?: Maybe<HousingVoucher>;
    /** The ID of an object */
    id: Scalars['ID']['output'];
    imageLink?: Maybe<Scalars['String']['output']>;
    /** Url for the property's interactive floor plan */
    interactiveFloorPlanUrl?: Maybe<Scalars['String']['output']>;
    /** The type of the latest Instant Offer related transaction */
    ioTransactionType?: Maybe<Scalars['String']['output']>;
    /** Whether this property is a camo property (a duplicate of a foreclosure home whose location is the nearest intersection) */
    isCamo?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Does this property belong to Canada
     * @deprecated We are expecting country code to be included in pogo. Use country instead.
     */
    isCanadian?: Maybe<Scalars['Boolean']['output']>;
    /**
     * True if a property is part of the Housing Connector project
     * @deprecated Use isHousingConnector instead
     */
    isCommunityPillar?: Maybe<Scalars['Boolean']['output']>;
    /**
     * The owner told us which home is theirs, but they have not taken the steps to become a "Verified Owner".
     * For most situations, this is the best type of claim to require since it requires no additional input.
     * This type of claim helps us treat the user as the owner of the homes for view customization.
     * For example: confirmed claim owners are shown the Owner Dashboard instead of the public view of the HDP.
     * This type of claim does not allow the user to edit any data.
     */
    isConfirmedClaimedByCurrentSignedInUser?: Maybe<Scalars['Boolean']['output']>;
    /**
     * True when the logged in user's account is the owner of the listing. False if
     * the user is not logged in or is not the owner of the listing.
     */
    isCurrentSignedInAgentResponsible?: Maybe<Scalars['Boolean']['output']>;
    isCurrentSignedInUserVerifiedOwner?: Maybe<Scalars['Boolean']['output']>;
    /** Is this a featured property */
    isFeatured?: Maybe<Scalars['Boolean']['output']>;
    /** True if a property is part of the Housing Connector project */
    isHousingConnector?: Maybe<Scalars['Boolean']['output']>;
    /** True if a property is exclusive to the Housing Connector program */
    isHousingConnectorExclusive?: Maybe<Scalars['Boolean']['output']>;
    /**
     * True if this property is in an active ZO markets
     * @deprecated Deprecated with ZO wind down
     */
    isInZOActiveMarkets?: Maybe<Scalars['Boolean']['output']>;
    /** True if a property has income restrictions */
    isIncomeRestricted?: Maybe<Scalars['Boolean']['output']>;
    /**
     * True if this property is eligible for Zillow Offers (deprecated: return false always)
     * @deprecated Superseded by zoAvailability
     */
    isInstantOfferEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** is listing created by owner */
    isListedByOwner?: Maybe<Scalars['Boolean']['output']>;
    isListingClaimedByCurrentSignedInUser?: Maybe<Scalars['Boolean']['output']>;
    isListingOwnedByCurrentSignedInUser?: Maybe<Scalars['Boolean']['output']>;
    /** Indicates whether the newly constructed property is featured in listings. */
    isNewConFeatured?: Maybe<Scalars['Boolean']['output']>;
    /** is this property not owner occupied */
    isNonOwnerOccupied?: Maybe<Scalars['Boolean']['output']>;
    isPaidMultiFamilyBrokerId?: Maybe<Scalars['Boolean']['output']>;
    isPaidSingleFamilyBrokerId?: Maybe<Scalars['Boolean']['output']>;
    /** Whether the property has undergone a non-retail auction */
    isPreforeclosureAuction?: Maybe<Scalars['Boolean']['output']>;
    /** Is this a premier builder's listing */
    isPremierBuilder?: Maybe<Scalars['Boolean']['output']>;
    /** true if the listing status has changed in the past 14 days */
    isRecentStatusChange?: Maybe<Scalars['Boolean']['output']>;
    isRentalListingOffMarket?: Maybe<Scalars['Boolean']['output']>;
    /** Indicates if the rentals lead cap for the lotId has been met (from Pogo) */
    isRentalsLeadCapMet?: Maybe<Scalars['Boolean']['output']>;
    isSavedByCurrentSignedInUser?: Maybe<Scalars['Boolean']['output']>;
    isSelectedAsComp?: Maybe<Scalars['Boolean']['output']>;
    /**
     * true when an agent has chosen this listing to be Showcased HDP with Listing
     * Media Services photos and other enhanced media. Implies that media is ready
     * for consumption.
     */
    isShowcaseListing?: Maybe<Scalars['Boolean']['output']>;
    isUndisclosedAddress?: Maybe<Scalars['Boolean']['output']>;
    /** TODO */
    isUnmappable?: Maybe<Scalars['Boolean']['output']>;
    /**
     * The owner had taken extra steps to verify their identity.
     * This type of claim allows the user to edit home facts, edit posting, upload photos, etc
     */
    isVerifiedClaimedByCurrentSignedInUser?: Maybe<Scalars['Boolean']['output']>;
    /** Is this property owned by Zillow */
    isZillowOwned?: Maybe<Scalars['Boolean']['output']>;
    keystoneHomeStatus?: Maybe<Scalars['String']['output']>;
    /** Price at which the property was last sold */
    lastSoldPrice?: Maybe<Scalars['Int']['output']>;
    /** Positive latitude is above the equator (N), and negative latitude is below the equator (S). */
    latitude?: Maybe<Scalars['Float']['output']>;
    /** A url to view this property in the internal LFA tool */
    lfaViewPropertyPageUrl?: Maybe<Scalars['String']['output']>;
    /** The lower price used for Value Range Pricing. The List Price must be greater than or equal to the ListPriceLow. */
    listPriceLow?: Maybe<Scalars['Int']['output']>;
    /** display mls related data in listedBy module */
    listedBy?: Maybe<Array<Maybe<ListedBySection>>>;
    listingAccount?: Maybe<ListingAccountType>;
    /** zuid of the listing account */
    listingAccountUserId?: Maybe<Scalars['String']['output']>;
    /** The options associated with the property entry to control its usage */
    listingCollectionConfig?: Maybe<ListingDisplayOptions>;
    /** Listing criteria for LC module on HDP */
    listingCriteria?: Maybe<ListingCriteria>;
    /** Source of listing data (e.g. Phoenix, Legacy) */
    listingDataSource?: Maybe<Scalars['String']['output']>;
    listingFeedID?: Maybe<Scalars['Int']['output']>;
    listingMetadata?: Maybe<listingMetadata>;
    /** The IDs of the configurations of the listing owner on this property. Admin-only */
    listingOwnerConfigIDs?: Maybe<Scalars['String']['output']>;
    listingOwnerReputation?: Maybe<ListingOwnerReputation>;
    /** Information about the listing provider of this property */
    listingProvider?: Maybe<ListingProvider>;
    /** Source of the listing. Admin-only */
    listingSource?: Maybe<Scalars['String']['output']>;
    /** last date that the listing status was changed */
    listingStatusChangeDate?: Maybe<Scalars['DateTime']['output']>;
    listingTypeDimension?: Maybe<Scalars['String']['output']>;
    listing_sub_type?: Maybe<ListingSubtype>;
    /**
     * Number of square feet in the property
     * @deprecated Use Property.livingAreaValue and Property.livingAreaUnits
     */
    livingArea?: Maybe<Scalars['Int']['output']>;
    /** Living area unit of measurement (ex "Square Feet") */
    livingAreaUnits?: Maybe<Scalars['String']['output']>;
    /** Living area unit of measurement short-name (ex "sqft") */
    livingAreaUnitsShort?: Maybe<Scalars['String']['output']>;
    /** Living area numerical value */
    livingAreaValue?: Maybe<Scalars['Float']['output']>;
    /** Local Protection Data For City, County, State */
    localProtections?: Maybe<localProtections>;
    /**
     * Positive longitude is east of the prime meridian, while negative longitude is
     * west of the prime meridian (a north-south line that runs through a point in England).
     */
    longitude?: Maybe<Scalars['Float']['output']>;
    /** Lot size unit of measurement (ex "Square Feet") */
    lotAreaUnits?: Maybe<Scalars['String']['output']>;
    /** Lot size numerical value */
    lotAreaValue?: Maybe<Scalars['Float']['output']>;
    /** Paid New Construction property friendly lot name, or null */
    lotName?: Maybe<Scalars['String']['output']>;
    /** Paid New Construction property lot number, or null */
    lotNumber?: Maybe<Scalars['String']['output']>;
    /** Cost of the lot or land associated with a posting on this property */
    lotPremium?: Maybe<Scalars['Int']['output']>;
    /**
     * lot area, in square feet
     * @deprecated Use Property.lotAreaValue and Property.lotAreaUnits
     */
    lotSize?: Maybe<Scalars['Int']['output']>;
    /** Malone property ID (from Pogo) */
    maloneId?: Maybe<Scalars['String']['output']>;
    /** Human-readable floorplan or builder plan name */
    marketingName?: Maybe<Scalars['String']['output']>;
    mediumImageLink?: Maybe<Scalars['String']['output']>;
    mlsid?: Maybe<Scalars['String']['output']>;
    /** monthly hoa fees, in dollars */
    monthlyHoaFee?: Maybe<Scalars['Int']['output']>;
    mortgageRates?: Maybe<MortgageRates>;
    mortgageZHLRates?: Maybe<MortgageZHLRates>;
    /** A relative url to edit the home location on map, available to admins only */
    moveHomeMapLocationLink?: Maybe<Scalars['String']['output']>;
    /** Date of construction completion */
    moveInCompletionDate?: Maybe<Scalars['DateTime']['output']>;
    /** Is this home ready for move-in */
    moveInReady?: Maybe<Scalars['Boolean']['output']>;
    /** List of rental building nearby the given zpid */
    nearbyBuildingLinks?: Maybe<Array<Maybe<NearbyBuildingLink>>>;
    /** List of nearby rental buildings */
    nearbyBuildings?: Maybe<Array<Maybe<BuildingCard>>>;
    /** Regions with a regionType of city that are geographically nearby the given zpid */
    nearbyCities?: Maybe<Array<Maybe<Region>>>;
    /** List of nearby homes in the neighborhood */
    nearbyHomes?: Maybe<Array<Maybe<Property>>>;
    /** Regions with a regionType of neighborhood that are geographically nearby the given zpid */
    nearbyNeighborhoods?: Maybe<Array<Maybe<Region>>>;
    /** List of nearby homes sales */
    nearbySales?: Maybe<Array<Maybe<Property>>>;
    /**
     * Information about nearby schools
     * @deprecated Provides identical results to `assignedSchools`. No usage in at least the last 3 months.
     */
    nearbySchools?: Maybe<Array<Maybe<School>>>;
    /** Regions with a regionType of zipcod that are geographically nearby the given zpid */
    nearbyZipcodes?: Maybe<Array<Maybe<Region>>>;
    /** Region ID for the neighborhood */
    neighborhoodId?: Maybe<Scalars['Int']['output']>;
    /** Region identified by neighborhoodId */
    neighborhoodRegion?: Maybe<Region>;
    /** search page url and text description to this property's neighborhood */
    neighborhoodSearchUrl?: Maybe<UrlObjectType>;
    /** Type of NC property. Possible values are based on home info object */
    newConstructionType?: Maybe<NewConstructionType>;
    nextSubmitFlowComponents?: Maybe<Array<Maybe<SubmitFlowComponent>>>;
    /** Total number of units included in the income property, occupied or unoccupied */
    numberOfUnitsTotal?: Maybe<Scalars['Float']['output']>;
    /**
     * Offer upsell data for a property, which includes standing offer data and
     * estimate offer data.If zpid is standingOffer eligible, we should show
     * StandingOffer upsell,else if zpid is estimate offer eligible, we should show
     * Estimate offer eligibleofferUpsellData and its subfields are nullable
     * @deprecated Deprecated with ZO wind down
     */
    offerUpsellData?: Maybe<OfferUpsellData>;
    onsiteMessage?: Maybe<OnsiteMessageResultType>;
    /** Open house hours for this property */
    openHouseHours?: Maybe<Scalars['String']['output']>;
    /** List of open houses for the property */
    openHouseSchedule?: Maybe<Array<Maybe<OpenHouse>>>;
    ouid?: Maybe<Scalars['String']['output']>;
    ownerAccount?: Maybe<OwnerAccountType>;
    pageUrlFragment?: Maybe<Scalars['String']['output']>;
    /** Number of page views this property has had */
    pageViewCount?: Maybe<Scalars['Int']['output']>;
    /** Number of times this property has been viewed each day, oldest to newest */
    pageViewCountsPerDay?: Maybe<Array<Maybe<PageViewCount>>>;
    pals?: Maybe<Array<Maybe<pals>>>;
    parcelId?: Maybe<Scalars['String']['output']>;
    /** Neighborhood if present, otherwise zipcode */
    parentRegion?: Maybe<Region>;
    /** @deprecated use userPersonalizedShoppingData instead */
    personalizedShoppingForUser?: Maybe<PersonalizedShoppingForUser>;
    photoCount?: Maybe<Scalars['Int']['output']>;
    /** Pictures of the property */
    photos?: Maybe<Array<Maybe<Photo>>>;
    /** The plan associated with a new-construction spec. */
    planForSpec?: Maybe<PlanForSpec>;
    /** Paid New Construction property plan number, or null */
    planNumber?: Maybe<Scalars['String']['output']>;
    postingContact?: Maybe<postingContact>;
    /** Posting presentation types. Admin-only */
    postingPresentationTypes?: Maybe<Array<PostingPresentationTypes>>;
    /** The type of posting product */
    postingProductType?: Maybe<PostingProductType>;
    /** The property's posting URL */
    postingUrl?: Maybe<Scalars['String']['output']>;
    /**
     * Price in USD. Magical catchall field, includes various business logic about
     * home type for displaying right number. TODO SearchContext
     */
    price?: Maybe<Scalars['Int']['output']>;
    /** A change in the listing price */
    priceChange?: Maybe<Scalars['Int']['output']>;
    /** A change in the listing price */
    priceChangeAmount?: Maybe<Scalars['Int']['output']>;
    /** When listing price changed */
    priceChangeDate?: Maybe<Scalars['DateTime']['output']>;
    /** When listing price changed (as date string) */
    priceChangeDateString?: Maybe<Scalars['String']['output']>;
    /** TODO */
    priceForHDP?: Maybe<Scalars['Int']['output']>;
    /** Price-relevant events in reverse chronological order */
    priceHistory?: Maybe<Array<PriceRecord>>;
    /** TODO */
    priceReduction?: Maybe<Scalars['String']['output']>;
    /**
     * The primary public video of the property
     * @deprecated Feature has been deprecated. Fields will be removed once clients remove their dependencies.
     */
    primaryPublicVideo?: Maybe<Video>;
    /** Description for this property's promotion */
    promotionDescription?: Maybe<Scalars['String']['output']>;
    /** Headline for this property's promotion */
    promotionHeadline?: Maybe<Scalars['String']['output']>;
    /** A relative url to view the logs for the property, available to admins only */
    propertyEventLogLink?: Maybe<Scalars['String']['output']>;
    /** The annual property tax rate of this property */
    propertyTaxRate?: Maybe<Scalars['Float']['output']>;
    /** Trace id indicating when the property was last updated in PDC, and what source it was updated by. */
    propertyTraceId?: Maybe<Scalars['String']['output']>;
    propertyTypeDimension?: Maybe<Scalars['String']['output']>;
    /** A relative url to update the property, available to admins only */
    propertyUpdatePageLink?: Maybe<Scalars['String']['output']>;
    /** Community-level ID for new construction listings */
    providerListingID?: Maybe<Scalars['String']['output']>;
    /** Specifies the type of the property. */
    pslHomeType?: Maybe<Scalars['String']['output']>;
    /** Showcases the manner in which the property is represented in marketing. */
    pslMarketingRepresentation?: Maybe<Scalars['String']['output']>;
    /** Current marketing status of the property. */
    pslMarketingStatus?: Maybe<Scalars['String']['output']>;
    /** The category of the provider supplying the property's listing data. */
    pslProviderCategory?: Maybe<Scalars['String']['output']>;
    /** Reflects the stage of public foreclosure for the property. */
    pslPublicForeclosureStage?: Maybe<Scalars['String']['output']>;
    /** The home status data as received directly from the data provider. */
    pslRawHomeStatus?: Maybe<Scalars['String']['output']>;
    /** The price data as received directly from the data provider. */
    rawPrice?: Maybe<Scalars['Int']['output']>;
    /** The URL string representation of the city region */
    regionString?: Maybe<Scalars['String']['output']>;
    /** zillow's estimate of property rental cost */
    rentZestimate?: Maybe<Scalars['Int']['output']>;
    /** Type of rentalApplicationAccepted */
    rentalApplicationsAcceptedType?: Maybe<RentalApplicationsAcceptedType>;
    /** UTC date and time when the rental property is available */
    rentalDateAvailable?: Maybe<Scalars['DateTime']['output']>;
    rentalListingOwnerContact?: Maybe<RentalListingOwnerContactType>;
    rentalListingOwnerReputation?: Maybe<RentalListingOwnerReputation>;
    /** Rental specific marketing treatments used to determine front end display logicsear */
    rentalMarketingTreatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    rentalPremiumPackages?: Maybe<Array<Maybe<RentalPremiumPackage>>>;
    /**
     * Premium rental refresh date
     * @deprecated Use Property.rentalRefreshTime to align with home info
     */
    rentalRankingTime?: Maybe<Scalars['DateTime']['output']>;
    /** Most recent date a unit in building was refreshed */
    rentalRefreshTime?: Maybe<Scalars['DateTime']['output']>;
    /** Detailed home facts in the Real Estate Standards Organization (RESO) form */
    resoFacts?: Maybe<RESOFacts>;
    /** high end of the restimate confidence interval */
    restimateHighPercent?: Maybe<Scalars['String']['output']>;
    /** lower end of the restimate confidence interval */
    restimateLowPercent?: Maybe<Scalars['String']['output']>;
    /** rent zestimate 30 days ago */
    restimateMinus30?: Maybe<Scalars['String']['output']>;
    restimatePercentile?: Maybe<Scalars['String']['output']>;
    /** Data used to render rich media virtual tours and floor plans */
    richMedia?: Maybe<richMedia>;
    /**
     * Data used to render rich media videos
     * @deprecated Feature has been deprecated. Fields will be removed once clients remove their dependencies.
     */
    richMediaVideos?: Maybe<richMediaVideos>;
    /** Room for rent details */
    roomForRent?: Maybe<RoomForRent>;
    /**
     * Room for rent details
     * @deprecated Use roomForRent instead
     */
    roomRentalDetails?: Maybe<RoomRentalDetails>;
    /** url to the schedule tour form for mobile */
    scheduleTourUrl?: Maybe<UrlObjectType>;
    /** All school ids assigned to a ZPID. First 3 ids are the closest elementary, middle, and high school, if available. */
    schoolIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    /** url and text description to search for schools in the property's city */
    schoolSearchUrl?: Maybe<UrlObjectType>;
    /**
     * returns assigned school information from the schools v6 endpoint
     * @deprecated Provides identical results to `assignedSchools`.
     */
    schools?: Maybe<Array<Maybe<School>>>;
    /** Adjusted screening criteria for properties participating in housing connector */
    screeningCriteria?: Maybe<ScreeningCriteria>;
    /** Number of seconds that the property has been on Zillow */
    secondsOnZillow?: Maybe<Scalars['Int']['output']>;
    /** Data used to render self tour availability and status */
    selfTour?: Maybe<selfTour>;
    /** Property Selling Soon Scores */
    sellingSoon?: Maybe<Array<Maybe<sellingSoonModel>>>;
    /** TODO */
    shouldHighlight?: Maybe<Scalars['Boolean']['output']>;
    /** True if property contains a description which may be out of date */
    showDescriptionDisclaimer?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** The ShowingTime tour availability for the interested property listing, specified for the requested start date and end date, and optional minimum lead time in minutes
     *
     * **Source:** showing-time-api
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** logged in
     */
    showingTimeTourAvailability?: Maybe<ShowingTimeTourAvailability>;
    /**
     * SolarPotential contains data that takes into account a buildings ability to utilize and save money using solar panals
     * @deprecated Detail pages don't use this data anymore and it has been removed from the backend tables as well
     */
    solarPotential?: Maybe<SolarPotential>;
    /** Paid New Construction property spec number, or null */
    specNumber?: Maybe<Scalars['String']['output']>;
    specialOffers?: Maybe<Array<Maybe<PropertySpecialOffer>>>;
    /** ssid */
    ssid?: Maybe<Scalars['Int']['output']>;
    /**
     * Standing offer data for property for V1 endpoint. The endpoint in GDP is deprecating
     * @deprecated Deprecated with ZO wind down
     */
    standingOffer?: Maybe<StandingOffer>;
    /** url to the Start An Offer form for mobile */
    startOfferUrl?: Maybe<UrlObjectType>;
    state?: Maybe<Scalars['String']['output']>;
    /** The state-specific disclaimer meant to be included in the VOW module */
    stateDisclaimerToBeAppendedToVOWDisclaimer?: Maybe<Scalars['String']['output']>;
    /** Region ID for the state */
    stateId?: Maybe<Scalars['Int']['output']>;
    /** search page url and text description to this property's state */
    stateSearchUrl?: Maybe<UrlObjectType>;
    /** Retrieve a static map of the requested property in a range of sizes */
    staticMap?: Maybe<StaticMap>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    /** Retrieve street views of the requested property, either based on latitude and longitude, or address, in a range of sizes */
    streetView?: Maybe<StreetView>;
    /**
     * Signed url for a Google street view image. Returns the image url directly,
     * rather than a url which can be used to get an image url from
     * street-view-url-service
     */
    streetViewImageUrl?: Maybe<Scalars['String']['output']>;
    /**
     * Signed Street-View-Url service url that a client can use to fetch Google
     * street view information with. Prefer streetViewImageUrl over this field
     */
    streetViewServiceUrl?: Maybe<Scalars['String']['output']>;
    /** Region identified by subdivisionId */
    subdivision?: Maybe<Region>;
    submitFlow?: Maybe<Array<Maybe<SubmitFlowComponent>>>;
    /**
     * SunScore is a value out of 100 that takes into account a buildings ability to utilize and save money using solar panals
     * @deprecated Replaced by solarPotential which contains all the data related to SunScore instead of single value
     */
    sunScore?: Maybe<Scalars['Float']['output']>;
    /** tax paid for the most recent tax year */
    taxAssessedPaid?: Maybe<Scalars['Float']['output']>;
    /** the property value in dollars, for tax purposes */
    taxAssessedValue?: Maybe<Scalars['Int']['output']>;
    /** the most recent year for tax assessment */
    taxAssessedYear?: Maybe<Scalars['Int']['output']>;
    /** Property tax records in reverse chronological order */
    taxHistory?: Maybe<Array<TaxRecord>>;
    /** Data used to render an approved third party virtual tours */
    thirdPartyVirtualTour?: Maybe<thirdPartyVirtualTour>;
    /**
     * The effective amount of time this listing has been present. Returns the time
     * this listing has been on zillow in either minutes, hours, or days.
     */
    timeOnZillow?: Maybe<Scalars['String']['output']>;
    /** IANA timezone string of this property (i.e. America/New_York) or null if lat/long is unavailable. */
    timeZone?: Maybe<Scalars['String']['output']>;
    /** links to be rendered in the global top nav, returned as JSON */
    topNavJson?: Maybe<Scalars['JSON']['output']>;
    /** links to be rendered in the global top nav, returned as markup */
    topNavMarkup?: Maybe<Scalars['JSON']['output']>;
    /** Eligibility for property tours */
    tourEligibility?: Maybe<tourEligibility>;
    /** @deprecated Use tourViews instead */
    tourView?: Maybe<TourView>;
    /** Number of times the 3D Home for this property has been viewed */
    tourViewCount?: Maybe<Scalars['Int']['output']>;
    tourViews?: Maybe<PropertyTourViews>;
    /** Information about public transit availability in the area */
    transitScore?: Maybe<TransitScoreResponse>;
    /** TODO */
    tvCollectionImageLink?: Maybe<Scalars['String']['output']>;
    /** TODO */
    tvHighResImageLink?: Maybe<Scalars['String']['output']>;
    /** TODO */
    tvImageLink?: Maybe<Scalars['String']['output']>;
    /**
     * The unassisted home showing information
     * @deprecated Deprecated with ZO wind down
     */
    unassistedShowing?: Maybe<UnassistedShowing>;
    /**  personalized shopping data for the signed-in user  */
    userPersonalizedShoppingData?: Maybe<UserPersonalizedShoppingData>;
    /** video id, return null if no video exists */
    videoId?: Maybe<Scalars['String']['output']>;
    /** Url for the property's virtual tour */
    virtualTourUrl?: Maybe<Scalars['String']['output']>;
    /** Data used to render a published 3D Home */
    vrModel?: Maybe<vrModel>;
    /** Information about the walkability of the area. */
    walkScore?: Maybe<WalkScoreResponse>;
    /** TODO */
    watchImageLink?: Maybe<Scalars['String']['output']>;
    whatILove?: Maybe<Scalars['String']['output']>;
    yearBuilt?: Maybe<Scalars['Int']['output']>;
    /** zillow's estimate of property value */
    zestimate?: Maybe<Scalars['Int']['output']>;
    zestimateDeepDiveData?: Maybe<zestimateDeepDiveData>;
    /** high end of the zestimate confidence interval */
    zestimateHighPercent?: Maybe<Scalars['String']['output']>;
    /** lower end of the zestimate confidence interval */
    zestimateLowPercent?: Maybe<Scalars['String']['output']>;
    /** zestimate value 30 days ago */
    zestimateMinus30?: Maybe<Scalars['String']['output']>;
    /** :shrug: */
    zestimatePercentile?: Maybe<Scalars['String']['output']>;
    /**
     * return geographic of Zillow Offer Market that ZO currently know of
     * @deprecated Deprecated with ZO wind down
     */
    zillowOfferMarket?: Maybe<ZillowOfferMarketType>;
    /** The 4-digit suffix to a base 5-digit zipcode */
    zipPlusFour?: Maybe<Scalars['String']['output']>;
    zipcode?: Maybe<Scalars['String']['output']>;
    /** Region ID for the zipcode */
    zipcodeId?: Maybe<Scalars['Int']['output']>;
    /** Region identified by zipcodeId */
    zipcodeRegion?: Maybe<Region>;
    /** search page url and text description to this property's zipcode */
    zipcodeSearchUrl?: Maybe<UrlObjectType>;
    /**
     * Upsell availability information for the property
     * @deprecated Deprecated with ZO wind down
     */
    zoAvailability?: Maybe<zoAvailability>;
    /**
     * ZO listing programs information for a property
     * @deprecated ZO wind down
     */
    zoListingPrograms?: Maybe<Array<Maybe<ZOListingPrograms>>>;
    zoMarketBasedABTests?: Maybe<ZoGuidBasedMarketABTestsType>;
    /**
     * return ZO market name, or called as availability group entity (buybox) for given zpid
     * @deprecated Deprecated with ZO wind down
     */
    zoMarketName?: Maybe<Scalars['String']['output']>;
    /**
     * Boolean to indicate if ZO Resale Start An Offer feature is enabled for the home
     * @deprecated ZO wind-down
     */
    zoResaleStartAnOfferEnabled?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Configurable static values for ZO Resale
     * @deprecated deprecating zo-hdp-statics repo as it is no longer used and is not necessary
     */
    zoStatics?: Maybe<zoStatics>;
    /**
     * Object that contains boolean flags for indicating which type of Zillow Offers upsell to be displayed for the property
     * @deprecated Prefer using zoUpsellDisplayInfo
     */
    zoUpsellDisplayFlags?: Maybe<zoUpsellDisplayFlags>;
    /** Object that contains information for controlling upsell display */
    zoUpsellDisplayInfo?: Maybe<zoUpsellDisplayInfo>;
    /** zillow property id */
    zpid?: Maybe<Scalars['Int']['output']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyaffordabilityEstimateArgs = {
    params?: InputMaybe<UserMortgagePreferences>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertycollectionsArgs = {
    building?: InputMaybe<BuildingCardMini>;
    cExperienceId: Scalars['String']['input'];
    contentTypes?: InputMaybe<Array<InputMaybe<CollectionContentType>>>;
    placements?: InputMaybe<Array<InputMaybe<ModulePlacement>>>;
    searchFilters?: InputMaybe<SearchFiltersInput>;
    shopperZuid?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertycompsArgs = {
    compType?: InputMaybe<Scalars['String']['input']>;
    count?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertycontactFormRenderDataArgs = {
    contactFormRenderParameter?: InputMaybe<ContactFormRenderParameter>;
    isDoubleScroll?: InputMaybe<Scalars['Boolean']['input']>;
    platform?: InputMaybe<ContactFormPlatform>;
    zpid?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertydownPaymentAssistanceProgramDetailsArgs = {
    feature_id?: InputMaybe<Scalars['Int']['input']>;
    sHouseholdSize?: InputMaybe<Scalars['String']['input']>;
    sIncome?: InputMaybe<Scalars['String']['input']>;
    sOccupation?: InputMaybe<Scalars['String']['input']>;
    sOwnership?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyfavoriteCountArgs = {
    since?: InputMaybe<Scalars['DateTime']['input']>;
    until?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyformattedChipArgs = {
    xConsumerUsername?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertygoogleStaticMapSignedUrlArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    height?: InputMaybe<Scalars['Int']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    scale?: InputMaybe<Scalars['Int']['input']>;
    type?: InputMaybe<GoogleStaticMapType>;
    width?: InputMaybe<Scalars['Int']['input']>;
    zoom?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertygoogleStreetViewImageSignedUrlArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    height?: InputMaybe<Scalars['Int']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    locationType?: InputMaybe<GoogleStreetviewLocationType>;
    width?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertygoogleStreetViewMetadataSignedUrlArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    locationType?: InputMaybe<GoogleStreetviewLocationType>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyhomeOwnerValuationArgs = {
    xConsumerUsername: Scalars['String']['input'];
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyhomeRecommendationsArgs = {
    clientName: Scalars['String']['input'];
    maxRecs?: InputMaybe<Scalars['Int']['input']>;
    placement: PlacementOption;
    queryType: QueryTypeOption;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyhomeValuationArgs = {
    xConsumerUsername: Scalars['String']['input'];
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyhomeValueChartDataArgs = {
    forecast?: InputMaybe<Scalars['Boolean']['input']>;
    forecastDuration?: InputMaybe<Scalars['Float']['input']>;
    metricType?: InputMaybe<HomeValueChartMetricType>;
    regionType?: InputMaybe<Array<InputMaybe<HomeValueChartRegionType>>>;
    timePeriod?: InputMaybe<HomeValueChartTimePeriod>;
    useNewChartAPI?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertymortgageRatesArgs = {
    params?: InputMaybe<UserMortgagePreferences>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertymortgageZHLRatesArgs = {
    params?: InputMaybe<UserMortgagePreferences>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertynearbyHomesArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertynextSubmitFlowComponentsArgs = {
    input: SubmitFlowInput;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyonsiteMessageArgs = {
    appVersion?: InputMaybe<Scalars['String']['input']>;
    placementData?: InputMaybe<PlacementData>;
    placementNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    platform?: InputMaybe<Scalars['String']['input']>;
    surfaceId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertypageViewCountArgs = {
    since?: InputMaybe<Scalars['DateTime']['input']>;
    until?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyphotosArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Scalars['Int']['input']>;
    size?: InputMaybe<PropertyPhotoSize>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyrichMediaArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyshowingTimeTourAvailabilityArgs = {
    endDate?: InputMaybe<Scalars['String']['input']>;
    minimumLeadTime?: InputMaybe<Scalars['Int']['input']>;
    startDate: Scalars['String']['input'];
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertystaticMapArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    shouldGetAdditionalHighResSources?: InputMaybe<Scalars['Boolean']['input']>;
    type?: InputMaybe<GoogleStaticMapType>;
    zoom?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertystreetViewArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertystreetViewImageUrlArgs = {
    cacheOnly?: InputMaybe<Scalars['Boolean']['input']>;
    featureArea?: InputMaybe<Scalars['String']['input']>;
    height?: InputMaybe<Scalars['Int']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    width?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertystreetViewServiceUrlArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    height?: InputMaybe<Scalars['Int']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    width?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertysubmitFlowArgs = {
    formType?: InputMaybe<FormType>;
    platform?: InputMaybe<ContactFormPlatform>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertytourEligibilityArgs = {
    platform?: InputMaybe<PropertyTourPlatform>;
    supportedTourTypes?: InputMaybe<Array<InputMaybe<PropertyTourAvailabilityType>>>;
    useAsyncAb?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertytourViewArgs = {
    id: TourViewId;
    input?: InputMaybe<TourViewInput>;
    platform?: InputMaybe<TourViewPlatform>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertytourViewCountArgs = {
    since?: InputMaybe<Scalars['DateTime']['input']>;
    until?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertytourViewsArgs = {
    platform: TourViewPlatform;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyzoAvailabilityArgs = {
    checkLevel?: InputMaybe<Scalars['Int']['input']>;
    criteriaCheckType?: InputMaybe<ZOAvailabilityCriteriaCheckType>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyzoStaticsArgs = {
    key?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type PropertyzoUpsellDisplayInfoArgs = {
    checkLevel?: InputMaybe<Scalars['Int']['input']>;
    placementId?: InputMaybe<Scalars['String']['input']>;
    surfaceId?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyActivity = Activity & {
    /** if available, the activity/event id */
    activityId?: Maybe<Scalars['ID']['output']>;
    /** if available, the activity time as epoch milliseconds */
    activityTime?: Maybe<Scalars['GraphQLLong']['output']>;
    /** the activity type */
    activityType: ActivityType;
    /** the user id associated with this activity */
    associatedId: IdBasedWithSource;
    /** source of the activity/event */
    source: Scalars['String']['output'];
    /** the related zgProperty */
    zgProperty: ZGProperty;
};

export type PropertyAddress = {
    city?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
};

export type PropertyAttributes = {
    propertyInfo?: Maybe<PropertyInfo>;
    rentalBuildingInfo?: Maybe<RentalBuildingInfo>;
};

export type PropertyClaimReleaseReason =
    | 'AGENT_CLAIM_TAKEN_OVER_VAI_BROKER_FEED'
    | 'ASSOCIATED_AGENT_POSTING_REMOVED'
    | 'CLAIM_DISPUTE_LOSER'
    | 'CUSTOMER_SERVICE_RELEASED_MALICIOUS_USER'
    | 'MISTAKENLY_CLAIMED_BY_USER'
    | 'NOT_SPECIFIED'
    | 'OWNER_KICKED_OFF_AGENT'
    | 'PROPERTY_SALE'
    | 'USER_RELEASED';

export type PropertyClaimSourceType =
    | 'CMA_COMPARISON'
    | 'FEED_HDP'
    | 'HISTORIC_LISTING'
    | 'HMMHW_LP'
    | 'LANDLORD_CONVERSION_POPUP'
    | 'NOO_HDP_MODULE'
    | 'NOO_LOCKED_UI'
    | 'NOO_POPUP'
    | 'NOO_SUBSCRIBER'
    | 'ODASH_ADD_A_HOME'
    | 'ODASH_CLAIM_FLOW'
    | 'ODASH_CREATE_NAME_VERIFICATION'
    | 'ODASH_PREVIEW_TOOLS'
    | 'ODASH_PREVIEW_UPSELL'
    | 'ODASH_UPDATE_NAME_VERIFICATION'
    | 'OM_HDP_CLAIMS_UPSELL'
    | 'OM_HDP_CLAIMS_UPSELL_MODAL'
    | 'OM_HDP_MORE_MENU'
    | 'OM_HDP_TRACK_HOME_VALUE'
    | 'UNKNOWN'
    | 'YOUR_HOME_APP'
    | 'ZO_QUESTIONNAIRE'
    | 'ZRM_DRAFT_LISTING'
    | 'ZRM_HDP';

export type PropertyClaimType =
    | 'AGENT_REPRESENTATION'
    | 'BUILDER'
    | 'LANDLORD'
    | 'OWNERSHIP'
    | 'PROPERTY_MANAGER';

export type PropertyClaimVerificationMethod =
    | 'AFFIDAVIT'
    | 'AUTO_APPROVED'
    | 'CREDIT_CARD_AUTHORIZATION'
    | 'CUSTOMER_SERVICE'
    | 'NAME_AND_PHONE_NUMBER'
    | 'USER_SELECTS_FROM_NAME_LIST';

export type PropertyClassType =
    | 'Commercial'
    | 'Industrial'
    | 'Land'
    | 'Mixed'
    | 'Mobile'
    | 'MultiFamily'
    | 'Other'
    | 'OtherResidential'
    | 'Recreational'
    | 'SharedResidential'
    | 'SingleResidential'
    | 'Unknown';

export type PropertyComminglingCategory = 'rulesApplicable' | 'rulesNotApplicable' | 'unknown';

export type PropertyConditionFieldDataMap = {
    address?: Maybe<PropertyConditionFieldValue>;
    complete_by_date?: Maybe<PropertyConditionFieldValue>;
    is_colandlord_present?: Maybe<PropertyConditionFieldValue>;
    move_in_date?: Maybe<PropertyConditionFieldValue>;
};

export type PropertyConditionFieldValue = {
    display?: Maybe<Scalars['String']['output']>;
    field?: Maybe<Scalars['String']['output']>;
    fieldValue?: Maybe<Scalars['String']['output']>;
    propertyConditionId?: Maybe<Scalars['ID']['output']>;
};

export type PropertyContactFormRenderData = {
    /** This field is provided as JSON, passed through from and documented in adsdisplay. */
    data?: Maybe<Scalars['JSON']['output']>;
};

/** an item in the property details bag */
export type PropertyDetailItem = {
    facts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    title?: Maybe<Scalars['String']['output']>;
};

export type PropertyFetchingDetail = {
    /**
     * Error status message of individual record in zpids search.
     * Only possibly populated when status is not "OK". May contain a more
     * detailed description of the encountered error.
     */
    errorStatusMessage?: Maybe<Scalars['String']['output']>;
    /** Metadata. Ex, latestTraceId... */
    metadata?: Maybe<Metadata>;
    /**
     * Status of individual record in zpids search.
     * "OK" in success cases, otherwise will be indicative of failure type. For
     * example: "DATA_NOT_FOUND", "DATA_DELETED", "PALSID_NO_MATCH", or
     * "INTERNAL_EXCEPTION".
     */
    status?: Maybe<StatusType>;
};

export type PropertyIdType =
    /**  building id type  */
    | 'lotId'
    /**  property listing id type  */
    | 'plid'
    /**  property id type  */
    | 'zpid';

export type PropertyIdentification = {
    /**
     * palsId identifying specific listings which are being looked up.
     *
     * If present, the number of palsIds specified must match the number of
     * zpids specified. Only listings with IsDisplay
     * `true` in PDC will be retrieved unless `includeNonDisplayedResults` is
     * specified as `true`.
     *
     * If not present, BestRecord listings from PDC will be used to formulate
     * results.
     */
    palsId: Scalars['ID']['input'];
    /** Zpids identifying the properties which are being looked up. */
    zpid: Scalars['ID']['input'];
};

export type PropertyImplicitClaimType =
    | 'APP_AGENT'
    | 'APP_FAVORITE'
    | 'APP_LOCATION'
    | 'APP_TIME_OF_DAY'
    | 'BEST_TIME_TO_SELL'
    | 'HOME_REPORT'
    | 'RENTAL'
    | 'SELL_HOME_PAGE'
    | 'SUBMITTED_REVIEW'
    | 'SWEEPSTAKES';

export type PropertyInfo = {
    baths?: Maybe<Scalars['Float']['output']>;
    beds?: Maybe<Scalars['Int']['output']>;
    geoAttributes?: Maybe<GeoAttributes>;
    homeStatus?: Maybe<Scalars['String']['output']>;
    homeType?: Maybe<Scalars['String']['output']>;
    listingPrice?: Maybe<Scalars['Int']['output']>;
    listingStatus?: Maybe<Scalars['String']['output']>;
    listingType?: Maybe<Scalars['String']['output']>;
    neighborhoodId?: Maybe<Scalars['Int']['output']>;
    sqft?: Maybe<Scalars['Float']['output']>;
    zpid?: Maybe<Scalars['Int']['output']>;
};

export type PropertyLeadSubmitForm = {
    buttonText: Scalars['String']['output'];
    disclosure?: Maybe<Scalars['String']['output']>;
    /** @deprecated use inputFields instead */
    emailValidationRegex: Scalars['String']['output'];
    financingCheckbox?: Maybe<FinancingCheckbox>;
    heading?: Maybe<Scalars['String']['output']>;
    headingIcon?: Maybe<Scalars['String']['output']>;
    inputFields: Array<ContactFormInputTextField>;
    /** @deprecated use inputFields instead */
    messagePlaceholder: Scalars['String']['output'];
    /** @deprecated use inputFields instead */
    phoneValidationRegex: Scalars['String']['output'];
    subheading?: Maybe<Scalars['String']['output']>;
    telephoneConsumerProtectionActDisclaimer?: Maybe<TourViewModuleText>;
    title: Scalars['String']['output'];
};

export type PropertyLeadSubmitFormInput = {
    email: Scalars['String']['input'];
    financingType: FinancingCheckboxType;
    isFinancingTypeChecked: Scalars['Boolean']['input'];
    message?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyPhotoSize =
    | 'EMAIL'
    | 'HDTV'
    | 'L'
    | 'LOGO_80_40'
    | 'LOGO_95_35'
    | 'LOGO_120_50'
    | 'LOGO_LIST'
    | 'LOGO_PROFILE'
    | 'M'
    | 'MINI_CARD_PHOTO'
    | 'M_CENTERED'
    | 'PROFILE_60_60'
    | 'PROFILE_75_100'
    | 'PROFILE_120_120'
    | 'PROFILE_160_180'
    | 'PROFILE_180_120'
    | 'PROFILE_240_240'
    | 'PROFILE_320_360'
    | 'PROFILE_360_240'
    | 'PROFILE_LARGE_THUMBNAIL'
    | 'PROFILE_MEDIUM'
    | 'PROFILE_SMALL_THUMBNAIL'
    | 'PROFILE_TALL_MEDIUM'
    | 'PROFILE_THUMBNAIL'
    | 'PROFILE_WEE_THUMBNAIL'
    | 'PROVIDER_LOGO'
    | 'S'
    | 'THUMBNAIL'
    | 'THUMBNAIL_150'
    | 'THUMBNAIL_LG'
    | 'TV_COLLECTION'
    | 'TV_TILE'
    | 'WATCH'
    | 'XL'
    | 'XXL';

export type PropertyResult = {
    /** The address of the property broken down into parts */
    address?: Maybe<PSLAddress>;
    /** Ads information */
    ads?: Maybe<Ads>;
    /** Additional contact information for the agent who posted the listing */
    agent?: Maybe<Agent>;
    /**
     * MultiMap of treatments (as keys) to Links (as values) for all of the property photos
     * For a requested treatment {@code t1},{@code allPhotos.get(t1)} will obtain the list of links for
     * all of the federated photos built with that treatment.
     */
    allFirstPartyPhotos?: Maybe<PhotoAlbums>;
    /**
     * Stand for "Ad Products Premium Listing Engine Id"
     * A list of listing owner configs - used by adsdisplay powering the contact form
     */
    appleIds?: Maybe<Array<Scalars['ID']['output']>>;
    /**
     * The date the property will be available for possession/occupation without a time-zone in ISO-8601.
     * Example: 2019-07-03
     */
    availabilityDate?: Maybe<Scalars['LocalDate']['output']>;
    /** The number of bathrooms this property has */
    bathroomCount?: Maybe<Scalars['Float']['output']>;
    /** The number of bedrooms this property has */
    bedroomCount?: Maybe<Scalars['Int']['output']>;
    /**
     * Our best guess of the timezone for the property represented as a region zone id
     * e.g. "America/Los_Angeles"
     */
    bestGuessTimezone?: Maybe<Scalars['String']['output']>;
    /** Additional contact information for the brokerage */
    brokerage?: Maybe<PSLBrokerage>;
    /** The id of the building with which this property is associated */
    buildingId?: Maybe<Scalars['ID']['output']>;
    /** Additional information about coming soon properties */
    comingSoon?: Maybe<ComingSoon>;
    /** The country code for the country where the property is located */
    countryCode?: Maybe<PSLCountryCode>;
    /** The type of currency to use when displaying the price of the property */
    currencyType?: Maybe<CurrencyType>;
    /** How long the property was on zillow in days precision, rounded down */
    daysOnZillow?: Maybe<Scalars['Int']['output']>;
    /** A textual description of the property */
    description?: Maybe<Scalars['String']['output']>;
    /**
     * A flexible spot for derived or related data about a property
     * that doesn't fit into the more rigorously tracked information
     */
    enrichment?: Maybe<PSLEnrichment>;
    /** Home facts and features - this object is mainly for the lookup endpoint */
    factsAndFeatures?: Maybe<FactsAndFeatures>;
    /** HOA and non-HOA dues paid by homeowner or by tenant. For example Hoa, Deposit, Application, membership, etc. */
    feesAndDues?: Maybe<Array<PSLFee>>;
    /** The type of fixture */
    fixtureClassification?: Maybe<FixtureType>;
    /** The address formatted for standard display */
    formattedAddress?: Maybe<FormattedAddress>;
    /** Information about the location of the property */
    geoRegion?: Maybe<PSLGeoRegion>;
    /** Is the virtual tour from an approved provider */
    hasApprovedThirdPartyVirtualTourUrl?: Maybe<Scalars['Boolean']['output']>;
    /** Whether this property has an upcoming open house */
    hasOpenHouse?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Does this property have a virtual tour
     * This field will be false when CannotShowNonIDXMedia is applicable
     */
    hasVRModel?: Maybe<Scalars['Boolean']['output']>;
    /**
     * True if the property has at least one video associated with it.
     * This field will be false when CannotShowNonIDXMedia is applicable
     */
    hasVideos?: Maybe<Scalars['Boolean']['output']>;
    /** Url string for home details (used by apps) */
    hdpWebviewUrl?: Maybe<Scalars['String']['output']>;
    /** Information about the status of the home */
    homeStatus?: Maybe<PSLHomeStatus>;
    /** The type of the property */
    homeType?: Maybe<PSLHomeType>;
    /**
     * Listings where the listing agent is the only agent shown
     * on the contact form. The featuring process is also used for
     * New construction to show their builder contact forms. It is
     * also used for rentals to indicate paid rental inclusions.
     */
    isFeaturedListing?: Maybe<Scalars['Boolean']['output']>;
    /** Whether the listing came from a feed (versus being manually entered) */
    isFeedControlled?: Maybe<Scalars['Boolean']['output']>;
    /** Whether the owner is occupying the property */
    isOwnerOccupied?: Maybe<Scalars['Boolean']['output']>;
    /** Is this property a showcase listing. */
    isShowcaseListing?: Maybe<Scalars['Boolean']['output']>;
    /** The raw RESO listing snippet */
    listingRaw?: Maybe<Scalars['String']['output']>;
    /** The URL of where this property was posted */
    listingUrl?: Maybe<Scalars['String']['output']>;
    /** The total living area of this property for Lookup, will be nulled out if HideActualSqft is applicable */
    livingArea?: Maybe<SizeWithUnits>;
    /** The total living area of this property in Square Feet for Search, will be nulled out if HideActualSqft is applicable */
    livingAreaSquareFeet?: Maybe<Scalars['Int']['output']>;
    /** The total area of the lot on which this property is located for Lookup */
    lotArea?: Maybe<SizeWithUnits>;
    /** The highlight tag to be displayed on map dots */
    mapDotTag?: Maybe<HighlightTag>;
    /** An mls number for the property used to uniquely identify it */
    mlsId?: Maybe<Scalars['ID']['output']>;
    /** Monthly cost of the property given the factors provided in MonthlyCostFilter. */
    monthlyCost?: Maybe<Scalars['Int']['output']>;
    /** Additional information for new construction properties */
    newConstruction?: Maybe<NewConstruction>;
    /** Additional information for notification properties */
    notification?: Maybe<Notification>;
    /**
     * Free-form field for office hour information. Typically applies
     * to new construction and rentals for larger complexes. Also
     * known as freeformOpenHouse or postingOpenHouse.
     */
    officeHours?: Maybe<Scalars['String']['output']>;
    /**
     * The date time the listing was placed on market. Where possible, this date time is
     * reflective of the date time entered by the agent reflecting when the change
     * occurred contractually, is a date time of when the change was made in
     * the MLS.
     * It is in UTC in ISO-8601.
     * Example: 2019-07-03T20:47:55Z
     * Locale of the user's browser can be used to format this to the user's timezone.
     */
    onMarketTime?: Maybe<Scalars['DateTime']['output']>;
    /** The open house showings for this property */
    openHouses?: Maybe<Array<PSLOpenHouse>>;
    /** Additional contact information for the owner of the property */
    owner?: Maybe<Owner>;
    /** Count of all the property photos */
    photoCount?: Maybe<Scalars['Int']['output']>;
    /** Information about the price of the property */
    price?: Maybe<Price>;
    /** Image treatments for the primary (AKA first) photo of the property. */
    primaryPhoto?: Maybe<PhotoAlbums>;
    /** Property fetching detail including status, errorMessage, latestTraceId, etc... */
    propertyFetchingDetail?: Maybe<PropertyFetchingDetail>;
    /** A name given to apartment or similar types of buildings */
    propertyName?: Maybe<Scalars['String']['output']>;
    /** Additional display rules relevant to this property */
    propertyResultRules?: Maybe<PropertyResultRules>;
    /** Upstream providers tag the provider category for downstream aggregators to determine the best record */
    providerCategory?: Maybe<ProviderCategory>;
    /**
     * This field can mean different things based on the home status.
     * In the context of New Construction, a promoted community is
     * a community that paid to be listed on zillow websites.
     * providerListingId is the unique identifier for these paid communities.
     * In the context of rentals, it is the id of the account that paid
     * for this property to be listed on Zillow websites.
     */
    providerListingId?: Maybe<Scalars['ID']['output']>;
    /** Public record foreclosure info for this property */
    publicForeclosure?: Maybe<Foreclosure>;
    /** Additional information for recommended homes */
    recommendation?: Maybe<PSLRecommendation>;
    /** Additional information about rental properties */
    rental?: Maybe<PSLRental>;
    /** How long the property was on Zillow in seconds precision */
    secondsOnZillow?: Maybe<Scalars['Long']['output']>;
    /** The Search Setup ID which this property data is attributed to. */
    ssid?: Maybe<Scalars['ID']['output']>;
    /**
     * The date time on which this listing last changed status
     * It is in UTC in ISO-8601.
     * Example: 2019-07-03T20:47:55Z
     * Locale of the user's browser can be used to format this to the user's timezone.
     */
    statusChangeTime?: Maybe<Scalars['DateTime']['output']>;
    /** The number of stories (floors) in this property */
    storyCount?: Maybe<Scalars['Float']['output']>;
    /**
     * The tax assessment records for the property
     * This field will be null when HideTaxHistory is applicable
     */
    taxAssessments?: Maybe<Array<PSLTaxAssessment>>;
    /**
     * Links to 3rd party photos for this property. These are typically used for display as a fallback
     * when the property does not have other photos.
     * This field will be null when HideNonMLSPhotosForListing is applicable
     */
    thirdPartyPhotos?: Maybe<ThirdPartyPhotoLinks>;
    /** The name that we should use when displaying the property */
    title?: Maybe<Scalars['String']['output']>;
    /**
     * The number of units that are part of the structure
     * associated with this property
     */
    unitCount?: Maybe<Scalars['Int']['output']>;
    /** A link to the virtual tour */
    virtualTourUrl?: Maybe<Scalars['String']['output']>;
    /** The year this property was build */
    yearBuilt?: Maybe<Scalars['Int']['output']>;
    /** The year that this property has last been remodeled/updated */
    yearUpdated?: Maybe<Scalars['Int']['output']>;
    /**
     * The raw RESO listing provided for the canonical schema.
     * Several fields within the ZillowResoListing object will be hidden if the DoNotDisplayFields rule is applicable.
     * The fields to be hidden are defined by the Rule service's metadata API.
     * Example: https://phoenix-rules-api.staging.oc.zillowgroup.net/metadata
     */
    zillowResoListing?: Maybe<ZillowResoListing>;
    /**  primary key of PropertyResult. source: property-search-lookup   */
    zpid: Scalars['ID']['output'];
};

export type PropertyResultallFirstPartyPhotosArgs = {
    fallbackPhotoStrategy?: InputMaybe<FallbackPhotoStrategy>;
    includePhotoKeys?: InputMaybe<Scalars['Boolean']['input']>;
    photoTreatments: Array<PhotoTreatmentRequest>;
};

export type PropertyResulthdpWebviewUrlArgs = {
    device: DevicePlatform;
    showFactsAndFeatures?: InputMaybe<Scalars['Boolean']['input']>;
    showGoogleMaps?: InputMaybe<Scalars['Boolean']['input']>;
    showStreetView?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyResultnotificationArgs = {
    encodedSeid?: InputMaybe<Scalars['String']['input']>;
    enrollmentId?: InputMaybe<Scalars['ID']['input']>;
    markReadDelayMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type PropertyResultprimaryPhotoArgs = {
    fallbackPhotoStrategy?: InputMaybe<FallbackPhotoStrategy>;
    photoTreatments: Array<PhotoTreatmentRequest>;
};

export type PropertyResultRules = {
    /**
     * Whether ads are restricted on the page.
     * This is true if AdRestrictionsInPlace rule is applicable to
     * the SSID of this property, please refer to rules.isAdsRestricted
     * for page ads display restriction
     */
    adsRestrictedForProperty?: Maybe<Scalars['Boolean']['output']>;
    /**
     * The agent name that list the property.  The value will be populated only if the property has the
     * "Display List Agent Name On List Card" rule requiring it be displayed on the list card.
     * This field will have license appended if AppendAgentLicenseToAgentName is applicable
     */
    agentNameIfRequired?: Maybe<Scalars['String']['output']>;
    /**
     * The phone number of the agent.  The value will be populated only if the property has the
     * "Display List Agent Phone Number On List Card" rule requiring it be displayed on the list card, and
     * "Display List Agent Name On List Card" allows Agent Name to be displayed, and Agent Name is not null.
     */
    agentPhoneIfRequired?: Maybe<Phone>;
    /**
     * The list office name that list the property.  The value will be populated only if the property has the
     * "Display Broker Name On List Card" rule requiring it be displayed on the list card.
     */
    brokerNameIfRequired?: Maybe<Scalars['String']['output']>;
    /**
     * The phone number of the list office.  The value will be populated only if the property has the
     * "Display Broker Phone Number On List Card" rule requiring it be displayed on the list card.
     */
    brokerPhoneIfRequired?: Maybe<Phone>;
    /** The builder name required to display on the list card */
    builderNameIfRequired?: Maybe<Scalars['String']['output']>;
    /** Whether we are permitted to display the address of this property */
    canShowAddress?: Maybe<Scalars['Boolean']['output']>;
    /** Whether we are permitted to display price estimate */
    canShowAutomatedValuationDisplay?: Maybe<Scalars['Boolean']['output']>;
    /** Whether we are permitted to display cropped photos for this property */
    canShowCroppedPhotos?: Maybe<Scalars['Boolean']['output']>;
    /** Whether we are permitted to show non idx media */
    canShowNonIDXMedia?: Maybe<Scalars['Boolean']['output']>;
    /** Whether we are permitted to display this property on the map */
    canShowOnMap?: Maybe<Scalars['Boolean']['output']>;
    /**
     * The commingling category of the property.  Each property has a commingling category of either rulesApplicable or
     * rulesNotApplicable/  The purpose of the the flag is to identify how the listing can be displayed with other listings.
     *
     * All listings marked as rulesApplicable can be displayed together (ie on tab 1).  Listings marked as rulesNotApplicable can
     * be displayed together (ie tab 2) but cannot be displayed on tab 1.
     */
    comminglingCategory?: Maybe<ListingComminglingCategory>;
    /**
     * The agent name that list the property.  The value will be populated only if the property has the
     * "Display List Agent Name On List Card" rule requiring it be displayed on the list card.
     * This field will NOT have license appended even if AppendAgentLicenseToAgentName is applicable, for apps only
     */
    justAgentNameIfRequired?: Maybe<Scalars['String']['output']>;
    /** The attributions required to displayed on the map marker card */
    mapCardAttribution?: Maybe<PSLMapCardAttribution>;
    /**
     * The MLS ID for the property used to uniquely identify it.  The value will be populated only if the property has
     * the "Display MLS ID On List Card" rule requiring it be displayed on the list card.
     */
    mlsIdIfRequired?: Maybe<Scalars['ID']['output']>;
    /**
     * The MLS name.  The value will be populated only if the property has the
     * "Display List MLS Name On List Card" rule requiring it be displayed on the list card.
     */
    mlsNameIfRequired?: Maybe<Scalars['String']['output']>;
    /**
     * The MLS status for the property.  The value will be populated only if the property has the
     * "Display MLS Status" rule requiring it be displayed.
     */
    mlsStatusIfRequired?: Maybe<Scalars['String']['output']>;
    /** Whether we must display lot size in acres */
    mustDisplayLotSizeInAcres?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Map of treatments (as keys) to PhotoLink (as values) for the logo of the provider of the property. The value will
     * only be populated if the property has the "Display Logo On List Card" rule requiring it be displayed on the list card.
     */
    providerLogoIfRequired?: Maybe<Array<PhotoAlbum>>;
    /**
     * The list office name that was associated with the recent sale of this
     * property.  The value will be populated only if the property has the
     * "Display Sold By Office Name On List Card" rule requiring it be
     * displayed on the list card.
     */
    soldByOfficeNameIfRequired?: Maybe<Scalars['String']['output']>;
};

export type PropertyResultRulesproviderLogoIfRequiredArgs = {
    photoTreatments: Array<PhotoTreatment>;
};

export type PropertyResultRulesPhone = {
    extension?: Maybe<Scalars['String']['output']>;
    number?: Maybe<Scalars['String']['output']>;
};

export type PropertySearchRequest = {
    /**
     * Only include properties with one of the given basement
     * statuses in the results
     */
    basementStatuses?: InputMaybe<Array<PSLBasementStatusType>>;
    /**
     * Only include properties with a number of bathrooms
     * within this range
     */
    bathrooms?: InputMaybe<MinMaxFloat>;
    /**
     * Only include properties with a number of bedrooms
     * within this range
     */
    bedrooms?: InputMaybe<MinMaxInteger>;
    /**
     * Only include properties that have a latitude
     * and longitude that fall within this bounding box
     */
    boundingBox: BoundingBox;
    /**
     * Only include properties that have been on zillow
     * for a number of days within this range
     */
    daysOnZillow?: InputMaybe<MinMaxInteger>;
    /**
     * Enable debug mode to help debug and evaluate rules related change
     * 1. Can enable log mode to log the rules response from rules api
     *      and the rules applicable information for each ssid the results from
     * 2. Can enable mock rule mode to override the rules behavior for the whole results
     */
    debugRequest?: InputMaybe<DebugRequest>;
    /**
     * Do not include properties that fall within any of the
     * given categories.
     * The complex exclude types
     * pendingContingentUnderContractUnlessAcceptingBackupOffers and
     * acceptingBackupOffersUnlessPendingContingentUnderContract cannot both
     * be specified in the same request, nor can either of them be included in
     * the same request as the following relevant `ExcludeType` values:
     * `pending`, `contingent`, `underContract`, or `acceptingBackupOffers`.
     */
    exclude?: InputMaybe<Array<PSLExcludeType>>;
    /** Do not include properties that have lotIds that are in the given set */
    excludedLotIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    /** Do not include properties that have zpids that are in the given set */
    excludedZpids?: InputMaybe<Array<Scalars['ID']['input']>>;
    /**
     * If set, filter the hidden properties for the signedIn user
     * Currently, it only supports zpids
     * NOTE: When zuid is missing, the value of the flag will be ignored
     * The flag won't be applied to the offmarket results added for supplementResultsWithOffMarket
     */
    filterHiddenHomes?: InputMaybe<Scalars['Boolean']['input']>;
    /** Whether and how similar results should be grouped together. */
    groupBy?: InputMaybe<GroupingStrategy>;
    /**
     * Only include properties with a monthly HOA fee within
     * this range
     */
    hoaFeesPerMonth?: InputMaybe<MinMaxInteger>;
    /**
     * Only include properties with one of the given home statuses in the
     * results. Please note that if the `newConstruction`, `auction`, or
     * `foreclosure` values are omitted while at least one "For Sale" home
     * status is explicitly included then results flagged with these types
     * will be explicitly excluded (even if they are also flagged with another
     * type that is included like `fsba`)
     * Note that homeStatus.zestimate is not allowed
     */
    homeStatuses: Array<InputMaybe<HomeStatusType>>;
    /**
     * Only include properties with one of the given
     * home types in the results
     */
    homeTypes?: InputMaybe<Array<PSLHomeType>>;
    /**
     * If set, tab1(agent) and tab2(other) counts will be returned by
     * resultCounts.agentListingsCount and resultCounts.otherListingsCount
     */
    includeCountsByRulesApplicable?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * Only include properties that have text matching the
     * provided keywords
     */
    keywords?: InputMaybe<Scalars['String']['input']>;
    /**
     * Return only listings that are affiliated with the agent(s)
     * identified by the information in this object
     */
    listingAgentInfoRequest?: InputMaybe<ListingAgentInfoRequest>;
    /**
     * Only include properties with a living area within this
     * range in square feet
     */
    livingAreaSqft?: InputMaybe<MinMaxInteger>;
    /** Includes listings that have the given lotIds. */
    lotIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    /**
     * Includes listings that have the given lotIds.
     * When both boundingBox and lotIdsConditionallyORWithBoundingBox are provided, the search uses two filters with an OR condition.
     * This is to achieve the effect of searching for properties with a lotId OR within a small rectangular area. Only works on ZGSearch path
     */
    lotIdsConditionallyORWithBoundingBox?: InputMaybe<Array<Scalars['ID']['input']>>;
    /**
     * The range of lot area in square feet for properties
     * within the search
     */
    lotSizeSqft?: InputMaybe<MinMaxInteger>;
    /**
     * Calculate monthly payment for properties based on user
     * inputs such as interestRate, downPaymentAmount, etc
     * Only include properties within your affordable range.
     * monthlyCostFilters does not apply to rental search
     */
    monthlyCostFilter?: InputMaybe<MonthlyCostFilter>;
    /**
     * Only include properties with a monthly payment
     * within this range
     */
    monthlyPayment?: InputMaybe<MinMaxInteger>;
    /** The page number to show. */
    pageNumber: Scalars['Int']['input'];
    /** The page size for the request */
    pageSize: Scalars['Int']['input'];
    /**
     * Only include properties with a number of parking
     * spots within this range
     */
    parkingSpots?: InputMaybe<MinMaxInteger>;
    /**
     * A/B test trial to treatment map for trials related
     * to personalized sort. This is required if asking
     * for the personalized or personalized2 sort types
     */
    personalizedSortABAssignments?: InputMaybe<Array<ABAssignment>>;
    /**
     * Only include properties with all of the following pet
     * restrictions in the results
     */
    petsRestrictions?: InputMaybe<Array<PetsAllowedType>>;
    /** Only include properties within this price range */
    price?: InputMaybe<MinMaxInteger>;
    /** Only return results with the given providerListingId */
    providerListingId?: InputMaybe<Scalars['ID']['input']>;
    /** Only include properties that fall within one or more of these provided regions. */
    regions?: InputMaybe<Array<PSLRegion>>;
    /**
     * Only multiFamilySalesListing supported for now
     * It represents rental paid multi family listings
     */
    rentalAvailabilityDate?: InputMaybe<RentalAvailabilityDate>;
    /**
     * Only multiFamilySalesListing supported for now
     * It represents rental paid multi family listings
     */
    rentalMarketingTreatments?: InputMaybe<Array<MarketingTreatment>>;
    /**
     * RulesRequest parameters control how rules should be applied to the results, including filtering on the
     * commingling category, which identifies listings as displayable on tab 1 (agent listings) or tab 2 (other listings)
     * the parameter is required.
     */
    rulesRequest: RulesRequest;
    /**
     * Only return results within these school district zones
     * for now, only 1 school district id is supported
     * either the district Id or the schoolId can be passed at a time.
     */
    schoolDistrictIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    /**
     * Only return results within these school zones
     * either schoolIds or schooldDistrictIds must be specified at a time
     */
    schoolIds?: InputMaybe<Array<Scalars['ID']['input']>>;
    /**
     * Only include properties that fall within all of the given categories
     * ShowOnlyType.tourItNow: Not all openhouses/zo homes are TIN, so we are kind of lying in the short term with the name
     */
    showOnly?: InputMaybe<Array<PSLShowOnlyType>>;
    /**
     * If set to true, sort the results in ascending order,
     * otherwise sort them in descending order
     */
    sortAscending?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * The sorting strategy to use when sorting the results.
     * See <a href="#sorting">sorting</a> for more details. Please note that the
     * `personalized` and `personalized2` values are not supported by the PSL
     * batch cluster. `rentSaleSoldOffMarket` and `saleSoldRentOffMarket` are only supported by
     * PSL all properties search endpoint.
     */
    sortSelection: SortOrderType;
    /**
     * Only include properties that have SSIDs that are in the given set
     * SSID stands for Search Setup ID and represents
     * the feed the property came from.
     */
    ssids?: InputMaybe<Array<Scalars['ID']['input']>>;
    /**
     * If we have fewer than pageSize
     * total results, populate the rest of the first page with off market
     * "zestimate" properties that fall within the searched geography
     */
    supplementResultsWithOffMarket?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * The location of the given user. Required if
     * using the nearby sort
     */
    userLocation?: InputMaybe<LatLonInput>;
    /** Information about the search query */
    userQueryInfo?: InputMaybe<SearchQueryInfo>;
    /**
     * Only include properties with one of the given
     * view types in the results
     */
    viewTypes?: InputMaybe<Array<PSLViewType>>;
    /**
     * Only include properties built within this range
     * of years
     */
    yearBuilt?: InputMaybe<MinMaxInteger>;
};

export type PropertySearchResponse = {
    /**
     * Only include properties that are within an acceptable commute
     * time from a destination
     */
    commutePolygon?: Maybe<Scalars['String']['output']>;
    /**
     * The ID retrieved from Realtime Recommendations (personalization) service which can be used for logging purposes.
     * Currently, the request trace ID is being used for logging the keystone and GA events.
     */
    personalizedResultLoggingId?: Maybe<Scalars['ID']['output']>;
    /** Property Search Metadata such as title and description */
    propertySearchResultMetadata?: Maybe<PropertySearchResultMetadata>;
    /**
     * This is a list of provider info object which the order is based on how the provider info objects
     * should be displayed in to the user.
     */
    providerInfoList?: Maybe<Array<Maybe<PSLProviderInfo>>>;
    /** Response that contains relaxed result information */
    relaxedResults?: Maybe<RelaxedResults>;
    /**
     * Summary information about the total number
     * of available results matching certain criteria
     */
    resultCounts?: Maybe<PropertySearchResultCounts>;
    /** A list of the properties */
    results?: Maybe<Array<PropertyResult>>;
    /**
     * Additional display rules that must be respected
     * when displaying data about these properties
     */
    rules?: Maybe<PropertySearchRules>;
};

export type PropertySearchResponsecommutePolygonArgs = {
    destinationLatLong: LatLonInput;
    maxCommuteTimeInMinutes: Scalars['Int']['input'];
    mode: CommuteMode;
    timeOfDay: TimeOfDay;
};

export type PropertySearchResponseproviderInfoListArgs = {
    includeDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
    includeLogo?: InputMaybe<Scalars['Boolean']['input']>;
    providerLogoTreatment?: InputMaybe<PhotoTreatmentRequest>;
};

export type PropertySearchResponserelaxedResultsArgs = {
    maxRelaxedResults: Scalars['Int']['input'];
    minSearchResults: Scalars['Int']['input'];
    personalizeRelaxedResults?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertySearchResultCounts = {
    /**
     * Count of tab1(agent) listings. Only populated if propertySearchRequest.includeCountsByRulesApplicable is set to true
     * (ignores pagination)
     */
    agentListingsCount?: Maybe<Scalars['Int']['output']>;
    /**
     * The value of displayResultsCount is the count the front end is allowed to display to users.  It represents either
     * the size of the results array or if the LimitSearchResults rule is applicable it will be the minimum of the size
     * of the results array or the value of the LimitSearchResults rule.
     *
     * If the value is from the LimitSearchResults rule, then the size of the results array may not match this value.
     */
    displayResultsCount?: Maybe<Scalars['Int']['output']>;
    /**
     * Count of tab2(other) listings. Only populated if propertySearchRequest.includeCountsByRulesApplicable is set to true
     * (ignores pagination)
     */
    otherListingsCount?: Maybe<Scalars['Int']['output']>;
    /**
     * The total number of results (ignoring
     * pagination that match the search criteria
     * (Each grouped result is counted as one result)
     */
    totalMatchingCount: Scalars['Int']['output'];
};

export type PropertySearchResultMetadata = {
    /** Search Description will be used for the description of the search results page */
    searchDescription?: Maybe<Scalars['String']['output']>;
    /** Search Title will be used for the title of the search results page */
    searchTitle?: Maybe<Scalars['String']['output']>;
};

export type PropertySearchRules = {
    /**
     * This value is true if the SSID for any listing in the current page of results matches an SSID
     * for which the AdRestrictionsInPlace rule is applicable
     * This value is false if the current page of results does NOT contain an SSID for which the rule
     * is applicable
     */
    isAdsRestricted: Scalars['Boolean']['output'];
    /**
     * Will be the lowest value of any LimitSearchResult rule's value on the current search page. If there is no
     * LimitSearchResults rule then this value will be null.
     */
    lowestLimitSearchResultsCount?: Maybe<Scalars['Int']['output']>;
};

export type PropertySpecialOffer = {
    description?: Maybe<Scalars['String']['output']>;
    endDate?: Maybe<Scalars['String']['output']>;
    headline?: Maybe<Scalars['String']['output']>;
    startDate?: Maybe<Scalars['String']['output']>;
};

export type PropertyTag = {
    /**  An ISO-8601 encoded UTC date time string. Example value: 2019-07-03T20:47:55Z  */
    createdDateTime?: Maybe<Scalars['DateTime']['output']>;
    /**  is public tag (not created by a user)  */
    isPublic: Scalars['Boolean']['output'];
    /**  property tag identifier  */
    propertyTagId: Scalars['ID']['output'];
    /**  The tag text added by the user  */
    tagText?: Maybe<Scalars['String']['output']>;
};

export type PropertyTourAvailability = {
    /** string representation of availability date. eg. "2022-02-09" */
    date?: Maybe<Scalars['String']['output']>;
    /** string representation of propertyTourAvailability status, eg. "AVAILABLE", "HOLIDAY" */
    status?: Maybe<Scalars['String']['output']>;
    /** list of strings representation of times available. eg. ["12:20:48"] */
    times?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PropertyTourAvailabilityType = 'INSTANT' | 'INSTANT_BOOK' | 'STANDARD';

export type PropertyTourPlatform = 'ANDROID' | 'IOS' | 'WEB';

export type PropertyTourViews = {
    postContactFormSubmit?: Maybe<PostContactFormSubmitView>;
    tourRequestConfirmation?: Maybe<TourRequestConfirmationView>;
};

export type PropertyTourViewspostContactFormSubmitArgs = {
    input: PostContactFormSubmitViewInput;
};

export type PropertyTourViewstourRequestConfirmationArgs = {
    input: TourRequestConfirmationViewInput;
    variant?: InputMaybe<TourRequestConfirmationViewVariants>;
    version?: InputMaybe<TourRequestConfirmationViewVersion>;
};

export type PropertyType =
    | 'condo'
    | 'divided'
    | 'garden'
    | 'house'
    | 'land'
    | 'large'
    | 'townhouse'
    | 'unknown';

export type PropertyView = {
    /**  True if the user viewed the property, false otherwise   */
    isViewed?: Maybe<Scalars['Boolean']['output']>;
};

export type ProtectionCovers = {
    genderIdentity?: Maybe<Scalars['Boolean']['output']>;
    housingChoiceVoucher?: Maybe<Scalars['Boolean']['output']>;
    sexualOrientation?: Maybe<Scalars['Boolean']['output']>;
    sourceOfIncome?: Maybe<Scalars['Boolean']['output']>;
};

export type ProtectionLevelType = {
    level?: Maybe<Scalars['String']['output']>;
    statePageUrl?: Maybe<Scalars['String']['output']>;
};

export type ProtectionLevels = {
    lgbt?: Maybe<ProtectionLevelType>;
    soi?: Maybe<ProtectionLevelType>;
    voucher?: Maybe<ProtectionLevelType>;
};

export type Protections = {
    covers?: Maybe<ProtectionCovers>;
    description?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

export type ProviderCategory =
    | 'BLI'
    | 'BROKER'
    | 'LIPO_PRIMARY'
    | 'LIPO_SUPPLEMENTARY'
    | 'MANUAL_AGENT'
    | 'MANUAL_USER'
    | 'MLS'
    | 'PAID_BUILDER'
    | 'PAID_MULTI_FAMILY'
    | 'PAID_SINGLE_FAMILY'
    | 'PROPERTY'
    | 'SYNDICATED'
    | 'UNKNOWN';

export type ProviderInfo = {
    disclaimer?: Maybe<Scalars['String']['output']>;
    ssid?: Maybe<Scalars['String']['output']>;
};

export type ProviderInfoListType = {
    disclaimer?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    providerLogo?: Maybe<ProviderLogo>;
    ssid?: Maybe<Scalars['Int']['output']>;
};

export type ProviderLogo = {
    caption?: Maybe<Scalars['String']['output']>;
    streetviewMetadataUrl?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
};

export type QandA = {
    answer?: Maybe<Scalars['String']['output']>;
    created?: Maybe<Scalars['String']['output']>;
    creatorEmail?: Maybe<Scalars['String']['output']>;
    lastUpdated?: Maybe<Scalars['String']['output']>;
    question?: Maybe<Scalars['String']['output']>;
    questionAnswerId?: Maybe<Scalars['String']['output']>;
};

/** query */
export type Query = {
    _noop?: Maybe<Scalars['String']['output']>;
    abTests?: Maybe<ABTests>;
    /**
     * **Definition:** Gets latest data for the team of a logged in team lead
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT token:** identifies team lead
     */
    agentCapacity?: Maybe<AgentCapacity>;
    /**
     * **Definition:** Gets current active connection targets and recommendations for all teams..
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT token: not supported
     *
     * **Auth - Okta User JWT token: Groups: Metro_Operations_ENV, Metro_Admin_ENV
     */
    allTeamMemberConnectionTargets?: Maybe<TeamMemberConnectionTargetConnection>;
    anonymousViewer?: Maybe<AnonymousViewer>;
    /**  get applied tags for the signed-in user for at most 5 specified properties */
    appliedTags?: Maybe<Array<Maybe<AppliedTag>>>;
    archivedApplicationStatuses?: Maybe<Array<Maybe<ListingApplicationStatus>>>;
    books?: Maybe<Array<Maybe<Book>>>;
    bridgeContainer?: Maybe<BridgeContainer>;
    /**
     * Look up a move by either moveId or by referenceId. If multiple inputs are specified, precedence is
     * given to MoveByIdInput then MoveByComponentRefIdInput
     */
    bridgeMoveById?: Maybe<BridgeMove>;
    bridgeMoveByRefId?: Maybe<BridgeMove>;
    /**
     * HDPs belonging to the leaf in the comprehensive tree.
     * @deprecated This field is no longer in use.
     */
    browseHomesComprehensiveLeafHdps?: Maybe<Array<Maybe<BrowseHomesHdp>>>;
    /**
     * Hdps belonging to the leaf in the comprehensive tree.
     * @deprecated This field is no longer in use.
     */
    browseHomesComprehensiveTreeHdps?: Maybe<Array<Maybe<BrowseHomesHdp>>>;
    /**
     * HDPs belonging to the leaf in the priority tree.
     * @deprecated This field is no longer in use.
     */
    browseHomesPriorityLeafHdps?: Maybe<Array<Maybe<BrowseHomesHdp>>>;
    /**
     * Hdps belonging to the leaf in the priority tree.
     * @deprecated This field is no longer in use.
     */
    browseHomesPriorityTreeHdps?: Maybe<Array<Maybe<BrowseHomesHdp>>>;
    builder?: Maybe<Builder>;
    builderDirectory?: Maybe<BuilderDirectory>;
    building?: Maybe<Building>;
    buildingSummaries?: Maybe<Array<Maybe<BuildingSummary>>>;
    bulkLookupByZpids?: Maybe<BulkLookupResponse>;
    bulkLookupByZpidsAndPalsIds?: Maybe<BulkLookupResponse>;
    buyingPowerDetailsView: BuyingPowerDetailsResultView;
    buyingPowerInputCollectionView: BuyingPowerInputCollectionView;
    buyingPowerSummaryView: BuyingPowerSummaryView;
    /**  Fetch buyside questionnaire json */
    buysideQuestionnaire?: Maybe<BuysideQuestionnaire>;
    /**
     *  query to fetch miso buyside questionnaire responses
     * @deprecated cross-sell deprecation
     */
    buysideQuestionnaireAnswers?: Maybe<BuysideQuestionnaireAnswers>;
    /** Cached conversation counts for current logged in user from satellite */
    cachedConversationCounts?: Maybe<CachedConversationCounts>;
    /**
     * Cached conversation counts for the specified user from satellite
     * @deprecated accountId is no longer needed in the param. Will be replaced by cachedConversationCounts
     */
    cachedConversationCountsForSpecifiedUser?: Maybe<CachedConversationCounts>;
    /** A query for media */
    cmsMedia?: Maybe<CMSAttachment>;
    /** A query to fetch menus */
    cmsMenu?: Maybe<Array<Maybe<CMSMenuItem>>>;
    /** A query for single post by slug and post type. */
    cmsPost?: Maybe<CMSPostInterface>;
    /** A query for posts with many different filters including search */
    cmsPosts?: Maybe<CMSPostsResult>;
    /** A query to fetch all redirects */
    cmsRedirects?: Maybe<Array<Maybe<CMSRedirect>>>;
    /** A query to find related posts given category and tag ids */
    cmsRelatedPosts?: Maybe<CMSPostsResult>;
    /** A query to fetch all redirects */
    cmsRevision?: Maybe<CMSRevision>;
    /** A query to fetch all redirects */
    cmsRevisions?: Maybe<Array<Maybe<CMSRevision>>>;
    cmsSearchHead?: Maybe<CMSSearchHead>;
    /** A query to fetch settings */
    cmsSettings?: Maybe<CMSSetting>;
    /** A query for a single taxonomy */
    cmsTaxonomy?: Maybe<CMSTaxonomy>;
    /** A query for single term by slug and taxonomy. */
    cmsTerm?: Maybe<CMSTerm>;
    /** A query for terms with many different filters */
    cmsTerms?: Maybe<Array<Maybe<CMSTerm>>>;
    /** List of personalized collections for a user */
    collections?: Maybe<Collections>;
    /** Root commute query to get commute details for an anonymous user */
    commute?: Maybe<Array<Maybe<CommuteResponseType>>>;
    /**
     * **Definition:** Gets the latest connection target recommendations for the team of a logged in team lead.
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT token:** identifies team lead
     */
    connectionPlanning?: Maybe<ConnectionPlanning>;
    /** Contact Buttons that are eligible to render for a given property */
    contactButtonsForProperty?: Maybe<Array<Maybe<ContactButton>>>;
    /**
     * Data for rendering for sale contact forms
     * @deprecated Use property.contactFormRenderData instead
     */
    contactFormRenderData?: Maybe<ContactFormRenderData>;
    /** Get single contacted rental if exist for the specified property */
    contactedRental?: Maybe<ContactedRentalData>;
    /** Get the Contacted Rental for current logged in user from satellite */
    contactedRentalForSpecifiedId?: Maybe<ContactedRentalForSpecifiedId>;
    /**
     * Get the data for the renter hub / contacted rentals page
     * For normal usage no param is needed
     */
    contactedRentalsPageData?: Maybe<ContactedRentalsPageData>;
    currentZHLBorrower?: Maybe<ZHLBorrower>;
    /**  retrieve eligible products by zpid under 'experimental' namespace  */
    experimental: ExperimentalQueries;
    fetchZHLDocumentRequests?: Maybe<Array<Maybe<ZHLDocumentRequest>>>;
    fetchZHLTaskTemplates?: Maybe<Array<Maybe<ZHLTaskTemplate>>>;
    fetchZHLTasks?: Maybe<Array<Maybe<ZHLTask>>>;
    financialProfile?: Maybe<FinancialProfile>;
    financialProfileByEncodedZuid?: Maybe<FinancialProfile>;
    financialProfileV2?: Maybe<FinancialProfile>;
    flexTransaction?: Maybe<FlexTransaction>;
    flexTransactionCancellationReasons?: Maybe<Array<FlexTransactionCancellationReasonItem>>;
    /**
     * Gets the latest version of the ABAD document and whether or not the user has seen it.
     * Can specify a user via a bearer token or authentication headers. Please see https://zgtools.net/docs/building-blocks/shared-services/zg-graph/auth/ for more details on how to pass headers.
     */
    getAbad?: Maybe<AbadResponse>;
    getAgentSelfPause?: Maybe<PAAgentSelfPause>;
    /** **Definition:** Getting all agent self pauses by list of encodedZuids or zUIDS, assigneeZillowUserId can be encoded zuid or zuid */
    getAgentSelfPausesByUserIds: Array<PAAgentSelfPause>;
    /**
     * **Definition:** Getting Best of Zillow reporting data
     * **Datasource:** Agent Reports API
     * ownerZillowUserId: ID! - agent id, supports ZUID and Encoded ZUID
     * assigneeZillowUserId: ID - team member id, supports ZUID and Encoded ZUID
     * interval: String - monthly, weekly
     * snapshotDate: Date - start date, Ex. 2024-01-01
     */
    getBestOfZillowReportData?: Maybe<BestOfZillowReportingResponse>;
    /**
     * **Definition:** Getting agent connections pipeline reporting data
     * **Datasource:** ElasticSearch
     * ownerZillowUserId: ID! - agent id, supports ZUID and Encoded ZUID
     * assigneeZillowUserId: ID - team member id, supports ZUID and Encoded ZUID
     * startDate: Date - start date, Ex. 2024-01-01
     * endDate: Date - end date, Ex. 2024-01-01
     * leadType: LeadType - MBP|FLEX|ALL_TOURS|RTT|MISO|null, by default FLEX, if null is being passed the query will return all lead types counts
     */
    getConnectionsPipelineReportingData?: Maybe<ConnectionsPipelineReportingData>;
    getCurrentUserSurvey?: Maybe<UserSurveyResponse>;
    getCustomRegion?: Maybe<CustomRegion>;
    /**
     * **Definition:** Getting enhanced market status for an agent
     *       **Datasource:** ElasticSearch
     *       assigneeZillowUserId: ID - team member id, supports ZUID and Encoded ZUID
     */
    getEnhancedMarketAgentStatus?: Maybe<EnhancedMarketDataResponse>;
    /**
     * **Definition:** Getting enhanced market status for a team lead
     *       **Datasource:** ElasticSearch
     *       ownerZillowUserId: ID - team lead id, supports ZUID and Encoded ZUID
     */
    getEnhancedMarketTeamLeadStatus?: Maybe<EnhancedMarketDataResponse>;
    getFinanceDashboardView: FinanceDashboardView;
    getFinanceJourneyContext?: Maybe<FinanceJourneyContext>;
    /** NOTE: hasLoan parameter is deprecated, will not be considered. */
    getFinanceView?: Maybe<FinanceView>;
    /** getFindAlanSummaryById gets the Find Alan Summary data from FindAlan Service given a transaction id */
    getFindAlanSummaryById?: Maybe<FindAlanSummaryByIdResponse>;
    getLoanFinanceJourneyContext?: Maybe<LoanFinanceJourneyContext>;
    /** getPhonesByAssociation gets the Phones data from Phone Number Service given their association */
    getPhonesByAssociation?: Maybe<PhonesByAssociationResponse>;
    /** Get a ZHL purchase lead by lead ID */
    getZHLPurchaseLeadByID?: Maybe<ZHLPreQualPurchaseLead>;
    getZHLPurchaseLeadByLoanID?: Maybe<ZHLPreQualPurchaseLead>;
    /**
     * **Definition:** Getting zhl agent reporting data
     * **Datasource:** ElasticSearch
     * assigneeZillowUserId: ID - team member id, supports ZUID and Encoded ZUID
     * startDate: Date - start date, Ex. 2024-01-01
     * endDate: Date - end date, Ex. 2024-01-01
     * optedIn: Boolean - true or false
     */
    getZhlAgentReport?: Maybe<ZhlAgentReportingDataResponse>;
    /**
     * **Definition:** Getting zhl team reporting data
     * **Datasource:** ElasticSearch
     * ownerZillowUserId: ID - team lead id, supports ZUID and Encoded ZUID
     * startDate: Date - start date, Ex. 2024-01-01
     * endDate: Date - end date, Ex. 2024-01-01
     * optedIn: Boolean - true or false
     */
    getZhlTeamReport?: Maybe<ZhlTeamReportingDataResponse>;
    /**
     * get the z-customer-profile for a user id
     * can be one of the ids we know of a user
     * null if we have no knowledge of the id
     */
    getZillowCustomerProfile?: Maybe<ZillowCustomerProfile>;
    googleAerialView?: Maybe<GoogleAerialView>;
    greeting?: Maybe<GreetingResult>;
    /**  get ODP GuestUser object by guid  */
    guestUser?: Maybe<GuestUser>;
    hasVerifiedIncomeAccount?: Maybe<Scalars['Boolean']['output']>;
    hdpMapSearch?: Maybe<Array<Maybe<HdpMapSearchResult>>>;
    /**  get all hidden homes for the signed-in user, only support properties with zpid */
    hiddenHomes?: Maybe<Array<Maybe<HiddenHome>>>;
    homeLoansDashboard: HomeLoansDashboard;
    /**
     * List of recommended homes for logged in and anonymous users
     * @deprecated Deprecated in favour of the collections API. For new homeRecommendations cases see https://zillowgroup.atlassian.net/wiki/spaces/AT/pages/269942836/Onboarding+a+Consumer+to+the+Collections+API
     */
    homeRecommendation?: Maybe<HomeRecommendation>;
    hubMoveListView?: Maybe<HubMoveListView>;
    /** Returns info about the Journey Plan of a user based on Journey Plan service and Bridge Container. */
    hubPlanOverview: HubIntroOrPlanModule;
    /**
     * This query retrieves a task using the task ID.
     * @deprecated Do not use this query in prod. Use the dev environment instead.
     */
    hubTask?: Maybe<HubTask>;
    hubTaskDetailView: HubTaskDetailView;
    hubTaskListView: HubTaskListView;
    idVerification?: Maybe<UserStatus>;
    isIpAddressInTheUs?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the API from Rental Platform instead */
    landlordLiaisonProperties?: Maybe<Array<Maybe<Property>>>;
    leases?: Maybe<Array<Maybe<Lease>>>;
    listingPreview?: Maybe<Property>;
    malone?: Maybe<MaloneProperty>;
    messages?: Maybe<Messages>;
    /**  get ODP MobileUser object by mpid  */
    mobileUser?: Maybe<MobileUser>;
    mortgageZHLRatesByCreditScore?: Maybe<MortgageZHLRatesByCreditScore>;
    /** Paged builder reviews */
    ncBuilderReviews?: Maybe<Array<Maybe<BuilderReview>>>;
    ncCommunities?: Maybe<Array<Maybe<NcCommunity>>>;
    ncCommunity?: Maybe<NcCommunity>;
    ncCommunityAggregate?: Maybe<NcCommunityAggregate>;
    ncCommunityCards?: Maybe<Array<Maybe<NcCommunityCard>>>;
    /** @deprecated Use ncListingAvailability */
    ncProperty?: Maybe<NcProperty>;
    ncSelfTour?: Maybe<NcSelfTour>;
    nextStepsView: FinanceNextStepsModuleV2;
    /** Fetches an object given its ID */
    node?: Maybe<Node>;
    odOfferStatusByOpendoorId?: Maybe<ODDataResponse>;
    /**  Wrapper for zhvi / zhvf / mrkt related queries  */
    odpMarketAnalytics?: Maybe<OdpMarketAnalytics>;
    /**
     * The offer request associated with the given offer request id
     * @deprecated ZO wind-down
     */
    offerRequest?: Maybe<OfferRequest>;
    /**  retrieve offers for the given access token  */
    offersByAccessToken?: Maybe<OffersResult>;
    /**  retrieve offers for the given miso id  */
    offersByMisoId?: Maybe<OffersResult>;
    /**  Retrieve offers for the given ZUID(Parsed from JWT token from header) + ZPID  */
    offersByZpid?: Maybe<OffersResult>;
    onsiteMessage?: Maybe<OnsiteMessageResultType>;
    /**
     * **Definition:** Get Agent data by Zuid
     *
     * **Team Slack:** #ppd-graphql-guild
     */
    paAgent?: Maybe<PAAgent>;
    /**
     * **Definition:** Get Agent data by Encoded Zuid
     *
     * **Team Slack:** #ppd-graphql-guild
     */
    paAgentByEncodedZuid?: Maybe<PAAgent>;
    /**
     * **Definition:** Get Agent data by Encrypted Zuid
     *
     * **Team Slack:** #ppd-graphql-guild
     */
    paAgentByEncryptedZuid?: Maybe<PAAgent>;
    /**
     * **Definition:** Get a contact by agent zuid/contactId/email/phone
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    paContact?: Maybe<PAContact>;
    /**
     * **Definition:** Contact flex pipeline
     *
     * **Team Slack:** #theclosers
     */
    paContactFlexPipeline?: Maybe<PAContactFlexPipeline>;
    /**
     * **Definition:** List of contact ids by zillow account zuids (single beth identity ids)
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    paContactIdsByZillowAccountZuids: Array<ContactZillowAccountZuidToContactIds>;
    /**
     * **Definition:** Contact loan status list
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    paContactLoanStatusList: Array<PAContactLoanStatus>;
    /**
     * **Definition:** Contact managed tags list
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    paContactManagedTags: Array<PAContactManagedTag>;
    /**
     * **Definition:** Get contact seller info by misoId
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    paContactSellerInfoByMisoIds?: Maybe<Array<PAContactSellerInfo>>;
    /**
     * **Definition:** Get the contact status label by id
     *
     * **Team Slack:** #theclosers
     */
    paContactStatusLabel?: Maybe<PAContactStatusLabel>;
    /**
     * **Definition:** List of default contact statuses.
     *
     * **Team Slack:** #theclosers
     */
    paContactStatusList: Array<PAContactStatus>;
    /**
     * **Definition:** List of contacts by agent zuid and filters. Limit/Offset to support pagination.
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    paContacts: Array<PAContactResult>;
    /**
     * **Definition:** CRM Static Data
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    paCrmStaticData?: Maybe<PAContactStaticData>;
    /**
     * **Definition:** Flex contact
     *
     * **Team Slack:** #theclosers
     */
    paFlexContact?: Maybe<PAFlexContact>;
    /**
     * **Definition:** Flex contacts by contact status
     *
     * **Team Slack:** #theclosers
     */
    paFlexContactsByStatus?: Maybe<Array<PAFlexContact>>;
    /**
     * **Definition:** Needs attention flex contacts for agent
     *
     * **Team Slack:** #theclosers
     */
    paNeedsAttentionFlexContacts?: Maybe<Array<PAFlexContact>>;
    /**
     * **Definition:** Get Routing Rules for an agent
     * @deprecated Not implemented yet. Hackweek26 Agent Self Pause
     */
    paRoutingRules?: Maybe<PARoutingRules>;
    /**
     * **Definition:** Get a contact transaction by transactionId
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    paTransaction?: Maybe<PATransaction>;
    paymentStatus?: Maybe<Payment>;
    /**
     * **Definition:** Gets data to power performance report page for Alan
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     * **Auth - Zillow OAuth2.0 User JWT token:** identifies team member
     */
    performanceReportForLoggedInTeamMember?: Maybe<TeamMemberPerformanceReport>;
    /**
     * **Definition:** Gets data to power performance report page for Alan
     * **Auth - Zillow Oauth2.0 Client Credentials:** requires scope: routing/crda.read
     */
    performanceReportForTeamMember?: Maybe<TeamMemberPerformanceReport>;
    /**  when allowedPropertyIdTypes isn't present, the default behavior is to fetch properties with zpid only  */
    personalizedShopping?: Maybe<PersonalizedShopping>;
    /**  get all potential tags (user custom tags, system/public tags) for the signed-in user */
    potentialTags?: Maybe<Array<Maybe<PropertyTag>>>;
    /**
     *  query to fetch property data from pdc for pre fill use case
     * @deprecated This query is for temporary purpose to pre-fill property data for miso mobile use case
     */
    prefillDataByZpid?: Maybe<MisoMobilePrefillPropertyData>;
    priceMyRental?: Maybe<priceMyRental>;
    proofOfInsurance?: Maybe<ProofOfInsurance>;
    properties?: Maybe<Array<Maybe<Property>>>;
    property?: Maybe<Property>;
    /**  Retrieve questionnaire responses and offer details with leadId  */
    questionnaireAnswersAndOffersByLeadId: QuestionnaireAnswersAndOffers;
    /**  Retrieve questionnaire responses and offer details with misoId  */
    questionnaireAnswersAndOffersByMisoId: QuestionnaireAnswersAndOffers;
    rawConversations?: Maybe<Array<Maybe<Conversation>>>;
    rawLeases?: Maybe<Array<Maybe<Lease>>>;
    rawPaymentStatus?: Maybe<Payment>;
    rawScheduledTours?: Maybe<Array<Maybe<ScheduledTour>>>;
    region?: Maybe<Region>;
    /** @deprecated Feature Flagging service is not available anymore. */
    regionFeatureFlags?: Maybe<FeatureFlagging>;
    rentalApplication?: Maybe<RentalApplication>;
    rentalApplications?: Maybe<Array<Maybe<RentalApplication>>>;
    rentalApplicationsBrownoutWarning?: Maybe<Scalars['String']['output']>;
    rentalApplicationsDocumentUploadToken?: Maybe<Scalars['String']['output']>;
    rentalListing?: Maybe<RentalListing>;
    rentalListingIds?: Maybe<Array<Maybe<RentalListingId>>>;
    /** Get the cached renter hub notification count for the navigation menu gleam */
    renterHubCachedNotificationCount?: Maybe<Scalars['Int']['output']>;
    renterHubData?: Maybe<RenterHubData>;
    /**
     * deprecated(reason: "Use renterHubCachedNotificationCount instead")
     *
     * Get the notification count for the navigation menu gleam
     * For normal usage no param is needed
     */
    renterHubNotificationCount?: Maybe<RenterHubNotificationCount>;
    rentersInsuranceZDocsUploadToken?: Maybe<RentersInsuranceZDocsUploadToken>;
    resourceView: FinanceResourcesView;
    /** @deprecated This is proxied to GDP from before GDP was federated. This migration is to support mobile usage. Otherwise, use `Query.viewer` instead. */
    rhViewer?: Maybe<RHViewer>;
    /** Rich media data not specific to a particular HDP variant (like showcase) */
    richMedia?: Maybe<RichMedia>;
    searchForProperties?: Maybe<PropertySearchResponse>;
    /**
     * This query retrieves one or more tasks using ZUID (required) and reference ID/type (optional)
     * @deprecated Do not use this query in prod. Use the dev environment instead.
     */
    searchHubTasks?: Maybe<Array<Maybe<HubTask>>>;
    /**  CCPA purpose only, to identify the data Records based on email  */
    sellingOptionDataByEmail?: Maybe<SellingOptionData>;
    /**  query to fetch miso ineligible responses. It can be exposed in ZG-Graph later when we have use case  */
    sellingOptionsIneligibleInfo?: Maybe<IneligibleInfo>;
    /**  Fetch selling options questionnaire json */
    sellingOptionsQuestionnaire?: Maybe<SellingOptionsQuestionnaire>;
    /**  query to fetch miso questionnaire responses. It can be exposed in ZG-Graph later when we have use case  */
    sellingOptionsQuestionnaireAnswers?: Maybe<QuestionnaireAnswers>;
    sellingOptionsQuestionnaireByKey?: Maybe<SellingOptionsQuestionnaire>;
    /**  Fetch metadata for all questionnaires  */
    sellingOptionsQuestionnairesMetadata?: Maybe<Array<Maybe<SellingOptionsQuestionnaireMetadata>>>;
    servers?: Maybe<Servers>;
    serviceAgreementById?: Maybe<ServiceAgreementByIdResponse>;
    serviceAgreements?: Maybe<ServiceAgreementsResponse>;
    shouldDisplayInsuranceUpsell?: Maybe<Scalars['Boolean']['output']>;
    /** Rich media data used to power the showcase HDP variant */
    showcase?: Maybe<Showcase>;
    /**  Data related to showing time plus  */
    showingTimePlus?: Maybe<ShowingTimePlus>;
    signInView: FinanceSignInModule;
    /**
     * **Definition:**
     *     Gets connection target submission history for a passed in team lead and recommendation ID.
     * **Auth - Zillow Oauth2.0 Client Credentials:** 'routing/crda.read' scope
     * **Auth - Zillow OAuth2.0 User JWT token:** not supported
     */
    submittedConnectionTargetHistory?: Maybe<Array<Maybe<SubmittedConnectionTarget>>>;
    /**
     * **Definition:** Gets connection target history information for a passed in team lead and team members.
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** 'routing/crda.read' scope
     *
     * **Auth - Zillow OAuth2.0 User JWT token:** not supported
     */
    teamMemberConnectionTargetHistory?: Maybe<TeamMemberConnectionTargetHistoryConnection>;
    tenantPropertyConditions?: Maybe<Array<Maybe<TenantPropertyCondition>>>;
    termSet?: Maybe<TermSet>;
    tourAppointment?: Maybe<TourAppointment>;
    tourAppointmentProperty?: Maybe<Array<TourAppointmentProperty>>;
    tourAppointments?: Maybe<Array<TourAppointment>>;
    tourAppointmentsByAppointmentHashes?: Maybe<Array<TourAppointment>>;
    /** Number of times the 3D Home for this vrmodel has been viewed */
    tourViewCountForVrModel?: Maybe<Scalars['Int']['output']>;
    /**  get ODP TruliaGuestUser object by tlid  */
    truliaGuestUser?: Maybe<TruliaGuestUser>;
    /**  get ODP TruliaUser object by tuid  */
    truliaUser?: Maybe<TruliaUser>;
    upsellView: FinanceUpsellModule;
    userAccount?: Maybe<User>;
    /** Get the user events for a user id */
    userEventsBySemanticTags: UserEventsBySemanticTags;
    userScheduledToursForListing?: Maybe<Array<Maybe<ScheduledTour>>>;
    userStatuses?: Maybe<Array<Maybe<UserStatus>>>;
    /** VaLoan status info */
    vaLoanStatus?: Maybe<Scalars['String']['output']>;
    validateRenterEmailAndPhoneNumber?: Maybe<ValidateRenterEmailAndPhoneNumber>;
    verifiedIncomeConnection?: Maybe<Scalars['URL']['output']>;
    viewer?: Maybe<Viewer>;
    vl_building?: Maybe<VL_Building>;
    vl_buildingSummaries?: Maybe<Array<Maybe<VL_BuildingSummary>>>;
    yourRentals?: Maybe<YourRentals>;
    /**
     * Get the data for the renter hub / your rentals page
     * Corresponding page urls: renterhub/your-rental renterhub/app-your-rental
     */
    yourRentalsPageData?: Maybe<YourRentalsPageData>;
    /** Fetches the UI module data to display the YourTeam feature */
    yourTeamView: YourTeamModule;
    /**  get ODP ZGProperty object by propertyId  */
    zgProperty?: Maybe<ZGProperty>;
    zgsAutocompleteRequest?: Maybe<SearchAssistanceAutocompleteResult>;
    zgsFinanceChatBotPaginationRequest?: Maybe<FinanceChatBotResponse>;
    zgsFinanceChatBotRequest?: Maybe<FinanceChatBotResponse>;
    zgsQueryUnderstandingRequest?: Maybe<SearchAssistanceQueryUnderstandingResult>;
    zgsSearchRefinementGetRefinements?: Maybe<SearchRefinementResult>;
    zhlBorrower?: Maybe<ZHLBorrower>;
    zhlGetPlaidAuditTokens?: Maybe<Array<Maybe<ZHLPlaidBorrowerAuditTokens>>>;
    zhlLead?: Maybe<ZHLLead>;
    zhlLoan: ZHLLoan;
    /** (experimental) Retrieve an ZHL LO by zuid or ZG email. NOTE: we may have to support get by ZHLUID or ZHL email in future. */
    zhlLoanOfficer?: Maybe<ZHLLoanOfficer>;
    /** (experimental) Search ZHL LOs, currently only search by state is supported. TODO: pass no state should return all LOs paged */
    zhlLoanOfficers?: Maybe<Array<ZHLLoanOfficer>>;
    zhlLoans?: Maybe<Array<Maybe<ZHLLoan>>>;
    zhlMACExperience?: Maybe<ZHLMACExperience>;
    zhlMACNextStepsStatus: MACNextStepsStatus;
    zhlMacNextSteps: ZhlMacNextSteps;
    zhlMacTaskByStatus: ZhlMacTaskByStatus;
    /** ZHL pre-approval experience */
    zhlPreApproval?: Maybe<ZHLPreApproval>;
    /** Gets all conversations related to user. User is determined from Authorization header. */
    zibsGetAllConversations?: Maybe<Array<Maybe<ZIBSConversation>>>;
    /**
     * Gets a specific conversation either by list of participants or conversation ID.
     * If no arguments are passed in, a 400 response is returned.
     */
    zibsGetConversation?: Maybe<ZIBSConversation>;
    /** @deprecated Deprecated with ZO wind down */
    zillowOffers?: Maybe<ZillowOffers>;
    /**  get ODP local ZillowUser object by zuid or ezuid  */
    zillowUser?: Maybe<ZillowUser>;
    /** Get all ZIM conversations associated with a specific user. */
    zimGetAllConversations?: Maybe<ZIMGetAllConversationsResponse>;
    /** Retrieves the details for a single conversation */
    zimGetConversation?: Maybe<ZIMConversation>;
    /**
     * Determines if the user is eligible for the messaging experience
     * Will implicitly pass in authenticated user info
     */
    zimIsMessagingEligible?: Maybe<ZIMMessagingEligibilityResponse>;
    /** Object that contains information for controlling upsell display */
    zoUpsellDisplayInfo?: Maybe<zoUpsellDisplayInfo>;
};

/** query */
export type QueryallTeamMemberConnectionTargetsArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
};

/** query */
export type QueryappliedTagsArgs = {
    appliedTagsInput: Array<AppliedTagsInput>;
};

/** query */
export type QuerybridgeContainerArgs = {
    filter?: InputMaybe<BridgeMoveFilters>;
    refId?: InputMaybe<Scalars['String']['input']>;
    refType?: InputMaybe<BridgeParticipantReferenceType>;
};

/** query */
export type QuerybridgeMoveByIdArgs = {
    moveId: Scalars['String']['input'];
};

/** query */
export type QuerybridgeMoveByRefIdArgs = {
    refId: Scalars['String']['input'];
    refType: BridgeMoveComponentReferenceType;
};

/** query */
export type QuerybrowseHomesComprehensiveLeafHdpsArgs = {
    leafId: Scalars['Int']['input'];
};

/** query */
export type QuerybrowseHomesComprehensiveTreeHdpsArgs = {
    leafId: Scalars['Int']['input'];
};

/** query */
export type QuerybrowseHomesPriorityLeafHdpsArgs = {
    leafId: Scalars['Int']['input'];
};

/** query */
export type QuerybrowseHomesPriorityTreeHdpsArgs = {
    leafId: Scalars['Int']['input'];
    treeId: Scalars['String']['input'];
};

/** query */
export type QuerybuilderArgs = {
    feedId?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QuerybuilderDirectoryArgs = {
    builderName?: InputMaybe<Scalars['String']['input']>;
    pageNumber?: InputMaybe<Scalars['Int']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    regionId?: InputMaybe<Scalars['Int']['input']>;
    regionName?: InputMaybe<Scalars['String']['input']>;
};

/** query */
export type QuerybuildingArgs = {
    buildingKey?: InputMaybe<Scalars['String']['input']>;
    cache?: InputMaybe<Scalars['Boolean']['input']>;
    latitude?: InputMaybe<Scalars['Float']['input']>;
    longitude?: InputMaybe<Scalars['Float']['input']>;
    lotId?: InputMaybe<Scalars['ID']['input']>;
    update?: InputMaybe<Scalars['Boolean']['input']>;
};

/** query */
export type QuerybuildingSummariesArgs = {
    lotIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** query */
export type QuerybulkLookupByZpidsArgs = {
    debugRequest?: InputMaybe<DebugRequest>;
    filters?: InputMaybe<BulkLookupFilters>;
    zpids: Array<Scalars['ID']['input']>;
};

/** query */
export type QuerybulkLookupByZpidsAndPalsIdsArgs = {
    debugRequest?: InputMaybe<DebugRequest>;
    filters?: InputMaybe<BulkLookupFilters>;
    propertyIdentifications: Array<PropertyIdentification>;
};

/** query */
export type QuerybuyingPowerDetailsViewArgs = {
    inputs?: InputMaybe<BuyingPowerInputs>;
    overrideInputs?: InputMaybe<BuyingPowerOverrideInputs>;
};

/** query */
export type QuerybuyingPowerInputCollectionViewArgs = {
    inputs?: InputMaybe<BuyingPowerInputs>;
    supportedExperiences?: InputMaybe<Array<BuyingPowerInputCollectionExperience>>;
};

/** query */
export type QuerybuysideQuestionnaireArgs = {
    zipcode: Scalars['Int']['input'];
};

/** query */
export type QuerybuysideQuestionnaireAnswersArgs = {
    responseId: Scalars['ID']['input'];
};

/** query */
export type QuerycachedConversationCountsForSpecifiedUserArgs = {
    accountId?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QuerycmsMediaArgs = {
    id: Scalars['ID']['input'];
    site?: InputMaybe<CMSSite>;
};

/** query */
export type QuerycmsMenuArgs = {
    id: Scalars['ID']['input'];
    site?: InputMaybe<CMSSite>;
};

/** query */
export type QuerycmsPostArgs = {
    id: Scalars['ID']['input'];
    idType: CMSIDType;
    post_type: CMSPostTypeEnum;
    site?: InputMaybe<CMSSite>;
};

/** query */
export type QuerycmsPostsArgs = {
    include?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    order?: InputMaybe<CMSPostOrder>;
    orderby?: InputMaybe<CMSPostOrderBy>;
    page?: InputMaybe<Scalars['String']['input']>;
    per_page?: InputMaybe<Scalars['String']['input']>;
    post_type: CMSPostTypeEnum;
    search?: InputMaybe<Scalars['String']['input']>;
    site?: InputMaybe<CMSSite>;
    taxonomies?: InputMaybe<Array<InputMaybe<CMSTaxonomyInput>>>;
};

/** query */
export type QuerycmsRedirectsArgs = {
    site?: InputMaybe<CMSSite>;
};

/** query */
export type QuerycmsRelatedPostsArgs = {
    categories: Array<Scalars['ID']['input']>;
    order?: InputMaybe<CMSPostOrder>;
    orderby?: InputMaybe<CMSPostOrderBy>;
    page?: InputMaybe<Scalars['String']['input']>;
    per_page?: InputMaybe<Scalars['String']['input']>;
    post_type: CMSPostTypeEnum;
    site?: InputMaybe<CMSSite>;
    tags: Array<Scalars['ID']['input']>;
};

/** query */
export type QuerycmsRevisionArgs = {
    parentID: Scalars['ID']['input'];
    post_type: CMSPostTypeEnum;
    revisionID: Scalars['ID']['input'];
    site?: InputMaybe<CMSSite>;
};

/** query */
export type QuerycmsRevisionsArgs = {
    parentID: Scalars['ID']['input'];
    per_page?: InputMaybe<Scalars['String']['input']>;
    post_type: CMSPostTypeEnum;
    site?: InputMaybe<CMSSite>;
};

/** query */
export type QuerycmsSearchHeadArgs = {
    searchTerm?: InputMaybe<Scalars['String']['input']>;
    site?: InputMaybe<CMSSite>;
};

/** query */
export type QuerycmsSettingsArgs = {
    site?: InputMaybe<CMSSite>;
};

/** query */
export type QuerycmsTaxonomyArgs = {
    site?: InputMaybe<CMSSite>;
    taxonomy: CMSTaxonomyEnum;
};

/** query */
export type QuerycmsTermArgs = {
    id: Scalars['ID']['input'];
    idType: CMSIDType;
    site?: InputMaybe<CMSSite>;
    taxonomy: CMSTaxonomyEnum;
};

/** query */
export type QuerycmsTermsArgs = {
    per_page?: InputMaybe<Scalars['String']['input']>;
    post?: InputMaybe<Scalars['ID']['input']>;
    site?: InputMaybe<CMSSite>;
    taxonomy: CMSTaxonomyEnum;
};

/** query */
export type QuerycollectionsArgs = {
    building?: InputMaybe<BuildingCardMini>;
    cExperienceId: Scalars['String']['input'];
    contentTypes?: InputMaybe<Array<InputMaybe<CollectionContentType>>>;
    placements?: InputMaybe<Array<InputMaybe<ModulePlacement>>>;
    searchFilters?: InputMaybe<SearchFiltersInput>;
    shopperZuid?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QuerycommuteArgs = {
    destinations: Array<InputMaybe<CommuteDestinationInputType>>;
    startLat: Scalars['Float']['input'];
    startLng: Scalars['Float']['input'];
};

/** query */
export type QuerycontactButtonsForPropertyArgs = {
    context: Scalars['String']['input'];
    platform: ZillowPlatform;
    supportedActionTypes: Array<InputMaybe<ContactButtonActionType>>;
    version?: InputMaybe<ContactButtonsForPropertyVersion>;
    zpid: Scalars['ID']['input'];
};

/** query */
export type QuerycontactFormRenderDataArgs = {
    contactFormRenderParameter?: InputMaybe<ContactFormRenderParameter>;
    isDoubleScroll?: InputMaybe<Scalars['Boolean']['input']>;
    platform?: InputMaybe<ContactFormPlatform>;
    zpid?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QuerycontactedRentalArgs = {
    clientData?: InputMaybe<Scalars['String']['input']>;
    propertyId: Scalars['String']['input'];
    propertyIdType: Scalars['String']['input'];
    readFromCache?: InputMaybe<Scalars['Boolean']['input']>;
    shouldCacheMock?: InputMaybe<Scalars['Boolean']['input']>;
    showInstantTour?: InputMaybe<Scalars['Boolean']['input']>;
    useCache?: InputMaybe<Scalars['Boolean']['input']>;
    useMock?: InputMaybe<Scalars['Boolean']['input']>;
    useNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

/** query */
export type QuerycontactedRentalForSpecifiedIdArgs = {
    propertyId?: InputMaybe<Scalars['ID']['input']>;
    propertyIdType?: InputMaybe<Scalars['String']['input']>;
};

/** query */
export type QuerycontactedRentalsPageDataArgs = {
    clientData?: InputMaybe<Scalars['String']['input']>;
    readFromCache?: InputMaybe<Scalars['Boolean']['input']>;
    shouldCacheMock?: InputMaybe<Scalars['Boolean']['input']>;
    showInstantTour?: InputMaybe<Scalars['Boolean']['input']>;
    useCache?: InputMaybe<Scalars['Boolean']['input']>;
    useMock?: InputMaybe<Scalars['Boolean']['input']>;
    useNotifications?: InputMaybe<Scalars['Boolean']['input']>;
};

/** query */
export type QuerycurrentZHLBorrowerArgs = {
    zhlLoanId: Scalars['ID']['input'];
};

/** query */
export type QueryfetchZHLDocumentRequestsArgs = {
    lfsLoanId: Scalars['ID']['input'];
};

/** query */
export type QueryfetchZHLTasksArgs = {
    includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    includeLFSAssociations?: InputMaybe<Scalars['Boolean']['input']>;
    lfsLoanId: Scalars['ID']['input'];
    taskCategory?: InputMaybe<ZHLTaskCategory>;
    taskTrigger?: InputMaybe<ZHLTaskTrigger>;
    taskTriggerList?: InputMaybe<Array<InputMaybe<ZHLTaskTrigger>>>;
};

/** query */
export type QueryfinancialProfileArgs = {
    zuid?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QueryfinancialProfileByEncodedZuidArgs = {
    encodedZuid?: InputMaybe<Scalars['String']['input']>;
};

/** query */
export type QueryflexTransactionArgs = {
    ztid: Scalars['String']['input'];
};

/** query */
export type QuerygetAgentSelfPauseArgs = {
    assigneeZillowUserId: Scalars['ID']['input'];
};

/** query */
export type QuerygetAgentSelfPausesByUserIdsArgs = {
    assigneeZillowUserIds: Array<Scalars['ID']['input']>;
};

/** query */
export type QuerygetBestOfZillowReportDataArgs = {
    assigneeZillowUserId?: InputMaybe<Scalars['ID']['input']>;
    interval?: InputMaybe<Scalars['String']['input']>;
    ownerZillowUserId: Scalars['ID']['input'];
    snapshotDate?: InputMaybe<Scalars['Date']['input']>;
};

/** query */
export type QuerygetConnectionsPipelineReportingDataArgs = {
    assigneeZillowUserId?: InputMaybe<Scalars['ID']['input']>;
    endDate?: InputMaybe<Scalars['Date']['input']>;
    leadType?: InputMaybe<LeadType>;
    ownerZillowUserId: Scalars['ID']['input'];
    startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** query */
export type QuerygetCurrentUserSurveyArgs = {
    brand?: InputMaybe<Brand>;
    checkCache?: InputMaybe<Scalars['Boolean']['input']>;
    deliveryChannel?: InputMaybe<DeliveryChannel>;
};

/** query */
export type QuerygetCustomRegionArgs = {
    customRegionId: Scalars['ID']['input'];
};

/** query */
export type QuerygetEnhancedMarketAgentStatusArgs = {
    assigneeZillowUserId?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QuerygetEnhancedMarketTeamLeadStatusArgs = {
    ownerZillowUserId?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QuerygetFinanceDashboardViewArgs = {
    supportedModules?: InputMaybe<Array<InputMaybe<FinanceDashboardModuleType>>>;
};

/** query */
export type QuerygetFinanceJourneyContextArgs = {
    zuid: Scalars['String']['input'];
};

/** query */
export type QuerygetFinanceViewArgs = {
    experienceVariant?: InputMaybe<FinanceExperienceVariant>;
    hasLoan?: InputMaybe<Scalars['Boolean']['input']>;
};

/** query */
export type QuerygetFindAlanSummaryByIdArgs = {
    in?: InputMaybe<GetFindAlanSummaryByIdInput>;
};

/** query */
export type QuerygetLoanFinanceJourneyContextArgs = {
    loanId: Scalars['String']['input'];
};

/** query */
export type QuerygetPhonesByAssociationArgs = {
    in?: InputMaybe<GetPhonesByAssociationInput>;
};

/** query */
export type QuerygetZHLPurchaseLeadByIDArgs = {
    leadID: Scalars['String']['input'];
};

/** query */
export type QuerygetZHLPurchaseLeadByLoanIDArgs = {
    loanId: Scalars['String']['input'];
};

/** query */
export type QuerygetZhlAgentReportArgs = {
    assigneeZillowUserId?: InputMaybe<Scalars['ID']['input']>;
    endDate?: InputMaybe<Scalars['Date']['input']>;
    optedIn?: InputMaybe<Scalars['Boolean']['input']>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** query */
export type QuerygetZhlTeamReportArgs = {
    endDate?: InputMaybe<Scalars['Date']['input']>;
    optedIn?: InputMaybe<Scalars['Boolean']['input']>;
    ownerZillowUserId?: InputMaybe<Scalars['ID']['input']>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** query */
export type QuerygetZillowCustomerProfileArgs = {
    filter: IdentityFilter;
};

/** query */
export type QuerygoogleAerialViewArgs = {
    aerialViewVideoId?: InputMaybe<Scalars['String']['input']>;
    lotId?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QuerygreetingArgs = {
    name: Scalars['String']['input'];
};

/** query */
export type QueryguestUserArgs = {
    guid: Scalars['String']['input'];
};

/** query */
export type QueryhdpMapSearchArgs = {
    eastLong: Scalars['Float']['input'];
    northLat: Scalars['Float']['input'];
    parentZpid?: InputMaybe<Scalars['Int']['input']>;
    southLat: Scalars['Float']['input'];
    westLong: Scalars['Float']['input'];
    zoomLevel: Scalars['Int']['input'];
};

/** query */
export type QueryhomeRecommendationArgs = {
    clientName: Scalars['String']['input'];
    excludeZpids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    maxRecs?: InputMaybe<Scalars['Int']['input']>;
    placement: PlacementOption;
    queryType: QueryTypeOption;
    zpid?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QueryhubMoveListViewArgs = {
    zuid: Scalars['ID']['input'];
};

/** query */
export type QueryhubPlanOverviewArgs = {
    includeZhlStatus?: Scalars['Boolean']['input'];
};

/** query */
export type QueryhubTaskArgs = {
    id: Scalars['ID']['input'];
};

/** query */
export type QueryhubTaskDetailViewArgs = {
    taskId: Scalars['ID']['input'];
};

/** query */
export type QueryhubTaskListViewArgs = {
    moveId: Scalars['ID']['input'];
};

/** query */
export type QueryidVerificationArgs = {
    zgAuthZone?: InputMaybe<ZgAuthZone>;
};

/** query */
export type QuerylistingPreviewArgs = {
    dateUpdatedTimestamp?: InputMaybe<Scalars['String']['input']>;
    listingAlias?: InputMaybe<Scalars['String']['input']>;
    secret?: InputMaybe<Scalars['String']['input']>;
};

/** query */
export type QuerymaloneArgs = {
    fullAddress: Scalars['String']['input'];
};

/** query */
export type QuerymobileUserArgs = {
    mpid: Scalars['String']['input'];
};

/** query */
export type QuerymortgageZHLRatesByCreditScoreArgs = {
    creditScoreRange?: InputMaybe<CreditScoreRange>;
};

/** query */
export type QueryncBuilderReviewsArgs = {
    feedId?: InputMaybe<Scalars['ID']['input']>;
    pageNumber?: InputMaybe<Scalars['Int']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    plid?: InputMaybe<Scalars['ID']['input']>;
    regionId?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QueryncCommunitiesArgs = {
    builderId?: InputMaybe<Scalars['Int']['input']>;
    pageNumber?: InputMaybe<Scalars['Int']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    plids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
    regionId?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QueryncCommunityArgs = {
    palsId?: InputMaybe<Scalars['ID']['input']>;
    plid?: InputMaybe<Scalars['ID']['input']>;
    zpid?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QueryncCommunityAggregateArgs = {
    builderId?: InputMaybe<Scalars['Int']['input']>;
    regionId?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QueryncCommunityCardsArgs = {
    builderId?: InputMaybe<Scalars['Int']['input']>;
    pageNumber?: InputMaybe<Scalars['Int']['input']>;
    pageSize?: InputMaybe<Scalars['Int']['input']>;
    plids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    regionId?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QueryncPropertyArgs = {
    id?: InputMaybe<Scalars['ID']['input']>;
    palsId?: InputMaybe<Scalars['ID']['input']>;
    zpid?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QueryncSelfTourArgs = {
    zpid?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QuerynextStepsViewArgs = {
    loanId?: InputMaybe<Scalars['String']['input']>;
};

/** query */
export type QuerynodeArgs = {
    id: Scalars['ID']['input'];
};

/** query */
export type QueryodOfferStatusByOpendoorIdArgs = {
    opendoorId: Scalars['String']['input'];
};

/** query */
export type QueryofferRequestArgs = {
    accessKey?: InputMaybe<Scalars['String']['input']>;
    encodedOfferRequestId: Scalars['String']['input'];
};

/** query */
export type QueryoffersByAccessTokenArgs = {
    accessToken: Scalars['ID']['input'];
};

/** query */
export type QueryoffersByMisoIdArgs = {
    misoId: Scalars['ID']['input'];
};

/** query */
export type QueryoffersByZpidArgs = {
    zpid: Scalars['Int']['input'];
};

/** query */
export type QueryonsiteMessageArgs = {
    appVersion?: InputMaybe<Scalars['String']['input']>;
    placementData?: InputMaybe<PlacementData>;
    placementNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    platform?: InputMaybe<Scalars['String']['input']>;
    surfaceId?: InputMaybe<Scalars['String']['input']>;
};

/** query */
export type QuerypaAgentArgs = {
    zillowUserId: Scalars['Int']['input'];
};

/** query */
export type QuerypaAgentByEncodedZuidArgs = {
    encodedZuid: Scalars['String']['input'];
};

/** query */
export type QuerypaAgentByEncryptedZuidArgs = {
    encryptedZuid: Scalars['String']['input'];
};

/** query */
export type QuerypaContactArgs = {
    agentZuid?: InputMaybe<Scalars['Int']['input']>;
    contactId?: InputMaybe<Scalars['Int']['input']>;
    email?: InputMaybe<Scalars['String']['input']>;
    encodedContactId?: InputMaybe<Scalars['String']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
};

/** query */
export type QuerypaContactFlexPipelineArgs = {
    agentZuid?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QuerypaContactIdsByZillowAccountZuidsArgs = {
    zillowAccountZuids: Array<Scalars['String']['input']>;
};

/** query */
export type QuerypaContactSellerInfoByMisoIdsArgs = {
    misoIds: Array<Scalars['ID']['input']>;
};

/** query */
export type QuerypaContactStatusLabelArgs = {
    statusId: Scalars['Int']['input'];
};

/** query */
export type QuerypaContactStatusListArgs = {
    agentZuid?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QuerypaContactsArgs = {
    agentZuid?: InputMaybe<Scalars['Int']['input']>;
    filters?: InputMaybe<PAContactListFiltersInput>;
    limit?: InputMaybe<Scalars['Int']['input']>;
    offset?: InputMaybe<Scalars['Int']['input']>;
    sortBy?: InputMaybe<PAContactListSortInput>;
};

/** query */
export type QuerypaFlexContactArgs = {
    agentZuid?: InputMaybe<Scalars['Int']['input']>;
    contactId: Scalars['Int']['input'];
};

/** query */
export type QuerypaFlexContactsByStatusArgs = {
    agentZuid?: InputMaybe<Scalars['Int']['input']>;
    contactStatusId: Scalars['ID']['input'];
};

/** query */
export type QuerypaNeedsAttentionFlexContactsArgs = {
    agentZuid?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QuerypaRoutingRulesArgs = {
    agentZuid: Scalars['Int']['input'];
};

/** query */
export type QuerypaTransactionArgs = {
    transactionId: Scalars['Int']['input'];
};

/** query */
export type QueryperformanceReportForLoggedInTeamMemberArgs = {
    teamLeadZuid: ZuidInput;
};

/** query */
export type QueryperformanceReportForTeamMemberArgs = {
    teamLeadZuid: ZuidInput;
    teamMemberZuid: ZuidInput;
};

/** query */
export type QuerypersonalizedShoppingArgs = {
    allowedPropertyIdTypes?: InputMaybe<Array<InputMaybe<PropertyIdType>>>;
};

/** query */
export type QueryprefillDataByZpidArgs = {
    zpid: Scalars['ID']['input'];
};

/** query */
export type QueryproofOfInsuranceArgs = {
    listingAlias: Scalars['String']['input'];
};

/** query */
export type QuerypropertiesArgs = {
    zpids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

/** query */
export type QuerypropertyArgs = {
    id?: InputMaybe<Scalars['ID']['input']>;
    listingMetadataStub?: InputMaybe<Scalars['String']['input']>;
    palsId?: InputMaybe<Scalars['ID']['input']>;
    zpid?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QueryquestionnaireAnswersAndOffersByLeadIdArgs = {
    leadId: Scalars['ID']['input'];
};

/** query */
export type QueryquestionnaireAnswersAndOffersByMisoIdArgs = {
    misoId: Scalars['ID']['input'];
};

/** query */
export type QueryregionArgs = {
    disableRegionLoader?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    rid?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QueryregionFeatureFlagsArgs = {
    rid?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QueryrentalApplicationArgs = {
    id?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QueryrentalListingArgs = {
    id: Scalars['ID']['input'];
};

/** query */
export type QueryrentalListingIdsArgs = {
    listingIdOrAliases: Array<InputMaybe<Scalars['ID']['input']>>;
};

/** query */
export type QueryrenterHubCachedNotificationCountArgs = {
    shouldCacheMock?: InputMaybe<Scalars['Boolean']['input']>;
    useMock?: InputMaybe<Scalars['Boolean']['input']>;
};

/** query */
export type QueryrenterHubNotificationCountArgs = {
    readFromCache?: InputMaybe<Scalars['Boolean']['input']>;
    shouldCacheMock?: InputMaybe<Scalars['Boolean']['input']>;
    useCache?: InputMaybe<Scalars['Boolean']['input']>;
    useMock?: InputMaybe<Scalars['Boolean']['input']>;
};

/** query */
export type QueryresourceViewArgs = {
    buyingPowerExperienceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** query */
export type QueryrichMediaArgs = {
    zpid?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QuerysearchForPropertiesArgs = {
    propertySearchRequest?: InputMaybe<PropertySearchRequest>;
};

/** query */
export type QuerysearchHubTasksArgs = {
    criteria: HubTaskSearchInput;
};

/** query */
export type QuerysellingOptionDataByEmailArgs = {
    email: Scalars['ID']['input'];
};

/** query */
export type QuerysellingOptionsIneligibleInfoArgs = {
    responseId: Scalars['ID']['input'];
};

/** query */
export type QuerysellingOptionsQuestionnaireArgs = {
    zipcode: Scalars['Int']['input'];
};

/** query */
export type QuerysellingOptionsQuestionnaireAnswersArgs = {
    responseId: Scalars['ID']['input'];
};

/** query */
export type QuerysellingOptionsQuestionnaireByKeyArgs = {
    schemaKey: Scalars['String']['input'];
    schemaVersion?: InputMaybe<Scalars['String']['input']>;
};

/** query */
export type QueryserviceAgreementByIdArgs = {
    zDocsId: Scalars['String']['input'];
};

/** query */
export type QueryserviceAgreementsArgs = {
    agentZuid?: InputMaybe<Scalars['Int']['input']>;
    contactId?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QueryshowcaseArgs = {
    zpid?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QuerysubmittedConnectionTargetHistoryArgs = {
    query: SubmittedConnectionTargetHistoryInput;
};

/** query */
export type QueryteamMemberConnectionTargetHistoryArgs = {
    query: TeamMemberConnectionTargetHistoryInput;
};

/** query */
export type QuerytenantPropertyConditionsArgs = {
    listingAlias?: InputMaybe<Scalars['String']['input']>;
};

/** query */
export type QuerytermSetArgs = {
    id: TermSetId;
};

/** query */
export type QuerytourAppointmentArgs = {
    appointmentHash: Scalars['ID']['input'];
};

/** query */
export type QuerytourAppointmentPropertyArgs = {
    isFutureAppointment: Scalars['Boolean']['input'];
    zpids: Array<Scalars['Int']['input']>;
};

/** query */
export type QuerytourAppointmentsArgs = {
    filters: TourAppointmentQueryParameters;
};

/** query */
export type QuerytourAppointmentsByAppointmentHashesArgs = {
    appointmentHashes: Array<Scalars['ID']['input']>;
};

/** query */
export type QuerytourViewCountForVrModelArgs = {
    since?: InputMaybe<Scalars['DateTime']['input']>;
    until?: InputMaybe<Scalars['DateTime']['input']>;
    vrModelGuid: Scalars['String']['input'];
};

/** query */
export type QuerytruliaGuestUserArgs = {
    tlid: Scalars['String']['input'];
};

/** query */
export type QuerytruliaUserArgs = {
    tuid: Scalars['String']['input'];
};

/** query */
export type QueryuserAccountArgs = {
    zuid?: InputMaybe<Scalars['Int']['input']>;
};

/** query */
export type QueryuserEventsBySemanticTagsArgs = {
    identityFilter: IdentityFilter;
};

/** query */
export type QueryuserScheduledToursForListingArgs = {
    propertyId: Scalars['String']['input'];
    propertyIdType: Scalars['String']['input'];
};

/** query */
export type QueryvaLoanStatusArgs = {
    lotId?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QueryvalidateRenterEmailAndPhoneNumberArgs = {
    email?: InputMaybe<Scalars['String']['input']>;
    phone?: InputMaybe<Scalars['String']['input']>;
    providerListingID?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type Queryvl_buildingArgs = {
    buildingKey?: InputMaybe<Scalars['String']['input']>;
    cache?: InputMaybe<Scalars['Boolean']['input']>;
    latitude?: InputMaybe<Scalars['Float']['input']>;
    longitude?: InputMaybe<Scalars['Float']['input']>;
    lotId?: InputMaybe<Scalars['ID']['input']>;
    update?: InputMaybe<Scalars['Boolean']['input']>;
};

/** query */
export type Queryvl_buildingSummariesArgs = {
    lotIds: Array<InputMaybe<Scalars['ID']['input']>>;
};

/** query */
export type QueryyourRentalsArgs = {
    readFromCache?: InputMaybe<Scalars['Boolean']['input']>;
    shouldCacheMock?: InputMaybe<Scalars['Boolean']['input']>;
    useMock?: InputMaybe<Scalars['Boolean']['input']>;
};

/** query */
export type QueryyourRentalsPageDataArgs = {
    mockDataId?: InputMaybe<Scalars['String']['input']>;
};

/** query */
export type QueryzgPropertyArgs = {
    propertyId: Scalars['ID']['input'];
    sourcePriorityOverride?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** query */
export type QueryzgsAutocompleteRequestArgs = {
    query: Scalars['String']['input'];
    queryOptions?: InputMaybe<SearchAssistanceQueryOptions>;
    resultType?: InputMaybe<Array<InputMaybe<SearchAssistanceResultType>>>;
};

/** query */
export type QueryzgsFinanceChatBotPaginationRequestArgs = {
    context?: InputMaybe<FinanceContext>;
    fcbMaxResults?: Scalars['Int']['input'];
    paginationOffset?: Scalars['Int']['input'];
};

/** query */
export type QueryzgsFinanceChatBotRequestArgs = {
    context?: InputMaybe<FinanceContext>;
    humanInteraction: Scalars['String']['input'];
};

/** query */
export type QueryzgsQueryUnderstandingRequestArgs = {
    query: Scalars['String']['input'];
    queryOptions?: InputMaybe<SearchAssistanceQueryOptions>;
    querySource?: SearchAssistanceQuerySource;
    resultType?: InputMaybe<Array<InputMaybe<SearchAssistanceResultType>>>;
};

/** query */
export type QueryzgsSearchRefinementGetRefinementsArgs = {
    deviceType: SearchRefinementDeviceType;
    filterState: Scalars['String']['input'];
    listingType: SearchRefinementListingType;
    queryOptions?: InputMaybe<SearchRefinementQueryOptions>;
    userIdentity: SearchRefinementUserIdentity;
};

/** query */
export type QueryzhlBorrowerArgs = {
    zhlBorrowerId: Scalars['ID']['input'];
};

/** query */
export type QueryzhlGetPlaidAuditTokensArgs = {
    loanId: Scalars['ID']['input'];
};

/** query */
export type QueryzhlLeadArgs = {
    id: Scalars['ID']['input'];
};

/** query */
export type QueryzhlLoanArgs = {
    includeConditions?: InputMaybe<Scalars['Boolean']['input']>;
    includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    includeLFSAssociations?: InputMaybe<Scalars['Boolean']['input']>;
    taskCategory?: InputMaybe<ZHLTaskCategory>;
    taskTrigger?: InputMaybe<ZHLTaskTrigger>;
    taskTriggerList?: InputMaybe<Array<InputMaybe<ZHLTaskTrigger>>>;
    zhlLoanId: Scalars['ID']['input'];
};

/** query */
export type QueryzhlLoanOfficerArgs = {
    zgEmail?: InputMaybe<Scalars['ID']['input']>;
    zuid?: InputMaybe<Scalars['ID']['input']>;
};

/** query */
export type QueryzhlLoanOfficersArgs = {
    state?: InputMaybe<State>;
};

/** query */
export type QueryzhlMACNextStepsStatusArgs = {
    zhlLoanId: Scalars['ID']['input'];
};

/** query */
export type QueryzhlMacNextStepsArgs = {
    zhlLoanId: Scalars['ID']['input'];
};

/** query */
export type QueryzhlMacTaskByStatusArgs = {
    zhlLoanId: Scalars['ID']['input'];
};

/** query */
export type QueryzhlPreApprovalArgs = {
    loanID: Scalars['ID']['input'];
};

/** query */
export type QueryzibsGetConversationArgs = {
    conversationId?: InputMaybe<Scalars['String']['input']>;
    notificationConnectionId?: InputMaybe<Scalars['String']['input']>;
};

/** query */
export type QueryzillowUserArgs = {
    isEzuid?: InputMaybe<Scalars['Boolean']['input']>;
    zuid: Scalars['String']['input'];
};

/** query */
export type QueryzimGetConversationArgs = {
    conversationId: Scalars['String']['input'];
};

/** query */
export type QueryzoUpsellDisplayInfoArgs = {
    checkLevel?: InputMaybe<Scalars['Int']['input']>;
    placementId?: InputMaybe<Scalars['String']['input']>;
    surfaceId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryIntent = 'COLLECTIONS';

export type QueryResolutionStatus = 'FAILED' | 'FULL_RESOLUTION' | 'PARTIAL_RESOLUTION';

export type QueryTypeOption =
    | 'EMAIL_HOMES_FOR_YOU'
    | 'HOMES_FOR_YOU'
    | 'HOMES_FOR_YOU_MIX'
    | 'RECENTLY_VIEWED_FAVORITE_HOMES'
    | 'RENTAL_HOMES_AND_BUILDINGS_FOR_YOU'
    | 'RENTAL_HOMES_FOR_YOU'
    | 'SIMILAR_HOMES';

export type Question = {
    answerType?: Maybe<AnswerType>;
    id?: Maybe<Scalars['ID']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    shortLabel?: Maybe<Scalars['String']['output']>;
};

export type QuestionMeta = {
    categories?: Maybe<Array<Maybe<Category>>>;
    isVoiEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type QuestionReason = {
    /**
     * **Definition:** Question reason copy
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Scalars['String']['output'];
    /**
     * **Definition:** Question reason ID
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    questionReasonId: Scalars['ID']['output'];
};

export type QuestionReasonsSet = {
    /**
     * **Definition:** Question description copy
     * **Datasource:** N/A (constant)
     *
     * **Team Slack:** #theclosers
     */
    description?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Question title copy
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    questionTitle?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Set of reasons for Alan to select in response to question
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    reasons: Array<QuestionReason>;
};

export type QuestionWithAnswer = {
    answer: Scalars['String']['input'];
    question: Scalars['String']['input'];
};

export type QuestionnaireAnswers = {
    /**  Contact Info of Sebastian  */
    contactInfo?: Maybe<MisoContactInfo>;
    /**  Sebastian answers  */
    questionnaireAnswersJson?: Maybe<QuestionnaireAnswersJson>;
    /**  The questionnaire response Id  */
    responseId: Scalars['ID']['output'];
    /**  Status of the questionnaire responses  */
    status?: Maybe<QuestionnaireAnswersStatus>;
    /**  The standard Zillow Property Id  */
    zpid: Scalars['Int']['output'];
};

export type QuestionnaireAnswersAndOffers = {
    /**  Sebastian BUY side Questionnaire Responses Id  */
    buysideResponseId?: Maybe<Scalars['ID']['output']>;
    /**  eligibilityType for miso offers  */
    eligibilityType?: Maybe<EligibilityType>;
    /**  miso dashboard url, not persisted in DB constructed at runtime */
    misoDashboardUrl: Scalars['String']['output'];
    /**  Opendoor and SCMA offer details  */
    offers: Offers;
    /**  Sebastian Questionnaire Responses  */
    questionnaireAnswers: QuestionnaireAnswersExt;
    /**  Sebastian Responses for both SELL and BUY Questionnaire  */
    questionnaireAnswersArray?: Maybe<Array<Maybe<NullableQuestionnaireAnswersExt>>>;
    /**  Sebastian SELL side Questionnaire Responses Id  */
    responseId: Scalars['ID']['output'];
    /**  zpid of property for this offer  */
    zpid?: Maybe<Scalars['Int']['output']>;
};

export type QuestionnaireAnswersExt = {
    /**  Contact Info of Sebastian  */
    contactInfo: MisoContactInfo;
    /**  Sebastian answers  */
    questionnaireAnswersJson: QuestionnaireAnswersJsonExt;
    /**  The questionnaire response Id  */
    responseId: Scalars['ID']['output'];
    /**  Status of the questionnaire responses  */
    status: QuestionnaireAnswersStatus;
    /**  The standard Zillow Property Id  */
    zpid: Scalars['Int']['output'];
};

export type QuestionnaireAnswersInput = {
    /**  Contact Info of Sebastian  */
    contactInfo?: InputMaybe<ContactInfoInput>;
    /**  Questionnaire schema and answers   */
    questionnaireAnswersJson?: InputMaybe<QuestionnaireAnswersJsonInput>;
    /**  Unique ID for the Sebastian answers  */
    responseId: Scalars['ID']['input'];
    /**  Status of Questionnaire Submission Process  */
    status?: InputMaybe<QuestionnaireAnswersStatus>;
    /**  The standard Zillow Property Id  */
    zpid: Scalars['Int']['input'];
};

export type QuestionnaireAnswersJson = {
    /**  Sebastian answers to the questionnaire */
    responses: Scalars['JSON']['output'];
    /**  The questionnaire schema key ex:MISO_ATL  */
    schemaKey: Scalars['String']['output'];
    /**  The questionnaire schema version  */
    schemaVersion: Scalars['String']['output'];
};

export type QuestionnaireAnswersJsonExt = {
    /**  Sebastian answers to the questionnaire */
    responses?: Maybe<Array<Maybe<ResponseDetails>>>;
    /**  The questionnaire schema key ex:MISO_ATL  */
    schemaKey: Scalars['String']['output'];
    /**  The questionnaire schema version  */
    schemaVersion: Scalars['String']['output'];
};

export type QuestionnaireAnswersJsonInput = {
    /**  Sebastian answers to the questionnaire */
    responses: Scalars['JSON']['input'];
    /**  The questionnaire schema key ex:MISO_ATL  */
    schemaKey: Scalars['String']['input'];
    /**  The questionnaire schema version  */
    schemaVersion: Scalars['String']['input'];
};

export type QuestionnaireAnswersStatus = 'COMPLETED' | 'IN_PROGRESS';

export type QuestionnaireFormInput = {
    questionsWithAnswers: Array<QuestionWithAnswer>;
};

export type QuestionnaireInput = {
    mappingSchema: Scalars['JSON']['input'];
    questionnaireSchema: Scalars['JSON']['input'];
    /**  Unique key for the Questionnaire schema  */
    schemaKey: Scalars['String']['input'];
    /**  Schema version for the Questionnaire schema  */
    schemaVersion: Scalars['String']['input'];
    /**  User email or System name making this request. Ex: System This field will be mapped to createdBy or updatedBy fields in database  */
    user: Scalars['String']['input'];
};

export type QuestionsAnswersInfo = {
    qandAs?: Maybe<Array<Maybe<QandA>>>;
};

export type RESOAssociations = {
    associationId?: Maybe<Scalars['Int']['output']>;
    fee?: Maybe<Scalars['Float']['output']>;
    feeFrequency?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
};

/**
 * Facts and features, collected into names based on the Real Estate Standard
 * Organization (RESO) data dictionary
 * (https://ddwiki.reso.org/display/DDW17/RESO+Data+Dictionary+Wiki+v1.7)
 */
export type RESOFacts = {
    aboveGradeFinishedArea?: Maybe<Scalars['String']['output']>;
    accessibilityFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    additionalFeeInfo?: Maybe<Scalars['String']['output']>;
    additionalParcelsDescription?: Maybe<Scalars['String']['output']>;
    allowedPets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    appliances?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    architecturalStyle?: Maybe<Scalars['String']['output']>;
    associationAmenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    associationFee?: Maybe<Scalars['String']['output']>;
    associationFee2?: Maybe<Scalars['String']['output']>;
    associationFeeIncludes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    associationName?: Maybe<Scalars['String']['output']>;
    associationName2?: Maybe<Scalars['String']['output']>;
    associationPhone?: Maybe<Scalars['String']['output']>;
    associationPhone2?: Maybe<Scalars['String']['output']>;
    associations?: Maybe<Array<Maybe<RESOAssociations>>>;
    atAGlanceFacts?: Maybe<Array<Maybe<FactType>>>;
    attic?: Maybe<Scalars['String']['output']>;
    availabilityDate?: Maybe<Scalars['DateTime']['output']>;
    basement?: Maybe<Scalars['String']['output']>;
    basementYN?: Maybe<Scalars['Boolean']['output']>;
    bathrooms?: Maybe<Scalars['Int']['output']>;
    bathroomsFloat?: Maybe<Scalars['Float']['output']>;
    bathroomsFull?: Maybe<Scalars['Int']['output']>;
    bathroomsHalf?: Maybe<Scalars['Int']['output']>;
    bathroomsOneQuarter?: Maybe<Scalars['Int']['output']>;
    bathroomsPartial?: Maybe<Scalars['Int']['output']>;
    bathroomsThreeQuarter?: Maybe<Scalars['Int']['output']>;
    bedrooms?: Maybe<Scalars['Int']['output']>;
    belowGradeFinishedArea?: Maybe<Scalars['String']['output']>;
    bodyType?: Maybe<Scalars['String']['output']>;
    builderModel?: Maybe<Scalars['String']['output']>;
    builderName?: Maybe<Scalars['String']['output']>;
    buildingArea?: Maybe<Scalars['String']['output']>;
    buildingAreaSource?: Maybe<Scalars['String']['output']>;
    buildingFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    buildingName?: Maybe<Scalars['String']['output']>;
    buyerAgencyCompensation?: Maybe<Scalars['String']['output']>;
    buyerAgencyCompensationType?: Maybe<Scalars['String']['output']>;
    canRaiseHorses?: Maybe<Scalars['Boolean']['output']>;
    carportParkingCapacity?: Maybe<Scalars['Float']['output']>;
    /** @deprecated Source field type is double, not integer */
    carportSpaces?: Maybe<Scalars['Int']['output']>;
    cityRegion?: Maybe<Scalars['String']['output']>;
    commonWalls?: Maybe<Scalars['String']['output']>;
    communityFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    compensationBasedOn?: Maybe<Scalars['String']['output']>;
    constructionMaterials?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    contingency?: Maybe<Scalars['String']['output']>;
    cooling?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    coveredParkingCapacity?: Maybe<Scalars['Float']['output']>;
    /** @deprecated Source field type is double, not integer */
    coveredSpaces?: Maybe<Scalars['Int']['output']>;
    cropsIncludedYN?: Maybe<Scalars['Boolean']['output']>;
    cumulativeDaysOnMarket?: Maybe<Scalars['String']['output']>;
    daysOnZillow?: Maybe<Scalars['Int']['output']>;
    depositsAndFees?: Maybe<Scalars['Int']['output']>;
    developmentStatus?: Maybe<Scalars['String']['output']>;
    doorFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    electric?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    elementarySchool?: Maybe<Scalars['String']['output']>;
    elementarySchoolDistrict?: Maybe<Scalars['String']['output']>;
    elevation?: Maybe<Scalars['Int']['output']>;
    elevationUnits?: Maybe<Scalars['String']['output']>;
    entryLevel?: Maybe<Scalars['String']['output']>;
    entryLocation?: Maybe<Scalars['String']['output']>;
    exclusions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    exteriorFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    feesAndDues?: Maybe<Array<Maybe<FeesAndDues>>>;
    fencing?: Maybe<Scalars['String']['output']>;
    fireplaceFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    fireplaces?: Maybe<Scalars['Int']['output']>;
    flooring?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    foundationArea?: Maybe<Scalars['Int']['output']>;
    foundationDetails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    frontageLength?: Maybe<Scalars['String']['output']>;
    frontageType?: Maybe<Scalars['String']['output']>;
    furnished?: Maybe<Scalars['Boolean']['output']>;
    garageParkingCapacity?: Maybe<Scalars['Float']['output']>;
    /** @deprecated Source field type is double, not integer */
    garageSpaces?: Maybe<Scalars['Int']['output']>;
    gas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    greenBuildingVerificationType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    greenEnergyEfficient?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    greenEnergyGeneration?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    greenIndoorAirQuality?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    greenSustainability?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    greenWaterConservation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    hasAdditionalParcels?: Maybe<Scalars['Boolean']['output']>;
    hasAssociation?: Maybe<Scalars['Boolean']['output']>;
    hasAttachedGarage?: Maybe<Scalars['Boolean']['output']>;
    hasAttachedProperty?: Maybe<Scalars['Boolean']['output']>;
    hasCarport?: Maybe<Scalars['Boolean']['output']>;
    hasCooling?: Maybe<Scalars['Boolean']['output']>;
    hasElectricOnProperty?: Maybe<Scalars['Boolean']['output']>;
    hasFireplace?: Maybe<Scalars['Boolean']['output']>;
    hasGarage?: Maybe<Scalars['Boolean']['output']>;
    hasHeating?: Maybe<Scalars['Boolean']['output']>;
    hasHomeWarranty?: Maybe<Scalars['Boolean']['output']>;
    hasLandLease?: Maybe<Scalars['Boolean']['output']>;
    hasOpenParking?: Maybe<Scalars['Boolean']['output']>;
    hasPetsAllowed?: Maybe<Scalars['Boolean']['output']>;
    hasPrivatePool?: Maybe<Scalars['Boolean']['output']>;
    hasRentControl?: Maybe<Scalars['Boolean']['output']>;
    hasSpa?: Maybe<Scalars['Boolean']['output']>;
    hasView?: Maybe<Scalars['Boolean']['output']>;
    hasWaterfrontView?: Maybe<Scalars['Boolean']['output']>;
    heating?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    highSchool?: Maybe<Scalars['String']['output']>;
    highSchoolDistrict?: Maybe<Scalars['String']['output']>;
    hoaFee?: Maybe<Scalars['String']['output']>;
    hoaFeeTotal?: Maybe<Scalars['String']['output']>;
    homeType?: Maybe<Scalars['String']['output']>;
    horseAmenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    horseYN?: Maybe<Scalars['Boolean']['output']>;
    inclusions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    incomeIncludes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    interiorFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    irrigationWaterRightsAcres?: Maybe<Scalars['Int']['output']>;
    irrigationWaterRightsYN?: Maybe<Scalars['Boolean']['output']>;
    isForRent?: Maybe<Scalars['Boolean']['output']>;
    isNewConstruction?: Maybe<Scalars['Boolean']['output']>;
    isSeniorCommunity?: Maybe<Scalars['Boolean']['output']>;
    isSmokingAllowed?: Maybe<Scalars['String']['output']>;
    landLeaseAmount?: Maybe<Scalars['String']['output']>;
    landLeaseExpirationDate?: Maybe<Scalars['DateTime']['output']>;
    laundryFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    leaseTerm?: Maybe<Scalars['String']['output']>;
    levels?: Maybe<Scalars['String']['output']>;
    listAOR?: Maybe<Scalars['String']['output']>;
    listTeamName?: Maybe<Scalars['String']['output']>;
    listingId?: Maybe<Scalars['String']['output']>;
    listingTerms?: Maybe<Scalars['String']['output']>;
    livingArea?: Maybe<Scalars['String']['output']>;
    livingAreaRange?: Maybe<Scalars['String']['output']>;
    livingAreaRangeUnits?: Maybe<Scalars['String']['output']>;
    livingQuarters?: Maybe<Array<Maybe<LivingQuarterType>>>;
    lotFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    lotSize?: Maybe<Scalars['String']['output']>;
    lotSizeDimensions?: Maybe<Scalars['String']['output']>;
    mainLevelBathrooms?: Maybe<Scalars['Int']['output']>;
    mainLevelBedrooms?: Maybe<Scalars['Int']['output']>;
    marketingType?: Maybe<Scalars['String']['output']>;
    middleOrJuniorSchool?: Maybe<Scalars['String']['output']>;
    middleOrJuniorSchoolDistrict?: Maybe<Scalars['String']['output']>;
    municipality?: Maybe<Scalars['String']['output']>;
    numberOfUnitsInCommunity?: Maybe<Scalars['Int']['output']>;
    numberOfUnitsVacant?: Maybe<Scalars['Int']['output']>;
    offerReview?: Maybe<Scalars['String']['output']>;
    offerReviewDate?: Maybe<Scalars['String']['output']>;
    onMarketDate?: Maybe<Scalars['DateTime']['output']>;
    oneTimeFees?: Maybe<Scalars['Int']['output']>;
    openParkingCapacity?: Maybe<Scalars['Float']['output']>;
    /** @deprecated Source field type is double, not integer */
    openParkingSpaces?: Maybe<Scalars['Int']['output']>;
    otherEquipment?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    otherFacts?: Maybe<Array<Maybe<RESOOtherFact>>>;
    otherParking?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    otherStructures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    ownership?: Maybe<Scalars['String']['output']>;
    ownershipType?: Maybe<Scalars['String']['output']>;
    parcelNumber?: Maybe<Scalars['String']['output']>;
    parkName?: Maybe<Scalars['String']['output']>;
    /** @deprecated Source field type is double, not integer */
    parking?: Maybe<Scalars['Int']['output']>;
    parkingCapacity?: Maybe<Scalars['Float']['output']>;
    parkingFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    patioAndPorchFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    petsAllowed?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    petsMaxWeight?: Maybe<Scalars['Int']['output']>;
    poolFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    pricePerSquareFoot?: Maybe<Scalars['Int']['output']>;
    propertyCondition?: Maybe<Scalars['String']['output']>;
    propertySubType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    publicRemarks?: Maybe<Scalars['String']['output']>;
    roadSurfaceType?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    roofType?: Maybe<Scalars['String']['output']>;
    rooms?: Maybe<Array<Maybe<RESORoom>>>;
    securityFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    sewer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    spaFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    specialListingConditions?: Maybe<Scalars['String']['output']>;
    stories?: Maybe<Scalars['Int']['output']>;
    storiesTotal?: Maybe<Scalars['Int']['output']>;
    structureType?: Maybe<Scalars['String']['output']>;
    subAgencyCompensation?: Maybe<Scalars['String']['output']>;
    subAgencyCompensationType?: Maybe<Scalars['String']['output']>;
    subdivisionName?: Maybe<Scalars['String']['output']>;
    taxAnnualAmount?: Maybe<Scalars['Int']['output']>;
    taxAssessedValue?: Maybe<Scalars['Int']['output']>;
    tenantPays?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    topography?: Maybe<Scalars['String']['output']>;
    totalActualRent?: Maybe<Scalars['Int']['output']>;
    transactionBrokerCompensation?: Maybe<Scalars['String']['output']>;
    transactionBrokerCompensationType?: Maybe<Scalars['String']['output']>;
    utilities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    vegetation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    view?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    virtualTour?: Maybe<Scalars['String']['output']>;
    virtualTourURLUnbranded?: Maybe<Scalars['String']['output']>;
    waterBodyName?: Maybe<Scalars['String']['output']>;
    waterSource?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    waterSources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    waterView?: Maybe<Scalars['String']['output']>;
    waterViewYN?: Maybe<Scalars['Boolean']['output']>;
    waterfrontFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    windowFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    woodedArea?: Maybe<Scalars['Int']['output']>;
    yearBuilt?: Maybe<Scalars['Int']['output']>;
    yearBuiltEffective?: Maybe<Scalars['Int']['output']>;
    zoning?: Maybe<Scalars['String']['output']>;
    zoningDescription?: Maybe<Scalars['String']['output']>;
};

export type RESOOtherFact = {
    name?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type RESORoom = {
    area?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    dimensions?: Maybe<Scalars['String']['output']>;
    features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    length?: Maybe<Scalars['String']['output']>;
    level?: Maybe<Scalars['String']['output']>;
    roomArea?: Maybe<Scalars['String']['output']>;
    roomAreaSource?: Maybe<Scalars['String']['output']>;
    roomAreaUnits?: Maybe<Scalars['String']['output']>;
    roomDescription?: Maybe<Scalars['String']['output']>;
    roomDimensions?: Maybe<Scalars['String']['output']>;
    roomFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    roomLength?: Maybe<Scalars['String']['output']>;
    roomLengthWidthSource?: Maybe<Scalars['String']['output']>;
    roomLengthWidthUnits?: Maybe<Scalars['String']['output']>;
    roomLevel?: Maybe<Scalars['String']['output']>;
    roomType?: Maybe<RESORoomType>;
    roomWidth?: Maybe<Scalars['String']['output']>;
    width?: Maybe<Scalars['String']['output']>;
};

export type RESORoomType =
    | 'Basement'
    | 'Bathroom'
    | 'Bathroom1'
    | 'Bathroom2'
    | 'Bathroom3'
    | 'Bathroom4'
    | 'Bathroom5'
    | 'Bedroom'
    | 'Bedroom1'
    | 'Bedroom2'
    | 'Bedroom3'
    | 'Bedroom4'
    | 'Bedroom5'
    | 'BonusRoom'
    | 'BreakfastNook'
    | 'Den'
    | 'DiningRoom'
    | 'ExerciseRoom'
    | 'FamilyRoom'
    | 'GameRoom'
    | 'Garage'
    | 'GreatRoom'
    | 'GuestRoom'
    | 'Gym'
    | 'Kitchen'
    | 'Laundry'
    | 'LaundryRoom'
    | 'Library'
    | 'LivingRoom'
    | 'Loft'
    | 'MasterBathroom'
    | 'MasterBedroom'
    | 'MediaRoom'
    | 'MudRoom'
    | 'Office'
    | 'Pantry'
    | 'PrimaryBathroom'
    | 'PrimaryBedroom'
    | 'RecreationRoom'
    | 'Sauna'
    | 'SolariumAtrium'
    | 'Study'
    | 'SunRoom'
    | 'UtilityRoom'
    | 'WalkInCloset'
    | 'Workshop';

export type RHViewer = {
    /** @deprecated This is proxied to GDP from before GDP was federated. This migration is to support mobile usage. Otherwise, use `Query.viewer` instead. */
    name?: Maybe<Scalars['String']['output']>;
    /** @deprecated This is proxied to GDP from before GDP was federated. This migration is to support mobile usage. Otherwise, use `Query.viewer` instead. */
    screenName?: Maybe<Scalars['String']['output']>;
};

export type RMXData = {
    /** Floor plan */
    floorPlan?: Maybe<PSLFloorPlan>;
    /** Integrated Media eXperience */
    imx?: Maybe<Imx>;
    /** LMS Agent identifier who purchased the media */
    listingMediaServiceAgentID?: Maybe<Scalars['ID']['output']>;
    /** Showcase availability */
    showcaseAvailable?: Maybe<ShowcaseAvailableData>;
    /** Virtual tour */
    virtualTour?: Maybe<PSLVirtualTour>;
};

export type RadioQuestion = Question & {
    answerType?: Maybe<AnswerType>;
    choices?: Maybe<Array<Maybe<Choice>>>;
    help?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    shortLabel?: Maybe<Scalars['String']['output']>;
};

/** The ratings information for the given partner agent */
export type Ratings = {
    average?: Maybe<Scalars['Float']['output']>;
    count?: Maybe<Scalars['Int']['output']>;
};

export type ReadyToDiscussFinancingStatus = 'NO' | 'UNSPECIFIED' | 'YES';

/** A recommendation from the realtime recommendations service */
export type RealtimeRecomendation = {
    /** The suggested hero image for the recommendation */
    heroImage?: Maybe<RecsHeroImage>;
    /** The reccomendation type and value (ie zpid) */
    id?: Maybe<RecId>;
    /** The tags associated with the recommended property */
    recsTags?: Maybe<Array<Maybe<RecsTag>>>;
};

/** An id for the recomendation containing the type (ie zpid) and value */
export type RecId = {
    /** Type of property id (ie zpid) */
    type: Scalars['String']['output'];
    /** Value of the property id */
    value: Scalars['String']['output'];
};

export type ReceivedCoapplicantInvitation = {
    id?: Maybe<Scalars['ID']['output']>;
    invitedBy?: Maybe<InvitedByContactInfo>;
};

export type RecentlyViewedHome = {
    property?: Maybe<Property>;
    propertyId?: Maybe<Scalars['String']['output']>;
    viewedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type Recommendation = {
    property: Property;
    /** Score for recommendation result, the higher the score reflect better recommendation */
    score?: Maybe<Scalars['Float']['output']>;
    trackingTags?: Maybe<trackingTags>;
    zpid?: Maybe<Scalars['Int']['output']>;
};

export type RecommendedOfferType = 'OPENDOOR' | 'PARTNER_AGENT';

/** The suggested hero image for the recommendation */
export type RecsHeroImage = {
    /** Default image size (p_g) url */
    defaultLink?: Maybe<Scalars['String']['output']>;
    /** High resolution image size (p_f) url */
    highResolutionLink?: Maybe<Scalars['String']['output']>;
    /** ID of the image */
    id?: Maybe<Scalars['String']['output']>;
    /** Medium image size (p_c) url */
    mediumSizeLink?: Maybe<Scalars['String']['output']>;
};

/** A core interface for recommended modules (collections, upsells, etc) */
export type RecsModule = {
    /** Content Type included in the module (UPSELL_ZHL, etc). */
    contentType?: Maybe<CollectionContentType>;
};

/** A tag associated with a property or request */
export type RecsTag = {
    /** Type/name of tag (ie home_insights) */
    type: Scalars['String']['output'];
    /** Value of the tag (ie pool) */
    value: Scalars['String']['output'];
};

export type ReferenceContactInfo = {
    email?: Maybe<Scalars['EmailAddress']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

/** Input schema for the list of referenceIds used to search for tasks */
export type ReferenceIdsInput = {
    /** LOB reference ID that links task to LOB processes */
    referenceId: Scalars['String']['input'];
    /** Type of reference ID e.g. ZHLID or MoveID */
    referenceType: Scalars['String']['input'];
};

export type RefinanceCashOutType = 'Other' | 'StudentLoanRepayment';

export type Region = Node & {
    /** List of alternative names for the region which does not include the primary name */
    alternateNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Subdivision amenities */
    amenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    body?: Maybe<RegionBody>;
    builderDirectoryUrl?: Maybe<UrlObjectType>;
    /** Building-related search page url and text description for this region */
    buildingSearchUrl?: Maybe<UrlObjectType>;
    centroid?: Maybe<RegionCentroid>;
    /** State and county level Federal Information Processing System (FIPS) Codes */
    fips?: Maybe<Scalars['Int']['output']>;
    /** 1-year forecast of median price */
    forecast?: Maybe<Scalars['Float']['output']>;
    /** The full geometric representation of the region in the form of a WKT */
    geom?: Maybe<Scalars['String']['output']>;
    /** The type of geometry being represented by the `geom` */
    geometryType?: Maybe<GeometryType>;
    homeValues?: Maybe<HomeValuesResponse>;
    /** Home values time series includes last 10 years' monthly data. */
    homeValuesTimeSeries?: Maybe<Array<Maybe<HomeValueTimeSeriesPoint>>>;
    housingDeveloper?: Maybe<HousingDeveloper>;
    /** The ID of an object */
    id: Scalars['ID']['output'];
    /** Trulia unique ID for every region */
    locationId?: Maybe<Scalars['Int']['output']>;
    /** The minimum bounding rectangle for the region in the form of a WKT */
    mbr?: Maybe<Scalars['String']['output']>;
    /** Primary name of the region of interest */
    name?: Maybe<Scalars['String']['output']>;
    parentCity?: Maybe<Region>;
    parentCounty?: Maybe<Region>;
    parentDmaId?: Maybe<Scalars['Int']['output']>;
    parentState?: Maybe<Region>;
    /** List of all parents with minimum identifying information provided */
    parentage?: Maybe<Array<Maybe<RegionParentageType>>>;
    /** Rough population of the region */
    population?: Maybe<Scalars['Int']['output']>;
    /** Region-specific descriptions. The contents come from thirty party. */
    profile?: Maybe<Profile>;
    /** Zillow unique ID for every region */
    regionId?: Maybe<Scalars['Int']['output']>;
    /** The region type, as an int, as a string? */
    regionType?: Maybe<Scalars['String']['output']>;
    regionTypeName?: Maybe<Scalars['String']['output']>;
    /** Search page url and text description to this region */
    regionUrl?: Maybe<UrlObjectType>;
    rid?: Maybe<Scalars['Int']['output']>;
    /**
     * Elementary, middle and high schools in this region.
     * @deprecated Functionality has not been used for years.
     */
    schools?: Maybe<Array<Maybe<RegionSchool>>>;
    /** Subdivision video tour URLs */
    videoTours?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** Median price of the region */
    zindex?: Maybe<Scalars['Float']['output']>;
    /** Median price per square foot in the region */
    zindexSqFt?: Maybe<Scalars['Float']['output']>;
};

export type RegionhomeValuesArgs = {
    dataTypeIds?: InputMaybe<Array<InputMaybe<HomeValuesDataTypeId>>>;
};

export type RegionhomeValuesTimeSeriesArgs = {
    dataTypeId?: InputMaybe<HomeValuesDataTypeId>;
    metricTypeId?: InputMaybe<HomeValuesMetricTypeId>;
};

export type RegionprofileArgs = {
    city?: InputMaybe<Scalars['String']['input']>;
    neighborhood?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    version?: InputMaybe<Scalars['String']['input']>;
};

export type RegionschoolsArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
    level?: InputMaybe<SCHOOL_LEVEL>;
};

export type RegionBody = {
    borough?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    community?: Maybe<Scalars['String']['output']>;
    county?: Maybe<Scalars['String']['output']>;
    metro?: Maybe<Scalars['String']['output']>;
    neighborhood?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    subdivision?: Maybe<Scalars['String']['output']>;
    zipcode?: Maybe<Scalars['String']['output']>;
};

export type RegionCentroid = {
    latitude?: Maybe<Scalars['Float']['output']>;
    longitude?: Maybe<Scalars['Float']['output']>;
};

export type RegionId = {
    /** The region ID */
    regionId: Scalars['ID']['input'];
    /** The category that this region id belongs to */
    regionIdType: RegionIdType;
};

export type RegionIdType =
    | 'BOROUGH'
    | 'CITY'
    | 'COUNTY'
    | 'FLEX'
    | 'NEIGHBORHODD'
    | 'STATE'
    | 'SUBDIVISION'
    | 'ZIPCODE';

/** Region ids where the building is located */
export type RegionIds = {
    borough?: Maybe<Scalars['Int']['output']>;
    city?: Maybe<Scalars['Int']['output']>;
    county?: Maybe<Scalars['Int']['output']>;
    neighborhood?: Maybe<Scalars['Int']['output']>;
    state?: Maybe<Scalars['Int']['output']>;
    zipcode?: Maybe<Scalars['Int']['output']>;
};

export type RegionParentageType = {
    /** Trulia unique ID for every region */
    locationId?: Maybe<Scalars['Int']['output']>;
    /** Primary name of the region of interest */
    name?: Maybe<Scalars['String']['output']>;
    /** Zillow unique ID for every region */
    regionId?: Maybe<Scalars['Int']['output']>;
    regionType?: Maybe<Scalars['String']['output']>;
};

export type RegionSchool = {
    grades?: Maybe<Scalars['String']['output']>;
    level?: Maybe<Scalars['String']['output']>;
    link?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    /** rating out of 10 */
    rating?: Maybe<Scalars['Int']['output']>;
    size?: Maybe<Scalars['Int']['output']>;
    studentsPerTeacher?: Maybe<Scalars['Int']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

export type RegionType = 'CENTRO_ID' | 'CUSTOM_POLYGON' | 'STANDARD_ID';

export type Relationship = {
    profile?: Maybe<UserData>;
    type?: Maybe<Scalars['String']['output']>;
};

export type RelaxedResults = {
    /** The distance expanded from the original search region to get relaxed results */
    expansionDistance: Scalars['Int']['output'];
    /** A list of relaxed property results */
    results?: Maybe<Array<PropertyResult>>;
};

export type RemoveAppliedPropertyTagInput = {
    /**  property identifier  */
    propertyId: Scalars['ID']['input'];
    /**  property identifier type, PTS supports zpid only */
    propertyIdType: PropertyIdType;
    /**  property tag identifier  */
    propertyTagId: Scalars['ID']['input'];
};

export type RemoveSavedHomeCategoryInput = {
    /**  the category of this saved home  */
    category: Scalars['String']['input'];
    /**  property identifier  */
    propertyId: Scalars['ID']['input'];
    /**  the type of property id  */
    propertyIdType: PropertyIdType;
};

export type RemoveSavedHomeInput = {
    /**  property id  */
    propertyId: Scalars['ID']['input'];
    /**  the type of property id  */
    propertyIdType: PropertyIdType;
};

export type RentAmountChangeRequest = {
    effectiveDueDate?: Maybe<Scalars['String']['output']>;
    effectiveScheduleMonth?: Maybe<Scalars['String']['output']>;
    expired?: Maybe<Scalars['Boolean']['output']>;
    newAmount?: Maybe<Scalars['String']['output']>;
    renterAcceptanceDate?: Maybe<Scalars['String']['output']>;
};

export type RentGuaranteeLegalDisclaimer = {
    description?: Maybe<Array<Maybe<StyledText>>>;
    header?: Maybe<Scalars['String']['output']>;
};

export type RentTerms = {
    address?: Maybe<Scalars['String']['output']>;
    amount?: Maybe<Scalars['Int']['output']>;
    firstDueDate?: Maybe<Scalars['String']['output']>;
    monthToMonth?: Maybe<Scalars['Boolean']['output']>;
    numberOfPayments?: Maybe<Scalars['Int']['output']>;
    rentAmountChangeRequest?: Maybe<RentAmountChangeRequest>;
};

export type RentalApplication = {
    answers?: Maybe<Answers>;
    applicationStatus?: Maybe<ApplicationStatus>;
    declinedDateTime?: Maybe<Scalars['DateTime']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    invitedDateTime?: Maybe<Scalars['DateTime']['output']>;
    invitedToMoveInDateTime?: Maybe<Scalars['DateTime']['output']>;
    ireneViewedDateTime?: Maybe<Scalars['DateTime']['output']>;
    isArchived?: Maybe<Scalars['Boolean']['output']>;
    isPrimaryApplicant?: Maybe<Scalars['Boolean']['output']>;
    listingOwner?: Maybe<ListingOwner>;
    /** @deprecated Use RentalApplication.applicationStatus */
    overallStatus?: Maybe<ApplicationStatus>;
    price?: Maybe<Scalars['USCurrency']['output']>;
    rentalListing?: Maybe<RentalListing>;
    startedDateTime?: Maybe<Scalars['DateTime']['output']>;
    status?: Maybe<ApplicantStatus>;
    statusLastViewedByRachel?: Maybe<Scalars['DateTime']['output']>;
    submittedDateTime?: Maybe<Scalars['DateTime']['output']>;
    withdrawnDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type RentalApplicationAddress = {
    city?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    street?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['ZipCode']['output']>;
};

export type RentalApplicationAddressInput = {
    city?: InputMaybe<Scalars['NonEmptyString']['input']>;
    state?: InputMaybe<Scalars['NonEmptyString']['input']>;
    street?: InputMaybe<Scalars['NonEmptyString']['input']>;
    zip?: InputMaybe<Scalars['ZipCode']['input']>;
};

export type RentalApplicationSection = 'applicant' | 'background' | 'credit';

export type RentalApplicationsAcceptedType = 'APPLY_NOW' | 'NOT_ELIGIBLE' | 'REQUEST_TO_APPLY';

export type RentalAvailabilityDate = {
    /**
     * Flag determining whether
     * to return properties with no availability dates
     */
    excludeNullAvailabilityDates?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * Used to get properties with availability dates
     * on or before the requested availability date
     */
    requestedAvailabilityDate?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type RentalBuildingInfo = {
    availableRentalUnitsSummary?: Maybe<BuildingUnitsSummarySnapshot>;
    buildingType?: Maybe<Scalars['String']['output']>;
    geoAttributes?: Maybe<GeoAttributes>;
    lotId?: Maybe<Scalars['GraphQLLong']['output']>;
    propertyTypes?: Maybe<Array<Scalars['String']['output']>>;
    providerListingId?: Maybe<Scalars['String']['output']>;
    sortedRentalUnit?: Maybe<BuildingUnit>;
};

export type RentalCurrentResidence = CurrentResidence &
    RentalResidence &
    Residence & {
        address?: Maybe<RentalApplicationAddress>;
        id?: Maybe<Scalars['ID']['output']>;
        manager?: Maybe<ManagerContactInfo>;
        monthlyPayment?: Maybe<Scalars['USCurrency']['output']>;
        startDate?: Maybe<Scalars['Date']['output']>;
        type?: Maybe<ResidenceType>;
    };

export type RentalFloorplans = {
    active?: Maybe<Scalars['Boolean']['output']>;
    aliasEncoded?: Maybe<Scalars['String']['output']>;
    distanceInMiles?: Maybe<Scalars['Float']['output']>;
    floorplanGroupId?: Maybe<Scalars['String']['output']>;
    geo?: Maybe<geo>;
    highPrice?: Maybe<Scalars['Int']['output']>;
    history?: Maybe<RentalHistory>;
    lowPrice?: Maybe<Scalars['Int']['output']>;
    maxSqft?: Maybe<Scalars['Int']['output']>;
    minSqft?: Maybe<Scalars['Int']['output']>;
    numBeds?: Maybe<Scalars['Int']['output']>;
    numFullBaths?: Maybe<Scalars['Int']['output']>;
    numPartialBaths?: Maybe<Scalars['Int']['output']>;
    numUnitsAvailable?: Maybe<Scalars['Int']['output']>;
    zestimate?: Maybe<RentalZestimate>;
};

export type RentalHistory = {
    activated?: Maybe<rentalUpdate>;
    deactivated?: Maybe<rentalUpdate>;
    lastUpdated?: Maybe<rentalUpdate>;
};

export type RentalInstantTour = {
    durationMinutes?: Maybe<Scalars['Int']['output']>;
    endTime?: Maybe<Scalars['String']['output']>;
    schedulingStatus?: Maybe<Scalars['String']['output']>;
    startTime?: Maybe<Scalars['String']['output']>;
    supportsCancel?: Maybe<Scalars['Boolean']['output']>;
    tourId?: Maybe<Scalars['String']['output']>;
    tourType?: Maybe<Scalars['String']['output']>;
};

export type RentalListing = {
    address?: Maybe<RentalApplicationAddress>;
    bathrooms?: Maybe<Scalars['NonNegativeFloat']['output']>;
    bedrooms?: Maybe<Scalars['NonNegativeInt']['output']>;
    contact?: Maybe<RentalListingContactDetails>;
    id?: Maybe<Scalars['ID']['output']>;
    invitationsToApply?: Maybe<Array<Maybe<SentLandlordInvitation>>>;
    isDeactivated?: Maybe<Scalars['Boolean']['output']>;
    isRentGuaranteeEligible?: Maybe<Scalars['Boolean']['output']>;
    isRentGuaranteeEnabled?: Maybe<Scalars['Boolean']['output']>;
    landlordRentalApplication?: Maybe<LandlordRentalApplication>;
    landlordRentalApplications?: Maybe<Array<Maybe<LandlordRentalApplication>>>;
    listingAlias?: Maybe<Scalars['String']['output']>;
    monthlyPayment?: Maybe<Scalars['USCurrency']['output']>;
    photos?: Maybe<Array<Maybe<RentalListingPhoto>>>;
    primaryPhoto?: Maybe<RentalListingPhoto>;
    propertyType?: Maybe<PropertyType>;
    propertyUrl?: Maybe<Scalars['URL']['output']>;
    questionMeta?: Maybe<QuestionMeta>;
    receivedInvitations?: Maybe<Array<Maybe<ReceivedCoapplicantInvitation>>>;
    rentGuaranteeLegalDisclaimers?: Maybe<Array<Maybe<RentGuaranteeLegalDisclaimer>>>;
    rentGuaranteeMinimumIncomeToRentRatio?: Maybe<Scalars['Int']['output']>;
    rentalApplications?: Maybe<Array<Maybe<RentalApplication>>>;
    squareFeet?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type RentalListinglandlordRentalApplicationArgs = {
    id: Scalars['ID']['input'];
};

export type RentalListinglandlordRentalApplicationsArgs = {
    isActive?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RentalListingrentGuaranteeLegalDisclaimersArgs = {
    isFromMobileApp?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RentalListingContactDetails = {
    name?: Maybe<Scalars['String']['output']>;
};

export type RentalListingDetail = {
    agentInfo?: Maybe<AgentInfo>;
    applicationCount?: Maybe<Scalars['Int']['output']>;
    brokerImageId?: Maybe<Scalars['String']['output']>;
    contactCount?: Maybe<Scalars['Int']['output']>;
    empty?: Maybe<Scalars['Boolean']['output']>;
    isLandlordIdVerified?: Maybe<Scalars['Boolean']['output']>;
    responseRate?: Maybe<Scalars['Int']['output']>;
    responseTimeMs?: Maybe<Scalars['String']['output']>;
};

export type RentalListingDetailResponse = {
    rentalListingDetail?: Maybe<RentalListingDetail>;
    zpid?: Maybe<Scalars['String']['output']>;
};

export type RentalListingId = {
    listingIdOrAlias?: Maybe<Scalars['String']['output']>;
    zpid?: Maybe<Scalars['String']['output']>;
};

/** Contact, agent badge type, and reviews info for owner of the rental listing. */
export type RentalListingOwnerContactType = {
    /** One of Agent, Community Pillar, Premier Agent, or null */
    agentBadgeType?: Maybe<Scalars['String']['output']>;
    /** The listing agent's business name (if any) */
    businessName?: Maybe<Scalars['String']['output']>;
    /** The listing agent's display name */
    displayName?: Maybe<Scalars['String']['output']>;
    /** Broker local compliance with rules */
    isBrokerLocalCompliance?: Maybe<Scalars['Boolean']['output']>;
    /** The listing agent's contact phone number */
    phoneNumber?: Maybe<Scalars['String']['output']>;
    /** The link to download a photo for the agent */
    photoUrl?: Maybe<Scalars['String']['output']>;
    /** Average rating left by users */
    ratingAverage?: Maybe<Scalars['Float']['output']>;
    /** Number of reviews an agent has received */
    reviewsReceivedCount?: Maybe<Scalars['Int']['output']>;
    /** A link to read or write agent reviews */
    reviewsUrl?: Maybe<Scalars['String']['output']>;
};

/** The reputation data for owner of the rental listing. */
export type RentalListingOwnerReputation = {
    /** Number of applications of the listing. */
    applicationCount?: Maybe<Scalars['Int']['output']>;
    /** Number of contacts of the listing provider. */
    contactCount?: Maybe<Scalars['Int']['output']>;
    /** Is listing owner id verified? */
    isLandlordIdVerified?: Maybe<Scalars['Boolean']['output']>;
    /** Response rate the listing provider contact. */
    responseRate?: Maybe<Scalars['Float']['output']>;
    /** Response time of the listing provider contact in milliseconds. */
    responseTimeMs?: Maybe<Scalars['Int']['output']>;
};

export type RentalListingPhoto = {
    imageUrl?: Maybe<Scalars['URL']['output']>;
    thumbUrl?: Maybe<Scalars['URL']['output']>;
};

export type RentalMarketingTreatments =
    /** multifamily sales listing marketing treatment */
    | 'MULTIFAMILY_SALES_LISTING'
    /** paid rental marketing treatment */
    | 'PAID'
    /** zillow rental manager marketing treatment */
    | 'ZILLOW_RENTAL_MANAGER';

export type RentalMrkt = {
    metadataKey: Scalars['String']['output'];
    regionId: Scalars['Int']['output'];
    timePeriodEnd: Scalars['Date']['output'];
    zordi?: Maybe<Scalars['Float']['output']>;
    zori?: Maybe<Scalars['Float']['output']>;
};

export type RentalPastResidence = PastResidence &
    RentalResidence &
    Residence & {
        address?: Maybe<RentalApplicationAddress>;
        endDate?: Maybe<Scalars['Date']['output']>;
        id?: Maybe<Scalars['ID']['output']>;
        manager?: Maybe<ManagerContactInfo>;
        startDate?: Maybe<Scalars['Date']['output']>;
        type?: Maybe<ResidenceType>;
    };

export type RentalPlatformListingDetails = {
    isMultifamily?: Maybe<Scalars['Boolean']['output']>;
    landlordContactName?: Maybe<Scalars['String']['output']>;
    /** The unique malone lotId that uniquely identifies an address, including building and property */
    lotId?: Maybe<Scalars['String']['output']>;
    /** Definition: https://bitbucket.hotterpads.com/projects/RP/repos/rental-apps/browse/listing-data-model-types/src/main/java/com/hotpads/listingdatamodeltypes/enums/PropertyType.java#17-25 */
    propertyTypeCode?: Maybe<Scalars['Int']['output']>;
};

/** Rental Premium Package info for a single zpid */
export type RentalPremiumPackage = {
    /** Rental Premium Package info for a single zpid */
    premiumPackageInfo?: Maybe<PremiumPackageInfo>;
    /** PropertyType info for this specific zpid */
    property?: Maybe<Property>;
};

export type RentalProductType =
    | 'BASE_PACKAGE'
    | 'ENHANCED_PACKAGE'
    | 'FEED_CONNECT'
    | 'LEASE_CONNECT'
    | 'LEASE_UP'
    | 'PREMIUM_PACKAGE'
    | 'PREMIUM_PLUS_PACKAGE'
    | 'ZRM';

export type RentalResidence = {
    manager?: Maybe<ManagerContactInfo>;
};

export type RentalSubStatus =
    | 'UNKNOWN'
    /** Waitlist: The rental is not definitively available at this time, but is taking leads. */
    | 'WAITLIST';

export type RentalZestimate = {
    rentZestimate?: Maybe<Scalars['Int']['output']>;
    thirtyDayChange?: Maybe<Scalars['Int']['output']>;
};

export type RenterHubCardTag = {
    tagAppearance?: Maybe<Scalars['String']['output']>;
    tagText?: Maybe<Scalars['String']['output']>;
};

export type RenterHubCta = {
    /**
     * Available actions for renter hub CTA (The reason that this is not a enum is that
     * we may introduce new actions from time to time from the API side, which will cause
     * parsing errors if we use enum here)
     *
     * Examples:
     * OPEN_DETAILS_MODAL
     * EDIT_APPLICATION
     * VIEW_APPLICATION
     * SEE_NEW_MESSAGE
     * REQUEST_TO_APPLY
     * VIEW_LEASE
     * MAKE_A_PAYMENT
     * EDIT_PAYMENT
     * CONTACT_LANDLORD
     *
     * For more actions, please refer to the API documentation
     */
    action?: Maybe<Scalars['String']['output']>;
    /** The additional data related to a CTA that the client may need */
    data?: Maybe<Scalars['String']['output']>;
    /** The request body if the cta is a post request */
    requestPayload?: Maybe<Scalars['String']['output']>;
    text?: Maybe<Scalars['String']['output']>;
    /**
     * The UI treatment of the CTA
     * (May or may not be needed, we can remove this if we end up not using this)
     */
    uiType?: Maybe<RenterHubCtaUIType>;
    url?: Maybe<Scalars['String']['output']>;
};

export type RenterHubCtaUIType =
    | 'MENU_ITEM'
    | 'PRIMARY_BUTTON'
    | 'SECONDARY_BUTTON'
    | 'TEXT_BUTTON';

export type RenterHubData = {
    error?: Maybe<RenterHubDataError>;
    hasArchivedApplications?: Maybe<Scalars['Boolean']['output']>;
    rawProperties?: Maybe<Array<Maybe<RenterHubProperty>>>;
};

export type RenterHubDataError = RenterHubError & {
    errorDetails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    message: Scalars['String']['output'];
};

export type RenterHubError = {
    message: Scalars['String']['output'];
};

export type RenterHubLandlordProfile = {
    name?: Maybe<Scalars['String']['output']>;
};

export type RenterHubNotification = {
    cta?: Maybe<RenterHubCta>;
    dismissed?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['String']['output'];
    listingAlias?: Maybe<Scalars['String']['output']>;
    messagePreview?: Maybe<Scalars['String']['output']>;
    messageSenderName?: Maybe<Scalars['String']['output']>;
    primaryText?: Maybe<Scalars['String']['output']>;
    propertyId?: Maybe<Scalars['String']['output']>;
    propertyIdType?: Maybe<PropertyIdType>;
    tagAppearance?: Maybe<Scalars['String']['output']>;
    tagText?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
    unixPostedDate?: Maybe<Scalars['Timestamp']['output']>;
};

export type RenterHubNotificationCount = {
    nextStepsCount?: Maybe<Scalars['Int']['output']>;
    totalCount?: Maybe<Scalars['Int']['output']>;
    unreadMessagesCount?: Maybe<Scalars['Int']['output']>;
};

export type RenterHubNotificationParams = {
    dismissed?: InputMaybe<Scalars['Boolean']['input']>;
    id: Scalars['String']['input'];
    propertyId?: InputMaybe<Scalars['String']['input']>;
    propertyIdType?: InputMaybe<PropertyIdType>;
    type?: InputMaybe<Scalars['String']['input']>;
};

export type RenterHubProperty = {
    applicationStatuses?: Maybe<Array<Maybe<ListingApplicationStatus>>>;
    building?: Maybe<VL_BuildingSummary>;
    buildingInfo?: Maybe<VL_Building>;
    contacts?: Maybe<Array<Maybe<Conversation>>>;
    gdpProperty?: Maybe<Property>;
    leases?: Maybe<Array<Maybe<Lease>>>;
    paymentStatus?: Maybe<Payment>;
    /** @deprecated use gdpProperty instead */
    property?: Maybe<ZGProperty>;
    propertyId?: Maybe<Scalars['ID']['output']>;
    propertyIdType?: Maybe<PropertyIdType>;
    scheduledTours?: Maybe<Array<Maybe<ScheduledTour>>>;
};

export type RentersInsuranceZDocsUploadToken = {
    uploadToken?: Maybe<Scalars['String']['output']>;
};

/** An item that needs repairing in a home submitted to Zillow Offers. */
export type RepairItem = {
    estimatedCost?: Maybe<Scalars['Float']['output']>;
    group?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    quantity?: Maybe<Scalars['Int']['output']>;
};

export type RequestHighlightsInput = {
    /** Email addresses to receive requests - not validated. */
    emails: Array<Scalars['String']['input']>;
    /** Zillow property identifier. */
    zpid: Scalars['Int']['input'];
};

export type RequestHighlightsResult = {
    errorMessage?: Maybe<Scalars['String']['output']>;
};

export type RequestSellingOffersConnectionInput = {
    isODSelected: Scalars['Boolean']['input'];
    isPLSelected: Scalars['Boolean']['input'];
    misoId: Scalars['ID']['input'];
};

export type RequestTour = {
    clickstreamMetadata: SubmitFlowComponentClickstreamMetadata;
    primaryCTA: SubmitFlowCTA;
    property: RequestTourProperty;
    timeSelection: RequestTourTimeSelection;
    tip: SubmitFlowTip;
    title: Scalars['String']['output'];
};

export type RequestTourProperty = {
    address: Scalars['String']['output'];
    bathroomCount?: Maybe<Scalars['Float']['output']>;
    bedroomCount?: Maybe<Scalars['Float']['output']>;
    city: Scalars['String']['output'];
    photo?: Maybe<SubmitFlowPhoto>;
    squareFeet?: Maybe<Scalars['Float']['output']>;
    state: Scalars['String']['output'];
    zipcode: Scalars['String']['output'];
};

export type RequestTourTimeSelection = {
    availabilities: Array<PropertyTourAvailability>;
    heading: Scalars['String']['output'];
};

export type RequestedTourTime = {
    date: Scalars['String']['input'];
    startTime?: InputMaybe<Scalars['String']['input']>;
};

export type RequestedZuidSource = 'CONTEXT' | 'OPTIONAL_ARG' | 'REQUIRED_ARG';

export type RescheduleEnumType = 'REQUESTED_TOUR_RESCHEDULE';

export type RescheduleErrorEnumType = 'GENERAL' | 'PAST_TIME_REQUESTED';

export type RescheduleTourContactAgentView = ITourView & {
    alerts?: Maybe<Array<TourViewAlert>>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewMetadata>;
    modules?: Maybe<Array<TourViewModule>>;
    toasts?: Maybe<Array<TourViewToast>>;
};

export type RescheduleTourRequestFormView = ITourView & {
    alerts?: Maybe<Array<TourViewAlert>>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewMetadata>;
    modules?: Maybe<Array<TourViewModule>>;
    toasts?: Maybe<Array<TourViewToast>>;
};

export type RescheduleTourV0Input = {
    appointmentHash: Scalars['ID']['input'];
};

export type RescheduleTourV1Input = {
    appointmentHash: Scalars['ID']['input'];
};

export type Residence = {
    address?: Maybe<RentalApplicationAddress>;
    id?: Maybe<Scalars['ID']['output']>;
    startDate?: Maybe<Scalars['Date']['output']>;
    type?: Maybe<ResidenceType>;
};

export type ResidenceInput = {
    address?: InputMaybe<RentalApplicationAddressInput>;
    description?: InputMaybe<Scalars['NonEmptyString']['input']>;
    endDate?: InputMaybe<Scalars['Date']['input']>;
    manager?: InputMaybe<ManagerContactInfoInput>;
    monthlyPayment?: InputMaybe<Scalars['USCurrency']['input']>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
    type: ResidenceType;
};

export type ResidenceType = 'other' | 'own' | 'rent';

export type ResponseDetails = {
    fieldName: Scalars['String']['output'];
    fieldValue: FieldValue;
    title?: Maybe<Scalars['String']['output']>;
};

export type ResponseStatus =
    /** Error */
    | 'ERROR'
    /** Finished */
    | 'FINISHED'
    /** Processing */
    | 'PROCESSING';

/** An image source option */
export type ResponsiveImageSource = {
    /** boolean to specify if the image is a Google Static map with scale > 1 */
    isHighResolutionStaticMap?: Maybe<Scalars['Boolean']['output']>;
    /** url of the photo at the specified width */
    url?: Maybe<Scalars['String']['output']>;
    /** width in pixels */
    width?: Maybe<Scalars['Int']['output']>;
};

export type ResponsiveString = {
    /** Shortened version of the text for smaller displays */
    abbreviatedValue?: Maybe<Scalars['String']['output']>;
    /** The full text */
    fullValue?: Maybe<Scalars['String']['output']>;
};

export type Restimate = {
    /** The dollar value of the Rental Zestimate */
    value?: Maybe<Scalars['Int']['output']>;
};

export type Review = {
    responseMessage?: Maybe<Scalars['String']['output']>;
    reviewId?: Maybe<Scalars['String']['output']>;
    reviewMessage?: Maybe<Scalars['String']['output']>;
    reviewResponseDate?: Maybe<Scalars['String']['output']>;
    starLevel?: Maybe<Scalars['Int']['output']>;
};

/** Building review information */
export type ReviewsInfo = {
    averageBuildingManagerRating?: Maybe<Scalars['Float']['output']>;
    averageBuildingRating?: Maybe<Scalars['Float']['output']>;
    averagePropertyManagerRating?: Maybe<Scalars['Float']['output']>;
    reviews?: Maybe<Array<Maybe<CombinedReview>>>;
    reviewsCount?: Maybe<Scalars['Int']['output']>;
};

export type RevokeHardCreditConsentOutput = {
    id?: Maybe<Scalars['ID']['output']>;
};

export type RichMedia = {
    /** Ordered media carousel photos: enforces 1:1 mapping of high mls:highRes photos even if photo matching technically allows 1:many */
    carouselPhotos: Array<ImxCarouselPhoto>;
    /** Floor ID (non-numeric) - Sourced originally IMX JSON data */
    defaultStartingFloor?: Maybe<Scalars['String']['output']>;
    /** Floors data associated with this imx model */
    floors: Array<ImxFloor>;
    /** Model has LMS data: sourced originally from rmx-richdata-api-service (same as property graph 'isLmsTour') */
    isLms?: Maybe<Scalars['Boolean']['output']>;
    /** Model has showcase data: sourced originally from rmx-richdata-api-service */
    isShowcase?: Maybe<Scalars['Boolean']['output']>;
    /** Key-value pairs of LMS to MLS photo keys: sourced originally from Photo Loc JSON data */
    lmsToMlsPhotoKeys?: Maybe<Scalars['Json']['output']>;
    /** Key-value pairs of MLS to LMS photo keys: sourced originally from Photo Loc JSON data */
    mlsToLmsPhotoKeys?: Maybe<Scalars['Json']['output']>;
    /** Pano loc data: guaranteed to correspond to data in panos array */
    panoLoc?: Maybe<ImxPanoLoc>;
    /** Panos data associated with this imx model */
    panos: Array<ImxPano>;
    /** Photo loc data: guaranteed to correspond to data in carouselPhotos array */
    photoLoc?: Maybe<ImxPhotoLoc>;
    /** Room highlighting data (rooms to relevant panos & photos): sourced originally from GBR-Lite JSON data */
    rooms: Array<ImxRoom>;
    /** 3D tour photographer: sourced originally from IMX JSON data */
    tourPhotographer?: Maybe<ImxTourPhotographer>;
    /** Represents floor layout visualization including floor plans: guaranteed to match data in floors */
    visualizations?: Maybe<Array<Maybe<ImxVisualization>>>;
};

export type RichMediacarouselPhotosArgs = {
    aspectRatio?: InputMaybe<ShowcaseAspectRatio>;
};

export type RichMediaFloor = {
    /** Physical floor order (in real life) */
    floorNumber: Scalars['Int']['output'];
    /** Floor ID */
    id: Scalars['String']['output'];
    /** Floor name or label */
    name: Scalars['String']['output'];
};

export type RichMediaMediaType = 'Unknown' | 'Video' | 'VirtualTour';

/** Base pano interface */
export type RichMediaPano = {
    /** Panos that can be navigated to from the current pano */
    destinations: Array<RichMediaPanoDestination>;
    /** Pano ID */
    entityId: Scalars['String']['output'];
    /** Associated floor ID */
    floorId: Scalars['String']['output'];
    /** Max fov or zoom level (in degrees): 180 for spherical panos, less for hand-held capture */
    fov: Scalars['Int']['output'];
    /** Safe default display angle (in degrees): editable via 3d tour editor */
    startAngle: Scalars['Int']['output'];
    /** Pano texture data and urls */
    textureFileUrls: RichMediaTextureFileUrls;
    /** Pano title or label */
    title: Scalars['String']['output'];
};

/** Base pano destination interface */
export type RichMediaPanoDestination = {
    /** Angle that the arrow (exit) should point to (in degrees) */
    departureAngle: Scalars['Int']['output'];
    /** Pano ID */
    destEntityId: Scalars['String']['output'];
    /** Relative angle between current pano and destination pano (in degrees). Aligns panos to same real world direction since tripod is not perfectly aligned between panos in real life. Combine this with user's current viewing angle to get direction they would face when they arrive. */
    panoRelativeAngle?: Maybe<Scalars['Float']['output']>;
    /** Pano title or label */
    title: Scalars['String']['output'];
};

/** Base high photo from non-MLS sources (e.g. LMS) */
export type RichMediaPhoto = {
    alt?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    isHeroPhoto?: Maybe<Scalars['Boolean']['output']>;
    isInteriorPhoto?: Maybe<Scalars['Boolean']['output']>;
    isShowcased?: Maybe<Scalars['Boolean']['output']>;
    mixedSources?: Maybe<MixedSources>;
};

/** Base pano texture file url tile interface */
export type RichMediaTextureFileUrlTiles = {
    coords: Array<Scalars['Int']['output']>;
    url: Scalars['String']['output'];
};

/** Base pano texture file url interface */
export type RichMediaTextureFileUrls = {
    pano4k: Scalars['String']['output'];
    pano512: Scalars['String']['output'];
    thumbnail?: Maybe<Scalars['String']['output']>;
    tiles: Array<RichMediaTextureFileUrlTiles>;
};

export type RichMediaType = {
    displayOrder?: Maybe<Scalars['Int']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    lotId?: Maybe<Scalars['Int']['output']>;
    mediaType?: Maybe<RichMediaMediaType>;
    richMediaId?: Maybe<Scalars['Int']['output']>;
    url?: Maybe<Scalars['String']['output']>;
};

export type RoomDetails = {
    /**
     * whether pets are allowed in room
     * @deprecated This field is no longer in use.
     */
    arePetsAllowed?: Maybe<Scalars['Boolean']['output']>;
    /**
     * General description of room
     * @deprecated Use roomDescription instead.
     */
    description?: Maybe<Scalars['String']['output']>;
    /** does room have private bath */
    hasPrivateBath?: Maybe<Scalars['Boolean']['output']>;
    /**
     * is room furnished
     * @deprecated Use roomIsFurnished instead.
     */
    isFurnished?: Maybe<Scalars['Boolean']['output']>;
    /**
     * is smoking allowed in room
     * @deprecated This field is no longer in use.
     */
    isSmokingAllowed?: Maybe<Scalars['Boolean']['output']>;
    /**
     * size of living area
     * @deprecated This field is no longer in use.
     */
    livingArea?: Maybe<Scalars['Int']['output']>;
    /**
     * living area units, i.e. square feet
     * @deprecated This field is no longer in use.
     */
    livingAreaUnits?: Maybe<Scalars['String']['output']>;
    /**
     * shortened version of living area units, i.e. sqft
     * @deprecated This field is no longer in use.
     */
    livingAreaUnitsShort?: Maybe<Scalars['String']['output']>;
    /**
     * description of how utilities are shared
     * @deprecated Use utilitiesShareDescription instead.
     */
    monthlyUtilitiesShareDescription?: Maybe<Scalars['String']['output']>;
    /** area of the room */
    roomArea?: Maybe<Scalars['Int']['output']>;
    /** units of the roomArea */
    roomAreaUnits?: Maybe<Scalars['String']['output']>;
    /** General description of room */
    roomDescription?: Maybe<Scalars['String']['output']>;
    /** is room furnished */
    roomIsFurnished?: Maybe<Scalars['Boolean']['output']>;
    /**
     * square footage of room
     * @deprecated This field is no longer in use.
     */
    roomSquareFeet?: Maybe<Scalars['Int']['output']>;
    /** type of the room */
    roomType?: Maybe<Scalars['String']['output']>;
    /** description of how utilities are shared */
    utilitiesShareDescription?: Maybe<Scalars['String']['output']>;
};

export type RoomForRent = {
    leaseDetails?: Maybe<LeaseDetails>;
    /** @deprecated This field is no longer in use. */
    petDetails?: Maybe<PetDetails>;
    /** Information on who posted this listing */
    postedBy?: Maybe<Scalars['String']['output']>;
    roomDetails?: Maybe<RoomDetails>;
    roommateDetails?: Maybe<RoommateDetails>;
    roommateRequirements?: Maybe<RoommateRequirements>;
};

export type RoomRentalDetails = {
    /** @deprecated This field is no longer in use. */
    petDetails?: Maybe<PetDetails>;
    roomDetails?: Maybe<RoomDetails>;
    roommateDetails?: Maybe<RoommateDetails>;
    roommateRequirements?: Maybe<RoommateRequirements>;
};

export type Roommate = {
    /**
     * Roommate's age
     * @deprecated This field is no longer in use.
     */
    age?: Maybe<Scalars['Int']['output']>;
    /**
     * Roommate's gender
     * @deprecated This field is no longer in use.
     */
    gender?: Maybe<Scalars['String']['output']>;
    /**
     * Roommate's interests
     * @deprecated This field is no longer in use.
     */
    interests?: Maybe<Scalars['String']['output']>;
    /**
     * Roommate's job
     * @deprecated This field is no longer in use.
     */
    job?: Maybe<Scalars['String']['output']>;
};

export type RoommateDetails = {
    /**
     * Number of cats in household
     * @deprecated This field is no longer in use.
     */
    catCount?: Maybe<Scalars['Int']['output']>;
    /** @deprecated This field is no longer in use. */
    currentRoommates?: Maybe<Array<Maybe<Roommate>>>;
    /** General description of current roommates in household */
    description?: Maybe<Scalars['String']['output']>;
    /**
     * Number of dogs in household
     * @deprecated This field is no longer in use.
     */
    dogCount?: Maybe<Scalars['Int']['output']>;
    /**
     * Total number of female roommates
     * @deprecated This field is no longer in use.
     */
    femaleCount?: Maybe<Scalars['String']['output']>;
    /**
     * Total number of male roommates
     * @deprecated This field is no longer in use.
     */
    maleCount?: Maybe<Scalars['String']['output']>;
    /**
     * Total number of non-binary roommates
     * @deprecated This field is no longer in use.
     */
    nonBinaryCount?: Maybe<Scalars['String']['output']>;
    /**
     * Number of other pets in household
     * @deprecated This field is no longer in use.
     */
    otherPetsCount?: Maybe<Scalars['Int']['output']>;
    /**
     * Description of pets in household
     * @deprecated This field is no longer in use.
     */
    petDescription?: Maybe<Scalars['String']['output']>;
    /**
     * Total number of roommates who prefer not to identify gender
     * @deprecated This field is no longer in use.
     */
    preferNotToIdentifyCount?: Maybe<Scalars['String']['output']>;
    /** Existing roommates gender and count. */
    roommateGenderDetails?: Maybe<Array<Maybe<RoommateGenderDetails>>>;
    /** Existing roommates pets and count. */
    roommatePetDetails?: Maybe<Array<Maybe<RoommatePetDetails>>>;
    /**
     * Social habits of current roommates
     * @deprecated This field is no longer in use.
     */
    socialHabits?: Maybe<Scalars['String']['output']>;
    /** Total number of roommates */
    totalCount?: Maybe<Scalars['String']['output']>;
    /**
     * Total number of roommates
     * @deprecated This field is no longer in use.
     */
    totalNumberOfRoommates?: Maybe<Scalars['Int']['output']>;
    /**
     * Work schedule of current roommates
     * @deprecated This field is no longer in use.
     */
    workSchedule?: Maybe<Scalars['String']['output']>;
};

export type RoommateGenderDetails = {
    /** Number roommates of specified gender. A string is used to support cases like "4+" */
    genderCount?: Maybe<Scalars['String']['output']>;
    /** The type of gender */
    type?: Maybe<Scalars['String']['output']>;
};

export type RoommatePetDetails = {
    petCount?: Maybe<Scalars['String']['output']>;
    /** The type of pet */
    type?: Maybe<Scalars['String']['output']>;
};

export type RoommateRequirements = {
    /**
     * Gender of desired roommate
     * @deprecated This field is no longer in use.
     */
    gender?: Maybe<Scalars['String']['output']>;
    /** genders */
    genderTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**
     * genders
     * @deprecated Use genderTypes instead.
     */
    genders?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**
     * Whether room can be rentable to only renter or renter + partner
     * @deprecated This field is no longer in use.
     */
    isLiveInPartnerAllowed?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Whether current renters prefer new roommate to be vegan
     * @deprecated This field is no longer in use.
     */
    isVegan?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Whether current renters prefer new roommate to be vegetarian
     * @deprecated This field is no longer in use.
     */
    isVegetarian?: Maybe<Scalars['Boolean']['output']>;
    /**
     * Maximum age for desired roommate
     * @deprecated This field is no longer in use.
     */
    maxAge?: Maybe<Scalars['Int']['output']>;
    /**
     * Minimum age for desired roommate
     * @deprecated Use minimumAge instead.
     */
    minAge?: Maybe<Scalars['Int']['output']>;
    /** Minimum age for desired roommate */
    minimumAge?: Maybe<Scalars['Int']['output']>;
    /**
     * Work schedule for desired roommate
     * @deprecated This field is no longer in use.
     */
    workSchedule?: Maybe<Scalars['String']['output']>;
};

export type RulesRequest = {
    /**
     * Filters results based on the property's commingling category.  Each property has a commingling category of
     * either rulesApplicable or rulesNotApplicable.
     *
     * The purpose of the the flag is to identify how the listing can be displayed with other listings.  All listings
     * marked as rulesApplicable can be displayed together (ie on tab 1).  Listings marked as rulesNotApplicable can
     * be displayed together (ie tab 2) but cannot be displayed on tab 1.
     *
     * This parameter accepts a third state 'commingled' which doesn't filter on the flag and returns all listings
     * regardless of how they can be displayed.   The response field propertyResultRules_comminglingCategory can be
     * requested and will identify each listing as rulesApplicable or rulesNotApplicable.
     * Given the importance of how listings are displayed, this parameter is required.
     */
    comminglingCategory: ComminglingCategory;
    /**
     * When `true`, forces inclusion of builder (new construction) plan
     * results that fall into the `rulesNotApplicable` commingling category
     * even though the `comminglingCategory` specified in the request is
     * `rulesApplicable`.  Specifying `true` in this parameter of the request
     * is only acceptable when the specified `comminglingCategory` is
     * `rulesApplicable`.
     */
    forceIncludeRulesNotApplicableBuilderPlans?: InputMaybe<Scalars['Boolean']['input']>;
    /**
     * The rules version to apply. Example: VOW would apply the Virtual Office Website (VOW) version of rules to the result.
     *
     * The parameter is optional
     */
    version?: InputMaybe<RulesVersion>;
};

export type RulesVersion = 'VOW';

export type SATLocation = SearchAssistanceLocation & {
    /** Latitude of the user's location, used for boosting. */
    latitude: Scalars['Float']['output'];
    /** Longitude of the user's location, used for boosting. */
    longitude: Scalars['Float']['output'];
};

export type SCHOOL_LEVEL = 'ELEMENTARY' | 'HIGH' | 'MIDDLE';

export type SalesOffice = {
    addressLine1?: Maybe<Scalars['String']['output']>;
    addressLine2?: Maybe<Scalars['String']['output']>;
};

/** shape of save comps request */
export type SaveCompsInputType = {
    comps?: InputMaybe<Array<InputMaybe<CompInputType>>>;
    zpid?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveCustomRegionInput = {
    /** if polygon is not in WKT format and needs to be converted */
    convertToWkt: Scalars['Boolean']['input'];
    /** polygon representation of custom region */
    polygon: Scalars['String']['input'];
};

export type SaveHomeEvent = UserEvent & {
    /** Events associated with the semantic tag: save_home */
    eventId: Scalars['ID']['output'];
    eventSource: StreamSource;
    eventTime: Scalars['GraphQLLong']['output'];
    /** This is the clickstream event type id */
    eventType: Scalars['String']['output'];
    propertyAttributes: PropertyAttributes;
};

export type Saved = {
    /**
     * The note (if any) that the user entered when they saved the
     * property
     */
    savedNote?: Maybe<Scalars['String']['output']>;
    /**
     * The date time that the property was saved.
     * It is in UTC in ISO-8601.
     * Example: 2019-07-03T20:47:55Z
     */
    savedTime?: Maybe<Scalars['DateTime']['output']>;
};

export type SavedHome = {
    building?: Maybe<Building>;
    comment?: Maybe<Scalars['String']['output']>;
    property?: Maybe<Property>;
    propertyId?: Maybe<Scalars['String']['output']>;
    propertyIdType?: Maybe<Scalars['String']['output']>;
    savedDate?: Maybe<Scalars['DateTime']['output']>;
};

export type SavedHomeInput = {
    /**  user comment or note  */
    comment?: InputMaybe<Scalars['String']['input']>;
    /**  property id  */
    propertyId: Scalars['ID']['input'];
    /**  the type of property id  */
    propertyIdType: PropertyIdType;
};

/** a property search which a user has saved for future searching and/or property update notifications */
export type SavedSearch = {
    /** creation date of saved search */
    createDate?: Maybe<Scalars['DateTime']['output']>;
    /** how often we send emails with updates about properties returned by the saved search */
    emailFrequency?: Maybe<SavedSearchEmailFrequency>;
    /** the number of unread notifications about new/updated properties returned by the saved search */
    notificationCount?: Maybe<Scalars['Int']['output']>;
    /** the saved search id (SSID) */
    savedSearchId?: Maybe<Scalars['ID']['output']>;
    /** the user-friendly name of the search */
    savedSearchName?: Maybe<Scalars['String']['output']>;
    savedSearchType?: Maybe<SavedSearchType>;
    /** the URL of the search results page showing the results of the saved search */
    searchUrl?: Maybe<Scalars['String']['output']>;
    /** the subscription enrollment id (SEID) */
    subscriptionEnrollmentId?: Maybe<Scalars['ID']['output']>;
};

export type SavedSearchEmailFrequency = 'DAILY' | 'INSTANT' | 'NEVER';

export type SavedSearchType =
    | 'ACCOUNTLESS'
    | 'BY_AGENT'
    | 'FAVORITE_HOMES'
    | 'INFERRED'
    | 'MOBILE'
    | 'WEB'
    | 'WEB_PUSH';

export type Scenario = {
    cash_to_close?: InputMaybe<Scalars['String']['input']>;
    credit_score?: InputMaybe<Scalars['Int']['input']>;
    down_payment?: InputMaybe<Scalars['String']['input']>;
    dti?: InputMaybe<Scalars['String']['input']>;
    hoa_fees?: InputMaybe<Scalars['String']['input']>;
    home_owners_insurance?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    interest_apr?: InputMaybe<Scalars['String']['input']>;
    loan_program?: InputMaybe<Scalars['String']['input']>;
    loan_purpose?: InputMaybe<Scalars['String']['input']>;
    lock_term?: InputMaybe<Scalars['Int']['input']>;
    ltv?: InputMaybe<Scalars['String']['input']>;
    mortgage_insurance?: InputMaybe<Scalars['String']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    occupancy_type?: InputMaybe<Scalars['String']['input']>;
    other_cost?: InputMaybe<Scalars['String']['input']>;
    pi?: InputMaybe<Scalars['String']['input']>;
    piti?: InputMaybe<Scalars['String']['input']>;
    points_price?: InputMaybe<Scalars['String']['input']>;
    property_taxes?: InputMaybe<Scalars['String']['input']>;
    property_type?: InputMaybe<Scalars['String']['input']>;
    purchase_price?: InputMaybe<Scalars['String']['input']>;
    total_closing_costs?: InputMaybe<Scalars['String']['input']>;
    total_loan_amount?: InputMaybe<Scalars['String']['input']>;
    upfront_fee?: InputMaybe<Scalars['String']['input']>;
    zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledTour = {
    brand?: Maybe<Scalars['String']['output']>;
    created?: Maybe<Scalars['String']['output']>;
    endTime?: Maybe<Scalars['String']['output']>;
    isMultifamily?: Maybe<Scalars['Boolean']['output']>;
    lotId?: Maybe<Scalars['String']['output']>;
    propertyTypeCode?: Maybe<Scalars['Int']['output']>;
    providerListingId?: Maybe<Scalars['String']['output']>;
    providerModelId?: Maybe<Scalars['String']['output']>;
    schedulingStatus?: Maybe<Scalars['String']['output']>;
    startTime?: Maybe<Scalars['String']['output']>;
    tourId?: Maybe<Scalars['String']['output']>;
    tourType?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    zoneId?: Maybe<Scalars['String']['output']>;
};

export type School = {
    address?: Maybe<SchoolAddress>;
    /** @deprecated This data is not used, and not provided by school-search-api. */
    assigned?: Maybe<Scalars['Boolean']['output']>;
    /** distance in miles */
    distance?: Maybe<Scalars['Float']['output']>;
    /** Hyphenated description of grades served. */
    grades?: Maybe<Scalars['String']['output']>;
    /** @deprecated This data is not known to be used, and not provided by school-search-api. */
    isAssigned?: Maybe<Scalars['Boolean']['output']>;
    level?: Maybe<Scalars['String']['output']>;
    /** URL of the relevant Great Schools page. */
    link?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    /** @deprecated Obsolete */
    overwriteSource?: Maybe<Scalars['String']['output']>;
    /** rating out of 10 */
    rating?: Maybe<Scalars['Int']['output']>;
    schoolId?: Maybe<Scalars['Int']['output']>;
    /** @deprecated This data is not known to be used, and not provided by school-search-api. */
    size?: Maybe<Scalars['Int']['output']>;
    /** @deprecated This data is not used, and not provided by school-search-api. */
    studentsPerTeacher?: Maybe<Scalars['Int']['output']>;
    /** @deprecated Obsolete */
    totalCount?: Maybe<Scalars['Int']['output']>;
    /** Public, private, or charter. */
    type?: Maybe<Scalars['String']['output']>;
};

export type SchoolAddress = {
    city?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    street?: Maybe<Scalars['String']['output']>;
    zip?: Maybe<Scalars['String']['output']>;
};

export type Scma = {
    /**  status of connect with agent request  */
    agentConnectionStatus?: Maybe<Scalars['String']['output']>;
    /**
     *  estimated agent fee of median property value 6%
     * @deprecated Agent fees are no longer a fixed value and instead a range
     */
    estAgentFee?: Maybe<Scalars['Int']['output']>;
    /**  estimated agent fee of median property value upper bound  */
    estAgentFeeHigh?: Maybe<Scalars['Int']['output']>;
    /**  estimated agent fee of median property value lower bound  */
    estAgentFeeLow?: Maybe<Scalars['Int']['output']>;
    /**  median estimate of the proceeds of transaction  */
    estCashProceed?: Maybe<Scalars['Int']['output']>;
    /**  high estimate of the proceeds of transaction  */
    estCashProceedHigh?: Maybe<Scalars['Int']['output']>;
    /**  low estimate of the proceeds of transaction  */
    estCashProceedLow?: Maybe<Scalars['Int']['output']>;
    /**  estimated closing cost of median property value 1%  */
    estClosingCost?: Maybe<Scalars['Int']['output']>;
    /**  high estimate of value  */
    estHigh?: Maybe<Scalars['Int']['output']>;
    /**  low estimate of value  */
    estLow?: Maybe<Scalars['Int']['output']>;
    /**  estimated repair cost, currently only null  */
    estRepairCost?: Maybe<Scalars['Int']['output']>;
    /**  median estimate of value  */
    estValue?: Maybe<Scalars['Int']['output']>;
    /**  when the SCMA expires and should be refreshed by  */
    expirationDateTime?: Maybe<Scalars['String']['output']>;
    /**  tags to display for PA purposes  */
    featureDisplayTags?: Maybe<Array<FeatureDisplayTag>>;
    /**  flag to determine if SCMA has responded with an valuation  */
    isScmaEligible?: Maybe<Scalars['Boolean']['output']>;
    /**  list of comparison zpids  */
    soldComps?: Maybe<Array<Maybe<SoldComp>>>;
    /**  status of the SCMA generation  */
    status: Scalars['String']['output'];
};

export type ScreeningCriteria = {
    /** Additional screening criteria */
    additional?: Maybe<Scalars['String']['output']>;
    /** Credit score screening criteria */
    creditScore?: Maybe<Scalars['String']['output']>;
    /** Eviction history requirements */
    evictionHistory?: Maybe<Scalars['String']['output']>;
    /** The ratio of income to rent */
    incomeToRent?: Maybe<Scalars['String']['output']>;
    /** Maximum past debt */
    pastDebt?: Maybe<Scalars['String']['output']>;
    /** Allow no previous rental history */
    rentalHistory?: Maybe<Scalars['String']['output']>;
};

export type SearchAssistanceAddressResult = SearchAssistanceResult & {
    apn?: Maybe<Scalars['String']['output']>;
    city?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    countyFips?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    location?: Maybe<SearchAssistanceLocation>;
    maloneId?: Maybe<Scalars['String']['output']>;
    spellCorrectedMetadata?: Maybe<SpellCorrectedMetadata>;
    state?: Maybe<Scalars['String']['output']>;
    streetName?: Maybe<Scalars['String']['output']>;
    streetNumber?: Maybe<Scalars['String']['output']>;
    subType: SearchAssistanceAddressSubtype;
    type: SearchAssistanceResponseType;
    unitNumber?: Maybe<Scalars['String']['output']>;
    zipCode?: Maybe<Scalars['String']['output']>;
    zpid?: Maybe<Scalars['Long']['output']>;
};

export type SearchAssistanceAddressSubtype =
    | 'COMMUNITY_ADDRESS'
    | 'FORSALE_ADDRESS'
    | 'MALONE_ADDRESS'
    | 'RENTAL_ADDRESS'
    | 'SOLD_ADDRESS'
    | 'STREET_ADDRESS';

export type SearchAssistanceAutocompleteResult = {
    /** category information for grouping the results, if desired by the UI */
    categories: Array<SearchAssistanceCategory>;
    /** enable debug response */
    debug?: Maybe<Scalars['String']['output']>;
    /** query time of request */
    qTime?: Maybe<Scalars['Float']['output']>;
    /** unique identifier for request */
    requestId?: Maybe<Scalars['String']['output']>;
    /** result object returned by autocomplete */
    results?: Maybe<Array<Maybe<SearchAssistanceResult>>>;
};

export type SearchAssistanceBuilderCommunityResult = SearchAssistanceResult & {
    city?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    location?: Maybe<SearchAssistanceLocation>;
    plid: Scalars['String']['output'];
    spellCorrectedMetadata?: Maybe<SpellCorrectedMetadata>;
    state?: Maybe<Scalars['String']['output']>;
    subType: SearchAssistanceBuilderCommunitySubtype;
    type: SearchAssistanceResponseType;
};

export type SearchAssistanceBuilderCommunitySubtype =
    | 'BUILDERCOMMUNITY_ADDRESS'
    | 'BUILDERCOMMUNITY_NAME';

export type SearchAssistanceCategory = {
    /** text to use as the header for the category. If it is empty as the first category, then no category header should be used. If it is empty as a subsequent category, then the category header should use a client-defined default value (e.g. 'More results') */
    categoryDisplayName: Scalars['String']['output'];
    /** text to use in the highlight field. If it is absent / empty, then no highlight should be used. */
    categoryHighlightText?: Maybe<Scalars['String']['output']>;
    /** Indexes of the results to include in this category within the main result list, ranked within the category */
    results: Array<Scalars['Int']['output']>;
};

export type SearchAssistanceCommercialResult = SearchAssistanceResult & {
    city?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    location?: Maybe<SearchAssistanceLocation>;
    mbr?: Maybe<Mbr>;
    spellCorrectedMetadata?: Maybe<SpellCorrectedMetadata>;
    state?: Maybe<Scalars['String']['output']>;
    streetName?: Maybe<Scalars['String']['output']>;
    streetNumber?: Maybe<Scalars['String']['output']>;
    subType: SearchAssistanceCommercialSubtype;
    type: SearchAssistanceResponseType;
    zipCode?: Maybe<Scalars['String']['output']>;
};

export type SearchAssistanceCommercialSubtype = 'COMMERCIAL_ADDRESS' | 'COMMERCIAL_NAME';

export type SearchAssistanceInputLocation = {
    /** Latitude of the user's location, used for boosting. */
    latitude: Scalars['Float']['input'];
    /** Longitude of the user's location, used for boosting. */
    longitude: Scalars['Float']['input'];
};

export type SearchAssistanceLocation = {
    /** Latitude of the user's location, used for boosting. */
    latitude: Scalars['Float']['output'];
    /** Longitude of the user's location, used for boosting. */
    longitude: Scalars['Float']['output'];
};

/** Optional arguments used to modify results returns by the API */
export type SearchAssistanceQueryOptions = {
    /** Output debug information */
    debug?: InputMaybe<Scalars['Boolean']['input']>;
    /** interactionId to track user autocomplete queries */
    interactionId?: InputMaybe<Scalars['String']['input']>;
    /** Set this flag to determine number of results returned by API */
    maxResults?: Scalars['Int']['input'];
    /** List of selected regions in a multi-region query, used for boosting. */
    multiRegion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Prior user searches, used for boosting. */
    priorSearches?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
    /** Pass RegionId to get data that's relevant to the regionId */
    regionId?: InputMaybe<Scalars['String']['input']>;
    /** Enable spell check for this search query */
    spellCheck?: InputMaybe<Scalars['Boolean']['input']>;
    /** Provide server-side a/b testing options */
    userIdentity?: InputMaybe<SearchAssistanceUserIdentity>;
    /** Latitude/longitude of the user's location, used for boosting. */
    userLocation?: InputMaybe<SearchAssistanceInputLocation>;
    /** User's Search context for the request */
    userSearchContext?: UserSearchContext;
    /** Viewport of the user.  If viewport is present, centroid of viewport will be used in place of lat/long. */
    viewPort?: InputMaybe<BBox>;
};

export type SearchAssistanceQuerySource =
    /** The query was generated from a click on an autocomplete result (after the user has typed at least one character) */
    | 'AUTOCOMPLETE'
    /** The query was generated from pressing enter (or otherwise does not match the provided autocomplete results) */
    | 'MANUAL'
    /** The query was generated by a user selecting a past query. This type of query may or may not match an autocomplete result. */
    | 'RECENT'
    /** The query was generated from a click on an autocomplete result (before the user has typed anything) */
    | 'SUGGESTED'
    /** The query is generated from an unknown source. This is the default value and should not be passed explicitly */
    | 'UNKNOWN';

export type SearchAssistanceQueryUnderstandingResult = {
    /** Enable debug response */
    debug?: Maybe<Scalars['String']['output']>;
    /** query time of request */
    qTime?: Maybe<Scalars['Float']['output']>;
    /** unique identifier for request */
    requestId?: Maybe<Scalars['String']['output']>;
    /** result object returned by query understanding */
    results?: Maybe<Array<Maybe<SearchAssistanceResult>>>;
};

export type SearchAssistanceRegionResult = SearchAssistanceResult & {
    city?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    county?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    location?: Maybe<SearchAssistanceLocation>;
    neighborhood?: Maybe<Scalars['String']['output']>;
    neighborhoodId?: Maybe<Scalars['String']['output']>;
    region?: Maybe<Region>;
    regionId: Scalars['Int']['output'];
    spellCorrectedMetadata?: Maybe<SpellCorrectedMetadata>;
    state?: Maybe<Scalars['String']['output']>;
    status: SearchAssistanceRegionStatus;
    subType: SearchAssistanceRegionSubtype;
    type: SearchAssistanceResponseType;
    zipCode?: Maybe<Scalars['String']['output']>;
    zipcodeAliases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type SearchAssistanceRegionStatus = 'ACTIVE' | 'DISABLED';

export type SearchAssistanceRegionSubtype =
    | 'BOROUGH'
    | 'CITY'
    | 'COUNTY'
    | 'FLEX_REGION'
    | 'NEIGHBORHOOD'
    | 'STATE'
    | 'ZIPCODE';

export type SearchAssistanceRentalCommunityResult = SearchAssistanceResult & {
    apn?: Maybe<Scalars['String']['output']>;
    building?: Maybe<VL_Building>;
    city?: Maybe<Scalars['String']['output']>;
    country?: Maybe<Scalars['String']['output']>;
    countyFips?: Maybe<Scalars['String']['output']>;
    id: Scalars['String']['output'];
    location?: Maybe<SearchAssistanceLocation>;
    lotId?: Maybe<Scalars['Long']['output']>;
    maloneId?: Maybe<Scalars['String']['output']>;
    spellCorrectedMetadata?: Maybe<SpellCorrectedMetadata>;
    state?: Maybe<Scalars['String']['output']>;
    streetName?: Maybe<Scalars['String']['output']>;
    streetNumber?: Maybe<Scalars['String']['output']>;
    subType: SearchAssistanceRentalCommunitySubtype;
    type: SearchAssistanceResponseType;
    zipCode?: Maybe<Scalars['String']['output']>;
};

export type SearchAssistanceRentalCommunitySubtype = 'COMMUNITY_ADDRESS' | 'COMMUNITY_NAME';

export type SearchAssistanceResponseType =
    /** property address response */
    | 'ADDRESS'
    /** semantic response with affordability filters */
    | 'AFFORDABILITY'
    /** builder community response */
    | 'BUILDER_COMMUNITY'
    /** commercial address and commercial name */
    | 'COMMERCIAL'
    /** region response */
    | 'REGION'
    /** rental community response */
    | 'RENTAL_COMMUNITY'
    /** school response */
    | 'SCHOOL'
    /** school district response */
    | 'SCHOOL_DISTRICT'
    /** region response with semantic suggestions */
    | 'SEMANTIC_REGIONS';

export type SearchAssistanceResult = {
    /** The textual identifier of the result - typically this is used to display the result (either as a suggestion in AC or in the search box for QU) */
    id: Scalars['String']['output'];
    /** Spell Corrected info */
    spellCorrectedMetadata?: Maybe<SpellCorrectedMetadata>;
    /** The type of this specific result. This can be used to determine how to process this result. */
    type: SearchAssistanceResponseType;
};

export type SearchAssistanceResultType =
    /** return active properties for the result type ADDRESS of addressSubType: FORSALE_ADDRESS */
    | 'ACTIVE'
    /** return addresses for address subtypes (e.g. ACTIVE, INACTIVE) */
    | 'ADDRESSES'
    /** return affordability filters in semantic results */
    | 'AFFORDABILITY'
    /** return boroughs for the result type REGION of regionSubType: BOROUGH */
    | 'BOROUGHS'
    /** return builder community names for the result type of BUILDER_COMMUNITY */
    | 'BUILDER_COMMUNITIES'
    /** return cities for the result type REGION of regionSubType: CITY */
    | 'CITIES'
    /** return commercial address for the result type ADDRESS of commercialSubType: COMMERCIAL_ADDRESS */
    | 'COMMERCIAL_ADDRESS'
    /** return commercial name for the result type ADDRESS of commercialSubType: COMMERCIAL_NAME */
    | 'COMMERCIAL_NAME'
    /** return community properties for the result type ADDRESS of rentalCommunitySubType: COMMUNITY_ADDRESS */
    | 'COMMUNITIES'
    /** return counties for the result type REGION of regionSubType: COUNTY */
    | 'COUNTIES'
    /** return flex regions for the result type REGION of regionSubType: FLEX_REGION */
    | 'FLEX_REGIONS'
    /** return for sale properties for the result type ADDRESS of addressSubType: FORSALE_ADDRESS */
    | 'FORSALE'
    /** return inactive properties for the result type SOLD or USPS */
    | 'INACTIVE'
    /** return neighborhoods for the result type REGION of regionSubType: NEIGHBORHOOD */
    | 'NEIGHBORHOODS'
    /** return regions for all region subTypes (e.g. CITY, ZIPCODE, etc) */
    | 'REGIONS'
    /** return rental properties for the result type ADDRESS of addressSubType: RENTAL_ADDRESS */
    | 'RENTALS'
    /** return school names for the result type SCHOOL of schoolSubType: SCHOOL */
    | 'SCHOOLS'
    /** return school district names for the result type SCHOOL of schoolSubType: SCHOOL_DISTRICT */
    | 'SCHOOL_DISTRICTS'
    /** return semantic results based on a region */
    | 'SEMANTIC_REGIONS'
    /** return sold properties for the result type ADDRESS of addressSubType: SOLD_ADDRESS */
    | 'SOLD'
    /** return states for the result type REGION of regionSubType: STATE */
    | 'STATES'
    /** return zipcodes for the result type REGION of regionSubType: ZIPCODE */
    | 'ZIPCODES';

export type SearchAssistanceSchoolResult = SearchAssistanceResult & {
    city?: Maybe<Scalars['String']['output']>;
    hasAttendanceZone?: Maybe<Scalars['Boolean']['output']>;
    id: Scalars['String']['output'];
    location?: Maybe<SearchAssistanceLocation>;
    name?: Maybe<Scalars['String']['output']>;
    schoolDistrictId?: Maybe<Scalars['Long']['output']>;
    schoolId?: Maybe<Scalars['Long']['output']>;
    spellCorrectedMetadata?: Maybe<SpellCorrectedMetadata>;
    state?: Maybe<Scalars['String']['output']>;
    subType: SearchAssistanceSchoolSubtype;
    type: SearchAssistanceResponseType;
    viewLatitudeDelta?: Maybe<Scalars['Float']['output']>;
};

export type SearchAssistanceSchoolSubtype = 'SCHOOL' | 'SCHOOL_DISTRICT';

export type SearchAssistanceSemanticResult = SearchAssistanceResult & {
    filters: SearchFilters;
    id: Scalars['String']['output'];
    nearMe?: Maybe<Scalars['Boolean']['output']>;
    queryResolutionStatus?: Maybe<QueryResolutionStatus>;
    rawQuery: Scalars['String']['output'];
    regionDisplayIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    regionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    regionTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    regions?: Maybe<Array<Maybe<Region>>>;
    schoolDisplayIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    schoolDistrictDisplayIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    schoolDistrictIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    schoolIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    spellCorrectedMetadata?: Maybe<SpellCorrectedMetadata>;
    status: SearchAssistanceRegionStatus;
    type: SearchAssistanceResponseType;
    understoodQuery?: Maybe<Scalars['String']['output']>;
    viewLatitudeDelta?: Maybe<Scalars['Float']['output']>;
};

export type SearchAssistanceUserIdentity = {
    /** Key for AB test that uniquely identifies a user */
    abKey?: InputMaybe<Scalars['String']['input']>;
    /** App installation ID. Used for AB testing in the apps */
    deviceInstallationId?: InputMaybe<Scalars['String']['input']>;
    /** Globally Unique Identifier. */
    guid?: InputMaybe<Scalars['String']['input']>;
    /** zillow account user id */
    zuid?: InputMaybe<Scalars['String']['input']>;
};

export type SearchFilters = {
    /** affordability filters */
    affordabilityFilters?: Maybe<AffordabilityFilters>;
    /** search filter for amenities */
    amenitiesFilters?: Maybe<Array<Maybe<AmenitiesFilters>>>;
    /** search filter for basement type */
    basementStatusType?: Maybe<Array<Maybe<BasementStatusType>>>;
    /** search filters for baths */
    baths?: Maybe<SearchRangeFloatFilter>;
    /** search filters for beds */
    beds?: Maybe<SearchRangeIntegerFilter>;
    /** search filter types to exclude */
    excludeTypes?: Maybe<Array<Maybe<ExcludeType>>>;
    /** search filters for home owner association fees cost per month */
    hoaFeesPerMonth?: Maybe<SearchRangeIntegerFilter>;
    /** search filter for the home type */
    homeType?: Maybe<Array<Maybe<SearchHomeType>>>;
    /** search filter for keywords */
    keywords?: Maybe<Array<Scalars['String']['output']>>;
    /** search filter for listing status type */
    listingStatusType?: Maybe<Array<Maybe<ListingStatusType>>>;
    /** search filters for living area space in square feet */
    livingAreaSqft?: Maybe<SearchRangeIntegerFilter>;
    /** search filters for lot size of property in square feet */
    lotSizeSqft?: Maybe<SearchRangeIntegerFilter>;
    /** search filters for parking spots */
    parkingSpots?: Maybe<SearchRangeIntegerFilter>;
    /** search filters for home prices */
    price?: Maybe<SearchRangeIntegerFilter>;
    /** search rental filters */
    searchRentalFilters?: Maybe<SearchRentalFilter>;
    /** search filter for num days on sale in zillow */
    searchSaleFilters?: Maybe<SearchSaleFilter>;
    /** search filter for homes sold in last num days */
    searchSoldFilters?: Maybe<SearchSoldFilter>;
    /** show only these search filter type */
    showOnlyType?: Maybe<Array<Maybe<ShowOnlyType>>>;
    /** sort results by the search sort filter type */
    sortBy?: Maybe<SearchSortFilter>;
    /** search filter for user search context */
    userSearchContext?: Maybe<UserSearchContext>;
    /** search filter for homes with specific view type */
    view?: Maybe<Array<Maybe<SearchViewType>>>;
    /** search filters for year the property was built */
    yearBuilt?: Maybe<SearchRangeIntegerFilter>;
};

/** Search filters in PSL format */
export type SearchFiltersInput = {
    /** Price range of search */
    price?: InputMaybe<SearchRangeIntegerFilterInput>;
};

export type SearchHomeType =
    /** apartment homes */
    | 'APARTMENT'
    /** condo type property */
    | 'CONDO'
    /** lot/land property */
    | 'LAND'
    /** manufactured homes */
    | 'MANUFACTURED'
    /** multifamily homes */
    | 'MULTIFAMILY'
    /** single family homes */
    | 'SINGLEFAMILY'
    /** townhome property */
    | 'TOWNHOME'
    /** unknown home type */
    | 'UNKNOWN';

export type SearchPetsAllowed =
    /** rental filter that allows cats */
    | 'CATS'
    /** rental filter that allows large dogs */
    | 'LARGEDOGS'
    /** rental filter that allows small dogs */
    | 'SMALLDOGS';

export type SearchQueryInfo = {
    /**
     * The region id of the anchor city. This param should be specified for
     * LLM collection searches when expecting region-specific data from the backend
     */
    anchorRegionId?: InputMaybe<Scalars['Int']['input']>;
    /**
     * The metadata specified by the user in the search query text (determined by QU API)
     * this can be any filters in textual format
     * E.g. For "Popular cities near Seattle with good schools", the criteria can be "good schools"
     */
    criteria: Scalars['String']['input'];
    /**
     * The intent of user's search query (determined by QU API). Currently Collection search
     * is supported when the queryIntent is specified. When not specified, the default
     * intent is property search i.e. search returning a list of properties
     */
    queryIntent?: InputMaybe<QueryIntent>;
    /**
     * The textual query typed by user in the search bar. This is mainly used when the query intent
     * is Collection search
     */
    rawSearchQuery: Scalars['String']['input'];
};

export type SearchRangeFloatFilter = {
    max?: Maybe<Scalars['Float']['output']>;
    min?: Maybe<Scalars['Float']['output']>;
};

export type SearchRangeIntegerFilter = {
    max?: Maybe<Scalars['Int']['output']>;
    min?: Maybe<Scalars['Int']['output']>;
};

/** Search filters numeric range input filter in PSL format */
export type SearchRangeIntegerFilterInput = {
    /** Maximum end of range */
    max?: InputMaybe<Scalars['Int']['input']>;
    /** Minimum end of range */
    min?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchRefinementDeviceType = 'ANDROID' | 'DESKTOP' | 'IOS' | 'MOBILE' | 'TABLET';

export type SearchRefinementEntity = {
    filters: Array<SearchRefinementFilter>;
    id?: Maybe<Scalars['Int']['output']>;
    label: Scalars['String']['output'];
    regions: Array<Scalars['Long']['output']>;
};

export type SearchRefinementFilter = {
    id: Scalars['String']['output'];
    type: Scalars['String']['output'];
    value: Scalars['String']['output'];
};

export type SearchRefinementListingType = 'FOR_RENT' | 'FOR_SALE' | 'RECENTLY_SOLD';

export type SearchRefinementModelType =
    | 'MODEL_1'
    | 'MODEL_2'
    | 'MODEL_3'
    | 'MULTIPLE_FILTERS'
    | 'NON_BOOLEAN_FILTERS'
    | 'REFINEMENT'
    | 'SAMPLE_REFINEMENT_MODEL_2'
    | 'SAMPLE_REFINEMENT_MODEL_3';

/** Optional arguments used to modify results returns by the API */
export type SearchRefinementQueryOptions = {
    /** Set this flag to determine number of results returned by API */
    maxResults?: Scalars['Int']['input'];
    /** Request results from a specific model type (e.g. filters optimized for submits/engagement or top subregions) */
    modelType?: SearchRefinementModelType;
    /** The preferred regions to search in, evaluated in order, from first to last. */
    regionPrecedence?: Array<Scalars['Int']['input']>;
    /** The latitude/longitude of the user */
    userLocation?: InputMaybe<SearchAssistanceInputLocation>;
    /** The channel the user used to arrive on the page */
    userOrigin?: InputMaybe<SearchRefinementUserOrigin>;
    /** The latitude/longitude of the user's view centroid */
    viewLocation?: InputMaybe<SearchAssistanceInputLocation>;
};

export type SearchRefinementResult = {
    activeRefinements?: Maybe<Array<Maybe<SearchRefinementEntity>>>;
    modelType: SearchRefinementModelType;
    queryTime: Scalars['Long']['output'];
    recommendedDisplay: Scalars['Boolean']['output'];
    suggestedRefinements?: Maybe<Array<Maybe<SearchRefinementEntity>>>;
};

export type SearchRefinementUserIdentity = {
    abKey: Scalars['String']['input'];
};

export type SearchRefinementUserOrigin = 'DIRECT' | 'OTHER' | 'SAVED_SEARCH' | 'SEM' | 'SEO';

export type SearchRentalFilter = {
    /** search rental filter for monthly payment */
    monthlyPayment?: Maybe<SearchRangeIntegerFilter>;
    /** search rental filter for allowed pets */
    petsAllowed?: Maybe<Array<Maybe<SearchPetsAllowed>>>;
    /** The date the rental will be available for move in */
    rentalAvailabilityDate?: Maybe<SearchRangeIntegerFilter>;
    /** search rental marketing treatment */
    rentalMarketingTreatments?: Maybe<RentalMarketingTreatments>;
};

export type SearchSaleFilter = {
    /** days on zillow search sale filter */
    daysOnZillow?: Maybe<SearchRangeIntegerFilter>;
};

export type SearchSoldFilter = {
    /** sold in last number of days search sold filter */
    soldInLast?: Maybe<SearchRangeIntegerFilter>;
};

export type SearchSortFilter = {
    /** sort by the search type */
    searchSortType?: Maybe<SearchSortType>;
    /** sort by ascending order */
    sortAscending?: Maybe<Scalars['Boolean']['output']>;
};

export type SearchSortType =
    /** number of baths search sort type */
    | 'BATHS'
    /** number of beds search sort type */
    | 'BEDS'
    /** days on zillow search sort type */
    | 'DAYS_ON'
    /** is property featured search sort type */
    | 'FEATURED'
    /** home living area search sort type */
    | 'LIVING_AREA'
    /** lot area search sort type */
    | 'LOT_AREA'
    /** homes nearby search sort type */
    | 'NEARBY'
    /** personalized search sort type */
    | 'PERSONALIZED'
    /** personalized2 search sort type */
    | 'PERSONALIZED2'
    /** price search sort type */
    | 'PRICE'
    /** recently changed search sort type */
    | 'RECENTLY_CHANGED'
    /** relevance search sort type */
    | 'RELEVANCE'
    /** relevance2 search sort type */
    | 'RELEVANCE2'
    /** rental days on zillow search sort type */
    | 'RENTAL_DAYS'
    /** rental priority score search sort type */
    | 'RENTAL_PRIORITY_SCORE'
    /** listing type search sort type */
    | 'RENT_SALES_OLDOFFMARKET_BY_NEWEST'
    /** listing type search sort type */
    | 'SALE_SOLD_RENT_OFFMARKET_BY_NEWEST'
    /** year built search sort type */
    | 'YEAR_BUILT';

export type SearchViewType =
    /** properties with city view */
    | 'CITY'
    /** properties with mountain view */
    | 'MOUNTAIN'
    /** properties with park view */
    | 'PARK'
    /** properties with territorial view */
    | 'TERRITORIAL'
    /** properties with water view */
    | 'WATER';

export type SecurityTypesType =
    | 'ControlledAccess'
    | 'Doorman'
    | 'GatedEntry'
    | 'Intercom'
    | 'NightPatrol'
    | 'None'
    | 'Unknown';

export type SelfReported = {
    annualIncome?: Maybe<CurrencyValue>;
    creditScoreRange?: Maybe<CreditScoreRangeCategory>;
    downPayment?: Maybe<DownPayment>;
    location?: Maybe<Array<Maybe<Location>>>;
    monthlyDebts?: Maybe<CurrencyValue>;
    monthlyPayment?: Maybe<CurrencyValue>;
};

export type SelfTourProviderEnumType = 'SELF_TOUR_VENDOR_SERVICE' | 'ZILLOW_OFFERS';

/** Responses from the seller to the initial and adjusted offers */
export type SellerResponseInfoItem = {
    adjustedOfferSellerResponse?: Maybe<Scalars['String']['output']>;
    initialOfferSellerResponse?: Maybe<Scalars['String']['output']>;
};

export type SellingOptionData = {
    questionnaireAnswersList?: Maybe<Array<Maybe<QuestionnaireAnswers>>>;
};

export type SellingOptionsQuestionnaire = {
    mappingSchema?: Maybe<Scalars['JSON']['output']>;
    questionnaireSchema?: Maybe<Scalars['JSON']['output']>;
    schemaKey?: Maybe<Scalars['String']['output']>;
    schemaVersion?: Maybe<Scalars['String']['output']>;
};

/** Type for questionnaire metadata */
export type SellingOptionsQuestionnaireMetadata = {
    createdAt?: Maybe<Scalars['String']['output']>;
    createdBy?: Maybe<Scalars['String']['output']>;
    isLatest?: Maybe<Scalars['Boolean']['output']>;
    schemaKey?: Maybe<Scalars['String']['output']>;
    schemaVersion?: Maybe<Scalars['String']['output']>;
    updatedAt?: Maybe<Scalars['String']['output']>;
    updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SendPaymentNotificationResponse = {
    error?: Maybe<Scalars['String']['output']>;
};

export type SentCoapplicantInvitation = ApplicantContactInfo & {
    email?: Maybe<Scalars['EmailAddress']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    invitedDateTime?: Maybe<Scalars['DateTime']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
};

export type SentLandlordInvitation = {
    email?: Maybe<Scalars['EmailAddress']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    invitedDateTime?: Maybe<Scalars['DateTime']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
};

export type SeoTest = {
    slot?: Maybe<Scalars['Int']['output']>;
    treatment?: Maybe<Scalars['String']['output']>;
    trial?: Maybe<Scalars['String']['output']>;
};

/** DEPRECATED. An artifact of transitional code. */
export type Servers = {
    mortgageAPIExternal?: Maybe<Scalars['String']['output']>;
};

export type ServiceAgreement = {
    agent?: Maybe<PAAgent>;
    buyer?: Maybe<Buyer>;
    compensation?: Maybe<AgentCompensation>;
    createdDate?: Maybe<Scalars['DateTime']['output']>;
    zDocsId?: Maybe<Scalars['String']['output']>;
};

export type ServiceAgreementByIdResponse = {
    agreement?: Maybe<ServiceAgreement>;
    errors?: Maybe<Array<ServiceAgreementError>>;
};

export type ServiceAgreementDocumentCreationError = ServiceAgreementError & {
    message?: Maybe<Scalars['String']['output']>;
    shouldRetry?: Maybe<Scalars['Boolean']['output']>;
};

export type ServiceAgreementDocumentRetrievalError = ServiceAgreementError & {
    message?: Maybe<Scalars['String']['output']>;
    shouldRetry?: Maybe<Scalars['Boolean']['output']>;
};

export type ServiceAgreementDocumentSignError = ServiceAgreementError & {
    message?: Maybe<Scalars['String']['output']>;
    shouldRetry?: Maybe<Scalars['Boolean']['output']>;
};

export type ServiceAgreementDocumentUpdateError = ServiceAgreementError & {
    message?: Maybe<Scalars['String']['output']>;
    shouldRetry?: Maybe<Scalars['Boolean']['output']>;
};

export type ServiceAgreementError = {
    message?: Maybe<Scalars['String']['output']>;
    shouldRetry?: Maybe<Scalars['Boolean']['output']>;
};

export type ServiceAgreementNotFoundError = ServiceAgreementError & {
    message?: Maybe<Scalars['String']['output']>;
    shouldRetry?: Maybe<Scalars['Boolean']['output']>;
};

export type ServiceAgreementOptInType = 'AUTO' | 'MANUAL' | 'OFF';

export type ServiceAgreementUnauthorizedError = ServiceAgreementError & {
    message?: Maybe<Scalars['String']['output']>;
    shouldRetry?: Maybe<Scalars['Boolean']['output']>;
};

export type ServiceAgreements = {
    buyerAgencyAgreement?: Maybe<Array<Maybe<BuyerAgencyAgreement>>>;
    touringAgreement?: Maybe<Array<Maybe<TouringAgreement>>>;
};

export type ServiceAgreementsResponse = {
    agreements?: Maybe<ServiceAgreements>;
    errors?: Maybe<Array<ServiceAgreementError>>;
};

export type SetBridgeMoveProfileError =
    | BadRequestError
    | ConcurrencyTokenConflictError
    | ForbiddenError
    | InternalServerError
    | NotAuthorizedError;

export type SetBridgeMoveProfileRequestInput = {
    arrivalGoals?: InputMaybe<Array<ArrivalGoal>>;
    components?: InputMaybe<Array<BridgeComponentInput>>;
    /** current version of the move, used as a concurrency token to ensure consistency */
    currentMoveVersion?: InputMaybe<Scalars['String']['input']>;
    departureGoals?: InputMaybe<Array<DepartureGoal>>;
    financeGoals?: InputMaybe<Array<FinanceGoal>>;
    firstTimeBuyers?: InputMaybe<FirstTimeBuyerStatus>;
    hasBuyerAgent?: InputMaybe<HasBuyerAgentStatus>;
    isPreQualified?: InputMaybe<IsPreQualifiedStatus>;
    moveId?: InputMaybe<Scalars['String']['input']>;
    participant?: InputMaybe<BridgeParticipantInput>;
    readyToDiscussFinancing?: InputMaybe<ReadyToDiscussFinancingStatus>;
    requestId: Scalars['String']['input'];
    source: BridgeSource;
    startedTouringHomes?: InputMaybe<StartedTouringHomesStatus>;
    timeline?: InputMaybe<BridgeTimelineInput>;
    workingWithLender?: InputMaybe<WorkingWithLenderStatus>;
};

export type SetBridgeMoveProfileResponse = {
    errors?: Maybe<Array<SetBridgeMoveProfileError>>;
    moveId: Scalars['String']['output'];
};

export type ShareHomeHomeEvent = UserEvent & {
    /** Events associated with the semantic tag: share_home:home */
    eventId: Scalars['ID']['output'];
    eventSource: StreamSource;
    eventTime: Scalars['GraphQLLong']['output'];
    /** This is the clickstream event type id */
    eventType: Scalars['String']['output'];
    propertyInfo?: Maybe<PropertyInfo>;
};

export type ShareHomeRentalBuildingEvent = UserEvent & {
    /** Events associated with the semantic tag: share_home:rental_building */
    eventId: Scalars['ID']['output'];
    eventSource: StreamSource;
    eventTime: Scalars['GraphQLLong']['output'];
    /** This is the clickstream event type id */
    eventType: Scalars['String']['output'];
    rentalBuildingInfo?: Maybe<RentalBuildingInfo>;
};

export type SharedBuilderCommunity = {
    distance?: Maybe<Scalars['Float']['output']>;
    ncCommunity?: Maybe<NcCommunity>;
};

export type ShopperProperty = {
    building?: Maybe<VL_Building>;
    personalizedCoShopping?: Maybe<PersonalizedCoShopping>;
    personalizedShoppingForUser?: Maybe<PersonalizedShoppingForUser>;
    property?: Maybe<PropertyResult>;
    propertyId: Scalars['ID']['output'];
    propertyIdType?: Maybe<PropertyIdType>;
};

export type ShopperSavedHome = {
    /**  the categories this saved home belongs to  */
    categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  An ISO-8601 encoded UTC date time string. Example value: 2019-07-03T20:47:55Z  */
    saveDateTime?: Maybe<Scalars['DateTime']['output']>;
};

export type ShowOnlyType =
    /** show only homes that accept rental applications */
    | 'ACCEPTS_RENTAL_APPLICATIONS'
    /** show only homes with air conditioning */
    | 'AIRCONDITIONING'
    /** show only properties with approved virtual tour */
    | 'APPROVED_VIRTUALTOUR'
    /** show only properties with assigned parking */
    | 'ASSIGNED_PARKING'
    /** show only homes with garage */
    | 'GARAGE'
    /** show only properties with a housing connector */
    | 'HOUSING_CONNECTOR'
    /** show only income restricted property */
    | 'INCOME_RESTRICTED'
    /** show only properties with in unit laundry */
    | 'INUNIT_LAUNDRY'
    /** show only properties that have open houses */
    | 'OPEN_HOUSES'
    /** show only homes with pool */
    | 'POOL'
    /** show only properties with a price reduction */
    | 'PRICE_REDUCTION'
    /** show only homes that are single story filter */
    | 'SINGLE_STORY'
    /** show only properties with tour it now */
    | 'TOUR_IT_NOW'
    /** show only water front homes */
    | 'WATER_FRONT'
    /** show only zillow owned homes */
    | 'ZILLOW_OWNED';

export type Showcase = {
    /** @deprecated Use showingTimePlusAgent agentId */
    agentId?: Maybe<Scalars['String']['output']>;
    /** @deprecated Prefer richMedia rooms */
    allPanosToRooms?: Maybe<Scalars['Json']['output']>;
    /** @deprecated Prefer richMedia rooms */
    allPhotosToRooms?: Maybe<Scalars['Json']['output']>;
    /** @deprecated floors array is already sorted */
    floorDisplayOrder: Array<Scalars['String']['output']>;
    /** Floor map guid associated with this showcase model */
    floorMapGuid?: Maybe<Scalars['String']['output']>;
    /** Floor plan data associated with this showcase model */
    floorPlanOnMap?: Maybe<FloorPlanOnMap>;
    /** Floors data associated with this showcase model */
    floors: Array<ShowcaseFloor>;
    /** @deprecated IMX data added separately */
    imx?: Maybe<IMX>;
    /** IMX revision ID associated with this showcase model */
    imxRevisionId?: Maybe<Scalars['String']['output']>;
    /** Panos data associated with this showcase model */
    panos: Array<ShowcasePano>;
    /** @deprecated photos array is already sorted */
    photoDisplayOrder: Array<Scalars['String']['output']>;
    /** High res photos - currently sourced from showcase model */
    photos: Array<ShowcasePhoto>;
    /** @deprecated Use photoLoc */
    photosLocalized?: Maybe<ShowcasePhotosLocalized>;
    /** @deprecated rooms array is already sorted */
    roomDisplayOrder: Array<Scalars['String']['output']>;
    /** Rooms data associated with this showcase model */
    rooms: Array<ShowcaseRoom>;
    /** ShowingTime+ agent data for this showcase model */
    showingTimePlusAgent?: Maybe<ShowcaseAgentInfo>;
    /** @deprecated Use floors array */
    validatedFloor?: Maybe<ShowcaseFloor>;
    /** @deprecated Use panos array */
    validatedPano?: Maybe<ShowcasePano>;
    /** @deprecated Use photos array */
    validatedPhoto?: Maybe<ShowcasePhoto>;
    /** @deprecated Use rooms array */
    validatedRoom?: Maybe<ShowcaseRoom>;
    /** @deprecated No longer used */
    vrModel?: Maybe<VRModel>;
    /** VR model guid associated with this showcase model */
    vrModelGuid?: Maybe<Scalars['String']['output']>;
    /** VR model revision ID associated with this showcase model */
    vrModelRevisionId?: Maybe<Scalars['String']['output']>;
};

export type ShowcasephotosArgs = {
    aspectRatio?: InputMaybe<ShowcaseAspectRatio>;
};

export type ShowcaseAgentInfo = {
    agentId?: Maybe<Scalars['String']['output']>;
    agentPhotoKey?: Maybe<Scalars['String']['output']>;
    agentPhotoUrl?: Maybe<Scalars['String']['output']>;
    brokerageName?: Maybe<Scalars['String']['output']>;
    brokeragePhotoKey?: Maybe<Scalars['String']['output']>;
    brokeragePhotoUrl?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    dre?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    /**
     * URLs for the agent or brokerage's social media
     * @deprecated Do not use in production yet. This is an experimental new field for Showcased Embedded Agent Profiles. It may not be hooked up to real data sources, or the data sources it is hooked up to may not be ready for production-level traffic yet. Schema feedback welcome in the comments of CMXB-191. When the field is finalized and ready for production, the field will unmarked as deprecated as part of that ticket's work.
     */
    socialMediaUrls?: Maybe<ShowcaseAgentInfoSocialMediaUrls>;
    /**
     * URL for the agent or brokerage's website
     * @deprecated Do not use in production yet. This is an experimental new field for Showcased Embedded Agent Profiles. It may not be hooked up to real data sources, or the data sources it is hooked up to may not be ready for production-level traffic yet. Schema feedback welcome in the comments of CMXB-191. When the field is finalized and ready for production, the field will unmarked as deprecated as part of that ticket's work.
     */
    websiteUrl?: Maybe<Scalars['String']['output']>;
    /**
     * Information for the linked Zillow account, if there is one
     * @deprecated Do not use in production yet. This is an experimental new field for Showcased Embedded Agent Profiles. It may not be hooked up to real data sources, or the data sources it is hooked up to may not be ready for production-level traffic yet. Schema feedback welcome in the comments of CMXB-191. When the field is finalized and ready for production, the field will unmarked as deprecated as part of that ticket's work.
     */
    zillowProfile?: Maybe<ShowcaseAgentInfoZillowProfile>;
};

export type ShowcaseAgentInfoSocialMediaUrls = {
    /** Facebook */
    facebook?: Maybe<Scalars['String']['output']>;
    /** Instagram */
    instagram?: Maybe<Scalars['String']['output']>;
    /** LinkedIn */
    linkedin?: Maybe<Scalars['String']['output']>;
    /** TikTok */
    tiktok?: Maybe<Scalars['String']['output']>;
    /** X (formerly Twitter) */
    x?: Maybe<Scalars['String']['output']>;
    /** YouTube */
    youtube?: Maybe<Scalars['String']['output']>;
};

export type ShowcaseAgentInfoZillowProfile = {
    /** Encoded Zillow User ID for the Zillow user (agent or team of agents) that the profile belongs to */
    encodedZuid: Scalars['ID']['output'];
    /** Indicates whether the 'top agent' badge has been earned and can be displayed on the profile */
    isTopAgent?: Maybe<Scalars['Boolean']['output']>;
    /** Ratings information for the profile */
    ratings?: Maybe<ShowcaseAgentInfoZillowProfileRatings>;
    /** Display text to pair with reviewsUrl fields (e.g., '37 Reviews') */
    reviewsText?: Maybe<Scalars['String']['output']>;
    /** Absolute URL for the profile's reviews on the Zillow website */
    reviewsUrl?: Maybe<Scalars['String']['output']>;
    /** Relative URL for the profile's reviews on the Zillow website */
    reviewsUrlRelative?: Maybe<Scalars['String']['output']>;
    /** The unique (but changeable) string used to identify the profile in Zillow URLs */
    screenName?: Maybe<Scalars['String']['output']>;
    /** Absolute URL for the profile on the Zillow website */
    url?: Maybe<Scalars['String']['output']>;
    /** Relative URL for the profile on the Zillow website */
    urlRelative?: Maybe<Scalars['String']['output']>;
};

export type ShowcaseAgentInfoZillowProfileRatings = {
    /** Average rating for the profile */
    average: Scalars['Float']['output'];
    /** Total number of ratings for the profile */
    count: Scalars['Int']['output'];
};

export type ShowcaseAspectRatio = 'FourThirds' | 'Original' | 'ThreeToTwo' | 'TwoToOne';

export type ShowcaseAvailableData = 'SHOWCASE_COMPLETE' | 'SHOWCASE_STARTED' | 'UNKNOWN';

export type ShowcaseFloor = {
    /** @deprecated Use richMedia.floors for this data */
    entrancePanoId?: Maybe<Scalars['String']['output']>;
    /** Physical floor order (in real life) */
    floorNumber: Scalars['Int']['output'];
    /** Floor ID */
    id: Scalars['String']['output'];
    /** @deprecated Use richMedia.floors for this data */
    isPanoless?: Maybe<Scalars['Boolean']['output']>;
    /** Floor name or label */
    name: Scalars['String']['output'];
    /** SVG visualization source for the floor plan */
    primarySvgSource: Scalars['String']['output'];
    /** @deprecated Use richMedia.floors for this data */
    sqft?: Maybe<Scalars['Float']['output']>;
    /** @deprecated Use richMedia.floors for this data */
    visualizationId?: Maybe<Scalars['String']['output']>;
};

export type ShowcasePano = RichMediaPano & {
    /** Panos that can be navigated to from the current pano */
    destinations: Array<ShowcasePanoDestination>;
    /** Pano ID */
    entityId: Scalars['String']['output'];
    /** Associated floor ID */
    floorId: Scalars['String']['output'];
    /** Max fov or zoom level (in degrees): 180 for spherical panos, less for hand-held capture */
    fov: Scalars['Int']['output'];
    /** @deprecated hidden panos are filtered out */
    isHidden: Scalars['Boolean']['output'];
    /** @deprecated use richMedia rooms */
    rooms: Array<Maybe<Scalars['String']['output']>>;
    /** Safe default display angle (in degrees): editable via 3d tour editor */
    startAngle: Scalars['Int']['output'];
    /** Pano texture data and urls */
    textureFileUrls: ShowcaseTextureFileUrls;
    /** Pano title or label */
    title: Scalars['String']['output'];
};

export type ShowcasePanoDestination = RichMediaPanoDestination & {
    /** Angle that the arrow (exit) should point to (in degrees) */
    departureAngle: Scalars['Int']['output'];
    /** Pano ID */
    destEntityId: Scalars['String']['output'];
    /** @deprecated filter out destinations with hidden panos */
    isHidden: Scalars['Boolean']['output'];
    /** Relative angle between current pano and destination pano (in degrees). Aligns panos to same real world direction since tripod is not perfectly aligned between panos in real life. Combine this with user's current viewing angle to get direction they would face when they arrive. */
    panoRelativeAngle?: Maybe<Scalars['Float']['output']>;
    /** Pano title or label */
    title: Scalars['String']['output'];
};

export type ShowcasePhoto = RichMediaPhoto & {
    /** Alt text for the photo */
    alt: Scalars['String']['output'];
    /** @deprecated Unnecessary as photos array is already sorted */
    displayOrder: Scalars['Int']['output'];
    /** Photo ID or key */
    id: Scalars['String']['output'];
    /** Is photo chosen as hero photo by the agent for display on the SDP */
    isHeroPhoto: Scalars['Boolean']['output'];
    /** Is photo an interior photo */
    isInteriorPhoto?: Maybe<Scalars['Boolean']['output']>;
    /** Is photo showcased by the agent for display on the SDP */
    isShowcased: Scalars['Boolean']['output'];
    /** Responsive photo URLs */
    mixedSources: ShowcasePhotoMixedSources;
    /** @deprecated use richMedia rooms */
    rooms: Array<Maybe<Scalars['String']['output']>>;
};

/** Same as PhotoMixedSource but we cannot re-name types and this came first */
export type ShowcasePhotoMixedSource = MixedSource & {
    url: Scalars['String']['output'];
    width: Scalars['Int']['output'];
};

/** Same as PhotoMixedSources but we cannot re-name types and this came first */
export type ShowcasePhotoMixedSources = MixedSources & {
    jpeg: Array<ShowcasePhotoMixedSource>;
    webp: Array<ShowcasePhotoMixedSource>;
};

export type ShowcasePhotosLocalized = {
    source?: Maybe<Scalars['String']['output']>;
};

export type ShowcaseRoom = {
    /** @deprecated Unnecessary as rooms array is already sorted */
    displayOrder: Scalars['Int']['output'];
    /** Floor ID associated with this room */
    floorId: Scalars['String']['output'];
    /** Room ID */
    id: Scalars['String']['output'];
    /** Whether the room is chosen to display on the SDP */
    isShowcased: Scalars['Boolean']['output'];
    /** Room name or label */
    name: Scalars['String']['output'];
    /** One showcased pano to display on the SDP */
    panoId?: Maybe<Scalars['String']['output']>;
    /** 1-3 showcased photos to display on the SDP */
    photos: Array<Scalars['String']['output']>;
};

export type ShowcaseTextureFileUrlTiles = RichMediaTextureFileUrlTiles & {
    coords: Array<Scalars['Int']['output']>;
    url: Scalars['String']['output'];
};

export type ShowcaseTextureFileUrls = RichMediaTextureFileUrls & {
    pano4k: Scalars['String']['output'];
    pano512: Scalars['String']['output'];
    thumbnail?: Maybe<Scalars['String']['output']>;
    tiles: Array<ShowcaseTextureFileUrlTiles>;
};

export type ShowingTimeCancellationInput = {
    /** **Definition:** Optional, maps to PA cancellation reason id, required if cancellationReasonText is not provided */
    cancellationReasonId?: InputMaybe<Scalars['Int']['input']>;
    /** **Definition:** Optional, required if cancellationReasonId is not provided */
    cancellationReasonText?: InputMaybe<Scalars['String']['input']>;
};

export type ShowingTimeCancellationResponse = {
    /** **Definition:** Explanatory details for unsuccessful requests */
    errorMessage?: Maybe<Scalars['String']['output']>;
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type ShowingTimePlus = {
    agentBatchLatest?: Maybe<Array<Maybe<ShowingTimePlusAgent>>>;
    agentLatest?: Maybe<ShowingTimePlusAgent>;
};

export type ShowingTimePlusagentBatchLatestArgs = {
    agentIdList: Array<Scalars['ID']['input']>;
};

export type ShowingTimePlusagentLatestArgs = {
    agentId: Scalars['ID']['input'];
};

export type ShowingTimePlusAgent = {
    /**  Used as primary key *  */
    agentId: Scalars['String']['output'];
    /**  Agent profile photo key for Federated Photos  */
    agentPhotoKey?: Maybe<Scalars['String']['output']>;
    /**  Brokerage name  */
    brokerageName?: Maybe<Scalars['String']['output']>;
    /**  Brokerage logo photo key for Federated Photos  */
    brokeragePhotoKey?: Maybe<Scalars['String']['output']>;
    /**  Text that provides a bio / description of the agent, brokerage or team  */
    description?: Maybe<Scalars['String']['output']>;
    /**  California DRE Number  */
    dreNumber?: Maybe<Scalars['String']['output']>;
    /**  Agent contact email to be displayed on SDP as a way to contact the agent  */
    email?: Maybe<Scalars['String']['output']>;
    encodedZuid?: Maybe<Scalars['String']['output']>;
    /**  Agent display first name  */
    firstName?: Maybe<Scalars['String']['output']>;
    /**  Agent display last name  */
    lastName?: Maybe<Scalars['String']['output']>;
    /**  Agent primary contact phone not to be displayed on SDP  */
    phone?: Maybe<Scalars['String']['output']>;
    socialMediaUrls?: Maybe<ShowingTimePlusAgent_SocialMediaUrls>;
    /**  Agent web site  */
    websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type ShowingTimePlusAgent_SocialMediaUrls = {
    /**  Facebook  */
    facebook?: Maybe<Scalars['String']['output']>;
    /**  Instagram  */
    instagram?: Maybe<Scalars['String']['output']>;
    /**  LinkedIn  */
    linkedin?: Maybe<Scalars['String']['output']>;
    /**  TikTok  */
    tiktok?: Maybe<Scalars['String']['output']>;
    /**  X (formerly Twitter)  */
    x?: Maybe<Scalars['String']['output']>;
    /**  YouTube  */
    youtube?: Maybe<Scalars['String']['output']>;
};

export type ShowingTimeSlot = {
    /**
     * **Definition:** The end time of the available time slot, in the property time zone
     *
     * **Source:** showing-time-api
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example:** 13:30
     */
    endTime?: Maybe<Scalars['LocalTime']['output']>;
    /**
     * **Definition:** The start time of the available time slot, in the property time zone
     *
     * **Source:** showing-time-api
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example:** 13:00
     */
    startTime?: Maybe<Scalars['LocalTime']['output']>;
};

export type ShowingTimeTourAvailability = {
    /**
     * **Definition:** The ShowingTime tour availability of the requested property listing per specified requested date
     *
     * **Source:** showing-time-api
     *
     * **Auth:** Uses the auth of the parent field
     */
    availabilities?: Maybe<Array<Maybe<ShowingTimeTourAvailabilityPerDate>>>;
    /**
     * **Definition:** The ShowingTime availability status of the requested property listing. Can be one of the following:
     * NOT_COVERED (Property is not covered by ST), NOT_AVAILABLE (Listing is inactive in ST), OK (Real-Time Availability (RTA) enabled), PRIVATE_LISTING (Availability is not public a.k.a. Online Enablement), SERVER_ERROR (Other issue occurred when fetching data)
     *
     * **Source:** showing-time-api
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example:** NOT_COVERED
     */
    status?: Maybe<ShowingTimeTourAvailabilityStatus>;
};

export type ShowingTimeTourAvailabilityPerDate = {
    /**
     * **Definition:** The requested date for the availability of the interested property
     *
     * **Source:** showing-time-api
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example:** 2025-12-31
     */
    requestedDate?: Maybe<Scalars['LocalDate']['output']>;
    /**
     * **Definition:** The time slots available for touring the interested property, in the property time zone
     *
     * **Source:** showing-time-api
     *
     * **Auth:** Uses the auth of the parent field
     */
    timeSlots?: Maybe<Array<Maybe<ShowingTimeSlot>>>;
};

export type ShowingTimeTourAvailabilityStatus =
    | 'NOT_AVAILABLE'
    | 'NOT_COVERED'
    | 'OK'
    | 'PRIVATE_LISTING'
    | 'SERVER_ERROR';

export type ShowingTimeUpdateTimeInput = {
    endTime?: InputMaybe<Scalars['LocalTime']['input']>;
    requestedDate: Scalars['LocalDate']['input'];
    startTime: Scalars['LocalTime']['input'];
};

export type Signator = {
    email?: Maybe<Scalars['String']['output']>;
    firstName?: Maybe<Scalars['String']['output']>;
    lastName?: Maybe<Scalars['String']['output']>;
    mailingAddress?: Maybe<Scalars['String']['output']>;
    telephone?: Maybe<Scalars['String']['output']>;
    userToken?: Maybe<Scalars['String']['output']>;
};

export type SignedUser = {
    fullName?: Maybe<Scalars['String']['output']>;
    hasSigned?: Maybe<Scalars['Boolean']['output']>;
    isItMe?: Maybe<Scalars['Boolean']['output']>;
    ouid?: Maybe<Scalars['String']['output']>;
    userType?: Maybe<Scalars['String']['output']>;
};

export type SimilarRentalFloorplans = {
    boundingBox?: Maybe<boundingBox>;
    distanceInMiles?: Maybe<Scalars['Float']['output']>;
    floorplans?: Maybe<Array<Maybe<RentalFloorplans>>>;
};

export type SizeWithUnits = {
    /** The size of the entity */
    size?: Maybe<Scalars['Float']['output']>;
    /** The units that correspond to the size such as Square Feet, Linear Feet, etc. */
    sizeUnits?: Maybe<Scalars['String']['output']>;
};

/**
 * **Definition:** Sms preferences for agent notifications
 * **Datasource:** EAN-API
 *
 * **Team Slack:** #deltaforce
 */
export type SmsPreferences = {
    active?: Maybe<Scalars['Boolean']['output']>;
    agentPhoneNumber?: Maybe<Scalars['String']['output']>;
    dayMask?: Maybe<Scalars['String']['output']>;
    hourMask?: Maybe<Scalars['String']['output']>;
    smsPreferenceId?: Maybe<Scalars['ID']['output']>;
    timeZone?: Maybe<Scalars['String']['output']>;
};

export type SolarPotential = {
    /**
     * The build factor value is based on the pitch, orientation, and size of the
     * roof planes, along with the amount of shade across the roof.
     */
    buildFactor?: Maybe<Scalars['Float']['output']>;
    /** Based on data from NREL, this corresponds to the annual amount of solar radiation in this region. */
    climateFactor?: Maybe<Scalars['Float']['output']>;
    /** Based on data from NREL, the higher the average cost of electricity the higher the score. */
    electricityFactor?: Maybe<Scalars['Float']['output']>;
    /** Based on data from NREL who estimates the average cost of a solar installation in the region. */
    solarFactor?: Maybe<Scalars['Float']['output']>;
    /** SunScore is a value out of 100 that takes into account a buildings ability to utilize and save money using solar panals. */
    sunScore?: Maybe<Scalars['Float']['output']>;
};

export type SoldComp = {
    /**  property used for comparison  */
    property: Property;
    /**  zpid of property used for comparison  */
    zpid: Scalars['Int']['output'];
};

export type SoldReservedListing = {
    address?: Maybe<Scalars['String']['output']>;
    latitude?: Maybe<Scalars['Float']['output']>;
    longitude?: Maybe<Scalars['Float']['output']>;
    price?: Maybe<Scalars['Int']['output']>;
    soldDate?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
};

export type Sort = 'ASC' | 'DESC';

export type SortOrderType =
    | 'BATHS'
    | 'BEDS'
    | 'DAYS_ON'
    | 'FEATURED'
    | 'LIVING_AREA'
    | 'LOT_AREA'
    | 'NEAR_BY'
    | 'PERSONALIZED'
    | 'PRICE'
    | 'RECENTLY_CHANGED'
    | 'RENTAL_DAYS'
    | 'RENTAL_PRIORITY_SCORE'
    | 'RENT_SALE_SOLD_OF_MARKET_BY_NEWEST'
    | 'SALE_SOLD_RENT_OFF_MARKET_BY_NEWEST'
    | 'YEAR_BUILT';

export type SpecPlanZpidsMapping = {
    planZpid?: Maybe<Scalars['Int']['output']>;
    specZpid?: Maybe<Scalars['Int']['output']>;
};

export type SpecialHousingType =
    | 'DISABLED'
    | 'INCOME_RESTRICTED'
    | 'MILITARY'
    | 'SENIOR'
    | 'STUDENT'
    | 'UNKNOWN';

/** Special offer information with end date information */
export type SpecialOffer = {
    description?: Maybe<Scalars['String']['output']>;
    endDate?: Maybe<Scalars['DateTime']['output']>;
};

export type SpecialOfferType = {
    specialOfferBeginDate?: Maybe<Scalars['String']['output']>;
    specialOfferDescription?: Maybe<Scalars['String']['output']>;
    specialOfferEndDate?: Maybe<Scalars['String']['output']>;
    specialOfferId?: Maybe<Scalars['Int']['output']>;
};

export type SpellCorrectedMetadata = {
    /** Spell corrected flag to indicate if query was spell corrected */
    isSpellCorrected?: Maybe<Scalars['Boolean']['output']>;
    /** Spell corrected query returned by AIP service */
    spellCorrectedQuery?: Maybe<Scalars['String']['output']>;
    /** User query provided to the API */
    userQuery?: Maybe<Scalars['String']['output']>;
};

export type SportsCourtType =
    | 'BasketballCourt'
    | 'BocceeCourt'
    | 'MultiPurposeSportsCourt'
    | 'None'
    | 'Other'
    | 'RacquetballCourt'
    | 'ShuffleboardCourt'
    | 'SportsField'
    | 'TennisCourt'
    | 'Unknown'
    | 'VolleyballCourt';

export type SsidMlsAgentIdentifierPair = {
    /** The identifier for the agent within a given MLS (that MLS is identified by the SSID) */
    mlsAgentIdentifier: Scalars['ID']['input'];
    /** The search setup id */
    ssid: Scalars['ID']['input'];
};

export type StandingOffer = {
    expGroup?: Maybe<Scalars['String']['output']>;
    isStandingOfferEligible?: Maybe<Scalars['Boolean']['output']>;
    market?: Maybe<Scalars['String']['output']>;
    standingOfferPrice?: Maybe<Scalars['Int']['output']>;
    version?: Maybe<Scalars['String']['output']>;
};

export type StartedTouringHomesStatus = 'NO' | 'UNSPECIFIED' | 'YES';

export type State =
    | 'AK'
    | 'AL'
    | 'AR'
    | 'AZ'
    | 'CA'
    | 'CO'
    | 'CT'
    | 'DC'
    | 'DE'
    | 'FL'
    | 'GA'
    | 'HI'
    | 'IA'
    | 'ID'
    | 'IL'
    | 'IN'
    | 'KS'
    | 'KY'
    | 'LA'
    | 'MA'
    | 'MD'
    | 'ME'
    | 'MI'
    | 'MN'
    | 'MO'
    | 'MS'
    | 'MT'
    | 'NC'
    | 'ND'
    | 'NE'
    | 'NH'
    | 'NJ'
    | 'NM'
    | 'NV'
    | 'NY'
    | 'OH'
    | 'OK'
    | 'OR'
    | 'PA'
    | 'RI'
    | 'SC'
    | 'SD'
    | 'TN'
    | 'TX'
    | 'UT'
    | 'VA'
    | 'VT'
    | 'WA'
    | 'WI'
    | 'WV'
    | 'WY';

/** A static map of the requested property in a range of sizes */
export type StaticMap = {
    sources?: Maybe<Array<Maybe<ResponsiveImageSource>>>;
};

/** A static map of the requested property in a range of sizes */
export type StaticMapsourcesArgs = {
    aspectRatio?: InputMaybe<AspectRatio>;
    maxWidth?: InputMaybe<Scalars['Int']['input']>;
    minWidth?: InputMaybe<Scalars['Int']['input']>;
};

export type StaticMapView = {
    /** The information of the hybrid static view photo */
    hybridViewPhotoLink?: Maybe<PhotoLink>;
    /** The information of the road static view photo */
    roadViewPhotoLink?: Maybe<PhotoLink>;
    /** The information of the satellite static view photo */
    satelliteViewPhotoLink?: Maybe<PhotoLink>;
    /** The information of the terrain static view photo */
    terrainViewPhotoLink?: Maybe<PhotoLink>;
};

export type StatusType =
    | 'ADS_RESTRICTED'
    | 'COMMINGLING_CATEGORY'
    | 'DATA_DELETED'
    | 'DATA_NOT_FOUND'
    | 'INTERNAL_EXCEPTION'
    | 'NO_FRONT_FACING_PALS'
    | 'OK'
    | 'PALSID_NO_MATCH'
    | 'UNKNOWN';

/** Message with details about the current task step. */
export type StepMessage = {
    /** Body of the step message. */
    body?: Maybe<Scalars['String']['output']>;
    /** Title/heading for the step message. */
    heading?: Maybe<Scalars['String']['output']>;
};

/** Message displayed to user regarding task progress. */
export type StepMessageInput = {
    /** Body of the step message. */
    body?: InputMaybe<Scalars['String']['input']>;
    /** Title/heading for the step message. */
    heading?: InputMaybe<Scalars['String']['input']>;
};

export type StickyHeader = {
    /** The CTA to display on the sticky header */
    cta?: Maybe<MortgageCTA>;
    /** The monthly cost value to display on the sticky header */
    monthlyCost?: Maybe<Scalars['String']['output']>;
};

export type StreamSource = 'CLICKSTREAM';

export type StreamingUserSegmentPersonalization = {
    /**  Sort key used by ODP. This is going to be the experience_id generated by offline job  */
    experienceId?: Maybe<Scalars['String']['output']>;
    /** @deprecated This field no longer exists based on the latest generated schema. */
    generatedDate?: Maybe<Scalars['Long']['output']>;
    /**  Concatination of type-value for user identification. For example, zuid-1234. This is the ODP primary key  */
    userId?: Maybe<Scalars['String']['output']>;
    /**  Container for User Segment Personlized information for a  specific user. Format is v1  */
    userPersonalizedInfo?: Maybe<StreamingUserSegmentPersonalization_UserSegmentPersonalization>;
    zuid: Scalars['String']['output'];
};

export type StreamingUserSegmentPersonalization_Segment =
    | 'dreamer'
    | 'highIntent'
    | 'seg_1'
    | 'seg_2';

export type StreamingUserSegmentPersonalization_UserSegmentPersonalization = {
    personalizationId?: Maybe<Scalars['String']['output']>;
    segmentInfo?: Maybe<StreamingUserSegmentPersonalization_Segment>;
    sendBudget?: Maybe<Scalars['Int']['output']>;
    sendThreshold?: Maybe<Array<Scalars['Float']['output']>>;
};

/** Street view images of the requested property in a range of sizes */
export type StreetView = {
    addressSources?: Maybe<Array<Maybe<ResponsiveImageSource>>>;
    latLongSources?: Maybe<Array<Maybe<ResponsiveImageSource>>>;
};

/** Street view images of the requested property in a range of sizes */
export type StreetViewaddressSourcesArgs = {
    aspectRatio?: InputMaybe<AspectRatio>;
    maxWidth?: InputMaybe<Scalars['Int']['input']>;
    minWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** Street view images of the requested property in a range of sizes */
export type StreetViewlatLongSourcesArgs = {
    aspectRatio?: InputMaybe<AspectRatio>;
    maxWidth?: InputMaybe<Scalars['Int']['input']>;
    minWidth?: InputMaybe<Scalars['Int']['input']>;
};

export type StringValue = {
    string: Scalars['String']['output'];
};

export type StructureType = 'GARDEN_STYLE' | 'MULTI_BUILDING' | 'SINGLE_BUILDING';

export type StructuredHours = {
    day?: Maybe<DayOfWeek>;
    /** Hours end time in ms */
    endHour?: Maybe<Scalars['Int']['output']>;
    /** Hours start time in ms */
    startHour?: Maybe<Scalars['Int']['output']>;
};

export type StyledText = {
    stylings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    text?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['URL']['output']>;
};

export type SubmitFlowCTA = {
    action?: Maybe<SubmitFlowCTAAction>;
    clickstreamMetadata: SubmitFlowCTAClickstreamMetadata;
    label: Scalars['String']['output'];
};

export type SubmitFlowCTAAction = LaunchUrlCTAAction;

export type SubmitFlowCTAClickstreamMetadata = {
    onClick?: Maybe<Scalars['JSON']['output']>;
    onError?: Maybe<Scalars['JSON']['output']>;
    onSuccess?: Maybe<Scalars['JSON']['output']>;
};

export type SubmitFlowComponent =
    | ABAD
    | AdditionalHomesDetail
    | AuthOTP
    | FinanceUpsellPage
    | FormQuestionnaire
    | MyAgentReconnections
    | NonConfirmationUpsellPage
    | PropertyLeadSubmitForm
    | RequestTour;

export type SubmitFlowComponentClickstreamMetadata = {
    onClick?: Maybe<Scalars['JSON']['output']>;
    onEarlyExit?: Maybe<Scalars['JSON']['output']>;
    onExit?: Maybe<Scalars['JSON']['output']>;
    onPageView?: Maybe<Scalars['JSON']['output']>;
    onSuccess?: Maybe<Scalars['JSON']['output']>;
};

export type SubmitFlowIcon =
    | 'IconCheckmark'
    | 'IconCheckmarkCircleOutline'
    | 'Lightbulb'
    | 'TourNotConfirmed';

export type SubmitFlowImageFormat = {
    size: SubmitFlowPhotoSize;
    type: SubmitFlowPhotoType;
    url: Scalars['String']['output'];
};

export type SubmitFlowInput = {
    initialSubmitFlowState: InitialSubmitFlowState;
    propertyLeadSubmitFormInput?: InputMaybe<PropertyLeadSubmitFormInput>;
    questionnaireFormInput?: InputMaybe<QuestionnaireFormInput>;
    tourRequestFormInput?: InputMaybe<TourRequestFormInput>;
    tourUpgradeInput?: InputMaybe<TourUpgradeInput>;
};

export type SubmitFlowOverlay = {
    bodyContent: Scalars['String']['output'];
    clickstreamMetadata: SubmitFlowComponentClickstreamMetadata;
    indices?: Maybe<IndexRange>;
    title: Scalars['String']['output'];
};

export type SubmitFlowPhoto = {
    format: Array<SubmitFlowImageFormat>;
};

export type SubmitFlowPhotoformatArgs = {
    size: SubmitFlowPhotoSize;
    type: SubmitFlowPhotoType;
};

export type SubmitFlowPhotoSize = 'L' | 'M' | 'S' | 'XL';

export type SubmitFlowPhotoType = 'JPEG' | 'PDF' | 'PNG' | 'SVG' | 'UNKNOWN';

export type SubmitFlowRequestSource = 'HDP_CTA' | 'HDP_INLINE' | 'SAVED_HOME';

export type SubmitFlowRequestType = 'CONTACT_AGENT' | 'REQUEST_TOUR';

export type SubmitFlowTip = {
    icon?: Maybe<SubmitFlowIcon>;
    text: Scalars['String']['output'];
};

export type SubmitFlowTourType = 'INSTANT' | 'INSTANT_BOOK' | 'NONE' | 'STANDARD';

export type SubmitQuestionnaireInput = {
    borrowers: Array<Scalars['ID']['input']>;
    questionnaireType: ZHLQuestionnaireType;
};

export type SubmitQuestionnaireOutput = {
    success: Scalars['Boolean']['output'];
};

export type SubmitZHLLeadInput = {
    abadInfo?: InputMaybe<ZHLLeadAbadInfo>;
    borrower: ZHLLeadBorrower;
    citizenship?: InputMaybe<ZHLLeadCitizenshipType>;
    creditScore?: InputMaybe<ZHLBorrowerCreditScore>;
    downPayment?: InputMaybe<Scalars['Int']['input']>;
    eSignatureConsent?: InputMaybe<Scalars['Boolean']['input']>;
    firstTimeBuyer?: InputMaybe<Scalars['Boolean']['input']>;
    gaClientID?: InputMaybe<Scalars['String']['input']>;
    hasAgent?: InputMaybe<Scalars['Boolean']['input']>;
    hasBankruptcy?: InputMaybe<Scalars['Boolean']['input']>;
    hasForeclosure?: InputMaybe<Scalars['Boolean']['input']>;
    journeyStage?: InputMaybe<ZHLLeadJourneyStage>;
    jumbo?: InputMaybe<Scalars['Boolean']['input']>;
    loanPurpose?: InputMaybe<ZHLLeadLoanPurpose>;
    lsh?: InputMaybe<ZHLLeadLsh>;
    marketingInfo?: InputMaybe<ZHLLeadMarketingInfo>;
    propertyAddress: ZHLLeadPropertyAddress;
    propertyType?: InputMaybe<ZHLBorrowerPropertyType>;
    propertyUse?: InputMaybe<ZHLBorrowerPropertyUse>;
    propertyValue?: InputMaybe<Scalars['Int']['input']>;
    tcpaConsent?: InputMaybe<Scalars['Boolean']['input']>;
    transactionTimeframe?: InputMaybe<TransactionTimeframe>;
    vaEligible?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Team member connection target. */
export type SubmittedConnectionTarget = {
    /** The ID of the capacity history record for the same update. */
    capacityHistoryId: Scalars['Int']['output'];
    /** The connection target for the team member */
    connectionTarget: Scalars['Int']['output'];
    /** The email of the user who made the submission (Audrey). */
    submittedBy: Scalars['String']['output'];
    /** The team member associated with this conneection target */
    teamMember: PAAgent;
    /** The ID of the recommendation record Audrey submitted for. */
    teamRecommendationId: Scalars['Int']['output'];
};

/** Query input to retrive submitted connection target history info for a team member */
export type SubmittedConnectionTargetHistoryInput = {
    /** Id of the recommendations that were being shown for Audrey to submit */
    recommendationBatchId: Scalars['String']['input'];
    /** The team lead's zuid */
    teamLeadZuid: ZuidInput;
};

export type SubsequentTourAnswerEnumType = 'ACCEPTED' | 'DECLINED';

export type SubsequentTourRequestInput = {
    confirmedTime?: InputMaybe<TourAppointmentSlotZonedInput>;
    rejectedReasonId?: InputMaybe<Scalars['Int']['input']>;
    responseType: SubsequentTourAnswerEnumType;
};

export type SubsequentTourRequestResponse = {
    /** **Definition:** Explanatory details for unsuccessful requests */
    errorMessage?: Maybe<Scalars['String']['output']>;
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type SuccessOutput = {
    id?: Maybe<Scalars['ID']['output']>;
    success?: Maybe<Scalars['Boolean']['output']>;
    zhlBorrower?: Maybe<ZHLBorrower>;
    zhlLoan?: Maybe<ZHLLoan>;
};

/** Address of the building */
export type SummaryAddress = {
    city?: Maybe<Scalars['String']['output']>;
    postalCode?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
};

/** Survey data for a specific touchpoint */
export type SurveyTouchpoint = {
    answers?: Maybe<Scalars['JSON']['output']>;
    firstQuestionName?: Maybe<Scalars['String']['output']>;
    questions?: Maybe<Scalars['JSON']['output']>;
    surveyInstanceID?: Maybe<Scalars['Int']['output']>;
    surveyLink?: Maybe<Scalars['String']['output']>;
    surveyName?: Maybe<Scalars['String']['output']>;
    touchpoint?: Maybe<Scalars['String']['output']>;
};

/** SwitchboardConversationMessages ... */
export type SwitchboardConversationMessages = {
    createDt?: Maybe<Scalars['String']['output']>;
    message?: Maybe<Scalars['String']['output']>;
    messageMetadata?: Maybe<Scalars['String']['output']>;
    messageType?: Maybe<Scalars['String']['output']>;
    persona?: Maybe<SwitchboardPersonaType>;
    senderId?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    updateDt?: Maybe<Scalars['String']['output']>;
};

/** SwitchboardConversationParticipants ... */
export type SwitchboardConversationParticipants = {
    channelType?: Maybe<Scalars['String']['output']>;
    createDt?: Maybe<Scalars['String']['output']>;
    isActive?: Maybe<Scalars['Boolean']['output']>;
    persona?: Maybe<SwitchboardPersonaType>;
    referenceId?: Maybe<Scalars['String']['output']>;
    referenceType?: Maybe<Scalars['String']['output']>;
    updateDt?: Maybe<Scalars['String']['output']>;
};

/** SwitchboardConversationResponse ... */
export type SwitchboardConversationResponse = {
    clientName?: Maybe<Scalars['String']['output']>;
    conversationId?: Maybe<Scalars['String']['output']>;
    createDt?: Maybe<Scalars['String']['output']>;
    messages?: Maybe<Array<Maybe<SwitchboardConversationMessages>>>;
    notificationConnectionId?: Maybe<Scalars['String']['output']>;
    participants?: Maybe<Array<Maybe<SwitchboardConversationParticipants>>>;
    updateDt?: Maybe<Scalars['String']['output']>;
    userId?: Maybe<Scalars['String']['output']>;
    userIdType?: Maybe<Scalars['String']['output']>;
};

/** SwitchboardGetConversationInput ... */
export type SwitchboardGetConversationInput = {
    conversation_id?: InputMaybe<Scalars['ID']['input']>;
    notification_connection_id?: InputMaybe<Scalars['ID']['input']>;
};

export type SwitchboardLlmMetadata = {
    createDt?: Maybe<Scalars['String']['output']>;
    data?: Maybe<Scalars['String']['output']>;
    referenceID?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

export type SwitchboardLlmModelDetails = {
    model?: Maybe<Scalars['String']['output']>;
    usage?: Maybe<SwitchboardLlmUsage>;
};

export type SwitchboardLlmResponse = {
    createDt?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<Array<Maybe<SwitchboardLlmMetadata>>>;
    modelDetails?: Maybe<SwitchboardLlmModelDetails>;
    nci?: Maybe<Scalars['String']['output']>;
    requestID?: Maybe<Scalars['String']['output']>;
    response?: Maybe<Array<Maybe<SwitchboardResponse>>>;
    skill?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
    updateDt?: Maybe<Scalars['String']['output']>;
};

export type SwitchboardLlmUsage = {
    completionTokens?: Maybe<Scalars['Int']['output']>;
    cost?: Maybe<Scalars['String']['output']>;
    promptTokens?: Maybe<Scalars['Int']['output']>;
    totalTokens?: Maybe<Scalars['Int']['output']>;
};

/** Type of the persona in switchboard conversations */
export type SwitchboardPersonaType =
    | 'BUYER'
    | 'BUYERAGENT'
    | 'CONCIERGEREP'
    | 'CONSUMER'
    | 'LOANOFFICER'
    | 'LOANOFFICER_ASSISTANT'
    | 'LOANOFFICER_MANAGER'
    | 'LOANPROCESSOR'
    | 'SELLER'
    | 'SELLERAGENT'
    | 'SYSTEM'
    | 'UNSPECIFIED';

/** SwitchboardPhone ... */
export type SwitchboardPhone = {
    associations?: Maybe<Array<Maybe<Association>>>;
    phoneNumber?: Maybe<Scalars['String']['output']>;
    phoneSource?: Maybe<PhoneSource>;
};

/** SwitchboardResponse ... */
export type SwitchboardResponse = {
    choiceIndex?: Maybe<Scalars['Int']['output']>;
    createDt?: Maybe<Scalars['String']['output']>;
    finishReason?: Maybe<Scalars['String']['output']>;
    llmId?: Maybe<Scalars['String']['output']>;
    message?: Maybe<Scalars['String']['output']>;
    object?: Maybe<Scalars['String']['output']>;
    updateDt?: Maybe<Scalars['String']['output']>;
};

/** @deprecated: use ZHLTaskParticipantRole */
export type TaskParticipantRole =
    | 'CoBorrower'
    | 'LoanOfficer'
    | 'LoanOfficerManager'
    | 'PrimaryBorrower'
    | 'Processor'
    | 'ProcessorManager'
    | 'Underwriter'
    | 'UnderwriterManager'
    | 'Unspecified'
    | 'ZHLEmployee';

/** Each task will have one type of payload depending on task type - either MicroUI or DeepLink. */
export type TaskPayload = DeepLinkPayload | MicroUIPayload;

/** Information necessary for displaying different types of tasks. */
export type TaskPayloadInput = {
    /** Text for the button shown for this task. Populate regardless of taskType. */
    buttonLabel: Scalars['String']['input'];
    /** If taskType is MICRO_UI, this is the URL to the remote package used by the platform to display content. Do not populate the url field. */
    remotePackageUrl?: InputMaybe<Scalars['String']['input']>;
    /** If taskType is DEEP_LINK, this is the URL to deep link experience for user. Do not populate the remotePackageUrl field. */
    url?: InputMaybe<Scalars['String']['input']>;
};

/** Type of task */
export type TaskType =
    /** Deep Link task. Task that includes a deep-link that takes users to an LOB-controlled experience */
    | 'DEEP_LINK'
    /** Micro-UI task. Task that utilizes Micro-UI platform to deliver content dynamically on Illuminate UI page */
    | 'MICRO_UI';

/** A single item in a tax history */
export type TaxRecord = {
    /** The percentage change in tax paid over the previous tax year */
    taxIncreaseRate?: Maybe<Scalars['Float']['output']>;
    /** The amount of property tax paid for the given tax year */
    taxPaid?: Maybe<Scalars['Float']['output']>;
    /** A timestamp indicating which tax year this record references */
    time?: Maybe<Scalars['DateTime']['output']>;
    /** The assessed tax value of the property for the given tax year */
    value?: Maybe<Scalars['Float']['output']>;
    /** The percentage change in assessed tax value over the previous tax year */
    valueIncreaseRate?: Maybe<Scalars['Float']['output']>;
};

/** Team member connection target info */
export type TeamMemberConnectionTarget = {
    /** The connection target for the team member */
    connectionTarget?: Maybe<Scalars['Int']['output']>;
    /** Team member's conversion rate */
    conversionRate?: Maybe<Scalars['Float']['output']>;
    /** The team member's rating for conversionRate */
    conversionRatePerformanceRating?: Maybe<PerformanceRating>;
    /** The effective date of the connection target */
    effectiveDate?: Maybe<Scalars['DateTime']['output']>;
    /** Team member's engaged transfer rate */
    engagedTransferRate?: Maybe<Scalars['Float']['output']>;
    /** The team member's rating for engagedTransferRate */
    engagedTransferRatePerformanceRating?: Maybe<PerformanceRating>;
    /** Last 90 days buyer connection count */
    last90DaysBuyerConnectionCount?: Maybe<Scalars['Int']['output']>;
    /** Last 90 days opt in connection count */
    last90DaysOptInConnectionCount?: Maybe<Scalars['Int']['output']>;
    /** Team member's performance rank out of all team members */
    performanceRank?: Maybe<Scalars['Int']['output']>;
    /** Team member's performance rating */
    performanceRating?: Maybe<PerformanceRating>;
    /** Date of Recommendation */
    recommendationDate: Scalars['DateTime']['output'];
    /** Reason for Recommendation */
    recommendationReason?: Maybe<Scalars['String']['output']>;
    /** The recommended connection target for the team member */
    recommendedConnectionTarget: Scalars['Int']['output'];
    /** The team lead */
    teamLead: PAAgent;
    /** The team member */
    teamMember: PAAgent;
};

/** Returns team members' connection target info using relay cursor implementation for pagination. */
export type TeamMemberConnectionTargetConnection = {
    /** List of team member connection target info returned within this page of data. */
    edges?: Maybe<Array<Maybe<TeamMemberConnectionTargetEdge>>>;
    /** Pagination metadata for the returned team member connection target info. */
    pageInfo: PageInfo;
};

/** Team member connection target data along with unique cursor. */
export type TeamMemberConnectionTargetEdge = {
    /** Unique identifier that points to specific item within a list (Relay cursor pagination). */
    cursor: Scalars['String']['output'];
    /** Team member connection target info. */
    node: TeamMemberConnectionTarget;
};

/** Team member connection target history info. */
export type TeamMemberConnectionTargetHistory = {
    /** The connection target for the team member */
    connectionTarget: Scalars['Int']['output'];
    /** The end date after which the connection target for the team member is no longer accurate */
    endDate?: Maybe<Scalars['DateTime']['output']>;
    /** The unique id of the capacity history record */
    id: Scalars['ID']['output'];
    /** The start date from which the connection target for the team member went into effect */
    startDate: Scalars['DateTime']['output'];
    /** The team member associated with this capacity history */
    teamMember: PAAgent;
};

/** Returns team members' connection target history info using relay cursor implementation for pagination. */
export type TeamMemberConnectionTargetHistoryConnection = {
    /** List of team member connection target history info returned within this page of data. */
    edges?: Maybe<Array<Maybe<TeamMemberConnectionTargetHistoryEdge>>>;
    /** Pagination metadata for the returned team member connection target info. */
    pageInfo?: Maybe<PageInfo>;
};

/** Team member connection target history data along with unique cursor. */
export type TeamMemberConnectionTargetHistoryEdge = {
    /** Unique identifier that points to specific item within a list (Relay cursor pagination). */
    cursor?: Maybe<Scalars['String']['output']>;
    /** Team member connection target history info. */
    node?: Maybe<TeamMemberConnectionTargetHistory>;
};

/** Query input to retrive connection target history info for a team member */
export type TeamMemberConnectionTargetHistoryInput = {
    /**
     * The cursor index from which we want to return histories after.
     * This field is used for cursor-based pagination, allowing clients to request
     * a specific subset of the history list starting from a given point. The value
     * should be the cursor of the last item in the current page of results.
     */
    after?: InputMaybe<Scalars['String']['input']>;
    /**
     * The cursor index before which we want to return histories.
     * This field is used for backward pagination, allowing clients to request
     * a specific subset of the history list ending before a given point. The value
     * should be the cursor of the first item in the current page of results.
     */
    before?: InputMaybe<Scalars['String']['input']>;
    /** The end date from which to stop searching for connection target histories */
    endDate?: InputMaybe<Scalars['DateTime']['input']>;
    /** The start date from which to search for connection target histories */
    startDate: Scalars['DateTime']['input'];
    /** The team lead's zuid */
    teamLeadZuid: ZuidInput;
    /** The list of team member's zuids */
    teamMemberZuids: Array<ZuidInput>;
};

/** Mutation input to update the connection target of a team member */
export type TeamMemberConnectionTargetInput = {
    /** The connection target to update the team member's value to */
    connectionTarget: Scalars['Int']['input'];
    /** The team member's zuid */
    teamMemberZuid: ZuidInput;
};

export type TeamMemberContactMethod = {
    buttons: Array<HubModuleButton>;
    description: Scalars['String']['output'];
};

export type TeamMemberContactMethodbuttonsArgs = {
    type?: InputMaybe<HubButtonType>;
};

export type TeamMemberInfo = HubDynamicText | TitleWithPopper;

export type TeamMemberInsight = {
    /** Insight text with markdown to render in UI */
    markdown?: Maybe<Scalars['String']['output']>;
};

export type TeamMemberMetadata = {
    hasProfileImage: Scalars['Boolean']['output'];
    id: Scalars['String']['output'];
    type: TeamMemberType;
};

/** Data for team member performance reporting */
export type TeamMemberPerformanceReport = {
    /** Current connection target */
    connectionTarget?: Maybe<Scalars['Int']['output']>;
    /** Team member's conversion rate */
    conversionRate?: Maybe<Scalars['Float']['output']>;
    /** The team member's rating for conversionRate */
    conversionRatePerformanceRating?: Maybe<PerformanceRating>;
    /** Team member's engaged transfer rate */
    engagedTransferRate?: Maybe<Scalars['Float']['output']>;
    /** The team member's rating for engagedTransferRate */
    engagedTransferRatePerformanceRating?: Maybe<PerformanceRating>;
    /** Last 90 days buyer connection count */
    last90DaysBuyerConnectionCount?: Maybe<Scalars['Int']['output']>;
    /** Last 90 days opt in connection count */
    last90DaysOptInConnectionCount?: Maybe<Scalars['Int']['output']>;
    /** List of team member performance leaderboard entries - paginated */
    leaderboardConnection?: Maybe<AgentPerformanceLeaderboardConnection>;
    /** Team member's ranking */
    performanceRank?: Maybe<Scalars['Int']['output']>;
    /** Number of team members for rank */
    performanceRankTotal?: Maybe<Scalars['Int']['output']>;
    /** Team member's performance rating */
    performanceRating?: Maybe<PerformanceRating>;
    /** Team lead Zillow User ID */
    teamLeadZuid: Scalars['Int']['output'];
    teamMemberInsights?: Maybe<Array<Maybe<TeamMemberInsight>>>;
    /** Team member Zillow User ID */
    teamMemberZuid?: Maybe<Scalars['Int']['output']>;
    /** The UTC timestamp at which the performance data was updated. */
    updatedAt: Scalars['DateTime']['output'];
};

/** Data for team member performance reporting */
export type TeamMemberPerformanceReportleaderboardConnectionArgs = {
    after?: InputMaybe<Scalars['String']['input']>;
    before?: InputMaybe<Scalars['String']['input']>;
};

export type TeamMemberType = 'AGENT' | 'LOAN_OFFICER';

export type TenantPropertyCondition = {
    accessedDate?: Maybe<Scalars['String']['output']>;
    completedDate?: Maybe<Scalars['String']['output']>;
    createdDate?: Maybe<Scalars['String']['output']>;
    fieldDataMap?: Maybe<PropertyConditionFieldDataMap>;
    gdpProperty?: Maybe<Property>;
    isArchived?: Maybe<Scalars['Boolean']['output']>;
    journeyId?: Maybe<Scalars['String']['output']>;
    lastPage?: Maybe<Scalars['String']['output']>;
    listingAlias?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    propertyConditionId?: Maybe<Scalars['ID']['output']>;
    propertyConditionTemplateId?: Maybe<Scalars['String']['output']>;
    sharedDate?: Maybe<Scalars['String']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    updatedDate?: Maybe<Scalars['String']['output']>;
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type Term = {
    acceptanceDateTime?: Maybe<Scalars['DateTime']['output']>;
    id?: Maybe<TermId>;
    version?: Maybe<Scalars['Int']['output']>;
};

export type TermId =
    | 'CIC_CONFIRMATION_RENTER'
    | 'CIC_TAC'
    | 'EXPERIAN_CIC_WRITTEN_CONSENT_RENTER'
    | 'EXPERIAN_TAC'
    | 'EXPERIAN_WRITTEN_CONSENT'
    | 'EXPERIAN_WRITTEN_CONSENT_LANDLORD'
    | 'EXPERIAN_WRITTEN_CONSENT_RENTER'
    | 'TERMS_ZILLOW_RENTAL_USER';

export type TermInput = {
    termId: TermId;
    version: Scalars['Int']['input'];
};

export type TermSet = {
    id?: Maybe<TermSetId>;
    status?: Maybe<TermSetStatus>;
};

export type TermSetId = 'landlordScreening' | 'renterScreening';

export type TermSetStatus = 'current' | 'never' | 'previous';

export type TextObject = {
    text?: Maybe<Scalars['String']['output']>;
};

export type ThirdPartyPhotoLinks = {
    /**
     * The information of the satellite view photo.
     * Also contained in: StaticMapView#satelliteViewPhotoLink
     */
    satelliteViewPhotoLink?: Maybe<PhotoLink>;
    /** The information of the static view photos of various kinds. */
    staticMapView?: Maybe<StaticMapView>;
    /**
     * Metadata tag for PhotoLink to retrieve data about Street View panoramas.
     * Details here: https://developers.google.com/maps/documentation/streetview/metadata
     */
    streetViewMetadataUrl?: Maybe<Scalars['String']['output']>;
    /** The information of the street view photo */
    streetViewPhotoLink?: Maybe<PhotoLink>;
};

export type ThirdPartyPhotoLinkssatelliteViewPhotoLinkArgs = {
    size: PhotoSize;
    zoom: Scalars['Int']['input'];
};

export type ThirdPartyPhotoLinksstaticMapViewArgs = {
    size: PhotoSize;
    zoom: Scalars['Int']['input'];
};

export type ThirdPartyPhotoLinksstreetViewPhotoLinkArgs = {
    size: PhotoSize;
};

export type ThirdPartyVirtualTour = {
    approved?: Maybe<Scalars['Boolean']['output']>;
    externalUrl?: Maybe<Scalars['String']['output']>;
    label?: Maybe<Scalars['String']['output']>;
    lightboxUrl?: Maybe<Scalars['String']['output']>;
    providerKey?: Maybe<ApprovedThirdPartyVirtualTourProviderKeys>;
    providerName?: Maybe<Scalars['String']['output']>;
    staticUrl?: Maybe<Scalars['String']['output']>;
};

/** thirty year fixed rate object */
export type ThirtyYearFixedBucket = {
    lastUpdated?: Maybe<Scalars['DateTime']['output']>;
    rate?: Maybe<Scalars['Float']['output']>;
    rateSource?: Maybe<Scalars['String']['output']>;
};

/** thirty year fixed rate object */
export type ThirtyYearFixedBucketByCreditScore = {
    lastUpdated?: Maybe<Scalars['DateTime']['output']>;
    rate?: Maybe<Scalars['Float']['output']>;
    rateSource?: Maybe<Scalars['String']['output']>;
};

export type TimeOfDay = 'NOW' | 'OFF_PEAK' | 'RUSH_HOUR';

export type Timeline = {
    endDate?: Maybe<Scalars['Time']['output']>;
    startDate?: Maybe<Scalars['Time']['output']>;
    status: TimelineStatus;
};

export type TimelineStatus =
    | 'PROFILE_TIMELINE_STATUS_UNSPECIFIED'
    | 'SELECTED_DECIDED'
    | 'SELECTED_UNDECIDED';

export type TitleHoldingMannerType =
    | 'JointTenancyWithRightOfSurvivorship'
    | 'LifeEstate'
    | 'Other'
    | 'SoleOwnership'
    | 'TenancyByTheEntirety'
    | 'TenancyInCommon';

export type TitleWithPopper = {
    navAction: HubNavAction;
    popperIcon: HubIconType;
    title: HubDynamicText;
};

/**
 *  Histograms generated for TLID-identified Trulia users in the context of For Rent properties and batch/offline
 * *  histogram computation. The "Long Term" suffux here indicates original assumption of using longer historical
 * *	user events to calculate the histograms. Should this Long Term assumption become invalid in future, it is suggested
 * 	to deprecate this set and create a more generic "offline" set instead.
 */
export type TlidUpsForRentLongTermHistograms = {
    /**  Histograms calculated as part of the For Rent Long Term experience  */
    histograms?: Maybe<TlidUpsForRentLongTermHistograms_LongTermHistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the unknown Trulia user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  TLID - the devide ID that uniquely identifies an unknown user interacting with Trulia  */
    tlid: Scalars['String']['output'];
    /**  History of rental properties viewed by the unknown Trulia user with the most recent views first  */
    viewHistory?: Maybe<Array<TlidUpsForRentLongTermHistograms_ViewHistoryRecord>>;
};

/**  Record contains time-decayed histogram fields based on Trulia properties a user has viewed on site.  */
export type TlidUpsForRentLongTermHistograms_LongTermHistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Internal representation for more granular city allocation  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Crime score of the viewed properties  */
    crimeScore?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure based on hash representation of longitude/latitude of viewed properties.  */
    geohash5?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure extended to geohash neighbors  */
    geohash5Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure based on hash representation of longitude/latitude of viewed properties.  */
    geohash6?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure extended to geohash neighbors  */
    geohash6Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  Whether or not the viewed properties allow pets  */
    petsAllowed?: Maybe<Scalars['JSON']['output']>;
    /**  Rental price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Rent price per bedroom  */
    pricePerBedroom?: Maybe<Scalars['JSON']['output']>;
    /** @deprecated This field no longer exists based on the latest generated schema. */
    rentPricePerBedroom?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a trulia property was viewed, and for how long it was viewed, by a user.  */
export type TlidUpsForRentLongTermHistograms_ViewHistoryRecord = {
    /**  dwell in seconds for the user viewed the property (specified by propertyId)  */
    dwellSeconds?: Maybe<Scalars['Int']['output']>;
    /**  idType - Unique identifier for types of property ids. 0: zpid, 1: tpid  */
    idType?: Maybe<Scalars['Int']['output']>;
    /**  propertyId - Unique identifier for a property viewed by a user.  */
    propertyId?: Maybe<Scalars['String']['output']>;
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
};

/**
 *  Histograms generated for GUID-identified Trulia users in the context of For Sale properties and batch/offline
 * *  histogram computation. The "Long Term" suffux here indicates original assumption of using longer historical
 * *	user events to calculate the histograms. Should this Long Term assumption become invalid in future, it is suggested
 * 	to deprecate this set and create a more generic "offline" set instead.
 */
export type TlidUpsForSaleLongTermHistograms = {
    /**  Histograms calculated as part of the For Sale Long Term experience  */
    histograms?: Maybe<TlidUpsForSaleLongTermHistograms_LongTermHistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the unknown Trulia user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  TLID - the devide ID that uniquely identifies an unknown user interacting with Trulia  */
    tlid: Scalars['String']['output'];
    /**  History of rental properties viewed by the known Trulia user with the most recent views first  */
    viewHistory?: Maybe<Array<TlidUpsForSaleLongTermHistograms_ViewHistoryRecord>>;
};

/**  Record contains time-decayed histogram fields based on Trulia properties a user has viewed on site.  */
export type TlidUpsForSaleLongTermHistograms_LongTermHistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Internal representation for more granular city allocation  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Crime score of the viewed properties  */
    crimeScore?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure based on hash representation of longitude/latitude of viewed properties.  */
    geohash5?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure extended to geohash neighbors  */
    geohash5Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure based on hash representation of longitude/latitude of viewed properties.  */
    geohash6?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure extended to geohash neighbors  */
    geohash6Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies whether the land is vacant or not  */
    isVacantLand?: Maybe<Scalars['JSON']['output']>;
    /**  Rental price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a trulia property was viewed, and for how long it was viewed, by a user.  */
export type TlidUpsForSaleLongTermHistograms_ViewHistoryRecord = {
    /**  dwell in seconds for the user viewed the property (specified by propertyId)  */
    dwellSeconds?: Maybe<Scalars['Int']['output']>;
    /**  idType - Unique identifier for types of property ids. 0: zpid, 1: tpid  */
    idType?: Maybe<Scalars['Int']['output']>;
    /**  propertyId - Unique identifier for a property viewed by a user.  */
    propertyId?: Maybe<Scalars['String']['output']>;
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
};

export type TopBuilder = {
    corporationName?: Maybe<Scalars['String']['output']>;
};

export type TourAppointment = {
    /**
     * **Definition:** Information about who accepted the appointment.
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** not visible
     */
    acceptedBy?: Maybe<AppointmentAcceptedByType>;
    /**
     * **Definition:** The current tour status, from the agent's point of view
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-agent.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    agentTourStatus?: Maybe<TourStatus>;
    agentTourView?: Maybe<AgentTourView>;
    /**
     * **Definition:** Unique identifier for tour appointment
     *
     * **Source:** Appointments API
     *
     * **No Auth**
     */
    appointmentHash?: Maybe<Scalars['ID']['output']>;
    /**
     * **Definition:** Information regarding whether appointment data should be visible
     *
     * **Source:** Auth Context and Appointments API
     *
     * **No Auth**
     */
    appointmentVisibility?: Maybe<AppointmentVisibility>;
    /**
     * **Definition:** The type of booking for this tour appointment (ex. STANDARD, INSTANT_BOOK)
     *
     * **Source:** Appointments API
     *
     * **No Auth**
     */
    bookingType?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** The current tour status, from the buyer's point of view
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer"
     */
    buyerTourStatus?: Maybe<TourStatus>;
    /**
     * **Definition:** Cancellation request data for the tour if it has been requested to cancel
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     */
    cancellationRequest?: Maybe<CancellationRequest>;
    /**
     * **Definition:** Time slot data for the tour if it has been cancelled
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     * @deprecated Use tourTime and agentTourStatus/buyerTourStatus
     */
    cancelledTourTime?: Maybe<TourAppointmentSlot>;
    /**
     * **Definition:** Time slot information for the currently confirmed tour time
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     * @deprecated Use tourTime and agentTourStatus/buyerTourStatus
     */
    confirmedTourTime?: Maybe<TourAppointmentSlot>;
    /** **Definition:** Information relating the appointment's participants' relationship */
    connection?: Maybe<TourAppointmentConnection>;
    /**
     * **Definition:** The date the appointment request was created
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     *
     * **Example:** 2023-06-22T14:20:00Z
     */
    creationDateTimeISO?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** Flag to indicates that the appointment is for the whole day
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    isAllDay?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Lead id for the appointment
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-agent.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** not visible
     */
    leadId?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** CRM message id for the appointment
     *
     * **Source:** Leads API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-agent.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** not visible
     */
    messageId?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** The previously confirmed time slot, if the tour time was previously scheduled for another time. Does not support isAvailableInShowingTime flag.
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer"
     */
    mostRecentlyRescheduledTourTime?: Maybe<TourAppointmentSlot>;
    participants?: Maybe<TourParticipants>;
    property?: Maybe<Property>;
    /**
     * **Definition:** List of all requested tour times. Empty if there is not an schedule/reschedule request in progress. Supports isAvailableInShowingTime flag.
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     */
    requestedTourTimes?: Maybe<Array<TourAppointmentSlot>>;
    /**
     * **Definition:** Active agreements between the participants of this appointment
     *
     * **Source:** zdocs
     */
    serviceAgreements?: Maybe<ServiceAgreements>;
    /**
     * **Definition:** The type of ShowingTime appointment (ex. "Go and Show", "Appointment Required, Confirm With Any")
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** not visible
     */
    showingAppointmentType?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Url to the Appointment Details page in ST for this appointment
     *
     * **Source:** showing-time-api
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-agent.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    showingTimeAppointmentDetailsUrl?: Maybe<TouringLink>;
    /**
     * **Definition:** The ShowingTime status of the appointment (ex. "Requested", "Confirmed", ...)
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     */
    showingTimeStatus?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Subsequent tour request time of expiration in epoch seconds
     *
     * **Source:** Alan Subsequent Tours Service
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    subtRequestExpirationTime?: Maybe<Scalars['Int']['output']>;
    /**
     * **Definition:** The standalone Tour Management Page's Url
     *
     * **Source:** Touring subgraph (TSG)
     *
     * **No Auth**
     */
    tourManagementPageUrl?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** The current assigned time slot, independent of tour status. Null if a time hasn't been selected yet. Does not support isAvailableInShowingTime flag.
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     */
    tourTime?: Maybe<TourAppointmentSlot>;
    /**
     * **Definition:** The tour type the appointment, whether in-person or virtual
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    tourType?: Maybe<TourType>;
    tourViews?: Maybe<TourAppointmentTourViews>;
    /**
     * **Definition:** Flag to indicates that the appointment was canceled by the logged in user
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    wasCanceledByCurrentViewer?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** Flag to indicates that the appointment was canceled via ShowingTime
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    wasCanceledViaShowingTime?: Maybe<Scalars['Boolean']['output']>;
};

export type TourAppointmentagentTourStatusArgs = {
    version: AgentStatusVersion;
};

export type TourAppointmentagentTourViewArgs = {
    id: AgentTourViewId;
};

export type TourAppointmentbuyerTourStatusArgs = {
    version: BuyerStatusVersion;
};

export type TourAppointmenttourViewsArgs = {
    platform: TourViewPlatform;
};

export type TourAppointmentConnection = {
    /**
     * **Definition:** Summary of the conversation between the appointment's active agent and the buyer
     *
     * **Source:** beth-messaging-service
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer"
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     */
    agentAndBuyerConversationSummary?: Maybe<ZIMConversationParticipantSummary>;
};

export type TourAppointmentFilterParameters = {
    includeCompletedTours?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TourAppointmentProperty = {
    /**
     * **Definition:** Unique identifier for tour appointment
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow OAuth2.0 User JWT:** "touring/appointment-zpid.read"
     *
     * **Example:** a584dcac-2a80-4d65-ab0d-e9d645523feb
     */
    appointmentHash?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** The property id
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow OAuth2.0 User JWT:** "touring/appointment-zpid.read"
     *
     * **Example:** 15118211
     */
    zpid?: Maybe<Scalars['Int']['output']>;
};

export type TourAppointmentQueryParameters = {
    agentZuid?: InputMaybe<Scalars['Int']['input']>;
    buyerZuid?: InputMaybe<Scalars['Int']['input']>;
    contactId?: InputMaybe<Scalars['Int']['input']>;
    leadId?: InputMaybe<Scalars['String']['input']>;
    /**
     * **Definition:** Filter appointments with tourTime's startDateTime are on or after the tourTimeOnOrAfter value
     * **Example:** 2023-09-23T15:00
     */
    tourTimeOnOrAfter?: InputMaybe<Scalars['LocalDateTime']['input']>;
    /**
     * **Definition:** Filter appointments with tourTime's startDateTime are on or before the tourTimeOnOrBefore value
     * **Example:** 2023-09-25T15:00
     */
    tourTimeOnOrBefore?: InputMaybe<Scalars['LocalDateTime']['input']>;
};

export type TourAppointmentRescheduleInput = {
    requestType: RescheduleEnumType;
    requestedTourTimes: Array<InputMaybe<TourAppointmentSlotInput>>;
};

export type TourAppointmentRescheduleResponse = {
    /** **Definition:** Explanatory details for unsuccessful requests */
    errorMessage?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** An error type returns when buyer initiated request to reschedule a tour appointment, defaults to GENERAL. Possible values are 'GENERAL' and 'PAST_TIME_REQUESTED'
     *
     * **Source:** Appointments API
     *
     * **Example: ** "PAST_TIME_REQUESTED"
     */
    errorType?: Maybe<RescheduleErrorEnumType>;
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type TourAppointmentSlot = {
    /**
     * **Definition:** The end date of a tour slot in UTC
     *
     * **Source:** Appointments API
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example:** 2019-06-14T14:56:00Z
     */
    endDateTimeISO?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** Flag that indicates if this requested time slot is available to book in ShowingTime. This field will be null if queried under any other field besides TourAppointment.requestedTourTimes
     *
     * **Source:** showing-time-api
     *
     * **Auth:** Uses the auth of the parent field
     */
    isAvailableInShowingTime?: Maybe<Scalars['Boolean']['output']>;
    /**
     * **Definition:** The start date of a tour slot in UTC
     *
     * **Source:** Appointments API
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example:** 2019-06-14T14:56:00Z
     */
    startDateTimeISO?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** The timezone for this appointment slot
     *
     * **Source:** Appointments API
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example ** America/Los_Angeles
     */
    timezone?: Maybe<Scalars['String']['output']>;
};

export type TourAppointmentSlotInput = {
    endDateTimeISO?: InputMaybe<Scalars['DateTime']['input']>;
    startDateTimeISO: Scalars['DateTime']['input'];
};

export type TourAppointmentSlotZonedInput = {
    endDateTimeISO?: InputMaybe<Scalars['DateTime']['input']>;
    startDateTimeISO: Scalars['DateTime']['input'];
    timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TourAppointmentTourViews = {
    cancelTourContactAgent?: Maybe<CancelTourContactAgentView>;
    cancelTourRequestForm?: Maybe<CancelTourRequestFormView>;
    rescheduleTourContactAgent?: Maybe<RescheduleTourContactAgentView>;
    rescheduleTourRequestForm?: Maybe<RescheduleTourRequestFormView>;
    tourDetails?: Maybe<TourDetailsView>;
};

export type TourAppointmentTourViewstourDetailsArgs = {
    version?: InputMaybe<TourDetailsViewVersion>;
};

export type TourDetailsView = ITourView & {
    alerts?: Maybe<Array<TourViewAlert>>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewMetadata>;
    modules?: Maybe<Array<TourViewModule>>;
    toasts?: Maybe<Array<TourViewToast>>;
};

export type TourDetailsViewVersion = 'V1' | 'V2';

export type TourListView = ITourView & {
    alerts?: Maybe<Array<TourViewAlert>>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewMetadata>;
    modules?: Maybe<Array<TourViewModule>>;
    toasts?: Maybe<Array<TourViewToast>>;
};

export type TourManagementV0Input = {
    appointmentHash: Scalars['ID']['input'];
};

export type TourParticipants = {
    agent?: Maybe<AgentParticipant>;
    buyer?: Maybe<BuyerParticipant>;
    previousAgent?: Maybe<PreviousAgentParticipant>;
};

export type TourRequestConfirmationView = ITourView & {
    alerts?: Maybe<Array<TourViewAlert>>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewMetadata>;
    modules?: Maybe<Array<TourViewModule>>;
    toasts?: Maybe<Array<TourViewToast>>;
};

export type TourRequestConfirmationViewInput = {
    /** The type of booking for this tour appointment (ex. STANDARD, INSTANT, INSTANT_BOOK) */
    bookingType?: InputMaybe<Scalars['String']['input']>;
    /** The tour experience type (ex: DCV1, DCV2, RTT, NONE) */
    experienceType?: InputMaybe<Scalars['String']['input']>;
    /** The type of financing checkbox that was displayed (ex: ZHL, ZGMI, NONE) */
    financingCheckboxType?: InputMaybe<Scalars['String']['input']>;
    /** Whether or not the buyer has indicated they are currently working with an agent */
    hasAgent?: InputMaybe<Scalars['Boolean']['input']>;
    /** An array of requested tour times, formatted with optional time value as YYYY-MM-DDTHH:MM:SS or without time value as YYYY-MM-DD */
    requestedTourTimes?: InputMaybe<Array<Scalars['String']['input']>>;
    /** The time range in which the buyer said they were looking to buy (ex: 0-3Months, 3-6Months, ... ) */
    timelineToBuy?: InputMaybe<Scalars['String']['input']>;
    /** Whether or not the buyer checked the box in the pre-qual flow that they want financing with ZHL */
    wantsFinancingWithZHL?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TourRequestConfirmationViewVariants = 'ZHL_UPSELL';

export type TourRequestConfirmationViewVersion = 'V1' | 'V2';

export type TourRequestFormInput = {
    requestedTourTimes: Array<RequestedTourTime>;
};

export type TourStatus = {
    /**
     * **Definition:** A single status for this appointment
     *
     * **Source:** Appointments API
     *
     * **Example: ** "BUYER_REQUESTED_TOUR_CANCELLATION"
     */
    status?: Maybe<Scalars['String']['output']>;
};

export type TourStatusHistory = {
    /**
     * **Definition:** The datetime the appointment entered the associated status in UTC
     *
     * **Source:** Appointments api
     *
     * **Note:** NOT IMPLEMENTED
     *
     * **Example: ** 2019-06-14T14:56:00Z
     */
    createDateISO?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** A single status for this appointment
     *
     * **Source:** Appointments api
     *
     * **Note:** NOT IMPLEMENTED
     *
     * **Example: ** "BUYER_REQUESTED_TOUR_CANCELLATION"
     */
    status?: Maybe<Scalars['String']['output']>;
};

export type TourTime = {
    /** Time available for touring */
    available?: Maybe<Scalars['Boolean']['output']>;
    /** ISO8601 in UTC */
    time?: Maybe<Scalars['String']['output']>;
};

export type TourType = 'IN_PERSON' | 'VIRTUAL';

export type TourUpgradeInput = {
    isTourUpgradeAccepted: Scalars['Boolean']['input'];
};

export type TourView = {
    alerts?: Maybe<Array<TourViewAlert>>;
    heading?: Maybe<TourViewModuleText>;
    modules?: Maybe<Array<TourViewModule>>;
    toasts?: Maybe<Array<TourViewToast>>;
};

export type TourViewABTrial = {
    /** The key sent to the ab trial. Typically a guid or installation id */
    trialKey?: Maybe<Scalars['String']['output']>;
    /** An array of strings in the format of ab_trial_name.treatment_name */
    trialTreatments?: Maybe<Array<Scalars['String']['output']>>;
};

export type TourViewAction =
    | TourViewExternalNavigationAction
    | TourViewNavigationAction
    | TourViewTriggerSMSAction;

export type TourViewActionButton =
    | TourViewCancelTourButton
    | TourViewDirectionsButton
    | TourViewMessageAgentButton
    | TourViewPropertyDetailsButton
    | TourViewRescheduleTourButton;

export type TourViewActionButtons = ITourViewModule & {
    buttons: Array<TourViewActionButton>;
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewAgentInfo = ITourViewModule & {
    avatar?: Maybe<TourViewModulePhoto>;
    brokerage?: Maybe<TourViewModuleText>;
    email?: Maybe<TourViewModuleText>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewModuleMetadata>;
    name?: Maybe<TourViewModuleText>;
    phone?: Maybe<TourViewModuleText>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewAlert = TourViewLoginBanner;

export type TourViewButtonSelectFormField = {
    options?: Maybe<Array<TourViewButtonSelectFormFieldOption>>;
};

export type TourViewButtonSelectFormFieldOption = {
    label?: Maybe<TourViewModuleText>;
    value?: Maybe<Scalars['String']['output']>;
};

export type TourViewCTA = ITourViewModule & {
    button: TourViewCTAButton;
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewCTAButton = TourViewHomeSearchButton | TourViewPrequalificationButton;

export type TourViewCancelTourButton = ITourViewModuleButton & {
    action?: Maybe<TourViewAction>;
    icon?: Maybe<TourViewIcon>;
    iconPosition?: Maybe<TourViewModuleButtonIconPosition>;
    label: TourViewModuleText;
    metadata?: Maybe<TourViewModuleMetadata>;
    tag?: Maybe<TourViewModuleTag>;
    type?: Maybe<TourViewModuleButtonType>;
};

export type TourViewCancelTourRequestForm = ITourViewModule & {
    metadata?: Maybe<TourViewModuleMetadata>;
    sections?: Maybe<Array<TourViewFormSection>>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewCheckboxSelectFormField = {
    options?: Maybe<Array<TourViewCheckboxSelectFormFieldOption>>;
};

export type TourViewCheckboxSelectFormFieldOption = {
    label?: Maybe<TourViewModuleText>;
    value?: Maybe<Scalars['String']['output']>;
};

export type TourViewConfirmation = ITourViewModule & {
    heading?: Maybe<TourViewHeading>;
    icon?: Maybe<TourViewIcon>;
    message?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewContent = ITourViewModule & {
    body?: Maybe<TourViewModuleText>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewDirectionsButton = ITourViewModuleButton & {
    action?: Maybe<TourViewAction>;
    icon?: Maybe<TourViewIcon>;
    iconPosition?: Maybe<TourViewModuleButtonIconPosition>;
    label: TourViewModuleText;
    metadata?: Maybe<TourViewModuleMetadata>;
    tag?: Maybe<TourViewModuleTag>;
    type?: Maybe<TourViewModuleButtonType>;
};

export type TourViewDivider = ITourViewModule & {
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
    type: TourViewDividerType;
};

export type TourViewDividerType = 'FULL_WIDTH' | 'INSET';

export type TourViewExternalNavigationAction = {
    url?: Maybe<Scalars['String']['output']>;
};

export type TourViewFailedSaveFeedbackToast = ITourViewToast & {
    appearance: TourViewToastAppearance;
    body: TourViewModuleText;
    duration: Scalars['Int']['output'];
};

export type TourViewFailedSaveNotesToast = ITourViewToast & {
    appearance: TourViewToastAppearance;
    body: TourViewModuleText;
    duration: Scalars['Int']['output'];
};

export type TourViewFailedTourCancelToast = ITourViewToast & {
    appearance: TourViewToastAppearance;
    body: TourViewModuleText;
    duration: Scalars['Int']['output'];
};

export type TourViewFailedTourRescheduleToast = ITourViewToast & {
    appearance: TourViewToastAppearance;
    body: TourViewModuleText;
    duration: Scalars['Int']['output'];
};

export type TourViewFeedbackForm = ITourViewModule & {
    confirmation?: Maybe<TourViewConfirmation>;
    entryPoint?: Maybe<TourViewFeedbackFormEntryPoint>;
    exitConfirmation?: Maybe<TourViewConfirmation>;
    metadata?: Maybe<TourViewModuleMetadata>;
    sections?: Maybe<Array<TourViewFormSection>>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewFeedbackFormEntryPoint = TourViewFormQuestion;

export type TourViewFinanceUpsellContent = ITourViewModule & {
    heading?: Maybe<TourViewHeading>;
    logo?: Maybe<TourViewModulePhoto>;
    metadata?: Maybe<TourViewModuleMetadata>;
    propertyPhoto?: Maybe<TourViewPropertyPhoto>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewFormField =
    | TourViewButtonSelectFormField
    | TourViewCheckboxSelectFormField
    | TourViewRadioSelectFormField;

export type TourViewFormQuestion = ITourViewModule & {
    id?: Maybe<Scalars['String']['output']>;
    metadata?: Maybe<TourViewModuleMetadata>;
    modules?: Maybe<Array<TourViewModule>>;
    responseField?: Maybe<TourViewFormField>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewFormSection = ITourViewModule & {
    metadata?: Maybe<TourViewModuleMetadata>;
    questions?: Maybe<Array<TourViewFormQuestion>>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewHeading = ITourViewModule & {
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
    subheading?: Maybe<TourViewModuleText>;
};

export type TourViewHeroImage = ITourViewModule & {
    metadata?: Maybe<TourViewModuleMetadata>;
    photo: TourViewModulePhoto;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewHomeSearchButton = ITourViewModuleButton & {
    action?: Maybe<TourViewAction>;
    icon?: Maybe<TourViewIcon>;
    iconPosition?: Maybe<TourViewModuleButtonIconPosition>;
    label: TourViewModuleText;
    metadata?: Maybe<TourViewModuleMetadata>;
    tag?: Maybe<TourViewModuleTag>;
    type?: Maybe<TourViewModuleButtonType>;
};

export type TourViewIcon =
    | 'DetailedIconHandshake'
    | 'IconArrowLeftOutline'
    | 'IconArrowRightOutline'
    | 'IconCheckmarkCircleOutline'
    | 'IconMessageOutline';

/** The id of the requested tour view */
export type TourViewId =
    | 'CANCEL_TOUR_V0'
    | 'EMBEDDED_TOUR_REQUEST_CONFIRMATION_V0'
    | 'EMBEDDED_TOUR_REQUEST_CONFIRMATION_V1'
    | 'RESCHEDULE_TOUR_V0'
    | 'RESCHEDULE_TOUR_V1'
    | 'TOUR_MANAGEMENT_V0';

export type TourViewInput = {
    CANCEL_TOUR_V0?: InputMaybe<CancelTourV0Input>;
    EMBEDDED_TOUR_REQUEST_CONFIRMATION_V0?: InputMaybe<EmbeddedTourRequestConfirmationV0Input>;
    EMBEDDED_TOUR_REQUEST_CONFIRMATION_V1?: InputMaybe<EmbeddedTourRequestConfirmationV1Input>;
    RESCHEDULE_TOUR_V0?: InputMaybe<RescheduleTourV0Input>;
    RESCHEDULE_TOUR_V1?: InputMaybe<RescheduleTourV1Input>;
    TOUR_MANAGEMENT_V0?: InputMaybe<TourManagementV0Input>;
};

export type TourViewList = ITourViewModule & {
    heading?: Maybe<TourViewHeading>;
    items?: Maybe<Array<TourViewListItem>>;
    listStyle?: Maybe<TourViewListStyle>;
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewListItem = {
    children?: Maybe<Array<TourViewListItem>>;
    text?: Maybe<TourViewModuleText>;
};

export type TourViewListStyle = 'BULLETED' | 'NONE' | 'NUMBERED';

export type TourViewLoginAlert = ITourViewModule & {
    body?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewLoginBanner = ITourViewModule & {
    body?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewLottieResource = 'HOUSE_SPARKLE_V1';

export type TourViewMessageAgentButton = ITourViewModuleButton & {
    action?: Maybe<TourViewAction>;
    icon?: Maybe<TourViewIcon>;
    iconPosition?: Maybe<TourViewModuleButtonIconPosition>;
    label: TourViewModuleText;
    metadata?: Maybe<TourViewModuleMetadata>;
    tag?: Maybe<TourViewModuleTag>;
    type?: Maybe<TourViewModuleButtonType>;
};

export type TourViewMetadata = {
    events?: Maybe<TourViewMetadataEvents>;
};

export type TourViewMetadataEvents = {
    newLaneEvents?: Maybe<TourViewMetadataNewLaneEvents>;
};

export type TourViewMetadataNewLaneEvents = {
    closeEventJson?: Maybe<Scalars['JSONObject']['output']>;
    confirmEventJson?: Maybe<Scalars['JSONObject']['output']>;
    impressionEventJson?: Maybe<Scalars['JSONObject']['output']>;
    interactionEventJson?: Maybe<Scalars['JSONObject']['output']>;
    updateEventJson?: Maybe<Scalars['JSONObject']['output']>;
};

export type TourViewModule =
    | TourViewActionButtons
    | TourViewAgentInfo
    | TourViewCTA
    | TourViewCancelTourRequestForm
    | TourViewConfirmation
    | TourViewContent
    | TourViewDivider
    | TourViewFeedbackForm
    | TourViewFinanceUpsellContent
    | TourViewHeading
    | TourViewHeroImage
    | TourViewLoginAlert
    | TourViewProgressStepper
    | TourViewPropertyPhoto
    | TourViewPropertySummaryCard
    | TourViewPropertyTags
    | TourViewRequestedTourTimes
    | TourViewTourChecklist
    | TourViewTourDetails
    | TourViewTourListCard
    | TourViewTourListSection
    | TourViewTourNotes
    | TourViewTourSummaryCard
    | TourViewZHLUpsell;

export type TourViewModuleAlignContentStyle = 'center' | 'left' | 'right';

export type TourViewModuleButtonIconPosition = 'end' | 'start';

export type TourViewModuleButtonType = 'caution' | 'primary' | 'secondary' | 'tertiary';

export type TourViewModuleDisplayMediaBreakpointStyle = 'xl_gte';

export type TourViewModuleMetadata = {
    events?: Maybe<TourViewMetadataEvents>;
};

export type TourViewModulePhoto = {
    formats: Array<TourViewModulePhotoFormat>;
    label?: Maybe<Scalars['String']['output']>;
};

export type TourViewModulePhotoformatsArgs = {
    size?: InputMaybe<Scalars['String']['input']>;
};

export type TourViewModulePhotoFormat = {
    lottieResource?: Maybe<TourViewLottieResource>;
    type: TourViewModulePhotoFormatType;
    url: Scalars['String']['output'];
};

export type TourViewModulePhotoFormatType =
    | 'JPG'
    | 'LOTTIE'
    | 'PDF'
    | 'PNG'
    | 'SVG'
    | 'UNKNOWN'
    | 'WEBP';

export type TourViewModuleStyle = {
    alignContent?: Maybe<TourViewModuleAlignContentStyle>;
    /** The breakpoint at which the module should be visible. If null, the module should always be visible. Read more: https://constellation.zillowgroup.com/platforms/web/developer-docs/media-queries#media-breakpoints */
    displayMediaBreakpoint?: Maybe<TourViewModuleDisplayMediaBreakpointStyle>;
};

export type TourViewModuleTag = ITourViewModule & {
    appearance?: Maybe<TourViewModuleTagAppearance>;
    content?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewModuleMetadata>;
    size?: Maybe<TourViewModuleTagSize>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewModuleTagAppearance =
    | 'aqua'
    | 'error'
    | 'gray'
    | 'info'
    | 'orange'
    | 'purple'
    | 'success'
    | 'warning';

export type TourViewModuleTagSize = 'md' | 'sm';

/**
 * tour-cms typedefs (must be kept in sync)
 * tour-cms repo: https://gitlab.zgtools.net/zillow/tour-experience-management/front-end/tour-cms
 */
export type TourViewModuleText = {
    text: Scalars['String']['output'];
    textAttributes?: Maybe<Array<TourViewModuleTextAttribute>>;
};

export type TourViewModuleTextAttribute =
    | TourViewModuleTextEmailLinkAttribute
    | TourViewModuleTextFontColorAttribute
    | TourViewModuleTextFontFamilyAttribute
    | TourViewModuleTextFontTypeAttribute
    | TourViewModuleTextFontWeightAttribute
    | TourViewModuleTextLinkAttribute
    | TourViewModuleTextPhoneLinkAttribute
    | TourViewModuleTextTooltipAttribute;

export type TourViewModuleTextEmailLinkAttribute = ITourViewModuleTextAttribute & {
    tokenEndIndex: Scalars['Int']['output'];
    tokenStartIndex: Scalars['Int']['output'];
    uri: Scalars['String']['output'];
};

export type TourViewModuleTextFontColorAttribute = ITourViewModuleTextAttribute & {
    fontColor: TourViewModuleTextFontColorAttributeValue;
    tokenEndIndex: Scalars['Int']['output'];
    tokenStartIndex: Scalars['Int']['output'];
};

export type TourViewModuleTextFontColorAttributeValue = 'textMedium' | 'textSecondary';

export type TourViewModuleTextFontFamilyAttribute = ITourViewModuleTextAttribute & {
    fontFamily: TourViewModuleTextFontFamilyAttributeValue;
    tokenEndIndex: Scalars['Int']['output'];
    tokenStartIndex: Scalars['Int']['output'];
};

export type TourViewModuleTextFontFamilyAttributeValue = 'sansSerif' | 'serif';

export type TourViewModuleTextFontTypeAttribute = ITourViewModuleTextAttribute & {
    fontType: TourViewModuleTextFontTypeAttributeValue;
    tokenEndIndex: Scalars['Int']['output'];
    tokenStartIndex: Scalars['Int']['output'];
};

export type TourViewModuleTextFontTypeAttributeValue =
    | 'body'
    | 'bodySmall'
    | 'finePrint'
    | 'heading1'
    | 'heading2'
    | 'heading3'
    | 'heading4'
    | 'legal';

export type TourViewModuleTextFontWeightAttribute = ITourViewModuleTextAttribute & {
    fontWeight: TourViewModuleTextFontWeightAttributeValue;
    tokenEndIndex: Scalars['Int']['output'];
    tokenStartIndex: Scalars['Int']['output'];
    /** @deprecated use fontWeight instead */
    value: TourViewModuleTextFontWeightAttributeValue;
};

export type TourViewModuleTextFontWeightAttributeValue = 'bold';

export type TourViewModuleTextLinkAttribute = ITourViewModuleTextAttribute & {
    tokenEndIndex: Scalars['Int']['output'];
    tokenStartIndex: Scalars['Int']['output'];
    url: Scalars['String']['output'];
};

export type TourViewModuleTextPhoneLinkAttribute = ITourViewModuleTextAttribute & {
    tokenEndIndex: Scalars['Int']['output'];
    tokenStartIndex: Scalars['Int']['output'];
    uri: Scalars['String']['output'];
};

export type TourViewModuleTextTooltipAttribute = ITourViewModuleTextAttribute & {
    tokenEndIndex: Scalars['Int']['output'];
    tokenStartIndex: Scalars['Int']['output'];
    tooltipText: Scalars['String']['output'];
};

export type TourViewNavigationAction = {
    appointmentHash?: Maybe<Scalars['String']['output']>;
    operation?: Maybe<TourViewNavigationActionOperation>;
};

export type TourViewNavigationActionOperation =
    | 'CANCEL_TOUR'
    | 'CANCEL_TOUR_WITH_FORM'
    | 'RESCHEDULE_TOUR'
    | 'VIEW_TOUR_DETAILS';

/** The platform requesting the tour view */
export type TourViewPlatform = 'ANDROID' | 'DESKTOP_WEB' | 'IOS' | 'MOBILE_WEB' | 'WEB';

export type TourViewPrequalificationButton = ITourViewModuleButton & {
    action?: Maybe<TourViewAction>;
    icon?: Maybe<TourViewIcon>;
    iconPosition?: Maybe<TourViewModuleButtonIconPosition>;
    label: TourViewModuleText;
    metadata?: Maybe<TourViewModuleMetadata>;
    tag?: Maybe<TourViewModuleTag>;
    type?: Maybe<TourViewModuleButtonType>;
};

export type TourViewProgressStepper = ITourViewModule & {
    activeStepIndex: Scalars['Int']['output'];
    metadata?: Maybe<TourViewModuleMetadata>;
    steps: Array<TourViewProgressStepperStep>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewProgressStepperStep = {
    appearance?: Maybe<TourViewProgressStepperStepAppearance>;
    label: Scalars['String']['output'];
};

export type TourViewProgressStepperStepAppearance = 'complete';

export type TourViewPropertyDetailsButton = ITourViewModuleButton & {
    action?: Maybe<TourViewAction>;
    icon?: Maybe<TourViewIcon>;
    iconPosition?: Maybe<TourViewModuleButtonIconPosition>;
    label: TourViewModuleText;
    metadata?: Maybe<TourViewModuleMetadata>;
    tag?: Maybe<TourViewModuleTag>;
    type?: Maybe<TourViewModuleButtonType>;
};

export type TourViewPropertyPhoto = ITourViewModule & {
    badge?: Maybe<TourViewPropertyPhotoBadge>;
    metadata?: Maybe<TourViewModuleMetadata>;
    propertyPhoto?: Maybe<TourViewModulePhoto>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewPropertyPhotoBadge = {
    content?: Maybe<TourViewModuleText>;
};

export type TourViewPropertySummaryCard = ITourViewModule & {
    address?: Maybe<TourViewModuleText>;
    homeFacts?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewModuleMetadata>;
    propertyPhoto?: Maybe<TourViewModulePhoto>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewPropertyTags = ITourViewModule & {
    heading?: Maybe<TourViewHeading>;
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewRadioSelectFormField = {
    options?: Maybe<Array<TourViewRadioSelectFormFieldOption>>;
};

export type TourViewRadioSelectFormFieldOption = {
    label?: Maybe<TourViewModuleText>;
    textarea?: Maybe<TourViewTextarea>;
    value?: Maybe<Scalars['String']['output']>;
};

export type TourViewRequestedTourTimes = ITourViewModule & {
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewModuleMetadata>;
    requestedTourTimes?: Maybe<Array<TourViewModuleText>>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewRescheduleTourButton = ITourViewModuleButton & {
    action?: Maybe<TourViewAction>;
    icon?: Maybe<TourViewIcon>;
    iconPosition?: Maybe<TourViewModuleButtonIconPosition>;
    label: TourViewModuleText;
    metadata?: Maybe<TourViewModuleMetadata>;
    tag?: Maybe<TourViewModuleTag>;
    type?: Maybe<TourViewModuleButtonType>;
};

export type TourViewSuccessfulSaveNotesToast = ITourViewToast & {
    appearance: TourViewToastAppearance;
    body: TourViewModuleText;
    duration: Scalars['Int']['output'];
};

export type TourViewSuccessfulTourCancelToast = ITourViewToast & {
    appearance: TourViewToastAppearance;
    body: TourViewModuleText;
    duration: Scalars['Int']['output'];
};

export type TourViewSuccessfulTourRequestToast = ITourViewToast & {
    appearance: TourViewToastAppearance;
    body: TourViewModuleText;
    duration: Scalars['Int']['output'];
};

export type TourViewSuccessfulTourRescheduleToast = ITourViewToast & {
    appearance: TourViewToastAppearance;
    body: TourViewModuleText;
    duration: Scalars['Int']['output'];
};

export type TourViewTextarea = {
    maxLength?: Maybe<Scalars['Int']['output']>;
    placeholder?: Maybe<Scalars['String']['output']>;
};

export type TourViewToast =
    | TourViewFailedSaveFeedbackToast
    | TourViewFailedSaveNotesToast
    | TourViewFailedTourCancelToast
    | TourViewFailedTourRescheduleToast
    | TourViewSuccessfulSaveNotesToast
    | TourViewSuccessfulTourCancelToast
    | TourViewSuccessfulTourRequestToast
    | TourViewSuccessfulTourRescheduleToast;

export type TourViewToastAppearance = 'error' | 'info' | 'success';

export type TourViewTourChecklist = ITourViewModule & {
    metadata?: Maybe<TourViewModuleMetadata>;
    sections?: Maybe<Array<TourViewTourChecklistSection>>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewTourChecklistSection = {
    heading?: Maybe<TourViewModuleText>;
    subsections?: Maybe<Array<TourViewTourChecklistSubsection>>;
};

export type TourViewTourChecklistSubsection = {
    heading?: Maybe<TourViewModuleText>;
    items?: Maybe<Array<TourViewModuleText>>;
};

export type TourViewTourDetails = ITourViewModule & {
    appointmentTime?: Maybe<TourViewModuleText>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewModuleMetadata>;
    propertyAddress?: Maybe<TourViewModuleText>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TourViewTourListCard = ITourViewModule & {
    action?: Maybe<TourViewAction>;
    heading?: Maybe<TourViewModuleText>;
    metadata?: Maybe<TourViewModuleMetadata>;
    propertyPhoto?: Maybe<TourViewModulePhoto>;
    style?: Maybe<TourViewModuleStyle>;
    subtitle?: Maybe<TourViewModuleText>;
    tag?: Maybe<TourViewModuleTag>;
    title?: Maybe<TourViewModuleText>;
};

export type TourViewTourListSection = ITourViewModule & {
    callToAction?: Maybe<TourViewCTA>;
    heading?: Maybe<TourViewHeading>;
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
    tourCards?: Maybe<Array<TourViewTourListCard>>;
};

export type TourViewTourNotes = ITourViewModule & {
    feedbackNotes?: Maybe<Array<TourViewList>>;
    heading?: Maybe<TourViewHeading>;
    metadata?: Maybe<TourViewModuleMetadata>;
    propertyTags?: Maybe<TourViewPropertyTags>;
    style?: Maybe<TourViewModuleStyle>;
    textarea?: Maybe<TourViewTextarea>;
};

export type TourViewTourSummaryCard = ITourViewModule & {
    metadata?: Maybe<TourViewModuleMetadata>;
    propertyPhoto?: Maybe<TourViewModulePhoto>;
    style?: Maybe<TourViewModuleStyle>;
    tourDetails?: Maybe<TourViewTourDetails>;
};

export type TourViewTriggerSMSAction = {
    messageBody: Scalars['String']['output'];
    recipientPhoneNumber: Scalars['String']['output'];
};

export type TourViewZHLUpsell = ITourViewModule & {
    abTrial?: Maybe<TourViewABTrial>;
    button?: Maybe<TourViewModuleText>;
    content?: Maybe<TourViewContent>;
    finePrint?: Maybe<TourViewModuleText>;
    icon?: Maybe<TourViewModulePhoto>;
    metadata?: Maybe<TourViewModuleMetadata>;
    style?: Maybe<TourViewModuleStyle>;
};

export type TouringAgreement = ServiceAgreement & {
    agent?: Maybe<PAAgent>;
    /**
     * **Definition:** Legal brokerage name for the agent
     *
     * **Source:** Hardcoded agent info in Touring Agreement service. Note PAAgent.businessName is editable by Alan and may not be the legal brokerage for filling out contracts
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    brokerage?: Maybe<Scalars['String']['output']>;
    buyer?: Maybe<Buyer>;
    compensation?: Maybe<AgentCompensation>;
    createdDate?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** link to the editable TouringAgreement in zDocs for agent
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible only to the agent associated with the agreement
     */
    editableAgentZDocsLink?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Expiration of touring agreement
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    expirationISO?: Maybe<Scalars['DateTime']['output']>;
    /**
     * **Definition:** link to the read only TouringAgreement in zDocs for Agent
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    readOnlyAgentZDocsLink?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** link to the read only TouringAgreement in zDocs for Beth
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    readOnlyBuyerZDocsLink?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** Status for this touring agreement
     *
     * **Source:** Touring Agreement service (inferred from zDocs agreement data)
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    workflowStatus?: Maybe<TouringAgreementWorkflowStatus>;
    /**
     * **Definition:** documentId from ZDocs
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    zDocsId?: Maybe<Scalars['String']['output']>;
};

export type TouringAgreementWorkflowStatus =
    | 'COMPLETED'
    | 'CREATED'
    | 'EXPIRED'
    | 'SIGNED_BY_AGENT'
    | 'UNKNOWN';

export type TouringLink = {
    /**
     * **Definition:** a link
     *
     * **Source:** the source of the parent field
     *
     * **Auth:** Uses the auth of the parent field
     */
    full?: Maybe<Scalars['String']['output']>;
    /**
     * **Definition:** a shortened version of the link
     *
     * **Source:** the source of the parent field
     *
     * **Note:** NOT IMPLEMENTED
     *
     * **Auth:** Uses the auth of the parent field
     */
    shortened?: Maybe<Scalars['String']['output']>;
};

export type TrackingData = {
    key?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

/** An object containing the transaction cost breakdown */
export type TransactionCosts = {
    additionalConcessions?: Maybe<Scalars['Int']['output']>;
    totalAgentCommissionPercent?: Maybe<Scalars['Int']['output']>;
    traditionalClosingCosts?: Maybe<Scalars['Int']['output']>;
};

export type TransactionRefinanceCashOut = {
    reason?: InputMaybe<RefinanceCashOutType>;
};

export type TransactionRefinanceProgramType =
    | 'FullDocumentation'
    | 'InterestRateReduction'
    | 'Streamlined';

export type TransactionTimeframe =
    | 'FourToSixMonths'
    | 'GreaterThanSixMonths'
    | 'LessThanFourMonths'
    | 'NotSure';

export type TransitScoreResponse = {
    description?: Maybe<Scalars['String']['output']>;
    help_link?: Maybe<Scalars['String']['output']>;
    transit_score?: Maybe<Scalars['Int']['output']>;
    ws_link?: Maybe<Scalars['String']['output']>;
};

export type TranslatedAmenities = {
    categorized?: Maybe<Scalars['JSON']['output']>;
    displayCategorized?: Maybe<Scalars['Boolean']['output']>;
};

export type TruliaGuestUser = {
    tlid: Scalars['String']['output'];
    upsForRentLongTermHistograms?: Maybe<TlidUpsForRentLongTermHistograms>;
    upsForSaleLongTermHistograms?: Maybe<TlidUpsForSaleLongTermHistograms>;
};

export type TruliaGuestUserupsForRentLongTermHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type TruliaGuestUserupsForSaleLongTermHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type TruliaUser = {
    aipersCollections?: Maybe<TuidAipersCollections>;
    tuid: Scalars['String']['output'];
    upsForRentLongTermHistograms?: Maybe<TuidUpsForRentLongTermHistograms>;
    upsForSaleLongTermHistograms?: Maybe<TuidUpsForSaleLongTermHistograms>;
};

export type TruliaUseraipersCollectionsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type TruliaUserupsForRentLongTermHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type TruliaUserupsForSaleLongTermHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type TrustType = 'LandTrust' | 'LivingTrust';

/**  Default Experience PersFeeds.Collections feature group generated by AI models for logged in Trulia Users  */
export type TuidAipersCollections = {
    /**  TODO  */
    collections?: Maybe<Array<TuidAipersCollections_CollectionsRecord>>;
    /**  TUID - the Trulia UserID that uniquely identifies logged in Trulia users  */
    tuid: Scalars['String']['output'];
};

/**  Structure used to identify a collection  */
export type TuidAipersCollections_CollectionFiltersRecord = {
    /**  The set of city Ids in the collection  */
    cities?: Maybe<Array<Scalars['String']['output']>>;
    /**  Interior sqft range  */
    livingAreaSqft?: Maybe<TuidAipersCollections_MaxMinFieldIntRecord>;
    /**  Price range  */
    price?: Maybe<TuidAipersCollections_MaxMinFieldIntRecord>;
    /**  A set of property attributes that should be included  */
    showOnly?: Maybe<Array<TuidAipersCollections_ShowOnlyType>>;
};

/**  Structure used to identify a collection  */
export type TuidAipersCollections_CollectionIdentifierRecord = {
    /**  TODO  */
    cid?: Maybe<Scalars['Long']['output']>;
    /**  TODO  */
    collectionCat?: Maybe<Scalars['String']['output']>;
    /**  TODO  */
    collectionType?: Maybe<Scalars['String']['output']>;
    /**  TODO  */
    filters?: Maybe<Scalars['JSON']['output']>;
    /**  The location name (ie city/state, neighborhood, etc) of the collection  */
    locationName?: Maybe<Scalars['String']['output']>;
    /**  TODO  */
    ranker?: Maybe<Scalars['String']['output']>;
};

/**  Defines collection treatment records for ZUID/GUID/TUID  */
export type TuidAipersCollections_CollectionsRecord = {
    /**  TODO  */
    batchOnly?: Maybe<Scalars['Boolean']['output']>;
    /**  TODO  */
    collectionIdentifier?: Maybe<TuidAipersCollections_CollectionIdentifierRecord>;
    /**  TODO  */
    collectionTimeStamp?: Maybe<Scalars['Long']['output']>;
    /**  TODO  */
    contentType?: Maybe<TuidAipersCollections_ContentTypeEnum>;
    /**  A set of search filters the collection should use  */
    filters?: Maybe<TuidAipersCollections_CollectionFiltersRecord>;
    /**
     *  Map of optional, or experimental, fields generated for Collections. Keys represent some experimental
     * feature that is being generated and tested. These features and their values are going through an evaluation
     * process to see if they should be permanently added as a field to the Collections schema(s).
     */
    flexFeatures?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    name?: Maybe<Scalars['String']['output']>;
    /**  TODO  */
    recs?: Maybe<Array<Scalars['Long']['output']>>;
    /**  TODO  */
    treatmentsToIndex?: Maybe<Scalars['JSON']['output']>;
};

/**  ENUM used to specify ContentType of a collection record  */
export type TuidAipersCollections_ContentTypeEnum = 'FOR_RENT' | 'FOR_SALE';

/**  A integer range filter  */
export type TuidAipersCollections_MaxMinFieldIntRecord = {
    /**  Max of integer range  */
    max?: Maybe<Scalars['Int']['output']>;
    /**  Min of integer range  */
    min?: Maybe<Scalars['Int']['output']>;
};

/**  ENUM used to specify an attribute of the property that should be filtered to  */
export type TuidAipersCollections_ShowOnlyType =
    | 'airConditioning'
    | 'pool'
    | 'waterfront'
    | 'waterview';

/**
 *  Histograms generated for TUID-identified Trulia users in the context of For Rent properties and batch/offline
 * *  histogram computation. The "Long Term" suffux here indicates original assumption of using longer historical
 * *	user events to calculate the histograms. Should this Long Term assumption become invalid in future, it is suggested
 * 	to deprecate this set and create a more generic "offline" set instead.
 */
export type TuidUpsForRentLongTermHistograms = {
    /**  Histograms calculated as part of the For Rent Long Term experience  */
    histograms?: Maybe<TuidUpsForRentLongTermHistograms_LongTermHistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the unknown Trulia user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  TUID - the devide ID that uniquely identifies an unknown user interacting with Trulia  */
    tuid: Scalars['String']['output'];
    /**  History of rental properties viewed by the known Trulia user with the most recent views first  */
    viewHistory?: Maybe<Array<TuidUpsForRentLongTermHistograms_ViewHistoryRecord>>;
};

/**  Record contains time-decayed histogram fields based on Trulia properties a user has viewed on site.  */
export type TuidUpsForRentLongTermHistograms_LongTermHistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Internal representation for more granular city allocation  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Crime score of the viewed properties  */
    crimeScore?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure based on hash representation of longitude/latitude of viewed properties.  */
    geohash5?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure extended to geohash neighbors  */
    geohash5Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure based on hash representation of longitude/latitude of viewed properties.  */
    geohash6?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure extended to geohash neighbors  */
    geohash6Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  Whether or not the viewed properties allow pets  */
    petsAllowed?: Maybe<Scalars['JSON']['output']>;
    /**  Rental price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Rent price per bedroom  */
    pricePerBedroom?: Maybe<Scalars['JSON']['output']>;
    /** @deprecated This field no longer exists based on the latest generated schema. */
    rentPricePerBedroom?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a trulia property was viewed, and for how long it was viewed, by a user.  */
export type TuidUpsForRentLongTermHistograms_ViewHistoryRecord = {
    /**  dwell in seconds for the user viewed the property (specified by propertyId)  */
    dwellSeconds?: Maybe<Scalars['Int']['output']>;
    /**  idType - Unique identifier for types of property ids. 0: zpid, 1: tpid  */
    idType?: Maybe<Scalars['Int']['output']>;
    /**  propertyId - Unique identifier for a property viewed by a user.  */
    propertyId?: Maybe<Scalars['String']['output']>;
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
};

/**
 *  Histograms generated for TUID-identified Trulia users in the context of For Sale properties and batch/offline
 * *  histogram computation. The "Long Term" suffux here indicates original assumption of using longer historical
 * *	user events to calculate the histograms. Should this Long Term assumption become invalid in future, it is suggested
 * 	to deprecate this set and create a more generic "offline" set instead.
 */
export type TuidUpsForSaleLongTermHistograms = {
    /**  Histograms calculated as part of the For Sale Long Term experience  */
    histograms?: Maybe<TuidUpsForSaleLongTermHistograms_LongTermHistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the unknown Trulia user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  TUID - the devide ID that uniquely identifies an known user interacting with Trulia  */
    tuid: Scalars['String']['output'];
    /**  History of rental properties viewed by the known Trulia user with the most recent views first  */
    viewHistory?: Maybe<Array<TuidUpsForSaleLongTermHistograms_ViewHistoryRecord>>;
};

/**  Record contains time-decayed histogram fields based on Trulia properties a user has viewed on site.  */
export type TuidUpsForSaleLongTermHistograms_LongTermHistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Internal representation for more granular city allocation  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Crime score of the viewed properties  */
    crimeScore?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure based on hash representation of longitude/latitude of viewed properties.  */
    geohash5?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure extended to geohash neighbors  */
    geohash5Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure based on hash representation of longitude/latitude of viewed properties.  */
    geohash6?: Maybe<Scalars['JSON']['output']>;
    /**  Activity measure extended to geohash neighbors  */
    geohash6Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies whether the land is vacant or not  */
    isVacantLand?: Maybe<Scalars['JSON']['output']>;
    /**  Rental price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a trulia property was viewed, and for how long it was viewed, by a user.  */
export type TuidUpsForSaleLongTermHistograms_ViewHistoryRecord = {
    /**  dwell in seconds for the user viewed the property (specified by propertyId)  */
    dwellSeconds?: Maybe<Scalars['Int']['output']>;
    /**  idType - Unique identifier for types of property ids. 0: zpid, 1: tpid  */
    idType?: Maybe<Scalars['Int']['output']>;
    /**  propertyId - Unique identifier for a property viewed by a user.  */
    propertyId?: Maybe<Scalars['String']['output']>;
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
};

export type UnassistedShowing = {
    /** Whether it is possible to subscribe to the event that this home became available */
    canSubscribeToAvailable?: Maybe<Scalars['Boolean']['output']>;
    /**
     * The timezone ID this property is in, such as "America/Los_Angeles", defined by
     * the Unicode Common Locale Data Repository (CLDR) project
     */
    homeTimeZone?: Maybe<Scalars['String']['output']>;
    /** The unix timestamp until which self tours are allowed on this day */
    showingEndTime?: Maybe<Scalars['DateTime']['output']>;
    /** The ISO-8601 date-time until which self tours are allowed on this day, in the property timezone */
    showingEndTimeIso?: Maybe<Scalars['String']['output']>;
    /** The unix timestamp from which self tours are allowed on this day */
    showingStartTime?: Maybe<Scalars['DateTime']['output']>;
    /** The ISO-8601 date-time from which self tours are allowed on this day, in the property timezone */
    showingStartTimeIso?: Maybe<Scalars['String']['output']>;
    /**
     * Home showing availability status. If showings set up, will be AVAILABLE if in
     * permitted time range, UNAVAILABLE if outside. Otherwise DISABLED
     */
    showingStatus?: Maybe<Scalars['String']['output']>;
    /** The unformatted US phone number to call in case of issues with home showings. May contain country code */
    showingSupportPhoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Detail unit information */
export type Unit = {
    availability?: Maybe<Scalars['String']['output']>;
    baths?: Maybe<Scalars['Float']['output']>;
    daysOn?: Maybe<Scalars['Int']['output']>;
    hdpUrl?: Maybe<Scalars['String']['output']>;
    listingType?: Maybe<Scalars['String']['output']>;
    photo?: Maybe<Photo>;
    price?: Maybe<Scalars['String']['output']>;
    providerListingID?: Maybe<Scalars['String']['output']>;
    rentalApplicationsAcceptedType?: Maybe<Scalars['String']['output']>;
    sqft?: Maybe<Scalars['Int']['output']>;
    unit?: Maybe<Scalars['String']['output']>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    zpid?: Maybe<Scalars['ID']['output']>;
};

/** Unit information grouped by type: For Rent, For Sale and Off Market when available */
export type UnitListGroup = {
    bedroomGroups?: Maybe<Array<Maybe<UnitTableBedroomGroupType>>>;
    label?: Maybe<Scalars['String']['output']>;
    onMarket?: Maybe<Scalars['Boolean']['output']>;
    unitCount?: Maybe<Scalars['String']['output']>;
};

export type UnitOverview = {
    bedCount?: Maybe<Scalars['Int']['output']>;
    maxBaths?: Maybe<Scalars['Float']['output']>;
    maxSqft?: Maybe<Scalars['Int']['output']>;
    minBaths?: Maybe<Scalars['Float']['output']>;
    minSqft?: Maybe<Scalars['Int']['output']>;
};

/** Unit information grouped by number of bedroom */
export type UnitTableBedroomGroupType = {
    bedCount?: Maybe<Scalars['Int']['output']>;
    floorplans?: Maybe<Array<Maybe<Floorplan>>>;
    priceRange?: Maybe<Scalars['String']['output']>;
    units?: Maybe<Array<Maybe<Unit>>>;
};

/** Detail unit information for WOW BDP */
export type UnitV2 = {
    availableFrom?: Maybe<Scalars['String']['output']>;
    availableFromDateStr?: Maybe<Scalars['String']['output']>;
    baths?: Maybe<Scalars['Float']['output']>;
    beds?: Maybe<Scalars['Int']['output']>;
    daysOn?: Maybe<Scalars['Int']['output']>;
    /** Unit has approved third party virtual tour */
    hasApprovedThirdPartyVirtualTour?: Maybe<Scalars['Boolean']['output']>;
    hdpUrl?: Maybe<Scalars['String']['output']>;
    homeStatus?: Maybe<Scalars['String']['output']>;
    housingConnector?: Maybe<Scalars['Boolean']['output']>;
    housingConnectorExclusive?: Maybe<Scalars['Boolean']['output']>;
    isRoomForRent?: Maybe<Scalars['Boolean']['output']>;
    isShowcaseListing?: Maybe<Scalars['Boolean']['output']>;
    /** Is this property owned by Zillow */
    isZillowOwned?: Maybe<Scalars['Boolean']['output']>;
    lastSoldAt?: Maybe<Scalars['String']['output']>;
    listingMetadata?: Maybe<listingMetadata>;
    listingType?: Maybe<Scalars['String']['output']>;
    listing_sub_type?: Maybe<ListingSubtype>;
    maloneId?: Maybe<Scalars['String']['output']>;
    maxPrice?: Maybe<Scalars['Int']['output']>;
    minPrice?: Maybe<Scalars['Int']['output']>;
    photo?: Maybe<Photo>;
    price?: Maybe<Scalars['Int']['output']>;
    propertyType?: Maybe<Scalars['String']['output']>;
    sqft?: Maybe<Scalars['Int']['output']>;
    /** The display label used to group units */
    tabGroupLabel?: Maybe<Scalars['String']['output']>;
    /** Unit level third party virtual tour */
    thirdPartyVirtualTour?: Maybe<thirdPartyVirtualTour>;
    unitNumber?: Maybe<Scalars['String']['output']>;
    /** unit VR Model based on virtualTourUrl */
    unitVRModel?: Maybe<BuildingVRModel>;
    /** This field will not be used until RDAPI fully supports requesting by zpid */
    vrModel?: Maybe<BuildingVRModel>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    zpid?: Maybe<Scalars['ID']['output']>;
};

/** Summary fields for the units of the building */
export type UnitsSummary = {
    availableUnitCount?: Maybe<Scalars['Int']['output']>;
    /** A list of all the possible bed counts for active rental units in the building */
    bedOptions?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    /** The price range for each bed options */
    bedOptionsPriceRanges?: Maybe<Array<Maybe<PriceRange>>>;
    maxPrice?: Maybe<Scalars['Int']['output']>;
    maxSqft?: Maybe<Scalars['Int']['output']>;
    minPrice?: Maybe<Scalars['Int']['output']>;
    minSqft?: Maybe<Scalars['Int']['output']>;
    unitCount?: Maybe<Scalars['Int']['output']>;
};

export type UpdateAbadResponse = {
    /** Type of ABAD seen, Digital or eConsented */
    abadType?: Maybe<AbadType>;
    /** The full text of the ABAD document, in markdown format. */
    documentText?: Maybe<Scalars['String']['output']>;
    /** The latest version of the ABAD document. */
    documentVersion: Scalars['Int']['output'];
    /** A Boolean value indicating if the ABAD has been viewed by the user or not */
    hasSeenAbad: Scalars['Boolean']['output'];
};

export type UpdateBorrowerInput = {
    attributes?: InputMaybe<BorrowerAttributesInput>;
};

export type UpdateBorrowerOutput = {
    id?: Maybe<Scalars['ID']['output']>;
};

export type UpdateContactedRentalCacheResponse = {
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateContactedRentalResponse = {
    contactedRental?: Maybe<ContactedRental>;
    notifications?: Maybe<Array<Maybe<RenterHubNotification>>>;
};

export type UpdateMessageStatusResponse = {
    message?: Maybe<Scalars['String']['output']>;
    success?: Maybe<Scalars['Boolean']['output']>;
};

/** Update contact input */
export type UpdatePAContactInput = {
    /** Contact info */
    contact: PAContactInput;
    /** Contact ID */
    id: Scalars['ID']['input'];
    /** Owner or assignee agent ZUID (for clients using scope token) */
    ownerOrAssigneeAgentZuid?: InputMaybe<Scalars['ID']['input']>;
};

/** Update contact mutationpayload */
export type UpdatePAContactPayload = {
    /** Updated Contact object */
    contact?: Maybe<PAContact>;
    /** Errors */
    errors?: Maybe<Array<Error>>;
};

export type UpdatePropertyViewInput = {
    /**  the type of property id, pvs supports only zpid  */
    propertyIdTypes: Array<PropertyIdType>;
    /**  property identifier  */
    propertyIds: Array<Scalars['ID']['input']>;
};

/** Mutation input to update all of the connection targets for a team lead */
export type UpdateTeamMemberConnectionTargetFromPlanningInput = {
    /** Id of the recommendations that were being shown when the update was made */
    recommendationBatchId: Scalars['String']['input'];
    /** List of connection targets */
    teamMemberConnectionTargets?: InputMaybe<Array<InputMaybe<TeamMemberConnectionTargetInput>>>;
};

/** Query input to update the connection target of a team member */
export type UpdateTeamMemberConnectionTargetInput = {
    /** The connection target to update the team member's value to */
    connectionTarget: Scalars['Int']['input'];
    /** The team member's zuid */
    teamMemberZuid: ZuidInput;
};

/** Input for updating team member connection target recommendations */
export type UpdateTeamMemberConnectionTargetRecommendationInput = {
    /** The team member's conversion rate */
    conversionRate?: InputMaybe<Scalars['Float']['input']>;
    /** The team member's rating for conversionRate */
    conversionRatePerformanceRating?: InputMaybe<PerformanceRating>;
    /** Created by email alias */
    createdBy: Scalars['String']['input'];
    /** Date Recommendation should be effective (currently ignored) */
    effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
    /** The team member's engaged transfer rate */
    engagedTransferRate?: InputMaybe<Scalars['Float']['input']>;
    /** The team member's rating for engagedTransferRate */
    engagedTransferRatePerformanceRating?: InputMaybe<PerformanceRating>;
    /** Last 90 days buyer connection count */
    last90DaysBuyerConnectionCount?: InputMaybe<Scalars['Int']['input']>;
    /** Last 90 days opt in connection count */
    last90DaysOptInConnectionCount?: InputMaybe<Scalars['Int']['input']>;
    /** Team member's performance rank out of all team members */
    performanceRank?: InputMaybe<Scalars['Int']['input']>;
    /** The team member's rating */
    performanceRating?: InputMaybe<PerformanceRating>;
    /** GUID identifying all recommendations uploaded in a single session */
    recommendationBatchId: Scalars['String']['input'];
    /** A note describing the team member's recommendation */
    recommendationReason?: InputMaybe<Scalars['String']['input']>;
    /** The team member's connection target */
    recommendedConnectionTarget: Scalars['Int']['input'];
    /** The team lead's (Audrey) zuid */
    teamLeadZuid: ZuidInput;
    /** The team member's (Alan) zuid */
    teamMemberZuid: ZuidInput;
};

export type UpdateTeamMemberConnectionTargetRecommendationsResult = {
    /** List of team member connection target recommendations updated */
    connectionTargets?: Maybe<Array<Maybe<TeamMemberConnectionTarget>>>;
    /** Whether or not the update succeeded */
    successful: Scalars['Boolean']['output'];
};

/** Mutation result of the updated values for a team member */
export type UpdateTeamMemberConnectionTargetResult = {
    /** Whether or not the update succeeded */
    successful: Scalars['Boolean']['output'];
    /** The updated connection target for a team member */
    teamMemberConnectionTarget?: Maybe<Array<Maybe<TeamMemberConnectionTarget>>>;
};

export type UpdateUserAbadStatusInput = {
    /** The version of the ABAD document seen. */
    documentVersion: Scalars['Int']['input'];
    /** A Boolean value indicating if the ABAD has been viewed by the user or not */
    hasSeenAbad: Scalars['Boolean']['input'];
};

export type UpdateUserNoteInput = {
    noteId?: InputMaybe<Scalars['String']['input']>;
    noteText: Scalars['String']['input'];
    noteType: Scalars['String']['input'];
    propertyId: Scalars['ID']['input'];
    propertyIdType: PropertyIdType;
    subjectLine?: InputMaybe<Scalars['String']['input']>;
};

/** Updates tab internal route */
export type UpdatesRoute = INativeIOSDestination & {
    attributions: Array<AttributionEntry>;
};

/** A recommended upsell to expose to the user */
export type Upsell = RecsModule & {
    /** Content Type included in the module (UPSELL_ZHL, etc). */
    contentType?: Maybe<CollectionContentType>;
};

export type UpsertBuysideDataInput = {
    buysideQuestionnarieId: Scalars['String']['input'];
    misoId: Scalars['ID']['input'];
};

export type Uris = {
    landscapeUri?: Maybe<Scalars['String']['output']>;
    portraitUri?: Maybe<Scalars['String']['output']>;
};

export type UrisFormat = {
    DASH?: Maybe<Uris>;
    HLS?: Maybe<Uris>;
    IMAGE?: Maybe<Uris>;
    MP4_HIGH?: Maybe<Uris>;
    MP4_LOW?: Maybe<Uris>;
    MP4_MEDIUM?: Maybe<Uris>;
};

export type UrlObjectType = {
    /** url path for the requested field */
    path?: Maybe<Scalars['String']['output']>;
    /** text description of the url */
    text?: Maybe<Scalars['String']['output']>;
};

export type User = {
    /** Information in core-profile-data service for the user */
    coreProfileData?: Maybe<CoreProfileData>;
    /** Account creation timestamp */
    createDate: Scalars['DateTime']['output'];
    /** Name meant for public display */
    displayName?: Maybe<Scalars['String']['output']>;
    /** Email of the user */
    email?: Maybe<Scalars['String']['output']>;
    /** Encoded zillow user ID of the user */
    encodedZuid: Scalars['String']['output'];
    /** The type of external account used to sign in (facebook, apple, google, etc) */
    externalAccount: Array<Maybe<ExternalAuthAccountData>>;
    /** First name of the user */
    firstName?: Maybe<Scalars['String']['output']>;
    hasOptOutOfAdvertising: Scalars['Boolean']['output'];
    /** The user has a password set for their account */
    hasPassword: Scalars['Boolean']['output'];
    /** The user has admin permissions */
    isAdmin: Scalars['Boolean']['output'];
    isEmailVerified: Scalars['Boolean']['output'];
    isEmployee: Scalars['Boolean']['output'];
    isZillowGroupEmployee: Scalars['Boolean']['output'];
    /** The user has signed the ZMA consent */
    isZmaConsentSigned?: Maybe<Scalars['Boolean']['output']>;
    /** Last Name of the user */
    lastName?: Maybe<Scalars['String']['output']>;
    logon?: Maybe<Scalars['String']['output']>;
    /** Information on Multi-Factor Authentication for the user */
    multiFactorAuth?: Maybe<MultiFactorAuthData>;
    /** Name of the user */
    name?: Maybe<Scalars['String']['output']>;
    permissions: Array<Maybe<Scalars['Int']['output']>>;
    profiles: Array<Maybe<Scalars['Int']['output']>>;
    roles: Array<Maybe<Scalars['Int']['output']>>;
    /** User-created, human-readable identifier for the user's account */
    screenName?: Maybe<Scalars['String']['output']>;
    status: Scalars['Int']['output'];
    type: Scalars['Int']['output'];
    /** ZMA consent signed timestamp */
    zmaConsentSignedDate?: Maybe<Scalars['DateTime']['output']>;
    zuid: Scalars['Int']['output'];
};

export type UserActivityAggregation = {
    /**
     * when null, default top metric level aggregation;
     * otherwise, depend on the UserActivityMetric -> specific sub-metric enums
     */
    aggregationType: AggregationType;
    aggregationWindow: AggregationWindow;
    /** the user id associated with this user activity metric */
    associatedId: IdBasedWithSource;
    metric: UserActivityMetric;
    subMetric?: Maybe<Scalars['String']['output']>;
    /** the meaning of the value is dependent on all the other attributes */
    value: Scalars['GraphQLLong']['output'];
};

/** related to aggregated metrics on user_activity */
export type UserActivityMetric = 'GUID';

/** filters on user activity summary metrics: implied AND logical operator among filter criteria fields */
export type UserActivitySummaryFilter = {
    /** Only the metrics with this aggregation type */
    aggregationType?: InputMaybe<AggregationType>;
    /** Only the metrics within this aggregation time window */
    aggregationWindow?: InputMaybe<AggregationWindow>;
    /** Only the metrics under this UserActivityMetric category */
    topLevelMetric?: InputMaybe<UserActivityMetric>;
};

export type UserData = {
    /** User's business number */
    businessNumber?: Maybe<Scalars['String']['output']>;
    /** User's cellphone number */
    cellNumber?: Maybe<Scalars['String']['output']>;
    /** User's first name */
    firstName?: Maybe<Scalars['String']['output']>;
    /** User's last name */
    lastName?: Maybe<Scalars['String']['output']>;
    /**
     * Link to user's profile image
     * @deprecated Security issue. See #prexit-profile-photo.
     */
    photo?: Maybe<Scalars['String']['output']>;
    /** User's ratings */
    ratings?: Maybe<UserRatings>;
    /** User's screen name */
    screenName?: Maybe<Scalars['String']['output']>;
    /** User's Twilio (tracked) phone number */
    twilioZillowHotPadsYahooNumber?: Maybe<Scalars['String']['output']>;
    /** User's Zillow unique ID */
    zuid?: Maybe<Scalars['Int']['output']>;
};

export type UserDataphotoArgs = {
    size?: InputMaybe<PropertyPhotoSize>;
};

export type UserEvent = {
    eventId: Scalars['ID']['output'];
    eventSource: StreamSource;
    eventTime: Scalars['GraphQLLong']['output'];
    /** This is the clickstream event type id */
    eventType: Scalars['String']['output'];
};

export type UserEventsBySemanticTags = {
    /**  user events organized by UES semantic tags  */
    calculatorInteraction?: Maybe<Array<Maybe<CalculatorInteractionEvent>>>;
    saveHome?: Maybe<Array<Maybe<SaveHomeEvent>>>;
    shareHomeHome?: Maybe<Array<Maybe<ShareHomeHomeEvent>>>;
    shareHomeRentalBuilding?: Maybe<Array<Maybe<ShareHomeRentalBuildingEvent>>>;
    viewContentHomeDetails?: Maybe<Array<Maybe<ViewContentHomeDetailsEvent>>>;
    viewContentRentalBuildingDetails?: Maybe<Array<Maybe<ViewContentRentalBuildingDetailsEvent>>>;
    /**  Access to fetch zhl submit events is currently suspended  */
    zhlSubmit?: Maybe<Array<Maybe<ZhlSubmitEvent>>>;
};

export type UserEventsBySemanticTagscalculatorInteractionArgs = {
    eventFilter?: InputMaybe<EventBySemanticTagFilter>;
};

export type UserEventsBySemanticTagssaveHomeArgs = {
    eventFilter?: InputMaybe<EventBySemanticTagFilter>;
};

export type UserEventsBySemanticTagsshareHomeHomeArgs = {
    eventFilter?: InputMaybe<EventBySemanticTagFilter>;
};

export type UserEventsBySemanticTagsshareHomeRentalBuildingArgs = {
    eventFilter?: InputMaybe<EventBySemanticTagFilter>;
};

export type UserEventsBySemanticTagsviewContentHomeDetailsArgs = {
    eventFilter?: InputMaybe<EventBySemanticTagFilter>;
};

export type UserEventsBySemanticTagsviewContentRentalBuildingDetailsArgs = {
    eventFilter?: InputMaybe<EventBySemanticTagFilter>;
};

export type UserEventsBySemanticTagszhlSubmitArgs = {
    eventFilter?: InputMaybe<EventBySemanticTagFilter>;
};

export type UserLearningResult = {
    associatedId: IdBasedWithSource;
    learningModel: LearningModel;
    resultTime?: Maybe<Scalars['GraphQLLong']['output']>;
};

/**
 * filters on Zillow learning results
 * currently supported goal is PROPENSITY in enum LearningGoal
 * currently supported modelNames for PROPENSITY are in LearningModelName enum
 */
export type UserLearningResultFilter = {
    goal: LearningGoal;
    modelName?: InputMaybe<Array<LearningModelName>>;
};

/** Optional mortgage preferences that can be specified by a user */
export type UserMortgagePreferences = {
    creditScoreRange?: InputMaybe<CreditScoreRange>;
    downPaymentAmount?: InputMaybe<Scalars['Float']['input']>;
    downPaymentPercentage?: InputMaybe<Scalars['Float']['input']>;
    isDownpaymentPreferencePercent?: InputMaybe<Scalars['Boolean']['input']>;
    loanTypeTerm?: InputMaybe<Scalars['Int']['input']>;
    splitTreatment?: InputMaybe<Scalars['String']['input']>;
};

export type UserNote = {
    /**  An ISO-8601 encoded UTC date time string. Example value: 2019-07-03T20:47:55Z  */
    createdDateTimeISO?: Maybe<Scalars['DateTime']['output']>;
    /**  user note identifier  */
    noteId?: Maybe<Scalars['String']['output']>;
    /**  The note text added by the user  */
    noteText: Scalars['String']['output'];
    /**  type of user note */
    noteType: Scalars['String']['output'];
    /**  property identifier  */
    propertyId: Scalars['ID']['output'];
    /**  type of property identifier, example: zpid  */
    propertyIdType: PropertyIdType;
    /**  The subject line or title added by the user  */
    subjectLine?: Maybe<Scalars['String']['output']>;
    /**  An ISO-8601 encoded UTC date time string. Example value: 2019-07-03T20:47:55Z  */
    updatedDateTimeISO?: Maybe<Scalars['DateTime']['output']>;
};

export type UserPersonalizedShoppingData = {
    /**  List of tags added by the user  */
    tags?: Maybe<Array<PropertyTag>>;
    /**  List of user notes added by the user */
    userNotes?: Maybe<Array<UserNote>>;
};

export type UserPersonalizedShoppingDatauserNotesArgs = {
    noteType: Scalars['String']['input'];
};

export type UserProfile = {
    /**
     * Property that the user is predicted to own. See also: propensityZpid
     *
     * Interested in using this field? Before you do, please check out the User
     * Profile API onboarding guide and get approval from its owners:
     * https://zwiki.zillowgroup.net/display/AT/User+Profile+Onboarding
     */
    likelyProperty?: Maybe<Property>;
    /**
     * Likelihood that the user is a homeowner. Between 0 and 1 (inclusive).
     *
     * Interested in using this field? Before you do, please check out the User
     * Profile API onboarding guide and get approval from its owners:
     * https://zwiki.zillowgroup.net/display/AT/User+Profile+Onboarding
     */
    propensityHomeowner?: Maybe<Scalars['Float']['output']>;
    /**
     * Likelihood that the user is a seller. Between 0 and 1 (inclusive).
     *
     * Interested in using this field? Before you do, please check out the User
     * Profile API onboarding guide and get approval from its owners:
     * https://zwiki.zillowgroup.net/display/AT/User+Profile+Onboarding
     */
    propensitySell?: Maybe<Scalars['Float']['output']>;
    /**
     * Likelihood that the user owns likelyProperty. Between 0 and 1 (inclusive).
     *
     * Interested in using this field? Before you do, please check out the User
     * Profile API onboarding guide and get approval from its owners:
     * https://zwiki.zillowgroup.net/display/AT/User+Profile+Onboarding
     */
    propensityZpid?: Maybe<Scalars['Float']['output']>;
};

export type UserProfilelikelyPropertyArgs = {
    clientName: Scalars['String']['input'];
    experience?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfilepropensityHomeownerArgs = {
    clientName: Scalars['String']['input'];
    experience?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfilepropensitySellArgs = {
    clientName: Scalars['String']['input'];
    experience?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfilepropensityZpidArgs = {
    clientName: Scalars['String']['input'];
    experience?: InputMaybe<Scalars['String']['input']>;
};

export type UserRatings = {
    /** User's average rating */
    average?: Maybe<Scalars['Float']['output']>;
    /** Count of user's ratings */
    count?: Maybe<Scalars['Int']['output']>;
};

export type UserSearchContext =
    /** Rental properties */
    | 'FOR_RENT'
    /** For sale properties */
    | 'FOR_SALE'
    /** Sold properties */
    | 'SOLD'
    /** All other properties that are not for sale, rental, or sold */
    | 'UNKNOWN';

export type UserStatus = {
    /** @deprecated Use expirationDateTime */
    expiration?: Maybe<Scalars['DateTime']['output']>;
    expirationDateTime?: Maybe<Scalars['DateTime']['output']>;
    requestedDateTime?: Maybe<Scalars['DateTime']['output']>;
    status?: Maybe<Scalars['String']['output']>;
    type?: Maybe<UserStatusType>;
};

export type UserStatusType =
    | 'backgroundReport'
    | 'creditReport'
    | 'idverification'
    | 'rentalApplicationPayment'
    | 'screeningReportShare';

export type UserSurvey = {
    surveyInstanceID?: Maybe<Scalars['String']['output']>;
    surveyUrl?: Maybe<Scalars['String']['output']>;
};

export type UserSurveyError = {
    message?: Maybe<Scalars['String']['output']>;
    shouldRetry: Scalars['Boolean']['output'];
};

export type UserSurveyResponse = {
    errors?: Maybe<Array<UserSurveyError>>;
    userSurvey?: Maybe<UserSurvey>;
};

export type UserZhlAttributes = {
    foreclosureBankruptcy?: Maybe<Scalars['Boolean']['output']>;
    geoAttributes?: Maybe<GeoAttributes>;
    loanType?: Maybe<Scalars['String']['output']>;
    propertyType?: Maybe<Scalars['String']['output']>;
    propertyUsage?: Maybe<Scalars['String']['output']>;
    vaEligible?: Maybe<Scalars['Boolean']['output']>;
    zhlLeadId?: Maybe<Scalars['String']['output']>;
};

export type UserZhlPurchaseAttributes = UserZhlAttributes & {
    bankruptcy?: Maybe<Scalars['Boolean']['output']>;
    cashToCloseBudget?: Maybe<Scalars['Float']['output']>;
    cityOrZip?: Maybe<Scalars['String']['output']>;
    firstTimeBuyer?: Maybe<Scalars['Boolean']['output']>;
    foreclosureBankruptcy?: Maybe<Scalars['Boolean']['output']>;
    geoAttributes?: Maybe<GeoAttributes>;
    hasAgent?: Maybe<Scalars['Boolean']['output']>;
    hasRetirementIncome?: Maybe<Scalars['Boolean']['output']>;
    journeyStage?: Maybe<Scalars['String']['output']>;
    loanType?: Maybe<Scalars['String']['output']>;
    monthlyPaymentBudget?: Maybe<Scalars['Float']['output']>;
    propertyType?: Maybe<Scalars['String']['output']>;
    propertyUsage?: Maybe<Scalars['String']['output']>;
    timeline?: Maybe<Scalars['String']['output']>;
    usCitizen?: Maybe<Scalars['Boolean']['output']>;
    vaEligible?: Maybe<Scalars['Boolean']['output']>;
    zhlLeadId?: Maybe<Scalars['String']['output']>;
};

export type UserZhlRefiAttributes = UserZhlAttributes & {
    annualIncome?: Maybe<Scalars['Float']['output']>;
    cashOut?: Maybe<Scalars['Boolean']['output']>;
    foreclosureBankruptcy?: Maybe<Scalars['Boolean']['output']>;
    geoAttributes?: Maybe<GeoAttributes>;
    loanBalance?: Maybe<Scalars['Float']['output']>;
    loanType?: Maybe<Scalars['String']['output']>;
    propertyType?: Maybe<Scalars['String']['output']>;
    propertyUsage?: Maybe<Scalars['String']['output']>;
    secondMortgage?: Maybe<Scalars['Boolean']['output']>;
    selfEmployed?: Maybe<Scalars['Boolean']['output']>;
    selfReportedCreditScore?: Maybe<Scalars['String']['output']>;
    vaEligible?: Maybe<Scalars['Boolean']['output']>;
    zhlLeadId?: Maybe<Scalars['String']['output']>;
};

export type UsersFeedback =
    /** Dislike */
    | 'DISLIKE'
    /** Like */
    | 'LIKE'
    /** No Response */
    | 'NO_RESPONSE';

export type UtilitiesIncludedType =
    | 'CableTV'
    | 'Cooling'
    | 'Electricity'
    | 'Garbage'
    | 'Gas'
    | 'Heat'
    | 'HotWater'
    | 'Internet'
    | 'None'
    | 'Sewer'
    | 'Unknown'
    | 'Water';

export type VL_Building = {
    adTargets?: Maybe<Scalars['JSON']['output']>;
    address?: Maybe<BuildingAddress>;
    aerialViewVideoId?: Maybe<Scalars['String']['output']>;
    amenitiesVRModels?: Maybe<Array<Maybe<BuildingVRModel>>>;
    amenityDetails?: Maybe<AmenityDetails>;
    amenityPhotos?: Maybe<Array<Maybe<Photo>>>;
    amenitySummary?: Maybe<AmenitySummary>;
    assignedSchools?: Maybe<Array<Maybe<BuildingSchool>>>;
    bdpUrl?: Maybe<Scalars['String']['output']>;
    bestGuessTimezone?: Maybe<Scalars['String']['output']>;
    bestMatchedUnit?: Maybe<VL_Unit>;
    breadcrumbs?: Maybe<Array<Maybe<Breadcrumb>>>;
    buildingAdTargets?: Maybe<AdTargets>;
    buildingAreas?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    buildingKey?: Maybe<Scalars['String']['output']>;
    buildingName?: Maybe<Scalars['String']['output']>;
    buildingNativeAppsUrl?: Maybe<Scalars['String']['output']>;
    buildingPhoneNumber?: Maybe<Scalars['String']['output']>;
    buildingRentalPremiumPackagesInfo?: Maybe<Array<Maybe<VL_BuildingCard>>>;
    buildingType?: Maybe<BuildingType>;
    city?: Maybe<Scalars['String']['output']>;
    citySearchUrl?: Maybe<UrlObjectType>;
    commonUnitAmenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    communityFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    communitySubType?: Maybe<CommunitySubType>;
    comps?: Maybe<VL_Comps>;
    contactInfo?: Maybe<ContactInfo>;
    country?: Maybe<CountryCode>;
    county?: Maybe<Scalars['String']['output']>;
    currency?: Maybe<CurrencyType>;
    description?: Maybe<Scalars['String']['output']>;
    detailedParkingPolicies?: Maybe<Array<Maybe<DetailedParkingPolicy>>>;
    detailedPetPolicy?: Maybe<DetailedPetPolicy>;
    exteriorFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    extraFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    floorPlanDisclaimer?: Maybe<Scalars['String']['output']>;
    floorPlans?: Maybe<Array<Maybe<VL_BuildingFloorPlan>>>;
    forSaleUnitsSummary?: Maybe<UnitsSummary>;
    fullAddress?: Maybe<Scalars['String']['output']>;
    googleStaticMapSignedUrl?: Maybe<Scalars['String']['output']>;
    googleStreetViewImageSignedUrl?: Maybe<Scalars['String']['output']>;
    googleStreetViewMetadataSignedUrl?: Maybe<Scalars['String']['output']>;
    hasInferredAttribute?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Videos are no longer supported for building */
    hasPublicVideo?: Maybe<Scalars['Boolean']['output']>;
    hasRoomForRent?: Maybe<Scalars['Boolean']['output']>;
    housingConnector?: Maybe<HousingConnector>;
    /** @deprecated migrating to instantTourTypesDetails */
    instantTourTypes?: Maybe<Array<Maybe<InstantTourType>>>;
    instantTourTypesDetails?: Maybe<Array<Maybe<InstantTourTypeDetails>>>;
    interiorFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    isAdsRestricted?: Maybe<Scalars['Boolean']['output']>;
    isInstantTourCancellable?: Maybe<Scalars['Boolean']['output']>;
    isInstantTourEnabled?: Maybe<Scalars['Boolean']['output']>;
    isLandlordLiaisonProgram?: Maybe<Scalars['Boolean']['output']>;
    isLowIncome?: Maybe<Scalars['Boolean']['output']>;
    isPaidMultiFamilyBrokerId?: Maybe<Scalars['Boolean']['output']>;
    isPaidSingleFamilyBrokerId?: Maybe<Scalars['Boolean']['output']>;
    isRentalsLeadCapMet?: Maybe<Scalars['Boolean']['output']>;
    isSavedByCurrentSignedInUser?: Maybe<Scalars['Boolean']['output']>;
    isSeniorHousing?: Maybe<Scalars['Boolean']['output']>;
    isStudentHousing?: Maybe<Scalars['Boolean']['output']>;
    isWaitlisted?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use 'latitude' and 'longitude' fields instead */
    latLong?: Maybe<LatLong>;
    latitude?: Maybe<Scalars['Float']['output']>;
    leaseLengths?: Maybe<Scalars['String']['output']>;
    listingFeatureType?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use 'rules' field instead */
    listingMetadata?: Maybe<ListingMetadata>;
    localProtections?: Maybe<LocalProtections>;
    longitude?: Maybe<Scalars['Float']['output']>;
    /**  primary key of VL_Building. source: building-graphql  */
    lotId?: Maybe<Scalars['ID']['output']>;
    marketInsightsUrl?: Maybe<MarketInsightsType>;
    marketingTreatments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    metaData?: Maybe<MetaData>;
    nearbyAmenities?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    nearbyBuildingLinks?: Maybe<Array<Maybe<NearbyBuildingLink>>>;
    nearbyCities?: Maybe<Array<Maybe<VL_Region>>>;
    nearbyNeighborhoods?: Maybe<Array<Maybe<VL_Region>>>;
    nearbyZipcodes?: Maybe<Array<Maybe<VL_Region>>>;
    neighborhood?: Maybe<Scalars['String']['output']>;
    photoCount?: Maybe<Scalars['Int']['output']>;
    photos?: Maybe<Array<Maybe<Photo>>>;
    poolFeatures?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    ppcLink?: Maybe<PPCLink>;
    /** @deprecated Videos are no longer supported for building */
    primaryPublicVideo?: Maybe<Video>;
    questionsAnswersInfo?: Maybe<QuestionsAnswersInfo>;
    regionIds?: Maybe<RegionIds>;
    rentalCostAndFeesDisclaimer?: Maybe<Scalars['String']['output']>;
    rentalUnitsSummary?: Maybe<UnitsSummary>;
    reviewsInfo?: Maybe<VL_ReviewsInfo>;
    rules?: Maybe<VL_PropertyResultRules>;
    screeningCriteria?: Maybe<ScreeningCriteria>;
    showAlnNotice?: Maybe<Scalars['Boolean']['output']>;
    specialOffers?: Maybe<Array<Maybe<SpecialOffer>>>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    thirdPartyVirtualTours?: Maybe<Array<Maybe<ThirdPartyVirtualTour>>>;
    thumbnailPhoto?: Maybe<Photo>;
    transitScore?: Maybe<TransitScoreResponse>;
    ungroupedUnits?: Maybe<Array<Maybe<VL_Unit>>>;
    unitOverview?: Maybe<Array<Maybe<UnitOverview>>>;
    unitsVRModels?: Maybe<Array<Maybe<BuildingVRModel>>>;
    walkScore?: Maybe<WalkScoreResponse>;
    zipcode?: Maybe<Scalars['String']['output']>;
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type VL_BuildingamenityPhotosArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Scalars['Int']['input']>;
    size?: InputMaybe<PropertyPhotoSize>;
};

export type VL_BuildinggoogleStaticMapSignedUrlArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    height?: InputMaybe<Scalars['Int']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    scale?: InputMaybe<Scalars['Int']['input']>;
    type?: InputMaybe<GoogleStaticMapType>;
    width?: InputMaybe<Scalars['Int']['input']>;
    zoom?: InputMaybe<Scalars['Int']['input']>;
};

export type VL_BuildinggoogleStreetViewImageSignedUrlArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    height?: InputMaybe<Scalars['Int']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    locationType?: InputMaybe<GoogleStreetviewLocationType>;
    width?: InputMaybe<Scalars['Int']['input']>;
};

export type VL_BuildinggoogleStreetViewMetadataSignedUrlArgs = {
    featureArea?: InputMaybe<Scalars['String']['input']>;
    key?: InputMaybe<Scalars['String']['input']>;
    locationType?: InputMaybe<GoogleStreetviewLocationType>;
};

export type VL_BuildingphotosArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
    from?: InputMaybe<Scalars['Int']['input']>;
    size?: InputMaybe<PropertyPhotoSize>;
};

export type VL_BuildingCard = {
    bdpLink?: Maybe<Scalars['String']['output']>;
    bedroomGroups?: Maybe<Array<Maybe<BedRoomGroup>>>;
    buildingAddress?: Maybe<Scalars['String']['output']>;
    buildingName?: Maybe<Scalars['String']['output']>;
    latitude?: Maybe<Scalars['Float']['output']>;
    /** @deprecated Use 'rules' field instead */
    listingMetadata?: Maybe<ListingMetadata>;
    longitude?: Maybe<Scalars['Float']['output']>;
    lotId?: Maybe<Scalars['ID']['output']>;
    maxPrice?: Maybe<Scalars['Int']['output']>;
    minBaths?: Maybe<Scalars['Float']['output']>;
    minBeds?: Maybe<Scalars['Int']['output']>;
    minLivingArea?: Maybe<Scalars['Int']['output']>;
    minPrice?: Maybe<Scalars['Int']['output']>;
    photo?: Maybe<Photo>;
    photoCount?: Maybe<Scalars['String']['output']>;
    providerListingId?: Maybe<Scalars['String']['output']>;
    recentlyUpdated?: Maybe<Scalars['Boolean']['output']>;
    rules?: Maybe<VL_PropertyResultRules>;
    showUpdateTime?: Maybe<Scalars['Boolean']['output']>;
    updateTimeLabel?: Maybe<Scalars['String']['output']>;
};

export type VL_BuildingFloorPlan = {
    amenityDetails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    availableFrom?: Maybe<Scalars['String']['output']>;
    availableFromDateStr?: Maybe<Scalars['String']['output']>;
    baths?: Maybe<Scalars['Float']['output']>;
    beds?: Maybe<Scalars['Int']['output']>;
    depositsAndFees?: Maybe<Scalars['Float']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    floorPlanUnitPhotos?: Maybe<Array<Maybe<Photo>>>;
    floorplanVRModel?: Maybe<BuildingVRModel>;
    hasApprovedThirdPartyVirtualTour?: Maybe<Scalars['Boolean']['output']>;
    leaseTerm?: Maybe<Scalars['String']['output']>;
    maloneId?: Maybe<Scalars['String']['output']>;
    maxPrice?: Maybe<Scalars['Int']['output']>;
    minPrice?: Maybe<Scalars['Int']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    photos?: Maybe<Array<Maybe<Photo>>>;
    sqft?: Maybe<Scalars['Int']['output']>;
    thirdPartyVirtualTour?: Maybe<ThirdPartyVirtualTour>;
    units?: Maybe<Array<Maybe<VL_Unit>>>;
    videos?: Maybe<Array<Maybe<FloorplanVideos>>>;
    vrModels?: Maybe<Array<Maybe<BuildingVRModel>>>;
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type VL_BuildingSummary = {
    address?: Maybe<BuildingAddress>;
    bestMatchZpid?: Maybe<Scalars['ID']['output']>;
    buildingPropertyRules?: Maybe<VL_PropertyResultRules>;
    buildingType?: Maybe<BuildingType>;
    canSaveBuilding?: Maybe<Scalars['Boolean']['output']>;
    hasSpecialOffers?: Maybe<Scalars['Boolean']['output']>;
    hasVRModel?: Maybe<Scalars['Boolean']['output']>;
    latitude?: Maybe<Scalars['Float']['output']>;
    longitude?: Maybe<Scalars['Float']['output']>;
    lotId?: Maybe<Scalars['ID']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    rentalUnitsSummary?: Maybe<UnitsSummary>;
    stateId?: Maybe<Scalars['Int']['output']>;
    thumbnailPhoto?: Maybe<BuildingSummaryPhoto>;
    url?: Maybe<Scalars['String']['output']>;
};

export type VL_Comps = {
    /** @deprecated Use 'compForSaleMlsHomes' field instead */
    BuildingDataT?: Maybe<Array<Maybe<VL_HomeCard>>>;
    /** @deprecated Use 'compForSaleNonMlsHomes' field instead */
    BuildingDataU?: Maybe<Array<Maybe<VL_HomeCard>>>;
    compBuildings?: Maybe<Array<Maybe<VL_BuildingCard>>>;
    compForSaleMlsHomes?: Maybe<Array<Maybe<VL_HomeCard>>>;
    compForSaleNonMlsHomes?: Maybe<Array<Maybe<VL_HomeCard>>>;
    compRecentlySoldHomes?: Maybe<Array<Maybe<VL_HomeCard>>>;
};

export type VL_HomeCard = {
    bathrooms?: Maybe<Scalars['Int']['output']>;
    bedrooms?: Maybe<Scalars['Int']['output']>;
    currency?: Maybe<Scalars['String']['output']>;
    displayIconType?: Maybe<Scalars['String']['output']>;
    hdpUrl?: Maybe<Scalars['String']['output']>;
    homeInfo?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use 'propertyRules' field instead */
    listingMetadata?: Maybe<ListingMetadata>;
    livingArea?: Maybe<Scalars['Int']['output']>;
    photo?: Maybe<Photo>;
    price?: Maybe<Scalars['Int']['output']>;
    propertyRules?: Maybe<VL_PropertyResultRules>;
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type VL_MapCardAttribution = {
    brokerNameIfRequired?: Maybe<Scalars['String']['output']>;
    mlsIdIfRequired?: Maybe<Scalars['String']['output']>;
    providerLogoIfRequired?: Maybe<Array<Maybe<VL_ProviderLogo>>>;
};

export type VL_PropertyResultRules = {
    agentNameIfRequired?: Maybe<Scalars['String']['output']>;
    agentPhoneIfRequired?: Maybe<PropertyResultRulesPhone>;
    brokerNameIfRequired?: Maybe<Scalars['String']['output']>;
    brokerPhoneIfRequired?: Maybe<PropertyResultRulesPhone>;
    builderNameIfRequired?: Maybe<Scalars['String']['output']>;
    canShowAddress?: Maybe<Scalars['Boolean']['output']>;
    canShowCroppedPhotos?: Maybe<Scalars['Boolean']['output']>;
    canShowNonIDXMedia?: Maybe<Scalars['Boolean']['output']>;
    canShowOnMap?: Maybe<Scalars['Boolean']['output']>;
    comminglingCategory?: Maybe<PropertyComminglingCategory>;
    justAgentNameIfRequired?: Maybe<Scalars['String']['output']>;
    mapCardAttribution?: Maybe<VL_MapCardAttribution>;
    mlsIdIfRequired?: Maybe<Scalars['String']['output']>;
    mlsNameIfRequired?: Maybe<Scalars['String']['output']>;
    mlsStatusIfRequired?: Maybe<Scalars['String']['output']>;
    mustDisplayLotSizeInAcres?: Maybe<Scalars['Boolean']['output']>;
    providerLogoIfRequired?: Maybe<Array<Maybe<VL_ProviderLogo>>>;
};

export type VL_ProviderLogo = {
    caption?: Maybe<Scalars['String']['output']>;
    photoType?: Maybe<Scalars['String']['output']>;
    streetviewMetadataUrl?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
};

export type VL_Region = {
    buildingSearchUrl?: Maybe<UrlObjectType>;
    name?: Maybe<Scalars['String']['output']>;
};

export type VL_ReviewsInfo = {
    averageBuildingManagerRating?: Maybe<Scalars['Float']['output']>;
    averageBuildingRating?: Maybe<Scalars['Float']['output']>;
    reviews?: Maybe<Array<Maybe<CombinedReview>>>;
};

export type VL_Unit = {
    availableFrom?: Maybe<Scalars['String']['output']>;
    availableFromDateStr?: Maybe<Scalars['String']['output']>;
    baths?: Maybe<Scalars['Float']['output']>;
    beds?: Maybe<Scalars['Int']['output']>;
    daysOn?: Maybe<Scalars['Int']['output']>;
    hasApprovedThirdPartyVirtualTour?: Maybe<Scalars['Boolean']['output']>;
    hdpUrl?: Maybe<Scalars['String']['output']>;
    homeStatus?: Maybe<Scalars['String']['output']>;
    housingConnector?: Maybe<Scalars['Boolean']['output']>;
    housingConnectorExclusive?: Maybe<Scalars['Boolean']['output']>;
    isRoomForRent?: Maybe<Scalars['Boolean']['output']>;
    isShowcaseListing?: Maybe<Scalars['Boolean']['output']>;
    isZillowOwned?: Maybe<Scalars['Boolean']['output']>;
    lastSoldAt?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use 'propertyRules' field instead */
    listingMetadata?: Maybe<ListingMetadata>;
    listingType?: Maybe<Scalars['String']['output']>;
    listing_sub_type?: Maybe<ListingSubtype>;
    photo?: Maybe<Photo>;
    price?: Maybe<Scalars['Int']['output']>;
    propertyRules?: Maybe<VL_PropertyResultRules>;
    propertyType?: Maybe<Scalars['String']['output']>;
    sqft?: Maybe<Scalars['Int']['output']>;
    thirdPartyVirtualTour?: Maybe<ThirdPartyVirtualTour>;
    unitNumber?: Maybe<Scalars['String']['output']>;
    unitVRModel?: Maybe<BuildingVRModel>;
    vrModel?: Maybe<BuildingVRModel>;
    zpid?: Maybe<Scalars['ID']['output']>;
};

export type VRModel = {
    source?: Maybe<Scalars['String']['output']>;
};

/** Checks if email and phone number are valid in seattle-rental-inlet */
export type ValidateRenterEmailAndPhoneNumber = {
    email?: Maybe<ValidationResult>;
    phone?: Maybe<ValidationResult>;
};

export type ValidationResult = {
    /** Reason field is invalid */
    reason?: Maybe<Scalars['String']['output']>;
    /** Whether field is valid */
    valid?: Maybe<Scalars['Boolean']['output']>;
};

export type Valuation = {
    /** @deprecated Harmonization paused */
    groupId?: Maybe<Scalars['String']['output']>;
    high?: Maybe<Scalars['Int']['output']>;
    highPercent?: Maybe<Scalars['Int']['output']>;
    low?: Maybe<Scalars['Int']['output']>;
    lowPercent?: Maybe<Scalars['Int']['output']>;
    /** @deprecated Harmonization paused */
    valuationId?: Maybe<Scalars['String']['output']>;
    valuationType?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['Int']['output']>;
};

export type VerifiedClaimedHome = {
    createTime?: Maybe<Scalars['String']['output']>;
    property?: Maybe<Property>;
    propertyClaimSourceType?: Maybe<PropertyClaimSourceType>;
    propertyClaimType?: Maybe<PropertyClaimType>;
    propertyClaimVerificationMethod?: Maybe<PropertyClaimVerificationMethod>;
    propertyId?: Maybe<Scalars['Int']['output']>;
    updateTime?: Maybe<Scalars['String']['output']>;
};

/** Details about a video */
export type Video = {
    /** The create date and time of the Video. Unix epoch timestamp. */
    createdAt?: Maybe<Scalars['DateTime']['output']>;
    postingClient?: Maybe<Scalars['String']['output']>;
    sourceVideoHeight?: Maybe<Scalars['Int']['output']>;
    sourceVideoWidth?: Maybe<Scalars['Int']['output']>;
    sources?: Maybe<Array<Maybe<VideoSource>>>;
    /** The status of the video (Public, Private, Processing, etc) */
    status?: Maybe<VideoStatusType>;
    videoDurationSeconds?: Maybe<Scalars['Int']['output']>;
    videoIdEncoded?: Maybe<Scalars['String']['output']>;
};

export type VideoMetaData = {
    captureDate?: Maybe<CaptureDate>;
    duration?: Maybe<Scalars['String']['output']>;
    videoId?: Maybe<Scalars['String']['output']>;
};

/** Details about a video source */
export type VideoSource = {
    /** The preset/codec used to transcode the video. */
    presetName?: Maybe<Scalars['String']['output']>;
    /** source URL */
    src?: Maybe<Scalars['String']['output']>;
    status?: Maybe<VideoStatusType>;
    /** Media type of the video source. Required by browsers in order to play video. */
    type?: Maybe<Scalars['String']['output']>;
};

/** Indicates status of the assets for this video source type. */
export type VideoStatusType = 'Deleted' | 'Draft' | 'Error' | 'Private' | 'Processing' | 'Public';

export type VideoUrl = {
    label?: Maybe<Scalars['String']['output']>;
    url?: Maybe<Scalars['String']['output']>;
};

export type ViewContentHomeDetailsEvent = UserEvent & {
    /** Events associated with the semantic tag: view_content:home_details */
    eventId: Scalars['ID']['output'];
    eventSource: StreamSource;
    eventTime: Scalars['GraphQLLong']['output'];
    /** This is the clickstream event type id */
    eventType: Scalars['String']['output'];
    propertyInfo?: Maybe<PropertyInfo>;
};

export type ViewContentRentalBuildingDetailsEvent = UserEvent & {
    /** Events associated with the semantic tag: view_content:rental_building_details */
    eventId: Scalars['ID']['output'];
    eventSource: StreamSource;
    eventTime: Scalars['GraphQLLong']['output'];
    /** This is the clickstream event type id */
    eventType: Scalars['String']['output'];
    rentalBuildingInfo?: Maybe<RentalBuildingInfo>;
};

export type ViewType =
    | 'City'
    | 'GolfCourse'
    | 'Mountain'
    | 'None'
    | 'Park'
    | 'Territorial'
    | 'Unknown'
    | 'Water'
    | 'Wooded';

/**
 * The currently authenticated user (via cookie).
 * The attributes of this object may include the name and contact information
 * of a user.
 *
 * This data is only accessible if the request includes an authentication cookie,
 * so the PII can only be retrieved if the client authenticates as the user
 * that owns the PII
 */
export type Viewer = {
    /** user consent for ZMA */
    ZMAConsent?: Maybe<Scalars['Boolean']['output']>;
    /** Cached conversation counts for current logged in user from satellite */
    cachedConversationCounts?: Maybe<CachedConversationCounts>;
    /** caseworker email and zuid for user with isLLPRenter role */
    caseworker?: Maybe<CaseworkerData>;
    confirmedClaimedHomes?: Maybe<Array<Maybe<ConfirmedClaimedHome>>>;
    /** Name meant for public display */
    displayName?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    /** Email encrypt with md5. */
    emailHash?: Maybe<Scalars['String']['output']>;
    /** The user has verified their email address */
    emailVerified: Scalars['Boolean']['output'];
    /** The type of external account used to sign in (facebook, apple, google, etc) */
    externalAccount?: Maybe<Array<Maybe<ExternalAuthData>>>;
    /** First name of the user. */
    firstName?: Maybe<Scalars['String']['output']>;
    /** Does the user have a password set for their account */
    hasPassword?: Maybe<Scalars['Boolean']['output']>;
    /**
     * List of recommended homes for logged in and anonymous users
     * @deprecated Deprecated in favour of the collections API. For new homeRecommendations cases see https://zillowgroup.atlassian.net/wiki/spaces/AT/pages/269942836/Onboarding+a+Consumer+to+the+Collections+API
     */
    homeRecommendation?: Maybe<HomeRecommendation>;
    isAdmin: Scalars['Boolean']['output'];
    /** Is the logged in user impersonating another user */
    isImpersonating?: Maybe<Scalars['Boolean']['output']>;
    /** Does the logged in user having role CS agent */
    isLoggedInUserCSAgent?: Maybe<Scalars['Boolean']['output']>;
    /** Is the logged in user an employee */
    isLoggedInUserEmployee?: Maybe<Scalars['Boolean']['output']>;
    /** Is the logged in user a zillow group employee */
    isLoggedInUserZillowGroupEmployee?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated TLP is enabled for all logged in users */
    isTourListPageEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** Last Name of the user. */
    lastName?: Maybe<Scalars['String']['output']>;
    /** @deprecated Superseded by multiFactorAuth */
    mfaEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** Information on Multi-Factor Authentication for the user */
    multiFactorAuth?: Maybe<mfaEnabledData>;
    myZillowPreferences?: Maybe<MyZillowPreferences>;
    /** First + Last, not checking for public display. */
    name?: Maybe<Scalars['String']['output']>;
    /** NC Self Tour Scheduled Appointment */
    ncSelfTourNextAppointment?: Maybe<NcSelfTourAppointment>;
    /** Number of active agent connections for user */
    numAgentConnections?: Maybe<Scalars['Int']['output']>;
    /**
     * The offer requests associated with the given account id
     * @deprecated ZO wind-down
     */
    offerRequests?: Maybe<Array<Maybe<OfferRequest>>>;
    /** User Data of current user */
    profile?: Maybe<UserData>;
    recentlyViewedHomes?: Maybe<Array<Maybe<RecentlyViewedHome>>>;
    relationships?: Maybe<Array<Maybe<Relationship>>>;
    /** User profile flag object to differentiate user type based on profile ID */
    roles?: Maybe<profile>;
    /** User saved comp list */
    savedCompList?: Maybe<CompListType>;
    savedHomes?: Maybe<Array<Maybe<SavedHome>>>;
    savedSearches?: Maybe<Array<Maybe<SavedSearch>>>;
    /** User-created, human-readable identifier for the user's account */
    screenName?: Maybe<Scalars['String']['output']>;
    serviceAgreements?: Maybe<ServiceAgreements>;
    tourAppointments?: Maybe<Array<TourAppointment>>;
    tourViews?: Maybe<ViewerTourViews>;
    userProfile?: Maybe<UserProfile>;
    verifiedClaimedHomes?: Maybe<Array<Maybe<VerifiedClaimedHome>>>;
    /** Encoded zillow user ID for the current user. */
    viewerId?: Maybe<Scalars['String']['output']>;
    /** Unencoded zillow user ID for the current user. Visible to admins only. */
    zuid?: Maybe<Scalars['Int']['output']>;
};

/**
 * The currently authenticated user (via cookie).
 * The attributes of this object may include the name and contact information
 * of a user.
 *
 * This data is only accessible if the request includes an authentication cookie,
 * so the PII can only be retrieved if the client authenticates as the user
 * that owns the PII
 */
export type ViewerhomeRecommendationArgs = {
    clientName: Scalars['String']['input'];
    excludeZpids?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
    maxRecs?: InputMaybe<Scalars['Int']['input']>;
    placement: PlacementOption;
    queryType: QueryTypeOption;
    zpid?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The currently authenticated user (via cookie).
 * The attributes of this object may include the name and contact information
 * of a user.
 *
 * This data is only accessible if the request includes an authentication cookie,
 * so the PII can only be retrieved if the client authenticates as the user
 * that owns the PII
 */
export type ViewerncSelfTourNextAppointmentArgs = {
    zpid?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * The currently authenticated user (via cookie).
 * The attributes of this object may include the name and contact information
 * of a user.
 *
 * This data is only accessible if the request includes an authentication cookie,
 * so the PII can only be retrieved if the client authenticates as the user
 * that owns the PII
 */
export type ViewerofferRequestsArgs = {
    isPermanentlyClosed?: InputMaybe<Scalars['Boolean']['input']>;
    limit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The currently authenticated user (via cookie).
 * The attributes of this object may include the name and contact information
 * of a user.
 *
 * This data is only accessible if the request includes an authentication cookie,
 * so the PII can only be retrieved if the client authenticates as the user
 * that owns the PII
 */
export type ViewerrecentlyViewedHomesArgs = {
    count?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The currently authenticated user (via cookie).
 * The attributes of this object may include the name and contact information
 * of a user.
 *
 * This data is only accessible if the request includes an authentication cookie,
 * so the PII can only be retrieved if the client authenticates as the user
 * that owns the PII
 */
export type ViewersavedCompListArgs = {
    zpid: Scalars['ID']['input'];
};

/**
 * The currently authenticated user (via cookie).
 * The attributes of this object may include the name and contact information
 * of a user.
 *
 * This data is only accessible if the request includes an authentication cookie,
 * so the PII can only be retrieved if the client authenticates as the user
 * that owns the PII
 */
export type ViewersavedHomesArgs = {
    allowedPropertyIdTypes?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The currently authenticated user (via cookie).
 * The attributes of this object may include the name and contact information
 * of a user.
 *
 * This data is only accessible if the request includes an authentication cookie,
 * so the PII can only be retrieved if the client authenticates as the user
 * that owns the PII
 */
export type ViewertourAppointmentsArgs = {
    filters?: InputMaybe<TourAppointmentFilterParameters>;
};

/**
 * The currently authenticated user (via cookie).
 * The attributes of this object may include the name and contact information
 * of a user.
 *
 * This data is only accessible if the request includes an authentication cookie,
 * so the PII can only be retrieved if the client authenticates as the user
 * that owns the PII
 */
export type ViewertourViewsArgs = {
    platform: TourViewPlatform;
};

export type ViewerRole = 'BUYER' | 'BUYER_AGENT' | 'OTHER';

export type ViewerTourViews = {
    tourList?: Maybe<TourListView>;
};

/** Values for whether task is past due or not */
export type VisualEscalation = 'NONE' | 'OVERDUE';

export type VoucherToRentCoverage = 'full' | 'partial';

export type WalkScoreResponse = {
    description?: Maybe<Scalars['String']['output']>;
    more_info_link?: Maybe<Scalars['String']['output']>;
    walkscore?: Maybe<Scalars['Int']['output']>;
    ws_link?: Maybe<Scalars['String']['output']>;
};

export type WhoHasSigned = {
    leaseId?: Maybe<Scalars['ID']['output']>;
    signedUsers?: Maybe<Array<Maybe<SignedUser>>>;
};

export type WorkingWithLenderStatus = 'NO' | 'UNSPECIFIED' | 'YES';

export type YesNoQuestion = FormQuestion & {
    inputName: Scalars['String']['output'];
    noTextLabel: Scalars['String']['output'];
    questionIcon: Scalars['String']['output'];
    questionOverlay?: Maybe<SubmitFlowOverlay>;
    questionText: Scalars['String']['output'];
    yesTextLabel: Scalars['String']['output'];
};

export type YourRental = {
    gdpProperty?: Maybe<Property>;
    propertyId?: Maybe<Scalars['String']['output']>;
};

export type YourRentalContact = {
    associatedVerticalDataId?: Maybe<Scalars['ID']['output']>;
    contactAction?: Maybe<RenterHubCta>;
    email?: Maybe<Scalars['String']['output']>;
    fullName?: Maybe<Scalars['String']['output']>;
    phone?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type YourRentalLease = {
    buttonAction?: Maybe<RenterHubCta>;
    dateText?: Maybe<Scalars['String']['output']>;
    leaseId?: Maybe<Scalars['ID']['output']>;
    listingAlias?: Maybe<Scalars['String']['output']>;
    signedUsersText?: Maybe<Scalars['String']['output']>;
    statusTag?: Maybe<RenterHubCardTag>;
    statusType?: Maybe<Scalars['String']['output']>;
};

export type YourRentalProperty = {
    address?: Maybe<YourRentalPropertyAddress>;
    conditionReportSection?: Maybe<YourRentalsConditionReportSectionData>;
    contactSection?: Maybe<YourRentalsContactSectionData>;
    leaseSection?: Maybe<YourRentalsLeaseSectionData>;
    listingAlias?: Maybe<Scalars['String']['output']>;
    paymentSection?: Maybe<YourRentalsPaymentSectionData>;
    propertyId?: Maybe<Scalars['String']['output']>;
};

export type YourRentalPropertyAddress = {
    city?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    streetAddress?: Maybe<Scalars['String']['output']>;
    zipcode?: Maybe<Scalars['String']['output']>;
};

export type YourRentals = {
    hasActiveYourRentals?: Maybe<Scalars['Boolean']['output']>;
    yourRentals?: Maybe<Array<Maybe<YourRental>>>;
};

export type YourRentalsConditionReportSectionData = {
    moveInReportCard?: Maybe<MoveInReportCard>;
};

export type YourRentalsContactSectionData = {
    contacts?: Maybe<Array<Maybe<YourRentalContact>>>;
    headingText?: Maybe<Scalars['String']['output']>;
};

export type YourRentalsLeaseSectionData = {
    defaultLeaseIndex?: Maybe<Scalars['Int']['output']>;
    headingText?: Maybe<Scalars['String']['output']>;
    leases?: Maybe<Array<Maybe<YourRentalLease>>>;
    /**
     * The type of upsell card to show
     *
     * Valid values are:
     * LEARN_ZILLOW_PAYMENT
     * CREDIT_REPORTING
     * LEASE_UPSELL
     */
    upsellCardType?: Maybe<Scalars['String']['output']>;
};

export type YourRentalsPageData = {
    defaultPropertyIndex?: Maybe<Scalars['Int']['output']>;
    yourRentalProperties?: Maybe<Array<Maybe<YourRentalProperty>>>;
};

export type YourRentalsPaymentSectionData = {
    alerts?: Maybe<Array<Maybe<PaymentAlertData>>>;
    hasUpcomingPaymentOrPaymentHistory?: Maybe<Scalars['Boolean']['output']>;
    headingText?: Maybe<Scalars['String']['output']>;
    notificationCards?: Maybe<Array<Maybe<PaymentNotificationCardData>>>;
    paymentListingAlias?: Maybe<Scalars['String']['output']>;
    primaryInformationCard?: Maybe<PaymentInformationCardData>;
    /**
     * The type of upsell card to show
     *
     * Valid values are:
     * LEARN_ZILLOW_PAYMENT
     * CREDIT_REPORTING
     * LEASE_UPSELL
     */
    upsellCardType?: Maybe<Scalars['String']['output']>;
};

/** Each role (e.g. agent, loan officer, co-shopper) can include either one empty card or potentially multiple team members cards for that role */
export type YourTeamCard = YourTeamEmptyCard | YourTeamMemberCard;

export type YourTeamEmptyCard = {
    backgroundColor?: Maybe<Scalars['String']['output']>;
    benefitsButton: HubStandardModuleButton;
    ctaInfo: HubStandardModuleButton;
    description: HubDynamicText;
    headerText: HubDynamicText;
    imageUrl?: Maybe<Scalars['String']['output']>;
    infoBullets?: Maybe<HubInfoBulletsList>;
    teamMemberType: TeamMemberType;
};

export type YourTeamEmptyCardimageUrlArgs = {
    format?: InputMaybe<ImageFileFormat>;
};

export type YourTeamMemberCard = {
    contactInfo: Array<TeamMemberContactMethod>;
    fullName: HubDynamicText;
    infoBullets?: Maybe<HubInfoBulletsList>;
    infoList: Array<TeamMemberInfo>;
    metadata: TeamMemberMetadata;
    profileImageUrl?: Maybe<Scalars['String']['output']>;
    profileLinkUrl?: Maybe<HubNavAction>;
    reviews?: Maybe<HubReviewsDisplay>;
    tag: HubTag;
};

export type YourTeamMemberCardprofileImageUrlArgs = {
    format?: InputMaybe<ImageFileFormat>;
};

export type YourTeamModule = {
    ctaButtons: Array<HubStandardModuleButton>;
    description?: Maybe<Scalars['String']['output']>;
    key: Scalars['String']['output'];
    showImage: Scalars['Boolean']['output'];
    teamMemberModules: Array<YourTeamCard>;
    title: Scalars['String']['output'];
};

/** external entity: ZGProperty, resolvable: false */
export type ZGProperty = {
    odpPropertyModels?: Maybe<OdpPropertyModels>;
    zpid?: Maybe<Scalars['String']['output']>;
};

export type ZHLAppDataSourceInput = 'Blend' | 'PreApproval' | 'Prequal';

/** Supported auth assurance levels */
export type ZHLAuthAssuranceLevel = 'AAL0' | 'AAL1' | 'AAL2' | 'AAL3';

export type ZHLBorrower = {
    assets?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
    attributes?: Maybe<ZHLUserAttributes>;
    /** The borrower pair. */
    borrowerPair: Array<Maybe<Scalars['ID']['output']>>;
    /**
     * For primary borrower on a loan, returns the whole borrower group.
     * For a borrower in a pair, returns the pair.
     * For a single borrower, returns the single borrowers and the borrower itself.
     */
    coborrowers?: Maybe<Array<Array<Maybe<Scalars['ID']['output']>>>>;
    creditConsent?: Maybe<ZHLCreditConsent>;
    employments?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
    id: Scalars['ID']['output'];
    loanId: Scalars['ID']['output'];
    otherIncomes?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
    zuid?: Maybe<Scalars['ID']['output']>;
};

export type ZHLBorrowerABADInfoInput = {
    seen: Scalars['Boolean']['input'];
    timestamp: Scalars['String']['input'];
    version: Scalars['String']['input'];
};

export type ZHLBorrowerAsset = {
    id: Scalars['ID']['output'];
    tridTriggered?: Maybe<Scalars['Boolean']['output']>;
};

export type ZHLBorrowerAssetAttributesInput = {
    accountNumber?: InputMaybe<Scalars['String']['input']>;
    dataSource?: InputMaybe<ZHLAppDataSourceInput>;
    financialInstitution?: InputMaybe<Scalars['String']['input']>;
    marketValue: Scalars['Int']['input'];
    otherTypeLiquid?: InputMaybe<Scalars['String']['input']>;
    otherTypeSpecified?: InputMaybe<Scalars['String']['input']>;
    type: ZHLBorrowerAssetTypeInput;
    verificationStatus?: InputMaybe<ZHLBorrowerVerificationStatusInput>;
};

export type ZHLBorrowerAssetTypeInput =
    | 'Bonds'
    | 'BorrowerPaidFeesCredit'
    | 'BridgeLoanProceeds'
    | 'CashValueOfLifeInsurance'
    | 'CertificateOfDeposit'
    | 'CheckingAccount'
    | 'EarnestMoneyCredit'
    | 'EmployerAssistanceCredit'
    | 'IndividualDevelopmentAccount'
    | 'LotEquityCredit'
    | 'MoneyMarketAccount'
    | 'MutualFund'
    | 'Other'
    | 'ProceedsFromSaleOfNonRealEstateAsset'
    | 'ProceedsFromSaleOfRealEstate'
    | 'RelocationFundsCredit'
    | 'RentCredit'
    | 'RetirementAccount'
    | 'SavingsAccount'
    | 'SecuredBorrowedFunds'
    | 'StockOptions'
    | 'Stocks'
    | 'SweatEquityCredit'
    | 'TradeEquityCredit'
    | 'TrustAccount'
    | 'UnsecuredBorrowedFunds';

export type ZHLBorrowerAttributes = {
    bankruptcy?: InputMaybe<ZHLBorrowerBankruptcy>;
    birthDate?: InputMaybe<Scalars['String']['input']>;
    cellPhone?: InputMaybe<Scalars['String']['input']>;
    citizenship?: InputMaybe<ZHLBorrowerCitizenshipType>;
    conveyedTitleInLieuOfForeclosure?: InputMaybe<Scalars['Boolean']['input']>;
    delinquent?: InputMaybe<Scalars['Boolean']['input']>;
    dependents?: InputMaybe<Array<InputMaybe<ZHLBorrowerDependent>>>;
    email?: InputMaybe<Scalars['String']['input']>;
    firstTimeBuyer?: InputMaybe<Scalars['Boolean']['input']>;
    foreclosure?: InputMaybe<Scalars['Boolean']['input']>;
    hasBankruptcy?: InputMaybe<Scalars['Boolean']['input']>;
    homePhone?: InputMaybe<Scalars['String']['input']>;
    intentToOccupy?: InputMaybe<Scalars['Boolean']['input']>;
    mailingAddress?: InputMaybe<ZHLBorrowerMailingAddress>;
    martialStatus?: InputMaybe<ZHLBorrowerMaritalStatus>;
    militaryService?: InputMaybe<ZHLBorrowerMilitaryService>;
    names?: InputMaybe<Array<InputMaybe<ZHLBorrowerAttributesName>>>;
    outstandingJudgments?: InputMaybe<Scalars['Boolean']['input']>;
    partyToLawsuit?: InputMaybe<Scalars['Boolean']['input']>;
    recentOwnershipInterest?: InputMaybe<ZHLBorrowerRecentOwnershipInterest>;
    residences?: InputMaybe<Array<InputMaybe<ZHLBorrowerResidentialAddress>>>;
    shortSale?: InputMaybe<Scalars['Boolean']['input']>;
    specialRelationshipWithSeller?: InputMaybe<Scalars['Boolean']['input']>;
    subjectToLien?: InputMaybe<Scalars['Boolean']['input']>;
    taxpayerID?: InputMaybe<Scalars['ID']['input']>;
    undisclosedCredit?: InputMaybe<Scalars['Boolean']['input']>;
    undisclosedFundsAmount?: InputMaybe<Scalars['Int']['input']>;
    undisclosedGuarantor?: InputMaybe<Scalars['Boolean']['input']>;
    undisclosedMortgage?: InputMaybe<Scalars['Boolean']['input']>;
    unmarriedAddendum?: InputMaybe<ZHLBorrowerUnmarriedAddendum>;
    workPhoneAndExtension?: InputMaybe<ZHLBorrowerWorkPhoneAndExtension>;
};

export type ZHLBorrowerAttributesName = {
    first?: InputMaybe<Scalars['String']['input']>;
    last?: InputMaybe<Scalars['String']['input']>;
    middle?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLBorrowerBankruptcy = {
    bankruptcy?: InputMaybe<ZHLBorrowerBankruptcyChapters>;
    na?: InputMaybe<NA>;
};

export type ZHLBorrowerBankruptcyChapters = {
    chapter7?: InputMaybe<Scalars['Boolean']['input']>;
    chapter11?: InputMaybe<Scalars['Boolean']['input']>;
    chapter12?: InputMaybe<Scalars['Boolean']['input']>;
    chapter13?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ZHLBorrowerCitizenshipType =
    | 'NonPermanentResidentAlien'
    | 'PermanentResidentAlien'
    | 'USCitizen';

export type ZHLBorrowerConnectWithZGMIConsentInput = {
    abadInfo?: InputMaybe<ZHLBorrowerABADInfoInput>;
    id: Scalars['ID']['input'];
};

export type ZHLBorrowerContactLongFormLenderInput = {
    context?: InputMaybe<Scalars['String']['input']>;
    creditScore?: InputMaybe<ZHLBorrowerCreditScore>;
    details?: InputMaybe<ZHLLongFormBorrowerDetails>;
    emailAddress?: InputMaybe<Scalars['String']['input']>;
    firstName?: InputMaybe<Scalars['String']['input']>;
    hasBankruptcy?: InputMaybe<Scalars['Boolean']['input']>;
    hasForeclosure?: InputMaybe<Scalars['Boolean']['input']>;
    journeyStage?: InputMaybe<ZHLBorrowerJourneyStage>;
    lastName?: InputMaybe<Scalars['String']['input']>;
    location?: InputMaybe<ZHLBorrowerZipCode>;
    partnerId: Scalars['ID']['input'];
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
    propertyType?: InputMaybe<ZHLBorrowerPropertyType>;
    propertyUse?: InputMaybe<ZHLBorrowerPropertyUse>;
    propertyValue?: InputMaybe<Scalars['Int']['input']>;
    userSessionId: Scalars['ID']['input'];
    vaEligible?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ZHLBorrowerCreditScore = {
    creditScoreHigh?: InputMaybe<Scalars['Int']['input']>;
    creditScoreLow?: InputMaybe<Scalars['Int']['input']>;
};

export type ZHLBorrowerDependent = {
    age: Scalars['Int']['input'];
};

export type ZHLBorrowerEmployment = {
    id: Scalars['ID']['output'];
    tridTriggered?: Maybe<Scalars['Boolean']['output']>;
};

export type ZHLBorrowerEmploymentAttributesInput = {
    address?: InputMaybe<ZHLMailingAddressInput>;
    dataSource?: InputMaybe<ZHLAppDataSourceInput>;
    employmentRecordType?: InputMaybe<ZHLBorrowerEmploymentRecordInput>;
    endDate?: InputMaybe<Scalars['Date']['input']>;
    foreign?: InputMaybe<Scalars['Boolean']['input']>;
    income?: InputMaybe<ZHLBorrowerEmploymentIncomeInput>;
    monthsInLineOfWork?: InputMaybe<Scalars['Int']['input']>;
    name?: InputMaybe<Scalars['String']['input']>;
    ownershipShare?: InputMaybe<ZHLBorrowerEmploymentOwnershipShareInput>;
    phone?: InputMaybe<Scalars['String']['input']>;
    position?: InputMaybe<Scalars['String']['input']>;
    seasonal?: InputMaybe<Scalars['Boolean']['input']>;
    selfEmployed?: InputMaybe<Scalars['Boolean']['input']>;
    specialBorrowerEmployerRelationship?: InputMaybe<Scalars['Boolean']['input']>;
    startDate?: InputMaybe<Scalars['Date']['input']>;
    verificationStatus?: InputMaybe<ZHLBorrowerVerificationStatusInput>;
};

export type ZHLBorrowerEmploymentIncomeDetailsInput = {
    amount?: InputMaybe<Scalars['Int']['input']>;
    frequency?: InputMaybe<ZHLBorrowerPayFrequencyInput>;
};

export type ZHLBorrowerEmploymentIncomeInput = {
    amount?: InputMaybe<Scalars['Int']['input']>;
    base?: InputMaybe<ZHLBorrowerEmploymentIncomeDetailsInput>;
    bonus?: InputMaybe<ZHLBorrowerEmploymentIncomeDetailsInput>;
    commission?: InputMaybe<ZHLBorrowerEmploymentIncomeDetailsInput>;
    frequency?: InputMaybe<ZHLBorrowerPayFrequencyInput>;
    militaryEntitlements?: InputMaybe<ZHLBorrowerEmploymentIncomeDetailsInput>;
    other?: InputMaybe<ZHLBorrowerEmploymentIncomeDetailsInput>;
    overtime?: InputMaybe<ZHLBorrowerEmploymentIncomeDetailsInput>;
};

export type ZHLBorrowerEmploymentOwnershipShareInput = 'AtLeast25Percent' | 'Under25Percent';

export type ZHLBorrowerEmploymentRecordInput = 'Education' | 'Employment';

export type ZHLBorrowerGrantSoftCreditConsentInput = {
    id: Scalars['ID']['input'];
    loanID: Scalars['ID']['input'];
    method: ZHLCreditConsentMethod;
};

export type ZHLBorrowerHandleZGMIConnectInput = {
    connectWithZGMIConsent: ZHLBorrowerConnectWithZGMIConsentInput;
    contactLongFormLender: ZHLBorrowerContactLongFormLenderInput;
    loanID: Scalars['ID']['input'];
};

export type ZHLBorrowerIncomeSourceInput =
    | 'Alimony'
    | 'AutoAllowance'
    | 'Boarder'
    | 'CapitalGains'
    | 'ChildSupport'
    | 'Disability'
    | 'FosterCare'
    | 'Housing'
    | 'InterestAndDividends'
    | 'MortgageCreditCertificate'
    | 'MortgageDifferentialPayments'
    | 'NotesReceivable'
    | 'Other'
    | 'PublicAssistance'
    | 'Retirement'
    | 'Royalties'
    | 'SeparateMaintenance'
    | 'SocialSecurity'
    | 'Trust'
    | 'Unemployment'
    | 'VACompensation';

export type ZHLBorrowerJourneyStage =
    | 'EstimatedAffordability'
    | 'LookingAtListings'
    | 'MakingOffer'
    | 'MakingOfferOrUnderContract'
    | 'PreapprovedOrPrequalified'
    | 'TouringHomes'
    | 'UnderContract';

export type ZHLBorrowerMailingAddress = {
    city: Scalars['String']['input'];
    code?: InputMaybe<Scalars['String']['input']>;
    country?: InputMaybe<Scalars['String']['input']>;
    street: Scalars['String']['input'];
    subdivision?: InputMaybe<Scalars['String']['input']>;
    unit?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLBorrowerMaritalStatus = 'Married' | 'Separated' | 'Unmarried';

export type ZHLBorrowerMilitaryService = {
    militaryService?: InputMaybe<ZHLBorrowerMilitaryServiceDeclarations>;
    na?: InputMaybe<NA>;
};

export type ZHLBorrowerMilitaryServiceDeclarations = {
    activeDutyExpiration?: InputMaybe<Scalars['String']['input']>;
    completed?: InputMaybe<Scalars['Boolean']['input']>;
    onlyNonActivatedReserve?: InputMaybe<Scalars['Boolean']['input']>;
    survivingSpouse?: InputMaybe<Scalars['Boolean']['input']>;
    vaEligible?: InputMaybe<Scalars['Boolean']['input']>;
    vaEntitlementAmount?: InputMaybe<Scalars['Int']['input']>;
    vaFederalTaxAmount?: InputMaybe<Scalars['Int']['input']>;
    vaFirstTimeUse?: InputMaybe<Scalars['Boolean']['input']>;
    vaFundingFeeExemption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ZHLBorrowerOfframpReasonPrequalify =
    | 'Bankruptcy'
    | 'Citizenship'
    | 'Credit'
    | 'DUPOS'
    | 'DownPayment'
    | 'FICO'
    | 'Foreclosure'
    | 'Jumbo'
    | 'LoanAmount'
    | 'Location'
    | 'Pricing'
    | 'PropertyType'
    | 'VAEligible';

export type ZHLBorrowerOfframpType = 'Hard' | 'Soft';

export type ZHLBorrowerOtherIncome = {
    id: Scalars['ID']['output'];
    tridTriggered?: Maybe<Scalars['Boolean']['output']>;
};

export type ZHLBorrowerOtherIncomeAttributesInput = {
    dataSource?: InputMaybe<ZHLAppDataSourceInput>;
    endDate?: InputMaybe<Scalars['Date']['input']>;
    income: ZHLBorrowerOtherIncomeFrequencyInput;
    otherSourceSpecified?: InputMaybe<Scalars['String']['input']>;
    source: ZHLBorrowerIncomeSourceInput;
};

export type ZHLBorrowerOtherIncomeFrequencyInput = {
    amount: Scalars['Int']['input'];
    description?: InputMaybe<Scalars['String']['input']>;
    frequency: ZHLBorrowerPayFrequencyInput;
};

export type ZHLBorrowerOwnershipType = 'JointWithOther' | 'JointWithSpouse' | 'SoleOwner';

export type ZHLBorrowerPayFrequencyInput = 'Annual' | 'Monthly';

export type ZHLBorrowerPropertyType =
    | 'Condo'
    | 'CondoFiveOrMoreStories'
    | 'CondoFourOrFewerStories'
    | 'Cooperative'
    | 'Leasehold'
    | 'MobileOrManufactured'
    | 'Modular'
    | 'SingleFamilyHome'
    | 'TownHouse';

export type ZHLBorrowerPropertyUse = 'InvestmentOrRental' | 'Primary' | 'SecondaryOrVacation';

export type ZHLBorrowerPurchaseDetails = {
    downPayment?: InputMaybe<Scalars['Int']['input']>;
    firstTimeBuyer?: InputMaybe<Scalars['Boolean']['input']>;
    hasAgent?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ZHLBorrowerRecentOwnershipInterest = {
    ZHLBorrowerrecentOwnershipInterest?: InputMaybe<ZHLBorrowerRecentOwnershipInterestDeclarations>;
    na?: InputMaybe<NA>;
};

export type ZHLBorrowerRecentOwnershipInterestDeclarations = {
    fhaSecondaryResidence?: InputMaybe<Scalars['Boolean']['input']>;
    ownershipType: ZHLBorrowerOwnershipType;
    propertyUse: ZHLPropertyUse;
};

export type ZHLBorrowerResidentialAddress = {
    address: ZHLBorrowerMailingAddress;
    basis?: InputMaybe<Scalars['String']['input']>;
    current: Scalars['Boolean']['input'];
    endDate?: InputMaybe<Scalars['String']['input']>;
    monthlyRent?: InputMaybe<Scalars['Int']['input']>;
    startDate?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLBorrowerSenderInput = {
    firstName: Scalars['String']['input'];
    lastName: Scalars['String']['input'];
};

export type ZHLBorrowerUnmarriedAddendum = {
    na?: InputMaybe<NA>;
    relationshipType?: InputMaybe<ZHLBorrowerUnmarriedAddendumRelationshipType>;
    relationshipTypeSpecified?: InputMaybe<Scalars['String']['input']>;
    state: Scalars['String']['input'];
    unmarriedAddendum?: InputMaybe<ZHLBorrowerUnmarriedAddendum>;
};

export type ZHLBorrowerUnmarriedAddendumRelationshipType =
    | 'CivilUnion'
    | 'DomesticPartnership'
    | 'Other'
    | 'RegisteredReciprocalBeneficiaryRelationship';

export type ZHLBorrowerVerificationStatusInput = 'DigitallySourced' | 'Unknown';

export type ZHLBorrowerWorkPhoneAndExtension = {
    extension?: InputMaybe<Scalars['String']['input']>;
    phone: Scalars['String']['input'];
};

export type ZHLBorrowerZipCode = {
    zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Interface to support UI buttons */
export type ZHLButton = {
    navAction: ZHLNavAction;
};

/** Fetches UI footer with a button and description */
export type ZHLButtonFooter = {
    ctaButton: ZHLStandardButton;
    footer: Scalars['String']['output'];
};

/** Supported Button Styles - Maps to Constellation button types */
export type ZHLButtonStyle = 'CAUTION' | 'PRIMARY' | 'SECONDARY' | 'TERTIARY' | 'TEXT_ONLY';

/** Navigation action to render detail view */
export type ZHLBuyingPowerDetailNavAction = ZHLNavAction & {
    analyticsTag?: Maybe<Scalars['String']['output']>;
};

/** Navigation action to render input collection view */
export type ZHLBuyingPowerInputCollectionNavAction = ZHLNavAction & {
    analyticsTag?: Maybe<Scalars['String']['output']>;
};

export type ZHLBuyingPowerSaveAndDetailNavAction = ZHLNavAction & {
    analyticsTag?: Maybe<Scalars['String']['output']>;
};

/** Navigation action for sign in and save */
export type ZHLBuyingPowerSaveNavAction = ZHLNavAction & {
    analyticsTag?: Maybe<Scalars['String']['output']>;
};

export type ZHLConstructionMethodType = 'Manufactured' | 'Modular' | 'SiteBuilt';

export type ZHLCreateAutomatedTasksPayload = {
    taskIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type ZHLCreatePlaidLinkPayload = {
    hostedLinkUrl?: Maybe<Scalars['String']['output']>;
    linkToken?: Maybe<Scalars['String']['output']>;
};

export type ZHLCreateTaskInput = {
    borrowerId: Scalars['ID']['input'];
    lfsLoanId: Scalars['String']['input'];
    taskComments?: InputMaybe<Array<InputMaybe<ZHLTaskCommentInput>>>;
    taskDescription?: InputMaybe<Scalars['String']['input']>;
    taskMetaData?: InputMaybe<Array<InputMaybe<ZHLTaskMetaDataInput>>>;
    taskName: Scalars['String']['input'];
    taskStatus: ZHLTaskStatus;
    taskTemplateId: Scalars['ID']['input'];
};

export type ZHLCreateTaskPayload = {
    id: Scalars['ID']['output'];
};

export type ZHLCreateTasksForLFSRecordInput = {
    lfsLoanId: Scalars['ID']['input'];
    lfsMetaData: ZHLLfsMetaDataInput;
    taskTrigger: ZHLTaskTrigger;
};

export type ZHLCreateTasksForLFSRecordPayload = {
    taskIds?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type ZHLCreditConsent = {
    method?: Maybe<ZHLCreditConsentMethod>;
};

export type ZHLCreditConsentMethod = 'Verbal' | 'Website';

export type ZHLDashboardActivationToken = {
    expirationUtc: Scalars['String']['output'];
    token: Scalars['String']['output'];
};

export type ZHLDashboardActivationTokenGenerationStatus = 'GENERATED' | 'USER_PREVIOUSLY_ACTIVATED';

export type ZHLDashboardErrorExtension = {
    errorCode?: Maybe<Scalars['Int']['output']>;
    errorMsg?: Maybe<Scalars['String']['output']>;
    errorType?: Maybe<Scalars['String']['output']>;
    statusText?: Maybe<Scalars['String']['output']>;
    typename?: Maybe<Scalars['String']['output']>;
};

export type ZHLDashboardGenerateActivationTokenResult = {
    activationToken?: Maybe<ZHLDashboardActivationToken>;
    activationUrl?: Maybe<Scalars['String']['output']>;
    tokenGenerationStatus: ZHLDashboardActivationTokenGenerationStatus;
};

export type ZHLDashboardUserActivationResult = {
    dashboardUrl?: Maybe<Scalars['String']['output']>;
    status: ZHLDashboardUserActivationStatus;
};

export type ZHLDashboardUserActivationStatus = 'ACTIVATED' | 'FAILED';

/** Document in a loan. Backed by zDocs to provide viewing & signing experience. */
export type ZHLDocument = {
    _id: Scalars['ID']['output'];
    createdBy?: Maybe<Scalars['String']['output']>;
    createdDate?: Maybe<Scalars['String']['output']>;
    documentId: Scalars['ID']['output'];
    /** @deprecated(reason: "Use documentId instead") while "_id" is a unique identifier for caching purpose only, will change "id" to equal "_id" in the future */
    id: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    sortKey?: Maybe<Scalars['ID']['output']>;
    /** status of the document, there will be only one document that is not inactive with the same id */
    status?: Maybe<ZHLDocumentStatus>;
    type?: Maybe<DocumentType>;
    uploadURL?: Maybe<Scalars['String']['output']>;
    viewingURL?: Maybe<Scalars['String']['output']>;
};

export type ZHLDocumentMetadata = {
    documentURL?: Maybe<Scalars['String']['output']>;
    downloadURL?: Maybe<Scalars['String']['output']>;
};

export type ZHLDocumentPreApprovalMetaData = {
    expiryDate?: Maybe<Scalars['Date']['output']>;
    issueDate: Scalars['Date']['output'];
    loanAmount: Scalars['String']['output'];
};

export type ZHLDocumentRequest = {
    assetName?: Maybe<Scalars['String']['output']>;
    assetType?: Maybe<Scalars['String']['output']>;
    asssetId?: Maybe<Scalars['ID']['output']>;
    borrowerId: Scalars['ID']['output'];
    comments?: Maybe<Array<Maybe<ZHLDocumentRequestComment>>>;
    createdUTC?: Maybe<Scalars['String']['output']>;
    description?: Maybe<Scalars['String']['output']>;
    documents?: Maybe<Array<Maybe<ZHLDocumentRequestDocument>>>;
    id: Scalars['ID']['output'];
    loanId: Scalars['ID']['output'];
    status?: Maybe<ZHLDocumentRequestStatus>;
    title?: Maybe<Scalars['String']['output']>;
};

export type ZHLDocumentRequestComment = {
    audienceRole?: Maybe<ZHLDocumentRequestParticipantRole>;
    content?: Maybe<Scalars['String']['output']>;
    createdBy?: Maybe<Scalars['String']['output']>;
    createdUTC?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
};

export type ZHLDocumentRequestCommentInput = {
    audienceRole?: InputMaybe<ZHLDocumentRequestParticipantRole>;
    content?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLDocumentRequestDocument = {
    createdBy?: Maybe<Scalars['String']['output']>;
    createdUTC?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    loanId: Scalars['ID']['output'];
    name?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
    urls?: Maybe<ZHLDocumentRequestDocumentUrl>;
};

export type ZHLDocumentRequestDocumentUrl = {
    downloadUrl?: Maybe<Scalars['String']['output']>;
    embeddedUrl?: Maybe<Scalars['String']['output']>;
};

export type ZHLDocumentRequestParticipantRole =
    | 'borrower'
    | 'loanOfficer'
    | 'loanOfficerManager'
    | 'processor'
    | 'processorManager'
    | 'underwriter'
    | 'underwriterManager'
    | 'zhlEmployee';

export type ZHLDocumentRequestStatus =
    | 'approved'
    | 'new'
    | 'published'
    | 'rejected'
    | 'submitted'
    | 'unassigned'
    | 'unknown';

export type ZHLDocumentStatus =
    | 'DOCUMENT_STATUS_DELETED'
    | 'DOCUMENT_STATUS_INACTIVE'
    | 'DOCUMENT_STATUS_READY'
    | 'DOCUMENT_STATUS_SIGNED'
    | 'DOCUMENT_STATUS_UNSPECIFIED'
    | 'DOCUMENT_STATUS_UPLOADED'
    | 'DOCUMENT_STATUS_VIEWED';

/** Error Message Styles */
export type ZHLErrorMessageStyle = 'ERROR' | 'INFO';

export type ZHLFontColorAttributes = IZHLTextAttributes & {
    endIndex: Scalars['Int']['output'];
    /** Using indicies to tell which part of the text should be colored */
    fontColor: ZHLFontColors;
    startIndex: Scalars['Int']['output'];
};

/** This maps to Constellation Colors https://constellation.zillowgroup.com/platforms/web/tokens/color */
export type ZHLFontColors =
    | 'BRAND'
    | 'BRAND_SECONDARY'
    | 'TEXT_DARK'
    | 'TEXT_LIGHT'
    | 'TEXT_MEDIUM'
    | 'TEXT_WHITE';

/** A link with a CTA and an Auth Assurance Level */
export type ZHLHyperLink = {
    /** Analytics tag associated with the hyperlink */
    analyticsTag?: Maybe<Scalars['String']['output']>;
    /** Auth level for the hyperlink */
    authAssuranceLevel: ZHLAuthAssuranceLevel;
    ctaUrl: Scalars['String']['output'];
    text: Scalars['String']['output'];
};

export type ZHLIcon = 'MAIL' | 'MESSAGE' | 'PHONE';

export type ZHLIconType = 'INFO';

export type ZHLLFSMetaData = {
    id?: Maybe<Scalars['ID']['output']>;
    lfsRecordSource?: Maybe<ZHLLfsRecordSource>;
    lfsRecordSubSource?: Maybe<ZHLLfsRecordSubSource>;
};

export type ZHLLead = {
    appraisalOrdered?: Maybe<Scalars['Boolean']['output']>;
    borrowers: Array<Borrower>;
    id: Scalars['ID']['output'];
    lastModifiedDate?: Maybe<Scalars['String']['output']>;
    leadStatus?: Maybe<LeadStatus>;
    loanFileServiceId?: Maybe<Scalars['String']['output']>;
    loanOfficerInfo?: Maybe<LoanOfficerInfo>;
    nextActivityDate?: Maybe<Scalars['String']['output']>;
    nextActivitySubject?: Maybe<Scalars['String']['output']>;
    preApprovalDate?: Maybe<Scalars['String']['output']>;
    preQualifiedDate?: Maybe<Scalars['String']['output']>;
    propertyAddress?: Maybe<PropertyAddress>;
};

export type ZHLLeadAbadInfo = {
    seen?: InputMaybe<Scalars['Boolean']['input']>;
    timestamp?: InputMaybe<Scalars['String']['input']>;
    version?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLLeadBorrower = {
    address?: InputMaybe<ZHLMailingAddressInput>;
    emailAddress: Scalars['String']['input'];
    firstName: Scalars['String']['input'];
    lastName: Scalars['String']['input'];
    phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLLeadCitizenshipType =
    | 'NonPermanentResidentAlien'
    | 'Other'
    | 'PermanentResidentAlien'
    | 'USCitizen';

export type ZHLLeadJourneyStage =
    | 'LookingAtListings'
    | 'MakingOffer'
    | 'TouringHomes'
    | 'UnderContract';

export type ZHLLeadLoanPurpose = 'Construction' | 'HELOC' | 'HomeEquity' | 'Purchase' | 'Refinance';

export type ZHLLeadLsh = {
    channel?: InputMaybe<Scalars['String']['input']>;
    source?: InputMaybe<Scalars['String']['input']>;
    type?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLLeadMarketingInfo = {
    utmCampaign?: InputMaybe<Scalars['String']['input']>;
    utmContent?: InputMaybe<Scalars['String']['input']>;
    utmMedium?: InputMaybe<Scalars['String']['input']>;
    utmSource?: InputMaybe<Scalars['String']['input']>;
    utmTerm?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLLeadPropertyAddress = {
    addressCity?: InputMaybe<Scalars['String']['input']>;
    addressCounty?: InputMaybe<Scalars['String']['input']>;
    addressCountyFIPS?: InputMaybe<Scalars['String']['input']>;
    addressState?: InputMaybe<State>;
    addressZIP?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLLeadSummary = {
    id: Scalars['ID']['output'];
    leadState?: Maybe<Scalars['String']['output']>;
    propertyValue?: Maybe<Scalars['Float']['output']>;
};

export type ZHLLfsMetaDataInput = {
    id?: InputMaybe<Scalars['ID']['input']>;
    lfsRecordSource?: InputMaybe<ZHLLfsRecordSource>;
    lfsRecordSubSource?: InputMaybe<ZHLLfsRecordSubSource>;
};

export type ZHLLfsRecordSource =
    | 'LFS_RECORD_SOURCE_ASSET'
    | 'LFS_RECORD_SOURCE_BORROWER'
    | 'LFS_RECORD_SOURCE_EMPLOYMENT'
    | 'LFS_RECORD_SOURCE_GIFT'
    | 'LFS_RECORD_SOURCE_OTHER_INCOME'
    | 'LFS_RECORD_SOURCE_REAL_ESTATE'
    | 'LFS_RECORD_SOURCE_UNSPECIFIED';

export type ZHLLfsRecordSubSource =
    | 'LFS_RECORD_SUB_SOURCE_CITIZENSHIP'
    | 'LFS_RECORD_SUB_SOURCE_UNSPECIFIED';

export type ZHLLoan = {
    attributes?: Maybe<ZHLLoanAttributes>;
    /** This returns mock data.  Will be implemented soon. */
    blendApplicationStatus?: Maybe<BlendApplicationStatus>;
    borrowers?: Maybe<Array<ZHLBorrower>>;
    ctaURL?: Maybe<Scalars['String']['output']>;
    digitalExperience?: Maybe<ZHLPreApprovalDigitalExperience>;
    /** Documents associated with the loan. Supports filtering by type or ID */
    documents?: Maybe<Array<Maybe<ZHLDocument>>>;
    id: Scalars['ID']['output'];
    lead?: Maybe<ZHLLeadSummary>;
    loanNumber?: Maybe<Scalars['String']['output']>;
    loanOfficer?: Maybe<ZHLLoanOfficer>;
    loanProcessor?: Maybe<ZHLLoanProcessor>;
    /** This returns mock data.  Will be implemented soon. */
    offerAccepted?: Maybe<Scalars['Boolean']['output']>;
    participants?: Maybe<Array<Maybe<ZHLParticipant>>>;
    /** This returns current pre-approval letter. */
    preApprovalLetterURL?: Maybe<ZHLDocumentMetadata>;
    /** This returns the pre approval document download and viewing URL. It will also return all of the data associated with that document if available */
    preApprovalLetters?: Maybe<Array<Maybe<ZHLPreapprovalLetter>>>;
    rateQuote?: Maybe<ZHLRateQuote>;
    salesforceLoanStage?: Maybe<Scalars['String']['output']>;
    /** This is the loan status as defined from LFS. */
    status?: Maybe<Scalars['String']['output']>;
    /** This returns tasks from Tasks service. Supports filtering by taskTrigger, taskTriggerList and taskCategory. */
    tasks?: Maybe<Array<Maybe<ZHLTask>>>;
    tridTriggeredUTC?: Maybe<Scalars['String']['output']>;
};

export type ZHLLoandocumentsArgs = {
    id?: InputMaybe<Scalars['ID']['input']>;
    type?: InputMaybe<DocumentType>;
};

export type ZHLLoanpreApprovalLettersArgs = {
    mostRecentOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ZHLLoantasksArgs = {
    includeConditions?: InputMaybe<Scalars['Boolean']['input']>;
    includeDeleted?: InputMaybe<Scalars['Boolean']['input']>;
    includeLFSAssociations?: InputMaybe<Scalars['Boolean']['input']>;
    taskCategory?: InputMaybe<ZHLTaskCategory>;
    taskTrigger?: InputMaybe<ZHLTaskTrigger>;
    taskTriggerList?: InputMaybe<Array<InputMaybe<ZHLTaskTrigger>>>;
};

export type ZHLLoanAttributes = {
    downPayment?: Maybe<Scalars['Float']['output']>;
    leadId?: Maybe<Scalars['ID']['output']>;
    loanPurpose?: Maybe<ZHLLoanPurpose>;
    propertyType?: Maybe<ZHLPropertyType>;
    propertyUse?: Maybe<ZHLPropertyUse>;
    purchaseLocation?: Maybe<ZHLLocation>;
    targetLoanAmount?: Maybe<Scalars['Float']['output']>;
    valuation?: Maybe<Scalars['Float']['output']>;
};

export type ZHLLoanAttributesInput = {
    addressCity?: InputMaybe<Scalars['String']['input']>;
    addressCountyFIPS?: InputMaybe<Scalars['String']['input']>;
    addressState?: InputMaybe<State>;
    addressStreet?: InputMaybe<Scalars['String']['input']>;
    addressUnit?: InputMaybe<Scalars['String']['input']>;
    addressZIP?: InputMaybe<Scalars['String']['input']>;
    constructionMethod?: InputMaybe<ZHLConstructionMethodType>;
    fhaSecondaryResidence?: InputMaybe<Scalars['Boolean']['input']>;
    financedUnits?: InputMaybe<Scalars['Int']['input']>;
    loanPurpose?: InputMaybe<ZHLLoanPurpose>;
    mixedUse?: InputMaybe<Scalars['Boolean']['input']>;
    propertyType?: InputMaybe<ZHLPropertyType>;
    propertyUse?: InputMaybe<ZHLPropertyUse>;
    rentalIncomeGross?: InputMaybe<Scalars['Float']['input']>;
    rentalIncomeNet?: InputMaybe<Scalars['Float']['input']>;
    targetLoanAmount?: InputMaybe<Scalars['Float']['input']>;
    transaction?: InputMaybe<ZHLLoanAttributesTransaction>;
    valuation?: InputMaybe<Scalars['Float']['input']>;
};

export type ZHLLoanAttributesTransaction = {
    appraisalStatus?: InputMaybe<AppraisalStatusType>;
    construction?: InputMaybe<ZHLLoanAttributesTransactionConstruction>;
    existingCleanEnergyLien?: InputMaybe<Scalars['Boolean']['input']>;
    financeEnergyImprovements?: InputMaybe<Scalars['Boolean']['input']>;
    indianCountryLandTenure?: InputMaybe<IndianCountryLandTenureType>;
    leaseholdExpirationDate?: InputMaybe<Scalars['String']['input']>;
    pud?: InputMaybe<Scalars['Boolean']['input']>;
    refinance?: InputMaybe<ZHLLoanAttributesTransactionRefinance>;
    titleHolder?: InputMaybe<Scalars['String']['input']>;
    titleHoldingManner?: InputMaybe<TitleHoldingMannerType>;
    trustType?: InputMaybe<TrustType>;
    type?: InputMaybe<ZHLLoanAttributesTransactionType>;
};

export type ZHLLoanAttributesTransactionConstruction = {
    closingProcess?: InputMaybe<ConstructionClosingProcessType>;
    constructionCosts?: InputMaybe<Scalars['Float']['input']>;
    lotAcquiredDate?: InputMaybe<Scalars['String']['input']>;
    lotOriginalCost?: InputMaybe<Scalars['Float']['input']>;
};

export type ZHLLoanAttributesTransactionRefinance = {
    appraisalRequired?: InputMaybe<Scalars['Boolean']['input']>;
    cashOut?: InputMaybe<TransactionRefinanceCashOut>;
    creditRequired?: InputMaybe<Scalars['Boolean']['input']>;
    currentTitleHolder?: InputMaybe<Scalars['String']['input']>;
    currentTitleHoldingManner?: InputMaybe<CurrentTitleHoldingMannerType>;
    program?: InputMaybe<TransactionRefinanceProgramType>;
};

export type ZHLLoanAttributesTransactionType =
    | 'Construction'
    | 'ConversionOfContract'
    | 'Renovation';

export type ZHLLoanOfficer = BridgeLoanOfficerParticipantDetails & {
    branchNMLSID?: Maybe<Scalars['Int']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    /** Workday Employee ID */
    employeeID?: Maybe<Scalars['ID']['output']>;
    fullName?: Maybe<Scalars['String']['output']>;
    name?: Maybe<ZHLName>;
    nmlsID?: Maybe<Scalars['Int']['output']>;
    officePhone?: Maybe<Scalars['String']['output']>;
    profilePictureURL?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    zgEmail?: Maybe<Scalars['String']['output']>;
    zhlEmail?: Maybe<Scalars['String']['output']>;
    zuid?: Maybe<Scalars['ID']['output']>;
};

export type ZHLLoanOfficerInput = {
    email?: InputMaybe<Scalars['String']['input']>;
    employeeId?: InputMaybe<Scalars['String']['input']>;
    fullName?: InputMaybe<Scalars['String']['input']>;
    nmlsID?: InputMaybe<Scalars['Int']['input']>;
    officePhone?: InputMaybe<Scalars['String']['input']>;
    zuid?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLLoanProcessor = {
    email?: Maybe<Scalars['String']['output']>;
    name?: Maybe<ZHLName>;
    officePhone?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
    zuid?: Maybe<Scalars['ID']['output']>;
};

export type ZHLLoanPurpose = 'Purchase' | 'Refinance';

export type ZHLLoanStatus =
    | 'Active'
    | 'DenialRequested'
    | 'Denied'
    | 'Submitted'
    | 'WithdrawalRequested'
    | 'Withdrawn';

export type ZHLLocation = {
    city?: Maybe<Scalars['String']['output']>;
    countyFIPS?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    street?: Maybe<Scalars['String']['output']>;
    zipcode?: Maybe<Scalars['String']['output']>;
};

export type ZHLLongFormBorrowerDetails = {
    purchase?: InputMaybe<ZHLBorrowerPurchaseDetails>;
};

export type ZHLMACExperience = {
    dashboardURL?: Maybe<Scalars['String']['output']>;
};

export type ZHLMACUserRegistration = {
    blendApplicationID?: Maybe<Scalars['String']['output']>;
    blendBorrowerID?: Maybe<Scalars['String']['output']>;
    borrowerID: Scalars['ID']['output'];
    leadID?: Maybe<Scalars['String']['output']>;
    loanID: Scalars['ID']['output'];
    registrationSource?: Maybe<ZHLMACUserRegistrationSource>;
};

export type ZHLMACUserRegistrationSource = 'BLEND_LOGIN' | 'PREQUAL';

export type ZHLMailingAddressInput = {
    city: Scalars['String']['input'];
    code?: InputMaybe<Scalars['String']['input']>;
    country?: InputMaybe<Country>;
    street: Scalars['String']['input'];
    subdivision?: InputMaybe<Scalars['String']['input']>;
    unit?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLMaritalStatus = 'Married' | 'Separated' | 'Unmarried';

export type ZHLMilitaryService = {
    Completed?: Maybe<Scalars['Boolean']['output']>;
    activeDutyExpiration?: Maybe<Scalars['String']['output']>;
    onlyNonActivatedReserve?: Maybe<Scalars['Boolean']['output']>;
    survivingSpouse?: Maybe<Scalars['Boolean']['output']>;
    vaFirstTimeUse?: Maybe<Scalars['Boolean']['output']>;
};

export type ZHLModuleText = {
    attributes: Array<ZHLFontColorAttributes>;
    /** Gives a text a font color attribute using indicies */
    text: Scalars['String']['output'];
};

export type ZHLMortgageType = 'Conventional' | 'FHA' | 'HomeReadyAndHomePossible' | 'VA';

export type ZHLName = {
    first?: Maybe<Scalars['String']['output']>;
    last?: Maybe<Scalars['String']['output']>;
    middle?: Maybe<Scalars['String']['output']>;
    suffix?: Maybe<Scalars['String']['output']>;
};

export type ZHLNameInput = {
    first: Scalars['String']['input'];
    last: Scalars['String']['input'];
    middle?: InputMaybe<Scalars['String']['input']>;
    suffix?: InputMaybe<Scalars['String']['input']>;
};

/** Interface to support navigation action for a button */
export type ZHLNavAction = {
    analyticsTag?: Maybe<Scalars['String']['output']>;
};

export type ZHLParticipant = {
    id?: Maybe<Scalars['ID']['output']>;
    participantType?: Maybe<Scalars['String']['output']>;
};

export type ZHLPersonalizedNextStep = {
    status: ZHLPersonalizedNextStepStatus;
    title: Scalars['String']['output'];
};

export type ZHLPersonalizedNextStepState =
    | 'DIGITAL_PREAPPROVAL_NEW_APPLICATION'
    | 'DIGITAL_PREAPPROVAL_VERIFIED_OUTSTANDING_TASKS'
    | 'DIGITAL_PREAPPROVAL_VERIFIED_PREAPPROVAL'
    | 'NEW_APPLICATION'
    | 'OUTSTANDING_TASKS'
    | 'VERIFIED_PREAPPROVAL'
    | 'WAITING_TO_CLOSE';

export type ZHLPersonalizedNextStepStatus = 'COMPLETED' | 'CURRENT' | 'NOT_STARTED';

export type ZHLPersonalizedNextSteps = {
    currentState: ZHLPersonalizedNextStepState;
    loanApplicationExperienceURL?: Maybe<Scalars['String']['output']>;
    loanId: Scalars['ID']['output'];
    steps: Array<ZHLPersonalizedNextStep>;
    version: ZHLPersonalizedNextStepsVersion;
};

export type ZHLPersonalizedNextStepsVersion = 'V1' | 'V2';

export type ZHLPlaidAssetReportAuditToken = {
    assetReportId?: Maybe<Scalars['String']['output']>;
    auditCopyToken?: Maybe<Scalars['String']['output']>;
};

export type ZHLPlaidBorrowerAuditTokens = {
    auditCopyTokens?: Maybe<Array<Maybe<ZHLPlaidAssetReportAuditToken>>>;
    borrowerId?: Maybe<Scalars['String']['output']>;
};

export type ZHLPlaidHostedLinkDeliveryMethod = 'email' | 'sms';

export type ZHLPreApproval = {
    borrowers?: Maybe<Array<ZHLPreApprovalBorrower>>;
    contactLO?: Maybe<ZHLPreApprovalContactLO>;
    faq?: Maybe<ZHLPreApprovalFAQSection>;
    hasSocialSecurityNumber?: Maybe<Scalars['Boolean']['output']>;
    leadID?: Maybe<Scalars['ID']['output']>;
    loan?: Maybe<ZHLLoan>;
    loanID: Scalars['ID']['output'];
    loanOfficer?: Maybe<ZHLLoanOfficer>;
    milestone?: Maybe<ZHLPreApprovalMilestoneStatus>;
    preApprovalSuccess?: Maybe<ZHLPreApprovalSuccess>;
    sections?: Maybe<Array<ZHLPreApprovalSection>>;
    ui?: Maybe<ZHLPreApprovalLandingUI>;
};

export type ZHLPreApprovalAssertions = {
    firstTimeBuyer: Scalars['Boolean']['output'];
    isVA: Scalars['Boolean']['output'];
    usCitizen: Scalars['Boolean']['output'];
};

export type ZHLPreApprovalAsset = {
    attributes?: Maybe<ZHLPreApprovalFinanceAttributes>;
    id?: Maybe<Scalars['String']['output']>;
};

export type ZHLPreApprovalAssetBrokerageAccountType =
    | 'Bonds'
    | 'MutualFund'
    | 'StockOptions'
    | 'Stocks';

export type ZHLPreApprovalAssetBrokerageAttributesInput = {
    accountType: ZHLPreApprovalAssetBrokerageAccountType;
    financialInstitution: Scalars['String']['input'];
};

export type ZHLPreApprovalAssetRegularAccountType =
    | 'CertificateOfDeposit'
    | 'CheckingAccount'
    | 'MoneyMarketAccount'
    | 'SavingsAccount';

export type ZHLPreApprovalAssetRegularAttributesInput = {
    accountType: ZHLPreApprovalAssetRegularAccountType;
    financialInstitution: Scalars['String']['input'];
};

export type ZHLPreApprovalAssetRetirementAccountType = 'RetirementAccount';

export type ZHLPreApprovalAssetRetirementAttributesInput = {
    accountType: ZHLPreApprovalAssetRetirementAccountType;
    financialInstitution: Scalars['String']['input'];
};

export type ZHLPreApprovalBorrower = {
    id: Scalars['ID']['output'];
    zuid?: Maybe<Scalars['String']['output']>;
};

export type ZHLPreApprovalCitizenshipType =
    | 'NonPermanentResidentAlien'
    | 'PermanentResidentAlien'
    | 'USCitizen';

export type ZHLPreApprovalContactLO = {
    assignedLOPage?: Maybe<ZHLPreApprovalLoanOfficerAssigned>;
    descriptionHtml: Scalars['String']['output'];
    descriptionMarkdown: Scalars['String']['output'];
    genericLOPage: ZHLPreApprovalLoanOfficerGeneric;
    headerText: Scalars['String']['output'];
    /** DPA Contact Us UI */
    pageTitle: Scalars['String']['output'];
};

export type ZHLPreApprovalContactSection = {
    cta: Array<Maybe<ZHLStandardButtonIcon>>;
    /** DPA Contact Us LO Navigation UI */
    text: Scalars['String']['output'];
};

export type ZHLPreApprovalDigitalExperience = {
    ctaURL?: Maybe<Scalars['String']['output']>;
    ctaURLWithHost?: Maybe<Scalars['String']['output']>;
    isEnabled: Scalars['Boolean']['output'];
};

export type ZHLPreApprovalDraftAnswersInput = {
    brokerage?: InputMaybe<Array<InputMaybe<ZHLPreApprovalAssetBrokerageAttributesInput>>>;
    checkingOrSavings?: InputMaybe<Array<InputMaybe<ZHLPreApprovalAssetRegularAttributesInput>>>;
    employments?: InputMaybe<Array<InputMaybe<ZHLPreApprovalEmploymentAttributesInput>>>;
    retirement?: InputMaybe<Array<InputMaybe<ZHLPreApprovalAssetRetirementAttributesInput>>>;
};

export type ZHLPreApprovalEmployment = {
    attributes?: Maybe<ZHLPreApprovalEmploymentAttributes>;
    id?: Maybe<Scalars['ID']['output']>;
};

export type ZHLPreApprovalEmploymentAttributes = {
    endDate?: Maybe<Scalars['String']['output']>;
    income?: Maybe<ZHLPreApprovalEmploymentAttributesIncome>;
    name?: Maybe<Scalars['String']['output']>;
    startDate?: Maybe<Scalars['String']['output']>;
};

export type ZHLPreApprovalEmploymentAttributesIncome = {
    amount?: Maybe<Scalars['Float']['output']>;
    base?: Maybe<ZHLPreApprovalEmploymentAttributesIncomeStream>;
    frequency?: Maybe<Scalars['String']['output']>;
};

export type ZHLPreApprovalEmploymentAttributesIncomeStream = {
    amount?: Maybe<Scalars['Float']['output']>;
    frequency?: Maybe<Scalars['String']['output']>;
};

export type ZHLPreApprovalEmploymentAttributesInput = {
    endDate?: InputMaybe<Scalars['String']['input']>;
    name: Scalars['String']['input'];
    startDate: Scalars['String']['input'];
};

export type ZHLPreApprovalExperiment = {
    feature: Scalars['String']['output'];
    treatment: Scalars['String']['output'];
};

export type ZHLPreApprovalExperimentTreatments = {
    treatments: Array<ZHLPreApprovalExperiment>;
};

export type ZHLPreApprovalFAQ = {
    /** Sections with/without a header within a FAQ section */
    headerText?: Maybe<Scalars['String']['output']>;
    items: Array<Maybe<ZHLPreApprovalFAQQuestion>>;
};

export type ZHLPreApprovalFAQQuestion = {
    contentHtml: Scalars['String']['output'];
    contentMarkdown: Scalars['String']['output'];
    /** Allows for html/markdown answer for a question */
    questionText: Scalars['String']['output'];
};

export type ZHLPreApprovalFAQSection = {
    cta: ZHLStandardButton;
    /** DPA FAQ Page UI */
    pageTitle: Scalars['String']['output'];
    questions: Array<Maybe<ZHLPreApprovalFAQ>>;
};

export type ZHLPreApprovalFinanceAttributes = {
    accountType?: Maybe<Scalars['String']['output']>;
    financialInstitution?: Maybe<Scalars['String']['output']>;
    marketValue?: Maybe<Scalars['Float']['output']>;
};

export type ZHLPreApprovalFinanceDraftAnswers = {
    brokerage?: Maybe<Array<Maybe<ZHLPreApprovalAsset>>>;
    checkingOrSavings?: Maybe<Array<Maybe<ZHLPreApprovalAsset>>>;
    retirement?: Maybe<Array<Maybe<ZHLPreApprovalAsset>>>;
};

/** Finance assets from LOP */
export type ZHLPreApprovalFinanceLOP = {
    brokerage?: Maybe<Array<Maybe<ZHLPreApprovalAsset>>>;
    checkingOrSavings?: Maybe<Array<Maybe<ZHLPreApprovalAsset>>>;
    retirement?: Maybe<Array<Maybe<ZHLPreApprovalAsset>>>;
};

export type ZHLPreApprovalFinanceMilestoneStatus =
    | 'DRAFT_BROKERAGE_ADDED'
    | 'DRAFT_CHECKING_ADDED'
    | 'DRAFT_RETIREMENT_ADDED'
    | 'NOT_STARTED'
    | 'SECTION_COMPLETED'
    | 'SSN_REQUIRED'
    | 'TASKS_INCOMPLETE'
    | 'TASKS_NOT_STARTED';

/** Finance assets from pre-approval flow */
export type ZHLPreApprovalFinancePreApproval = {
    brokerage?: Maybe<Array<Maybe<ZHLPreApprovalAsset>>>;
    checkingOrSavings?: Maybe<Array<Maybe<ZHLPreApprovalAsset>>>;
    retirement?: Maybe<Array<Maybe<ZHLPreApprovalAsset>>>;
};

/** Finance assets from pre-qualification flow */
export type ZHLPreApprovalFinancePreQual = {
    brokerage?: Maybe<Array<Maybe<ZHLPreApprovalAsset>>>;
    checkingOrSavings?: Maybe<Array<Maybe<ZHLPreApprovalAsset>>>;
    retirement?: Maybe<Array<Maybe<ZHLPreApprovalAsset>>>;
};

export type ZHLPreApprovalFinanceSection = IZHLPreApprovalSection & {
    draftAnswers?: Maybe<ZHLPreApprovalFinanceDraftAnswers>;
    financeMilestone: ZHLPreApprovalFinanceMilestoneStatus;
    lop?: Maybe<ZHLPreApprovalFinanceLOP>;
    preApproval?: Maybe<ZHLPreApprovalFinancePreApproval>;
    preQual?: Maybe<ZHLPreApprovalFinancePreQual>;
    tasks: Array<Maybe<ZHLTask>>;
    type: ZHLPreApprovalSectionType;
    ui?: Maybe<ZHLPreApprovalSectionUI>;
};

export type ZHLPreApprovalIncomeDraftAnswers = {
    employments?: Maybe<Array<Maybe<ZHLPreApprovalEmployment>>>;
};

/** Employments from LOP */
export type ZHLPreApprovalIncomeLOP = {
    employments?: Maybe<Array<Maybe<ZHLPreApprovalEmployment>>>;
};

export type ZHLPreApprovalIncomeMilestoneStatus =
    | 'DRAFT_EMPLOYMENT_ADDED'
    | 'NOT_STARTED'
    | 'SECTION_COMPLETED'
    | 'TASKS_INCOMPLETE'
    | 'TASKS_NOT_STARTED';

/** Employments from pre-approval flow */
export type ZHLPreApprovalIncomePreApproval = {
    employments?: Maybe<Array<Maybe<ZHLPreApprovalEmployment>>>;
};

/** Employments from pre-qualificaton flow */
export type ZHLPreApprovalIncomePreQual = {
    employments?: Maybe<Array<Maybe<ZHLPreApprovalEmployment>>>;
};

export type ZHLPreApprovalIncomeSection = IZHLPreApprovalSection & {
    draftAnswers?: Maybe<ZHLPreApprovalIncomeDraftAnswers>;
    incomeMilestone: ZHLPreApprovalIncomeMilestoneStatus;
    lop?: Maybe<ZHLPreApprovalIncomeLOP>;
    preApproval?: Maybe<ZHLPreApprovalIncomePreApproval>;
    preQual?: Maybe<ZHLPreApprovalIncomePreQual>;
    tasks: Array<Maybe<ZHLTask>>;
    type: ZHLPreApprovalSectionType;
    ui?: Maybe<ZHLPreApprovalSectionUI>;
};

export type ZHLPreApprovalLandingUI = {
    headerActionModal?: Maybe<ZHLPreApprovalModal>;
    headerHtml: Scalars['String']['output'];
    headerMarkdown: ZHLModuleText;
    headerSubtext?: Maybe<Scalars['String']['output']>;
    /** L1 UI Header */
    pageTitle: Scalars['String']['output'];
};

export type ZHLPreApprovalLoanDetails = {
    downPayment?: Maybe<Scalars['Int']['output']>;
    monthlyPayment: Scalars['Int']['output'];
    selfReportedClosingCash?: Maybe<Scalars['Int']['output']>;
};

export type ZHLPreApprovalLoanOfficerAssigned = {
    contact: Array<Maybe<ZHLPreApprovalContactSection>>;
    cta: ZHLHyperLink;
    nmlsCompany: Scalars['String']['output'];
    nmlsLO: Scalars['String']['output'];
    profilePictureURL?: Maybe<Scalars['String']['output']>;
    /** DPA Contact Us Assigned LO UI */
    tag: ZHLTag;
};

export type ZHLPreApprovalLoanOfficerGeneric = {
    availableHtml: Scalars['String']['output'];
    availableMarkdown: Scalars['String']['output'];
    cta: ZHLStandardButton;
    /** DPA Contact Us Generic LO UI */
    headerText: Scalars['String']['output'];
    profilePictureURL: Scalars['String']['output'];
    subText: Scalars['String']['output'];
};

export type ZHLPreApprovalMilestoneStatus =
    | 'FOLLOW_UP_NEEDED'
    | 'IN_PROGRESS'
    | 'IN_REVIEW'
    | 'NOT_STARTED'
    | 'PRE_APPROVED'
    | 'PRE_APPROVED_WITH_TASKS';

export type ZHLPreApprovalModal = {
    modalContent: Scalars['String']['output'];
    modalTitle: Scalars['String']['output'];
    /** Follows constellation Trigger Text opening a modal. https://constellation.zillowgroup.com/platforms/web/components/trigger-text */
    triggerText: Scalars['String']['output'];
};

export type ZHLPreApprovalOutput = {
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type ZHLPreApprovalPersonalInfoDetails = {
    address: ZHLPreQualBorrowerAddress;
    assertions?: Maybe<ZHLPreApprovalAssertions>;
    citizenshipType?: Maybe<ZHLPreApprovalCitizenshipType>;
    email: Scalars['String']['output'];
    firstName: Scalars['String']['output'];
    lastName: Scalars['String']['output'];
    loanDetails: ZHLPreApprovalLoanDetails;
    propertyType: ZHLPreQualPropertyType;
    propertyUse: ZHLPreQualPropertyUse;
};

export type ZHLPreApprovalPersonalInfoMilestoneStatus = 'SECTION_COMPLETED';

export type ZHLPreApprovalPersonalInfoSection = IZHLPreApprovalSection & {
    details: ZHLPreApprovalPersonalInfoDetails;
    personalInfoMilestone: ZHLPreApprovalPersonalInfoMilestoneStatus;
    type: ZHLPreApprovalSectionType;
    ui?: Maybe<ZHLPreApprovalSectionUI>;
};

export type ZHLPreApprovalReviewMilestoneStatus =
    | 'NOT_REQUIRED'
    | 'SECTION_COMPLETED'
    | 'TASKS_INCOMPLETE'
    | 'TASKS_NOT_STARTED';

export type ZHLPreApprovalReviewSection = IZHLPreApprovalSection & {
    reviewMilestone: ZHLPreApprovalReviewMilestoneStatus;
    tasks: Array<Maybe<ZHLTask>>;
    type: ZHLPreApprovalSectionType;
    ui?: Maybe<ZHLPreApprovalSectionUI>;
};

export type ZHLPreApprovalSection =
    | ZHLPreApprovalFinanceSection
    | ZHLPreApprovalIncomeSection
    | ZHLPreApprovalPersonalInfoSection
    | ZHLPreApprovalReviewSection;

export type ZHLPreApprovalSectionType = 'FINANCE' | 'INCOME' | 'PERSONAL' | 'REVIEW';

export type ZHLPreApprovalSectionUI = {
    contentHtml: Scalars['String']['output'];
    contentMarkdown: Scalars['String']['output'];
    cta?: Maybe<ZHLStandardButton>;
    /** DPA L1 Section UI */
    headerText: Scalars['String']['output'];
    isExpanded: Scalars['Boolean']['output'];
    progressText?: Maybe<Scalars['String']['output']>;
    progressValue?: Maybe<Scalars['Float']['output']>;
};

export type ZHLPreApprovalSuccess = {
    cta: ZHLStandardButton;
    descriptionText: Scalars['String']['output'];
    headerHtml: Scalars['String']['output'];
    headerMarkdown: ZHLModuleText;
    /** Beth succeeds in getting preapproved UI */
    pageTitle: Scalars['String']['output'];
    value?: Maybe<Scalars['Int']['output']>;
    valueText?: Maybe<Scalars['String']['output']>;
};

export type ZHLPreQualAsset = {
    marketValue: Scalars['Int']['output'];
    type: ZHLPreQualAssetType;
};

export type ZHLPreQualAssetInput = {
    marketValue: Scalars['Int']['input'];
    type: ZHLPreQualAssetType;
};

export type ZHLPreQualAssetType = 'Brokerage' | 'Cash' | 'Gift' | 'OtherAssets' | 'Retirement';

export type ZHLPreQualBorrowerAddress = {
    city: Scalars['String']['output'];
    code: Scalars['String']['output'];
    street: Scalars['String']['output'];
    subDivision?: Maybe<Scalars['String']['output']>;
    unit?: Maybe<Scalars['String']['output']>;
};

export type ZHLPreQualBorrowerAddressInput = {
    city: Scalars['String']['input'];
    code: Scalars['String']['input'];
    street: Scalars['String']['input'];
    subDivision?: InputMaybe<Scalars['String']['input']>;
    unit?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLPreQualBorrowerAssertions = {
    employed?: Maybe<Scalars['Boolean']['output']>;
    firstTimeBuyer: Scalars['Boolean']['output'];
    hasBankruptcy: Scalars['Boolean']['output'];
    hasForeClosure: Scalars['Boolean']['output'];
    isVA: Scalars['Boolean']['output'];
    ownCurrentHome?: Maybe<Scalars['Boolean']['output']>;
    rentCurrentHome?: Maybe<Scalars['Boolean']['output']>;
    usCitizen: Scalars['Boolean']['output'];
};

export type ZHLPreQualBorrowerAssertionsInput = {
    employed?: InputMaybe<Scalars['Boolean']['input']>;
    firstTimeBuyer: Scalars['Boolean']['input'];
    hasBankruptcy: Scalars['Boolean']['input'];
    hasForeClosure: Scalars['Boolean']['input'];
    isVA: Scalars['Boolean']['input'];
    ownCurrentHome?: InputMaybe<Scalars['Boolean']['input']>;
    rentCurrentHome?: InputMaybe<Scalars['Boolean']['input']>;
    usCitizen: Scalars['Boolean']['input'];
};

export type ZHLPreQualBorrowerDetails = {
    address: ZHLPreQualBorrowerAddress;
    assertions: ZHLPreQualBorrowerAssertions;
    assets: Array<ZHLPreQualAsset>;
    citizenshipType?: Maybe<ZHLBorrowerCitizenshipType>;
    email: Scalars['String']['output'];
    employment: Array<ZHLPreQualEmployment>;
    firstName: Scalars['String']['output'];
    id?: Maybe<Scalars['ID']['output']>;
    lastName: Scalars['String']['output'];
    otherIncome?: Maybe<Array<ZHLPreQualOtherIncome>>;
    phone: Scalars['String']['output'];
    zuid?: Maybe<Scalars['ID']['output']>;
};

export type ZHLPreQualBorrowerDetailsInput = {
    address: ZHLPreQualBorrowerAddressInput;
    assertions: ZHLPreQualBorrowerAssertionsInput;
    assets: Array<ZHLPreQualAssetInput>;
    citizenshipType?: InputMaybe<ZHLBorrowerCitizenshipType>;
    email: Scalars['String']['input'];
    employment: Array<ZHLPreQualEmploymentInput>;
    firstName: Scalars['String']['input'];
    id?: InputMaybe<Scalars['ID']['input']>;
    lastName: Scalars['String']['input'];
    otherIncome?: InputMaybe<Array<ZHLPreQualOtherIncomeInput>>;
    phone: Scalars['String']['input'];
};

export type ZHLPreQualBorrowerJourneyStage =
    | 'EstimatedAffordability'
    /** Follows https://gitlab.zgtools.net/zillow-home-loans/services/zhl-graphql/-/blob/main/src/schema/zhlBorrower/zhlBorrower.schema.ts#L335 */
    | 'LookingAtListings'
    | 'MakingOffer'
    | 'MakingOfferOrUnderContract'
    | 'PreapprovedOrPrequalified'
    | 'TouringHomes'
    | 'UnderContract';

export type ZHLPreQualBorrowerPayFrequencyInput =
    /** Follows https://gitlab.zgtools.net/zillow-offers/orca/registrars/zg-graph-schemas/-/blob/master/schemas/zhl-graphql.graphql */
    'Annual' | 'Monthly';

export type ZHLPreQualCreatePurchaseLeadInput = {
    borrowerDetails: ZHLPreQualBorrowerDetailsInput;
    hasAgent: Scalars['Boolean']['input'];
    id?: InputMaybe<Scalars['ID']['input']>;
    journeyStage: ZHLPreQualBorrowerJourneyStage;
    loanDetails: ZHLPreQualLoanDetailsInput;
    offRamping?: InputMaybe<ZHLPreQualOffRampingInput>;
    propertyDetails: ZHLPreQualPropertyDetailsInput;
    purchaseDate?: InputMaybe<ZHLPreQualPurchaseDate>;
    softCreditConsent: Scalars['Boolean']['input'];
};

export type ZHLPreQualEmployment = {
    amount: Scalars['Int']['output'];
    frequency: ZHLPreQualBorrowerPayFrequencyInput;
    type?: Maybe<ZHLPreQualEmploymentType>;
};

export type ZHLPreQualEmploymentInput = {
    amount: Scalars['Int']['input'];
    frequency: ZHLPreQualBorrowerPayFrequencyInput;
    type?: InputMaybe<ZHLPreQualEmploymentType>;
};

export type ZHLPreQualEmploymentType = 'SelfEmployment' | 'W2';

export type ZHLPreQualIncomeType = 'Other' | 'Retirement';

export type ZHLPreQualLoanDetails = {
    downPayment?: Maybe<Scalars['Int']['output']>;
    downPaymentPercent?: Maybe<Scalars['Int']['output']>;
    hasCoBorrower?: Maybe<Scalars['Boolean']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    isJumboLoan?: Maybe<Scalars['Boolean']['output']>;
    monthlyPayment?: Maybe<Scalars['Int']['output']>;
    purchasePrice?: Maybe<Scalars['Int']['output']>;
    selfReportedClosingCash?: Maybe<Scalars['Int']['output']>;
    selfReportedCredit: Scalars['String']['output'];
    selfReportedMonthlyBudget?: Maybe<Scalars['Int']['output']>;
};

export type ZHLPreQualLoanDetailsInput = {
    downPayment?: InputMaybe<Scalars['Int']['input']>;
    downPaymentPercent?: InputMaybe<Scalars['Int']['input']>;
    hasCoBorrower?: InputMaybe<Scalars['Boolean']['input']>;
    id?: InputMaybe<Scalars['ID']['input']>;
    isJumboLoan?: InputMaybe<Scalars['Boolean']['input']>;
    purchasePrice?: InputMaybe<Scalars['Int']['input']>;
    selfReportedClosingCash?: InputMaybe<Scalars['Int']['input']>;
    selfReportedCredit: Scalars['String']['input'];
    selfReportedMonthlyBudget?: InputMaybe<Scalars['Int']['input']>;
};

export type ZHLPreQualLocation = {
    /** Follows https://gitlab.zgtools.net/zillow-home-loans/services/zhl-graphql/-/blob/main/src/schema/zhlLoan/zhlLoan.schema.ts#L115 */
    city?: Maybe<Scalars['String']['output']>;
    countyFIPS?: Maybe<Scalars['String']['output']>;
    state?: Maybe<Scalars['String']['output']>;
    street?: Maybe<Scalars['String']['output']>;
    zipcode?: Maybe<Scalars['String']['output']>;
};

export type ZHLPreQualLocationInput = {
    /** Follows https://gitlab.zgtools.net/zillow-home-loans/services/zhl-graphql/-/blob/main/src/schema/zhlLoan/zhlLoan.schema.ts#L115 */
    city?: InputMaybe<Scalars['String']['input']>;
    countyFIPS?: InputMaybe<Scalars['String']['input']>;
    state?: InputMaybe<Scalars['String']['input']>;
    street?: InputMaybe<Scalars['String']['input']>;
    zipcode?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLPreQualOffRamping = {
    description: Scalars['String']['output'];
    reason: Scalars['String']['output'];
    type: Scalars['String']['output'];
};

export type ZHLPreQualOffRampingInput = {
    description: Scalars['String']['input'];
    reason: Scalars['String']['input'];
    type: Scalars['String']['input'];
};

export type ZHLPreQualOtherIncome = {
    amount: Scalars['Int']['output'];
    frequency: ZHLPreQualBorrowerPayFrequencyInput;
    type?: Maybe<ZHLPreQualIncomeType>;
};

export type ZHLPreQualOtherIncomeInput = {
    amount: Scalars['Int']['input'];
    frequency: ZHLPreQualBorrowerPayFrequencyInput;
    type?: InputMaybe<ZHLPreQualIncomeType>;
};

export type ZHLPreQualPropertyDetails = {
    address?: Maybe<ZHLPreQualLocation>;
    propertyType: ZHLPreQualPropertyType;
    propertyUse: ZHLPreQualPropertyUse;
};

export type ZHLPreQualPropertyDetailsInput = {
    address?: InputMaybe<ZHLPreQualLocationInput>;
    propertyType: ZHLPreQualPropertyType;
    propertyUse: ZHLPreQualPropertyUse;
};

export type ZHLPreQualPropertyType =
    | 'CoOp'
    | 'Condo'
    | 'Condotel'
    | 'Duplex'
    | 'Fourplex'
    | 'MobileOrManufactured'
    /** Follows https://gitlab.zgtools.net/zillow-home-loans/services/zhl-graphql/-/blob/main/src/schema/zhlLoan/zhlLoan.schema.ts#L176 */
    | 'Single'
    | 'Townhome'
    | 'Triplex';

export type ZHLPreQualPropertyUse =
    | 'InvestmentProperty'
    /** Follows https://gitlab.zgtools.net/zillow-offers/orca/registrars/zg-graph-schemas/-/blob/master/schemas/zhl-graphql.graphql */
    | 'PrimaryResidence'
    | 'SecondHome';

export type ZHLPreQualPurchaseDate =
    | 'FourToSix'
    | 'FourToSixMonths'
    | 'GreaterThanSixMonths'
    | 'LessThanFourMonths'
    | 'MoreThanSix'
    | 'MoreThanSixMonths'
    | 'NotSure';

export type ZHLPreQualPurchaseLead = {
    borrowerDetails: ZHLPreQualBorrowerDetails;
    digitalExperience: ZHLPreApprovalDigitalExperience;
    experimentTreatments: ZHLPreApprovalExperimentTreatments;
    hasAgent: Scalars['Boolean']['output'];
    id?: Maybe<Scalars['ID']['output']>;
    journeyStage: ZHLPreQualBorrowerJourneyStage;
    loanDetails: ZHLPreQualLoanDetails;
    offRamping?: Maybe<ZHLPreQualOffRamping>;
    propertyDetails: ZHLPreQualPropertyDetails;
    purchaseDate?: Maybe<ZHLPreQualPurchaseDate>;
    softCreditConsent: Scalars['Boolean']['output'];
    zuid?: Maybe<Scalars['ID']['output']>;
};

export type ZHLPreapprovalLetter = {
    _id: Scalars['ID']['output'];
    createdBy: Scalars['String']['output'];
    createdDate: Scalars['Date']['output'];
    documentId: Scalars['ID']['output'];
    downloadURL: Scalars['String']['output'];
    /** document meta data, e.g. preApprovalMetaData. All meta data will be appended to this object */
    metaData?: Maybe<ZHLDocumentPreApprovalMetaData>;
    viewingURL: Scalars['String']['output'];
};

export type ZHLPropertyType =
    | 'CoOp'
    | 'Condo'
    | 'Condotel'
    | 'Duplex'
    | 'Fourplex'
    | 'Single'
    | 'Townhome'
    | 'Triplex';

export type ZHLPropertyUse = 'InvestmentProperty' | 'PrimaryResidence' | 'SecondHome';

export type ZHLQuestionnaireType = 'LoanApplication' | 'PreApproval';

export type ZHLRateQuote = {
    id: Scalars['ID']['output'];
    scenario?: Maybe<ZHLScenario>;
};

/** Supported Rate Source types */
export type ZHLRatesSource = 'ZGMI' | 'ZHL';

export type ZHLScenario = {
    attributes?: Maybe<ZHLScenarioAttributes>;
    id: Scalars['ID']['output'];
};

export type ZHLScenarioAttributes = {
    mortgageType?: Maybe<ZHLMortgageType>;
};

/** Fetches a UI button */
export type ZHLStandardButton = ZHLButton & {
    buttonIcon?: Maybe<ZHLRatesSource>;
    buttonType: ZHLButtonStyle;
    navAction: ZHLNavAction;
    text: Scalars['String']['output'];
};

export type ZHLStandardButtonIcon = ZHLButton & {
    buttonIcon: ZHLIcon;
    buttonType: ZHLButtonStyle;
    /** An icon button has a CTA, no text */
    navAction: ZHLNavAction;
};

export type ZHLStandardTooltip = ZHLTooltip & {
    body?: Maybe<Scalars['String']['output']>;
    heading?: Maybe<Scalars['String']['output']>;
    title: Scalars['String']['output'];
};

/** Fetches UI for displaying tags */
export type ZHLTag = {
    color: ZHLTagStyle;
    text: Scalars['String']['output'];
};

/** Supported Tag Styles - Maps with Constellation Tags - https://constellation.zillowgroup.com/platforms/web/components/tag */
export type ZHLTagStyle = 'ERROR' | 'GRAY' | 'INFO' | 'SUCCESS' | 'WARNING';

export type ZHLTask = {
    externalDescription?: Maybe<Scalars['String']['output']>;
    id: Scalars['ID']['output'];
    internalDescription?: Maybe<Scalars['String']['output']>;
    lfsMetaData?: Maybe<Array<Maybe<ZHLLFSMetaData>>>;
    source?: Maybe<ZHLTaskSourceSystem>;
    /** @deprecated No current use case or returned data */
    stepMessage?: Maybe<Scalars['String']['output']>;
    taskAssignedTo?: Maybe<ZHLTaskParticipantRole>;
    taskCategory?: Maybe<ZHLTaskCategory>;
    taskComments?: Maybe<Array<Maybe<ZHLTaskComment>>>;
    taskCompletedDate?: Maybe<Scalars['String']['output']>;
    taskCreatedDate?: Maybe<Scalars['String']['output']>;
    /** @deprecated: use taskDocuments. This field will be removed in the future unless new usage is found. */
    taskDocument?: Maybe<ZHLDocument>;
    taskDocuments?: Maybe<Array<Maybe<ZHLDocument>>>;
    taskDueDate?: Maybe<Scalars['String']['output']>;
    taskName?: Maybe<Scalars['String']['output']>;
    taskParticipants?: Maybe<Array<Maybe<ZHLTaskParticipant>>>;
    taskReRequestedDate?: Maybe<Scalars['String']['output']>;
    taskStatus?: Maybe<ZHLTaskStatus>;
    taskTrigger?: Maybe<ZHLTaskTrigger>;
    taskType?: Maybe<ZHLTaskType>;
    taskUpdatedDate?: Maybe<Scalars['String']['output']>;
    taskUpdatedDateByZHLEmployee?: Maybe<Scalars['String']['output']>;
    title?: Maybe<Scalars['String']['output']>;
};

export type ZHLTasktaskDocumentArgs = {
    status?: InputMaybe<ZHLDocumentStatus>;
};

export type ZHLTasktaskDocumentsArgs = {
    includeInactiveDocuments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ZHLTaskCategory =
    | 'TASK_CATEGORY_ASSETS'
    | 'TASK_CATEGORY_CREDIT'
    | 'TASK_CATEGORY_INCOME'
    | 'TASK_CATEGORY_MISC'
    | 'TASK_CATEGORY_PROPERTY'
    | 'TASK_CATEGORY_UNSPECIFIED';

export type ZHLTaskComment = {
    audienceRole?: Maybe<ZHLTaskParticipantRole>;
    content?: Maybe<Scalars['String']['output']>;
    createdBy?: Maybe<Scalars['String']['output']>;
    createdDate?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
};

export type ZHLTaskCommentInput = {
    audienceRole?: InputMaybe<ZHLTaskParticipantRole>;
    content?: InputMaybe<Scalars['String']['input']>;
};

export type ZHLTaskMetaDataInput = {
    id: Scalars['ID']['input'];
    type: ZHLLfsRecordSource;
};

export type ZHLTaskParticipant = {
    borrower?: Maybe<ZHLBorrower>;
    /** Borrower's UUID in Loan File Service */
    borrowerId?: Maybe<Scalars['ID']['output']>;
    participantRole?: Maybe<ZHLTaskParticipantRole>;
    /** @deprecated: use participantRole */
    role?: Maybe<TaskParticipantRole>;
    zuid?: Maybe<Scalars['ID']['output']>;
};

export type ZHLTaskParticipantRole =
    | 'TASK_PARTICIPANT_ROLE_CONDITIONS_BORROWER'
    | 'TASK_PARTICIPANT_ROLE_CO_BORROWER'
    | 'TASK_PARTICIPANT_ROLE_LOAN_OFFICER'
    | 'TASK_PARTICIPANT_ROLE_LOAN_OFFICER_MANAGER'
    | 'TASK_PARTICIPANT_ROLE_PRIMARY_BORROWER'
    | 'TASK_PARTICIPANT_ROLE_PROCESSOR'
    | 'TASK_PARTICIPANT_ROLE_PROCESSOR_MANAGER'
    | 'TASK_PARTICIPANT_ROLE_UNDERWRITER'
    | 'TASK_PARTICIPANT_ROLE_UNDERWRITER_MANAGER'
    | 'TASK_PARTICIPANT_ROLE_UNSPECIFIED'
    | 'TASK_PARTICIPANT_ROLE_ZHL_EMPLOYEE';

export type ZHLTaskSourceSystem = 'CONDITIONS' | 'TASK_SERVICE';

export type ZHLTaskStatus =
    | 'TASK_STATUS_COMPLETED'
    | 'TASK_STATUS_DELETED'
    | 'TASK_STATUS_FAILED_TO_TRIGGER'
    | 'TASK_STATUS_IN_PROGRESS'
    | 'TASK_STATUS_IN_REVIEW'
    | 'TASK_STATUS_PRE_TRIGGERED'
    | 'TASK_STATUS_REJECTED'
    | 'TASK_STATUS_TRIGGERED'
    | 'TASK_STATUS_UNSPECIFIED';

export type ZHLTaskTemplate = {
    displayName?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['ID']['output']>;
    taskCategory?: Maybe<ZHLTaskCategory>;
    taskDescription?: Maybe<Scalars['String']['output']>;
    taskName?: Maybe<Scalars['String']['output']>;
    taskTemplateLabels?: Maybe<Array<Maybe<ZHLTaskTemplateLabel>>>;
};

export type ZHLTaskTemplateLabel =
    | 'TASK_LABEL_BORROWER_NAME'
    | 'TASK_LABEL_COMPANY_NAME'
    | 'TASK_LABEL_CREDITOR_BALANCE'
    | 'TASK_LABEL_DEPENDENT_NAME'
    | 'TASK_LABEL_DOLLAR_AMOUNT'
    | 'TASK_LABEL_EMPLOYER_NAME'
    | 'TASK_LABEL_FINANCIAL_ACCOUNT'
    | 'TASK_LABEL_INCOME_SOURCE'
    | 'TASK_LABEL_PROPERTY_ADDRESS'
    | 'TASK_LABEL_REASON'
    | 'TASK_LABEL_RESERVE_DOLLAR_AMOUNT'
    | 'TASK_LABEL_UNSPECIFIED'
    | 'TASK_LABEL_YEAR';

export type ZHLTaskTrigger =
    | 'TASK_TRIGGER_API'
    | 'TASK_TRIGGER_AUTOMATED'
    | 'TASK_TRIGGER_BLEND_AUTOMATED'
    | 'TASK_TRIGGER_LOP'
    | 'TASK_TRIGGER_LOP_AUTOMATED'
    | 'TASK_TRIGGER_LOP_MANUAL'
    | 'TASK_TRIGGER_LOP_PREAPPROVAL_AUTOMATED'
    | 'TASK_TRIGGER_LOP_PREAPPROVAL_MANUAL'
    | 'TASK_TRIGGER_PREAPPROVAL'
    | 'TASK_TRIGGER_PREAPPROVAL_AUTOMATED'
    | 'TASK_TRIGGER_UNSPECIFIED';

export type ZHLTaskType =
    | 'TASK_TYPE_DOCUMENT_ESIGN'
    | 'TASK_TYPE_DOCUMENT_REVIEW'
    | 'TASK_TYPE_DOCUMENT_UPLOAD'
    | 'TASK_TYPE_UNSPECIFIED';

export type ZHLTextUrlNavExperience = ZHLUrlNavExperience & {
    authAssuranceLevel: ZHLAuthAssuranceLevel;
    ctaUrl: Scalars['String']['output'];
    text?: Maybe<Scalars['String']['output']>;
};

export type ZHLTooltip = {
    title: Scalars['String']['output'];
};

export type ZHLTooltipButton = ZHLButton & {
    icon: ZHLIconType;
    navAction: ZHLTooltipNavAction;
    title?: Maybe<Scalars['String']['output']>;
};

export type ZHLTooltipNavAction = ZHLNavAction & {
    analyticsTag: Scalars['String']['output'];
    tooltip?: Maybe<ZHLTooltip>;
};

/** Navigation action to direct user to external links */
export type ZHLUrlNavAction = ZHLNavAction & {
    analyticsTag?: Maybe<Scalars['String']['output']>;
    ctaUrl: Scalars['String']['output'];
    showAbad: Scalars['Boolean']['output'];
    urlExperience: ZHLUrlNavExperience;
};

/** Interface for various url navigation actions supported by mobile */
export type ZHLUrlNavExperience = {
    ctaUrl: Scalars['String']['output'];
};

/** Nav Experience - In App Safari sandbox */
export type ZHLUrlNavInAppBrowserExperience = ZHLUrlNavExperience & {
    ctaUrl: Scalars['String']['output'];
};

/** Nav Experience - Opens Safari browser outside the app */
export type ZHLUrlNavSystemBrowserExperience = ZHLUrlNavExperience & {
    authAssuranceLevel: ZHLAuthAssuranceLevel;
    ctaUrl: Scalars['String']['output'];
};

/** Nav Experience - In App Web Views - experiences that don't need OAuth or SSO */
export type ZHLUrlNavWebViewExperience = ZHLUrlNavExperience & {
    ctaUrl: Scalars['String']['output'];
};

export type ZHLUserAttributes = {
    birthDate?: Maybe<Scalars['String']['output']>;
    cellPhone?: Maybe<Scalars['String']['output']>;
    email?: Maybe<Scalars['String']['output']>;
    maritalStatus?: Maybe<ZHLMaritalStatus>;
    names?: Maybe<Array<ZHLName>>;
    taxpayerID?: Maybe<Scalars['String']['output']>;
};

/**
 * Type denoting the conversation between participants.
 * todo: add styling cues?
 */
export type ZIBSConversation = {
    /** Real-time messaging channel name. */
    channelName?: Maybe<Scalars['String']['output']>;
    /** Switchboard conversation id. */
    conversationId?: Maybe<Scalars['String']['output']>;
    createDate?: Maybe<Scalars['String']['output']>;
    /** List of messages in conversation. */
    messages?: Maybe<Array<ZIBSMessage>>;
    /** Notification connection id from Switchboard. */
    notificationConnectionId?: Maybe<Scalars['String']['output']>;
    /** List of participants in conversation. */
    participants?: Maybe<Array<ZIBSParticipant>>;
    title?: Maybe<Scalars['String']['output']>;
    updateDate?: Maybe<Scalars['String']['output']>;
};

/** Input type for conversation. */
export type ZIBSConversationInput = {
    createDate?: InputMaybe<Scalars['String']['input']>;
    /** List of participants in conversation. */
    participants?: InputMaybe<Array<ZIBSParticipantInput>>;
    title?: InputMaybe<Scalars['String']['input']>;
};

export type ZIBSMessage = {
    /** ZIBSMessage body (JSON) */
    bodyJSON: Scalars['String']['output'];
    /** conversation identifier */
    conversationId?: Maybe<Scalars['String']['output']>;
    /** message identifier */
    messageId: Scalars['String']['output'];
    /** client-generated identifier, which can be used later to fetch messages or dedupe on the client */
    notificationConnectionId: Scalars['String']['output'];
    /** user ID of the sender, typically a ZUID */
    senderID: Scalars['String']['output'];
    /** Date and time the message was sent in UTC format (YYYY-MM-DD'T'HH:mm:ss'Z') */
    sentDateUTC?: Maybe<Scalars['String']['output']>;
    status?: Maybe<ZIBSMessageStatus>;
};

/** Input type for sendZIBSMessage */
export type ZIBSMessageInput = {
    /** Real-time messaging channel name. */
    channelName: Scalars['String']['input'];
    /** Switchboard conversation ID. */
    conversationId?: InputMaybe<Scalars['String']['input']>;
    messageBody: Scalars['String']['input'];
    /** Client-generated UUID, which can be used later to fetch messages or dedupe on the client. */
    notificationConnectionId?: InputMaybe<Scalars['String']['input']>;
};

export type ZIBSMessageStatus = 'DELIVERED' | 'PENDING';

/** ZIBSParticipant in conversation. */
export type ZIBSParticipant = {
    /** ZIBSParticipant's profile picture url */
    avatarUrl?: Maybe<Scalars['String']['output']>;
    id?: Maybe<Scalars['String']['output']>;
    idType?: Maybe<ZIBSUserIdType>;
    name?: Maybe<Scalars['String']['output']>;
    /** Participant's switchboard persona */
    persona?: Maybe<ZIBSPersona>;
    userTitle?: Maybe<Scalars['String']['output']>;
};

/** ZIBSParticipant input type */
export type ZIBSParticipantInput = {
    /** ZIBSParticipant's profile picture url */
    avatarUrl?: InputMaybe<Scalars['String']['input']>;
    id?: InputMaybe<Scalars['String']['input']>;
    idType?: InputMaybe<ZIBSUserIdType>;
    name?: InputMaybe<Scalars['String']['input']>;
    /** Participant's switchboard persona */
    persona?: InputMaybe<ZIBSPersona>;
    userTitle?: InputMaybe<Scalars['String']['input']>;
};

export type ZIBSPersona = 'AGENT' | 'CONSUMER' | 'LOANOFFICER' | 'OTHER' | 'SYSTEM';

export type ZIBSUserIdType = 'ZUID';

export type ZIMChannel = {
    name: Scalars['String']['output'];
    type: ZIMChannelType;
};

export type ZIMChannelType = 'GLOBAL' | 'INBOX';

export type ZIMChannels = {
    channelInfo?: Maybe<Array<Maybe<ZIMChannel>>>;
    config?: Maybe<ZIMPubNubConfig>;
    keys?: Maybe<ZIMKeys>;
    userId: Scalars['String']['output'];
};

export type ZIMConversation = {
    conversationId: Scalars['String']['output'];
    createDate?: Maybe<Scalars['String']['output']>;
    header?: Maybe<ZIMHeader>;
    messages?: Maybe<ZIMMessageResponse>;
    participants?: Maybe<Array<ZIMParticipant>>;
    preview?: Maybe<ZIMMessage>;
    updateDate?: Maybe<Scalars['String']['output']>;
};

export type ZIMConversationmessagesArgs = {
    cursor?: InputMaybe<Scalars['String']['input']>;
    messageLimit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Type used to see if participants have a conversation together.
 * Requires the JWT Auth Header and passed in participantId to determine all the participants.
 * Resolved only via ZG-Graph federated calls to resolve the entity.
 */
export type ZIMConversationParticipantSummary = {
    allParticipantIds: Array<Scalars['String']['output']>;
    participantId: Scalars['String']['output'];
    status: ZIMConversationStatus;
};

export type ZIMConversationStatus = 'DOES_NOT_HAVE_CONVERSATION' | 'HAS_CONVERSATION';

export type ZIMGetAllConversationsResponse = {
    conversations: Array<ZIMConversation>;
};

export type ZIMHeader = {
    id: Scalars['String']['output'];
};

export type ZIMIconType =
    | 'BEST_OF_ZILLOW'
    | 'CALENDAR_TIME_OUTLINE'
    | 'CHECKMARK_CIRCLE_OUTLINE'
    | 'INFO_OUTLINE'
    | 'TOUR_DOOR_FILLED'
    | 'USER_FILLED'
    | 'WARNING_OUTLINE';

export type ZIMKeys = {
    authToken: Scalars['String']['output'];
    publishKey: Scalars['String']['output'];
    subscribeKey: Scalars['String']['output'];
};

export type ZIMMessage = {
    conversationId: Scalars['String']['output'];
    createDate: Scalars['String']['output'];
    messageId: Scalars['String']['output'];
    senderId: Scalars['String']['output'];
    text: Scalars['String']['output'];
};

/** Input type for zimSendMessage mutation */
export type ZIMMessageInput = {
    /** Id generated by the client to track the message */
    clientMessageId?: InputMaybe<Scalars['String']['input']>;
    /** Switchboard conversation ID. */
    conversationId: Scalars['String']['input'];
    messageBody: Scalars['String']['input'];
};

export type ZIMMessageResponse = {
    cursor?: Maybe<Scalars['String']['output']>;
    maxMessages?: Maybe<Scalars['Int']['output']>;
    messageList?: Maybe<Array<ZIMMessage>>;
};

export type ZIMMessagingEligibilityResponse = {
    channels?: Maybe<ZIMChannels>;
    status: ZIMMessagingStatus;
    totalUnreadCount?: Maybe<Scalars['Int']['output']>;
};

export type ZIMMessagingStatus = 'ELIGIBLE' | 'FORCE_UPGRADE' | 'NOT_ELIGIBLE' | 'SUGGEST_UPGRADE';

export type ZIMNoIntroHeader = ZIMHeader & {
    id: Scalars['String']['output'];
};

export type ZIMParticipant = {
    id: Scalars['String']['output'];
    participantDetails: ZIMParticipantDetails;
    persona: ZIMPersona;
    unreadMessageCount: Scalars['Int']['output'];
};

export type ZIMParticipantDetails = PAAgent | User | ZillowMessagingUser;

export type ZIMPersona = 'AGENT' | 'CONSUMER' | 'UNSPECIFIED' | 'ZILLOW';

export type ZIMPersonaIntroHeader = ZIMHeader & {
    id: Scalars['String']['output'];
    persona?: Maybe<ZIMPersona>;
};

export type ZIMPubNubConfig = {
    /**  Milliseconds  */
    clientSubscriptionDelay?: Maybe<Scalars['Int']['output']>;
    /**  Milliseconds  */
    heartbeatInterval?: Maybe<Scalars['Int']['output']>;
    /**  Milliseconds  */
    presenceTimeOut?: Maybe<Scalars['Int']['output']>;
};

export type ZIMReadConversationInput = {
    conversationId: Scalars['String']['input'];
    lastReadMessageId: Scalars['String']['input'];
};

export type ZIMReadConversationResponse = {
    result?: Maybe<ZIMResponseType>;
};

export type ZIMResponseType = 'SUCCESS';

export type ZIMStandardUserMessage = ZIMMessage & {
    clientMessageId?: Maybe<Scalars['String']['output']>;
    conversationId: Scalars['String']['output'];
    createDate: Scalars['String']['output'];
    messageId: Scalars['String']['output'];
    persona?: Maybe<ZIMPersona>;
    senderId: Scalars['String']['output'];
    text: Scalars['String']['output'];
};

export type ZIMSystemConfirmationMessage = ZIMMessage & {
    conversationId: Scalars['String']['output'];
    createDate: Scalars['String']['output'];
    icon?: Maybe<ZIMIconType>;
    messageId: Scalars['String']['output'];
    senderId: Scalars['String']['output'];
    text: Scalars['String']['output'];
};

export type ZMAModel = {
    approveDate?: Maybe<Scalars['DateTime']['output']>;
    comps?: Maybe<Array<Maybe<Property>>>;
    currentProperty?: Maybe<Property>;
    providerInfo?: Maybe<Array<Maybe<ProviderInfo>>>;
    zmaValue?: Maybe<Scalars['Float']['output']>;
    zmaValueHigh?: Maybe<Scalars['Float']['output']>;
    zmaValueLow?: Maybe<Scalars['Float']['output']>;
};

export type ZOAvailabilityCriteriaCheckType = 'CONFIDENT' | 'FULL' | 'NONE' | 'PARTIAL';

/** The listing programs for a given property. Please reach out to ZOAP team (#zo-advisor-platform) for more information. */
export type ZOListingPrograms = {
    amount?: Maybe<Scalars['String']['output']>;
    type?: Maybe<Scalars['String']['output']>;
};

export type ZOUpsellLink = {
    parameters?: Maybe<Array<Maybe<ZOUpsellLinkParameter>>>;
    url?: Maybe<Scalars['String']['output']>;
};

export type ZOUpsellLinkParameter = {
    name?: Maybe<Scalars['String']['output']>;
    value?: Maybe<Scalars['String']['output']>;
};

export type ZOUpsellLinks = {
    /** Zillow Offers landing page */
    zoLandingPage?: Maybe<ZOUpsellLink>;
    /** Zillow Offers questionnaire page */
    zoQuestionnairePage?: Maybe<ZOUpsellLink>;
};

export type ZOUpsellURLs = {
    /** The landing page to open for clicking ZO upsell link */
    landingPage?: Maybe<Scalars['String']['output']>;
    /** The page for requesting an offer for a property */
    requestAnOfferPage?: Maybe<Scalars['String']['output']>;
};

export type ZeliosPermission = {
    objectName: Scalars['String']['input'];
    objectSource: ZeliosPermissionObjectSource;
    permission: Scalars['String']['input'];
};

export type ZeliosPermissionObjectSource = 'ARGS' | 'AUTH_PRINCIPAL' | 'CONTEXT';

export type ZestimateConfidenceLabels = {
    confidenceLabel?: Maybe<Scalars['Int']['output']>;
    regionidcounty?: Maybe<Scalars['Int']['output']>;
    valuationId?: Maybe<Scalars['String']['output']>;
    zpid: Scalars['Int']['output'];
};

export type ZestimateDeepDiveHedonicCompsModel = {
    comps?: Maybe<Array<Maybe<Property>>>;
    estimate?: Maybe<Scalars['Int']['output']>;
};

export type ZestimateDeepDiveListRatioModel = {
    comps?: Maybe<Array<Maybe<Property>>>;
    estimate?: Maybe<Scalars['Int']['output']>;
    listRatio?: Maybe<Scalars['Float']['output']>;
};

export type ZestimateDeepDiveOffMarketModel = {
    estimate?: Maybe<Scalars['Int']['output']>;
};

export type ZestimateDeepDivePriorSaleModel = {
    estimate?: Maybe<Scalars['Int']['output']>;
    soldDate?: Maybe<Scalars['DateTime']['output']>;
    soldPrice?: Maybe<Scalars['Int']['output']>;
    wrsRatio?: Maybe<Scalars['Float']['output']>;
};

export type ZestimateDeepDiveTaxRatioModel = {
    comps?: Maybe<Array<Maybe<Property>>>;
    estimate?: Maybe<Scalars['Int']['output']>;
    regionId?: Maybe<Scalars['ID']['output']>;
    taxAssessmentYear?: Maybe<Scalars['Int']['output']>;
    taxRatio?: Maybe<Scalars['Float']['output']>;
    taxValue?: Maybe<Scalars['Int']['output']>;
    /** @deprecated Use property.taxAssessedYear, as it is the same data */
    taxYear?: Maybe<Scalars['Int']['output']>;
};

export type ZestimateNeuralNetComps = {
    comps?: Maybe<Array<ZestimateNeuralNetComps_Comp>>;
    parcelid?: Maybe<Scalars['Int']['output']>;
    zpid?: Maybe<Scalars['Int']['output']>;
};

export type ZestimateNeuralNetComps2 = {
    comps?: Maybe<Array<ZestimateNeuralNetComps2_Comp>>;
    parcelid?: Maybe<Scalars['Long']['output']>;
    zpid?: Maybe<Scalars['Long']['output']>;
};

export type ZestimateNeuralNetComps2_Comp = {
    rank?: Maybe<Scalars['Long']['output']>;
    zpid?: Maybe<Scalars['Long']['output']>;
};

export type ZestimateNeuralNetComps_Comp = {
    rank?: Maybe<Scalars['Int']['output']>;
    zpid?: Maybe<Scalars['Int']['output']>;
};

export type ZestimateOffMarket = {
    groupId?: Maybe<Scalars['Int']['output']>;
    high?: Maybe<Scalars['Float']['output']>;
    low?: Maybe<Scalars['Float']['output']>;
    score?: Maybe<Scalars['Float']['output']>;
    valuationId?: Maybe<Scalars['String']['output']>;
    zpid: Scalars['Int']['output'];
};

export type ZgAuthZone = 'hotpads' | 'trulia' | 'zillow' | 'zrm';

export type ZhlAgentData = {
    connectionsTotal: Scalars['Int']['output'];
    engagedTransferTotal: Scalars['Int']['output'];
    fundedTransferTotal: Scalars['Int']['output'];
    overallEngagedTransferRate: Scalars['Float']['output'];
    overallTransferRate: Scalars['Float']['output'];
    transferTotal: Scalars['Int']['output'];
    zhlContactRate: Scalars['Float']['output'];
};

export type ZhlAgentReportingDataResponse = {
    agentMetrics?: Maybe<ZhlAgentData>;
    dateRange?: Maybe<ZhlDateRange>;
    filters?: Maybe<ZhlFilters>;
};

export type ZhlDateRange = {
    endDate: Scalars['Date']['output'];
    startDate: Scalars['Date']['output'];
};

export type ZhlFilters = {
    optedIn?: Maybe<Scalars['Boolean']['output']>;
};

export type ZhlFlowType = 'PRE_QUAL';

export type ZhlMacAlertType = 'ACTION_NEEDED' | 'UPDATE_REQUIRED';

export type ZhlMacNextSteps = {
    nextStepsCtaURL: Scalars['String']['output'];
    state: ZhlMacNextStepsState;
    steps: Array<ZhlMacStep>;
    zhlLoanId: Scalars['ID']['output'];
};

export type ZhlMacNextStepsState =
    | 'NEW'
    | 'OUTSTANDING_TASKS'
    | 'VERIFIED_PREAPPROVAL'
    | 'WAITING_TO_CLOSE';

export type ZhlMacPnsStep = {
    status: ZhlMacPnsStepStatus;
    title: Scalars['String']['output'];
};

export type ZhlMacPnsStepStatus = 'COMPLETED' | 'CURRENT' | 'NOT_STARTED';

export type ZhlMacStep = {
    status: ZhlMacStepStatus;
    title: Scalars['String']['output'];
};

export type ZhlMacStepStatus = 'COMPLETED' | 'CURRENT' | 'NOT_STARTED';

export type ZhlMacTask = {
    alertType?: Maybe<ZhlMacAlertType>;
    description: Scalars['String']['output'];
    displayCategory: Scalars['String']['output'];
    displayDateUTC: Scalars['String']['output'];
    id: Scalars['ID']['output'];
    status: ZhlMacTaskStatus;
    title: Scalars['String']['output'];
};

export type ZhlMacTaskByStatus = {
    Complete?: Maybe<Array<ZhlMacTask>>;
    InProgress?: Maybe<Array<ZhlMacTask>>;
    InReview?: Maybe<Array<ZhlMacTask>>;
    NotStarted?: Maybe<Array<ZhlMacTask>>;
};

export type ZhlMacTaskStatus = 'COMPLETE' | 'IN_PROGRESS' | 'IN_REVIEW' | 'NOT_STARTED';

export type ZhlSubmitEvent = UserEvent & {
    /** Events associated with the semantic tag: zhl_submit */
    eventId: Scalars['ID']['output'];
    eventSource: StreamSource;
    eventTime: Scalars['GraphQLLong']['output'];
    /** This is the clickstream event type id */
    eventType: Scalars['String']['output'];
    userZhlPurchaseAttributes?: Maybe<UserZhlPurchaseAttributes>;
    userZhlRefiAttributes?: Maybe<UserZhlRefiAttributes>;
    zhlFlowType: ZhlFlowType;
};

export type ZhlTeamData = {
    agentName?: Maybe<Scalars['String']['output']>;
    connectionsTotal?: Maybe<Scalars['Int']['output']>;
    contactedLeadsCount?: Maybe<Scalars['Int']['output']>;
    creditPullRate?: Maybe<Scalars['Float']['output']>;
    engagedTransferTotal?: Maybe<Scalars['Int']['output']>;
    fundedTransferTotal?: Maybe<Scalars['Int']['output']>;
    fundedZhlLoans?: Maybe<Scalars['Int']['output']>;
    leadToFundRate?: Maybe<Scalars['Float']['output']>;
    lockedLeadRate?: Maybe<Scalars['Float']['output']>;
    metLeadTransferRate?: Maybe<Scalars['Float']['output']>;
    metWithConnectionsTotal?: Maybe<Scalars['Int']['output']>;
    overallEngagedTransferRate?: Maybe<Scalars['Float']['output']>;
    overallTransferRate?: Maybe<Scalars['Float']['output']>;
    preapprovedRate?: Maybe<Scalars['Float']['output']>;
    transferTotal?: Maybe<Scalars['Int']['output']>;
    zhlContactRate?: Maybe<Scalars['Float']['output']>;
};

export type ZhlTeamMetrics = {
    teamConnectionsTotal?: Maybe<Scalars['Int']['output']>;
    teamContactedLeadsCountRate?: Maybe<Scalars['Float']['output']>;
    teamCreditPulledLeadsRate?: Maybe<Scalars['Float']['output']>;
    teamEngagedTransferRate?: Maybe<Scalars['Float']['output']>;
    teamEngagedTransferTotal?: Maybe<Scalars['Int']['output']>;
    teamFundedTransfersTotal?: Maybe<Scalars['Int']['output']>;
    teamLeadToFundRate?: Maybe<Scalars['Float']['output']>;
    teamLockedLeadsRate?: Maybe<Scalars['Float']['output']>;
    teamMetLeadTransferRate?: Maybe<Scalars['Float']['output']>;
    teamMetWithConnectionsRate?: Maybe<Scalars['Float']['output']>;
    teamPreapprovedLeadsRate?: Maybe<Scalars['Float']['output']>;
    teamTransferRate?: Maybe<Scalars['Float']['output']>;
    teamTransferTotal?: Maybe<Scalars['Int']['output']>;
    teamZhlContactRate?: Maybe<Scalars['Float']['output']>;
};

export type ZhlTeamReportingDataResponse = {
    dateRange?: Maybe<ZhlDateRange>;
    filters?: Maybe<ZhlFilters>;
    teamMembers?: Maybe<Array<Maybe<ZhlTeamData>>>;
    teamMetrics?: Maybe<ZhlTeamMetrics>;
};

export type Zhvf = {
    dataValue?: Maybe<Scalars['Float']['output']>;
    growthCumulative?: Maybe<Scalars['Float']['output']>;
    horizonNumMonths?: Maybe<Scalars['Int']['output']>;
    levels?: Maybe<Scalars['Float']['output']>;
    metadataKey: Scalars['String']['output'];
    regionId: Scalars['Int']['output'];
    timePeriodEnd: Scalars['Date']['output'];
};

export type Zhvi = {
    dataValue?: Maybe<Scalars['Float']['output']>;
    metadataKey: Scalars['String']['output'];
    regionId: Scalars['Int']['output'];
    timePeriodEnd: Scalars['Date']['output'];
};

/** entity type: the id struct for Zillow Account only */
export type ZillowAccount = IdBasedWithSource & {
    /** the internal zillow account type of this id */
    accountType: ZillowAccountType;
    /** the internal zillow account type id of this id */
    accountTypeId: Scalars['Int']['output'];
    /** the confidence score about this id and the id's association to the primary id */
    confidence: Scalars['Float']['output'];
    createTime: Scalars['GraphQLLong']['output'];
    id: Scalars['String']['output'];
    idType: IdType;
    lastChecked: Scalars['GraphQLLong']['output'];
    /** the Zillow role for this account */
    role?: Maybe<ZillowPersona>;
    /** the source of this id */
    source: Scalars['String']['output'];
};

/** Zillow User Account types */
export type ZillowAccountType =
    /** 2 */
    | 'ADVERTISER_ACCOUNT'
    /** 13 */
    | 'EMPLOYEE_ACCOUNT'
    /** 10 */
    | 'EXTERNAL_CONNECTION'
    /** 11 */
    | 'FREE_PASS'
    /** 6 */
    | 'NEWSPAPER_FEED_ACCOUNT'
    /** 3 */
    | 'REAL_ESTATE_PRO'
    /** 12 */
    | 'RESTRICTED_ACCOUNT'
    /** 4 */
    | 'SITE_FEEDBACK_SUBMISSION'
    /** 14 */
    | 'UNKNOWN'
    /** 1 */
    | 'USER_ACCOUNT'
    /** 5, not for granting Admin priv. */
    | 'ZILLOW_ADMIN_ACCOUNT';

/** root entity: for z-customer-profile */
export type ZillowCustomerProfile = {
    /**
     * summaries of the user's activities we know of: different types of metrics over different time windows
     * map zcust-sum (total_associated_guid_count)
     * to a UserActivityAggregation (
     * associatedId: primaryId
     * metric: UserActivityMetric.GUID
     * subMetric: GuidSubMetric.UNIQUE_COUNT
     * aggregationType: AggregationType.TOTAL
     * aggregationWindow: AggregationWindow.LIFETIME
     * value: zcust-sum.total_associated_guid_count
     * )
     */
    activitySummary?: Maybe<Array<Maybe<UserActivityAggregation>>>;
    /**
     * the ids associated with this primary id: include the primary id
     * maps each guid in zcust-sum (associated_guids) with idType=GUID
     * for zcust-sum.id_type=="zuid",
     * map zcust-sum (id, account_type_id, account_type, account_create_date, account_last_login_date)
     * to ZillowAccount with idType=ZUID, role=is_agent?ALAN:customer_persona, source=is_agent_source
     * primaryId is one of the identities
     */
    identities?: Maybe<Array<IdBasedWithSource>>;
    /**
     * the primary id for this user profile
     * due to different view points, the primary id may vary in contexts
     * the major difference will be activitySummary: user events are keyed on one id
     * other fields could differ as well
     * we will project what the underlying data supports with no additional data mutation logic
     * For example, if our underlying data supports only primary id as zuid or guid
     * we will be able to serve requests with idFilter on idType = ZUID or GUID only
     * maps to zcust-sum (id_type + id)
     * for zcust-sum.id_type=="zuid",
     * map zcust-sum (id, account_type_id, account_type, account_create_date, account_last_login_date)
     * to ZillowAccount with idType=ZUID, role=is_agent?ALAN:customer_persona, source=is_agent_source
     */
    primaryId: IdBasedWithSource;
    /**
     * propensity scores for this id
     * map zcust-sum (likely_buyer_score_decile, likely_seller_score_decile, likely_renter_score_decile, likely_mortgage_purchase_submitter_score_decile)
     * to a BasicScoringResult each respectively (
     * primaryId as the associatedId,
     * learningModel as (modelName: likely_buyer|seller|renter|..., goal: LearningGoal.PROPENSITY),
     * scoreDecile = the value of zcust-sum.likely_buyer_score_decile, ...
     * )
     */
    propensityScores?: Maybe<Array<Maybe<UserLearningResult>>>;
    /**
     * List of user events, sorted in ascending order by timestamp, that matched the filter query.
     * These are of type com.zillow.customer_data.ues.UserEventStore, which is a reduced version of
     * Clickstream's validated_raw_event schema.
     */
    userEventsBySemanticTags: UserEventsBySemanticTags;
};

/** root entity: for z-customer-profile */
export type ZillowCustomerProfileactivitySummaryArgs = {
    filter?: InputMaybe<UserActivitySummaryFilter>;
};

/** root entity: for z-customer-profile */
export type ZillowCustomerProfilepropensityScoresArgs = {
    filter?: InputMaybe<UserLearningResultFilter>;
};

export type ZillowMessagingUser = {
    name: Scalars['String']['output'];
};

export type ZillowOfferMarketType = {
    code?: Maybe<Scalars['String']['output']>;
    legacyName?: Maybe<Scalars['String']['output']>;
    marketId?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
};

/** Contains resolvers related to the Zillow Offers line-of-business. */
export type ZillowOffers = {
    /**
     * Number of homes we own in a given market, for testing search filter accuracy.
     * @deprecated Deprecated with ZO wind down
     */
    expectedZOCountForMarket?: Maybe<Scalars['Int']['output']>;
    /**
     * True if a zipcode is in an active ZO markets
     * @deprecated Deprecated with ZO wind down
     */
    isZipcodeInZOActiveMarket?: Maybe<Scalars['Boolean']['output']>;
};

/** Contains resolvers related to the Zillow Offers line-of-business. */
export type ZillowOffersexpectedZOCountForMarketArgs = {
    marketShort: Scalars['String']['input'];
};

/** Contains resolvers related to the Zillow Offers line-of-business. */
export type ZillowOffersisZipcodeInZOActiveMarketArgs = {
    includeInactiveZipcode?: InputMaybe<Scalars['Boolean']['input']>;
    zipcode: Scalars['String']['input'];
};

/** Zillow User personas/basic roles */
export type ZillowPersona =
    /** pro personas */
    | 'ALAN'
    | 'AUDREY'
    | 'BETH'
    | 'BRUCE'
    | 'HARRIET'
    | 'IRENE'
    | 'LARRY'
    | 'MELISSA'
    | 'NICOLE'
    | 'PAM'
    | 'PHIL'
    | 'RACHEL'
    | 'RICK'
    | 'RUBEN'
    | 'SEBASTIAN'
    | 'SHELBY'
    /** Error handling */
    | 'UNKNOWN';

/** Client platforms to access Zillow */
export type ZillowPlatform = 'ANDROID' | 'DESKTOP' | 'IOS' | 'MOBILE_WEB' | 'TABLET_WEB';

export type ZillowResoListing = {
    /** The Property includes fields commonly used in a Multiple Listing Service listing. */
    property?: Maybe<ZillowResoProperty>;
};

export type ZillowResoMedia = {
    /** Category describing the Photos, Documents, Video, Unbranded Virtual Tour, Branded Virtual Tour, Floor Plan, Logo */
    mediaCategory?: Maybe<Scalars['String']['output']>;
    /** The URI to the media file referenced by this record. */
    mediaURL?: Maybe<Scalars['String']['output']>;
};

export type ZillowResoProperty = {
    /**
     * The Media is a database and informational representation of media, such as photos, virtual tours, documents/supplements, etc.
     * Please note, we are NOT supporting all the categories of Media in this record like Photo, Logo etc.
     */
    media?: Maybe<Array<ZillowResoMedia>>;
};

/**  Object containing data relevant to a ZillowUser  */
export type ZillowUser = {
    aipersCollections?: Maybe<ZuidAipersCollections>;
    /**  CCD propensity scores, can be null  */
    ccdPropensityScores?: Maybe<Array<Maybe<CCDPropensity>>>;
    /**  the CCD latest denormalized view about the user, can be null  */
    latestCCDView?: Maybe<CCDLatestDenormalizedView>;
    marketingUserProfile?: Maybe<MarketingUserProfile>;
    streamingUserSegmentPersonalization?: Maybe<StreamingUserSegmentPersonalization>;
    upsBDPRealTimeHistograms?: Maybe<ZuidUpsBDPRealTimeHistograms>;
    upsCollectionFeedbackRealTimeHistograms?: Maybe<ZuidUpsCollectionFeedbackRealTimeHistograms>;
    upsForRentLongTermFeatures?: Maybe<ZuidUpsForRentLongTermFeatures>;
    upsForRentRealTimeHistograms?: Maybe<ZuidUpsForRentRealTimeHistograms>;
    upsForSaleBatchOnlyEmbeddings?: Maybe<ZuidUpsForSaleBatchOnlyEmbeddings>;
    upsForSaleBatchOnlyHistograms?: Maybe<ZuidUpsForSaleBatchOnlyHistograms>;
    upsForSaleLongTermFeatures?: Maybe<ZuidUpsForSaleLongTermFeatures>;
    upsForSaleRealTimeHistograms?: Maybe<ZuidUpsForSaleRealTimeHistograms>;
    upsSavedSearchRealTimeFeatures?: Maybe<ZuidUpsSavedSearchRealTimeFeatures>;
    upsSearchRealTimeFeatures?: Maybe<ZuidUpsSearchRealTimeFeatures>;
    zuid: Scalars['String']['output'];
};

/**  Object containing data relevant to a ZillowUser  */
export type ZillowUseraipersCollectionsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing data relevant to a ZillowUser  */
export type ZillowUserstreamingUserSegmentPersonalizationArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing data relevant to a ZillowUser  */
export type ZillowUserupsBDPRealTimeHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing data relevant to a ZillowUser  */
export type ZillowUserupsCollectionFeedbackRealTimeHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing data relevant to a ZillowUser  */
export type ZillowUserupsForRentLongTermFeaturesArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing data relevant to a ZillowUser  */
export type ZillowUserupsForRentRealTimeHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing data relevant to a ZillowUser  */
export type ZillowUserupsForSaleBatchOnlyHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing data relevant to a ZillowUser  */
export type ZillowUserupsForSaleLongTermFeaturesArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing data relevant to a ZillowUser  */
export type ZillowUserupsForSaleRealTimeHistogramsArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing data relevant to a ZillowUser  */
export type ZillowUserupsSavedSearchRealTimeFeaturesArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

/**  Object containing data relevant to a ZillowUser  */
export type ZillowUserupsSearchRealTimeFeaturesArgs = {
    sortKey?: InputMaybe<Scalars['ID']['input']>;
};

export type ZipLevelAnswerRateData = {
    assigneeZillowUserId: Scalars['ID']['output'];
    assigneeZillowUserIdEncoded: Scalars['ID']['output'];
    pickupRates: Array<Maybe<PickUpRate>>;
};

/** Market AB treatments tied to guid */
export type ZoGuidBasedMarketABTestsType = {
    abTest?: Maybe<Scalars['String']['output']>;
};

/** Market AB treatments tied to guid */
export type ZoGuidBasedMarketABTestsTypeabTestArgs = {
    trial?: InputMaybe<Scalars['String']['input']>;
};

export type Zori = {
    dataValue?: Maybe<Scalars['Float']['output']>;
    metadataKey: Scalars['String']['output'];
    regionId: Scalars['Int']['output'];
    timePeriodEnd: Scalars['Date']['output'];
};

/**  Default Experience PersFeeds.Collections feature group generated by AI models for logged in Zillow Users  */
export type ZuidAipersCollections = {
    /**  TODO  */
    collections?: Maybe<Array<ZuidAipersCollections_CollectionsRecord>>;
    /**  ZUID - the Zillow UserID that uniquely identifies logged in Zillow users  */
    zuid: Scalars['String']['output'];
};

/**  Structure used to identify a collection  */
export type ZuidAipersCollections_CollectionFiltersRecord = {
    /**  The set of city Ids in the collection  */
    cities?: Maybe<Array<Scalars['String']['output']>>;
    /**  Interior sqft range  */
    livingAreaSqft?: Maybe<ZuidAipersCollections_MaxMinFieldIntRecord>;
    /**  Price range  */
    price?: Maybe<ZuidAipersCollections_MaxMinFieldIntRecord>;
    /**  A set of property attributes that should be included  */
    showOnly?: Maybe<Array<ZuidAipersCollections_ShowOnlyType>>;
};

/**  Structure used to identify a collection  */
export type ZuidAipersCollections_CollectionIdentifierRecord = {
    /**  TODO  */
    cid?: Maybe<Scalars['Long']['output']>;
    /**  TODO  */
    collectionCat?: Maybe<Scalars['String']['output']>;
    /**  TODO  */
    collectionType?: Maybe<Scalars['String']['output']>;
    /**  TODO  */
    filters?: Maybe<Scalars['JSON']['output']>;
    /**  The location name (ie city/state, neighborhood, etc) of the collection  */
    locationName?: Maybe<Scalars['String']['output']>;
    /**  TODO  */
    ranker?: Maybe<Scalars['String']['output']>;
};

/**  Defines collection treatment records for ZUID/GUID/TUID  */
export type ZuidAipersCollections_CollectionsRecord = {
    /**  Arguments passed to Collections model generator  */
    args?: Maybe<Scalars['String']['output']>;
    /**  TODO  */
    batchOnly?: Maybe<Scalars['Boolean']['output']>;
    /**  TODO  */
    collectionIdentifier?: Maybe<ZuidAipersCollections_CollectionIdentifierRecord>;
    /**  TODO  */
    collectionTimeStamp?: Maybe<Scalars['Long']['output']>;
    /**  TODO  */
    contentType?: Maybe<ZuidAipersCollections_ContentTypeEnum>;
    /**  TODO  */
    features?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    /**  A set of search filters the collection should use  */
    filters?: Maybe<ZuidAipersCollections_CollectionFiltersRecord>;
    /**
     *  Map of optional, or experimental, fields generated for Collections. Keys represent some experimental
     * feature that is being generated and tested. These features and their values are going through an evaluation
     * process to see if they should be permanently added as a field to the Collections schema(s).
     */
    flexFeatures?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  TODO - change to ENUM when implemented - https://docs.google.com/document/d/1GkrOesvEkRyMhZB6AAgq7LznXtzpp52pv4CPCfDgrkw/edit?disco=AAAAgzQBWi8  */
    lExperienceId?: Maybe<Scalars['String']['output']>;
    /**  TODO  */
    name?: Maybe<Scalars['String']['output']>;
    /**  TODO  */
    recs?: Maybe<Array<Scalars['Long']['output']>>;
    /**  TODO  */
    score?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    /**  TODO  */
    tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  TODO  */
    treatmentsToIndex?: Maybe<Scalars['JSON']['output']>;
};

/**  ENUM used to specify ContentType of a collection record  */
export type ZuidAipersCollections_ContentTypeEnum = 'FOR_RENT' | 'FOR_SALE';

/**  A integer range filter  */
export type ZuidAipersCollections_MaxMinFieldIntRecord = {
    /**  Max of integer range  */
    max?: Maybe<Scalars['Int']['output']>;
    /**  Min of integer range  */
    min?: Maybe<Scalars['Int']['output']>;
};

/**  ENUM used to specify an attribute of the property that should be filtered to  */
export type ZuidAipersCollections_ShowOnlyType =
    | 'airConditioning'
    | 'pool'
    | 'waterfront'
    | 'waterview';

/** A type to allow inputs of both zuid and encodedZuid. Prioritizes zuid if both values are passed in. */
export type ZuidInput = {
    /** Encoded zillow user id */
    encodedZuid?: InputMaybe<Scalars['String']['input']>;
    /** Zillow user id */
    zuid?: InputMaybe<Scalars['Int']['input']>;
};

/**  Default Experience BDP feature group for features filtered by logged in Zillow Users  */
export type ZuidUpsBDPRealTimeHistograms = {
    /**  Record containing computed histogram features for a user  */
    histograms?: Maybe<ZuidUpsBDPRealTimeHistograms_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  History of properties viewed by the known Zillow user with the most recent views first  */
    viewHistory?: Maybe<Array<ZuidUpsBDPRealTimeHistograms_ViewHistoryRecord>>;
    /**  ZUID - the Zillow UserID that uniquely identifies logged in Zillow users  */
    zuid: Scalars['String']['output'];
};

/**  Histogram fields/feature group computed for ZUIDs and GUIDs for BDP views  */
export type ZuidUpsBDPRealTimeHistograms_HistogramRecord = {
    /**  The number of bedrooms based on BDP Views  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies cities of the properties viewed, BDP only  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.), based on HDP views only  */
    hdpHouseType?: Maybe<Scalars['JSON']['output']>;
    /**  Distribution of HDP vs. BDP views  */
    hdpView?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  The min number of bedrooms, BDP only  */
    minBedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Min Home price, BDP only  */
    minPrice?: Maybe<Scalars['JSON']['output']>;
    /**  Min Square Feet of the property, BDP only  */
    minSqft?: Maybe<Scalars['JSON']['output']>;
    /**  The number of bedrooms based on HDP and BDP Views, short-term  */
    mixBedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  The number of bedrooms based on HDP and BDP Views, long-term  */
    mixBedroomsLR?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies cities of the properties viewed, BDP and HDP, short term  */
    mixCityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies cities of the properties viewed, BDP and HDP, long term  */
    mixCityRegionIdLR?: Maybe<Scalars['JSON']['output']>;
    /**  Home price from HDP and BDP events, short-term  */
    mixPrice?: Maybe<Scalars['JSON']['output']>;
    /**  Home price from HDP and BDP events, long-term  */
    mixPriceLR?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property, HDP and BDP, short term  */
    mixSqft?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property, HDP and BDP, long term  */
    mixSqftLR?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property, BDP+ HDP, short term  */
    mixZip2?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property, BDP+ HDP, long term  */
    mixZip2LR?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property, BDP+ HDP, short term  */
    mixZip3?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property, BDP+ HDP, long term  */
    mixZip3LR?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property, BDP + HDP, short term  */
    mixZip4?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property, BDP + HDP, long term  */
    mixZip4LR?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property, BDP + HDP, short term  */
    mixZipCode?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property, BDP + HDP, long term  */
    mixZipCodeLR?: Maybe<Scalars['JSON']['output']>;
    /**  Home price from BDP events only  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property, BDP only  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property, BDP  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property, BDP  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property, BDP  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property, BDP  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a zillow property was viewed, and for how long it was viewed, by a user.  */
export type ZuidUpsBDPRealTimeHistograms_ViewHistoryRecord = {
    /**  lotid - Unique identifier for a (rental) building viewed by a user.  */
    lotid?: Maybe<Scalars['String']['output']>;
    /**  providerlistingid - Provider listing ID is what ties a listing to an Agent..  */
    providerlistingid?: Maybe<Scalars['String']['output']>;
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
    /**  ZPID - Unique identifier for a property viewed by a user.  */
    zpid?: Maybe<Scalars['String']['output']>;
};

/**  Default Collection Feedback feature group for features filtered by logged in Zillow Users  */
export type ZuidUpsCollectionFeedbackRealTimeHistograms = {
    /**  Record containing computed histogram features for a user  */
    histograms?: Maybe<ZuidUpsCollectionFeedbackRealTimeHistograms_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  ZUID - the Zillow UserID that uniquely identifies logged in Zillow users  */
    zuid: Scalars['String']['output'];
};

/**  Histogram fields/feature group computed for ZUIDs and GUIDs for Collections Feedback  */
export type ZuidUpsCollectionFeedbackRealTimeHistograms_HistogramRecord = {
    /**
     *  Value indicates the preferences of the user on collection feedback.
     * *  Positive value means like, negative value means dislike.
     */
    collectionFeedback?: Maybe<Scalars['JSON']['output']>;
};

/**  long_term/zillow_for_rent_histograms feature group for ZUIDs, ups-fr-longterm-zh  */
export type ZuidUpsForRentLongTermFeatures = {
    /**  Histograms calculated as part of the For Rent Long Term experience  */
    histograms?: Maybe<ZuidUpsForRentLongTermFeatures_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  History of rental properties viewed by the Zillow user with the most recent views first  */
    viewHistory?: Maybe<Array<ZuidUpsForRentLongTermFeatures_ViewHistoryRecord>>;
    /**  ZUID - the Zillow UserID that uniquely identifies logged in Zillow users  */
    zuid: Scalars['String']['output'];
};

/**  Histogram fields/feature group computed for ZUIDs and GUIDs for long_term/zillow_for_rent_histograms feature group  */
export type ZuidUpsForRentLongTermFeatures_HistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Internal representation for more granular city allocation  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  Rental price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a zillow property was viewed, and for how long it was viewed, by a user.  */
export type ZuidUpsForRentLongTermFeatures_ViewHistoryRecord = {
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
    /**  ZPID - Unique identifier for a property viewed by a user.  */
    zpid?: Maybe<Scalars['String']['output']>;
};

/**
 *  Histograms generated for ZUID-identified (logged in) Zillow users in the context of For Rent properties and near-realtime
 * *  histogram computation (RUFUS).
 */
export type ZuidUpsForRentRealTimeHistograms = {
    /**  Histograms calculated as part of the For Rent Long Term experience  */
    histograms?: Maybe<ZuidUpsForRentRealTimeHistograms_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  History of rental properties viewed by the Zillow user with the most recent views first  */
    viewHistory?: Maybe<Array<ZuidUpsForRentRealTimeHistograms_ViewHistoryRecord>>;
    /**  ZUID - the Zillow UserID that uniquely identifies logged in Zillow users  */
    zuid: Scalars['String']['output'];
};

/**  Record contains realtime time-decayed histogram fields based on rental properties a user has viewed on site.  */
export type ZuidUpsForRentRealTimeHistograms_HistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Internal representation for more granular city allocation  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies whether the land is vacant or not  */
    isVacantLand?: Maybe<Scalars['JSON']['output']>;
    /**  Rental price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a zillow property was viewed, and for how long it was viewed, by a user.  */
export type ZuidUpsForRentRealTimeHistograms_ViewHistoryRecord = {
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
    /**  ZPID - Unique identifier for a property viewed by a user.  */
    zpid?: Maybe<Scalars['String']['output']>;
};

/**
 *  Contains embedding representation generated by AI models for
 * search features filtered by logged in Zillow Users
 */
export type ZuidUpsForSaleBatchOnlyEmbeddings = {
    /**  Embedding representation of a user  */
    embedding?: Maybe<Array<Scalars['Float']['output']>>;
    /**  Metadata of producing entity  */
    version?: Maybe<Scalars['String']['output']>;
    /**  ZUID - the Zillow UserID that uniquely identifies logged in Zillow users  */
    zuid: Scalars['String']['output'];
};

/**
 *  Default Experience feature group for RelevanceMLBatchOnly containing histograms generated by AI models for
 * search features filtered by logged in Zillow Users
 */
export type ZuidUpsForSaleBatchOnlyHistograms = {
    /**  Record containing computed histogram features for a user  */
    histograms?: Maybe<ZuidUpsForSaleBatchOnlyHistograms_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  ZUID - the Zillow UserID that uniquely identifies logged in Zillow users  */
    zuid: Scalars['String']['output'];
};

/**  Histogram fields/feature group computed for ZUIDs and GUIDs as part of the default relevanceMLBatchOnly UPS experience  */
export type ZuidUpsForSaleBatchOnlyHistograms_HistogramRecord = {
    /**  TODO  */
    boroughRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    cityDaysCount?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    cityDaysDiff?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    geohash5?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    geohash5Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    neighborhoodRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    newConstruction?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    priceDaysCount?: Maybe<Scalars['JSON']['output']>;
    /**  TODO  */
    priceDaysDiff?: Maybe<Scalars['JSON']['output']>;
    /**  Histogram of school district ids that reflect the school district preference per user  */
    schoolDistrictIds?: Maybe<Scalars['JSON']['output']>;
};

/**  long_term/zillow_for_sale_histograms feature group for ZUIDs, ups-fs-longterm-zh  */
export type ZuidUpsForSaleLongTermFeatures = {
    /**  Record containing computed histogram features for a user  */
    histograms?: Maybe<ZuidUpsForSaleLongTermFeatures_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  History of properties viewed by the known Zillow user with the most recent views first  */
    viewHistory?: Maybe<Array<ZuidUpsForSaleLongTermFeatures_ViewHistoryRecord>>;
    /**  ZUID - the Zillow UserID that uniquely identifies logged in Zillow users  */
    zuid: Scalars['String']['output'];
};

/**  Histogram fields/feature group computed for ZUIDs and GUIDs for long_term/zillow_for_sale_histograms feature group  */
export type ZuidUpsForSaleLongTermFeatures_HistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  RegionID of the borough, PDA data  */
    boroughRegionId?: Maybe<Scalars['JSON']['output']>;
    /**
     *  the number of days a user had actions on each city and normalized by the total number of active
     * days
     */
    cityDaysCount?: Maybe<Scalars['JSON']['output']>;
    /**
     *  the days difference between a user's latest interaction on a city and the current date
     * and subtracted by the min of days difference.
     */
    cityDaysDiff?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies cities of the properties viewed  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  5 letter/digit string geohash of the geo location of the property, PDA data  */
    geohash5?: Maybe<Scalars['JSON']['output']>;
    /**  geohash5 of the neighborhood, PDA data  */
    geohash5Neighbor?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  was the property vacant  */
    isVacant?: Maybe<Scalars['JSON']['output']>;
    /**  RegionID of the neighborhood, PDA data  */
    neighborhoodRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Boolean histogram for whether the property is a new construction  */
    newConstruction?: Maybe<Scalars['JSON']['output']>;
    /**  Home price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**
     *  the number of days a user had actions on each price range and normalized by the total number of active
     * days
     */
    priceDaysCount?: Maybe<Scalars['JSON']['output']>;
    /**
     *  the days difference between a user's latest interaction on a price range and the current date
     * and subtracted by the min of days difference.
     */
    priceDaysDiff?: Maybe<Scalars['JSON']['output']>;
    /**  distribution of school districts associated with the viewed neighborhoods  */
    schoolDistrictIds?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a zillow property was viewed, and for how long it was viewed, by a user.  */
export type ZuidUpsForSaleLongTermFeatures_ViewHistoryRecord = {
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
    /**  ZPID - Unique identifier for a property viewed by a user.  */
    zpid?: Maybe<Scalars['String']['output']>;
};

/**
 *  Default Experience feature group for RelevanceML containing histograms generated by AI models for search
 * features filtered by logged in Zillow Users
 */
export type ZuidUpsForSaleRealTimeHistograms = {
    /**  Record containing computed histogram features for a user  */
    histograms?: Maybe<ZuidUpsForSaleRealTimeHistograms_HistogramRecord>;
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  History of properties viewed by the known Zillow user with the most recent views first  */
    viewHistory?: Maybe<Array<ZuidUpsForSaleRealTimeHistograms_ViewHistoryRecord>>;
    /**  ZUID - the Zillow UserID that uniquely identifies logged in Zillow users  */
    zuid: Scalars['String']['output'];
};

/**  Histogram fields/feature group computed for ZUIDs and GUIDs as part of the default relevanceML UPS experience  */
export type ZuidUpsForSaleRealTimeHistograms_HistogramRecord = {
    /**  The number of bedrooms  */
    bedrooms?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies cities of the properties viewed  */
    cityRegionId?: Maybe<Scalars['JSON']['output']>;
    /**  Classifies the type of residence (single family, lot/land, apartment, etc.)  */
    houseType?: Maybe<Scalars['JSON']['output']>;
    /**  Boolean histogram for whether the property is a new construction  */
    newConstruction?: Maybe<Scalars['JSON']['output']>;
    /**  Home price  */
    price?: Maybe<Scalars['JSON']['output']>;
    /**  Square Feet of the property  */
    sqft?: Maybe<Scalars['JSON']['output']>;
    /**  2-digit zip code of the viewed property  */
    zip2?: Maybe<Scalars['JSON']['output']>;
    /**  3-digit zip code of the viewed property  */
    zip3?: Maybe<Scalars['JSON']['output']>;
    /**  4-digit zip code of the viewed property  */
    zip4?: Maybe<Scalars['JSON']['output']>;
    /**  5-digit zip code of the viewed property  */
    zipCode?: Maybe<Scalars['JSON']['output']>;
    /**  Specifies zipcode region id of the properties viewed  */
    zipcodeId?: Maybe<Scalars['JSON']['output']>;
};

/**  Specifies at what time a zillow property was viewed, and for how long it was viewed, by a user.  */
export type ZuidUpsForSaleRealTimeHistograms_ViewHistoryRecord = {
    /**  epoch timestamp for when the user viewed the property (specified by zpid)  */
    timestampEpoch?: Maybe<Scalars['Long']['output']>;
    /**  ZPID - Unique identifier for a property viewed by a user.  */
    zpid?: Maybe<Scalars['String']['output']>;
};

/**  Default Search feature group for ZUID  */
export type ZuidUpsSavedSearchRealTimeFeatures = {
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  Record containing computed search features for a user  */
    recentSearches?: Maybe<Array<ZuidUpsSavedSearchRealTimeFeatures_SearchRecord>>;
    /**  ZUID - the Zillow UserID that uniquely identifies logged in Zillow users  */
    zuid: Scalars['String']['output'];
};

/**  History of search related features computed for ZUIDs and GUIDs  */
export type ZuidUpsSavedSearchRealTimeFeatures_SearchRecord = {
    /**  timestamp when search event happens  */
    searchEventTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  contains raw UESV2 search filters where the values of filters are non-null, non-default  */
    searchFilters?: Maybe<ZuidUpsSavedSearchRealTimeFeatures_UpsSearchFiltersSchema>;
};

/**  this block will provide key search filter metadata  */
export type ZuidUpsSavedSearchRealTimeFeatures_UpsSearchFiltersSchema = {
    /**  true if has air conditioning  */
    acInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is accepting backup offers  */
    acceptingBackupOfferInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Represents the credit score for the affordability monthly cost calculation  */
    affordabilityCreditScoreTxt?: Maybe<Scalars['String']['output']>;
    /**  customer can select a down payment to calculate monthly cost  */
    affordabilityDownPaymentNb?: Maybe<Scalars['String']['output']>;
    /**  customer can select monthly cost to filter listings  */
    affordabilityFilterTxt?: Maybe<Scalars['String']['output']>;
    /**  Represents the interest rate for the affordability monthly cost calculation  */
    affordabilityInterestRateNb?: Maybe<Scalars['Float']['output']>;
    /**  Represents the loan term for the affordability monthly cost calculation  */
    affordabilityLoanTermNb?: Maybe<Scalars['Int']['output']>;
    /**  user identified age is 55 or higher  */
    age55PlusInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is all homes  */
    allHomesInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Rachels can indicate if they want an Apartment Community. This is different from the Home Type filter above because Apartment Communities refer specifically s to larger properties that have extra amenities and at least 50 units  */
    apartmentCommunityInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is an apartment  */
    aptInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is an apartment or a condo  */
    aptOrCondoInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is auction  */
    auctionInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Rachel can indicate if she wants a basement, with no options for finished or unfinished basements. Applies only for Rentals Search  */
    basementInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected, this displays the number of bathrooms for that search  */
    bathCntTxt?: Maybe<Scalars['String']['output']>;
    /**  if selected by the user, this displays the highest bedroom count for that search  */
    bedMaxCntTxt?: Maybe<Scalars['String']['output']>;
    /**  if selected by the user, this displays the lowest bedroom count for that search  */
    bedMinCntTxt?: Maybe<Scalars['String']['output']>;
    /**  if selected by the user, this displays the newest year build for that search  */
    builtYearMaxNb?: Maybe<Scalars['Int']['output']>;
    /**  if selected by the user, this displays the oldest year build for that search  */
    builtYearMinNb?: Maybe<Scalars['Int']['output']>;
    /**  boolean if user chose buy  */
    buyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  The filter fields which were changed in the user's most recent filter interaction. E.g. if a user enters a query for 'Seattle WA homes with 3 beds and in unit laundry', this field would be ['custom_region_ids', 'bath_cnt_txt', 'rental_in_unit_laundry_ind']. This is necessary to measure which filters are changed by users  */
    changedFilterFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  true if the filter includes charter schools  */
    charterSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  zillow identier for city included in the search  */
    cityId?: Maybe<Scalars['Int']['output']>;
    /**  this is the city name included in the search  */
    cityNm?: Maybe<Scalars['String']['output']>;
    /**  true if has a city view  */
    cityViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is coming soon  */
    comingSoonInd?: Maybe<Scalars['Boolean']['output']>;
    /**  customer can select a location from autocomplete to commute from it to filter listtings  */
    commuteAutoCompleteTxt?: Maybe<Scalars['String']['output']>;
    /**  This indicates whether the commute destination was selected from the autocomplete results or resolved by query understanding. This field is expected only when the commute destination  field is first set and not on subsequent triggers.  */
    commuteFilterSelectionTypeCd?: Maybe<Scalars['String']['output']>;
    /**  customer can enter an address to commute from it to filter listing  */
    commuteFilterTxt?: Maybe<Scalars['String']['output']>;
    /**  customer can select a max commute travel time including 60,45,30,15, or Any  */
    commuteMaxTravelTimeTxt?: Maybe<Scalars['String']['output']>;
    /**  customer can select a commute mode including car, transit, walk, bicycle  */
    commuteModeCd?: Maybe<Scalars['String']['output']>;
    /**  customer can select a commute time including rush hour, now, off-peak  */
    commuteTimeOfDayTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is a condo  */
    condoInd?: Maybe<Scalars['Boolean']['output']>;
    /**  user identified custom region populates homes within that identified region  */
    customRegionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    /**  user identified region search (used to be assocaited with cd018, customdimension018) - deprecated  */
    customRegionTxt?: Maybe<Scalars['String']['output']>;
    /**  user identified region search (used to be assocaited with cd018, customdimension018), and it can include an array of strings because multiple regions can be searched  */
    customRegionsTxt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  if selected by the user, this displays the number of days this listing has been shown on zillows website  */
    dayOnZillowNb?: Maybe<Scalars['Int']['output']>;
    /**  user identified district id populates homes within that district  */
    districtId?: Maybe<Scalars['String']['output']>;
    /**  true if the filter includes elementary schools  */
    elementarySchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if schools are allowed in the search  */
    enableSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the basement is finished  */
    finishedBasementInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is for rent  */
    forRentInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is fore sale foreclosure  */
    forclosureInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is for sale by agent  */
    fsbaInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is for sale by owner  */
    fsboInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if has a garage  */
    garageInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the ratings of the school  */
    greatSchoolsRatingTxt?: Maybe<Scalars['String']['output']>;
    /**  true if the filter includes high schools  */
    highSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the property is not in an homeowner's association  */
    hoaInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the highest homeowner's association costs allowed for that search  */
    hoaMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  Rachel can indicate whether she wants to search for homes, apartments, townhomes, or a combination of those  */
    homeTypeCd?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  indicates whether search filter housing_connector is checked  */
    housingConnectorInd?: Maybe<Scalars['Boolean']['output']>;
    /**  The unique identifier for each search box interaction. It is used to link requests within a single search box interaction to generate ML training data and produce interaction level metrics on the search box.  */
    interactionId?: Maybe<Scalars['String']['output']>;
    /**  customer inputs keywords to serach for hom. this is provided per search filter definitions: https://gitlab.zgtools.net/zillow/searchxp/search-filter-defs/-/blob/master/filter-definitions.json  */
    keywordsTxt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  True when customer selects list price to filter homes  */
    listPriceInd?: Maybe<Scalars['Boolean']['output']>;
    /**  boolean if user chose “just look around”  */
    lookAroundInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a lot of land  */
    lotLandInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the lot size ceiling for that search  */
    lotSizeSqftMaxNb?: Maybe<Scalars['Float']['output']>;
    /**  if selected by the user, this displays the lot size floor for that search (in feet)  */
    lotSizeSqftMinNb?: Maybe<Scalars['Float']['output']>;
    /**  true if is a manufactured property  */
    manufacturedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the filter includes middle schools  */
    middleSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Return listings where monthly costs fall within the minimum and maximum monthly cost ranges user has entered  */
    monthlyCostPaymentMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  Return listings where monthly costs fall within the minimum and maximum monthly cost ranges user has entered.  */
    monthlyCostPaymentMinAmt?: Maybe<Scalars['Float']['output']>;
    /**  True when customer selects monthly price to filter homes  */
    monthlyPaymentInd?: Maybe<Scalars['Boolean']['output']>;
    /**  maximum amount for the monthly payment for rent search. this is provided per search filter definitions. https://gitlab.zgtools.net/zillow/searchxp/search-filter-defs/-/blob/master/filter-definitions.json  */
    monthlyPaymentMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  minimum amount for the monthly payment for for rent search. this is provided per search filter definitions. https://gitlab.zgtools.net/zillow/searchxp/search-filter-defs/-/blob/master/filter-definitions.json  */
    monthlyPaymentMinAmt?: Maybe<Scalars['Float']['output']>;
    /**  true if is a mountain view  */
    mountainViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this is the date the user selected to move in. The standard format is yyyy-mm-dd.  */
    moveInDt?: Maybe<Scalars['String']['output']>;
    /**  true if is a multi family property  */
    multiFamilyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this is the neighborhood id included in the search  */
    neighborhoodId?: Maybe<Scalars['Int']['output']>;
    /**  this is the neighborhood name included in the search  */
    neighborhoodNm?: Maybe<Scalars['String']['output']>;
    /**  true if is new construction  */
    newConstructionInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is open houses only  */
    onlyOpenHouseInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if properties already have a price reduction  */
    onlyPriceReductionInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if properties must have a photo  */
    onlyWithPhotoInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a park view  */
    parkViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  the number of parking spots at the property (Any, 1+, 2+, 3+, 4+)  */
    parkingSpotTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is pending listings only  */
    pendingListingInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this will capture the point of interest that was either displayed to the user or was selected by the user within their search experience.  */
    poiTxt?: Maybe<Scalars['String']['output']>;
    /**  true if has a pool  */
    poolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is pre market foreclosure  */
    premarketForeclosureInd?: Maybe<Scalars['Boolean']['output']>;
    /**  represents the current value of the premarket pre-foreclosure filter for the user  */
    premarketPreforeclosureInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the price ceiling for that search (applies for for-sale properties)  */
    priceRangeMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  if selected by the user, this displays the price floor for that search (applies for for-sale properties)  */
    priceRangeMinAmt?: Maybe<Scalars['Float']['output']>;
    /**  true if the filter includes private schools  */
    privateSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the filter includes public schools  */
    publicSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  This is either 'FULLY', 'PARTIALLY' or 'FAILED'. It indicates whether the last search box query was understood fully, parts of the query was understood, or the query failed completely. It is used to measure query success rate and impact of failed searches on downstream metrics.  */
    queryResolutionStatusTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is recently sold  */
    recentlySoldInd?: Maybe<Scalars['Boolean']['output']>;
    /**  This is an array of the type (city, neighborhood, zip, borough, etc) of each region in the custom_region_ids field. This is used to measure distribution of searches and understand how user behavior changes based on region type searched (and optimize the search experience based on that)  */
    regionTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  true if rental proeprty allows large pets (dogs)  */
    rentLargePetsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property is accepting applications  */
    rentalAcceptsApplicationInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property allows cats  */
    rentalCatsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the rrental housing is connected  */
    rentalHousingConnectedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if laundry is available in unit  */
    rentalInUnitLaundryInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property is a rental income restricted listing  */
    rentalIncomeRestrictedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the rental is a multi family building  */
    rentalMultiFamilyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the rentals in the dates provided by the user are not available  */
    rentalNotAvailableInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental parking is available  */
    rentalParkingAvailableInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property allows pets (any pets - dogs or cats)  */
    rentalPetsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this is the rental availability date selected in the search  */
    rentalRequestedAvailabilityDt?: Maybe<Scalars['String']['output']>;
    /**  true if rental property allows small pets (dogs)  */
    rentalSmallPetsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  The unique identifier for each request made to the AC / QU API. It is used to join the clickstream logs to the backend logs which contain additional metadata at a request level  */
    requestId?: Maybe<Scalars['String']['output']>;
    /**  True when the search was completed and the room for rent filter was turned on.  */
    roomForRentInd?: Maybe<Scalars['Boolean']['output']>;
    /**  enrollment id is populated when a search is saved  */
    savedSearchEnrollmentId?: Maybe<Scalars['String']['output']>;
    /**  to know what type of school the user is searching for.  */
    schoolClassifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  to know what school district(s) the user is searching for  */
    schoolDistrictIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  to know what school(s) the user is searching for  */
    schoolIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  This is the method the user used to execute their search (AUTOCOMPLETE, MANUAL, RECENT, SAVED_SEARCH, SAVED_HOME, SUGGESTED, CURRENT_LOCATION, etc) It is used to measure distribution of search methods and understand how to further optimize the search experience & build models  */
    searchSelectionTypeTxt?: Maybe<Scalars['String']['output']>;
    /**  This is the type of the result which was selected by the user (ADDRESS, REGION, NATURAL, SCHOOL, BUILDING, COMMUNITY, etc). It is used to measure distribution of search types and understand how to further optimize the search experience & build models.  */
    searchTypeTxt?: Maybe<Scalars['String']['output']>;
    /**  If the search was executed via clicking a result from the search box dropdown list (autocomplete, recent, etc), then this is the index/rank (1 indexed) of the clicked suggestion. If the search was not generated from a click on one of those suggestions, then it should be null. This is necessary to measure the relevance of the autocomplete suggestions  */
    selectionIndexNb?: Maybe<Scalars['Int']['output']>;
    /**  boolean if user chose rent  */
    sellInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the property search requests that its a senior living property  */
    seniorLivingInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if added by the user this is field for extra keywords for the search  */
    seoFieldTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is a single family home  */
    singleFamilyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the property is a 1 story  */
    singleStoryInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the square footage celing for that search  */
    sqftMaxNb?: Maybe<Scalars['Int']['output']>;
    /**  if selected by the user, this displays the square footage floor for that search  */
    sqftMinNb?: Maybe<Scalars['Int']['output']>;
    /**  this is the state name included in the search  */
    stateCd?: Maybe<Scalars['String']['output']>;
    /**  zillow identier for state included in the search  */
    stateId?: Maybe<Scalars['Int']['output']>;
    /**  true if 3d tours are available for the property  */
    tour3dInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a townhouse  */
    townhouseInd?: Maybe<Scalars['Boolean']['output']>;
    /**  This is the understood form of the user's query and is used to know what was the actual search result that the user ended up with after their query  */
    understoodQueryTxt?: Maybe<Scalars['String']['output']>;
    /**  true if the basement is unfinished  */
    unfinishedBasementInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if unrated schools are allowed in the search  */
    unratedSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  the array of words the user typed out in the search field  */
    userSearchTermsTxt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  This is what the user typed in the commute destination field before selecting an autocomplete suggestion or hitting the search button. This field is expected only when the commute destination field is first set and not on subsequent triggers  */
    userTypedCommuteFilterTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is a water view  */
    waterViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a waterfront property  */
    waterfrontInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is zillow owned  */
    zillowOwnedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this is the zip code included in the search  */
    zipCd?: Maybe<Scalars['String']['output']>;
};

/**  Default Search feature group for ZUID  */
export type ZuidUpsSearchRealTimeFeatures = {
    /**  Most recent interaction time in epoch of a click event by the Zillow user  */
    latestInteractionTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  Record containing computed search features for a user  */
    recentSearches?: Maybe<Array<ZuidUpsSearchRealTimeFeatures_SearchRecord>>;
    /**  ZUID - the Zillow UserID that uniquely identifies logged in Zillow users  */
    zuid: Scalars['String']['output'];
};

/**  History of search related features computed for ZUIDs and GUIDs  */
export type ZuidUpsSearchRealTimeFeatures_SearchRecord = {
    /**  timestamp when search event happens  */
    searchEventTimestamp?: Maybe<Scalars['Long']['output']>;
    /**  contains raw UESV2 search filters where the values of filters are non-null, non-default  */
    searchFilters?: Maybe<ZuidUpsSearchRealTimeFeatures_UpsSearchFiltersSchema>;
};

/**  this block will provide key search filter metadata  */
export type ZuidUpsSearchRealTimeFeatures_UpsSearchFiltersSchema = {
    /**  true if has air conditioning  */
    acInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is accepting backup offers  */
    acceptingBackupOfferInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Represents the credit score for the affordability monthly cost calculation  */
    affordabilityCreditScoreTxt?: Maybe<Scalars['String']['output']>;
    /**  customer can select a down payment to calculate monthly cost  */
    affordabilityDownPaymentNb?: Maybe<Scalars['String']['output']>;
    /**  customer can select monthly cost to filter listings  */
    affordabilityFilterTxt?: Maybe<Scalars['String']['output']>;
    /**  Represents the interest rate for the affordability monthly cost calculation  */
    affordabilityInterestRateNb?: Maybe<Scalars['Float']['output']>;
    /**  Represents the loan term for the affordability monthly cost calculation  */
    affordabilityLoanTermNb?: Maybe<Scalars['Int']['output']>;
    /**  user identified age is 55 or higher  */
    age55PlusInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is all homes  */
    allHomesInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Rachels can indicate if they want an Apartment Community. This is different from the Home Type filter above because Apartment Communities refer specifically s to larger properties that have extra amenities and at least 50 units  */
    apartmentCommunityInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is an apartment  */
    aptInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is an apartment or a condo  */
    aptOrCondoInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is auction  */
    auctionInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Rachel can indicate if she wants a basement, with no options for finished or unfinished basements. Applies only for Rentals Search  */
    basementInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected, this displays the number of bathrooms for that search  */
    bathCntTxt?: Maybe<Scalars['String']['output']>;
    /**  if selected by the user, this displays the highest bedroom count for that search  */
    bedMaxCntTxt?: Maybe<Scalars['String']['output']>;
    /**  if selected by the user, this displays the lowest bedroom count for that search  */
    bedMinCntTxt?: Maybe<Scalars['String']['output']>;
    /**  if selected by the user, this displays the newest year build for that search  */
    builtYearMaxNb?: Maybe<Scalars['Int']['output']>;
    /**  if selected by the user, this displays the oldest year build for that search  */
    builtYearMinNb?: Maybe<Scalars['Int']['output']>;
    /**  boolean if user chose buy  */
    buyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  The filter fields which were changed in the user's most recent filter interaction. E.g. if a user enters a query for 'Seattle WA homes with 3 beds and in unit laundry', this field would be ['custom_region_ids', 'bath_cnt_txt', 'rental_in_unit_laundry_ind']. This is necessary to measure which filters are changed by users  */
    changedFilterFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  true if the filter includes charter schools  */
    charterSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  zillow identier for city included in the search  */
    cityId?: Maybe<Scalars['Int']['output']>;
    /**  this is the city name included in the search  */
    cityNm?: Maybe<Scalars['String']['output']>;
    /**  true if has a city view  */
    cityViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is coming soon  */
    comingSoonInd?: Maybe<Scalars['Boolean']['output']>;
    /**  customer can select a location from autocomplete to commute from it to filter listtings  */
    commuteAutoCompleteTxt?: Maybe<Scalars['String']['output']>;
    /**  This indicates whether the commute destination was selected from the autocomplete results or resolved by query understanding. This field is expected only when the commute destination  field is first set and not on subsequent triggers.  */
    commuteFilterSelectionTypeCd?: Maybe<Scalars['String']['output']>;
    /**  customer can enter an address to commute from it to filter listing  */
    commuteFilterTxt?: Maybe<Scalars['String']['output']>;
    /**  customer can select a max commute travel time including 60,45,30,15, or Any  */
    commuteMaxTravelTimeTxt?: Maybe<Scalars['String']['output']>;
    /**  customer can select a commute mode including car, transit, walk, bicycle  */
    commuteModeCd?: Maybe<Scalars['String']['output']>;
    /**  customer can select a commute time including rush hour, now, off-peak  */
    commuteTimeOfDayTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is a condo  */
    condoInd?: Maybe<Scalars['Boolean']['output']>;
    /**  user identified custom region populates homes within that identified region  */
    customRegionIds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
    /**  user identified region search (used to be assocaited with cd018, customdimension018) - deprecated  */
    customRegionTxt?: Maybe<Scalars['String']['output']>;
    /**  user identified region search (used to be assocaited with cd018, customdimension018), and it can include an array of strings because multiple regions can be searched  */
    customRegionsTxt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  if selected by the user, this displays the number of days this listing has been shown on zillows website  */
    dayOnZillowNb?: Maybe<Scalars['Int']['output']>;
    /**  user identified district id populates homes within that district  */
    districtId?: Maybe<Scalars['String']['output']>;
    /**  true if the filter includes elementary schools  */
    elementarySchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if schools are allowed in the search  */
    enableSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the basement is finished  */
    finishedBasementInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is for rent  */
    forRentInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is fore sale foreclosure  */
    forclosureInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is for sale by agent  */
    fsbaInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is for sale by owner  */
    fsboInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if has a garage  */
    garageInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the ratings of the school  */
    greatSchoolsRatingTxt?: Maybe<Scalars['String']['output']>;
    /**  true if the filter includes high schools  */
    highSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the property is not in an homeowner's association  */
    hoaInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the highest homeowner's association costs allowed for that search  */
    hoaMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  Rachel can indicate whether she wants to search for homes, apartments, townhomes, or a combination of those  */
    homeTypeCd?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  indicates whether search filter housing_connector is checked  */
    housingConnectorInd?: Maybe<Scalars['Boolean']['output']>;
    /**  The unique identifier for each search box interaction. It is used to link requests within a single search box interaction to generate ML training data and produce interaction level metrics on the search box.  */
    interactionId?: Maybe<Scalars['String']['output']>;
    /**  customer inputs keywords to serach for hom. this is provided per search filter definitions: https://gitlab.zgtools.net/zillow/searchxp/search-filter-defs/-/blob/master/filter-definitions.json  */
    keywordsTxt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  True when customer selects list price to filter homes  */
    listPriceInd?: Maybe<Scalars['Boolean']['output']>;
    /**  boolean if user chose “just look around”  */
    lookAroundInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a lot of land  */
    lotLandInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the lot size ceiling for that search  */
    lotSizeSqftMaxNb?: Maybe<Scalars['Float']['output']>;
    /**  if selected by the user, this displays the lot size floor for that search (in feet)  */
    lotSizeSqftMinNb?: Maybe<Scalars['Float']['output']>;
    /**  true if is a manufactured property  */
    manufacturedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the filter includes middle schools  */
    middleSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  Return listings where monthly costs fall within the minimum and maximum monthly cost ranges user has entered  */
    monthlyCostPaymentMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  Return listings where monthly costs fall within the minimum and maximum monthly cost ranges user has entered.  */
    monthlyCostPaymentMinAmt?: Maybe<Scalars['Float']['output']>;
    /**  True when customer selects monthly price to filter homes  */
    monthlyPaymentInd?: Maybe<Scalars['Boolean']['output']>;
    /**  maximum amount for the monthly payment for rent search. this is provided per search filter definitions. https://gitlab.zgtools.net/zillow/searchxp/search-filter-defs/-/blob/master/filter-definitions.json  */
    monthlyPaymentMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  minimum amount for the monthly payment for for rent search. this is provided per search filter definitions. https://gitlab.zgtools.net/zillow/searchxp/search-filter-defs/-/blob/master/filter-definitions.json  */
    monthlyPaymentMinAmt?: Maybe<Scalars['Float']['output']>;
    /**  true if is a mountain view  */
    mountainViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this is the date the user selected to move in. The standard format is yyyy-mm-dd.  */
    moveInDt?: Maybe<Scalars['String']['output']>;
    /**  true if is a multi family property  */
    multiFamilyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this is the neighborhood id included in the search  */
    neighborhoodId?: Maybe<Scalars['Int']['output']>;
    /**  this is the neighborhood name included in the search  */
    neighborhoodNm?: Maybe<Scalars['String']['output']>;
    /**  true if is new construction  */
    newConstructionInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is open houses only  */
    onlyOpenHouseInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if properties already have a price reduction  */
    onlyPriceReductionInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if properties must have a photo  */
    onlyWithPhotoInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a park view  */
    parkViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  the number of parking spots at the property (Any, 1+, 2+, 3+, 4+)  */
    parkingSpotTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is pending listings only  */
    pendingListingInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this will capture the point of interest that was either displayed to the user or was selected by the user within their search experience.  */
    poiTxt?: Maybe<Scalars['String']['output']>;
    /**  true if has a pool  */
    poolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is pre market foreclosure  */
    premarketForeclosureInd?: Maybe<Scalars['Boolean']['output']>;
    /**  represents the current value of the premarket pre-foreclosure filter for the user  */
    premarketPreforeclosureInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the price ceiling for that search (applies for for-sale properties)  */
    priceRangeMaxAmt?: Maybe<Scalars['Float']['output']>;
    /**  if selected by the user, this displays the price floor for that search (applies for for-sale properties)  */
    priceRangeMinAmt?: Maybe<Scalars['Float']['output']>;
    /**  true if the filter includes private schools  */
    privateSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the filter includes public schools  */
    publicSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  This is either 'FULLY', 'PARTIALLY' or 'FAILED'. It indicates whether the last search box query was understood fully, parts of the query was understood, or the query failed completely. It is used to measure query success rate and impact of failed searches on downstream metrics.  */
    queryResolutionStatusTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is recently sold  */
    recentlySoldInd?: Maybe<Scalars['Boolean']['output']>;
    /**  This is an array of the type (city, neighborhood, zip, borough, etc) of each region in the custom_region_ids field. This is used to measure distribution of searches and understand how user behavior changes based on region type searched (and optimize the search experience based on that)  */
    regionTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  true if rental proeprty allows large pets (dogs)  */
    rentLargePetsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property is accepting applications  */
    rentalAcceptsApplicationInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property allows cats  */
    rentalCatsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the rrental housing is connected  */
    rentalHousingConnectedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if laundry is available in unit  */
    rentalInUnitLaundryInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property is a rental income restricted listing  */
    rentalIncomeRestrictedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the rental is a multi family building  */
    rentalMultiFamilyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the rentals in the dates provided by the user are not available  */
    rentalNotAvailableInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental parking is available  */
    rentalParkingAvailableInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if rental property allows pets (any pets - dogs or cats)  */
    rentalPetsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this is the rental availability date selected in the search  */
    rentalRequestedAvailabilityDt?: Maybe<Scalars['String']['output']>;
    /**  true if rental property allows small pets (dogs)  */
    rentalSmallPetsAllowedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  The unique identifier for each request made to the AC / QU API. It is used to join the clickstream logs to the backend logs which contain additional metadata at a request level  */
    requestId?: Maybe<Scalars['String']['output']>;
    /**  True when the search was completed and the room for rent filter was turned on.  */
    roomForRentInd?: Maybe<Scalars['Boolean']['output']>;
    /**  enrollment id is populated when a search is saved  */
    savedSearchEnrollmentId?: Maybe<Scalars['String']['output']>;
    /**  to know what type of school the user is searching for.  */
    schoolClassifications?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  to know what school district(s) the user is searching for  */
    schoolDistrictIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  to know what school(s) the user is searching for  */
    schoolIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  This is the method the user used to execute their search (AUTOCOMPLETE, MANUAL, RECENT, SAVED_SEARCH, SAVED_HOME, SUGGESTED, CURRENT_LOCATION, etc) It is used to measure distribution of search methods and understand how to further optimize the search experience & build models  */
    searchSelectionTypeTxt?: Maybe<Scalars['String']['output']>;
    /**  This is the type of the result which was selected by the user (ADDRESS, REGION, NATURAL, SCHOOL, BUILDING, COMMUNITY, etc). It is used to measure distribution of search types and understand how to further optimize the search experience & build models.  */
    searchTypeTxt?: Maybe<Scalars['String']['output']>;
    /**  If the search was executed via clicking a result from the search box dropdown list (autocomplete, recent, etc), then this is the index/rank (1 indexed) of the clicked suggestion. If the search was not generated from a click on one of those suggestions, then it should be null. This is necessary to measure the relevance of the autocomplete suggestions  */
    selectionIndexNb?: Maybe<Scalars['Int']['output']>;
    /**  boolean if user chose rent  */
    sellInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the property search requests that its a senior living property  */
    seniorLivingInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if added by the user this is field for extra keywords for the search  */
    seoFieldTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is a single family home  */
    singleFamilyInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if the property is a 1 story  */
    singleStoryInd?: Maybe<Scalars['Boolean']['output']>;
    /**  if selected by the user, this displays the square footage celing for that search  */
    sqftMaxNb?: Maybe<Scalars['Int']['output']>;
    /**  if selected by the user, this displays the square footage floor for that search  */
    sqftMinNb?: Maybe<Scalars['Int']['output']>;
    /**  this is the state name included in the search  */
    stateCd?: Maybe<Scalars['String']['output']>;
    /**  zillow identier for state included in the search  */
    stateId?: Maybe<Scalars['Int']['output']>;
    /**  true if 3d tours are available for the property  */
    tour3dInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a townhouse  */
    townhouseInd?: Maybe<Scalars['Boolean']['output']>;
    /**  This is the understood form of the user's query and is used to know what was the actual search result that the user ended up with after their query  */
    understoodQueryTxt?: Maybe<Scalars['String']['output']>;
    /**  true if the basement is unfinished  */
    unfinishedBasementInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if unrated schools are allowed in the search  */
    unratedSchoolInd?: Maybe<Scalars['Boolean']['output']>;
    /**  the array of words the user typed out in the search field  */
    userSearchTermsTxt?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /**  This is what the user typed in the commute destination field before selecting an autocomplete suggestion or hitting the search button. This field is expected only when the commute destination field is first set and not on subsequent triggers  */
    userTypedCommuteFilterTxt?: Maybe<Scalars['String']['output']>;
    /**  true if is a water view  */
    waterViewInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is a waterfront property  */
    waterfrontInd?: Maybe<Scalars['Boolean']['output']>;
    /**  true if is zillow owned  */
    zillowOwnedInd?: Maybe<Scalars['Boolean']['output']>;
    /**  this is the zip code included in the search  */
    zipCd?: Maybe<Scalars['String']['output']>;
};

export type autoPublishPastSalesSetting = {
    shouldAutoPublish: Scalars['Boolean']['output'];
    timeUpdatedUTC: Scalars['String']['output'];
};

export type boundingBox = {
    maxLat?: Maybe<Scalars['Float']['output']>;
    maxLon?: Maybe<Scalars['Float']['output']>;
    minLat?: Maybe<Scalars['Float']['output']>;
    minLon?: Maybe<Scalars['Float']['output']>;
};

/** Feature configuration for a new construction builder */
export type builderFeatureConfig = {
    isExclusive?: Maybe<Scalars['Boolean']['output']>;
    zoUpsellLevel?: Maybe<Scalars['Int']['output']>;
    zoUpsellUrl?: Maybe<Scalars['String']['output']>;
};

export type buildingInsights = {
    phrases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    treatmentId?: Maybe<Scalars['String']['output']>;
};

/** Address details for a property */
export type byAddressRentalSearch = {
    floorplans?: Maybe<Array<Maybe<RentalFloorplans>>>;
    geo?: Maybe<geo>;
    similarFloorplans?: Maybe<SimilarRentalFloorplans>;
};

export type covers = {
    /** Is gender identity */
    genderIdentity?: Maybe<Scalars['Boolean']['output']>;
    /** Is housing choice voucher */
    housingChoiceVoucher?: Maybe<Scalars['Boolean']['output']>;
    /** Is sexual orientation */
    sexualOrientation?: Maybe<Scalars['Boolean']['output']>;
    /** Is source of income */
    sourceOfIncome?: Maybe<Scalars['Boolean']['output']>;
};

/** Device types supported by onsiteMessage placements */
export type deviceType = 'desktop' | 'mobile' | 'tablet';

export type downPaymentAssistance = {
    /** The maximum dollar amount of assistance provided by any of the available programs */
    maxAssistance?: Maybe<Scalars['Int']['output']>;
    /** The number of available programs */
    resultCount?: Maybe<Scalars['Int']['output']>;
};

export type dpaRenderParameters = {
    City?: InputMaybe<Scalars['String']['input']>;
    DpaPageLink?: InputMaybe<Scalars['String']['input']>;
    MaxAssistanceAmount?: InputMaybe<Scalars['String']['input']>;
    NumberOfPrograms?: InputMaybe<Scalars['String']['input']>;
    Programs?: InputMaybe<Array<InputMaybe<DpaProgram>>>;
    PropertyAddress?: InputMaybe<Scalars['String']['input']>;
    SalePrice?: InputMaybe<Scalars['String']['input']>;
    SearchResultsPageLink?: InputMaybe<Scalars['String']['input']>;
};

export type enableZMA = {
    /** Error type if any */
    error?: Maybe<Scalars['String']['output']>;
    /** Indicates if the operation was successful */
    success?: Maybe<Scalars['Boolean']['output']>;
};

/** Details about a single estimate for the offer request. */
export type estimate = {
    estimate?: Maybe<Scalars['Float']['output']>;
    estimateType?: Maybe<Scalars['String']['output']>;
};

/** Feature configuration for a new construction community */
export type featureConfig = {
    arePAEmailLeadsEnabled?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Clients should use lead-type-specific PA enablement fields */
    arePALeadsEnabled?: Maybe<Scalars['Boolean']['output']>;
    arePAPhoneLeadsEnabled?: Maybe<Scalars['Boolean']['output']>;
    arePATourLeadsEnabled?: Maybe<Scalars['Boolean']['output']>;
    isExclusive?: Maybe<Scalars['Boolean']['output']>;
    isInPersonTourBookingEnabled?: Maybe<Scalars['Boolean']['output']>;
    isTourBookingEnabled?: Maybe<Scalars['Boolean']['output']>;
    isVirtualTourBookingEnabled?: Maybe<Scalars['Boolean']['output']>;
    zoUpsellLevel?: Maybe<Scalars['Int']['output']>;
    zoUpsellUrl?: Maybe<Scalars['String']['output']>;
};

export type federatedPhoto = {
    caption?: Maybe<Scalars['String']['output']>;
    photoKey?: Maybe<Scalars['String']['output']>;
};

export type geo = {
    lat?: Maybe<Scalars['Float']['output']>;
    lon?: Maybe<Scalars['Float']['output']>;
};

/** Home insights for home features */
export type homeInsights = {
    insights?: Maybe<Array<Maybe<insights>>>;
    palsId?: Maybe<Scalars['String']['output']>;
};

/** Interactive media experience */
export type imx = {
    hasLocalizedPhotos?: Maybe<Scalars['Boolean']['output']>;
    isLmsTour?: Maybe<Scalars['Boolean']['output']>;
    revisionId?: Maybe<Scalars['String']['output']>;
    viewerUrl?: Maybe<Scalars['String']['output']>;
};

/** Insight phrases for home highlights */
export type insights = {
    modelId?: Maybe<Scalars['String']['output']>;
    phrases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    treatmentId?: Maybe<Scalars['String']['output']>;
    updatedTime?: Maybe<Scalars['DateTime']['output']>;
};

export type levelType = {
    /** The geographical level for this protection (eg state, county, or city) */
    level?: Maybe<Scalars['String']['output']>;
    /** lgbtmap.org state page URL */
    statePageUrl?: Maybe<Scalars['String']['output']>;
};

export type listingAgent = {
    associatedAgentType?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoField1?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoField2?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoField3?: Maybe<Scalars['String']['output']>;
    memberFullName?: Maybe<Scalars['String']['output']>;
    memberStateLicense?: Maybe<Scalars['String']['output']>;
};

export type listingMetadata = {
    BuildingDataA?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataB?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataC?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataD?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataE?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataF?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataG?: Maybe<Scalars['String']['output']>;
    BuildingDataH?: Maybe<Scalars['String']['output']>;
    BuildingDataI?: Maybe<Scalars['String']['output']>;
    BuildingDataJ?: Maybe<Scalars['String']['output']>;
    BuildingDataK?: Maybe<Scalars['String']['output']>;
    BuildingDataL?: Maybe<Scalars['String']['output']>;
    BuildingDataM?: Maybe<Scalars['String']['output']>;
    BuildingDataN?: Maybe<Scalars['String']['output']>;
    BuildingDataO?: Maybe<Scalars['String']['output']>;
    BuildingDataP?: Maybe<Scalars['String']['output']>;
    BuildingDataQ?: Maybe<Scalars['String']['output']>;
    BuildingDataR?: Maybe<Scalars['Boolean']['output']>;
    BuildingDataS?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutA?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutAA?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutAB?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutB?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutC?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutD?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutE?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutF?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutG?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutH?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutI?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutJ?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutK?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutL?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutM?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutN?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutO?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutP?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutQ?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutR?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutS?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutT?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutU?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutV?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutW?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutX?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutY?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutZ?: Maybe<Scalars['Boolean']['output']>;
    /** @deprecated Use the camel-cased version instead */
    HidePriceAdjustmentFlexField?: Maybe<Scalars['Boolean']['output']>;
    attributeAgentAttributionContact?: Maybe<Scalars['Boolean']['output']>;
    attributeListingAttributionContact?: Maybe<Scalars['Boolean']['output']>;
    attributeOfficeAttributionContact?: Maybe<Scalars['Boolean']['output']>;
    canCommingleComparables?: Maybe<Scalars['Boolean']['output']>;
    canShowAutomatedValuationDisplay?: Maybe<Scalars['Boolean']['output']>;
    canShowComparables?: Maybe<Scalars['Boolean']['output']>;
    canShowCroppedPhotos?: Maybe<Scalars['Boolean']['output']>;
    canShowNonIDXMedia?: Maybe<Scalars['Boolean']['output']>;
    canShowOnMap?: Maybe<Scalars['Boolean']['output']>;
    canShowPrequalifiedLinkInChip?: Maybe<Scalars['Boolean']['output']>;
    canShowPriceHistory?: Maybe<Scalars['Boolean']['output']>;
    canShowPropertyContingency?: Maybe<Scalars['Boolean']['output']>;
    canShowPropertyPetsAllowed?: Maybe<Scalars['Boolean']['output']>;
    canShowTaxHistory?: Maybe<Scalars['Boolean']['output']>;
    canShowUserGeneratedContent?: Maybe<Scalars['Boolean']['output']>;
    canShowZillowLogoInHeader?: Maybe<Scalars['Boolean']['output']>;
    comminglingCategory?: Maybe<Scalars['Boolean']['output']>;
    comminglingCategoryIsRulesApplicable?: Maybe<Scalars['Boolean']['output']>;
    hidePriceAdjustmentFlexField?: Maybe<Scalars['Boolean']['output']>;
    isAdsRestricted?: Maybe<Scalars['Boolean']['output']>;
    isSuperTrafficOptimized?: Maybe<Scalars['Boolean']['output']>;
    mustAttributeOfficeNameBeforeAgentName?: Maybe<Scalars['Boolean']['output']>;
    mustAttributeTeamNameBeforeAgentName?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayAttributionAboveLocalFacts?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayAttributionListAgentEmail?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayAttributionListAgentPhone?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayAttributionListAgentPhoneExtension?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayAttributionListingOfficePhone?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayAuctionStatusAsSold?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayDisclaimerBelowAttribution?: Maybe<Scalars['Boolean']['output']>;
    mustDisplayFeedLogoInContactBox?: Maybe<Scalars['Boolean']['output']>;
    mustHighlightAgentName?: Maybe<Scalars['Boolean']['output']>;
    mustHighlightListOfficeName?: Maybe<Scalars['Boolean']['output']>;
    mustHighlightMarketingType?: Maybe<Scalars['Boolean']['output']>;
    mustHighlightMlsId?: Maybe<Scalars['Boolean']['output']>;
    mustHighlightMlsStatus?: Maybe<Scalars['Boolean']['output']>;
    mustMakeListingAgentContactable?: Maybe<Scalars['Boolean']['output']>;
    mustPreferMlsPhotos?: Maybe<Scalars['Boolean']['output']>;
    passwordRequiredForZestimateMarketAnalysis?: Maybe<Scalars['Boolean']['output']>;
};

export type listingOffice = {
    associatedOfficeType?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoField1?: Maybe<Scalars['String']['output']>;
    /** @deprecated Use non-obfuscated information instead */
    infoField2?: Maybe<Scalars['String']['output']>;
    officeName?: Maybe<Scalars['String']['output']>;
};

export type localProtections = {
    /**
     * LGBT community at the <state|county|city> level
     * @deprecated Removed in v2 of the API
     */
    level?: Maybe<Scalars['String']['output']>;
    /** Geographical information for the legal protections in the response */
    protectionLevels?: Maybe<protectionLevels>;
    /** List of legal protections included in response */
    protectionTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** List of legal protection statuses */
    protections?: Maybe<Array<Maybe<protections>>>;
    /**
     * lgbtmap.org state page URL
     * @deprecated Removed in v2 of the API
     */
    statePageUrl?: Maybe<Scalars['String']['output']>;
};

export type mfaEnabledData = {
    /** If MFA is enabled for the account */
    enabled?: Maybe<Scalars['Boolean']['output']>;
    /** The phone number associated with the MFA */
    phoneNo?: Maybe<Scalars['String']['output']>;
};

export type nameUpdate = {
    /** Error type if any */
    error?: Maybe<Scalars['String']['output']>;
    /** Indicates if the operation was successful */
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type ncSelfTourAvailableTimes = {
    /** Length of time in minutes */
    duration?: Maybe<Scalars['Int']['output']>;
    /** List of time objects */
    times?: Maybe<Array<Maybe<TourTime>>>;
};

/** An offer presentation of an offer request */
export type offer = {
    createDate?: Maybe<Scalars['DateTime']['output']>;
    feesBreakdownAvailable?: Maybe<Scalars['Boolean']['output']>;
    hasNewConstructionFee?: Maybe<Scalars['Boolean']['output']>;
    traditionalClosingCosts?: Maybe<Scalars['Int']['output']>;
    traditionalHoldingCostsPercent?: Maybe<Scalars['Float']['output']>;
    traditionalTotalAgentCommissionPercent?: Maybe<Scalars['Float']['output']>;
    zillowBuyerAgentCommissionPercent?: Maybe<Scalars['Float']['output']>;
    zillowClosingCosts?: Maybe<Scalars['Int']['output']>;
    zillowClosingCostsPercent?: Maybe<Scalars['Float']['output']>;
    zillowConvenienceCharge?: Maybe<Scalars['Int']['output']>;
    zillowConvenienceChargePercent?: Maybe<Scalars['Float']['output']>;
    zillowDaysOnMarket?: Maybe<Scalars['Int']['output']>;
    zillowEstimatedNetProceeds?: Maybe<Scalars['Int']['output']>;
    zillowHoldingCosts?: Maybe<Scalars['Int']['output']>;
    zillowHoldingCostsPercent?: Maybe<Scalars['Float']['output']>;
    zillowMakeReadyIncludedInFeeAmount?: Maybe<Scalars['Int']['output']>;
    zillowMarketDepreciation?: Maybe<Scalars['Int']['output']>;
    zillowMarketDepreciationPercent?: Maybe<Scalars['Float']['output']>;
    zillowMarketValue?: Maybe<Scalars['Int']['output']>;
    zillowRepairCosts?: Maybe<Scalars['Int']['output']>;
    zillowSellingCosts?: Maybe<Scalars['Int']['output']>;
    zillowSellingCostsPercent?: Maybe<Scalars['Float']['output']>;
};

export type pals = {
    name?: Maybe<Scalars['String']['output']>;
    palsId?: Maybe<Scalars['String']['output']>;
};

export type passwordReset = {
    /** Error type if any */
    error?: Maybe<Scalars['String']['output']>;
    /** Indicates if the operation was successful */
    success?: Maybe<Scalars['Boolean']['output']>;
};

/** Posting Contact fields subset. */
export type postingContact = {
    brokerName?: Maybe<Scalars['String']['output']>;
    brokerageName?: Maybe<Scalars['String']['output']>;
    /** Name of the listing provider contact. */
    name?: Maybe<Scalars['String']['output']>;
    photo?: Maybe<Photo>;
};

/** Posting Contact fields subset. */
export type postingContactphotoArgs = {
    size?: InputMaybe<PropertyPhotoSize>;
};

/** Price My Rental namespace for queries to the Rentals service. */
export type priceMyRental = {
    /** Full street address for property */
    byAddress?: Maybe<byAddressRentalSearch>;
};

/** Price My Rental namespace for queries to the Rentals service. */
export type priceMyRentalbyAddressArgs = {
    fullAddress?: InputMaybe<Scalars['String']['input']>;
    unit?: InputMaybe<Scalars['String']['input']>;
};

export type profile = {
    isAgent?: Maybe<Scalars['Boolean']['output']>;
    isDteRenter?: Maybe<Scalars['Boolean']['output']>;
    isLandlordLiaisonMember?: Maybe<Scalars['Boolean']['output']>;
    isLlpRenter?: Maybe<Scalars['Boolean']['output']>;
};

export type propertyTourOptions = {
    /** indicates whether or not ShowingTime is being called to determine availability */
    isFinal?: Maybe<Scalars['Boolean']['output']>;
    /** availability in list form for this property if eligible for a PA property tour */
    tourAvailability?: Maybe<Array<Maybe<PropertyTourAvailability>>>;
    /** string representation of the tour type, e.g. "STANDARD", "INSTANT", "INSTANT_BOOK", "NONE" */
    tourType?: Maybe<Scalars['String']['output']>;
};

export type protectionLevels = {
    /** Describes sexual orientation and gender identity */
    lgbt?: Maybe<levelType>;
    /** Describes source of income */
    soi?: Maybe<levelType>;
    /** Describes housing choice voucher */
    voucher?: Maybe<levelType>;
};

export type protections = {
    /** Covers of a protection */
    covers?: Maybe<covers>;
    /** Description of a protection */
    description?: Maybe<Scalars['String']['output']>;
    /** Type of a protection */
    type?: Maybe<Scalars['String']['output']>;
};

export type recommendedPropertyOrBuilding = {
    building?: Maybe<Building>;
    property?: Maybe<Property>;
};

export type rentalUpdate = {
    ago?: Maybe<Scalars['String']['output']>;
    date?: Maybe<Scalars['DateTime']['output']>;
};

export type richMedia = {
    floorPlan?: Maybe<Array<Maybe<richMediaFloorPlan>>>;
    imx?: Maybe<Array<Maybe<imx>>>;
    palsIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    virtualTour?: Maybe<Array<Maybe<richMediaVirtualTour>>>;
};

export type richMediaFloorPlan = {
    floorMapGuid?: Maybe<Scalars['String']['output']>;
    heroImageUrl?: Maybe<Scalars['String']['output']>;
    viewerUrl?: Maybe<Scalars['String']['output']>;
};

export type richMediaVideos = {
    hlsUrl?: Maybe<Scalars['String']['output']>;
    mp4Url?: Maybe<Scalars['String']['output']>;
    palsIds?: Maybe<Scalars['String']['output']>;
};

export type richMediaVirtualTour = {
    isLmsTour?: Maybe<Scalars['Boolean']['output']>;
    revisionId?: Maybe<Scalars['String']['output']>;
    viewerUrl?: Maybe<Scalars['String']['output']>;
    vrModelGuid?: Maybe<Scalars['String']['output']>;
};

export type selfTour = {
    /** True if self-tour is enabled for property. */
    hasSelfTour?: Maybe<Scalars['Boolean']['output']>;
    /** Information about the model home where the tour will take place. */
    modelHomeInfo?: Maybe<ModelHomeInfo>;
    /** Name of internal self tour data provider. */
    provider?: Maybe<SelfTourProviderEnumType>;
    /** Third party URL used to direct users to in order to book self tours. */
    tourBookingUrl?: Maybe<Scalars['String']['output']>;
    /** ID string of third party tour provider. */
    vendorId?: Maybe<Scalars['String']['output']>;
    /** Third party URL where visitor terms are displayed for property tour. */
    visitorTermsUrl?: Maybe<Scalars['String']['output']>;
};

export type sellingSoonModel = {
    modelId?: Maybe<Scalars['String']['output']>;
    percentile?: Maybe<Scalars['Float']['output']>;
    treatmentId?: Maybe<Scalars['String']['output']>;
};

export type sendEmail = {
    /** Error type if any */
    error?: Maybe<Scalars['String']['output']>;
    /** Indicates if the operation was successful */
    success?: Maybe<Scalars['Boolean']['output']>;
};

export type thirdPartyVirtualTour = {
    /** Whether the virtual tour provider is approved AND we know how to parse it */
    approved?: Maybe<Scalars['Boolean']['output']>;
    /** Url to be linked to when embedding is not supported yet */
    externalUrl?: Maybe<Scalars['String']['output']>;
    /** Label used to match third party tours to specific locations in a building, can be null */
    label?: Maybe<Scalars['String']['output']>;
    /** Url to be embedded in the light box, can be null */
    lightboxUrl?: Maybe<Scalars['String']['output']>;
    /** Friendly key for the provider */
    providerKey?: Maybe<ApprovedThirdPartyVirtualTourProviderKeys>;
    /** Friendly name for the provider */
    providerName?: Maybe<Scalars['String']['output']>;
    /** Url to a static image to be used as a placeholder in the media stream, can be null */
    staticUrl?: Maybe<Scalars['String']['output']>;
};

/** Types defined for PropertyTours in GDP (must be kept in sync) */
export type tourEligibility = {
    /** boolean indicating if this property is eligible for a PA property tour */
    isPropertyTourEligible?: Maybe<Scalars['Boolean']['output']>;
    /**
     * availability in list form for this property if eligible for a PA property tour
     * @deprecated Use property.tourEligibility.propertyTourOptions.tourAvailability.
     */
    propertyTourAvailability?: Maybe<Array<Maybe<PropertyTourAvailability>>>;
    propertyTourOptions?: Maybe<propertyTourOptions>;
    /**
     * string representation of the tour type, e.g. "STANDARD", "INSTANT", "INSTANT_BOOK", "NONE"
     * @deprecated Use property.tourEligibility.propertyTourOptions.tourType.
     */
    propertyTourType?: Maybe<Scalars['String']['output']>;
};

/** Types defined for PropertyTours in GDP (must be kept in sync) */
export type tourEligibilitypropertyTourAvailabilityArgs = {
    platform?: InputMaybe<PropertyTourPlatform>;
    supportedTourTypes?: InputMaybe<Array<InputMaybe<PropertyTourAvailabilityType>>>;
    type?: InputMaybe<PropertyTourAvailabilityType>;
    useAsyncAb?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Types defined for PropertyTours in GDP (must be kept in sync) */
export type tourEligibilitypropertyTourOptionsArgs = {
    platform?: InputMaybe<PropertyTourPlatform>;
    supportedTourTypes?: InputMaybe<Array<InputMaybe<PropertyTourAvailabilityType>>>;
    type?: InputMaybe<PropertyTourAvailabilityType>;
    useAsyncAb?: InputMaybe<Scalars['Boolean']['input']>;
};

export type trackingTags = {
    hrsRequestId?: Maybe<Scalars['String']['output']>;
};

export type vrModel = {
    cdnHost?: Maybe<Scalars['String']['output']>;
    posterUrl?: Maybe<Scalars['String']['output']>;
    revisionId?: Maybe<Scalars['String']['output']>;
    vrModelGuid?: Maybe<Scalars['String']['output']>;
};

export type zestimateDeepDiveData = {
    /** A breakout of the comps component of the zestimate */
    hedonicCompsModel?: Maybe<ZestimateDeepDiveHedonicCompsModel>;
    /** A breakout of the ratio of list price to sale price component of the zestimate */
    listRatioModel?: Maybe<ZestimateDeepDiveListRatioModel>;
    /** An estimate of what the zestimate would be for off-market properties */
    offMarketModel?: Maybe<ZestimateDeepDiveOffMarketModel>;
    /** A breakout of the ratio of previous sale price to sale price component of the zestimate */
    priorSaleModel?: Maybe<ZestimateDeepDivePriorSaleModel>;
    /** A breakout of the ratio of tax value to sale price component of the zestimate */
    taxRatioModel?: Maybe<ZestimateDeepDiveTaxRatioModel>;
    /** @deprecated Use properly schema-typed siblings instead */
    zestimateDeepDiveResponseObject?: Maybe<Scalars['String']['output']>;
    /** the ZMA Model for the property */
    zmaModel?: Maybe<ZMAModel>;
};

export type zoAvailability = {
    /** Whether the property is available for an upsell */
    available?: Maybe<Scalars['Boolean']['output']>;
    /** The lead which this zpid qualifies for, which determines which upsell to display */
    leadType?: Maybe<Scalars['String']['output']>;
};

export type zoStatics = {
    /** Versions of the value indexed by reno spec level */
    atSpecLevel?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** The default value for a given key */
    default?: Maybe<Scalars['String']['output']>;
};

export type zoUpsellDisplayFlags = {
    /** Whether to display Zillow Offers For Sale Upsell */
    showForSaleUpsell?: Maybe<Scalars['Boolean']['output']>;
    /** Whether to display Zillow Offers Off Market Upsell */
    showOffMarketUpsell?: Maybe<Scalars['Boolean']['output']>;
    /** Whether to display Zillow Offers Owner View Upsell */
    showOwnerViewUpsell?: Maybe<Scalars['Boolean']['output']>;
};

export type zoUpsellDisplayInfo = {
    /** Whether to display an upsell */
    display?: Maybe<Scalars['Boolean']['output']>;
    /** An object containing attributes used for displaying upsell serialized as JSON */
    displayAttributes?: Maybe<Scalars['JSON']['output']>;
    /** A value to tell why upsell is displaying */
    displayCategory?: Maybe<Scalars['String']['output']>;
    /** A list of all eligible lead types with OASIS Priority */
    eligibleLeadTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
    /** A list of all entry action links for eligibleLeadTypes */
    entryActionLinks?: Maybe<Array<Maybe<EntryActionLink>>>;
    /**
     * A boolean indicate whether the home passes ZO full criteria check.ZO full
     * criteria means for data of bedrooms, yearBuilt and LivingSquareFeet of the ZO
     * property, source should be reliable.
     */
    isEligibleZOFullCriteria?: Maybe<Scalars['Boolean']['output']>;
    /**
     * A temporary boolean value that indicate whether the ZO_SO_QUESTIONNAIRE Market trial is enabled/On
     * @deprecated SO questionnaire experiment is done, it will always be on.
     */
    isSOQuestionnaireTrialOn?: Maybe<Scalars['Boolean']['output']>;
    links?: Maybe<ZOUpsellLinks>;
    /** ID for the placement indicating where the upsell is displayed on the surface */
    placementId?: Maybe<Scalars['String']['output']>;
    /** The reason why an upsell is turned on or off */
    reason?: Maybe<Scalars['String']['output']>;
    /** ID for the surface on which the upsell is displayed */
    surfaceId?: Maybe<Scalars['String']['output']>;
    /** The treatment for which an upsell should be using */
    treatment?: Maybe<Scalars['String']['output']>;
    /** @deprecated Prefer using links */
    urls?: Maybe<ZOUpsellURLs>;
};

export type getHomeRecsQueryVariables = Exact<{ [key: string]: never }>;

export type getHomeRecsQuery = {
    collections?: {
        collections?: Array<{
            __typename: 'Collection';
            contentType?: CollectionContentType | null;
            name: string;
            caption?: string | null;
            recs?: Array<{
                id?: { type: string; value: string } | null;
                recsTags?: Array<{ type: string; value: string } | null> | null;
                heroImage?: {
                    id?: string | null;
                    defaultLink?: string | null;
                    mediumSizeLink?: string | null;
                    highResolutionLink?: string | null;
                } | null;
            } | null> | null;
            link?: { displayText: string; url: string } | null;
            trackingTags?: Array<{ type: string; value: string } | null> | null;
            propertyDetails?: Array<{
                bedrooms?: number | null;
                bathrooms?: number | null;
                buildingId?: string | null;
                country?: CountryCode | null;
                currency?: CurrencyType | null;
                hdpUrl?: string | null;
                newConstructionType?: NewConstructionType | null;
                price?: number | null;
                pslHomeType?: string | null;
                pslMarketingStatus?: string | null;
                pslProviderCategory?: string | null;
                pslRawHomeStatus?: string | null;
                videoId?: string | null;
                isZillowOwned?: boolean | null;
                zestimate?: number | null;
                pslPublicForeclosureStage?: string | null;
                listingStatusChangeDate?: any | null;
                livingAreaValue?: number | null;
                isRecentStatusChange?: boolean | null;
                isPremierBuilder?: boolean | null;
                isNonOwnerOccupied?: boolean | null;
                isSavedByCurrentSignedInUser?: boolean | null;
                zpid?: number | null;
                address?: {
                    city?: string | null;
                    state?: string | null;
                    streetAddress?: string | null;
                    zipcode?: string | null;
                } | null;
                attributionInfo?: {
                    brokerName?: string | null;
                    brokerPhoneNumber?: string | null;
                    mlsId?: string | null;
                    mlsName?: string | null;
                    agentName?: string | null;
                    agentPhoneNumber?: string | null;
                    providerLogo?: string | null;
                } | null;
                building?: { buildingName?: string | null } | null;
                photos?: Array<{
                    url?: string | null;
                    width?: number | null;
                    height?: number | null;
                } | null> | null;
                listingMetadata?: { isAdsRestricted?: boolean | null } | null;
            } | null> | null;
        } | null> | null;
        trackingTags?: Array<{ type: string; value: string } | null> | null;
    } | null;
};

export type getOmpDataQueryVariables = Exact<{
    placements?: InputMaybe<
        Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
    >;
    isCarouselAdsRestricted?: InputMaybe<Scalars['Boolean']['input']>;
    deviceType?: InputMaybe<deviceType>;
    surfaceId?: InputMaybe<Scalars['String']['input']>;
    platform?: InputMaybe<Scalars['String']['input']>;
}>;

export type getOmpDataQuery = {
    onsiteMessage?: {
        messages?: Array<{
            skipDisplayReason?: string | null;
            shouldDisplay: boolean;
            isGlobalHoldout: boolean;
            isPlacementHoldout: boolean;
            placementName: string;
            testPhase: MessageTestPhaseType;
            bucket: MessageAbBucketType;
            placementId: number;
            passThrottle: boolean;
            lastModified: string;
            eventId?: string | null;
            decisionContext?: any | null;
            selectedTreatment?: {
                id: number;
                name: string;
                component?: string | null;
                status: MessageTreatmentStatusType;
                renderingProps?: any | null;
                lastModified: string;
            } | null;
            qualifiedTreatments?: Array<{
                id: number;
                name: string;
                status: MessageTreatmentStatusType;
                lastModified: string;
            } | null> | null;
        } | null> | null;
    } | null;
};

export type getYourTeamBCQueryVariables = Exact<{
    refId?: InputMaybe<Scalars['String']['input']>;
    refType?: InputMaybe<BridgeParticipantReferenceType>;
}>;

export type getYourTeamBCQuery = {
    bridgeContainer?: {
        moves: Array<{
            buy: Array<{ id: string }>;
            team: {
                agents: Array<{
                    zuid?: string | null;
                    participatingComponents: Array<{ componentId: string } | null>;
                    paAgent?: {
                        name?: string | null;
                        businessName?: string | null;
                        email?: string | null;
                        phone?: string | null;
                        photoUrl?: string | null;
                        hasPremierAgent: boolean;
                        profile?: {
                            officeCity?: string | null;
                            officeState?: string | null;
                            profileUrl?: string | null;
                            ratingAverage?: number | null;
                            ratingCount?: number | null;
                        } | null;
                    } | null;
                }>;
            };
        }>;
    } | null;
    viewer?: { firstName?: string | null } | null;
};

export const getHomeRecsDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getHomeRecs' },
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'collections' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'cExperienceId' },
                                value: {
                                    kind: 'StringValue',
                                    value: 'zillowWebHomePageCollections',
                                    block: false,
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'collections' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: '__typename' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'contentType' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'recs' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'id' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'type',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'value',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'recsTags',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'type',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'value',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'heroImage',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'id',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'defaultLink',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'mediumSizeLink',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'highResolutionLink',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'name' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'caption' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'contentType' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'link' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'displayText',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'url' },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'trackingTags' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'type' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'value' },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'propertyDetails' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'address',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'city',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'state',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'streetAddress',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'zipcode',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'attributionInfo',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'brokerName',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'brokerPhoneNumber',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'mlsId',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'mlsName',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'agentName',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'agentPhoneNumber',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'providerLogo',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'bedrooms',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'bathrooms',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'building',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'buildingName',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'buildingId',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'country',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'currency',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'hdpUrl' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'newConstructionType',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'price' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'pslHomeType',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'pslMarketingStatus',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'pslProviderCategory',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'pslRawHomeStatus',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'videoId',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'isZillowOwned',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'zestimate',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'pslPublicForeclosureStage',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'listingStatusChangeDate',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'livingAreaValue',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'isRecentStatusChange',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'isPremierBuilder',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'isNonOwnerOccupied',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'isSavedByCurrentSignedInUser',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'photos' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'url',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'width',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'height',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'zpid' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'listingMetadata',
                                                            },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'isAdsRestricted',
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'trackingTags' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'type' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'value' },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<getHomeRecsQuery, getHomeRecsQueryVariables>;
export const getOmpDataDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getOmpData' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'placements' } },
                    type: {
                        kind: 'ListType',
                        type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                    },
                },
                {
                    kind: 'VariableDefinition',
                    variable: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'isCarouselAdsRestricted' },
                    },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'deviceType' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'deviceType' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'surfaceId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'platform' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'onsiteMessage' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'placementNames' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'placements' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'placementData' },
                                value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                        {
                                            kind: 'ObjectField',
                                            name: {
                                                kind: 'Name',
                                                value: 'isCarouselAdsRestricted',
                                            },
                                            value: {
                                                kind: 'Variable',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'isCarouselAdsRestricted',
                                                },
                                            },
                                        },
                                        {
                                            kind: 'ObjectField',
                                            name: { kind: 'Name', value: 'deviceType' },
                                            value: {
                                                kind: 'Variable',
                                                name: { kind: 'Name', value: 'deviceType' },
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'surfaceId' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'surfaceId' },
                                },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'platform' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'platform' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'skipDisplayReason' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'shouldDisplay' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isGlobalHoldout' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isPlacementHoldout' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'placementName' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'testPhase' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'bucket' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'placementId' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'passThrottle' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'lastModified' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'eventId' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'decisionContext' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'selectedTreatment' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'id' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'name' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'component',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'status' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'renderingProps',
                                                            },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'lastModified',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: {
                                                    kind: 'Name',
                                                    value: 'qualifiedTreatments',
                                                },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'id' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'name' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'status' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'lastModified',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<getOmpDataQuery, getOmpDataQueryVariables>;
export const getYourTeamBCDocument = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'getYourTeamBC' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'refId' } },
                    type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
                },
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'refType' } },
                    type: {
                        kind: 'NamedType',
                        name: { kind: 'Name', value: 'BridgeParticipantReferenceType' },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'bridgeContainer' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'refId' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'refId' } },
                            },
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'refType' },
                                value: {
                                    kind: 'Variable',
                                    name: { kind: 'Name', value: 'refType' },
                                },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'moves' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'buy' },
                                                arguments: [
                                                    {
                                                        kind: 'Argument',
                                                        name: { kind: 'Name', value: 'filter' },
                                                        value: {
                                                            kind: 'ObjectValue',
                                                            fields: [
                                                                {
                                                                    kind: 'ObjectField',
                                                                    name: {
                                                                        kind: 'Name',
                                                                        value: 'statuses',
                                                                    },
                                                                    value: {
                                                                        kind: 'ListValue',
                                                                        values: [
                                                                            {
                                                                                kind: 'EnumValue',
                                                                                value: 'ACTIVE',
                                                                            },
                                                                        ],
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    },
                                                ],
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'id' },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'team' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'agents' },
                                                            selectionSet: {
                                                                kind: 'SelectionSet',
                                                                selections: [
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'zuid',
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'participatingComponents',
                                                                        },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'componentId',
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    },
                                                                    {
                                                                        kind: 'Field',
                                                                        name: {
                                                                            kind: 'Name',
                                                                            value: 'paAgent',
                                                                        },
                                                                        selectionSet: {
                                                                            kind: 'SelectionSet',
                                                                            selections: [
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'name',
                                                                                    },
                                                                                },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'businessName',
                                                                                    },
                                                                                },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'email',
                                                                                    },
                                                                                },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'phone',
                                                                                    },
                                                                                },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'photoUrl',
                                                                                    },
                                                                                },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'hasPremierAgent',
                                                                                    },
                                                                                },
                                                                                {
                                                                                    kind: 'Field',
                                                                                    name: {
                                                                                        kind: 'Name',
                                                                                        value: 'profile',
                                                                                    },
                                                                                    selectionSet: {
                                                                                        kind: 'SelectionSet',
                                                                                        selections:
                                                                                            [
                                                                                                {
                                                                                                    kind: 'Field',
                                                                                                    name: {
                                                                                                        kind: 'Name',
                                                                                                        value: 'officeCity',
                                                                                                    },
                                                                                                },
                                                                                                {
                                                                                                    kind: 'Field',
                                                                                                    name: {
                                                                                                        kind: 'Name',
                                                                                                        value: 'officeState',
                                                                                                    },
                                                                                                },
                                                                                                {
                                                                                                    kind: 'Field',
                                                                                                    name: {
                                                                                                        kind: 'Name',
                                                                                                        value: 'profileUrl',
                                                                                                    },
                                                                                                },
                                                                                                {
                                                                                                    kind: 'Field',
                                                                                                    name: {
                                                                                                        kind: 'Name',
                                                                                                        value: 'ratingAverage',
                                                                                                    },
                                                                                                },
                                                                                                {
                                                                                                    kind: 'Field',
                                                                                                    name: {
                                                                                                        kind: 'Name',
                                                                                                        value: 'ratingCount',
                                                                                                    },
                                                                                                },
                                                                                            ],
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'viewer' },
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            ],
                        },
                    },
                ],
            },
        },
    ],
} as unknown as DocumentNode<getYourTeamBCQuery, getYourTeamBCQueryVariables>;
